export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A string containing an access token for Famly */
  AccessToken: string;
  /** A string containing a 36-character UUID */
  AccidentReportId: string;
  /** A string containing a 36-character UUID */
  AccountId: string;
  /** A string representing a cursor into a paged result */
  ActivityCursor: string;
  /** A string containing a 36-character UUID */
  ActivityId: string;
  /** A string containing a 36-character UUID */
  ActivityVersionId: string;
  /** A string representing a cursor into a paged result */
  AdministeredMedicationCursor: string;
  /** A string containing a 36-character UUID */
  AdministeredMedicationId: string;
  /** A string containing a 36-character UUID */
  AgeBandSettingId: string;
  /** A string containing a 36-character UUID */
  ApiAccessTokenId: string;
  /** A string containing a 36-character UUID */
  AreaId: string;
  /** A string containing a 36-character UUID */
  AssessmentOptionSettingId: string;
  /** A string containing a 36-character UUID */
  AssessmentSettingsCustomFieldId: string;
  /** A string containing a 36-character UUID */
  AssessmentSettingsId: string;
  /** A string containing a 36-character UUID */
  AttendanceScheduleId: string;
  /** A string representing a cursor into a paged result */
  AuditCursor: string;
  /** A string containing an amount of money given as a decimal number */
  BadMoney: string;
  /** A string containing base 64 encoded data */
  Base64String: string;
  /** The `BigDecimal` scalar type represents signed fractional values with arbitrary precision. */
  BigDecimal: number;
  /** A string representing a cursor into a paged result */
  BillPayerCursor: string;
  /** A string containing a 36-character UUID */
  BillPayerId: string;
  /** A string containing a 36-character UUID */
  BillingProfileId: string;
  /** A string containing a 36-character UUID */
  CheckInStatementId: string;
  /** A string representing a cursor into a paged result */
  ChildBasedFundingReportCursor: string;
  /** A string containing a 36-character UUID */
  ChildCheckinId: string;
  /** A string containing a 36-character UUID */
  ChildId: string;
  /** A string representing a cursor into a paged result */
  ChildNoteCursor: string;
  /** A string containing a 36-character UUID */
  ChildNoteId: string;
  /** A string representing a name */
  CleanNameScalar: string;
  /** A string containing a 36-character UUID */
  ClosingDayId: string;
  /** A string containing a 36-character UUID */
  CommentId: string;
  /** A string representing a cursor into a paged result */
  CompletedLeaveRequestsCursor: string;
  /** A string containing a 36-character UUID */
  ContactId: string;
  /** A string containing a 36-character UUID */
  ConversationId: string;
  /** A string containing a country */
  Country: string;
  /** A string containing a 36-character UUID */
  CustomLineId: string;
  /** A string containing a 36-character UUID */
  CustomRegistrationFormFieldId: string;
  /** A string containing a 36-character UUID */
  CustomRegistrationFormId: string;
  /** A string containing a 36-character UUID */
  CustomRegistrationFormSectionId: string;
  /** A string containing a 36-character UUID */
  DailyMedicationFormUpdateId: string;
  /** A string containing a day of week */
  DayOfWeek: string;
  /** A string containing a 36-character UUID */
  DepartmentId: string;
  /** A string containing a 36-character UUID */
  DeviceId: string;
  /** A string containing a 36-character UUID */
  DirectDebitInstructionId: string;
  /** A string containing a 36-character UUID */
  DocumentId: string;
  /** A string containing a possibly valid email address */
  EmailAddress: string;
  /** A string containing a 36-character UUID */
  EmployeeCheckInId: string;
  /** A string containing a 36-character UUID */
  EmployeeId: string;
  /** A string containing a 36-character UUID */
  EmployeeLeaveId: string;
  /** A string containing a 36-character UUID */
  ExportRequestId: string;
  /** A string containing a 36-character UUID */
  FacebookAccessTokenId: string;
  /** Contains a FeedItemId */
  FeedItemId: string;
  /** A string containing a 36-character UUID */
  FileExportId: string;
  /** A string containing a 36-character UUID */
  FileId: string;
  /** A string representing a cursor into a paged result */
  FinanceOverviewCursor: string;
  /** A string containing a 36-character UUID */
  FolderId: string;
  /** A string containing a 36-character UUID */
  FoodItemId: string;
  /** A string representing a cursor into a paged result */
  FormCursor: string;
  /** A string representing a cursor into a paged result */
  FormSubmissionCursor: string;
  /** A string containing a 36-character UUID */
  FrameworkId: string;
  /** A string containing a 36-character UUID */
  FundingPeriodId: string;
  /** A string containing a 36-character UUID */
  FundingTypeId: string;
  /** A string containing a 36-character UUID */
  GenericFormFieldTemplateId: string;
  /** A string containing a 36-character UUID */
  GenericFormFieldValueId: string;
  /** A string containing a 36-character UUID */
  GenericFormInstanceId: string;
  /** A string containing a 36-character UUID */
  GenericFormTemplateId: string;
  /** A string containing a 36-character UUID */
  GenericFormTemplateVersionId: string;
  /** A string containing a 36-character UUID */
  GroupId: string;
  /** A HMAC used to secure a request */
  HMAC: string;
  /** A string representing a cursor into a paged result */
  HeadcountCursor: string;
  /** A string containing a 36-character UUID */
  HeadcountId: string;
  /** A string representing a cursor into a paged result */
  HomeWidgetCursor: string;
  /** A string containing a 36-character UUID */
  HomeWidgetId: string;
  /** A string containing a 36-character UUID */
  ImageId: string;
  /** A string representing a cursor into a paged result */
  ImmunizationRecordsCursor: string;
  /** A string containing a 36-character UUID */
  ImmunizationRegulationId: string;
  /** A string containing a 36-character UUID */
  ImmunizationRuleId: string;
  /** A string containing a 36-character UUID */
  ImportObjectId: string;
  /** A string representing a cursor into a paged result */
  InquiriesCursor: string;
  /** A string containing a 36-character UUID */
  InquiryActionId: string;
  /** A string containing a 36-character UUID */
  InquiryId: string;
  /** A string containing a 36 character UUID */
  InstitutionId: string;
  /** A string containing a 36 character UUID */
  InstitutionSetId: string;
  /** A string containing a 36-character UUID */
  IntegrationTaskId: string;
  /** A string containing a 36-character UUID */
  InvoiceId: string;
  Json: string;
  /** A string containing a 36-character UUID */
  KibigChildPeriodId: string;
  /** A string containing a 36-character UUID */
  KibigEmployeePeriodId: string;
  /** A string containing a 36-character UUID */
  KibigFundingId: string;
  /** A string containing a 36-character UUID */
  KibigMunicipalityId: string;
  /** A string containing a 36-character UUID */
  KibigQualificationId: string;
  /** A string containing a 36-character UUID */
  LessonPlanId: string;
  /** A string containing a 36-character UUID */
  LessonPlanItemId: string;
  /** A string containing a 36-character UUID */
  LessonPlanSectionId: string;
  /** A string containing a local date in the ISO-8601 format, e.g. YYYY-MM-DD */
  LocalDate: string;
  /** A string containing a local date time in the ISO-8601 format, e.g. 'YYYY-MM-DDTHH:mm:ss' */
  LocalDateTime: string;
  /** A string containing a local time in ISO format, i.e. HH:MM:SS. Example: 10:15:36. */
  LocalTime: string;
  /** A string A string containing a locale */
  Locale: string;
  /** A string containing a 36-character UUID */
  LoginId: string;
  /** The `Long` scalar type represents non-fractional signed whole numeric values. Long can represent values between -(2^63) and 2^63 - 1. */
  Long: string;
  /** Markdown-formatted string */
  Markdown: string;
  /** A string representing a cursor into a paged result */
  MealBookingReportCursor: string;
  /** A string containing a 36-character UUID */
  MealPlanId: string;
  /** A string containing a 36-character UUID */
  MealPlanSegmentId: string;
  /** A string containing a 36-character UUID */
  MealTypeId: string;
  /** A string containing a 36-character UUID */
  MediaId: string;
  /** A string representing a cursor into a paged result */
  MedicationFormCursor: string;
  /** A string containing a 36-character UUID */
  MedicationFormId: string;
  /** A string representing name of a user */
  NameInput: string;
  /** A string containing a 36-character UUID */
  NavigationItemId: string;
  /** A string containing a 36-character UUID */
  NavigationViewId: string;
  /** A string containing a 36-character UUID */
  OIDCProviderId: string;
  /** A string representing a cursor into a paged result */
  ObservationCursor: string;
  /** A string containing a 36-character UUID */
  ObservationId: string;
  /** A string containing a 36-character UUID */
  OrganizationId: string;
  /** A string containing a 36-character UUID */
  OrganizationPersonId: string;
  /** A string containing a 36-character UUID */
  PackageId: string;
  /** A string containing a 36-character UUID */
  ParagonContextId: string;
  /** A string containing a 26-character Universally Unique Lexicographically Sortable Identifier */
  ParentSurveyResponseId: string;
  /** A string containing a 36-character UUID */
  ParentalPermissionId: string;
  /** A string containing a password. Be careful! */
  Password: string;
  /** A string representing a cursor into a paged result */
  PaymentCursor: string;
  /** A string containing a 36-character UUID */
  PaymentId: string;
  /** A string containing a 36-character UUID */
  PaymentPromoConfigurationId: string;
  /** A string containing a 36-character UUID */
  PaymentReminderEmailId: string;
  /** A string containing a 36-character UUID */
  PaymentsAccountId: string;
  /** A string containing a 36-character UUID */
  PaymentsCorrectionId: string;
  /** A string representing a cursor into a paged result */
  PaymentsFeedCursor: string;
  /** A string containing a 36-character UUID */
  PaymentsFeedId: string;
  /** A string containing a 36-character UUID */
  PaymentsPayoutId: string;
  /** A string containing a 36-character UUID */
  PaymentsSourceId: string;
  /** A string containing a 36-character UUID */
  PaymentsTransactionId: string;
  /** A string representing a cursor into a paged result */
  PeriodPlanCursor: string;
  /** A string containing a 36-character UUID */
  PeriodPlanId: string;
  /** A string containing a possibly valid phone number */
  PhoneNumber: string;
  /** A string containing a 36-character UUID */
  PlanId: string;
  /** A string containing a 36-character UUID */
  PlanLineId: string;
  /** A string containing a 36-character UUID */
  PlanPartId: string;
  /** A string representing a cursor into a paged result */
  PossibleRecipientCursor: string;
  /** A string containing a 36-character UUID */
  PostId: string;
  /** A string containing a 36-character UUID */
  PricingGroupId: string;
  /** A string containing a 36-character UUID */
  ProductAvailabilityId: string;
  /** A string containing a 36-character UUID */
  ProductId: string;
  /** A string containing a 36-character UUID */
  ProductPurchaseId: string;
  /** A string containing a 36-character UUID */
  ProductVersionId: string;
  /** A string representing a cursor into a paged result */
  ProtoPaymentCursor: string;
  /** A string containing a 36-character UUID */
  PublicFundingSettingsId: string;
  /** A string representing a cursor into a paged result */
  PurchaseCursor: string;
  /** A string containing a 36-character UUID */
  PurchaseId: string;
  /** A string containing a 36-character UUID */
  PurchaseLineId: string;
  QuestionInputType: string;
  /** A string containing a 36-character UUID */
  RelationId: string;
  /** A string containing a 36-character UUID */
  RemarkId: string;
  /** A string containing a 26-character Universally Unique Lexicographically Sortable Identifier */
  ReportCategoryId: string;
  /** A string containing a 36-character UUID */
  ReportConfigId: string;
  /** A string representing a cursor into a paged result */
  ReportCursor: string;
  /** A string containing a 26-character Universally Unique Lexicographically Sortable Identifier */
  ReportDatasetId: string;
  /** A string containing a 26-character Universally Unique Lexicographically Sortable Identifier */
  ReportId: string;
  /** A string representing a cursor into a paged result */
  RoleCursor: string;
  /** A string containing a 36-character UUID */
  RoleId: string;
  /** A string containing a 36-character UUID */
  RoleInvitationId: string;
  /** A string containing a 26-character Universally Unique Lexicographically Sortable Identifier */
  RuleGroupId: string;
  /** A string containing a 36-character UUID */
  RunId: string;
  /** A string containing a 26-character Universally Unique Lexicographically Sortable Identifier */
  SMSIdentifier: string;
  /** A string containing a 36-character UUID */
  SessionAvailabilityId: string;
  /** A string containing a 36-character UUID */
  SessionBookingId: string;
  /** A string containing a 36-character UUID */
  SessionId: string;
  /** A string containing a 36-character UUID */
  SessionPurchaseId: string;
  /** A string containing a 36-character UUID */
  SessionVersionId: string;
  /** A string containing a 36-character UUID */
  ShiftId: string;
  /** A string representing a cursor into a paged result */
  ShiftPlannerByGroupsCursor: string;
  /** A string representing a cursor into a paged result */
  ShiftPlannerByStaffCursor: string;
  /** A string containing a 36-character UUID */
  ShiftRecurrenceId: string;
  /** A string containing a 36-character UUID */
  SiblingLinkId: string;
  /** A string containing a 36-character UUID */
  SignatureId: string;
  /** A string containing a 36-character UUID */
  SigninSecretId: string;
  /** A string containing a 36-character UUID */
  SiteId: string;
  /** A string containing a 36-character UUID */
  SiteSetId: string;
  /** A string containing a 26-character Universally Unique Lexicographically Sortable Identifier */
  SmsMessageId: string;
  /** A string representing a cursor into a paged result */
  StaffHoursByStaffCursor: string;
  /** A string containing a 36-character UUID */
  StaffLeaveRequestId: string;
  /** A string containing a 36-character UUID */
  StaffLeaveSubTypeId: string;
  /** A string containing a 36-character UUID */
  StaffQualificationAssignmentId: string;
  /** A string containing a 36-character UUID */
  StaffQualificationId: string;
  /** A string containing a 36-character UUID */
  StaffRotasDailyScheduleId: string;
  /** A string containing a 36-character UUID */
  StaffRotasScheduleId: string;
  /** A string containing a 36-character UUID */
  StatementId: string;
  /** A string containing a 36-character UUID */
  StatusConfigId: string;
  /** A string containing a 36-character UUID */
  StripeFlexibleFeeSchemeId: string;
  /** A string containing a 36-character UUID */
  StripeFlexibleFeeSchemeLinkId: string;
  /** A string containing a 26-character Universally Unique Lexicographically Sortable Identifier */
  StripeProductId: string;
  /** A string containing a 36-character UUID */
  SubLineId: string;
  /** A string containing a 36-character UUID */
  SubmissionId: string;
  /** A string containing a 36-character UUID */
  SubmissionKeyId: string;
  /** A string containing a 36-character UUID */
  SubscriptionId: string;
  /** A string containing a 36-character UUID */
  TagId: string;
  /** A string containing a title */
  Title: string;
  /** A string containing a valid URI */
  URI: string;
  /** A string containing a 36-character UUID */
  UniqueId: string;
  /** A string representing a cursor into a paged result */
  UserGeneratedContentListReportsCursor: string;
  /** A string containing a 36-character UUID */
  UserGeneratedContentReportId: string;
  /** A string containing a 36-character UUID */
  VaccinationId: string;
  /** A string containing a 36-character UUID */
  VaccineId: string;
  /** A valid email address */
  ValidEmailAddress: string;
  /** A string containing a 36-character UUID */
  VideoId: string;
  /** A string containing a 36-character UUID */
  VolumeDiscountGroupId: string;
  /** A string representing a cursor into a paged result */
  WebhookEndpointCursor: string;
  /** A string containing a 26-character Universally Unique Lexicographically Sortable Identifier */
  WebhookEndpointId: string;
  /** A string representing a cursor into a paged result */
  WebhookEventCursor: string;
  /** A string containing a 26-character Universally Unique Lexicographically Sortable Identifier */
  WebhookEventId: string;
  /** A string representing a cursor into a paged result */
  WebhookRequestCursor: string;
  /** A string containing a 26-character Universally Unique Lexicographically Sortable Identifier */
  WebhookRequestId: string;
  /** A string containing a 36-character UUID */
  WorkTagId: string;
  /** A string containing a zone ID */
  ZoneId: string;
  /** A string containing an instant in a specific time zone */
  ZonedDateTime: string;
};

export type AbsencesWidget = Widget & {
  __typename?: 'AbsencesWidget';
  id: Scalars['HomeWidgetId'];
  next?: Maybe<Scalars['HomeWidgetCursor']>;
  /** Rooms with absence information */
  rooms: Array<RoomAbsence>;
  title: Scalars['String'];
  widgetId: Scalars['String'];
};

export type AbsentReason = AbsentReasonChildHoliday;

export type AbsentReasonChildHoliday = {
  __typename?: 'AbsentReasonChildHoliday';
  id: Scalars['String'];
};

/** Represents an accident report. */
export type AccidentReport = {
  __typename?: 'AccidentReport';
  /** Body map points for the report */
  bodyMapPoints: Array<BodyMapPoint>;
  reportId: Scalars['AccidentReportId'];
};

export type AccidentReportResult = {
  __typename?: 'AccidentReportResult';
  results: Array<AccidentReport>;
};

/** Queries and objects related to accident reprots */
export type AccidentReports = {
  __typename?: 'AccidentReports';
  /** Lists accident reports. */
  listAccidentReports: AccidentReportResult;
  /** Lists available body map files. */
  listBodyMapFiles: Array<BodyMapFile>;
};


/** Queries and objects related to accident reprots */
export type AccidentReportslistAccidentReportsArgs = {
  ids: Array<Scalars['AccidentReportId']>;
};

export type AccidentReportsMutations = {
  __typename?: 'AccidentReportsMutations';
  updateBodyMapPoints: Array<BodyMapPoint>;
};


export type AccidentReportsMutationsupdateBodyMapPointsArgs = {
  points: Array<BodyMapPointInput>;
  reportId: Scalars['AccidentReportId'];
};

/** A financial account */
export type Account = {
  __typename?: 'Account';
  accountId: Scalars['AccountId'];
  /** What this account should be used for. Each account type must only have one default account. */
  defaultFor: Array<AccountType>;
  /** If true, means that this account has been deleted */
  deleted: Scalars['Boolean'];
  /** How this account is referenced in external systems */
  reference: Scalars['String'];
  /** Human readable title */
  title: Scalars['String'];
};

export type AccountInput = {
  accountId?: InputMaybe<Scalars['AccountId']>;
  defaultFor: Array<AccountType>;
  reference: Scalars['String'];
  title: Scalars['String'];
};

/** Configure accounts for a site */
export type AccountMutations = {
  __typename?: 'AccountMutations';
  /** Set accounts and replaces (destructive) AccountSetup for a site */
  accountSetup: AccountSetup;
  /** Append account lines configuration for a site */
  appendAccounts: AccountSetup;
};


/** Configure accounts for a site */
export type AccountMutationsaccountSetupArgs = {
  accounts: Array<AccountInput>;
  institutionId: Scalars['InstitutionId'];
};


/** Configure accounts for a site */
export type AccountMutationsappendAccountsArgs = {
  accounts: Array<AccountInput>;
  institutionId: Scalars['SiteId'];
};

/** Describes how accounts are set up for a nursery */
export type AccountSetup = {
  __typename?: 'AccountSetup';
  /** All accounts */
  accounts: Array<Account>;
  institution: Site;
};

/** The current status of the payments account */
export enum AccountStatus {
  /** Further information is required to verify your account. */
  INFORMATION_REQUIRED = 'INFORMATION_REQUIRED',
  /** The account is pending verification, no current action required. */
  PENDING = 'PENDING',
  /** The account has been permanently disabled and cannot be used. */
  REJECTED = 'REJECTED',
  /** The account is verified. */
  VERIFIED = 'VERIFIED'
}

/**
 *
 * The Account Types cover the various options possible in `AccountSetup`, which lays out the various accounting
 * codes that are used to track expenses and reveneu.
 *
 * There are two concepts used in the accounting setup:
 *   - Tracking and attributing goods and services via account codes.
 *   - Tracking and attributing payments to balance your cashbooks and compare with your actual bank accounts that money
 *     flows into.
 *
 * While these two concepts are different, they are so closely related that they are included together in the Account
 * Setup.
 *
 */
export enum AccountType {
  /** Goods and services accounting code for credits. */
  CREDIT = 'CREDIT',
  /** Goods and services accounting code for deposits. */
  DEPOSIT = 'DEPOSIT',
  /** Goods and services accounting code used as a fallback when nothing else is explicitly specified in the other goods and services related fields. */
  MISC = 'MISC',
  /** Payment accounting code for Credit Card transactions. */
  PAYMENT_METHOD_CREDIT_CARD = 'PAYMENT_METHOD_CREDIT_CARD',
  /** Payment accounting code for Debit Card transactions. */
  PAYMENT_METHOD_DEBIT_CARD = 'PAYMENT_METHOD_DEBIT_CARD',
  /** Payment accounting code for Direct Debit transactions. */
  PAYMENT_METHOD_DIRECT_DEBIT = 'PAYMENT_METHOD_DIRECT_DEBIT',
  /** Payment accounting code used as a fallback when nothing else is explicitly specified in the other payment related fields. */
  PAYMENT_METHOD_MISC = 'PAYMENT_METHOD_MISC',
  /** Goods and services accounting code for plans. */
  PLAN = 'PLAN',
  /** Goods and services accounting code for products. */
  PRODUCT = 'PRODUCT',
  /** Goods and services accounting code for ad-hoc purchases. */
  PURCHASE = 'PURCHASE',
  /** Goods and services accounting code for sessions. */
  SESSION = 'SESSION',
  /** Goods and services accounting code for surcharges. */
  SURCHARGE = 'SURCHARGE'
}

export type Acknowledgment = {
  acknowledgedAt: Scalars['ZonedDateTime'];
  acknowledgedBy: Person;
  id: Scalars['SignatureId'];
  signedAs: SignedAs;
  valid: Scalars['Boolean'];
  withdrawnAt?: Maybe<Scalars['ZonedDateTime']>;
};

export type ActionCompletedInput = {
  actionCompleted: TestChildActionId;
  childId: Scalars['ChildId'];
  siteId: Scalars['InstitutionId'];
};

export type Activity = {
  __typename?: 'Activity';
  /** The original author of the activity */
  author: Person;
  behaviors: Array<Behavior>;
  /** Comments for this activity */
  comments: Array<Comment>;
  country?: Maybe<Scalars['Country']>;
  id: Scalars['ActivityId'];
  /** The latest version of the activity */
  latest: ActivityVersion;
  /** Likes for this activity */
  likes: Likes;
  locale: Scalars['Locale'];
  public: Scalars['Boolean'];
  title: Scalars['String'];
};

/** Objects related to the activities database */
export type ActivityField = {
  __typename?: 'ActivityField';
  /** Behaviors related to activities */
  behaviors: Array<Behavior>;
  defaultImages: Array<Image>;
  /** A white list of frameworks which can be linked to activities */
  frameworks: Array<Framework>;
  list: Array<Activity>;
  /** Search for activities - institutionSetIds, forUser or public must be provided */
  search: ActivityResult;
  tags: Array<Scalars['String']>;
};


/** Objects related to the activities database */
export type ActivityFieldlistArgs = {
  activityIds: Array<Scalars['ActivityId']>;
};


/** Objects related to the activities database */
export type ActivityFieldsearchArgs = {
  after?: InputMaybe<Scalars['ActivityCursor']>;
  areaIds?: InputMaybe<Array<Scalars['AreaId']>>;
  authorIds?: InputMaybe<Array<Scalars['LoginId']>>;
  count: Scalars['Int'];
  countries?: InputMaybe<Array<Scalars['Country']>>;
  excludeActivityIds?: InputMaybe<Array<Scalars['ActivityId']>>;
  excludeAuthorIds?: InputMaybe<Array<Scalars['LoginId']>>;
  forUser?: InputMaybe<Scalars['Boolean']>;
  institutionSetIds?: InputMaybe<Array<Scalars['InstitutionSetId']>>;
  locales?: InputMaybe<Array<Scalars['Locale']>>;
  maxAgeMonths?: InputMaybe<Scalars['Int']>;
  minAgeMonths?: InputMaybe<Scalars['Int']>;
  public?: InputMaybe<Scalars['Boolean']>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  titleSearch?: InputMaybe<Scalars['String']>;
};

export type ActivityLibrary = InstitutionActivityLibrary | OrganizationActivityLibrary | PrivateActivityLibrary | PublicActivityLibrary;

/** CRUD for the activities database */
export type ActivityMutation = {
  __typename?: 'ActivityMutation';
  createActivity: Activity;
  deleteActivity: Scalars['ActivityId'];
  /** Report the activity. */
  report: ReportActivityResponse;
  setLibraryMemberships: Scalars['Boolean'];
  setPublic: Scalars['Boolean'];
  updateActivity: Activity;
};


/** CRUD for the activities database */
export type ActivityMutationcreateActivityArgs = {
  country?: InputMaybe<Scalars['Country']>;
  description?: InputMaybe<Scalars['String']>;
  descriptionHtml?: InputMaybe<Scalars['String']>;
  fileIds?: InputMaybe<Array<Scalars['FileId']>>;
  images: Array<Scalars['ImageId']>;
  locale: Scalars['Locale'];
  maxAgeMonths?: InputMaybe<Scalars['Int']>;
  minAgeMonths?: InputMaybe<Scalars['Int']>;
  public: Scalars['Boolean'];
  statements: Array<Scalars['AreaId']>;
  tags: Array<Scalars['String']>;
  title: Scalars['String'];
  videos?: InputMaybe<Array<Scalars['VideoId']>>;
  whatIsNeeded: Array<Scalars['String']>;
};


/** CRUD for the activities database */
export type ActivityMutationdeleteActivityArgs = {
  activityId: Scalars['ActivityId'];
};


/** CRUD for the activities database */
export type ActivityMutationreportArgs = {
  activityId: Scalars['ActivityId'];
  reason?: InputMaybe<Scalars['String']>;
};


/** CRUD for the activities database */
export type ActivityMutationsetLibraryMembershipsArgs = {
  activityId: Scalars['ActivityId'];
  memberships: Array<LibraryMembershipInput>;
};


/** CRUD for the activities database */
export type ActivityMutationsetPublicArgs = {
  activityIds: Array<Scalars['ActivityId']>;
  public: Scalars['Boolean'];
};


/** CRUD for the activities database */
export type ActivityMutationupdateActivityArgs = {
  activityId: Scalars['ActivityId'];
  description?: InputMaybe<Scalars['String']>;
  descriptionHtml?: InputMaybe<Scalars['String']>;
  fileIds?: InputMaybe<Array<Scalars['FileId']>>;
  images: Array<Scalars['ImageId']>;
  maxAgeMonths?: InputMaybe<Scalars['Int']>;
  minAgeMonths?: InputMaybe<Scalars['Int']>;
  statements: Array<Scalars['AreaId']>;
  tags: Array<Scalars['String']>;
  title: Scalars['String'];
  videos?: InputMaybe<Array<Scalars['VideoId']>>;
  whatIsNeeded: Array<Scalars['String']>;
};

export type ActivityResult = {
  __typename?: 'ActivityResult';
  next?: Maybe<Scalars['ActivityCursor']>;
  results: Array<Activity>;
};

export type ActivityTag = {
  __typename?: 'ActivityTag';
  name: Scalars['String'];
};

export type ActivityVersion = {
  __typename?: 'ActivityVersion';
  activityId: Scalars['ActivityId'];
  /** The child development areas related to this activity */
  areas: Array<Area>;
  createdAt: Scalars['ZonedDateTime'];
  /** The author/editor of this specific version */
  createdBy: Person;
  description: Scalars['String'];
  descriptionHtml?: Maybe<Scalars['String']>;
  files: Array<File>;
  id: Scalars['ActivityVersionId'];
  /** Images depicting the activity */
  images: Array<Image>;
  maxAgeMonths?: Maybe<Scalars['Int']>;
  minAgeMonths?: Maybe<Scalars['Int']>;
  /** Activities in the same child development areas from libraries the user has access to */
  related: Array<Activity>;
  /** The tags associated with this activity version */
  tags: Array<ActivityTag>;
  title: Scalars['String'];
  videos: Array<Video>;
  whatIsNeeded: Array<Scalars['String']>;
};


export type ActivityVersionrelatedArgs = {
  count?: InputMaybe<Scalars['Int']>;
};

export type AddNewSiteInput = {
  country: Scalars['String'];
  createNewBillPayerInput?: InputMaybe<CreateNewBillPayerInput>;
  existingBillPayerId?: InputMaybe<Scalars['BillPayerId']>;
  orgId: Scalars['OrganizationId'];
  packageId: Scalars['PackageId'];
  siteName: Scalars['String'];
  timezone: Scalars['String'];
};

/** Objects related to adding a new site to an organization */
export type AddNewSiteMutations = {
  __typename?: 'AddNewSiteMutations';
  /** Creates new site, adds it to the organization */
  addNewSite: Scalars['SiteSetId'];
};


/** Objects related to adding a new site to an organization */
export type AddNewSiteMutationsaddNewSiteArgs = {
  addNewSite: AddNewSiteInput;
};

/** Top level object for adding a new site to an organization */
export type AddNewSiteQueryType = {
  __typename?: 'AddNewSiteQueryType';
  /** Returns either the highest package of the organization's sites or the list of valid packages that can be chosen for a new site */
  availableSubscriptionPackages: Array<Scalars['PackageId']>;
};


/** Top level object for adding a new site to an organization */
export type AddNewSiteQueryTypeavailableSubscriptionPackagesArgs = {
  organizationId: Scalars['OrganizationId'];
};

export enum AddOn {
  Sidekick = 'Sidekick'
}

/** Result of the Sidekick add-on setup. */
export type AddOnSetupResult = {
  __typename?: 'AddOnSetupResult';
  siteSetId: Scalars['String'];
  success: Scalars['Boolean'];
};

export type AddOnTrialInput = {
  addOn: AddOn;
  institutionSetId: Scalars['InstitutionSetId'];
};

export type AddOnTrialResponse = {
  __typename?: 'AddOnTrialResponse';
  /** ID of the package that was activated. */
  packageId?: Maybe<Scalars['PackageId']>;
  /** Number of seconds the app should wait before refetching behaviors. */
  replicaLag: Scalars['Int'];
};

export enum AddOnTypeBrowse {
  Sidekick = 'Sidekick'
}

export type Address = {
  __typename?: 'Address';
  city: Scalars['String'];
  country?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  street: Scalars['String'];
  zip: Scalars['String'];
};

export enum AddressFormat {
  Default = 'Default',
  US = 'US'
}

export type AddressFormatting = {
  __typename?: 'AddressFormatting';
  format: AddressFormat;
};

export type AddressInput = {
  city: Scalars['String'];
  country?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  street: Scalars['String'];
  zip: Scalars['String'];
};

export type AdministeredMedication = {
  __typename?: 'AdministeredMedication';
  acknowledgements: Array<AdministeredMedicationAcknowledgement>;
  administeredAt: Scalars['ZonedDateTime'];
  administeredBy: Person;
  canAcknowledgeAs: Array<SignedAs>;
  comment?: Maybe<Scalars['String']>;
  doseGiven: Scalars['BigDecimal'];
  doseUnit: Scalars['String'];
  id: Scalars['AdministeredMedicationId'];
  medicationForm: MedicationForm;
  scheduledAt?: Maybe<Scalars['LocalTime']>;
  /** Information about the employee witnesses */
  witnessInfo: AdministeredMedicationWitnessInfo;
  /** List all employee witnesses, use `witnessInfo.names` instead for reading only the names */
  witnesses: Array<Employee>;
};

export type AdministeredMedicationAcknowledgement = {
  __typename?: 'AdministeredMedicationAcknowledgement';
  acknowledgedAt: Scalars['ZonedDateTime'];
  acknowledgedBy: Person;
  administeredMedication: AdministeredMedication;
  id: Scalars['SignatureId'];
  inCapacityOf: SignedAs;
};

export type AdministeredMedicationResult = {
  __typename?: 'AdministeredMedicationResult';
  next?: Maybe<Scalars['AdministeredMedicationCursor']>;
  results: Array<AdministeredMedication>;
};

export type AdministeredMedicationWitnessInfo = {
  __typename?: 'AdministeredMedicationWitnessInfo';
  names: Array<Name>;
};

/** Represents the assessment age band setting. */
export type AgeBandSetting = {
  __typename?: 'AgeBandSetting';
  ageBandSettingId: Scalars['AgeBandSettingId'];
  assessmentSettingsId: Scalars['AssessmentSettingsId'];
  from?: Maybe<Scalars['Int']>;
  label: Scalars['String'];
  to?: Maybe<Scalars['Int']>;
};

export type AgeBandSettingInput = {
  from?: InputMaybe<Scalars['Int']>;
  label: Scalars['String'];
  to?: InputMaybe<Scalars['Int']>;
};

/** Represents the assessment age band settings. */
export type AgeBandSettings = {
  __typename?: 'AgeBandSettings';
  ageBands: Array<AgeBandSetting>;
  enabled: Scalars['Boolean'];
};

export type AgeBandSettingsInput = {
  ageBands: Array<AgeBandSettingInput>;
  enabled: Scalars['Boolean'];
};

export type AgeGroup = {
  __typename?: 'AgeGroup';
  capacity?: Maybe<Scalars['Int']>;
  capacityFactor: Scalars['Float'];
  lower: Scalars['Int'];
  staffRatio: Scalars['Float'];
  upper?: Maybe<Scalars['Int']>;
};

export type AgeGroupAttendanceReport = AttendanceSummary & {
  __typename?: 'AgeGroupAttendanceReport';
  ageGroup: AgeGroup;
  children: Array<ChildAttendanceReport>;
  rooms: Array<RoomAttendanceReport>;
  slots: Array<AttendanceSlot>;
  stats: AttendanceStats;
};


export type AgeGroupAttendanceReportroomsArgs = {
  rooms?: InputMaybe<Array<Scalars['GroupId']>>;
};


export type AgeGroupAttendanceReportslotsArgs = {
  buckets?: InputMaybe<Array<ClosedLocalTimeRange>>;
};

export type AgeGroupInput = {
  capacity?: InputMaybe<Scalars['Int']>;
  capacityFactor?: InputMaybe<Scalars['Float']>;
  lower: Scalars['Int'];
  staffRatio: Scalars['Float'];
  upper?: InputMaybe<Scalars['Int']>;
};

export type AgeGroupSet = {
  __typename?: 'AgeGroupSet';
  ageGroups: Array<AgeGroup>;
  validFrom: Scalars['LocalDate'];
};

/** Objects related to age groups */
export type AgeGroups = {
  __typename?: 'AgeGroups';
  /** Possible behaviors */
  behaviors: Array<Behavior>;
  sets: Array<AgeGroupSet>;
};


/** Objects related to age groups */
export type AgeGroupssetsArgs = {
  validOnDay?: InputMaybe<Scalars['LocalDate']>;
};

export type AllergiesResult = {
  __typename?: 'AllergiesResult';
  withAllergies: Scalars['Boolean'];
  withDietaryConsiderations: Scalars['Boolean'];
};

export type Annualization = {
  __typename?: 'Annualization';
  invoices: Scalars['Float'];
  weeksOfCare: Scalars['Float'];
};

export type AnnualizationInput = {
  invoices: Scalars['Float'];
  weeksOfCare: Scalars['Float'];
};

/** An anonymized representation of a payments source */
export type AnonymousPaymentsSource = {
  __typename?: 'AnonymousPaymentsSource';
  owner?: Maybe<Login>;
  status: PaymentsSourceStatus;
  title: Scalars['String'];
};

export type ApiAccessToken = {
  __typename?: 'ApiAccessToken';
  accessTokenId: Scalars['ApiAccessTokenId'];
  assignedPermissions: Array<RolePermission>;
  /** The name which will be displayed in the application for actions performed using this token */
  author: Scalars['String'];
  createdAt: Scalars['ZonedDateTime'];
  createdBy: Person;
  expiresAt: Scalars['ZonedDateTime'];
  lastChangedAt: Scalars['ZonedDateTime'];
  lastChangedBy: Person;
  lastUsedAt: Scalars['ZonedDateTime'];
  name: Scalars['String'];
  token: Scalars['AccessToken'];
};

/** The result of querying API access tokens */
export type ApiAccessTokenListResult = {
  __typename?: 'ApiAccessTokenListResult';
  tokens: Array<ApiAccessToken>;
};

/** The object holding all possible mutations regarding API access tokens */
export type ApiAccessTokenMutations = {
  __typename?: 'ApiAccessTokenMutations';
  create: ApiAccessToken;
  delete: Scalars['ApiAccessTokenId'];
  update: ApiAccessToken;
};


/** The object holding all possible mutations regarding API access tokens */
export type ApiAccessTokenMutationscreateArgs = {
  assignedPermissions: Array<Scalars['String']>;
  author: Scalars['String'];
  expiresAt: Scalars['ZonedDateTime'];
  name: Scalars['String'];
  targetId: Scalars['SiteSetId'];
};


/** The object holding all possible mutations regarding API access tokens */
export type ApiAccessTokenMutationsdeleteArgs = {
  accessTokenId: Scalars['ApiAccessTokenId'];
};


/** The object holding all possible mutations regarding API access tokens */
export type ApiAccessTokenMutationsupdateArgs = {
  accessTokenId: Scalars['ApiAccessTokenId'];
  assignedPermissions: Array<Scalars['String']>;
  author: Scalars['String'];
  name: Scalars['String'];
};

/** The object holding all possible queries regarding API access tokens */
export type ApiAccessTokenQueries = {
  __typename?: 'ApiAccessTokenQueries';
  list: ApiAccessTokenListResult;
  listBySiteSetIds: ApiAccessTokenListResult;
  settings?: Maybe<ApiAccessTokenSettings>;
};


/** The object holding all possible queries regarding API access tokens */
export type ApiAccessTokenQuerieslistArgs = {
  accessTokenIds: Array<Scalars['ApiAccessTokenId']>;
};


/** The object holding all possible queries regarding API access tokens */
export type ApiAccessTokenQuerieslistBySiteSetIdsArgs = {
  siteSetIds: Array<Scalars['SiteSetId']>;
};


/** The object holding all possible queries regarding API access tokens */
export type ApiAccessTokenQueriessettingsArgs = {
  siteSetId: Scalars['SiteSetId'];
};

/** Represents the actions available for the current user on a single site set */
export type ApiAccessTokenSettings = {
  __typename?: 'ApiAccessTokenSettings';
  canCreate: Scalars['Boolean'];
  canDelete: Scalars['Boolean'];
  canRead: Scalars['Boolean'];
  canUpdate: Scalars['Boolean'];
  siteSetId: Scalars['SiteSetId'];
};

export type App = {
  __typename?: 'App';
  descriptionList: Array<Scalars['String']>;
  helpArticleUrl: Scalars['String'];
  id: StoreAppId;
  shortDescription: Scalars['String'];
  subtitle: Scalars['String'];
  testimonial?: Maybe<Testimonial>;
  title: Scalars['String'];
};

/** Application ID */
export enum AppId {
  ACCIDENT_REPORTING = 'ACCIDENT_REPORTING',
  ACTIVITY_LIBRARY = 'ACTIVITY_LIBRARY',
  ACTIVITY_PLANNER = 'ACTIVITY_PLANNER',
  AD_HOC_PURCHASES = 'AD_HOC_PURCHASES',
  ATTENDANCE_REPORT = 'ATTENDANCE_REPORT',
  AUTOMATED_PLAN_CHANGES = 'AUTOMATED_PLAN_CHANGES',
  CURRICULUM_BUILDER = 'CURRICULUM_BUILDER',
  CUSTOM_LISTS = 'CUSTOM_LISTS',
  CUSTOM_ROLES = 'CUSTOM_ROLES',
  CUSTOM_STATUSES = 'CUSTOM_STATUSES',
  DEBT_REPORT = 'DEBT_REPORT',
  DIRECT_DEBIT_EXPORT = 'DIRECT_DEBIT_EXPORT',
  DOCUMENT_STORAGE = 'DOCUMENT_STORAGE',
  ENQUIRIES = 'ENQUIRIES',
  FAMLY_INSIGHTS = 'FAMLY_INSIGHTS',
  FAMLY_PAY = 'FAMLY_PAY',
  FUNDING_LOOP = 'FUNDING_LOOP',
  GROUP_DASHBOARDS = 'GROUP_DASHBOARDS',
  GROUP_REPORTING = 'GROUP_REPORTING',
  HEAD_COUNTS = 'HEAD_COUNTS',
  HOLIDAY_RSVP = 'HOLIDAY_RSVP',
  INVOICING = 'INVOICING',
  LEAVE_APPROVAL = 'LEAVE_APPROVAL',
  MEAL_PLANS = 'MEAL_PLANS',
  MEDICATION_FORMS = 'MEDICATION_FORMS',
  OCCUPANCY_PLANNING = 'OCCUPANCY_PLANNING',
  PARENTAL_PERMISSIONS = 'PARENTAL_PERMISSIONS',
  PARENT_REQUESTED_CARE = 'PARENT_REQUESTED_CARE',
  PAYMENT_REMINDERS = 'PAYMENT_REMINDERS',
  REVENUE_REPORT = 'REVENUE_REPORT',
  ROOM_MOVE_RULES = 'ROOM_MOVE_RULES',
  ROOM_PLANNING = 'ROOM_PLANNING',
  SIGN_IN_OUT = 'SIGN_IN_OUT',
  STAFFING = 'STAFFING',
  STAFF_ROTAS = 'STAFF_ROTAS',
  XERO_CSV_INTEGRATION = 'XERO_CSV_INTEGRATION'
}

/** App, or feature, and the package it's available in. */
export type AppInPackage = {
  __typename?: 'AppInPackage';
  app: App;
  package: Package;
};

export enum AppModule {
  MESSAGES = 'MESSAGES',
  OBSERVATIONS = 'OBSERVATIONS',
  POSTS = 'POSTS'
}

export type AppType = {
  __typename?: 'AppType';
  id: Scalars['String'];
  name: Scalars['String'];
  order: Scalars['Int'];
};

/** Holds information about the user's app version, e.g. whether or not the version is supported. */
export type AppVersionInformation = {
  __typename?: 'AppVersionInformation';
  supportStatus?: Maybe<SupportStatus>;
};

export type Area = {
  __typename?: 'Area';
  abbr?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['Int']>;
  config?: Maybe<AreaConfig>;
  curriculaCategory: CurriculumCategory;
  deletedAt?: Maybe<Scalars['ZonedDateTime']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']>;
  framework: Framework;
  frameworkId: Scalars['FrameworkId'];
  id: Scalars['AreaId'];
  isHeader: Scalars['Boolean'];
  isLinkable: Scalars['Boolean'];
  lower?: Maybe<Scalars['Int']>;
  parent?: Maybe<Area>;
  parentId?: Maybe<Scalars['AreaId']>;
  placement: Scalars['Int'];
  statements: Array<Statement>;
  subAreas: Array<Area>;
  title?: Maybe<Scalars['String']>;
  upper?: Maybe<Scalars['Int']>;
};


export type AreaconfigArgs = {
  reportConfigId: Scalars['ReportConfigId'];
};

export type AreaConfig = {
  __typename?: 'AreaConfig';
  areaId: Scalars['AreaId'];
  configType: AreaConfigType;
};

export enum AreaConfigType {
  AREADISPLAY_COMPLETION = 'AREADISPLAY_COMPLETION',
  AREADISPLAY_COUNT = 'AREADISPLAY_COUNT',
  AREA_LINK_COUNT = 'AREA_LINK_COUNT',
  PROGRESSMETHOD_LOWESTUNCOMPLETED = 'PROGRESSMETHOD_LOWESTUNCOMPLETED',
  PROGRESS_REPORT_WITH_ASSESSMENT_CONFIG = 'PROGRESS_REPORT_WITH_ASSESSMENT_CONFIG',
  STATEMENT_LINK_COUNT = 'STATEMENT_LINK_COUNT'
}

export type AreaFilterInput = {
  areaIds?: InputMaybe<Array<Scalars['AreaId']>>;
  childrenAgeRange?: InputMaybe<Array<Scalars['ChildId']>>;
};

export type AreaRefMaterial = {
  __typename?: 'AreaRefMaterial';
  area?: Maybe<Area>;
  reference: Area;
};

export type AreaReport = {
  area: Area;
  subTitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type AssessmentDraftsWidgetType = Widget & {
  __typename?: 'AssessmentDraftsWidgetType';
  id: Scalars['HomeWidgetId'];
  next?: Maybe<Scalars['HomeWidgetCursor']>;
  observations: Array<Observation>;
  title: Scalars['String'];
  version: ObservationVersion;
  widgetId: Scalars['String'];
};

/** Represents the assessment option setting. */
export type AssessmentOptionSetting = {
  __typename?: 'AssessmentOptionSetting';
  assessmentOptionSettingId: Scalars['AssessmentOptionSettingId'];
  assessmentSettingsId: Scalars['AssessmentSettingsId'];
  backgroundColor: Scalars['Int'];
  fontColor: Scalars['Int'];
  label: Scalars['String'];
};

export type AssessmentOptionSettingInput = {
  backgroundColor: Scalars['Int'];
  fontColor: Scalars['Int'];
  label: Scalars['String'];
};

/** Represents the assessment option settings. */
export type AssessmentOptionSettings = {
  __typename?: 'AssessmentOptionSettings';
  enabled: Scalars['Boolean'];
  options: Array<AssessmentOptionSetting>;
};

export type AssessmentOptionSettingsInput = {
  enabled: Scalars['Boolean'];
  options: Array<AssessmentOptionSettingInput>;
};

/**
 * Describes the progress for an area as defined by the latest assessment.
 * Requires a report configuration and assessment configurations as filters for the report query.
 */
export type AssessmentProgress = AreaReport & {
  __typename?: 'AssessmentProgress';
  area: Area;
  assessmentSettings?: Maybe<ChildDevelopmentAreaRefinementSettings>;
  subTitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

/** Represents the assessment settings. */
export type AssessmentSettings = {
  __typename?: 'AssessmentSettings';
  ageBandSettings: AgeBandSettings;
  assessmentSettingsId: Scalars['AssessmentSettingsId'];
  behaviors: Array<Behavior>;
  customFieldSettings: CustomFieldSettings;
  frameworkId: Scalars['FrameworkId'];
  institutionSetId: Scalars['InstitutionSetId'];
  optionSettings: AssessmentOptionSettings;
  parent?: Maybe<Scalars['InstitutionSetId']>;
  preset: Scalars['Boolean'];
  reflectionSettings: ReflectionSettings;
  status: FrameworkSettingsStatus;
  title: Scalars['String'];
};

export type AssessmentSettingsFilterInput = {
  assessmentSettingsIds?: InputMaybe<Array<Scalars['AssessmentSettingsId']>>;
  frameworkIds?: InputMaybe<Array<Scalars['FrameworkId']>>;
  /** If true default settings will be addedd to the response */
  includePresets?: Scalars['Boolean'];
  statuses?: InputMaybe<Array<FrameworkSettingsStatus>>;
  /** If true, only return assessment settings that should be visible in the progress report */
  visibleInProgressReport?: InputMaybe<Scalars['Boolean']>;
};

export type AssessmentSettingsInput = {
  ageBandSettings: AgeBandSettingsInput;
  customFieldSettings?: InputMaybe<CustomFieldSettingsInput>;
  frameworkId: Scalars['FrameworkId'];
  institutionSetId: Scalars['InstitutionSetId'];
  optionSettings: AssessmentOptionSettingsInput;
  reflectionSettings: ReflectionSettingsInput;
  title: Scalars['String'];
};

export type AssessmentSettingsUpdate = {
  ageBandSettings: AgeBandSettingsInput;
  assessmentSettingsId: Scalars['AssessmentSettingsId'];
  customFieldSettings?: InputMaybe<CustomFieldSettingsInput>;
  frameworkId?: InputMaybe<Scalars['FrameworkId']>;
  institutionSetId: Scalars['InstitutionSetId'];
  optionSettings: AssessmentOptionSettingsInput;
  reflectionSettings: ReflectionSettingsInput;
  title: Scalars['String'];
};

/** Represents what an user can do with assessment settings. */
export type AssessmentSettingsUserOptions = {
  __typename?: 'AssessmentSettingsUserOptions';
  canUseCustomFields: Scalars['Boolean'];
};

/** Configuration to automatically be assigned to new bill payers */
export type AssignToNewBillPayers = {
  __typename?: 'AssignToNewBillPayers';
  occurrence: AutomaticInvoicingOccurrence;
};

/** Configuration to automatically be assigned to new bill payers */
export type AssignToNewBillPayersInput = {
  occurrence: AutomaticInvoicingOccurrence;
};

export type AssignedShiftsType = {
  __typename?: 'AssignedShiftsType';
  date: Scalars['LocalDate'];
  scheduledMinutesOnDay: Scalars['Float'];
  shifts: Array<ShiftType>;
};

export type AssistedChildImportServiceOffering = {
  __typename?: 'AssistedChildImportServiceOffering';
  isEnabled: Scalars['Boolean'];
};


export type AssistedChildImportServiceOfferingisEnabledArgs = {
  siteSetId: Scalars['SiteSetId'];
};

/** Bill Payer associated with user, with in-app payments-related data */
export type AssociatedBillPayer = {
  __typename?: 'AssociatedBillPayer';
  automaticPaymentsDate?: Maybe<Scalars['LocalDate']>;
  billPayerId: Scalars['BillPayerId'];
  enabledSourceTypes: Array<PaymentsSourceType>;
  institutionId: Scalars['InstitutionId'];
  name: Scalars['String'];
};

export type AttendanceCreateInputType = {
  /** Attendance date-time range */
  dateTimeRange: NonEmptyLocalDateTimeRangeInput;
  /** Staff member id */
  employeeId: Scalars['EmployeeId'];
  /** Room id of attendance */
  groupId: Scalars['GroupId'];
  /** Work tag id */
  workTagId?: InputMaybe<Scalars['WorkTagId']>;
};

/** Attendance empty states queries */
export type AttendanceEmptyStatesQueries = {
  __typename?: 'AttendanceEmptyStatesQueries';
  childAttendance: EmptyStateChildAttendanceResultType;
  customRegistrationForms: EmptyStateCustomRegistrationFormsResultType;
  futureAvailability: EmptyStateFutureAvailabilityResultType;
  inquiries: EmptyStateInquiriesResultType;
  occupancyReport: EmptyStateOccupancyReportResultType;
  roomPlanner: EmptyStateRoomPlannerResultType;
};


/** Attendance empty states queries */
export type AttendanceEmptyStatesQuerieschildAttendanceArgs = {
  siteSetId: Scalars['SiteSetId'];
};


/** Attendance empty states queries */
export type AttendanceEmptyStatesQueriescustomRegistrationFormsArgs = {
  siteSetId: Scalars['SiteSetId'];
};


/** Attendance empty states queries */
export type AttendanceEmptyStatesQueriesfutureAvailabilityArgs = {
  siteSetId: Scalars['SiteSetId'];
};


/** Attendance empty states queries */
export type AttendanceEmptyStatesQueriesinquiriesArgs = {
  siteSetId: Scalars['SiteSetId'];
};


/** Attendance empty states queries */
export type AttendanceEmptyStatesQueriesoccupancyReportArgs = {
  siteSetId: Scalars['SiteSetId'];
};

/** Operations querying attendance feature settings */
export type AttendanceFeatureSettingsQueries = {
  __typename?: 'AttendanceFeatureSettingsQueries';
  customFte: CustomFteFeatureSettingsFlags;
  customRegistrationForms: CustomRegistrationFormsFeatureSettingsFlags;
  inquiry: InquiryFeatureSettingsFlags;
  kinderConnect: KinderConnectFeatureSettingsFlags;
  milkReport: MilkReportFeatureSettingsFlags;
  orgInquiries: OrgInquiriesFeatureSettingsFlags;
};


/** Operations querying attendance feature settings */
export type AttendanceFeatureSettingsQueriescustomFteArgs = {
  siteSetId: Scalars['InstitutionSetId'];
};


/** Operations querying attendance feature settings */
export type AttendanceFeatureSettingsQueriescustomRegistrationFormsArgs = {
  siteSetId: Scalars['InstitutionSetId'];
};


/** Operations querying attendance feature settings */
export type AttendanceFeatureSettingsQueriesinquiryArgs = {
  siteSetId: Scalars['SiteSetId'];
};


/** Operations querying attendance feature settings */
export type AttendanceFeatureSettingsQuerieskinderConnectArgs = {
  siteSetId: Scalars['InstitutionSetId'];
};


/** Operations querying attendance feature settings */
export type AttendanceFeatureSettingsQueriesmilkReportArgs = {
  siteSetId: Scalars['InstitutionSetId'];
};


/** Operations querying attendance feature settings */
export type AttendanceFeatureSettingsQueriesorgInquiriesArgs = {
  siteSetId: Scalars['SiteSetId'];
};

export type AttendanceManagementFlagsType = {
  __typename?: 'AttendanceManagementFlagsType';
  canCreate: Scalars['Boolean'];
  canDelete: Scalars['Boolean'];
  canEdit: Scalars['Boolean'];
  canView: Scalars['Boolean'];
};

/** Operations querying attendance management */
export type AttendanceManagementQueries = {
  __typename?: 'AttendanceManagementQueries';
  customFte: CustomFteManagementType;
  customRegistrationForm: CustomRegistrationFormManagementQueries;
  /** True if current user is a staff member (current user context is a professional) */
  isStaffMember: Scalars['Boolean'];
  orgInquiries: Array<OrgInquiriesManagementType>;
};


/** Operations querying attendance management */
export type AttendanceManagementQueriescustomFteArgs = {
  siteSetId: Scalars['InstitutionSetId'];
};


/** Operations querying attendance management */
export type AttendanceManagementQueriesorgInquiriesArgs = {
  siteSetIds: Array<Scalars['SiteSetId']>;
};

export type AttendanceManagementResultType = {
  __typename?: 'AttendanceManagementResultType';
  canCreate: Scalars['Boolean'];
  canDelete: Scalars['Boolean'];
  canEdit: Scalars['Boolean'];
  canView: Scalars['Boolean'];
  dailyCsvExportURL: AttendanceManagementFlagsType;
  detailedCsvExportURL: AttendanceManagementFlagsType;
  historicalCsvExportURL: AttendanceManagementFlagsType;
  siteSet: AttendanceManagementFlagsType;
};

/** Create, delete or update staff member attendance */
export type AttendanceMutation = {
  __typename?: 'AttendanceMutation';
  /** @deprecated Deprecated in App Version 162. Use createV2 instead. */
  create: StaffMemberRecords;
  /** @deprecated Deprecated in App Version 163 (but never used on FE). Use V3 instead. */
  createV2: StaffHoursAttendanceByStaffType;
  createV3: StaffHoursAttendanceByStaffTypeV2;
  /** @deprecated Deprecated in App Version 162. Use deleteV2 instead. */
  delete: StaffMemberRecords;
  /** @deprecated Deprecated in App Version 163 (but never used on FE). Use V3 instead. */
  deleteV2: StaffHoursAttendanceByStaffType;
  deleteV3: StaffHoursAttendanceByStaffTypeV2;
  /** @deprecated Deprecated in App Version 162. Use updateV2 instead. */
  update: StaffMemberRecords;
  /** @deprecated Deprecated in App Version 163 (but never used on FE). Use V3 instead. */
  updateV2: StaffHoursAttendanceByStaffType;
  updateV3: StaffHoursAttendanceByStaffTypeV2;
};


/** Create, delete or update staff member attendance */
export type AttendanceMutationcreateArgs = {
  attendanceInput: EmployeeAttendanceInput;
  displayRange: ClosedLocalDateRange;
};


/** Create, delete or update staff member attendance */
export type AttendanceMutationcreateV2Args = {
  attendanceInput: AttendanceCreateInputType;
  displayRange: ClosedLocalDateRange;
};


/** Create, delete or update staff member attendance */
export type AttendanceMutationcreateV3Args = {
  attendanceInput: AttendanceCreateInputType;
  displayRange: ClosedLocalDateRange;
};


/** Create, delete or update staff member attendance */
export type AttendanceMutationdeleteArgs = {
  displayRange: ClosedLocalDateRange;
  employeeCheckInId: Scalars['EmployeeCheckInId'];
};


/** Create, delete or update staff member attendance */
export type AttendanceMutationdeleteV2Args = {
  displayRange: ClosedLocalDateRange;
  employeeCheckInId: Scalars['EmployeeCheckInId'];
};


/** Create, delete or update staff member attendance */
export type AttendanceMutationdeleteV3Args = {
  displayRange: ClosedLocalDateRange;
  employeeCheckInId: Scalars['EmployeeCheckInId'];
};


/** Create, delete or update staff member attendance */
export type AttendanceMutationupdateArgs = {
  displayRange: ClosedLocalDateRange;
  updateAttendanceInput: UpdateAttendanceInput;
};


/** Create, delete or update staff member attendance */
export type AttendanceMutationupdateV2Args = {
  attendanceInput: AttendanceUpdateInputType;
  displayRange: ClosedLocalDateRange;
};


/** Create, delete or update staff member attendance */
export type AttendanceMutationupdateV3Args = {
  attendanceInput: AttendanceUpdateInputType;
  displayRange: ClosedLocalDateRange;
};

export type AttendanceMutations = {
  __typename?: 'AttendanceMutations';
  customRegistrationForm: CustomRegistrationFormMutations;
  inquiries: InquiriesMutations;
};

export type AttendanceQueries = {
  __typename?: 'AttendanceQueries';
  childCheckins: ChildCheckinsQueryType;
  customRegistrationForm: CustomRegistrationFormQueries;
  emptyStates: AttendanceEmptyStatesQueries;
  featureSettings: AttendanceFeatureSettingsQueries;
  fte: FTEQueries;
  inquiries: InquiriesQueries;
  management: AttendanceManagementQueries;
  milkReport: MilkReportQueryType;
  /** provides a summary of the attendance for the given institution set in the provided range */
  summary: Array<AttendanceReport>;
};


export type AttendanceQueriessummaryArgs = {
  childIds?: InputMaybe<Array<Scalars['ChildId']>>;
  ignorePlanIds?: InputMaybe<Array<Scalars['PlanId']>>;
  ignorePurchaseIds?: InputMaybe<Array<Scalars['PurchaseId']>>;
  ignoreRules?: InputMaybe<Scalars['Boolean']>;
  institutionSetId: Scalars['InstitutionSetId'];
  ranges: Array<ClosedLocalDateRange>;
};

export type AttendanceReport = AttendanceSummary & {
  __typename?: 'AttendanceReport';
  ageGroups: Array<AgeGroupAttendanceReport>;
  children: Array<ChildAttendanceReport>;
  range: TimeRangeClosed;
  rooms: Array<RoomAttendanceReport>;
  slots: Array<AttendanceSlot>;
  stats: AttendanceStats;
};


export type AttendanceReportroomsArgs = {
  rooms?: InputMaybe<Array<Scalars['GroupId']>>;
};


export type AttendanceReportslotsArgs = {
  buckets?: InputMaybe<Array<ClosedLocalTimeRange>>;
};

export type AttendanceSchedule = {
  __typename?: 'AttendanceSchedule';
  behaviors: Array<Behavior>;
  deletedAt?: Maybe<Scalars['ZonedDateTime']>;
  fullYear?: Maybe<Scalars['Boolean']>;
  id: Scalars['AttendanceScheduleId'];
  periods: Array<TimeRangeClosed>;
  startMonth?: Maybe<Scalars['Int']>;
  title: Scalars['Title'];
};


export type AttendanceSchedulebehaviorsArgs = {
  range?: InputMaybe<ClosedLocalDateRange>;
};

export type AttendanceScheduleInput = {
  fullYear: Scalars['Boolean'];
  id?: InputMaybe<Scalars['AttendanceScheduleId']>;
  institutionSetId: Scalars['InstitutionSetId'];
  periods: Array<ClosedLocalDateRange>;
  startMonth?: InputMaybe<Scalars['Int']>;
  title: Scalars['Title'];
};

export type AttendanceScheduleMutations = {
  __typename?: 'AttendanceScheduleMutations';
  deleteAttendanceSchedules: Array<Scalars['AttendanceScheduleId']>;
  setAttendanceSchedule: AttendanceSchedule;
};


export type AttendanceScheduleMutationsdeleteAttendanceSchedulesArgs = {
  attendanceScheduleIds: Array<Scalars['AttendanceScheduleId']>;
};


export type AttendanceScheduleMutationssetAttendanceScheduleArgs = {
  attendanceSchedule: AttendanceScheduleInput;
};

export type AttendanceScheduleQueries = {
  __typename?: 'AttendanceScheduleQueries';
  list: Array<AttendanceSchedule>;
};


export type AttendanceScheduleQuerieslistArgs = {
  attendanceScheduleIds?: InputMaybe<Array<Scalars['AttendanceScheduleId']>>;
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
  institutionSetIds?: InputMaybe<Array<Scalars['InstitutionSetId']>>;
};

export type AttendanceSlot = {
  __typename?: 'AttendanceSlot';
  children: Array<ChildAttendanceStatus>;
  day: Scalars['LocalDate'];
  stats: AttendanceSlotStats;
  timeRange: TimeRangeClosedLocalTime;
  vacancy: FreeSeats;
};

export type AttendanceSlotStats = {
  __typename?: 'AttendanceSlotStats';
  staffRequired?: Maybe<Scalars['Float']>;
  /** Returns staffRequired taking the capacity factor of age groups into account (called via `AttendanceFamlyAPIService.php`). */
  staffRequiredByAgeGroupCapacityFactor?: Maybe<Scalars['Float']>;
  totalChildren: Scalars['Int'];
};

export type AttendanceStats = {
  __typename?: 'AttendanceStats';
  available: AvailabilityStats;
  days: DaysStats;
  occupied: OccupancyStats;
};

export type AttendanceStatus = AttendanceStatusExpected | AttendanceStatusNotExpected;

export type AttendanceStatusExpected = {
  __typename?: 'AttendanceStatusExpected';
  id: Scalars['String'];
  reasons: Array<ExpectedReason>;
};

export enum AttendanceStatusFilter {
  ExpectedFromBookings = 'ExpectedFromBookings',
  ExpectedFromCheckins = 'ExpectedFromCheckins',
  ExpectedFromPlanBookings = 'ExpectedFromPlanBookings',
  IgnoreChildLeaves = 'IgnoreChildLeaves'
}

export type AttendanceStatusNotExpected = {
  __typename?: 'AttendanceStatusNotExpected';
  id: Scalars['String'];
  reasons: Array<AbsentReason>;
};

export type AttendanceSummary = {
  slots: Array<AttendanceSlot>;
  stats: AttendanceStats;
};


export type AttendanceSummaryslotsArgs = {
  buckets?: InputMaybe<Array<ClosedLocalTimeRange>>;
};

/** Time recorded and calculated of attendance (checkIn/checkOut) */
export type AttendanceTimeInfo = {
  __typename?: 'AttendanceTimeInfo';
  calculatedTime: Scalars['LocalDateTime'];
  time: Scalars['LocalDateTime'];
};

export type AttendanceUpdateInputType = {
  /** Attendance date-time range */
  dateTimeRange: NonEmptyLocalDateTimeRangeInput;
  /** Attendance id */
  employeeCheckInId: Scalars['EmployeeCheckInId'];
  /** Room id of attendance */
  groupId: Scalars['GroupId'];
  /** Work tag id */
  workTagId?: InputMaybe<Scalars['WorkTagId']>;
};

/** The target of an audit log entry, i.e. who it relates to */
export type AuditEntryTarget = {
  __typename?: 'AuditEntryTarget';
  id: Scalars['String'];
  type: TargetType;
};

/** An entry in the audit log */
export type AuditLogEntry = {
  __typename?: 'AuditLogEntry';
  body?: Maybe<Scalars['String']>;
  entryType: EntryType;
  id: Scalars['String'];
  initiator: Person;
  link?: Maybe<Scalars['String']>;
  targets: Array<AuditEntryTarget>;
  timestamp: Scalars['ZonedDateTime'];
  title: Scalars['String'];
};

export type AuthenticateWithOIDCResult = AuthenticationChallenged | AuthenticationFailed | AuthenticationSucceeded;

export type AuthenticateWithPasswordAndContextResult = AuthenticationFailed | AuthenticationSucceeded;

export type AuthenticateWithPasswordResult = AuthenticationChallenged | AuthenticationFailed | AuthenticationSucceeded;

export type AuthenticateWithPinResult = AuthenticationFailed | AuthenticationSucceeded;

/** More input needed for authentication to proceed */
export type AuthenticationChallenged = AuthenticationResult & {
  __typename?: 'AuthenticationChallenged';
  choices: Array<UserContextChoice>;
  deviceId: Scalars['DeviceId'];
  expiresAt: Scalars['Long'];
  loginId: Scalars['LoginId'];
  person: Person;
  status: AuthenticationStatus;
};

/** The authentication attempt failed. */
export type AuthenticationFailed = AuthenticationResult & {
  __typename?: 'AuthenticationFailed';
  errorDetails: Scalars['Markdown'];
  errorTitle: Scalars['Markdown'];
  status: AuthenticationStatus;
};

/** Describes which options are available for authentication */
export type AuthenticationOptions = {
  __typename?: 'AuthenticationOptions';
  behaviors: Array<Behavior>;
};

export type AuthenticationResult = {
  status: AuthenticationStatus;
};

/** The possible authentication statuses */
export enum AuthenticationStatus {
  Failed = 'Failed',
  FailedHmacExpired = 'FailedHmacExpired',
  FailedInvalidPassword = 'FailedInvalidPassword',
  FailedInvalidPin = 'FailedInvalidPin',
  FailedInvalidTwofactorCode = 'FailedInvalidTwofactorCode',
  FailedLoginNotFound = 'FailedLoginNotFound',
  FailedNoPin = 'FailedNoPin',
  FailedNoValidLoginsBeforePin = 'FailedNoValidLoginsBeforePin',
  FailedOIDC = 'FailedOIDC',
  FailedPasswordAttemptInsteadOfOIDC = 'FailedPasswordAttemptInsteadOfOIDC',
  FailedPasswordNotSet = 'FailedPasswordNotSet',
  FailedTooManyAttempts = 'FailedTooManyAttempts',
  FailedTooManyPinAttempts = 'FailedTooManyPinAttempts',
  Succeeded = 'Succeeded',
  UnknownResult = 'UnknownResult'
}

/** The authentication succeeded and user is ready to use the app. */
export type AuthenticationSucceeded = AuthenticationResult & {
  __typename?: 'AuthenticationSucceeded';
  accessToken: Scalars['AccessToken'];
  deviceId: Scalars['DeviceId'];
  status: AuthenticationStatus;
};

export type AutoLogout = {
  __typename?: 'AutoLogout';
  afterSeconds: Scalars['Int'];
  version: AutoLogoutVersion;
};

export enum AutoLogoutVersion {
  AutoLogoutV1 = 'AutoLogoutV1',
  AutoLogoutV2 = 'AutoLogoutV2'
}

/** The billing date set up for automatic payments */
export type AutomaticBillingDate = {
  __typename?: 'AutomaticBillingDate';
  dayOfTheWeek?: Maybe<DayOfTheWeek>;
  exactDay?: Maybe<Scalars['Int']>;
  relativeBillingDate: RelativeBillingDate;
};

/** Set the relative (or exact) monthly or weekly billing date for automatic payments */
export type AutomaticBillingDateInput = {
  dayOfTheWeek?: InputMaybe<DayOfTheWeek>;
  exactDay?: InputMaybe<Scalars['Int']>;
  relativeBillingDate: RelativeBillingDate;
};

/** Details about the Automatic Invoicing Configuration for this site/org */
export type AutomaticInvoicingConfig = {
  __typename?: 'AutomaticInvoicingConfig';
  assignToNewBillPayers?: Maybe<AssignToNewBillPayers>;
  biweekly?: Maybe<BiweeklyInvoicingConfig>;
  configurationInheritance: ConfigurationInheritance;
  daysUntilPaymentDeadline?: Maybe<Scalars['Int']>;
  invoicingPeriod?: Maybe<InvoicingPeriod>;
  monthly?: Maybe<MonthlyInvoicingConfig>;
  weekly?: Maybe<WeeklyInvoicingConfig>;
};

/** Details about the Automatic Invoicing Configuration for this site/org */
export type AutomaticInvoicingConfigInput = {
  assignToNewBillPayers?: InputMaybe<AssignToNewBillPayersInput>;
  biweekly?: InputMaybe<BiweeklyInvoicingConfigInput>;
  daysUntilPaymentDeadline?: InputMaybe<Scalars['Int']>;
  invoicingPeriod?: InputMaybe<InvoicingPeriod>;
  monthly?: InputMaybe<MonthlyInvoicingConfigInput>;
  weekly?: InputMaybe<WeeklyInvoicingConfigInput>;
};

export type AutomaticInvoicingConfigMutation = {
  __typename?: 'AutomaticInvoicingConfigMutation';
  /** Set automatic invoicing configuration for this org/site */
  setAutomaticInvoicingConfig: AutomaticInvoicingConfig;
  /** Set automatic invoicing configuration for bill payer(s). */
  setBillPayerAutomaticInvoicingConfig: Array<BillPayerAutomaticInvoicingConfig>;
};


export type AutomaticInvoicingConfigMutationsetAutomaticInvoicingConfigArgs = {
  config: AutomaticInvoicingConfigInput;
  siteSetId: Scalars['InstitutionSetId'];
};


export type AutomaticInvoicingConfigMutationsetBillPayerAutomaticInvoicingConfigArgs = {
  billPayerIds: Array<Scalars['BillPayerId']>;
  schedule?: InputMaybe<AutomaticInvoicingOccurrence>;
  siteSetId: Scalars['InstitutionSetId'];
};

export type AutomaticInvoicingConfigQuery = {
  __typename?: 'AutomaticInvoicingConfigQuery';
  /** List automatic invoicing configuration(s) for this org/site */
  automaticInvoicingConfig: AutomaticInvoicingConfig;
  /** List the automatic invoicing setup for the given bill payers */
  billPayerAutomaticInvoicingConfig: Array<BillPayerAutomaticInvoicingConfig>;
};


export type AutomaticInvoicingConfigQueryautomaticInvoicingConfigArgs = {
  siteSetId: Scalars['InstitutionSetId'];
};


export type AutomaticInvoicingConfigQuerybillPayerAutomaticInvoicingConfigArgs = {
  billPayerIds: Array<Scalars['BillPayerId']>;
  siteSetId: Scalars['InstitutionSetId'];
};

export enum AutomaticInvoicingFilterInputType {
  /** Filter on bill payers with automatic invoicing schedule of BIWEEKLY */
  BIWEEKLY = 'BIWEEKLY',
  /** Filter on bill payers with automatic invoicing schedule of MONTHLY */
  MONTHLY = 'MONTHLY',
  /** Filter on bill payers without automatic invoicing schedule */
  NOT_SET_UP = 'NOT_SET_UP',
  /** Filter on bill payers with automatic invoicing schedule of WEEKLY */
  WEEKLY = 'WEEKLY'
}

export enum AutomaticInvoicingOccurrence {
  BIWEEKLY = 'BIWEEKLY',
  MONTHLY = 'MONTHLY',
  WEEKLY = 'WEEKLY'
}

/** The configuration for automatic payments for the given institution / account */
export type AutomaticPayments = {
  __typename?: 'AutomaticPayments';
  automaticBillingDate?: Maybe<AutomaticBillingDate>;
  enabled: Scalars['Boolean'];
  nextAutomaticPayments: Array<Scalars['LocalDate']>;
  retryFailed: Scalars['Boolean'];
  voucherHandlingConfiguration: VoucherHandlingConfiguration;
};

/** The upcoming dates for automatically charging bill payers for a given configuration */
export type AutomaticPaymentsPreview = {
  __typename?: 'AutomaticPaymentsPreview';
  dates: Array<Scalars['LocalDate']>;
  voucherDates?: Maybe<Array<Scalars['LocalDate']>>;
  warning?: Maybe<Scalars['String']>;
  warningWhy?: Maybe<Scalars['String']>;
};

/** A session or a product availability */
export type Availability = {
  day: Scalars['DayOfWeek'];
};

export type AvailabilityStats = {
  __typename?: 'AvailabilityStats';
  fraction: Scalars['Float'];
  percentage: Scalars['Float'];
};

/** The available payment methods and whether the site is US based */
export type AvailablePaymentMethodsType = {
  __typename?: 'AvailablePaymentMethodsType';
  isInUS: Scalars['Boolean'];
  paymentMethods: Array<PaymentsSourceType>;
};

/** List available report headers for sites. They are always associated to a curriculum but optionally associated to an assessment setting */
export type AvailableReportHeaders = {
  __typename?: 'AvailableReportHeaders';
  list: Array<ChildDevelopmentReportHeader>;
};


/** List available report headers for sites. They are always associated to a curriculum but optionally associated to an assessment setting */
export type AvailableReportHeaderslistArgs = {
  includeRefinementReports: Scalars['Boolean'];
  reportType: ReportConfigType;
  siteSetId: Scalars['SiteSetId'];
};

/** The Direct Debit Instruction and Payments Source that represents a BACS Payments Source */
export type BACSSource = {
  __typename?: 'BACSSource';
  ddi: DirectDebitInstruction;
  paymentsSource: PaymentsSource;
};

export type Badge = QualificationAssignment & {
  __typename?: 'Badge';
  certificateNumber?: Maybe<Scalars['String']>;
  employeeId: Scalars['EmployeeId'];
  expirationDate?: Maybe<Scalars['LocalDateTime']>;
  fileIds: Array<Scalars['FileId']>;
  /** The files attached to the qualification, if any */
  files: Array<File>;
  id: Scalars['StaffQualificationAssignmentId'];
  imageIds: Array<Scalars['ImageId']>;
  /** The images attached to the qualification, if any */
  images: Array<Image>;
  institutionId: Scalars['InstitutionId'];
  note?: Maybe<Scalars['String']>;
  qualification: Qualification;
  qualificationDate: Scalars['LocalDateTime'];
  qualificationId: Scalars['StaffQualificationId'];
  title?: Maybe<Scalars['String']>;
};

export type BankHours = {
  __typename?: 'BankHours';
  employeeId: Scalars['EmployeeId'];
  hours: Scalars['Int'];
  minutes: Scalars['Int'];
  validFrom: Scalars['ZonedDateTime'];
};

export type BankHoursInput = {
  hours: Scalars['Int'];
  minutes: Scalars['Int'];
};

export type BankHoursInputV2 = {
  minutes: Scalars['Int'];
};

/** Bank hours mutations */
export type BankHoursMutations = {
  __typename?: 'BankHoursMutations';
  /**
   * Save employee bank hours. Replaces current value if present.
   * @deprecated Current Mobile App Version 160. Use 'saveV2' instead
   */
  save: BankHoursResult;
  /** Save employee bank hours. Replaces current value if present. */
  saveV2: BankHoursResultV2;
};


/** Bank hours mutations */
export type BankHoursMutationssaveArgs = {
  bankHoursInput: BankHoursInput;
  employeeId: Scalars['EmployeeId'];
};


/** Bank hours mutations */
export type BankHoursMutationssaveV2Args = {
  bankHoursInput: BankHoursInputV2;
  employeeId: Scalars['EmployeeId'];
};

/** Bank hours queries */
export type BankHoursQueries = {
  __typename?: 'BankHoursQueries';
  /**
   * Returns current value for employee bank hours, if defined.
   * @deprecated Current Mobile App Version 160. Use 'byEmployeeV2' instead
   */
  byEmployee: BankHoursResult;
  /** Returns current value for employee bank hours, if defined. */
  byEmployeeV2: BankHoursResultV2;
};


/** Bank hours queries */
export type BankHoursQueriesbyEmployeeArgs = {
  employeeId: Scalars['EmployeeId'];
};


/** Bank hours queries */
export type BankHoursQueriesbyEmployeeV2Args = {
  employeeId: Scalars['EmployeeId'];
};

export type BankHoursResult = {
  __typename?: 'BankHoursResult';
  current?: Maybe<BankHours>;
};

export type BankHoursResultV2 = {
  __typename?: 'BankHoursResultV2';
  current?: Maybe<BankHoursV2>;
};

export type BankHoursV2 = {
  __typename?: 'BankHoursV2';
  employeeId: Scalars['EmployeeId'];
  minutes: Scalars['Int'];
  validFrom: Scalars['ZonedDateTime'];
};

/** Information about banners */
export type Banners = {
  __typename?: 'Banners';
  buyNowBanner?: Maybe<BuyNowBannerResult>;
  debtCollectionBanner?: Maybe<DebtCollectionBannerResult>;
  /** @deprecated This banner is no longer in use. */
  oldFreeMigrationNoticeBanner?: Maybe<OldFreeMigrationNoticeBanner>;
};


/** Information about banners */
export type BannersbuyNowBannerArgs = {
  siteSetId: Scalars['InstitutionSetId'];
};

export type Baseline = {
  __typename?: 'Baseline';
  baselines: Array<SiteBaseline>;
};

/** Deprecated! Represents a Behavior */
export type Behavior = {
  /** The ID of the behavior */
  behaviorId: Scalars['String'];
  /**
   * The ID of the behavior
   * @deprecated Use 'behaviorId' instead
   */
  id: Scalars['String'];
};

export type BehaviorAccountIsOnboarding = Behavior & {
  __typename?: 'BehaviorAccountIsOnboarding';
  /** The ID of the behavior */
  behaviorId: Scalars['String'];
  /**
   * The ID of the behavior
   * @deprecated Use 'behaviorId' instead
   */
  id: Scalars['String'];
  parentsNotified: Scalars['Boolean'];
};

export type BehaviorActiveLoginValidation = Behavior & {
  __typename?: 'BehaviorActiveLoginValidation';
  /** The ID of the behavior */
  behaviorId: Scalars['String'];
  /**
   * The ID of the behavior
   * @deprecated Use 'behaviorId' instead
   */
  id: Scalars['String'];
  validationOption: ValidationOption;
};

export type BehaviorAutomaticPayments = Behavior & {
  __typename?: 'BehaviorAutomaticPayments';
  /** The ID of the behavior */
  behaviorId: Scalars['String'];
  billPayers: Array<BillPayer>;
  /**
   * The ID of the behavior
   * @deprecated Use 'behaviorId' instead
   */
  id: Scalars['String'];
};

export type BehaviorCanAddActivityToLibrary = Behavior & {
  __typename?: 'BehaviorCanAddActivityToLibrary';
  /** The ID of the behavior */
  behaviorId: Scalars['String'];
  /**
   * The ID of the behavior
   * @deprecated Use 'behaviorId' instead
   */
  id: Scalars['String'];
  libraries: Array<ActivityLibrary>;
};

export type BehaviorCanCreateChildNote = Behavior & {
  __typename?: 'BehaviorCanCreateChildNote';
  /** The ID of the behavior */
  behaviorId: Scalars['String'];
  draft: Array<ChildNoteType>;
  /**
   * The ID of the behavior
   * @deprecated Use 'behaviorId' instead
   */
  id: Scalars['String'];
  publish: Array<ChildNoteType>;
  regular: Scalars['Boolean'];
  safeguarding: Scalars['Boolean'];
  sensitive: Scalars['Boolean'];
};

export type BehaviorCanCreatePurchase = Behavior & {
  __typename?: 'BehaviorCanCreatePurchase';
  autoApprove: Scalars['Boolean'];
  /** The ID of the behavior */
  behaviorId: Scalars['String'];
  /**
   * The ID of the behavior
   * @deprecated Use 'behaviorId' instead
   */
  id: Scalars['String'];
};

export type BehaviorCanDeleteActivity = Behavior & {
  __typename?: 'BehaviorCanDeleteActivity';
  /** The ID of the behavior */
  behaviorId: Scalars['String'];
  /**
   * The ID of the behavior
   * @deprecated Use 'behaviorId' instead
   */
  id: Scalars['String'];
  lessonPlansEnabled: Scalars['Boolean'];
};

export type BehaviorCanEnableSourceTypes = Behavior & {
  __typename?: 'BehaviorCanEnableSourceTypes';
  /** The ID of the behavior */
  behaviorId: Scalars['String'];
  /**
   * The ID of the behavior
   * @deprecated Use 'behaviorId' instead
   */
  id: Scalars['String'];
  types: Array<PaymentsSourceType>;
};

export type BehaviorCanImportBillPayers = Behavior & {
  __typename?: 'BehaviorCanImportBillPayers';
  /** The ID of the behavior */
  behaviorId: Scalars['String'];
  canImportSensitive: Scalars['Boolean'];
  /**
   * The ID of the behavior
   * @deprecated Use 'behaviorId' instead
   */
  id: Scalars['String'];
};

export type BehaviorCanLinkToFrameworks = Behavior & {
  __typename?: 'BehaviorCanLinkToFrameworks';
  /** The ID of the behavior */
  behaviorId: Scalars['String'];
  frameworks: Array<Framework>;
  /**
   * The ID of the behavior
   * @deprecated Use 'behaviorId' instead
   */
  id: Scalars['String'];
};

export type BehaviorCanMakeAutomaticPayments = Behavior & {
  __typename?: 'BehaviorCanMakeAutomaticPayments';
  active: Scalars['Boolean'];
  /** The ID of the behavior */
  behaviorId: Scalars['String'];
  /**
   * The ID of the behavior
   * @deprecated Use 'behaviorId' instead
   */
  id: Scalars['String'];
  sourceType: PaymentsSourceType;
};

export type BehaviorCanManageActivityEditRights = Behavior & {
  __typename?: 'BehaviorCanManageActivityEditRights';
  /** The ID of the behavior */
  behaviorId: Scalars['String'];
  /**
   * The ID of the behavior
   * @deprecated Use 'behaviorId' instead
   */
  id: Scalars['String'];
  /** @deprecated Use libraries_v2 instead */
  libraries: Array<EditableLibrary>;
  libraries_v2: Array<EditableLibraryV2>;
};

export type BehaviorCanManageLoginValidation = Behavior & {
  __typename?: 'BehaviorCanManageLoginValidation';
  /** The ID of the behavior */
  behaviorId: Scalars['String'];
  /**
   * The ID of the behavior
   * @deprecated Use 'behaviorId' instead
   */
  id: Scalars['String'];
  validationOptions: Array<ValidationOption>;
};

export type BehaviorCanRemoveActivityFromLibrary = Behavior & {
  __typename?: 'BehaviorCanRemoveActivityFromLibrary';
  /** The ID of the behavior */
  behaviorId: Scalars['String'];
  /**
   * The ID of the behavior
   * @deprecated Use 'behaviorId' instead
   */
  id: Scalars['String'];
  libraries: Array<ActivityLibrary>;
};

export type BehaviorCanSeePurchaseAvailability = Behavior & {
  __typename?: 'BehaviorCanSeePurchaseAvailability';
  /** The ID of the behavior */
  behaviorId: Scalars['String'];
  /**
   * The ID of the behavior
   * @deprecated Use 'behaviorId' instead
   */
  id: Scalars['String'];
  rooms: Array<Scalars['GroupId']>;
};

export type BehaviorCanSeeStatuses = Behavior & {
  __typename?: 'BehaviorCanSeeStatuses';
  /** The ID of the behavior */
  behaviorId: Scalars['String'];
  /**
   * The ID of the behavior
   * @deprecated Use 'behaviorId' instead
   */
  id: Scalars['String'];
  statuses: Array<ObservationStatusState>;
};

export type BehaviorCanSeeVariants = Behavior & {
  __typename?: 'BehaviorCanSeeVariants';
  /** The ID of the behavior */
  behaviorId: Scalars['String'];
  /**
   * The ID of the behavior
   * @deprecated Use 'behaviorId' instead
   */
  id: Scalars['String'];
  variants: Array<ObservationVariant>;
};

export type BehaviorCanSetAutomaticPayments = Behavior & {
  __typename?: 'BehaviorCanSetAutomaticPayments';
  automaticPayments: AutomaticPayments;
  /** The ID of the behavior */
  behaviorId: Scalars['String'];
  /**
   * The ID of the behavior
   * @deprecated Use 'behaviorId' instead
   */
  id: Scalars['String'];
};

export type BehaviorCanSetPin = Behavior & {
  __typename?: 'BehaviorCanSetPin';
  /** The ID of the behavior */
  behaviorId: Scalars['String'];
  /**
   * The ID of the behavior
   * @deprecated Use 'behaviorId' instead
   */
  id: Scalars['String'];
  useOIDC: Array<OpenIDProvider>;
  usePassword: Scalars['Boolean'];
};

export type BehaviorCanSyncExternally = Behavior & {
  __typename?: 'BehaviorCanSyncExternally';
  /** The ID of the behavior */
  behaviorId: Scalars['String'];
  /**
   * The ID of the behavior
   * @deprecated Use 'behaviorId' instead
   */
  id: Scalars['String'];
  status: SynchronizationStatus;
};

export type BehaviorCanViewActivityLibraries = Behavior & {
  __typename?: 'BehaviorCanViewActivityLibraries';
  /** The ID of the behavior */
  behaviorId: Scalars['String'];
  /**
   * The ID of the behavior
   * @deprecated Use 'behaviorId' instead
   */
  id: Scalars['String'];
  libraries: Array<ActivityLibrary>;
};

export type BehaviorExternalAccountEditLink = Behavior & {
  __typename?: 'BehaviorExternalAccountEditLink';
  /** The ID of the behavior */
  behaviorId: Scalars['String'];
  /**
   * The ID of the behavior
   * @deprecated Use 'behaviorId' instead
   */
  id: Scalars['String'];
  url: Scalars['String'];
};

export type BehaviorFundingCanChangeToDate = Behavior & {
  __typename?: 'BehaviorFundingCanChangeToDate';
  /** The ID of the behavior */
  behaviorId: Scalars['String'];
  /**
   * The ID of the behavior
   * @deprecated Use 'behaviorId' instead
   */
  id: Scalars['String'];
  maxDate?: Maybe<Scalars['LocalDate']>;
  minDate?: Maybe<Scalars['LocalDate']>;
};

export type BehaviorFundingPeriodWarnings = Behavior & {
  __typename?: 'BehaviorFundingPeriodWarnings';
  /** The ID of the behavior */
  behaviorId: Scalars['String'];
  /**
   * The ID of the behavior
   * @deprecated Use 'behaviorId' instead
   */
  id: Scalars['String'];
  warnings: Array<Scalars['String']>;
};

export type BehaviorFundingTypeWarnings = Behavior & {
  __typename?: 'BehaviorFundingTypeWarnings';
  /** The ID of the behavior */
  behaviorId: Scalars['String'];
  /**
   * The ID of the behavior
   * @deprecated Use 'behaviorId' instead
   */
  id: Scalars['String'];
  warnings: Array<Scalars['String']>;
};

export type BehaviorHasPossibleSourceTypes = Behavior & {
  __typename?: 'BehaviorHasPossibleSourceTypes';
  /** The ID of the behavior */
  behaviorId: Scalars['String'];
  /**
   * The ID of the behavior
   * @deprecated Use 'behaviorId' instead
   */
  id: Scalars['String'];
  types: Array<PaymentsSourceType>;
};

export type BehaviorLinkToPeriodPlans = Behavior & {
  __typename?: 'BehaviorLinkToPeriodPlans';
  /** The ID of the behavior */
  behaviorId: Scalars['String'];
  /**
   * The ID of the behavior
   * @deprecated Use 'behaviorId' instead
   */
  id: Scalars['String'];
  institutionId: Scalars['InstitutionId'];
};

export type BehaviorObservationVariantAmbiguity = Behavior & {
  __typename?: 'BehaviorObservationVariantAmbiguity';
  /** The ID of the behavior */
  behaviorId: Scalars['String'];
  /**
   * The ID of the behavior
   * @deprecated Use 'behaviorId' instead
   */
  id: Scalars['String'];
  variants: Array<ObservationVariant>;
};

/** Key-value pair used to hold additional behavior-specific data */
export type BehaviorPayload = {
  __typename?: 'BehaviorPayload';
  key: Scalars['String'];
  value: Scalars['String'];
};

/** Behavior with data on relevant institutions and organizations */
export type BehaviorQuery = {
  __typename?: 'BehaviorQuery';
  behavior: Behavior;
  institutions: Array<InstitutionBehaviorNode>;
  organizations: Array<OrganizationBehaviorNode>;
};

export type BehaviorShowBillingProfileVideo = Behavior & {
  __typename?: 'BehaviorShowBillingProfileVideo';
  /** The ID of the behavior */
  behaviorId: Scalars['String'];
  /**
   * The ID of the behavior
   * @deprecated Use 'behaviorId' instead
   */
  id: Scalars['String'];
  video: Scalars['String'];
};

export type BehaviorShowChildNotes = Behavior & {
  __typename?: 'BehaviorShowChildNotes';
  acknowledge: Scalars['Boolean'];
  /** The ID of the behavior */
  behaviorId: Scalars['String'];
  /**
   * The ID of the behavior
   * @deprecated Use 'behaviorId' instead
   */
  id: Scalars['String'];
  regular: Scalars['Boolean'];
  safeguarding: Scalars['Boolean'];
  sensitive: Scalars['Boolean'];
  view: Array<ChildNoteType>;
};

export type BehaviorShowIntegrationTaskExport = Behavior & {
  __typename?: 'BehaviorShowIntegrationTaskExport';
  /** The ID of the behavior */
  behaviorId: Scalars['String'];
  /**
   * The ID of the behavior
   * @deprecated Use 'behaviorId' instead
   */
  id: Scalars['String'];
  url: Scalars['String'];
};

export type BehaviorShowLeaveRequests = Behavior & {
  __typename?: 'BehaviorShowLeaveRequests';
  /** The ID of the behavior */
  behaviorId: Scalars['String'];
  /**
   * The ID of the behavior
   * @deprecated Use 'behaviorId' instead
   */
  id: Scalars['String'];
  requests: Scalars['Int'];
};

export type BehaviorShowStaffRotasDiscount = Behavior & {
  __typename?: 'BehaviorShowStaffRotasDiscount';
  /** The ID of the behavior */
  behaviorId: Scalars['String'];
  discountPercentage: Scalars['Int'];
  /**
   * The ID of the behavior
   * @deprecated Use 'behaviorId' instead
   */
  id: Scalars['String'];
};

export type BehaviorShowStaffRotasPermissions = Behavior & {
  __typename?: 'BehaviorShowStaffRotasPermissions';
  /** The ID of the behavior */
  behaviorId: Scalars['String'];
  /** If true, the current user can manage Staffing subscriptions */
  canManageSubscription: Scalars['Boolean'];
  /**
   * The ID of the behavior
   * @deprecated Use 'behaviorId' instead
   */
  id: Scalars['String'];
  /** Other staff members who can manage Staffing subscriptions */
  otherSubscriptionManagers: Array<Person>;
};

export type BehaviorShowStaffRotasPricing = Behavior & {
  __typename?: 'BehaviorShowStaffRotasPricing';
  /** The ID of the behavior */
  behaviorId: Scalars['String'];
  /** The discounted monthly price for a Staff Rotas subscription at the current tier */
  discountedPrice?: Maybe<Scalars['BadMoney']>;
  /**
   * The ID of the behavior
   * @deprecated Use 'behaviorId' instead
   */
  id: Scalars['String'];
  /** The maximum number of staff members with a schedule you can have at the current price */
  maxNumberOfStaffOnTier: Scalars['Int'];
  /** The full monthly price for a Staff Rotas subscription at the current tier */
  price: Scalars['BadMoney'];
  /** The current number of individual staff members with a schedule set up in Staff Rotas */
  staffWithSchedules: Scalars['Int'];
};

export type BehaviorSingleton = Behavior & {
  __typename?: 'BehaviorSingleton';
  /** The ID of the behavior */
  behaviorId: Scalars['String'];
  /**
   * The ID of the behavior
   * @deprecated Use 'behaviorId' instead
   */
  id: Scalars['String'];
};

export type BehaviorUseObservationVersion = Behavior & {
  __typename?: 'BehaviorUseObservationVersion';
  /** The ID of the behavior */
  behaviorId: Scalars['String'];
  /**
   * The ID of the behavior
   * @deprecated Use 'behaviorId' instead
   */
  id: Scalars['String'];
  version: ObservationVersion;
};

export type BehaviorVolatileInvoicePeriods = Behavior & {
  __typename?: 'BehaviorVolatileInvoicePeriods';
  /** The ID of the behavior */
  behaviorId: Scalars['String'];
  /**
   * The ID of the behavior
   * @deprecated Use 'behaviorId' instead
   */
  id: Scalars['String'];
  periods: Array<TimeRangeClosed>;
};

export type BehaviorXeroIntegration = Behavior & {
  __typename?: 'BehaviorXeroIntegration';
  /** The ID of the behavior */
  behaviorId: Scalars['String'];
  /**
   * The ID of the behavior
   * @deprecated Use 'behaviorId' instead
   */
  id: Scalars['String'];
  tenant?: Maybe<XeroConnectionInfo>;
};

/** An entity who has paid, or will be paying, an invoice */
export type BillPayer = {
  __typename?: 'BillPayer';
  accountName?: Maybe<Scalars['String']>;
  accountNumber?: Maybe<Scalars['String']>;
  bic?: Maybe<Scalars['String']>;
  billPayerId: Scalars['BillPayerId'];
  billingReference?: Maybe<Scalars['String']>;
  /**
   * "True if a bill payer has an email set or if an email
   * is set on at least 1 of the invoice recipients for the bill payer.
   * "
   */
  canBeNotified: Scalars['Boolean'];
  deleted: Scalars['Boolean'];
  deletion?: Maybe<BillPayerDeletionStrategy>;
  email?: Maybe<Scalars['String']>;
  externalReferences: Array<BillPayerExternalSystemReference>;
  iban?: Maybe<Scalars['String']>;
  institutionId: Scalars['InstitutionId'];
  name: Scalars['String'];
  sortCode?: Maybe<Scalars['String']>;
};

export type BillPayerAdoptionWidgetData = {
  __typename?: 'BillPayerAdoptionWidgetData';
  isNewToFamlyPay: Scalars['Boolean'];
  paymentAdoptionPromo?: Maybe<BillPayerAdoptionWidgetPaymentAdoptionPromo>;
  payments: BillPayerAdoptionWidgetPayments;
  period: BillPayerAdoptionWidgetPeriod;
  rates: BillPayerAdoptionWidgetRates;
};

export type BillPayerAdoptionWidgetMilestone = {
  __typename?: 'BillPayerAdoptionWidgetMilestone';
  isReached: Scalars['Boolean'];
  reachedAt?: Maybe<Scalars['LocalDate']>;
  target: Scalars['Int'];
  targetReachedMessage: Scalars['String'];
};

export type BillPayerAdoptionWidgetPaymentAdoptionPromo = {
  __typename?: 'BillPayerAdoptionWidgetPaymentAdoptionPromo';
  milestones: Array<BillPayerAdoptionWidgetMilestone>;
};

export type BillPayerAdoptionWidgetPayments = {
  __typename?: 'BillPayerAdoptionWidgetPayments';
  paid: Scalars['Int'];
  unpaid: Scalars['Int'];
};

export type BillPayerAdoptionWidgetPeriod = {
  __typename?: 'BillPayerAdoptionWidgetPeriod';
  from: Scalars['LocalDate'];
  to: Scalars['LocalDate'];
};

export type BillPayerAdoptionWidgetRates = {
  __typename?: 'BillPayerAdoptionWidgetRates';
  automaticPayments: Scalars['Int'];
  manualPayments: Scalars['Int'];
};

export type BillPayerAdoptionWidgetType = Widget & {
  __typename?: 'BillPayerAdoptionWidgetType';
  adoption: BillPayerAdoptionWidgetData;
  id: Scalars['HomeWidgetId'];
  next?: Maybe<Scalars['HomeWidgetCursor']>;
  title: Scalars['String'];
  widgetId: Scalars['String'];
};

/** Automatic Invoicing Configuration for given BillPayer */
export type BillPayerAutomaticInvoicingConfig = {
  __typename?: 'BillPayerAutomaticInvoicingConfig';
  availableSchedules: Array<AutomaticInvoicingOccurrence>;
  billPayerId: Scalars['BillPayerId'];
  enabledSchedule?: Maybe<AutomaticInvoicingOccurrence>;
  isEnabled: Scalars['Boolean'];
  nextInvoice?: Maybe<Scalars['LocalDate']>;
};

/** Output for creating a bill payer */
export type BillPayerCreationResult = {
  __typename?: 'BillPayerCreationResult';
  accountNumber?: Maybe<Scalars['String']>;
  billPayerId?: Maybe<Scalars['BillPayerId']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['EmailAddress']>;
  errors: Array<ImportError>;
  externalId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  note?: Maybe<Scalars['String']>;
  socialSecurityNo?: Maybe<Scalars['String']>;
  sortCode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  streetAddress?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type BillPayerDataType = {
  __typename?: 'BillPayerDataType';
  billPayerId: Scalars['BillPayerId'];
  siteId: Scalars['SiteId'];
};

export type BillPayerDeletionStrategy = {
  __typename?: 'BillPayerDeletionStrategy';
  canDelete: Scalars['Boolean'];
  strategy: DeletionStrategy;
};

export type BillPayerExportInputType = {
  action: IntegrationTaskBillPayerAction;
  billPayerId: Scalars['BillPayerId'];
  institutionId: Scalars['InstitutionId'];
};

/** The result of a(n) bill payer export */
export type BillPayerExportResult = {
  __typename?: 'BillPayerExportResult';
  details: Array<BillPayerExportStatus>;
  /** @deprecated Use details instead */
  failed: Array<ExportedBillPayer>;
  /** @deprecated Use details instead */
  succeeded: Array<ExportedBillPayer>;
};

/** The status of exporting a(n) bill payer */
export type BillPayerExportStatus = {
  __typename?: 'BillPayerExportStatus';
  billPayerId: Scalars['BillPayerId'];
  status: SynchronizationStatus;
};

/** Details of the reference in an external system for a specific billpayer */
export type BillPayerExternalSystemReference = {
  __typename?: 'BillPayerExternalSystemReference';
  /** The external ID this billpayer relates to. */
  id: Scalars['String'];
  /** The name of the custom integration. Only relevant if `system` is set to `CUSTOM`. */
  name?: Maybe<Scalars['String']>;
  /** The name of the external system this billpayer relates to, or 'CUSTOM' if it is a custom integration. */
  system: ExternalSystemName;
};

/** Input for creating a bill payer */
export type BillPayerInput = {
  accountNumber?: InputMaybe<Scalars['String']>;
  billingReference?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  /** Identifier for keeping the bill payer in sync with an external system */
  externalId?: InputMaybe<Scalars['String']>;
  name: Scalars['NameInput'];
  note?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  /** Only available when sensitive bill payer information has been enabled */
  socialSecurityNo?: InputMaybe<Scalars['String']>;
  sortCode?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  streetAddress?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

/** Data to create a bill payer */
export type BillPayerInputResult = {
  __typename?: 'BillPayerInputResult';
  accountNumber?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['EmailAddress']>;
  externalId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  note?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  socialSecurityNo?: Maybe<Scalars['String']>;
  sortCode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  streetAddress?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

/** A listing a bill payers with balance information */
export type BillPayerListResult = {
  __typename?: 'BillPayerListResult';
  next?: Maybe<Scalars['BillPayerCursor']>;
  results: Array<BillPayerWithBalance>;
};

/** Objects related to mutating bill payer data */
export type BillPayerMutations = {
  __typename?: 'BillPayerMutations';
  /** Anonymizes the given bill payers. */
  anonymize: Array<Scalars['BillPayerId']>;
  /** Creates bill payer for internal finance site, without any child relation */
  createInternalBillPayerForSite?: Maybe<Scalars['BillPayerId']>;
  /** Fully removes the given bill payers, unless they have made FamlyPay payments, in which case they are simply anonymized. */
  hardDelete: Array<Scalars['BillPayerId']>;
  /**
   * Update the externalId on a bill payer.
   * @deprecated This is deprecated, and will set the systemName to UNKNOWN. Use the updateExternalReference mutation instead to set the systemName
   */
  updateExternalId: Scalars['String'];
  /** Update the externalReference (a.k.a externalId) on a bill payer with the given system name. */
  updateExternalReference: BillPayerExternalSystemReference;
};


/** Objects related to mutating bill payer data */
export type BillPayerMutationsanonymizeArgs = {
  billPayerIds: Array<Scalars['BillPayerId']>;
};


/** Objects related to mutating bill payer data */
export type BillPayerMutationscreateInternalBillPayerForSiteArgs = {
  email: Scalars['EmailAddress'];
  fullName: Scalars['String'];
  phoneNumber: Scalars['String'];
  role: Scalars['String'];
};


/** Objects related to mutating bill payer data */
export type BillPayerMutationshardDeleteArgs = {
  billPayerIds: Array<Scalars['BillPayerId']>;
};


/** Objects related to mutating bill payer data */
export type BillPayerMutationsupdateExternalIdArgs = {
  billPayerId: Scalars['BillPayerId'];
  externalId: Scalars['String'];
};


/** Objects related to mutating bill payer data */
export type BillPayerMutationsupdateExternalReferenceArgs = {
  billPayerId: Scalars['BillPayerId'];
  externalReference: BillpayerExternalSystemReferenceInput;
};

/** Details for referencing a bill payer in Famly */
export type BillPayerReferenceInput = {
  billPayerId?: InputMaybe<Scalars['BillPayerId']>;
  externalId?: InputMaybe<Scalars['String']>;
  siteId?: InputMaybe<Scalars['SiteId']>;
  tags: Array<ReferenceTag>;
};

/** The results of searching for a bill payer */
export type BillPayerSearchResult = {
  __typename?: 'BillPayerSearchResult';
  billPayers: Array<BillPayer>;
  next?: Maybe<Scalars['BillPayerCursor']>;
};

export enum BillPayerShareFilter {
  ActiveShares = 'ActiveShares',
  InactiveShares = 'InactiveShares'
}

/** Information about the source for a bill payer */
export type BillPayerSource = {
  __typename?: 'BillPayerSource';
  anonymous: AnonymousPaymentsSource;
  source?: Maybe<PaymentsSource>;
};

/** An entity who has paid, or will be paying an invoice */
export type BillPayerWithBalance = {
  __typename?: 'BillPayerWithBalance';
  automaticInvoicingSchedule?: Maybe<AutomaticInvoicingOccurrence>;
  balance: Scalars['BadMoney'];
  behaviors: Array<Behavior>;
  billPayer: BillPayer;
  referenceNumber?: Maybe<Scalars['String']>;
};

/** Objects related to bill payers */
export type BillPayers = {
  __typename?: 'BillPayers';
  byBillPayerIds: BillPayerListResult;
  byBillPayerName: BillPayerSearchResult;
  byInstitutionSetIds: BillPayerListResult;
  byProtoPayments: ByProtoPaymentResult;
};


/** Objects related to bill payers */
export type BillPayersbyBillPayerIdsArgs = {
  asOfDate?: InputMaybe<Scalars['LocalDate']>;
  billPayerIds: Array<Scalars['BillPayerId']>;
  includeCreditNotesAndCancelledInvoicesInBalance?: InputMaybe<Scalars['Boolean']>;
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
};


/** Objects related to bill payers */
export type BillPayersbyBillPayerNameArgs = {
  institutionId: Scalars['InstitutionId'];
  name: Scalars['String'];
  next?: InputMaybe<Scalars['BillPayerCursor']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


/** Objects related to bill payers */
export type BillPayersbyInstitutionSetIdsArgs = {
  asOfDate?: InputMaybe<Scalars['LocalDate']>;
  automaticInvoicingFilter?: InputMaybe<Array<AutomaticInvoicingFilterInputType>>;
  createdAfter?: InputMaybe<Scalars['LocalDate']>;
  createdBefore?: InputMaybe<Scalars['LocalDate']>;
  forPaymentSources?: InputMaybe<Array<PaymentsSourceFilterInputType>>;
  includeCreditNotesAndCancelledInvoicesInBalance?: InputMaybe<Scalars['Boolean']>;
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
  institutionSetIds: Array<Scalars['InstitutionSetId']>;
  next?: InputMaybe<Scalars['BillPayerCursor']>;
  onlyMissingAddress?: InputMaybe<Scalars['Boolean']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


/** Objects related to bill payers */
export type BillPayersbyProtoPaymentsArgs = {
  paymentsFeedId: Scalars['PaymentsFeedId'];
  protoPayments: Array<ByProtoPaymentInput>;
};

export enum BillingCycle {
  Annually = 'Annually',
  Monthly = 'Monthly',
  Never = 'Never'
}

export type BillingProfile = {
  __typename?: 'BillingProfile';
  annualization?: Maybe<Annualization>;
  attendanceSchedule?: Maybe<AttendanceSchedule>;
  behaviors: Array<Behavior>;
  billingProfileId: Scalars['BillingProfileId'];
  billingScheme: BillingScheme;
  fundingTypes?: Maybe<Array<Funding>>;
  /** @deprecated Use siteSetId field instead */
  institutionSetId: Scalars['InstitutionSetId'];
  isDeleted: Scalars['Boolean'];
  siteSetId: Scalars['SiteSetId'];
  title: Scalars['Title'];
};

/** Objects related to mutating billing profiles. */
export type BillingProfileMutations = {
  __typename?: 'BillingProfileMutations';
  /** Delete the billing profile */
  delete: Scalars['BillingProfileId'];
  /** Create or update a billing profile */
  upsert: BillingProfile;
};


/** Objects related to mutating billing profiles. */
export type BillingProfileMutationsdeleteArgs = {
  billingProfileId: Scalars['BillingProfileId'];
};


/** Objects related to mutating billing profiles. */
export type BillingProfileMutationsupsertArgs = {
  annualization?: InputMaybe<AnnualizationInput>;
  attendanceScheduleId: Scalars['AttendanceScheduleId'];
  billingProfileId?: InputMaybe<Scalars['BillingProfileId']>;
  billingScheme: Scalars['String'];
  fundingTypeIds?: InputMaybe<Array<Scalars['FundingTypeId']>>;
  institutionSetId: Scalars['InstitutionSetId'];
  title: Scalars['Title'];
};

/** Objects related to billing profiles. */
export type BillingProfileQueries = {
  __typename?: 'BillingProfileQueries';
  behaviors: Array<Behavior>;
  /** List all available billing profiles in the institution set */
  list: Array<BillingProfile>;
};


/** Objects related to billing profiles. */
export type BillingProfileQueriesbehaviorsArgs = {
  institutionSetId: Scalars['InstitutionSetId'];
};


/** Objects related to billing profiles. */
export type BillingProfileQuerieslistArgs = {
  billingProfileId?: InputMaybe<Array<Scalars['BillingProfileId']>>;
  institutionSetId?: InputMaybe<Scalars['InstitutionSetId']>;
};

export type BillingScheme = {
  __typename?: 'BillingScheme';
  id: Scalars['String'];
  shortTitle: Scalars['String'];
  title: Scalars['String'];
};

export type BillingSchemeQueries = {
  __typename?: 'BillingSchemeQueries';
  list: Array<BillingScheme>;
};


export type BillingSchemeQuerieslistArgs = {
  institutionSetId: Scalars['InstitutionSetId'];
};

/** Details of the reference in an external system for a specific billpayer */
export type BillpayerExternalSystemReferenceInput = {
  /** The external ID this billpayer relates to. */
  id: Scalars['String'];
  /** The name of the custom integration. Only relevant if `system` is set to `CUSTOM`. */
  name?: InputMaybe<Scalars['String']>;
  /** The name of the external system this billpayer relates to, or 'CUSTOM' if it is a custom integration. */
  system?: InputMaybe<ExternalSystemName>;
};

/** Biweekly (every other week) automatic invoicing configuration */
export type BiweeklyInvoicingConfig = {
  __typename?: 'BiweeklyInvoicingConfig';
  startDate: Scalars['LocalDate'];
};

/** Biweekly (every other week) automatic invoicing configuration */
export type BiweeklyInvoicingConfigInput = {
  startDate: Scalars['LocalDate'];
};

/** Represents a body map file resource. */
export type BodyMapFile = {
  __typename?: 'BodyMapFile';
  file: File;
  label: BodyMapLabel;
};

export enum BodyMapLabel {
  BACK = 'BACK',
  FRONT = 'FRONT',
  HEAD_FRONT_BACK = 'HEAD_FRONT_BACK',
  HEAD_SIDES = 'HEAD_SIDES',
  LEFT = 'LEFT',
  RIGHT = 'RIGHT'
}

/** Represents a body map point. */
export type BodyMapPoint = {
  __typename?: 'BodyMapPoint';
  bodyMapFile: BodyMapFile;
  radius: Scalars['Float'];
  reportId: Scalars['AccidentReportId'];
  x: Scalars['Float'];
  y: Scalars['Float'];
};

export type BodyMapPointInput = {
  fileId: Scalars['FileId'];
  radius: Scalars['Float'];
  x: Scalars['Float'];
  y: Scalars['Float'];
};

/** Top level object for the booking pattern builder queries */
export type BookingPatternBuilder = {
  __typename?: 'BookingPatternBuilder';
  config: BookingPatternBuilderConfigResult;
};


/** Top level object for the booking pattern builder queries */
export type BookingPatternBuilderconfigArgs = {
  siteId: Scalars['SiteId'];
};

export type BookingPatternBuilderConfigResult = {
  __typename?: 'BookingPatternBuilderConfigResult';
  canAccess: Scalars['Boolean'];
};

export enum BoosterPack {
  Engage = 'Engage',
  IncreaseRevenue = 'IncreaseRevenue',
  Learn = 'Learn',
  SaveTime = 'SaveTime'
}

export type BoosterPackDetails = {
  __typename?: 'BoosterPackDetails';
  annuallyPrice?: Maybe<Scalars['String']>;
  annuallyPriceVAT?: Maybe<Scalars['String']>;
  boosterPack: BoosterPack;
  canBeUpgradedTo: Scalars['Boolean'];
  description: Scalars['String'];
  /** The feature package that a booster pack belongs to. All booster packs have a 'parent' feature package. This becomes important when upgrading to a specific booster pack since there might exist multiple 'Connect' booster packs but each on their own feature package */
  featurePackage: FeaturePackage;
  freeFeatures: Array<Scalars['String']>;
  includedFeatures: Array<Scalars['String']>;
  isCurrentlyOnThisBoosterPack: Scalars['Boolean'];
  longDescription: Scalars['String'];
  monthlyPrice?: Maybe<Scalars['String']>;
  monthlyPriceVAT?: Maybe<Scalars['String']>;
  /** @deprecated use annual or monthly price instead */
  price?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  valuePropositions: Array<Scalars['String']>;
};

export type BoosterPackUpgradeInfo = {
  billingCycle: BillingCycle;
  boosterPacks: Array<BoosterPack>;
  /** The feature package the booster pack belongs to */
  featurePackage: FeaturePackage;
  paymentPreference: PaymentMethod;
  siteSetId: Scalars['SiteSetId'];
};

export type BoosterPackUpsellInfo = {
  billingCycle: BillingCycle;
  boosterPack: Array<BoosterPack>;
  /** The feature package the booster packs belongs to */
  featurePackage: FeaturePackage;
  siteSetId: Scalars['SiteSetId'];
};

/** Browse all apps by the category they are in. */
export type Browse = {
  __typename?: 'Browse';
  categories: Categories;
};

/** An add-on available for browsing */
export type BrowseAddOn = {
  __typename?: 'BrowseAddOn';
  addOnType: AddOnTypeBrowse;
  annualPrice?: Maybe<Scalars['String']>;
  annualPriceVAT?: Maybe<Scalars['String']>;
  canPurchase: Scalars['Boolean'];
  hasPurchased: Scalars['Boolean'];
  monthlyPrice?: Maybe<Scalars['String']>;
  monthlyPriceVAT?: Maybe<Scalars['String']>;
  packageId: Scalars['PackageId'];
  title: Scalars['String'];
};

export type BuiltInReport = Report & {
  __typename?: 'BuiltInReport';
  categories: Array<ReportCategory>;
  createdBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']>;
  enabledFor: Array<InstitutionSet>;
  favorite: Scalars['Boolean'];
  id: Scalars['ReportId'];
  title: Scalars['String'];
};

/** Top level object for the book pattern flow queries */
export type BulkPatternFlow = {
  __typename?: 'BulkPatternFlow';
  config: BulkPatternFlowConfigResult;
};


/** Top level object for the book pattern flow queries */
export type BulkPatternFlowconfigArgs = {
  siteId: Scalars['SiteId'];
};

export type BulkPatternFlowConfigResult = {
  __typename?: 'BulkPatternFlowConfigResult';
  canAccess: Scalars['Boolean'];
};

/** Object representing the buy now banner */
export type BuyNowBannerResult = {
  __typename?: 'BuyNowBannerResult';
  scenario: BuyNowBannerScenario;
};

/** Object representing the current scenario of the buy now banner. A scenario carries multiple versions of the banner and affect what information they carry. */
export type BuyNowBannerScenario = {
  __typename?: 'BuyNowBannerScenario';
  id: Scalars['String'];
  versions: Array<BuyNowBannerVersion>;
};

/** Object representing a version of the buy now banner's scenario. The version represents the exact data and attributes that the buy now banner could carry. */
export type BuyNowBannerVersion = {
  __typename?: 'BuyNowBannerVersion';
  bannerText: Scalars['String'];
  buttonText?: Maybe<Scalars['String']>;
  hasIcon: Scalars['Boolean'];
  id: Scalars['String'];
  linkText?: Maybe<Scalars['String']>;
};

/**
 * Contains information from a protoPayment that can be used for searching through bill payers
 * In the case of conflicting results from the provided parameters, they are prioritized in this order:
 * 1. Bill payer reference
 * 2. Invoice number
 * 3. Bill payer name
 *
 * Example: If all of the parameters point to different bill payers, the bill payer found by the bill payer reference will be returned
 *
 */
export type ByProtoPaymentInput = {
  billPayerName?: InputMaybe<Scalars['String']>;
  billPayerReference?: InputMaybe<Scalars['String']>;
  invoiceNumber?: InputMaybe<Scalars['String']>;
  rowNumber: Scalars['Int'];
};

/** A map of Proto payment => Search results */
export type ByProtoPaymentMatchedResults = {
  __typename?: 'ByProtoPaymentMatchedResults';
  rowNumber: Scalars['Int'];
  suggestedBillPayer?: Maybe<SuggestedBillPayer>;
};

/** A map of Proto payment => Bill payer suggestions */
export type ByProtoPaymentResult = {
  __typename?: 'ByProtoPaymentResult';
  paymentsFeedId: Scalars['PaymentsFeedId'];
  results: Array<ByProtoPaymentMatchedResults>;
};

/** The result of a call to the cancelPayment endpoint */
export type CancelPaymentResult = {
  __typename?: 'CancelPaymentResult';
  transaction: PaymentTransaction;
};

/** Opening hours combined with a capacity */
export type CapacityHours = {
  __typename?: 'CapacityHours';
  capacity: Scalars['Int'];
  hours: TimeRangeClosedLocalTime;
};

/** Opening hours with capacity, grouped by day-of-week */
export type CapacityHoursByDay = {
  __typename?: 'CapacityHoursByDay';
  day: Scalars['DayOfWeek'];
  openAt: Array<CapacityHours>;
};

export type CapacityHoursForDayInput = {
  capacity: Scalars['Int'];
  day: Scalars['DayOfWeek'];
  hours: ClosedLocalTimeRange;
};

export type CapacityHoursInput = {
  capacity: Scalars['Int'];
  hours: ClosedLocalTimeRange;
};

/** The different categories of which we show apps in. */
export type Categories = {
  __typename?: 'Categories';
  /** @deprecated Use 'engage' node instead */
  connect: Array<AppInPackage>;
  engage: Array<AppInPackage>;
  increaseRevenue: Array<AppInPackage>;
  learn: Array<AppInPackage>;
  saveTime: Array<AppInPackage>;
};

export enum Category {
  ATTENDANCE = 'ATTENDANCE',
  CHILDREN = 'CHILDREN',
  FINANCE = 'FINANCE',
  LEARNING = 'LEARNING',
  UNKNOWN = 'UNKNOWN'
}

export type CategoryLandingPageMutation = {
  __typename?: 'CategoryLandingPageMutation';
  v1: CategoryLandingPageMutationV1;
};

export type CategoryLandingPageMutationV1 = {
  __typename?: 'CategoryLandingPageMutationV1';
  dismiss: DismissCategoryLandingPageTypeV1;
};


export type CategoryLandingPageMutationV1dismissArgs = {
  categoryLandingPage: Category;
};

export type CategoryLandingPageQuery = {
  __typename?: 'CategoryLandingPageQuery';
  v1: CategoryLandingPageQueryV1;
};

export type CategoryLandingPageQueryV1 = {
  __typename?: 'CategoryLandingPageQueryV1';
  dismiss: CategoryLandingPageTypeV1Dismiss;
  landingPageAssets?: Maybe<LandingPageAssets>;
};

export type CategoryLandingPageTypeV1Dismiss = {
  __typename?: 'CategoryLandingPageTypeV1Dismiss';
  /** @deprecated Use the `isDismissed` prop in the navigation item payload instead. */
  isDismissed: Scalars['Boolean'];
};


export type CategoryLandingPageTypeV1DismissisDismissedArgs = {
  categoryLandingPage: Category;
};

export type CategoryOnboarding = {
  __typename?: 'CategoryOnboarding';
  /** @deprecated Use v2 instead. v1 was deprecated and no longer returns any data. */
  v1: Array<CategoryOnboardingV1Category>;
  /** @deprecated Use v3 instead. v2 is deprecated. */
  v2: CategoryOnboardingV2;
  v3: CategoryOnboardingV3;
  v4: CategoryOnboardingV4;
};


export type CategoryOnboardingv1Args = {
  siteSetId: Scalars['SiteSetId'];
};

export enum CategoryOnboardingHowShouldParentsInfoBeDisplayedOnNewsfeedQuestionVariant {
  ParentFirstNameChildFirstName = 'ParentFirstNameChildFirstName',
  ParentFirstNameChildNoName = 'ParentFirstNameChildNoName',
  ParentFullNameChildFirstName = 'ParentFullNameChildFirstName'
}

export type CategoryOnboardingHowShouldParentsInfoBeDisplayedOnNewsfeedQuestionVariantWithLabel = {
  __typename?: 'CategoryOnboardingHowShouldParentsInfoBeDisplayedOnNewsfeedQuestionVariantWithLabel';
  label: Scalars['String'];
  name: CategoryOnboardingHowShouldParentsInfoBeDisplayedOnNewsfeedQuestionVariant;
};

export enum CategoryOnboardingHowToSignChildrenAndStaffQuestionAnswerSignInOption {
  GPS = 'GPS',
  IN_APP = 'IN_APP',
  QR_CODE = 'QR_CODE'
}

export enum CategoryOnboardingHowToSignChildrenAndStaffQuestionAnswerSignInWithPinOption {
  GPS = 'GPS',
  QR_CODE = 'QR_CODE'
}

export type CategoryOnboardingMutation = {
  __typename?: 'CategoryOnboardingMutation';
  /** @deprecated Use v2 instead. v1 was deprecated and no longer returns any data. */
  v1: CategoryOnboardingV1Mutation;
  /** @deprecated Use v3 instead. v2 is deprecated. */
  v2: CategoryOnboardingV2Mutation;
  v3: CategoryOnboardingV3Mutation;
  v4: CategoryOnboardingV4Mutation;
};

export type CategoryOnboardingV1BasicsCategory = {
  __typename?: 'CategoryOnboardingV1BasicsCategory';
  sections: Array<CategoryOnboardingV1Section>;
  title: Scalars['String'];
};

export type CategoryOnboardingV1Category = CategoryOnboardingV1BasicsCategory;

export type CategoryOnboardingV1ClosingDaysQuestion = {
  __typename?: 'CategoryOnboardingV1ClosingDaysQuestion';
  answer?: Maybe<CategoryOnboardingV1ClosingDaysQuestionAnswer>;
  description?: Maybe<Scalars['String']>;
  payload: CategoryOnboardingV1ClosingDaysQuestionPayload;
  title: Scalars['String'];
};

export type CategoryOnboardingV1ClosingDaysQuestionAnswer = {
  __typename?: 'CategoryOnboardingV1ClosingDaysQuestionAnswer';
  closingDays: Array<ClosingDayDay>;
};

export type CategoryOnboardingV1ClosingDaysQuestionAnswerInput = {
  deletedClosingDays: Array<ClosingDayInput>;
  existingClosingDays: Array<ClosingDayInput>;
  newClosingDays: Array<ClosingDayInput>;
};

export type CategoryOnboardingV1ClosingDaysQuestionMutation = {
  __typename?: 'CategoryOnboardingV1ClosingDaysQuestionMutation';
  answer: Array<CategoryOnboardingV1Category>;
};


export type CategoryOnboardingV1ClosingDaysQuestionMutationanswerArgs = {
  answer: CategoryOnboardingV1ClosingDaysQuestionAnswerInput;
  siteSetId: Scalars['SiteSetId'];
};

export type CategoryOnboardingV1ClosingDaysQuestionPayload = {
  __typename?: 'CategoryOnboardingV1ClosingDaysQuestionPayload';
  closingDaysGrouped: Array<ClosingDayGroup>;
};

export type CategoryOnboardingV1Mutation = {
  __typename?: 'CategoryOnboardingV1Mutation';
  questions: CategoryOnboardingV1MutationQuestion;
};

export type CategoryOnboardingV1MutationQuestion = {
  __typename?: 'CategoryOnboardingV1MutationQuestion';
  closingDays: CategoryOnboardingV1ClosingDaysQuestionMutation;
  nurseryInfo: CategoryOnboardingV1NurseryInfoQuestionMutation;
  nurseryLogo: CategoryOnboardingV1NurseryLogoQuestionMutation;
  openingHours: CategoryOnboardingV1OpeningHoursQuestionMutation;
  pinCode: CategoryOnboardingV1PinCodeQuestionMutation;
  profileInfo: CategoryOnboardingV1ProfileInfoQuestionMutation;
  roles: CategoryOnboardingV1RolesQuestionMutation;
  rooms: CategoryOnboardingV1RoomsQuestionMutation;
};

export type CategoryOnboardingV1NurseryInfoQuestion = {
  __typename?: 'CategoryOnboardingV1NurseryInfoQuestion';
  answer?: Maybe<CategoryOnboardingV1NurseryInfoQuestionAnswer>;
  description?: Maybe<Scalars['String']>;
  payload: CategoryOnboardingV1NurseryInfoQuestionPayload;
  title: Scalars['String'];
};

export type CategoryOnboardingV1NurseryInfoQuestionAnswer = {
  __typename?: 'CategoryOnboardingV1NurseryInfoQuestionAnswer';
  address: Address;
  name: Scalars['String'];
  vat: Scalars['String'];
};

export type CategoryOnboardingV1NurseryInfoQuestionAnswerInput = {
  address: AddressInput;
  name: Scalars['String'];
  vat: Scalars['String'];
};

export type CategoryOnboardingV1NurseryInfoQuestionMutation = {
  __typename?: 'CategoryOnboardingV1NurseryInfoQuestionMutation';
  answer: Array<CategoryOnboardingV1Category>;
};


export type CategoryOnboardingV1NurseryInfoQuestionMutationanswerArgs = {
  answer: CategoryOnboardingV1NurseryInfoQuestionAnswerInput;
  siteSetId: Scalars['SiteSetId'];
};

export type CategoryOnboardingV1NurseryInfoQuestionPayload = {
  __typename?: 'CategoryOnboardingV1NurseryInfoQuestionPayload';
  address?: Maybe<Address>;
  name?: Maybe<Scalars['String']>;
  vat?: Maybe<Scalars['String']>;
};

export type CategoryOnboardingV1NurseryLogoQuestion = {
  __typename?: 'CategoryOnboardingV1NurseryLogoQuestion';
  answer?: Maybe<CategoryOnboardingV1NurseryLogoQuestionAnswer>;
  description?: Maybe<Scalars['String']>;
  payload: CategoryOnboardingV1NurseryLogoQuestionPayload;
  title: Scalars['String'];
};

export type CategoryOnboardingV1NurseryLogoQuestionAnswer = {
  __typename?: 'CategoryOnboardingV1NurseryLogoQuestionAnswer';
  profileImage?: Maybe<ProfileImage>;
};

export type CategoryOnboardingV1NurseryLogoQuestionAnswerInput = {
  profileImage?: InputMaybe<CategoryOnboardingV1QuestionAnswerProfileImageInput>;
};

export type CategoryOnboardingV1NurseryLogoQuestionMutation = {
  __typename?: 'CategoryOnboardingV1NurseryLogoQuestionMutation';
  answer: Array<CategoryOnboardingV1Category>;
};


export type CategoryOnboardingV1NurseryLogoQuestionMutationanswerArgs = {
  answer: CategoryOnboardingV1NurseryLogoQuestionAnswerInput;
  siteSetId: Scalars['SiteSetId'];
};

export type CategoryOnboardingV1NurseryLogoQuestionPayload = {
  __typename?: 'CategoryOnboardingV1NurseryLogoQuestionPayload';
  siteSetId: Scalars['SiteSetId'];
};

export type CategoryOnboardingV1OpeningHoursQuestion = {
  __typename?: 'CategoryOnboardingV1OpeningHoursQuestion';
  answer?: Maybe<CategoryOnboardingV1OpeningHoursQuestionAnswer>;
  description?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type CategoryOnboardingV1OpeningHoursQuestionAnswer = {
  __typename?: 'CategoryOnboardingV1OpeningHoursQuestionAnswer';
  openingHours: OpeningHours;
};

export type CategoryOnboardingV1OpeningHoursQuestionAnswerInput = {
  openingHours: OpeningHoursInput;
};

export type CategoryOnboardingV1OpeningHoursQuestionMutation = {
  __typename?: 'CategoryOnboardingV1OpeningHoursQuestionMutation';
  answer: Array<CategoryOnboardingV1Category>;
};


export type CategoryOnboardingV1OpeningHoursQuestionMutationanswerArgs = {
  answer: CategoryOnboardingV1OpeningHoursQuestionAnswerInput;
  siteSetId: Scalars['SiteSetId'];
};

export type CategoryOnboardingV1PinCodeQuestion = {
  __typename?: 'CategoryOnboardingV1PinCodeQuestion';
  answer?: Maybe<CategoryOnboardingV1PinCodeQuestionAnswer>;
  description?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type CategoryOnboardingV1PinCodeQuestionAnswer = {
  __typename?: 'CategoryOnboardingV1PinCodeQuestionAnswer';
  password: Scalars['Password'];
  pinCode: Scalars['String'];
};

export type CategoryOnboardingV1PinCodeQuestionAnswerInput = {
  password: Scalars['String'];
  pinCode: Scalars['String'];
};

export type CategoryOnboardingV1PinCodeQuestionMutation = {
  __typename?: 'CategoryOnboardingV1PinCodeQuestionMutation';
  answer: Array<CategoryOnboardingV1Category>;
};


export type CategoryOnboardingV1PinCodeQuestionMutationanswerArgs = {
  answer: CategoryOnboardingV1PinCodeQuestionAnswerInput;
  siteSetId: Scalars['SiteSetId'];
};

export type CategoryOnboardingV1ProfileInfoQuestion = {
  __typename?: 'CategoryOnboardingV1ProfileInfoQuestion';
  answer?: Maybe<CategoryOnboardingV1ProfileInfoQuestionAnswer>;
  description?: Maybe<Scalars['String']>;
  payload: CategoryOnboardingV1ProfileInfoQuestionPayload;
  title: Scalars['String'];
};

export type CategoryOnboardingV1ProfileInfoQuestionAnswer = {
  __typename?: 'CategoryOnboardingV1ProfileInfoQuestionAnswer';
  name: Name;
  profileImage?: Maybe<ProfileImage>;
};

export type CategoryOnboardingV1ProfileInfoQuestionAnswerInput = {
  name: Scalars['NameInput'];
  profileImage?: InputMaybe<CategoryOnboardingV1QuestionAnswerProfileImageInput>;
};

export type CategoryOnboardingV1ProfileInfoQuestionMutation = {
  __typename?: 'CategoryOnboardingV1ProfileInfoQuestionMutation';
  answer: Array<CategoryOnboardingV1Category>;
};


export type CategoryOnboardingV1ProfileInfoQuestionMutationanswerArgs = {
  answer: CategoryOnboardingV1ProfileInfoQuestionAnswerInput;
  siteSetId: Scalars['SiteSetId'];
};

export type CategoryOnboardingV1ProfileInfoQuestionPayload = {
  __typename?: 'CategoryOnboardingV1ProfileInfoQuestionPayload';
  loginId: Scalars['LoginId'];
  name?: Maybe<Name>;
  profileImage?: Maybe<ProfileImage>;
};

export type CategoryOnboardingV1Question = CategoryOnboardingV1ClosingDaysQuestion | CategoryOnboardingV1NurseryInfoQuestion | CategoryOnboardingV1NurseryLogoQuestion | CategoryOnboardingV1OpeningHoursQuestion | CategoryOnboardingV1PinCodeQuestion | CategoryOnboardingV1ProfileInfoQuestion | CategoryOnboardingV1RolesQuestion | CategoryOnboardingV1RoomsQuestion;

export type CategoryOnboardingV1QuestionAnswerProfileImageInput = {
  id: Scalars['String'];
  url: Scalars['String'];
};

export type CategoryOnboardingV1RolesQuestion = {
  __typename?: 'CategoryOnboardingV1RolesQuestion';
  answer?: Maybe<CategoryOnboardingV1RolesQuestionAnswer>;
  description?: Maybe<Scalars['String']>;
  payload: CategoryOnboardingV1RolesQuestionPayload;
  title: Scalars['String'];
};

export type CategoryOnboardingV1RolesQuestionAnswer = {
  __typename?: 'CategoryOnboardingV1RolesQuestionAnswer';
  roles: Array<CategoryOnboardingV1RolesQuestionRole>;
};

export type CategoryOnboardingV1RolesQuestionAnswerInput = {
  roles: Array<CategoryOnboardingV1RolesQuestionRoleInput>;
};

export type CategoryOnboardingV1RolesQuestionMutation = {
  __typename?: 'CategoryOnboardingV1RolesQuestionMutation';
  answer: Array<CategoryOnboardingV1Category>;
};


export type CategoryOnboardingV1RolesQuestionMutationanswerArgs = {
  answer: CategoryOnboardingV1RolesQuestionAnswerInput;
  siteSetId: Scalars['SiteSetId'];
};

export type CategoryOnboardingV1RolesQuestionPayload = {
  __typename?: 'CategoryOnboardingV1RolesQuestionPayload';
  managerRoleId: Scalars['RoleId'];
};

export type CategoryOnboardingV1RolesQuestionRole = {
  __typename?: 'CategoryOnboardingV1RolesQuestionRole';
  id: Scalars['RoleId'];
  title: Scalars['String'];
};

export type CategoryOnboardingV1RolesQuestionRoleInput = {
  id: Scalars['RoleId'];
  title: Scalars['String'];
};

export type CategoryOnboardingV1RoomsQuestion = {
  __typename?: 'CategoryOnboardingV1RoomsQuestion';
  answer?: Maybe<CategoryOnboardingV1RoomsQuestionAnswer>;
  description?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type CategoryOnboardingV1RoomsQuestionAnswer = {
  __typename?: 'CategoryOnboardingV1RoomsQuestionAnswer';
  rooms: Array<CategoryOnboardingV1RoomsQuestionRoom>;
};

export type CategoryOnboardingV1RoomsQuestionAnswerInput = {
  rooms: CategoryOnboardingV1RoomsQuestionRoomInput;
};

export type CategoryOnboardingV1RoomsQuestionMutation = {
  __typename?: 'CategoryOnboardingV1RoomsQuestionMutation';
  answer: Array<CategoryOnboardingV1Category>;
};


export type CategoryOnboardingV1RoomsQuestionMutationanswerArgs = {
  answer: CategoryOnboardingV1RoomsQuestionAnswerInput;
  siteSetId: Scalars['SiteSetId'];
};

export type CategoryOnboardingV1RoomsQuestionRoom = CategoryOnboardingV1RoomsQuestionRoomDeleted | CategoryOnboardingV1RoomsQuestionRoomExisting | CategoryOnboardingV1RoomsQuestionRoomNew;

export type CategoryOnboardingV1RoomsQuestionRoomDeleted = {
  __typename?: 'CategoryOnboardingV1RoomsQuestionRoomDeleted';
  id: Scalars['GroupId'];
};

export type CategoryOnboardingV1RoomsQuestionRoomDeletedInput = {
  id: Scalars['GroupId'];
};

export type CategoryOnboardingV1RoomsQuestionRoomExisting = {
  __typename?: 'CategoryOnboardingV1RoomsQuestionRoomExisting';
  capacity?: Maybe<Scalars['Int']>;
  id: Scalars['GroupId'];
  name: Scalars['String'];
};

export type CategoryOnboardingV1RoomsQuestionRoomExistingInput = {
  capacity?: InputMaybe<Scalars['Int']>;
  id: Scalars['GroupId'];
  name: Scalars['String'];
};

export type CategoryOnboardingV1RoomsQuestionRoomInput = {
  deleted: Array<CategoryOnboardingV1RoomsQuestionRoomDeletedInput>;
  existing: Array<CategoryOnboardingV1RoomsQuestionRoomExistingInput>;
  new: Array<CategoryOnboardingV1RoomsQuestionRoomNewInput>;
};

export type CategoryOnboardingV1RoomsQuestionRoomNew = {
  __typename?: 'CategoryOnboardingV1RoomsQuestionRoomNew';
  capacity?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
};

export type CategoryOnboardingV1RoomsQuestionRoomNewInput = {
  capacity?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
};

export type CategoryOnboardingV1RoomsSection = {
  __typename?: 'CategoryOnboardingV1RoomsSection';
  questions: Array<CategoryOnboardingV1Question>;
  title: Scalars['String'];
};

export type CategoryOnboardingV1Section = CategoryOnboardingV1RoomsSection | CategoryOnboardingV1YourNurserySection | CategoryOnboardingV1YourProfileSection;

export type CategoryOnboardingV1YourNurserySection = {
  __typename?: 'CategoryOnboardingV1YourNurserySection';
  questions: Array<CategoryOnboardingV1Question>;
  title: Scalars['String'];
};

export type CategoryOnboardingV1YourProfileSection = {
  __typename?: 'CategoryOnboardingV1YourProfileSection';
  questions: Array<CategoryOnboardingV1Question>;
  title: Scalars['String'];
};

export type CategoryOnboardingV2 = {
  __typename?: 'CategoryOnboardingV2';
  categories: Array<CategoryOnboardingV2Category>;
  config: CategoryOnboardingV2Config;
};


export type CategoryOnboardingV2categoriesArgs = {
  siteSetId: Scalars['SiteSetId'];
};

export type CategoryOnboardingV2BasicsCategory = {
  __typename?: 'CategoryOnboardingV2BasicsCategory';
  sections: Array<CategoryOnboardingV2Section>;
  title: Scalars['String'];
};

export type CategoryOnboardingV2Category = CategoryOnboardingV2BasicsCategory;

export type CategoryOnboardingV2ChildrenSection = {
  __typename?: 'CategoryOnboardingV2ChildrenSection';
  questions: Array<CategoryOnboardingV2Question>;
  title: Scalars['String'];
};

export type CategoryOnboardingV2ClosingDaysQuestion = {
  __typename?: 'CategoryOnboardingV2ClosingDaysQuestion';
  answer?: Maybe<CategoryOnboardingV2ClosingDaysQuestionAnswer>;
  description?: Maybe<Scalars['String']>;
  payload: CategoryOnboardingV2ClosingDaysQuestionPayload;
  title: Scalars['String'];
};

export type CategoryOnboardingV2ClosingDaysQuestionAnswer = {
  __typename?: 'CategoryOnboardingV2ClosingDaysQuestionAnswer';
  closingDays: Array<ClosingDayDay>;
};

export type CategoryOnboardingV2ClosingDaysQuestionAnswerInput = {
  deletedClosingDays: Array<ClosingDayInput>;
  existingClosingDays: Array<ClosingDayInput>;
  newClosingDays: Array<ClosingDayInput>;
};

export type CategoryOnboardingV2ClosingDaysQuestionMutation = {
  __typename?: 'CategoryOnboardingV2ClosingDaysQuestionMutation';
  answer: Array<CategoryOnboardingV2Category>;
};


export type CategoryOnboardingV2ClosingDaysQuestionMutationanswerArgs = {
  answer: CategoryOnboardingV2ClosingDaysQuestionAnswerInput;
  siteSetId: Scalars['SiteSetId'];
};

export type CategoryOnboardingV2ClosingDaysQuestionPayload = {
  __typename?: 'CategoryOnboardingV2ClosingDaysQuestionPayload';
  closingDaysGrouped: Array<ClosingDayGroup>;
};

export type CategoryOnboardingV2Config = {
  __typename?: 'CategoryOnboardingV2Config';
  isEnabled: Scalars['Boolean'];
};


export type CategoryOnboardingV2ConfigisEnabledArgs = {
  siteSetId: Scalars['SiteSetId'];
};

export type CategoryOnboardingV2Mutation = {
  __typename?: 'CategoryOnboardingV2Mutation';
  dismiss: Scalars['Boolean'];
  questions: CategoryOnboardingV2MutationQuestion;
};

export type CategoryOnboardingV2MutationQuestion = {
  __typename?: 'CategoryOnboardingV2MutationQuestion';
  closingDays: CategoryOnboardingV2ClosingDaysQuestionMutation;
  nurseryInfo: CategoryOnboardingV2NurseryInfoQuestionMutation;
  nurseryLogo: CategoryOnboardingV2NurseryLogoQuestionMutation;
  openingHours: CategoryOnboardingV2OpeningHoursQuestionMutation;
  pinCode: CategoryOnboardingV2PinCodeQuestionMutation;
  profileInfo: CategoryOnboardingV2ProfileInfoQuestionMutation;
  roles: CategoryOnboardingV2RolesQuestionMutation;
  rooms: CategoryOnboardingV2RoomsQuestionMutation;
};

export type CategoryOnboardingV2NurseryInfoQuestion = {
  __typename?: 'CategoryOnboardingV2NurseryInfoQuestion';
  answer?: Maybe<CategoryOnboardingV2NurseryInfoQuestionAnswer>;
  description?: Maybe<Scalars['String']>;
  payload: CategoryOnboardingV2NurseryInfoQuestionPayload;
  title: Scalars['String'];
};

export type CategoryOnboardingV2NurseryInfoQuestionAnswer = {
  __typename?: 'CategoryOnboardingV2NurseryInfoQuestionAnswer';
  address: Address;
  name: Scalars['String'];
  vat: Scalars['String'];
};

export type CategoryOnboardingV2NurseryInfoQuestionAnswerInput = {
  address: AddressInput;
  name: Scalars['String'];
  vat: Scalars['String'];
};

export type CategoryOnboardingV2NurseryInfoQuestionMutation = {
  __typename?: 'CategoryOnboardingV2NurseryInfoQuestionMutation';
  answer: Array<CategoryOnboardingV2Category>;
};


export type CategoryOnboardingV2NurseryInfoQuestionMutationanswerArgs = {
  answer: CategoryOnboardingV2NurseryInfoQuestionAnswerInput;
  siteSetId: Scalars['SiteSetId'];
};

export type CategoryOnboardingV2NurseryInfoQuestionPayload = {
  __typename?: 'CategoryOnboardingV2NurseryInfoQuestionPayload';
  address?: Maybe<Address>;
  name?: Maybe<Scalars['String']>;
  vat?: Maybe<Scalars['String']>;
};

export type CategoryOnboardingV2NurseryLogoQuestion = {
  __typename?: 'CategoryOnboardingV2NurseryLogoQuestion';
  answer?: Maybe<CategoryOnboardingV2NurseryLogoQuestionAnswer>;
  description?: Maybe<Scalars['String']>;
  payload: CategoryOnboardingV2NurseryLogoQuestionPayload;
  title: Scalars['String'];
};

export type CategoryOnboardingV2NurseryLogoQuestionAnswer = {
  __typename?: 'CategoryOnboardingV2NurseryLogoQuestionAnswer';
  profileImage?: Maybe<ProfileImage>;
};

export type CategoryOnboardingV2NurseryLogoQuestionAnswerInput = {
  profileImage?: InputMaybe<CategoryOnboardingV2QuestionAnswerProfileImageInput>;
};

export type CategoryOnboardingV2NurseryLogoQuestionMutation = {
  __typename?: 'CategoryOnboardingV2NurseryLogoQuestionMutation';
  answer: Array<CategoryOnboardingV2Category>;
};


export type CategoryOnboardingV2NurseryLogoQuestionMutationanswerArgs = {
  answer: CategoryOnboardingV2NurseryLogoQuestionAnswerInput;
  siteSetId: Scalars['SiteSetId'];
};

export type CategoryOnboardingV2NurseryLogoQuestionPayload = {
  __typename?: 'CategoryOnboardingV2NurseryLogoQuestionPayload';
  siteSetId: Scalars['SiteSetId'];
};

export type CategoryOnboardingV2OpeningHoursQuestion = {
  __typename?: 'CategoryOnboardingV2OpeningHoursQuestion';
  answer?: Maybe<CategoryOnboardingV2OpeningHoursQuestionAnswer>;
  description?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type CategoryOnboardingV2OpeningHoursQuestionAnswer = {
  __typename?: 'CategoryOnboardingV2OpeningHoursQuestionAnswer';
  openingHours: OpeningHours;
};

export type CategoryOnboardingV2OpeningHoursQuestionAnswerInput = {
  openingHours: OpeningHoursInput;
};

export type CategoryOnboardingV2OpeningHoursQuestionMutation = {
  __typename?: 'CategoryOnboardingV2OpeningHoursQuestionMutation';
  answer: Array<CategoryOnboardingV2Category>;
};


export type CategoryOnboardingV2OpeningHoursQuestionMutationanswerArgs = {
  answer: CategoryOnboardingV2OpeningHoursQuestionAnswerInput;
  siteSetId: Scalars['SiteSetId'];
};

export type CategoryOnboardingV2PinCodeQuestion = {
  __typename?: 'CategoryOnboardingV2PinCodeQuestion';
  answer?: Maybe<CategoryOnboardingV2PinCodeQuestionAnswer>;
  description?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type CategoryOnboardingV2PinCodeQuestionAnswer = {
  __typename?: 'CategoryOnboardingV2PinCodeQuestionAnswer';
  password: Scalars['Password'];
  pinCode: Scalars['String'];
};

export type CategoryOnboardingV2PinCodeQuestionAnswerInput = {
  password: Scalars['String'];
  pinCode: Scalars['String'];
};

export type CategoryOnboardingV2PinCodeQuestionMutation = {
  __typename?: 'CategoryOnboardingV2PinCodeQuestionMutation';
  answer: Array<CategoryOnboardingV2Category>;
};


export type CategoryOnboardingV2PinCodeQuestionMutationanswerArgs = {
  answer: CategoryOnboardingV2PinCodeQuestionAnswerInput;
  siteSetId: Scalars['SiteSetId'];
};

export type CategoryOnboardingV2ProfileInfoQuestion = {
  __typename?: 'CategoryOnboardingV2ProfileInfoQuestion';
  answer?: Maybe<CategoryOnboardingV2ProfileInfoQuestionAnswer>;
  description?: Maybe<Scalars['String']>;
  payload: CategoryOnboardingV2ProfileInfoQuestionPayload;
  title: Scalars['String'];
};

export type CategoryOnboardingV2ProfileInfoQuestionAnswer = {
  __typename?: 'CategoryOnboardingV2ProfileInfoQuestionAnswer';
  name: Name;
  profileImage?: Maybe<ProfileImage>;
};

export type CategoryOnboardingV2ProfileInfoQuestionAnswerInput = {
  name: Scalars['NameInput'];
  profileImage?: InputMaybe<CategoryOnboardingV2QuestionAnswerProfileImageInput>;
};

export type CategoryOnboardingV2ProfileInfoQuestionMutation = {
  __typename?: 'CategoryOnboardingV2ProfileInfoQuestionMutation';
  answer: Array<CategoryOnboardingV2Category>;
};


export type CategoryOnboardingV2ProfileInfoQuestionMutationanswerArgs = {
  answer: CategoryOnboardingV2ProfileInfoQuestionAnswerInput;
  siteSetId: Scalars['SiteSetId'];
};

export type CategoryOnboardingV2ProfileInfoQuestionPayload = {
  __typename?: 'CategoryOnboardingV2ProfileInfoQuestionPayload';
  loginId: Scalars['LoginId'];
  name?: Maybe<Name>;
  profileImage?: Maybe<ProfileImage>;
};

export type CategoryOnboardingV2Question = CategoryOnboardingV2ClosingDaysQuestion | CategoryOnboardingV2NurseryInfoQuestion | CategoryOnboardingV2NurseryLogoQuestion | CategoryOnboardingV2OpeningHoursQuestion | CategoryOnboardingV2PinCodeQuestion | CategoryOnboardingV2ProfileInfoQuestion | CategoryOnboardingV2RolesQuestion | CategoryOnboardingV2RoomsQuestion;

export type CategoryOnboardingV2QuestionAnswerProfileImageInput = {
  id: Scalars['String'];
  url: Scalars['String'];
};

export type CategoryOnboardingV2RolesQuestion = {
  __typename?: 'CategoryOnboardingV2RolesQuestion';
  answer?: Maybe<CategoryOnboardingV2RolesQuestionAnswer>;
  description?: Maybe<Scalars['String']>;
  payload: CategoryOnboardingV2RolesQuestionPayload;
  title: Scalars['String'];
};

export type CategoryOnboardingV2RolesQuestionAnswer = {
  __typename?: 'CategoryOnboardingV2RolesQuestionAnswer';
  roles: Array<CategoryOnboardingV2RolesQuestionRole>;
};

export type CategoryOnboardingV2RolesQuestionAnswerInput = {
  roles: Array<CategoryOnboardingV2RolesQuestionRoleInput>;
};

export type CategoryOnboardingV2RolesQuestionMutation = {
  __typename?: 'CategoryOnboardingV2RolesQuestionMutation';
  answer: Array<CategoryOnboardingV2Category>;
};


export type CategoryOnboardingV2RolesQuestionMutationanswerArgs = {
  answer: CategoryOnboardingV2RolesQuestionAnswerInput;
  siteSetId: Scalars['SiteSetId'];
};

export type CategoryOnboardingV2RolesQuestionPayload = {
  __typename?: 'CategoryOnboardingV2RolesQuestionPayload';
  managerRoleId: Scalars['RoleId'];
};

export type CategoryOnboardingV2RolesQuestionRole = {
  __typename?: 'CategoryOnboardingV2RolesQuestionRole';
  id: Scalars['RoleId'];
  title: Scalars['String'];
};

export type CategoryOnboardingV2RolesQuestionRoleInput = {
  id: Scalars['RoleId'];
  title: Scalars['String'];
};

export type CategoryOnboardingV2RoomsQuestion = {
  __typename?: 'CategoryOnboardingV2RoomsQuestion';
  answer?: Maybe<CategoryOnboardingV2RoomsQuestionAnswer>;
  description?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type CategoryOnboardingV2RoomsQuestionAnswer = {
  __typename?: 'CategoryOnboardingV2RoomsQuestionAnswer';
  rooms: Array<CategoryOnboardingV2RoomsQuestionRoom>;
};

export type CategoryOnboardingV2RoomsQuestionAnswerInput = {
  rooms: CategoryOnboardingV2RoomsQuestionRoomInput;
};

export type CategoryOnboardingV2RoomsQuestionMutation = {
  __typename?: 'CategoryOnboardingV2RoomsQuestionMutation';
  answer: Array<CategoryOnboardingV2Category>;
};


export type CategoryOnboardingV2RoomsQuestionMutationanswerArgs = {
  answer: CategoryOnboardingV2RoomsQuestionAnswerInput;
  siteSetId: Scalars['SiteSetId'];
};

export type CategoryOnboardingV2RoomsQuestionRoom = CategoryOnboardingV2RoomsQuestionRoomDeleted | CategoryOnboardingV2RoomsQuestionRoomExisting | CategoryOnboardingV2RoomsQuestionRoomNew;

export type CategoryOnboardingV2RoomsQuestionRoomDeleted = {
  __typename?: 'CategoryOnboardingV2RoomsQuestionRoomDeleted';
  id: Scalars['GroupId'];
};

export type CategoryOnboardingV2RoomsQuestionRoomDeletedInput = {
  id: Scalars['GroupId'];
};

export type CategoryOnboardingV2RoomsQuestionRoomExisting = {
  __typename?: 'CategoryOnboardingV2RoomsQuestionRoomExisting';
  capacity?: Maybe<Scalars['Int']>;
  id: Scalars['GroupId'];
  name: Scalars['String'];
};

export type CategoryOnboardingV2RoomsQuestionRoomExistingInput = {
  capacity?: InputMaybe<Scalars['Int']>;
  id: Scalars['GroupId'];
  name: Scalars['String'];
};

export type CategoryOnboardingV2RoomsQuestionRoomInput = {
  deleted: Array<CategoryOnboardingV2RoomsQuestionRoomDeletedInput>;
  existing: Array<CategoryOnboardingV2RoomsQuestionRoomExistingInput>;
  new: Array<CategoryOnboardingV2RoomsQuestionRoomNewInput>;
};

export type CategoryOnboardingV2RoomsQuestionRoomNew = {
  __typename?: 'CategoryOnboardingV2RoomsQuestionRoomNew';
  capacity?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
};

export type CategoryOnboardingV2RoomsQuestionRoomNewInput = {
  capacity?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
};

export type CategoryOnboardingV2RoomsSection = {
  __typename?: 'CategoryOnboardingV2RoomsSection';
  questions: Array<CategoryOnboardingV2Question>;
  title: Scalars['String'];
};

export type CategoryOnboardingV2Section = CategoryOnboardingV2ChildrenSection | CategoryOnboardingV2RoomsSection | CategoryOnboardingV2YourNurserySection | CategoryOnboardingV2YourProfileSection;

export type CategoryOnboardingV2YourNurserySection = {
  __typename?: 'CategoryOnboardingV2YourNurserySection';
  questions: Array<CategoryOnboardingV2Question>;
  title: Scalars['String'];
};

export type CategoryOnboardingV2YourProfileSection = {
  __typename?: 'CategoryOnboardingV2YourProfileSection';
  questions: Array<CategoryOnboardingV2Question>;
  title: Scalars['String'];
};

export type CategoryOnboardingV3 = {
  __typename?: 'CategoryOnboardingV3';
  categories: Array<CategoryOnboardingV3Category>;
  config: CategoryOnboardingV3Config;
};


export type CategoryOnboardingV3categoriesArgs = {
  siteSetId: Scalars['SiteSetId'];
};

export type CategoryOnboardingV3BasicsCategory = {
  __typename?: 'CategoryOnboardingV3BasicsCategory';
  sections: Array<CategoryOnboardingV3Section>;
  title: Scalars['String'];
};

export type CategoryOnboardingV3Category = CategoryOnboardingV3BasicsCategory | CategoryOnboardingV3ChildDevelopmentCategory;

export type CategoryOnboardingV3ChildDevelopmentCategory = {
  __typename?: 'CategoryOnboardingV3ChildDevelopmentCategory';
  sections: Array<CategoryOnboardingV3Section>;
  title: Scalars['String'];
};

export type CategoryOnboardingV3ClosingDaysQuestion = {
  __typename?: 'CategoryOnboardingV3ClosingDaysQuestion';
  answer?: Maybe<CategoryOnboardingV3ClosingDaysQuestionAnswer>;
  description?: Maybe<Scalars['String']>;
  payload: CategoryOnboardingV3ClosingDaysQuestionPayload;
  title: Scalars['String'];
};

export type CategoryOnboardingV3ClosingDaysQuestionAnswer = {
  __typename?: 'CategoryOnboardingV3ClosingDaysQuestionAnswer';
  closingDays: Array<ClosingDayDay>;
};

export type CategoryOnboardingV3ClosingDaysQuestionAnswerInput = {
  deletedClosingDays: Array<ClosingDayInput>;
  existingClosingDays: Array<ClosingDayInput>;
  newClosingDays: Array<ClosingDayInput>;
};

export type CategoryOnboardingV3ClosingDaysQuestionMutation = {
  __typename?: 'CategoryOnboardingV3ClosingDaysQuestionMutation';
  answer: Array<CategoryOnboardingV3Category>;
};


export type CategoryOnboardingV3ClosingDaysQuestionMutationanswerArgs = {
  answer: CategoryOnboardingV3ClosingDaysQuestionAnswerInput;
  siteSetId: Scalars['SiteSetId'];
};

export type CategoryOnboardingV3ClosingDaysQuestionPayload = {
  __typename?: 'CategoryOnboardingV3ClosingDaysQuestionPayload';
  closingDaysGrouped: Array<ClosingDayGroup>;
};

export type CategoryOnboardingV3Config = {
  __typename?: 'CategoryOnboardingV3Config';
  isEnabled: Scalars['Boolean'];
};


export type CategoryOnboardingV3ConfigisEnabledArgs = {
  siteSetId: Scalars['SiteSetId'];
};

export type CategoryOnboardingV3CountryQuestion = {
  __typename?: 'CategoryOnboardingV3CountryQuestion';
  answer?: Maybe<CategoryOnboardingV3CountryQuestionAnswer>;
  description?: Maybe<Scalars['String']>;
  payload: CategoryOnboardingV3CountryQuestionPayload;
  title: Scalars['String'];
};

export type CategoryOnboardingV3CountryQuestionAnswer = {
  __typename?: 'CategoryOnboardingV3CountryQuestionAnswer';
  country: ConstituentCountries;
};

export type CategoryOnboardingV3CountryQuestionAnswerInput = {
  country: ConstituentCountries;
};

export type CategoryOnboardingV3CountryQuestionMutation = {
  __typename?: 'CategoryOnboardingV3CountryQuestionMutation';
  answer: Array<CategoryOnboardingV3Category>;
};


export type CategoryOnboardingV3CountryQuestionMutationanswerArgs = {
  answer: CategoryOnboardingV3CountryQuestionAnswerInput;
  siteSetId: Scalars['SiteSetId'];
};

export type CategoryOnboardingV3CountryQuestionPayload = {
  __typename?: 'CategoryOnboardingV3CountryQuestionPayload';
  countries: Array<ConstituentCountries>;
};

export type CategoryOnboardingV3LearningBasicsSection = {
  __typename?: 'CategoryOnboardingV3LearningBasicsSection';
  questions: Array<CategoryOnboardingV3Question>;
  title: Scalars['String'];
};

export type CategoryOnboardingV3LearningFrameworksForEnglandQuestion = {
  __typename?: 'CategoryOnboardingV3LearningFrameworksForEnglandQuestion';
  answer?: Maybe<CategoryOnboardingV3LearningFrameworksForEnglandQuestionAnswer>;
  description?: Maybe<Scalars['String']>;
  payload: CategoryOnboardingV3LearningFrameworksForEnglandQuestionPayload;
  title: Scalars['String'];
};

export type CategoryOnboardingV3LearningFrameworksForEnglandQuestionAnswer = {
  __typename?: 'CategoryOnboardingV3LearningFrameworksForEnglandQuestionAnswer';
  learningFrameworks: Array<LearningFramework>;
};

export type CategoryOnboardingV3LearningFrameworksForEnglandQuestionAnswerInput = {
  learningFrameworks: Array<LearningFramework>;
};

export type CategoryOnboardingV3LearningFrameworksForEnglandQuestionMutation = {
  __typename?: 'CategoryOnboardingV3LearningFrameworksForEnglandQuestionMutation';
  answer: Array<CategoryOnboardingV3Category>;
};


export type CategoryOnboardingV3LearningFrameworksForEnglandQuestionMutationanswerArgs = {
  answer: CategoryOnboardingV3LearningFrameworksForEnglandQuestionAnswerInput;
  siteSetId: Scalars['SiteSetId'];
};

export type CategoryOnboardingV3LearningFrameworksForEnglandQuestionPayload = {
  __typename?: 'CategoryOnboardingV3LearningFrameworksForEnglandQuestionPayload';
  learningFrameworks: Array<LearningFramework>;
};

export type CategoryOnboardingV3LearningFrameworksForWalesQuestion = {
  __typename?: 'CategoryOnboardingV3LearningFrameworksForWalesQuestion';
  answer?: Maybe<CategoryOnboardingV3LearningFrameworksForWalesQuestionAnswer>;
  description?: Maybe<Scalars['String']>;
  payload: CategoryOnboardingV3LearningFrameworksForWalesQuestionPayload;
  title: Scalars['String'];
};

export type CategoryOnboardingV3LearningFrameworksForWalesQuestionAnswer = {
  __typename?: 'CategoryOnboardingV3LearningFrameworksForWalesQuestionAnswer';
  learningFrameworks: Array<LearningFramework>;
};

export type CategoryOnboardingV3LearningFrameworksForWalesQuestionAnswerInput = {
  learningFrameworks: Array<LearningFramework>;
};

export type CategoryOnboardingV3LearningFrameworksForWalesQuestionMutation = {
  __typename?: 'CategoryOnboardingV3LearningFrameworksForWalesQuestionMutation';
  answer: Array<CategoryOnboardingV3Category>;
};


export type CategoryOnboardingV3LearningFrameworksForWalesQuestionMutationanswerArgs = {
  answer: CategoryOnboardingV3LearningFrameworksForWalesQuestionAnswerInput;
  siteSetId: Scalars['SiteSetId'];
};

export type CategoryOnboardingV3LearningFrameworksForWalesQuestionPayload = {
  __typename?: 'CategoryOnboardingV3LearningFrameworksForWalesQuestionPayload';
  learningFrameworks: Array<LearningFramework>;
};

export type CategoryOnboardingV3Mutation = {
  __typename?: 'CategoryOnboardingV3Mutation';
  dismiss: Scalars['Boolean'];
  questions: CategoryOnboardingV3MutationQuestion;
};

export type CategoryOnboardingV3MutationQuestion = {
  __typename?: 'CategoryOnboardingV3MutationQuestion';
  closingDays: CategoryOnboardingV3ClosingDaysQuestionMutation;
  country: CategoryOnboardingV3CountryQuestionMutation;
  followsStatementBasedTracking: CategoryOnboardingV3StatementBasedTrackingQuestionMutation;
  learningFrameworksForEngland: CategoryOnboardingV3LearningFrameworksForEnglandQuestionMutation;
  learningFrameworksForWales: CategoryOnboardingV3LearningFrameworksForWalesQuestionMutation;
  nurseryInfo: CategoryOnboardingV3NurseryInfoQuestionMutation;
  nurseryLogo: CategoryOnboardingV3NurseryLogoQuestionMutation;
  openingHours: CategoryOnboardingV3OpeningHoursQuestionMutation;
  pinCode: CategoryOnboardingV3PinCodeQuestionMutation;
  profileInfo: CategoryOnboardingV3ProfileInfoQuestionMutation;
  referenceMaterialsForEngland: CategoryOnboardingV3ReferenceMaterialsForEnglandQuestionMutation;
  referenceMaterialsForWales: CategoryOnboardingV3ReferenceMaterialsForWalesQuestionMutation;
  roles: CategoryOnboardingV3RolesQuestionMutation;
  rooms: CategoryOnboardingV3RoomsQuestionMutation;
};

export type CategoryOnboardingV3NurseryInfoQuestion = {
  __typename?: 'CategoryOnboardingV3NurseryInfoQuestion';
  answer?: Maybe<CategoryOnboardingV3NurseryInfoQuestionAnswer>;
  description?: Maybe<Scalars['String']>;
  payload: CategoryOnboardingV3NurseryInfoQuestionPayload;
  title: Scalars['String'];
};

export type CategoryOnboardingV3NurseryInfoQuestionAnswer = {
  __typename?: 'CategoryOnboardingV3NurseryInfoQuestionAnswer';
  address: Address;
  name: Scalars['String'];
  vat: Scalars['String'];
};

export type CategoryOnboardingV3NurseryInfoQuestionAnswerInput = {
  address: AddressInput;
  name: Scalars['String'];
  vat: Scalars['String'];
};

export type CategoryOnboardingV3NurseryInfoQuestionMutation = {
  __typename?: 'CategoryOnboardingV3NurseryInfoQuestionMutation';
  answer: Array<CategoryOnboardingV3Category>;
};


export type CategoryOnboardingV3NurseryInfoQuestionMutationanswerArgs = {
  answer: CategoryOnboardingV3NurseryInfoQuestionAnswerInput;
  siteSetId: Scalars['SiteSetId'];
};

export type CategoryOnboardingV3NurseryInfoQuestionPayload = {
  __typename?: 'CategoryOnboardingV3NurseryInfoQuestionPayload';
  address?: Maybe<Address>;
  name?: Maybe<Scalars['String']>;
  vat?: Maybe<Scalars['String']>;
};

export type CategoryOnboardingV3NurseryLogoQuestion = {
  __typename?: 'CategoryOnboardingV3NurseryLogoQuestion';
  answer?: Maybe<CategoryOnboardingV3NurseryLogoQuestionAnswer>;
  description?: Maybe<Scalars['String']>;
  payload: CategoryOnboardingV3NurseryLogoQuestionPayload;
  title: Scalars['String'];
};

export type CategoryOnboardingV3NurseryLogoQuestionAnswer = {
  __typename?: 'CategoryOnboardingV3NurseryLogoQuestionAnswer';
  profileImage?: Maybe<ProfileImage>;
};

export type CategoryOnboardingV3NurseryLogoQuestionAnswerInput = {
  profileImage?: InputMaybe<CategoryOnboardingV3QuestionAnswerProfileImageInput>;
};

export type CategoryOnboardingV3NurseryLogoQuestionMutation = {
  __typename?: 'CategoryOnboardingV3NurseryLogoQuestionMutation';
  answer: Array<CategoryOnboardingV3Category>;
};


export type CategoryOnboardingV3NurseryLogoQuestionMutationanswerArgs = {
  answer: CategoryOnboardingV3NurseryLogoQuestionAnswerInput;
  siteSetId: Scalars['SiteSetId'];
};

export type CategoryOnboardingV3NurseryLogoQuestionPayload = {
  __typename?: 'CategoryOnboardingV3NurseryLogoQuestionPayload';
  siteSetId: Scalars['SiteSetId'];
};

export type CategoryOnboardingV3OpeningHoursQuestion = {
  __typename?: 'CategoryOnboardingV3OpeningHoursQuestion';
  answer?: Maybe<CategoryOnboardingV3OpeningHoursQuestionAnswer>;
  description?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type CategoryOnboardingV3OpeningHoursQuestionAnswer = {
  __typename?: 'CategoryOnboardingV3OpeningHoursQuestionAnswer';
  openingHours: OpeningHours;
};

export type CategoryOnboardingV3OpeningHoursQuestionAnswerInput = {
  openingHours: OpeningHoursInput;
};

export type CategoryOnboardingV3OpeningHoursQuestionMutation = {
  __typename?: 'CategoryOnboardingV3OpeningHoursQuestionMutation';
  answer: Array<CategoryOnboardingV3Category>;
};


export type CategoryOnboardingV3OpeningHoursQuestionMutationanswerArgs = {
  answer: CategoryOnboardingV3OpeningHoursQuestionAnswerInput;
  siteSetId: Scalars['SiteSetId'];
};

export type CategoryOnboardingV3PinCodeQuestion = {
  __typename?: 'CategoryOnboardingV3PinCodeQuestion';
  answer?: Maybe<CategoryOnboardingV3PinCodeQuestionAnswer>;
  description?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type CategoryOnboardingV3PinCodeQuestionAnswer = {
  __typename?: 'CategoryOnboardingV3PinCodeQuestionAnswer';
  password: Scalars['Password'];
  pinCode: Scalars['String'];
};

export type CategoryOnboardingV3PinCodeQuestionAnswerInput = {
  password: Scalars['String'];
  pinCode: Scalars['String'];
};

export type CategoryOnboardingV3PinCodeQuestionMutation = {
  __typename?: 'CategoryOnboardingV3PinCodeQuestionMutation';
  answer: Array<CategoryOnboardingV3Category>;
};


export type CategoryOnboardingV3PinCodeQuestionMutationanswerArgs = {
  answer: CategoryOnboardingV3PinCodeQuestionAnswerInput;
  siteSetId: Scalars['SiteSetId'];
};

export type CategoryOnboardingV3ProfileInfoQuestion = {
  __typename?: 'CategoryOnboardingV3ProfileInfoQuestion';
  answer?: Maybe<CategoryOnboardingV3ProfileInfoQuestionAnswer>;
  description?: Maybe<Scalars['String']>;
  payload: CategoryOnboardingV3ProfileInfoQuestionPayload;
  title: Scalars['String'];
};

export type CategoryOnboardingV3ProfileInfoQuestionAnswer = {
  __typename?: 'CategoryOnboardingV3ProfileInfoQuestionAnswer';
  name: Name;
  profileImage?: Maybe<ProfileImage>;
};

export type CategoryOnboardingV3ProfileInfoQuestionAnswerInput = {
  name: Scalars['NameInput'];
  profileImage?: InputMaybe<CategoryOnboardingV3QuestionAnswerProfileImageInput>;
};

export type CategoryOnboardingV3ProfileInfoQuestionMutation = {
  __typename?: 'CategoryOnboardingV3ProfileInfoQuestionMutation';
  answer: Array<CategoryOnboardingV3Category>;
};


export type CategoryOnboardingV3ProfileInfoQuestionMutationanswerArgs = {
  answer: CategoryOnboardingV3ProfileInfoQuestionAnswerInput;
  siteSetId: Scalars['SiteSetId'];
};

export type CategoryOnboardingV3ProfileInfoQuestionPayload = {
  __typename?: 'CategoryOnboardingV3ProfileInfoQuestionPayload';
  loginId: Scalars['LoginId'];
  name?: Maybe<Name>;
  profileImage?: Maybe<ProfileImage>;
};

export type CategoryOnboardingV3Question = CategoryOnboardingV3ClosingDaysQuestion | CategoryOnboardingV3CountryQuestion | CategoryOnboardingV3LearningFrameworksForEnglandQuestion | CategoryOnboardingV3LearningFrameworksForWalesQuestion | CategoryOnboardingV3NurseryInfoQuestion | CategoryOnboardingV3NurseryLogoQuestion | CategoryOnboardingV3OpeningHoursQuestion | CategoryOnboardingV3PinCodeQuestion | CategoryOnboardingV3ProfileInfoQuestion | CategoryOnboardingV3ReferenceMaterialsForEnglandQuestion | CategoryOnboardingV3ReferenceMaterialsForWalesQuestion | CategoryOnboardingV3RolesQuestion | CategoryOnboardingV3RoomsQuestion | CategoryOnboardingV3StatementBasedTrackingQuestion;

export type CategoryOnboardingV3QuestionAnswerProfileImageInput = {
  id: Scalars['String'];
  url: Scalars['String'];
};

export type CategoryOnboardingV3ReferenceMaterialWithObservationType = {
  __typename?: 'CategoryOnboardingV3ReferenceMaterialWithObservationType';
  observation: ObservationType;
  referenceMaterial: ReferenceMaterial;
};

export type CategoryOnboardingV3ReferenceMaterialWithObservationTypeForWales = {
  __typename?: 'CategoryOnboardingV3ReferenceMaterialWithObservationTypeForWales';
  observation: ObservationType;
  referenceMaterial: ReferenceMaterial;
};

export type CategoryOnboardingV3ReferenceMaterialsForEnglandQuestion = {
  __typename?: 'CategoryOnboardingV3ReferenceMaterialsForEnglandQuestion';
  answer?: Maybe<CategoryOnboardingV3ReferenceMaterialsForEnglandQuestionAnswer>;
  description?: Maybe<Scalars['String']>;
  payload: CategoryOnboardingV3ReferenceMaterialsForEnglandQuestionPayload;
  title: Scalars['String'];
};

export type CategoryOnboardingV3ReferenceMaterialsForEnglandQuestionAnswer = {
  __typename?: 'CategoryOnboardingV3ReferenceMaterialsForEnglandQuestionAnswer';
  referenceMaterials: Array<CategoryOnboardingV3ReferenceMaterialWithObservationType>;
};

export type CategoryOnboardingV3ReferenceMaterialsForEnglandQuestionAnswerInput = {
  referenceMaterials: Array<CategoryOnboardingV3ReferenceMaterialsType>;
};

export type CategoryOnboardingV3ReferenceMaterialsForEnglandQuestionMutation = {
  __typename?: 'CategoryOnboardingV3ReferenceMaterialsForEnglandQuestionMutation';
  answer: Array<CategoryOnboardingV3Category>;
};


export type CategoryOnboardingV3ReferenceMaterialsForEnglandQuestionMutationanswerArgs = {
  answer: CategoryOnboardingV3ReferenceMaterialsForEnglandQuestionAnswerInput;
  siteSetId: Scalars['SiteSetId'];
};

export type CategoryOnboardingV3ReferenceMaterialsForEnglandQuestionPayload = {
  __typename?: 'CategoryOnboardingV3ReferenceMaterialsForEnglandQuestionPayload';
  referenceMaterials: Array<CategoryOnboardingV3ReferenceMaterialWithObservationType>;
};

export type CategoryOnboardingV3ReferenceMaterialsForWalesQuestion = {
  __typename?: 'CategoryOnboardingV3ReferenceMaterialsForWalesQuestion';
  answer?: Maybe<CategoryOnboardingV3ReferenceMaterialsForWalesQuestionAnswer>;
  description?: Maybe<Scalars['String']>;
  payload: CategoryOnboardingV3ReferenceMaterialsForWalesQuestionPayload;
  title: Scalars['String'];
};

export type CategoryOnboardingV3ReferenceMaterialsForWalesQuestionAnswer = {
  __typename?: 'CategoryOnboardingV3ReferenceMaterialsForWalesQuestionAnswer';
  referenceMaterials: Array<CategoryOnboardingV3ReferenceMaterialWithObservationTypeForWales>;
};

export type CategoryOnboardingV3ReferenceMaterialsForWalesQuestionAnswerInput = {
  referenceMaterials: Array<CategoryOnboardingV3ReferenceMaterialsTypeForWales>;
};

export type CategoryOnboardingV3ReferenceMaterialsForWalesQuestionMutation = {
  __typename?: 'CategoryOnboardingV3ReferenceMaterialsForWalesQuestionMutation';
  answer: Array<CategoryOnboardingV3Category>;
};


export type CategoryOnboardingV3ReferenceMaterialsForWalesQuestionMutationanswerArgs = {
  answer: CategoryOnboardingV3ReferenceMaterialsForWalesQuestionAnswerInput;
  siteSetId: Scalars['SiteSetId'];
};

export type CategoryOnboardingV3ReferenceMaterialsForWalesQuestionPayload = {
  __typename?: 'CategoryOnboardingV3ReferenceMaterialsForWalesQuestionPayload';
  referenceMaterials: Array<CategoryOnboardingV3ReferenceMaterialWithObservationTypeForWales>;
};

export type CategoryOnboardingV3ReferenceMaterialsType = {
  observation: ObservationType;
  referenceMaterial: ReferenceMaterial;
};

export type CategoryOnboardingV3ReferenceMaterialsTypeForWales = {
  observation: ObservationType;
  referenceMaterial: ReferenceMaterial;
};

export type CategoryOnboardingV3RolesQuestion = {
  __typename?: 'CategoryOnboardingV3RolesQuestion';
  answer?: Maybe<CategoryOnboardingV3RolesQuestionAnswer>;
  description?: Maybe<Scalars['String']>;
  payload: CategoryOnboardingV3RolesQuestionPayload;
  title: Scalars['String'];
};

export type CategoryOnboardingV3RolesQuestionAnswer = {
  __typename?: 'CategoryOnboardingV3RolesQuestionAnswer';
  roles: Array<CategoryOnboardingV3RolesQuestionRole>;
};

export type CategoryOnboardingV3RolesQuestionAnswerInput = {
  roles: Array<CategoryOnboardingV3RolesQuestionRoleInput>;
};

export type CategoryOnboardingV3RolesQuestionMutation = {
  __typename?: 'CategoryOnboardingV3RolesQuestionMutation';
  answer: Array<CategoryOnboardingV3Category>;
};


export type CategoryOnboardingV3RolesQuestionMutationanswerArgs = {
  answer: CategoryOnboardingV3RolesQuestionAnswerInput;
  siteSetId: Scalars['SiteSetId'];
};

export type CategoryOnboardingV3RolesQuestionPayload = {
  __typename?: 'CategoryOnboardingV3RolesQuestionPayload';
  managerRoleId: Scalars['RoleId'];
};

export type CategoryOnboardingV3RolesQuestionRole = {
  __typename?: 'CategoryOnboardingV3RolesQuestionRole';
  id: Scalars['RoleId'];
  title: Scalars['String'];
};

export type CategoryOnboardingV3RolesQuestionRoleInput = {
  id: Scalars['RoleId'];
  title: Scalars['String'];
};

export type CategoryOnboardingV3RoomsQuestion = {
  __typename?: 'CategoryOnboardingV3RoomsQuestion';
  answer?: Maybe<CategoryOnboardingV3RoomsQuestionAnswer>;
  description?: Maybe<Scalars['String']>;
  payload: CategoryOnboardingV3RoomsQuestionPayload;
  title: Scalars['String'];
};

export type CategoryOnboardingV3RoomsQuestionAnswer = {
  __typename?: 'CategoryOnboardingV3RoomsQuestionAnswer';
  rooms: Array<CategoryOnboardingV3RoomsQuestionRoom>;
};

export type CategoryOnboardingV3RoomsQuestionAnswerInput = {
  rooms: CategoryOnboardingV3RoomsQuestionRoomInput;
};

export type CategoryOnboardingV3RoomsQuestionMutation = {
  __typename?: 'CategoryOnboardingV3RoomsQuestionMutation';
  answer: Array<CategoryOnboardingV3Category>;
};


export type CategoryOnboardingV3RoomsQuestionMutationanswerArgs = {
  answer: CategoryOnboardingV3RoomsQuestionAnswerInput;
  siteSetId: Scalars['SiteSetId'];
};

export type CategoryOnboardingV3RoomsQuestionPayload = {
  __typename?: 'CategoryOnboardingV3RoomsQuestionPayload';
  rooms: Array<CategoryOnboardingV3RoomsQuestionRoom>;
};

export type CategoryOnboardingV3RoomsQuestionRoom = CategoryOnboardingV3RoomsQuestionRoomDeleted | CategoryOnboardingV3RoomsQuestionRoomExistingEmpty | CategoryOnboardingV3RoomsQuestionRoomExistingNotEmpty | CategoryOnboardingV3RoomsQuestionRoomNew;

export type CategoryOnboardingV3RoomsQuestionRoomDeleted = {
  __typename?: 'CategoryOnboardingV3RoomsQuestionRoomDeleted';
  id: Scalars['GroupId'];
};

export type CategoryOnboardingV3RoomsQuestionRoomDeletedInput = {
  id: Scalars['GroupId'];
};

export type CategoryOnboardingV3RoomsQuestionRoomExistingEmpty = {
  __typename?: 'CategoryOnboardingV3RoomsQuestionRoomExistingEmpty';
  capacity?: Maybe<Scalars['Int']>;
  id: Scalars['GroupId'];
  name: Scalars['String'];
};

export type CategoryOnboardingV3RoomsQuestionRoomExistingEmptyInput = {
  capacity?: InputMaybe<Scalars['Int']>;
  id: Scalars['GroupId'];
  name: Scalars['String'];
};

export type CategoryOnboardingV3RoomsQuestionRoomExistingNotEmpty = {
  __typename?: 'CategoryOnboardingV3RoomsQuestionRoomExistingNotEmpty';
  capacity?: Maybe<Scalars['Int']>;
  id: Scalars['GroupId'];
  name: Scalars['String'];
};

export type CategoryOnboardingV3RoomsQuestionRoomExistingNotEmptyInput = {
  capacity?: InputMaybe<Scalars['Int']>;
  id: Scalars['GroupId'];
  name: Scalars['String'];
};

export type CategoryOnboardingV3RoomsQuestionRoomInput = {
  deleted: Array<CategoryOnboardingV3RoomsQuestionRoomDeletedInput>;
  existingEmpty: Array<CategoryOnboardingV3RoomsQuestionRoomExistingEmptyInput>;
  existingNotEmpty: Array<CategoryOnboardingV3RoomsQuestionRoomExistingNotEmptyInput>;
  new: Array<CategoryOnboardingV3RoomsQuestionRoomNewInput>;
};

export type CategoryOnboardingV3RoomsQuestionRoomNew = {
  __typename?: 'CategoryOnboardingV3RoomsQuestionRoomNew';
  capacity?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
};

export type CategoryOnboardingV3RoomsQuestionRoomNewInput = {
  capacity?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
};

export type CategoryOnboardingV3RoomsSection = {
  __typename?: 'CategoryOnboardingV3RoomsSection';
  questions: Array<CategoryOnboardingV3Question>;
  title: Scalars['String'];
};

export type CategoryOnboardingV3Section = CategoryOnboardingV2ChildrenSection | CategoryOnboardingV3LearningBasicsSection | CategoryOnboardingV3RoomsSection | CategoryOnboardingV3YourNurserySection | CategoryOnboardingV3YourProfileSection;

export type CategoryOnboardingV3StatementBasedTrackingQuestion = {
  __typename?: 'CategoryOnboardingV3StatementBasedTrackingQuestion';
  answer?: Maybe<CategoryOnboardingV3StatementBasedTrackingQuestionAnswer>;
  description?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type CategoryOnboardingV3StatementBasedTrackingQuestionAnswer = {
  __typename?: 'CategoryOnboardingV3StatementBasedTrackingQuestionAnswer';
  followsStatementBasedTracking: Scalars['Boolean'];
};

export type CategoryOnboardingV3StatementBasedTrackingQuestionAnswerInput = {
  followsStatementBasedTracking: Scalars['Boolean'];
};

export type CategoryOnboardingV3StatementBasedTrackingQuestionMutation = {
  __typename?: 'CategoryOnboardingV3StatementBasedTrackingQuestionMutation';
  answer: Array<CategoryOnboardingV3Category>;
};


export type CategoryOnboardingV3StatementBasedTrackingQuestionMutationanswerArgs = {
  answer: CategoryOnboardingV3StatementBasedTrackingQuestionAnswerInput;
  siteSetId: Scalars['SiteSetId'];
};

export type CategoryOnboardingV3YourNurserySection = {
  __typename?: 'CategoryOnboardingV3YourNurserySection';
  questions: Array<CategoryOnboardingV3Question>;
  title: Scalars['String'];
};

export type CategoryOnboardingV3YourProfileSection = {
  __typename?: 'CategoryOnboardingV3YourProfileSection';
  questions: Array<CategoryOnboardingV3Question>;
  title: Scalars['String'];
};

export type CategoryOnboardingV4 = {
  __typename?: 'CategoryOnboardingV4';
  categories: Array<CategoryOnboardingV4Category>;
  config: CategoryOnboardingV4Config;
  setupGuide: CategoryOnboardingV4SetupGuide;
};


export type CategoryOnboardingV4categoriesArgs = {
  siteSetId: Scalars['SiteSetId'];
};


export type CategoryOnboardingV4setupGuideArgs = {
  siteSetId: Scalars['SiteSetId'];
};

export type CategoryOnboardingV4AddPlansToChildrenPayload = {
  __typename?: 'CategoryOnboardingV4AddPlansToChildrenPayload';
  allChildrenHavePlans: Scalars['Boolean'];
  hasSetupInvoicingBasics: Scalars['Boolean'];
};

export type CategoryOnboardingV4AddPlansToChildrenQuestion = {
  __typename?: 'CategoryOnboardingV4AddPlansToChildrenQuestion';
  description?: Maybe<Scalars['String']>;
  payload: CategoryOnboardingV4AddPlansToChildrenPayload;
  title: Scalars['String'];
};

export type CategoryOnboardingV4AgeGroupsQuestion = {
  __typename?: 'CategoryOnboardingV4AgeGroupsQuestion';
  answer?: Maybe<CategoryOnboardingV4AgeGroupsQuestionAnswer>;
  description?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type CategoryOnboardingV4AgeGroupsQuestionAgeGroup = {
  __typename?: 'CategoryOnboardingV4AgeGroupsQuestionAgeGroup';
  capacity: Scalars['Int'];
  range: CategoryOnboardingV4AgeGroupsQuestionAgeGroupRange;
  staffRatio: Scalars['Float'];
};

export type CategoryOnboardingV4AgeGroupsQuestionAgeGroupInput = {
  capacity: Scalars['Int'];
  range: CategoryOnboardingV4AgeGroupsQuestionAgeGroupRangeInput;
  staffRatio: Scalars['Float'];
};

export type CategoryOnboardingV4AgeGroupsQuestionAgeGroupRange = {
  __typename?: 'CategoryOnboardingV4AgeGroupsQuestionAgeGroupRange';
  from: Scalars['Int'];
  to?: Maybe<Scalars['Int']>;
};

export type CategoryOnboardingV4AgeGroupsQuestionAgeGroupRangeInput = {
  from: Scalars['Int'];
  to?: InputMaybe<Scalars['Int']>;
};

export type CategoryOnboardingV4AgeGroupsQuestionAnswer = {
  __typename?: 'CategoryOnboardingV4AgeGroupsQuestionAnswer';
  ageGroups: Array<CategoryOnboardingV4AgeGroupsQuestionAgeGroup>;
};

export type CategoryOnboardingV4AgeGroupsQuestionAnswerInput = {
  ageGroups: Array<CategoryOnboardingV4AgeGroupsQuestionAgeGroupInput>;
};

export type CategoryOnboardingV4AgeGroupsQuestionMutation = {
  __typename?: 'CategoryOnboardingV4AgeGroupsQuestionMutation';
  answer: Array<CategoryOnboardingV4Category>;
};


export type CategoryOnboardingV4AgeGroupsQuestionMutationanswerArgs = {
  answer: CategoryOnboardingV4AgeGroupsQuestionAnswerInput;
  siteSetId: Scalars['SiteSetId'];
};

export type CategoryOnboardingV4AllowUsersToTranslateMessageAndPostsAnswer = {
  __typename?: 'CategoryOnboardingV4AllowUsersToTranslateMessageAndPostsAnswer';
  enabled: Scalars['Boolean'];
};

export type CategoryOnboardingV4AllowUsersToTranslateMessageAndPostsAnswerInput = {
  enabled: Scalars['Boolean'];
};

export type CategoryOnboardingV4AllowUsersToTranslateMessageAndPostsQuestion = {
  __typename?: 'CategoryOnboardingV4AllowUsersToTranslateMessageAndPostsQuestion';
  answer?: Maybe<CategoryOnboardingV4AllowUsersToTranslateMessageAndPostsAnswer>;
  description?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  whatsThis?: Maybe<CategoryOnboardingV4QuestionWhatsThisWithMedia>;
};

export type CategoryOnboardingV4AllowUsersToTranslateMessageAndPostsQuestionMutation = {
  __typename?: 'CategoryOnboardingV4AllowUsersToTranslateMessageAndPostsQuestionMutation';
  answer: Array<CategoryOnboardingV4Category>;
};


export type CategoryOnboardingV4AllowUsersToTranslateMessageAndPostsQuestionMutationanswerArgs = {
  answer: CategoryOnboardingV4AllowUsersToTranslateMessageAndPostsAnswerInput;
  siteSetId: Scalars['SiteSetId'];
};

export type CategoryOnboardingV4AssessmentsQuestion = {
  __typename?: 'CategoryOnboardingV4AssessmentsQuestion';
  answer?: Maybe<CategoryOnboardingV4AssessmentsQuestionAnswer>;
  description?: Maybe<Scalars['String']>;
  payload: CategoryOnboardingV4AssessmentsQuestionPayload;
  title: Scalars['String'];
  whatsThis?: Maybe<CategoryOnboardingV4QuestionWhatsThis>;
};

export type CategoryOnboardingV4AssessmentsQuestionAnswer = {
  __typename?: 'CategoryOnboardingV4AssessmentsQuestionAnswer';
  birthToFiveRecommendationEnabled: Scalars['Boolean'];
  devMattersRecommendationEnabled: Scalars['Boolean'];
};

export type CategoryOnboardingV4AssessmentsQuestionAnswerInput = {
  birthToFiveRecommendationEnabled: Scalars['Boolean'];
  devMattersRecommendationEnabled: Scalars['Boolean'];
};

export type CategoryOnboardingV4AssessmentsQuestionMutation = {
  __typename?: 'CategoryOnboardingV4AssessmentsQuestionMutation';
  answer: Array<CategoryOnboardingV4Category>;
};


export type CategoryOnboardingV4AssessmentsQuestionMutationanswerArgs = {
  answer: CategoryOnboardingV4AssessmentsQuestionAnswerInput;
  siteSetId: Scalars['SiteSetId'];
};

export type CategoryOnboardingV4AssessmentsQuestionPayload = {
  __typename?: 'CategoryOnboardingV4AssessmentsQuestionPayload';
  birthToFiveRecommendation: CategoryOnboardingV4AssessmentsQuestionRecommendation;
  devMattersRecommendation: CategoryOnboardingV4AssessmentsQuestionRecommendation;
};

export type CategoryOnboardingV4AssessmentsQuestionRecommendation = {
  __typename?: 'CategoryOnboardingV4AssessmentsQuestionRecommendation';
  whatsThis: CategoryOnboardingV4QuestionWhatsThis;
};

export type CategoryOnboardingV4AssignNewBillPayersQuestion = {
  __typename?: 'CategoryOnboardingV4AssignNewBillPayersQuestion';
  answer?: Maybe<CategoryOnboardingV4AssignNewBillPayersQuestionAnswer>;
  description?: Maybe<Scalars['String']>;
  payload: CategoryOnboardingV4AssignNewBillPayersQuestionPayload;
  title: Scalars['String'];
};

export type CategoryOnboardingV4AssignNewBillPayersQuestionAnswer = {
  __typename?: 'CategoryOnboardingV4AssignNewBillPayersQuestionAnswer';
  assignToNewBillPayers: Scalars['Boolean'];
  schedule?: Maybe<AutomaticInvoicingOccurrence>;
};

export type CategoryOnboardingV4AssignNewBillPayersQuestionAnswerInput = {
  assignToNewBillPayers: Scalars['Boolean'];
  schedule: AutomaticInvoicingOccurrence;
};

export type CategoryOnboardingV4AssignNewBillPayersQuestionMutation = {
  __typename?: 'CategoryOnboardingV4AssignNewBillPayersQuestionMutation';
  answer: Array<CategoryOnboardingV4Category>;
};


export type CategoryOnboardingV4AssignNewBillPayersQuestionMutationanswerArgs = {
  answer: CategoryOnboardingV4AssignNewBillPayersQuestionAnswerInput;
  siteSetId: Scalars['SiteSetId'];
};

export type CategoryOnboardingV4AssignNewBillPayersQuestionPayload = {
  __typename?: 'CategoryOnboardingV4AssignNewBillPayersQuestionPayload';
  schedules: Array<AutomaticInvoicingOccurrence>;
};

export type CategoryOnboardingV4AttendanceCategory = {
  __typename?: 'CategoryOnboardingV4AttendanceCategory';
  id: SetupGuideCategoryId;
  progress: Scalars['Int'];
  sections: Array<CategoryOnboardingV4Section>;
  title: Scalars['String'];
};

export type CategoryOnboardingV4AutomaticInvoicingSection = {
  __typename?: 'CategoryOnboardingV4AutomaticInvoicingSection';
  currentQuestion?: Maybe<CategoryOnboardingV4Question>;
  id: SetupGuideSectionId;
  isCompleted: Scalars['Boolean'];
  questions: Array<CategoryOnboardingV4Question>;
  state: CategoryOnboardingV4SectionState;
  title: Scalars['String'];
};

export type CategoryOnboardingV4BasicsCategory = {
  __typename?: 'CategoryOnboardingV4BasicsCategory';
  id: SetupGuideCategoryId;
  progress: Scalars['Int'];
  sections: Array<CategoryOnboardingV4Section>;
  title: Scalars['String'];
};

export type CategoryOnboardingV4BuildYourOwnCurriculumQuestion = {
  __typename?: 'CategoryOnboardingV4BuildYourOwnCurriculumQuestion';
  description?: Maybe<Scalars['String']>;
  payload: CategoryOnboardingV4BuildYourOwnCurriculumQuestionPayload;
  title: Scalars['String'];
};

export type CategoryOnboardingV4BuildYourOwnCurriculumQuestionPayload = {
  __typename?: 'CategoryOnboardingV4BuildYourOwnCurriculumQuestionPayload';
  hasCurriculums: Scalars['Boolean'];
};

export type CategoryOnboardingV4CanParentsDownloadNewsfeedPhotosFromTheAppQuestion = {
  __typename?: 'CategoryOnboardingV4CanParentsDownloadNewsfeedPhotosFromTheAppQuestion';
  answer: CategoryOnboardingV4CanParentsDownloadNewsfeedPhotosFromTheAppQuestionAnswer;
  description?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type CategoryOnboardingV4CanParentsDownloadNewsfeedPhotosFromTheAppQuestionAnswer = {
  __typename?: 'CategoryOnboardingV4CanParentsDownloadNewsfeedPhotosFromTheAppQuestionAnswer';
  canParentsDownloadNewsfeedPhotosFromTheApp: Scalars['Boolean'];
};

export type CategoryOnboardingV4CanParentsDownloadNewsfeedPhotosFromTheAppQuestionAnswerInput = {
  canParentsDownloadNewsfeedPhotosFromTheApp: Scalars['Boolean'];
};

export type CategoryOnboardingV4CanParentsDownloadNewsfeedPhotosFromTheAppQuestionMutation = {
  __typename?: 'CategoryOnboardingV4CanParentsDownloadNewsfeedPhotosFromTheAppQuestionMutation';
  answer: Array<CategoryOnboardingV4Category>;
};


export type CategoryOnboardingV4CanParentsDownloadNewsfeedPhotosFromTheAppQuestionMutationanswerArgs = {
  answer: CategoryOnboardingV4CanParentsDownloadNewsfeedPhotosFromTheAppQuestionAnswerInput;
  siteSetId: Scalars['SiteSetId'];
};

export type CategoryOnboardingV4CanParentsWriteObservationsQuestion = {
  __typename?: 'CategoryOnboardingV4CanParentsWriteObservationsQuestion';
  answer?: Maybe<CategoryOnboardingV4CanParentsWriteObservationsQuestionAnswer>;
  description?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type CategoryOnboardingV4CanParentsWriteObservationsQuestionAnswer = {
  __typename?: 'CategoryOnboardingV4CanParentsWriteObservationsQuestionAnswer';
  canParentsWriteObservations: Scalars['Boolean'];
};

export type CategoryOnboardingV4CanParentsWriteObservationsQuestionAnswerInput = {
  canParentsWriteObservations: Scalars['Boolean'];
};

export type CategoryOnboardingV4CanParentsWriteObservationsQuestionMutation = {
  __typename?: 'CategoryOnboardingV4CanParentsWriteObservationsQuestionMutation';
  answer: Array<CategoryOnboardingV4Category>;
};


export type CategoryOnboardingV4CanParentsWriteObservationsQuestionMutationanswerArgs = {
  answer: CategoryOnboardingV4CanParentsWriteObservationsQuestionAnswerInput;
  siteSetId: Scalars['SiteSetId'];
};

export type CategoryOnboardingV4Category = CategoryOnboardingV4AttendanceCategory | CategoryOnboardingV4BasicsCategory | CategoryOnboardingV4ChildDevelopmentCategory | CategoryOnboardingV4CommunicationCategory | CategoryOnboardingV4FinanceCategory;

export type CategoryOnboardingV4ChildDevelopmentCategory = {
  __typename?: 'CategoryOnboardingV4ChildDevelopmentCategory';
  id: SetupGuideCategoryId;
  progress: Scalars['Int'];
  sections: Array<CategoryOnboardingV4Section>;
  title: Scalars['String'];
};

export type CategoryOnboardingV4ChildPlansSection = {
  __typename?: 'CategoryOnboardingV4ChildPlansSection';
  currentQuestion?: Maybe<CategoryOnboardingV4Question>;
  id: SetupGuideSectionId;
  isCompleted: Scalars['Boolean'];
  questions: Array<CategoryOnboardingV4Question>;
  state: CategoryOnboardingV4SectionState;
  title: Scalars['String'];
};

export type CategoryOnboardingV4ChildrenQuestion = {
  __typename?: 'CategoryOnboardingV4ChildrenQuestion';
  description?: Maybe<Scalars['String']>;
  payload: CategoryOnboardingV4ChildrenQuestionPayload;
  title: Scalars['String'];
};

export type CategoryOnboardingV4ChildrenQuestionPayload = {
  __typename?: 'CategoryOnboardingV4ChildrenQuestionPayload';
  hasChildren: Scalars['Boolean'];
};

export type CategoryOnboardingV4ChildrenSection = {
  __typename?: 'CategoryOnboardingV4ChildrenSection';
  currentQuestion?: Maybe<CategoryOnboardingV4Question>;
  id: SetupGuideSectionId;
  isCompleted: Scalars['Boolean'];
  questions: Array<CategoryOnboardingV4Question>;
  state: CategoryOnboardingV4SectionState;
  title: Scalars['String'];
};

export type CategoryOnboardingV4ClosingDaysQuestion = {
  __typename?: 'CategoryOnboardingV4ClosingDaysQuestion';
  answer?: Maybe<CategoryOnboardingV4ClosingDaysQuestionAnswer>;
  description?: Maybe<Scalars['String']>;
  payload: CategoryOnboardingV4ClosingDaysQuestionPayload;
  title: Scalars['String'];
};

export type CategoryOnboardingV4ClosingDaysQuestionAnswer = {
  __typename?: 'CategoryOnboardingV4ClosingDaysQuestionAnswer';
  closingDays: Array<ClosingDayDay>;
};

export type CategoryOnboardingV4ClosingDaysQuestionAnswerInput = {
  deletedClosingDays: Array<ClosingDayInput>;
  existingClosingDays: Array<ClosingDayInput>;
  newClosingDays: Array<ClosingDayInput>;
};

export type CategoryOnboardingV4ClosingDaysQuestionMutation = {
  __typename?: 'CategoryOnboardingV4ClosingDaysQuestionMutation';
  answer: Array<CategoryOnboardingV4Category>;
};


export type CategoryOnboardingV4ClosingDaysQuestionMutationanswerArgs = {
  answer: CategoryOnboardingV4ClosingDaysQuestionAnswerInput;
  siteSetId: Scalars['SiteSetId'];
};

export type CategoryOnboardingV4ClosingDaysQuestionPayload = {
  __typename?: 'CategoryOnboardingV4ClosingDaysQuestionPayload';
  closingDayTypes: Array<ClosingDayWithLabel>;
  closingDaysGrouped: Array<ClosingDayGroup>;
};

export type CategoryOnboardingV4CommunicationCategory = {
  __typename?: 'CategoryOnboardingV4CommunicationCategory';
  id: SetupGuideCategoryId;
  progress: Scalars['Int'];
  sections: Array<CategoryOnboardingV4Section>;
  title: Scalars['String'];
};

export type CategoryOnboardingV4Config = {
  __typename?: 'CategoryOnboardingV4Config';
  isEnabled: Scalars['Boolean'];
};


export type CategoryOnboardingV4ConfigisEnabledArgs = {
  siteSetId: Scalars['SiteSetId'];
};

export type CategoryOnboardingV4CountryQuestion = {
  __typename?: 'CategoryOnboardingV4CountryQuestion';
  answer?: Maybe<CategoryOnboardingV4CountryQuestionAnswer>;
  description?: Maybe<Scalars['String']>;
  payload: CategoryOnboardingV4CountryQuestionPayload;
  title: Scalars['String'];
};

export type CategoryOnboardingV4CountryQuestionAnswer = {
  __typename?: 'CategoryOnboardingV4CountryQuestionAnswer';
  country: ConstituentCountries;
};

export type CategoryOnboardingV4CountryQuestionAnswerInput = {
  country: ConstituentCountries;
};

export type CategoryOnboardingV4CountryQuestionMutation = {
  __typename?: 'CategoryOnboardingV4CountryQuestionMutation';
  answer: Array<CategoryOnboardingV4Category>;
};


export type CategoryOnboardingV4CountryQuestionMutationanswerArgs = {
  answer: CategoryOnboardingV4CountryQuestionAnswerInput;
  siteSetId: Scalars['SiteSetId'];
};

export type CategoryOnboardingV4CountryQuestionPayload = {
  __typename?: 'CategoryOnboardingV4CountryQuestionPayload';
  countries: Array<ConstituentCountries>;
};

export type CategoryOnboardingV4CurriculumBuilderSection = {
  __typename?: 'CategoryOnboardingV4CurriculumBuilderSection';
  currentQuestion?: Maybe<CategoryOnboardingV4Question>;
  id: SetupGuideSectionId;
  isCompleted: Scalars['Boolean'];
  questions: Array<CategoryOnboardingV4Question>;
  state: CategoryOnboardingV4SectionState;
  title: Scalars['String'];
};

export type CategoryOnboardingV4DesignYourOwnAssessmentConfigurationQuestion = {
  __typename?: 'CategoryOnboardingV4DesignYourOwnAssessmentConfigurationQuestion';
  description?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  whatsThis?: Maybe<CategoryOnboardingV4QuestionWhatsThis>;
};

export type CategoryOnboardingV4DoYouWantToUseTheSignInKioskQuestionAnswer = {
  __typename?: 'CategoryOnboardingV4DoYouWantToUseTheSignInKioskQuestionAnswer';
  doYouWantToUseSignInKiosk: Scalars['Boolean'];
};

export type CategoryOnboardingV4DoYouWantToUseTheSignInKioskQuestionMutation = {
  __typename?: 'CategoryOnboardingV4DoYouWantToUseTheSignInKioskQuestionMutation';
  answer: Array<CategoryOnboardingV4Category>;
};


export type CategoryOnboardingV4DoYouWantToUseTheSignInKioskQuestionMutationanswerArgs = {
  doYouWantToUseTheSignInKiosk: Scalars['Boolean'];
  siteSetId: Scalars['SiteSetId'];
};

export type CategoryOnboardingV4EnableSidekickQuestion = {
  __typename?: 'CategoryOnboardingV4EnableSidekickQuestion';
  answer?: Maybe<CategoryOnboardingV4EnableSidekickQuestionAnswer>;
  description?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  whatsThis?: Maybe<CategoryOnboardingV4QuestionWhatsThisWithMedia>;
};

export type CategoryOnboardingV4EnableSidekickQuestionAnswer = {
  __typename?: 'CategoryOnboardingV4EnableSidekickQuestionAnswer';
  enableSidekick: Scalars['Boolean'];
};

export type CategoryOnboardingV4EnableSidekickQuestionAnswerInput = {
  enableSidekick: Scalars['Boolean'];
};

export type CategoryOnboardingV4EnableSidekickQuestionMutation = {
  __typename?: 'CategoryOnboardingV4EnableSidekickQuestionMutation';
  answer: Array<CategoryOnboardingV4Category>;
};


export type CategoryOnboardingV4EnableSidekickQuestionMutationanswerArgs = {
  answer: CategoryOnboardingV4EnableSidekickQuestionAnswerInput;
  siteSetId: Scalars['SiteSetId'];
};

export type CategoryOnboardingV4FinanceCategory = {
  __typename?: 'CategoryOnboardingV4FinanceCategory';
  id: SetupGuideCategoryId;
  progress: Scalars['Int'];
  sections: Array<CategoryOnboardingV4Section>;
  title: Scalars['String'];
};

export type CategoryOnboardingV4HowShouldParentsInfoBeDisplayedOnNewsfeedQuestion = {
  __typename?: 'CategoryOnboardingV4HowShouldParentsInfoBeDisplayedOnNewsfeedQuestion';
  answer?: Maybe<CategoryOnboardingV4HowShouldParentsInfoBeDisplayedOnNewsfeedQuestionAnswer>;
  description?: Maybe<Scalars['String']>;
  payload: CategoryOnboardingV4HowShouldParentsInfoBeDisplayedOnNewsfeedQuestionPayload;
  title: Scalars['String'];
};

export type CategoryOnboardingV4HowShouldParentsInfoBeDisplayedOnNewsfeedQuestionAnswer = {
  __typename?: 'CategoryOnboardingV4HowShouldParentsInfoBeDisplayedOnNewsfeedQuestionAnswer';
  displayChildRoom: Scalars['Boolean'];
  variant: CategoryOnboardingHowShouldParentsInfoBeDisplayedOnNewsfeedQuestionVariantWithLabel;
};

export type CategoryOnboardingV4HowShouldParentsInfoBeDisplayedOnNewsfeedQuestionAnswerInput = {
  displayChildRoom: Scalars['Boolean'];
  variant: CategoryOnboardingHowShouldParentsInfoBeDisplayedOnNewsfeedQuestionVariant;
};

export type CategoryOnboardingV4HowShouldParentsInfoBeDisplayedOnNewsfeedQuestionMutation = {
  __typename?: 'CategoryOnboardingV4HowShouldParentsInfoBeDisplayedOnNewsfeedQuestionMutation';
  answer: Array<CategoryOnboardingV4Category>;
};


export type CategoryOnboardingV4HowShouldParentsInfoBeDisplayedOnNewsfeedQuestionMutationanswerArgs = {
  answer: CategoryOnboardingV4HowShouldParentsInfoBeDisplayedOnNewsfeedQuestionAnswerInput;
  siteSetId: Scalars['SiteSetId'];
};

export type CategoryOnboardingV4HowShouldParentsInfoBeDisplayedOnNewsfeedQuestionPayload = {
  __typename?: 'CategoryOnboardingV4HowShouldParentsInfoBeDisplayedOnNewsfeedQuestionPayload';
  variants: Array<CategoryOnboardingHowShouldParentsInfoBeDisplayedOnNewsfeedQuestionVariantWithLabel>;
};

export type CategoryOnboardingV4HowToSignChildrenAndStaffInQuestion = {
  __typename?: 'CategoryOnboardingV4HowToSignChildrenAndStaffInQuestion';
  answer?: Maybe<CategoryOnboardingV4HowToSignChildrenAndStaffInQuestionAnswer>;
  description?: Maybe<Scalars['String']>;
  payload: CategoryOnboardingV4HowToSignChildrenAndStaffInQuestionPayload;
  title: Scalars['String'];
};

export type CategoryOnboardingV4HowToSignChildrenAndStaffInQuestionAnswer = {
  __typename?: 'CategoryOnboardingV4HowToSignChildrenAndStaffInQuestionAnswer';
  signInOption: CategoryOnboardingHowToSignChildrenAndStaffQuestionAnswerSignInOption;
};

export type CategoryOnboardingV4HowToSignChildrenAndStaffInQuestionAnswerInput = {
  signInOption: CategoryOnboardingHowToSignChildrenAndStaffQuestionAnswerSignInOption;
};

export type CategoryOnboardingV4HowToSignChildrenAndStaffInQuestionMutation = {
  __typename?: 'CategoryOnboardingV4HowToSignChildrenAndStaffInQuestionMutation';
  answer: Array<CategoryOnboardingV4Category>;
};


export type CategoryOnboardingV4HowToSignChildrenAndStaffInQuestionMutationanswerArgs = {
  answer: CategoryOnboardingV4HowToSignChildrenAndStaffInQuestionAnswerInput;
  siteSetId: Scalars['SiteSetId'];
};

export type CategoryOnboardingV4HowToSignChildrenAndStaffInQuestionPayload = {
  __typename?: 'CategoryOnboardingV4HowToSignChildrenAndStaffInQuestionPayload';
  onlyStaffCanSignInChildren: Scalars['Boolean'];
};

export type CategoryOnboardingV4HowToSignChildrenAndStaffInWithPinQuestion = {
  __typename?: 'CategoryOnboardingV4HowToSignChildrenAndStaffInWithPinQuestion';
  answer?: Maybe<CategoryOnboardingV4HowToSignChildrenAndStaffInWithPinQuestionAnswer>;
  description?: Maybe<Scalars['String']>;
  payload: CategoryOnboardingV4HowToSignChildrenAndStaffInWithPinQuestionPayload;
  title: Scalars['String'];
};

export type CategoryOnboardingV4HowToSignChildrenAndStaffInWithPinQuestionAnswer = {
  __typename?: 'CategoryOnboardingV4HowToSignChildrenAndStaffInWithPinQuestionAnswer';
  signInOption: CategoryOnboardingHowToSignChildrenAndStaffQuestionAnswerSignInWithPinOption;
};

export type CategoryOnboardingV4HowToSignChildrenAndStaffInWithPinQuestionAnswerInput = {
  signInOption: CategoryOnboardingHowToSignChildrenAndStaffQuestionAnswerSignInWithPinOption;
};

export type CategoryOnboardingV4HowToSignChildrenAndStaffInWithPinQuestionMutation = {
  __typename?: 'CategoryOnboardingV4HowToSignChildrenAndStaffInWithPinQuestionMutation';
  answer: Array<CategoryOnboardingV4Category>;
};


export type CategoryOnboardingV4HowToSignChildrenAndStaffInWithPinQuestionMutationanswerArgs = {
  answer: CategoryOnboardingV4HowToSignChildrenAndStaffInWithPinQuestionAnswerInput;
  siteSetId: Scalars['SiteSetId'];
};

export type CategoryOnboardingV4HowToSignChildrenAndStaffInWithPinQuestionPayload = {
  __typename?: 'CategoryOnboardingV4HowToSignChildrenAndStaffInWithPinQuestionPayload';
  onlyStaffCanSignInChildren: Scalars['Boolean'];
};

export type CategoryOnboardingV4InstructionsForUsingSignInKioskQuestion = {
  __typename?: 'CategoryOnboardingV4InstructionsForUsingSignInKioskQuestion';
  description?: Maybe<Scalars['String']>;
  payload: CategoryOnboardingV4InstructionsForUsingSignInKioskQuestionPayload;
  title: Scalars['String'];
};

export type CategoryOnboardingV4InstructionsForUsingSignInKioskQuestionPayload = {
  __typename?: 'CategoryOnboardingV4InstructionsForUsingSignInKioskQuestionPayload';
  device: CategoryOnboardingWhatDeviceForYourSignInKioskQuestionAnswerDevice;
  instructionsPDFLink: Scalars['String'];
  signInPassword: Scalars['String'];
};

export type CategoryOnboardingV4InvoiceDeadlineQuestion = {
  __typename?: 'CategoryOnboardingV4InvoiceDeadlineQuestion';
  answer?: Maybe<CategoryOnboardingV4InvoiceDeadlineQuestionAnswer>;
  description?: Maybe<Scalars['String']>;
  payload: CategoryOnboardingV4InvoiceDeadlineQuestionPayload;
  title: Scalars['String'];
};

export type CategoryOnboardingV4InvoiceDeadlineQuestionAnswer = {
  __typename?: 'CategoryOnboardingV4InvoiceDeadlineQuestionAnswer';
  days: Scalars['Int'];
};

export type CategoryOnboardingV4InvoiceDeadlineQuestionAnswerInput = {
  days: Scalars['Int'];
};

export type CategoryOnboardingV4InvoiceDeadlineQuestionMutation = {
  __typename?: 'CategoryOnboardingV4InvoiceDeadlineQuestionMutation';
  answer: Array<CategoryOnboardingV4Category>;
};


export type CategoryOnboardingV4InvoiceDeadlineQuestionMutationanswerArgs = {
  answer: CategoryOnboardingV4InvoiceDeadlineQuestionAnswerInput;
  siteSetId: Scalars['SiteSetId'];
};

export type CategoryOnboardingV4InvoiceDeadlineQuestionPayload = {
  __typename?: 'CategoryOnboardingV4InvoiceDeadlineQuestionPayload';
  defaultNumberOfDays: Scalars['Int'];
};

export type CategoryOnboardingV4InvoiceLayoutQuestion = {
  __typename?: 'CategoryOnboardingV4InvoiceLayoutQuestion';
  answer?: Maybe<CategoryOnboardingV4InvoiceLayoutQuestionAnswer>;
  description?: Maybe<Scalars['String']>;
  payload: CategoryOnboardingV4InvoiceLayoutQuestionPayload;
  title: Scalars['String'];
  whatsThis?: Maybe<CategoryOnboardingV4InvoiceLayoutQuestionWhatsThis>;
};

export type CategoryOnboardingV4InvoiceLayoutQuestionAnswer = {
  __typename?: 'CategoryOnboardingV4InvoiceLayoutQuestionAnswer';
  footer?: Maybe<Scalars['String']>;
  header?: Maybe<Scalars['String']>;
  invoiceFooter?: Maybe<Scalars['String']>;
  logo?: Maybe<CategoryOnboardingV4InvoiceLayoutQuestionAnswerLogo>;
};

export type CategoryOnboardingV4InvoiceLayoutQuestionAnswerInput = {
  footer?: InputMaybe<Scalars['String']>;
  header?: InputMaybe<Scalars['String']>;
  invoiceFooter?: InputMaybe<Scalars['String']>;
  logo?: InputMaybe<CategoryOnboardingV4InvoiceLayoutQuestionAnswerLogoInput>;
};

export type CategoryOnboardingV4InvoiceLayoutQuestionAnswerLogo = {
  __typename?: 'CategoryOnboardingV4InvoiceLayoutQuestionAnswerLogo';
  id: Scalars['String'];
  url: Scalars['String'];
};

export type CategoryOnboardingV4InvoiceLayoutQuestionAnswerLogoInput = {
  id: Scalars['String'];
  url: Scalars['String'];
};

export type CategoryOnboardingV4InvoiceLayoutQuestionMutation = {
  __typename?: 'CategoryOnboardingV4InvoiceLayoutQuestionMutation';
  answer: Array<CategoryOnboardingV4Category>;
};


export type CategoryOnboardingV4InvoiceLayoutQuestionMutationanswerArgs = {
  answer: CategoryOnboardingV4InvoiceLayoutQuestionAnswerInput;
  siteSetId: Scalars['SiteSetId'];
};

export type CategoryOnboardingV4InvoiceLayoutQuestionPayload = {
  __typename?: 'CategoryOnboardingV4InvoiceLayoutQuestionPayload';
  header: Scalars['String'];
};

export type CategoryOnboardingV4InvoiceLayoutQuestionWhatsThis = {
  __typename?: 'CategoryOnboardingV4InvoiceLayoutQuestionWhatsThis';
  description?: Maybe<Scalars['String']>;
  image: CategoryOnboardingV4InvoiceLayoutQuestionWhatsThisImage;
  title: Scalars['String'];
};

export type CategoryOnboardingV4InvoiceLayoutQuestionWhatsThisImage = {
  __typename?: 'CategoryOnboardingV4InvoiceLayoutQuestionWhatsThisImage';
  alt: Scalars['String'];
  url: Scalars['String'];
};

export type CategoryOnboardingV4InvoiceLayoutSection = {
  __typename?: 'CategoryOnboardingV4InvoiceLayoutSection';
  currentQuestion?: Maybe<CategoryOnboardingV4Question>;
  id: SetupGuideSectionId;
  isCompleted: Scalars['Boolean'];
  questions: Array<CategoryOnboardingV4Question>;
  state: CategoryOnboardingV4SectionState;
  title: Scalars['String'];
};

export type CategoryOnboardingV4InvoiceSendPeriodQuestion = {
  __typename?: 'CategoryOnboardingV4InvoiceSendPeriodQuestion';
  answer?: Maybe<CategoryOnboardingV4InvoiceSendPeriodQuestionAnswer>;
  description?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type CategoryOnboardingV4InvoiceSendPeriodQuestionAnswer = {
  __typename?: 'CategoryOnboardingV4InvoiceSendPeriodQuestionAnswer';
  period: InvoicingPeriod;
};

export type CategoryOnboardingV4InvoiceSendPeriodQuestionAnswerInput = {
  period: InvoicingPeriod;
};

export type CategoryOnboardingV4InvoiceSendPeriodQuestionMutation = {
  __typename?: 'CategoryOnboardingV4InvoiceSendPeriodQuestionMutation';
  answer: Array<CategoryOnboardingV4Category>;
};


export type CategoryOnboardingV4InvoiceSendPeriodQuestionMutationanswerArgs = {
  answer: CategoryOnboardingV4InvoiceSendPeriodQuestionAnswerInput;
  siteSetId: Scalars['SiteSetId'];
};

export type CategoryOnboardingV4InvoiceSendScheduleQuestion = {
  __typename?: 'CategoryOnboardingV4InvoiceSendScheduleQuestion';
  answer?: Maybe<CategoryOnboardingV4InvoiceSendScheduleQuestionAnswer>;
  description?: Maybe<Scalars['String']>;
  payload: CategoryOnboardingV4InvoiceSendScheduleQuestionPayload;
  title: Scalars['String'];
};

export type CategoryOnboardingV4InvoiceSendScheduleQuestionAnswer = {
  __typename?: 'CategoryOnboardingV4InvoiceSendScheduleQuestionAnswer';
  biweeklyStartDate?: Maybe<Scalars['LocalDate']>;
  monthlyAlternative?: Maybe<MonthlyInvoicingOptions>;
  monthlyExactDay?: Maybe<CategoryOnboardingV4MonthDay>;
  weeklyDayOfWeek?: Maybe<Scalars['DayOfWeek']>;
};

export type CategoryOnboardingV4InvoiceSendScheduleQuestionAnswerInput = {
  biweeklyStartDate?: InputMaybe<Scalars['LocalDate']>;
  monthlyAlternative?: InputMaybe<MonthlyInvoicingOptions>;
  monthlyExactDay?: InputMaybe<CategoryOnboardingV4MonthDayInput>;
  weeklyDayOfWeek?: InputMaybe<Scalars['DayOfWeek']>;
};

export type CategoryOnboardingV4InvoiceSendScheduleQuestionMutation = {
  __typename?: 'CategoryOnboardingV4InvoiceSendScheduleQuestionMutation';
  answer: Array<CategoryOnboardingV4Category>;
};


export type CategoryOnboardingV4InvoiceSendScheduleQuestionMutationanswerArgs = {
  answer: CategoryOnboardingV4InvoiceSendScheduleQuestionAnswerInput;
  siteSetId: Scalars['SiteSetId'];
};

export type CategoryOnboardingV4InvoiceSendScheduleQuestionPayload = {
  __typename?: 'CategoryOnboardingV4InvoiceSendScheduleQuestionPayload';
  days: Array<CategoryOnboardingV4MonthDay>;
  monthlyAlternatives: Array<MonthlyInvoicingOptions>;
  weeklyAlternatives: Array<Scalars['DayOfWeek']>;
};

export type CategoryOnboardingV4InvoicingBasicsSection = {
  __typename?: 'CategoryOnboardingV4InvoicingBasicsSection';
  currentQuestion?: Maybe<CategoryOnboardingV4Question>;
  id: SetupGuideSectionId;
  isCompleted: Scalars['Boolean'];
  questions: Array<CategoryOnboardingV4Question>;
  state: CategoryOnboardingV4SectionState;
  title: Scalars['String'];
};

export type CategoryOnboardingV4LearningBasicsSection = {
  __typename?: 'CategoryOnboardingV4LearningBasicsSection';
  currentQuestion?: Maybe<CategoryOnboardingV4Question>;
  id: SetupGuideSectionId;
  isCompleted: Scalars['Boolean'];
  questions: Array<CategoryOnboardingV4Question>;
  state: CategoryOnboardingV4SectionState;
  title: Scalars['String'];
};

export type CategoryOnboardingV4LearningFrameworksForEnglandQuestion = {
  __typename?: 'CategoryOnboardingV4LearningFrameworksForEnglandQuestion';
  answer?: Maybe<CategoryOnboardingV4LearningFrameworksForEnglandQuestionAnswer>;
  description?: Maybe<Scalars['String']>;
  payload: CategoryOnboardingV4LearningFrameworksForEnglandQuestionPayload;
  title: Scalars['String'];
  whatsThis?: Maybe<CategoryOnboardingV4QuestionWhatsThis>;
};

export type CategoryOnboardingV4LearningFrameworksForEnglandQuestionAnswer = {
  __typename?: 'CategoryOnboardingV4LearningFrameworksForEnglandQuestionAnswer';
  learningFrameworks: Array<LearningFramework>;
};

export type CategoryOnboardingV4LearningFrameworksForEnglandQuestionAnswerInput = {
  learningFrameworks: Array<LearningFramework>;
};

export type CategoryOnboardingV4LearningFrameworksForEnglandQuestionMutation = {
  __typename?: 'CategoryOnboardingV4LearningFrameworksForEnglandQuestionMutation';
  answer: Array<CategoryOnboardingV4Category>;
};


export type CategoryOnboardingV4LearningFrameworksForEnglandQuestionMutationanswerArgs = {
  answer: CategoryOnboardingV4LearningFrameworksForEnglandQuestionAnswerInput;
  siteSetId: Scalars['SiteSetId'];
};

export type CategoryOnboardingV4LearningFrameworksForEnglandQuestionPayload = {
  __typename?: 'CategoryOnboardingV4LearningFrameworksForEnglandQuestionPayload';
  learningFrameworks: Array<LearningFramework>;
};

export type CategoryOnboardingV4LearningFrameworksForScotlandQuestion = {
  __typename?: 'CategoryOnboardingV4LearningFrameworksForScotlandQuestion';
  answer?: Maybe<CategoryOnboardingV4LearningFrameworksForScotlandQuestionAnswer>;
  description?: Maybe<Scalars['String']>;
  payload: CategoryOnboardingV4LearningFrameworksForScotlandQuestionPayload;
  title: Scalars['String'];
  whatsThis?: Maybe<CategoryOnboardingV4QuestionWhatsThis>;
};

export type CategoryOnboardingV4LearningFrameworksForScotlandQuestionAnswer = {
  __typename?: 'CategoryOnboardingV4LearningFrameworksForScotlandQuestionAnswer';
  learningFrameworks: Array<LearningFrameworkForScotland>;
};

export type CategoryOnboardingV4LearningFrameworksForScotlandQuestionAnswerInput = {
  learningFrameworks: Array<LearningFrameworkForScotland>;
};

export type CategoryOnboardingV4LearningFrameworksForScotlandQuestionMutation = {
  __typename?: 'CategoryOnboardingV4LearningFrameworksForScotlandQuestionMutation';
  answer: Array<CategoryOnboardingV4Category>;
};


export type CategoryOnboardingV4LearningFrameworksForScotlandQuestionMutationanswerArgs = {
  answer: CategoryOnboardingV4LearningFrameworksForScotlandQuestionAnswerInput;
  siteSetId: Scalars['SiteSetId'];
};

export type CategoryOnboardingV4LearningFrameworksForScotlandQuestionPayload = {
  __typename?: 'CategoryOnboardingV4LearningFrameworksForScotlandQuestionPayload';
  learningFrameworks: Array<LearningFrameworkForScotland>;
};

export type CategoryOnboardingV4LearningFrameworksForWalesQuestion = {
  __typename?: 'CategoryOnboardingV4LearningFrameworksForWalesQuestion';
  answer?: Maybe<CategoryOnboardingV4LearningFrameworksForWalesQuestionAnswer>;
  description?: Maybe<Scalars['String']>;
  payload: CategoryOnboardingV4LearningFrameworksForWalesQuestionPayload;
  title: Scalars['String'];
  whatsThis?: Maybe<CategoryOnboardingV4QuestionWhatsThis>;
};

export type CategoryOnboardingV4LearningFrameworksForWalesQuestionAnswer = {
  __typename?: 'CategoryOnboardingV4LearningFrameworksForWalesQuestionAnswer';
  learningFrameworks: Array<LearningFrameworkForWales>;
};

export type CategoryOnboardingV4LearningFrameworksForWalesQuestionAnswerInput = {
  learningFrameworks: Array<LearningFrameworkForWales>;
};

export type CategoryOnboardingV4LearningFrameworksForWalesQuestionMutation = {
  __typename?: 'CategoryOnboardingV4LearningFrameworksForWalesQuestionMutation';
  answer: Array<CategoryOnboardingV4Category>;
};


export type CategoryOnboardingV4LearningFrameworksForWalesQuestionMutationanswerArgs = {
  answer: CategoryOnboardingV4LearningFrameworksForWalesQuestionAnswerInput;
  siteSetId: Scalars['SiteSetId'];
};

export type CategoryOnboardingV4LearningFrameworksForWalesQuestionPayload = {
  __typename?: 'CategoryOnboardingV4LearningFrameworksForWalesQuestionPayload';
  learningFrameworks: Array<LearningFrameworkForWales>;
};

export type CategoryOnboardingV4MonthDay = {
  __typename?: 'CategoryOnboardingV4MonthDay';
  number: Scalars['Int'];
  ordinal: Scalars['String'];
};

export type CategoryOnboardingV4MonthDayInput = {
  number?: InputMaybe<Scalars['Int']>;
};

export type CategoryOnboardingV4Mutation = {
  __typename?: 'CategoryOnboardingV4Mutation';
  dismiss: Scalars['Boolean'];
  questions: CategoryOnboardingV4MutationQuestion;
  unwant: CategoryOnboardingV4SetupGuide;
};


export type CategoryOnboardingV4MutationunwantArgs = {
  question: Scalars['QuestionInputType'];
  siteSetId: Scalars['SiteSetId'];
};

export type CategoryOnboardingV4MutationQuestion = {
  __typename?: 'CategoryOnboardingV4MutationQuestion';
  ageGroups: CategoryOnboardingV4AgeGroupsQuestionMutation;
  allowUsersToTranslateMessageAndPosts: CategoryOnboardingV4AllowUsersToTranslateMessageAndPostsQuestionMutation;
  assessments: CategoryOnboardingV4AssessmentsQuestionMutation;
  assignNewBillPayers: CategoryOnboardingV4AssignNewBillPayersQuestionMutation;
  canParentsDownloadNewsfeedPhotosFromTheApp: CategoryOnboardingV4CanParentsDownloadNewsfeedPhotosFromTheAppQuestionMutation;
  canParentsWriteObservations: CategoryOnboardingV4CanParentsWriteObservationsQuestionMutation;
  closingDays: CategoryOnboardingV4ClosingDaysQuestionMutation;
  country: CategoryOnboardingV4CountryQuestionMutation;
  doYouWantToUseTheSignInKiosk: CategoryOnboardingV4DoYouWantToUseTheSignInKioskQuestionMutation;
  followsStatementBasedTracking: CategoryOnboardingV4StatementBasedTrackingQuestionMutation;
  howShouldParentsInfoBeDisplayedOnNewsfeed: CategoryOnboardingV4HowShouldParentsInfoBeDisplayedOnNewsfeedQuestionMutation;
  howToSignChildrenAndStaffIn: CategoryOnboardingV4HowToSignChildrenAndStaffInQuestionMutation;
  howToSignChildrenAndStaffInWithPin: CategoryOnboardingV4HowToSignChildrenAndStaffInWithPinQuestionMutation;
  invoiceDeadline: CategoryOnboardingV4InvoiceDeadlineQuestionMutation;
  invoiceLayout: CategoryOnboardingV4InvoiceLayoutQuestionMutation;
  invoiceSendPeriod: CategoryOnboardingV4InvoiceSendPeriodQuestionMutation;
  invoiceSendSchedule: CategoryOnboardingV4InvoiceSendScheduleQuestionMutation;
  learningFrameworksForEngland: CategoryOnboardingV4LearningFrameworksForEnglandQuestionMutation;
  learningFrameworksForScotland: CategoryOnboardingV4LearningFrameworksForScotlandQuestionMutation;
  learningFrameworksForWales: CategoryOnboardingV4LearningFrameworksForWalesQuestionMutation;
  nurseryInfo: CategoryOnboardingV4NurseryInfoQuestionMutation;
  nurseryLogo: CategoryOnboardingV4NurseryLogoQuestionMutation;
  nurseryProfile: CategoryOnboardingV4NurseryProfileQuestionMutation;
  openingHours: CategoryOnboardingV4OpeningHoursQuestionMutation;
  pinCode: CategoryOnboardingV4PinCodeQuestionMutation;
  profileInfo: CategoryOnboardingV4ProfileInfoQuestionMutation;
  referenceMaterialsForEngland: CategoryOnboardingV4ReferenceMaterialsForEnglandQuestionMutation;
  referenceMaterialsForScotland: CategoryOnboardingV4ReferenceMaterialsForScotlandQuestionMutation;
  referenceMaterialsForWales: CategoryOnboardingV4ReferenceMaterialsForWalesQuestionMutation;
  roles: CategoryOnboardingV4RolesQuestionMutation;
  rooms: CategoryOnboardingV4RoomsQuestionMutation;
  setupAddressForLocationBasedSignIn: CategoryOnboardingV4SetupAddressForLocationBasedSignInQuestionMutation;
  shouldParentsBeAbleToSendMessagesToOtherParents: CategoryOnboardingV4ShouldParentsBeAbleToSendMessagesToOtherParentsQuestionMutation;
  toggleSidekick: CategoryOnboardingV4EnableSidekickQuestionMutation;
  whatDeviceForYourSignInKiosk: CategoryOnboardingV4WhatDeviceForYourSignInKioskQuestionMutation;
  whenShouldYourStaffBeAutomaticallyLoggedOut: CategoryOnboardingV4WhenShouldYourStaffBeAutomaticallyLoggedOutQuestionMutation;
  whoShouldSeeSeenByReceipts: CategoryOnboardingV4WhoShouldSeeSeenByReceiptsQuestionMutation;
  whoShouldSignChildrenInAndOut: CategoryOnboardingV4WhoShouldSignChildrenInAndOutQuestionMutation;
};

export type CategoryOnboardingV4NurseryInfoQuestion = {
  __typename?: 'CategoryOnboardingV4NurseryInfoQuestion';
  answer?: Maybe<CategoryOnboardingV4NurseryInfoQuestionAnswer>;
  description?: Maybe<Scalars['String']>;
  payload: CategoryOnboardingV4NurseryInfoQuestionPayload;
  title: Scalars['String'];
};

export type CategoryOnboardingV4NurseryInfoQuestionAnswer = {
  __typename?: 'CategoryOnboardingV4NurseryInfoQuestionAnswer';
  address: Address;
  name: Scalars['String'];
  vat: Scalars['String'];
};

export type CategoryOnboardingV4NurseryInfoQuestionAnswerInput = {
  address: AddressInput;
  name: Scalars['String'];
  vat: Scalars['String'];
};

export type CategoryOnboardingV4NurseryInfoQuestionMutation = {
  __typename?: 'CategoryOnboardingV4NurseryInfoQuestionMutation';
  answer: Array<CategoryOnboardingV4Category>;
};


export type CategoryOnboardingV4NurseryInfoQuestionMutationanswerArgs = {
  answer: CategoryOnboardingV4NurseryInfoQuestionAnswerInput;
  siteSetId: Scalars['SiteSetId'];
};

export type CategoryOnboardingV4NurseryInfoQuestionPayload = {
  __typename?: 'CategoryOnboardingV4NurseryInfoQuestionPayload';
  address?: Maybe<Address>;
  addressFormat: AddressFormat;
  name?: Maybe<Scalars['String']>;
  vat?: Maybe<Scalars['String']>;
};

export type CategoryOnboardingV4NurseryLogoQuestion = {
  __typename?: 'CategoryOnboardingV4NurseryLogoQuestion';
  answer?: Maybe<CategoryOnboardingV4NurseryLogoQuestionAnswer>;
  description?: Maybe<Scalars['String']>;
  payload: CategoryOnboardingV4NurseryLogoQuestionPayload;
  title: Scalars['String'];
};

export type CategoryOnboardingV4NurseryLogoQuestionAnswer = {
  __typename?: 'CategoryOnboardingV4NurseryLogoQuestionAnswer';
  profileImage?: Maybe<ProfileImage>;
};

export type CategoryOnboardingV4NurseryLogoQuestionAnswerInput = {
  profileImage?: InputMaybe<CategoryOnboardingV4QuestionAnswerProfileImageInput>;
};

export type CategoryOnboardingV4NurseryLogoQuestionMutation = {
  __typename?: 'CategoryOnboardingV4NurseryLogoQuestionMutation';
  answer: Array<CategoryOnboardingV4Category>;
};


export type CategoryOnboardingV4NurseryLogoQuestionMutationanswerArgs = {
  answer: CategoryOnboardingV4NurseryLogoQuestionAnswerInput;
  siteSetId: Scalars['SiteSetId'];
};

export type CategoryOnboardingV4NurseryLogoQuestionPayload = {
  __typename?: 'CategoryOnboardingV4NurseryLogoQuestionPayload';
  siteSetId: Scalars['SiteSetId'];
};

export type CategoryOnboardingV4NurseryProfileQuestion = {
  __typename?: 'CategoryOnboardingV4NurseryProfileQuestion';
  answer?: Maybe<CategoryOnboardingV4NurseryProfileQuestionAnswer>;
  description?: Maybe<Scalars['String']>;
  payload: CategoryOnboardingV4NurseryProfileQuestionPayload;
  title: Scalars['String'];
};

export type CategoryOnboardingV4NurseryProfileQuestionAnswer = {
  __typename?: 'CategoryOnboardingV4NurseryProfileQuestionAnswer';
  identificationNumber: Scalars['String'];
  vat: Scalars['String'];
};

export type CategoryOnboardingV4NurseryProfileQuestionAnswerInput = {
  identificationNumber: Scalars['String'];
  vat: Scalars['String'];
};

export type CategoryOnboardingV4NurseryProfileQuestionMutation = {
  __typename?: 'CategoryOnboardingV4NurseryProfileQuestionMutation';
  answer: Array<CategoryOnboardingV4Category>;
};


export type CategoryOnboardingV4NurseryProfileQuestionMutationanswerArgs = {
  answer: CategoryOnboardingV4NurseryProfileQuestionAnswerInput;
  siteSetId: Scalars['SiteSetId'];
};

export type CategoryOnboardingV4NurseryProfileQuestionPayload = {
  __typename?: 'CategoryOnboardingV4NurseryProfileQuestionPayload';
  addressFormat: AddressFormat;
  identificationNumber?: Maybe<Scalars['String']>;
  vat?: Maybe<Scalars['String']>;
};

export type CategoryOnboardingV4OpeningHoursQuestion = {
  __typename?: 'CategoryOnboardingV4OpeningHoursQuestion';
  answer?: Maybe<CategoryOnboardingV4OpeningHoursQuestionAnswer>;
  description?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type CategoryOnboardingV4OpeningHoursQuestionAnswer = {
  __typename?: 'CategoryOnboardingV4OpeningHoursQuestionAnswer';
  openingHours: OpeningHours;
};

export type CategoryOnboardingV4OpeningHoursQuestionAnswerInput = {
  openingHours: OpeningHoursInput;
};

export type CategoryOnboardingV4OpeningHoursQuestionMutation = {
  __typename?: 'CategoryOnboardingV4OpeningHoursQuestionMutation';
  answer: Array<CategoryOnboardingV4Category>;
};


export type CategoryOnboardingV4OpeningHoursQuestionMutationanswerArgs = {
  answer: CategoryOnboardingV4OpeningHoursQuestionAnswerInput;
  siteSetId: Scalars['SiteSetId'];
};

export type CategoryOnboardingV4PinCodeQuestion = {
  __typename?: 'CategoryOnboardingV4PinCodeQuestion';
  answer?: Maybe<CategoryOnboardingV4PinCodeQuestionAnswer>;
  description?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type CategoryOnboardingV4PinCodeQuestionAnswer = {
  __typename?: 'CategoryOnboardingV4PinCodeQuestionAnswer';
  password: Scalars['Password'];
  pinCode: Scalars['String'];
};

export type CategoryOnboardingV4PinCodeQuestionAnswerInput = {
  password: Scalars['String'];
  pinCode: Scalars['String'];
};

export type CategoryOnboardingV4PinCodeQuestionMutation = {
  __typename?: 'CategoryOnboardingV4PinCodeQuestionMutation';
  answer: Array<CategoryOnboardingV4Category>;
};


export type CategoryOnboardingV4PinCodeQuestionMutationanswerArgs = {
  answer: CategoryOnboardingV4PinCodeQuestionAnswerInput;
  siteSetId: Scalars['SiteSetId'];
};

export type CategoryOnboardingV4PrivacySection = {
  __typename?: 'CategoryOnboardingV4PrivacySection';
  currentQuestion?: Maybe<CategoryOnboardingV4Question>;
  id: SetupGuideSectionId;
  isCompleted: Scalars['Boolean'];
  questions: Array<CategoryOnboardingV4Question>;
  state: CategoryOnboardingV4SectionState;
  title: Scalars['String'];
};

export type CategoryOnboardingV4ProfileInfoQuestion = {
  __typename?: 'CategoryOnboardingV4ProfileInfoQuestion';
  answer?: Maybe<CategoryOnboardingV4ProfileInfoQuestionAnswer>;
  description?: Maybe<Scalars['String']>;
  payload: CategoryOnboardingV4ProfileInfoQuestionPayload;
  title: Scalars['String'];
};

export type CategoryOnboardingV4ProfileInfoQuestionAnswer = {
  __typename?: 'CategoryOnboardingV4ProfileInfoQuestionAnswer';
  name: Name;
  profileImage?: Maybe<ProfileImage>;
};

export type CategoryOnboardingV4ProfileInfoQuestionAnswerInput = {
  name: Scalars['NameInput'];
  profileImage?: InputMaybe<CategoryOnboardingV4QuestionAnswerProfileImageInput>;
};

export type CategoryOnboardingV4ProfileInfoQuestionMutation = {
  __typename?: 'CategoryOnboardingV4ProfileInfoQuestionMutation';
  answer: Array<CategoryOnboardingV4Category>;
};


export type CategoryOnboardingV4ProfileInfoQuestionMutationanswerArgs = {
  answer: CategoryOnboardingV4ProfileInfoQuestionAnswerInput;
  siteSetId: Scalars['SiteSetId'];
};

export type CategoryOnboardingV4ProfileInfoQuestionPayload = {
  __typename?: 'CategoryOnboardingV4ProfileInfoQuestionPayload';
  loginId: Scalars['LoginId'];
  name?: Maybe<Name>;
  profileImage?: Maybe<ProfileImage>;
};

export type CategoryOnboardingV4Question = CategoryOnboardingV4AddPlansToChildrenQuestion | CategoryOnboardingV4AgeGroupsQuestion | CategoryOnboardingV4AllowUsersToTranslateMessageAndPostsQuestion | CategoryOnboardingV4AssessmentsQuestion | CategoryOnboardingV4AssignNewBillPayersQuestion | CategoryOnboardingV4BuildYourOwnCurriculumQuestion | CategoryOnboardingV4CanParentsDownloadNewsfeedPhotosFromTheAppQuestion | CategoryOnboardingV4CanParentsWriteObservationsQuestion | CategoryOnboardingV4ChildrenQuestion | CategoryOnboardingV4ClosingDaysQuestion | CategoryOnboardingV4CountryQuestion | CategoryOnboardingV4DesignYourOwnAssessmentConfigurationQuestion | CategoryOnboardingV4EnableSidekickQuestion | CategoryOnboardingV4HowShouldParentsInfoBeDisplayedOnNewsfeedQuestion | CategoryOnboardingV4HowToSignChildrenAndStaffInQuestion | CategoryOnboardingV4HowToSignChildrenAndStaffInWithPinQuestion | CategoryOnboardingV4InstructionsForUsingSignInKioskQuestion | CategoryOnboardingV4InvoiceDeadlineQuestion | CategoryOnboardingV4InvoiceLayoutQuestion | CategoryOnboardingV4InvoiceSendPeriodQuestion | CategoryOnboardingV4InvoiceSendScheduleQuestion | CategoryOnboardingV4LearningFrameworksForEnglandQuestion | CategoryOnboardingV4LearningFrameworksForScotlandQuestion | CategoryOnboardingV4LearningFrameworksForWalesQuestion | CategoryOnboardingV4NurseryInfoQuestion | CategoryOnboardingV4NurseryLogoQuestion | CategoryOnboardingV4NurseryProfileQuestion | CategoryOnboardingV4OpeningHoursQuestion | CategoryOnboardingV4PinCodeQuestion | CategoryOnboardingV4ProfileInfoQuestion | CategoryOnboardingV4ReferenceMaterialsForEnglandQuestion | CategoryOnboardingV4ReferenceMaterialsForScotlandQuestion | CategoryOnboardingV4ReferenceMaterialsForWalesQuestion | CategoryOnboardingV4RolesQuestion | CategoryOnboardingV4RoomsQuestion | CategoryOnboardingV4SetUpInvoicingBasicsQuestion | CategoryOnboardingV4SetupAddressForLocationBasedSignInQuestion | CategoryOnboardingV4ShouldParentsAndStaffUseTheSignInKioskQuestion | CategoryOnboardingV4ShouldParentsBeAbleToSendMessagesToOtherParentsQuestion | CategoryOnboardingV4StaffQuestion | CategoryOnboardingV4StatementBasedTrackingQuestion | CategoryOnboardingV4WhatDeviceForYourSignInKioskQuestion | CategoryOnboardingV4WhenShouldYourStaffBeAutomaticallyLoggedOutQuestion | CategoryOnboardingV4WhoShouldSeeSeenByReceiptsQuestion | CategoryOnboardingV4WhoShouldSignChildrenInAndOutQuestion | CategoryOnboardingV4YourQRCodeIsReadyQuestion;

export type CategoryOnboardingV4QuestionAnswerProfileImageInput = {
  id: Scalars['String'];
  url: Scalars['String'];
};

export type CategoryOnboardingV4QuestionWhatsThis = {
  __typename?: 'CategoryOnboardingV4QuestionWhatsThis';
  description: Scalars['String'];
  experts: Array<CategoryOnboardingV4QuestionWhatsThisExperts>;
  image: CategoryOnboardingV4QuestionWhatsThisImage;
  subtitle?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type CategoryOnboardingV4QuestionWhatsThisExpert = {
  __typename?: 'CategoryOnboardingV4QuestionWhatsThisExpert';
  firstName: Scalars['String'];
  imageURL: Scalars['String'];
  lastName: Scalars['String'];
};

export type CategoryOnboardingV4QuestionWhatsThisExperts = {
  __typename?: 'CategoryOnboardingV4QuestionWhatsThisExperts';
  firstName: Scalars['String'];
  imageURL: Scalars['String'];
  lastName: Scalars['String'];
};

export type CategoryOnboardingV4QuestionWhatsThisImage = {
  __typename?: 'CategoryOnboardingV4QuestionWhatsThisImage';
  alt: Scalars['String'];
  url: Scalars['String'];
};

export type CategoryOnboardingV4QuestionWhatsThisImageMedia = {
  __typename?: 'CategoryOnboardingV4QuestionWhatsThisImageMedia';
  alt: Scalars['String'];
  mediaType: WhatsThisMediaType;
  url: Scalars['String'];
};

export type CategoryOnboardingV4QuestionWhatsThisMedia = CategoryOnboardingV4QuestionWhatsThisImageMedia | CategoryOnboardingV4QuestionWhatsThisVideoMedia;

export type CategoryOnboardingV4QuestionWhatsThisVideoMedia = {
  __typename?: 'CategoryOnboardingV4QuestionWhatsThisVideoMedia';
  backgroundImageUrl?: Maybe<Scalars['String']>;
  mediaType: WhatsThisMediaType;
  url: Scalars['String'];
};

export type CategoryOnboardingV4QuestionWhatsThisWithMedia = {
  __typename?: 'CategoryOnboardingV4QuestionWhatsThisWithMedia';
  description: Scalars['String'];
  experts: Array<CategoryOnboardingV4QuestionWhatsThisExpert>;
  media: CategoryOnboardingV4QuestionWhatsThisMedia;
  subtitle?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type CategoryOnboardingV4ReferenceMaterialWithObservationForScotlandType = {
  __typename?: 'CategoryOnboardingV4ReferenceMaterialWithObservationForScotlandType';
  observation: ObservationType;
  referenceMaterial: ReferenceMaterialForScotland;
};

export type CategoryOnboardingV4ReferenceMaterialWithObservationType = {
  __typename?: 'CategoryOnboardingV4ReferenceMaterialWithObservationType';
  observation: ObservationType;
  referenceMaterial: ReferenceMaterial;
};

export type CategoryOnboardingV4ReferenceMaterialWithObservationTypeForWales = {
  __typename?: 'CategoryOnboardingV4ReferenceMaterialWithObservationTypeForWales';
  observation: ObservationType;
  referenceMaterial: ReferenceMaterialForWales;
};

export type CategoryOnboardingV4ReferenceMaterialsForEnglandQuestion = {
  __typename?: 'CategoryOnboardingV4ReferenceMaterialsForEnglandQuestion';
  answer?: Maybe<CategoryOnboardingV4ReferenceMaterialsForEnglandQuestionAnswer>;
  description?: Maybe<Scalars['String']>;
  payload: CategoryOnboardingV4ReferenceMaterialsForEnglandQuestionPayload;
  title: Scalars['String'];
  whatsThis?: Maybe<CategoryOnboardingV4QuestionWhatsThis>;
};

export type CategoryOnboardingV4ReferenceMaterialsForEnglandQuestionAnswer = {
  __typename?: 'CategoryOnboardingV4ReferenceMaterialsForEnglandQuestionAnswer';
  referenceMaterials: Array<CategoryOnboardingV4ReferenceMaterialWithObservationType>;
};

export type CategoryOnboardingV4ReferenceMaterialsForEnglandQuestionAnswerInput = {
  referenceMaterials: Array<CategoryOnboardingV4ReferenceMaterialsType>;
};

export type CategoryOnboardingV4ReferenceMaterialsForEnglandQuestionMutation = {
  __typename?: 'CategoryOnboardingV4ReferenceMaterialsForEnglandQuestionMutation';
  answer: Array<CategoryOnboardingV4Category>;
};


export type CategoryOnboardingV4ReferenceMaterialsForEnglandQuestionMutationanswerArgs = {
  answer: CategoryOnboardingV4ReferenceMaterialsForEnglandQuestionAnswerInput;
  siteSetId: Scalars['SiteSetId'];
};

export type CategoryOnboardingV4ReferenceMaterialsForEnglandQuestionPayload = {
  __typename?: 'CategoryOnboardingV4ReferenceMaterialsForEnglandQuestionPayload';
  referenceMaterials: Array<CategoryOnboardingV4ReferenceMaterialWithObservationType>;
};

export type CategoryOnboardingV4ReferenceMaterialsForScotlandQuestion = {
  __typename?: 'CategoryOnboardingV4ReferenceMaterialsForScotlandQuestion';
  answer?: Maybe<CategoryOnboardingV4ReferenceMaterialsForScotlandQuestionAnswer>;
  description?: Maybe<Scalars['String']>;
  payload: CategoryOnboardingV4ReferenceMaterialsForScotlandQuestionPayload;
  title: Scalars['String'];
  whatsThis?: Maybe<CategoryOnboardingV4QuestionWhatsThis>;
};

export type CategoryOnboardingV4ReferenceMaterialsForScotlandQuestionAnswer = {
  __typename?: 'CategoryOnboardingV4ReferenceMaterialsForScotlandQuestionAnswer';
  referenceMaterials: Array<CategoryOnboardingV4ReferenceMaterialWithObservationForScotlandType>;
};

export type CategoryOnboardingV4ReferenceMaterialsForScotlandQuestionAnswerInput = {
  referenceMaterials: Array<CategoryOnboardingV4ReferenceMaterialsForScotlandType>;
};

export type CategoryOnboardingV4ReferenceMaterialsForScotlandQuestionMutation = {
  __typename?: 'CategoryOnboardingV4ReferenceMaterialsForScotlandQuestionMutation';
  answer: Array<CategoryOnboardingV4Category>;
};


export type CategoryOnboardingV4ReferenceMaterialsForScotlandQuestionMutationanswerArgs = {
  answer: CategoryOnboardingV4ReferenceMaterialsForScotlandQuestionAnswerInput;
  siteSetId: Scalars['SiteSetId'];
};

export type CategoryOnboardingV4ReferenceMaterialsForScotlandQuestionPayload = {
  __typename?: 'CategoryOnboardingV4ReferenceMaterialsForScotlandQuestionPayload';
  referenceMaterials: Array<CategoryOnboardingV4ReferenceMaterialWithObservationForScotlandType>;
};

export type CategoryOnboardingV4ReferenceMaterialsForScotlandType = {
  observation: ObservationType;
  referenceMaterial: ReferenceMaterialForScotland;
};

export type CategoryOnboardingV4ReferenceMaterialsForWalesQuestion = {
  __typename?: 'CategoryOnboardingV4ReferenceMaterialsForWalesQuestion';
  answer?: Maybe<CategoryOnboardingV4ReferenceMaterialsForWalesQuestionAnswer>;
  description?: Maybe<Scalars['String']>;
  payload: CategoryOnboardingV4ReferenceMaterialsForWalesQuestionPayload;
  title: Scalars['String'];
  whatsThis?: Maybe<CategoryOnboardingV4QuestionWhatsThis>;
};

export type CategoryOnboardingV4ReferenceMaterialsForWalesQuestionAnswer = {
  __typename?: 'CategoryOnboardingV4ReferenceMaterialsForWalesQuestionAnswer';
  referenceMaterials: Array<CategoryOnboardingV4ReferenceMaterialWithObservationTypeForWales>;
};

export type CategoryOnboardingV4ReferenceMaterialsForWalesQuestionAnswerInput = {
  referenceMaterials: Array<CategoryOnboardingV4ReferenceMaterialsTypeForWales>;
};

export type CategoryOnboardingV4ReferenceMaterialsForWalesQuestionMutation = {
  __typename?: 'CategoryOnboardingV4ReferenceMaterialsForWalesQuestionMutation';
  answer: Array<CategoryOnboardingV4Category>;
};


export type CategoryOnboardingV4ReferenceMaterialsForWalesQuestionMutationanswerArgs = {
  answer: CategoryOnboardingV4ReferenceMaterialsForWalesQuestionAnswerInput;
  siteSetId: Scalars['SiteSetId'];
};

export type CategoryOnboardingV4ReferenceMaterialsForWalesQuestionPayload = {
  __typename?: 'CategoryOnboardingV4ReferenceMaterialsForWalesQuestionPayload';
  referenceMaterials: Array<CategoryOnboardingV4ReferenceMaterialWithObservationTypeForWales>;
};

export type CategoryOnboardingV4ReferenceMaterialsType = {
  observation: ObservationType;
  referenceMaterial: ReferenceMaterial;
};

export type CategoryOnboardingV4ReferenceMaterialsTypeForWales = {
  observation: ObservationType;
  referenceMaterial: ReferenceMaterialForWales;
};

export type CategoryOnboardingV4RolesQuestion = {
  __typename?: 'CategoryOnboardingV4RolesQuestion';
  answer?: Maybe<CategoryOnboardingV4RolesQuestionAnswer>;
  description?: Maybe<Scalars['String']>;
  payload: CategoryOnboardingV4RolesQuestionPayload;
  title: Scalars['String'];
};

export type CategoryOnboardingV4RolesQuestionAnswer = {
  __typename?: 'CategoryOnboardingV4RolesQuestionAnswer';
  roles: Array<CategoryOnboardingV4RolesQuestionRole>;
};

export type CategoryOnboardingV4RolesQuestionAnswerInput = {
  roles: Array<CategoryOnboardingV4RolesQuestionRoleInput>;
};

export type CategoryOnboardingV4RolesQuestionMutation = {
  __typename?: 'CategoryOnboardingV4RolesQuestionMutation';
  answer: Array<CategoryOnboardingV4Category>;
};


export type CategoryOnboardingV4RolesQuestionMutationanswerArgs = {
  answer: CategoryOnboardingV4RolesQuestionAnswerInput;
  siteSetId: Scalars['SiteSetId'];
};

export type CategoryOnboardingV4RolesQuestionPayload = {
  __typename?: 'CategoryOnboardingV4RolesQuestionPayload';
  managerRoleId: Scalars['RoleId'];
};

export type CategoryOnboardingV4RolesQuestionRole = {
  __typename?: 'CategoryOnboardingV4RolesQuestionRole';
  id: Scalars['RoleId'];
  title: Scalars['String'];
};

export type CategoryOnboardingV4RolesQuestionRoleInput = {
  id: Scalars['RoleId'];
  title: Scalars['String'];
};

export type CategoryOnboardingV4RoomsQuestion = {
  __typename?: 'CategoryOnboardingV4RoomsQuestion';
  answer?: Maybe<CategoryOnboardingV4RoomsQuestionAnswer>;
  description?: Maybe<Scalars['String']>;
  payload: CategoryOnboardingV4RoomsQuestionPayload;
  title: Scalars['String'];
};

export type CategoryOnboardingV4RoomsQuestionAnswer = {
  __typename?: 'CategoryOnboardingV4RoomsQuestionAnswer';
  rooms: Array<CategoryOnboardingV4RoomsQuestionRoom>;
};

export type CategoryOnboardingV4RoomsQuestionAnswerInput = {
  rooms: CategoryOnboardingV4RoomsQuestionRoomInput;
};

export type CategoryOnboardingV4RoomsQuestionMutation = {
  __typename?: 'CategoryOnboardingV4RoomsQuestionMutation';
  answer: Array<CategoryOnboardingV4Category>;
};


export type CategoryOnboardingV4RoomsQuestionMutationanswerArgs = {
  answer: CategoryOnboardingV4RoomsQuestionAnswerInput;
  siteSetId: Scalars['SiteSetId'];
};

export type CategoryOnboardingV4RoomsQuestionPayload = {
  __typename?: 'CategoryOnboardingV4RoomsQuestionPayload';
  rooms: Array<CategoryOnboardingV4RoomsQuestionRoom>;
};

export type CategoryOnboardingV4RoomsQuestionRoom = CategoryOnboardingV4RoomsQuestionRoomDeleted | CategoryOnboardingV4RoomsQuestionRoomExistingEmpty | CategoryOnboardingV4RoomsQuestionRoomExistingNotEmpty | CategoryOnboardingV4RoomsQuestionRoomNew;

export type CategoryOnboardingV4RoomsQuestionRoomDeleted = {
  __typename?: 'CategoryOnboardingV4RoomsQuestionRoomDeleted';
  id: Scalars['GroupId'];
};

export type CategoryOnboardingV4RoomsQuestionRoomDeletedInput = {
  id: Scalars['GroupId'];
};

export type CategoryOnboardingV4RoomsQuestionRoomExistingEmpty = {
  __typename?: 'CategoryOnboardingV4RoomsQuestionRoomExistingEmpty';
  capacity?: Maybe<Scalars['Int']>;
  id: Scalars['GroupId'];
  name: Scalars['String'];
};

export type CategoryOnboardingV4RoomsQuestionRoomExistingEmptyInput = {
  capacity?: InputMaybe<Scalars['Int']>;
  id: Scalars['GroupId'];
  name: Scalars['String'];
};

export type CategoryOnboardingV4RoomsQuestionRoomExistingNotEmpty = {
  __typename?: 'CategoryOnboardingV4RoomsQuestionRoomExistingNotEmpty';
  capacity?: Maybe<Scalars['Int']>;
  id: Scalars['GroupId'];
  name: Scalars['String'];
};

export type CategoryOnboardingV4RoomsQuestionRoomExistingNotEmptyInput = {
  capacity?: InputMaybe<Scalars['Int']>;
  id: Scalars['GroupId'];
  name: Scalars['String'];
};

export type CategoryOnboardingV4RoomsQuestionRoomInput = {
  deleted: Array<CategoryOnboardingV4RoomsQuestionRoomDeletedInput>;
  existingEmpty: Array<CategoryOnboardingV4RoomsQuestionRoomExistingEmptyInput>;
  existingNotEmpty: Array<CategoryOnboardingV4RoomsQuestionRoomExistingNotEmptyInput>;
  new: Array<CategoryOnboardingV4RoomsQuestionRoomNewInput>;
};

export type CategoryOnboardingV4RoomsQuestionRoomNew = {
  __typename?: 'CategoryOnboardingV4RoomsQuestionRoomNew';
  capacity?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
};

export type CategoryOnboardingV4RoomsQuestionRoomNewInput = {
  capacity?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
};

export type CategoryOnboardingV4RoomsSection = {
  __typename?: 'CategoryOnboardingV4RoomsSection';
  currentQuestion?: Maybe<CategoryOnboardingV4Question>;
  id: SetupGuideSectionId;
  isCompleted: Scalars['Boolean'];
  questions: Array<CategoryOnboardingV4Question>;
  state: CategoryOnboardingV4SectionState;
  title: Scalars['String'];
};

export type CategoryOnboardingV4Section = CategoryOnboardingV4AutomaticInvoicingSection | CategoryOnboardingV4ChildPlansSection | CategoryOnboardingV4ChildrenSection | CategoryOnboardingV4CurriculumBuilderSection | CategoryOnboardingV4InvoiceLayoutSection | CategoryOnboardingV4InvoicingBasicsSection | CategoryOnboardingV4LearningBasicsSection | CategoryOnboardingV4PrivacySection | CategoryOnboardingV4RoomsSection | CategoryOnboardingV4SignInKioskSection | CategoryOnboardingV4SignInOptionsSection | CategoryOnboardingV4StaffSection | CategoryOnboardingV4WritingAssistanceSection | CategoryOnboardingV4YourNurserySection | CategoryOnboardingV4YourProfileSection;

export type CategoryOnboardingV4SectionState = CategoryOnboardingV4SectionStateCompleted | CategoryOnboardingV4SectionStateInProgress | CategoryOnboardingV4SectionStateNotStarted;

export type CategoryOnboardingV4SectionStateCompleted = {
  __typename?: 'CategoryOnboardingV4SectionStateCompleted';
  currentQuestion: CategoryOnboardingV4Question;
};

export type CategoryOnboardingV4SectionStateInProgress = {
  __typename?: 'CategoryOnboardingV4SectionStateInProgress';
  currentQuestion: CategoryOnboardingV4Question;
};

export type CategoryOnboardingV4SectionStateNotStarted = {
  __typename?: 'CategoryOnboardingV4SectionStateNotStarted';
  currentQuestion: CategoryOnboardingV4Question;
};

export type CategoryOnboardingV4SetUpInvoicingBasicsPayload = {
  __typename?: 'CategoryOnboardingV4SetUpInvoicingBasicsPayload';
  hasChildren: Scalars['Boolean'];
  hasSetupInvoicingBasics: Scalars['Boolean'];
};

export type CategoryOnboardingV4SetUpInvoicingBasicsQuestion = {
  __typename?: 'CategoryOnboardingV4SetUpInvoicingBasicsQuestion';
  description?: Maybe<Scalars['String']>;
  payload: CategoryOnboardingV4SetUpInvoicingBasicsPayload;
  title: Scalars['String'];
};

export type CategoryOnboardingV4SetupAddressForLocationBasedSignInQuestion = {
  __typename?: 'CategoryOnboardingV4SetupAddressForLocationBasedSignInQuestion';
  answer?: Maybe<CategoryOnboardingV4SetupAddressForLocationBasedSignInQuestionAnswer>;
  description?: Maybe<Scalars['String']>;
  payload: CategoryOnboardingV4SetupAddressForLocationBasedSignInQuestionPayload;
  title: Scalars['String'];
};

export type CategoryOnboardingV4SetupAddressForLocationBasedSignInQuestionAnswer = {
  __typename?: 'CategoryOnboardingV4SetupAddressForLocationBasedSignInQuestionAnswer';
  address: Address;
  position?: Maybe<Position>;
};

export type CategoryOnboardingV4SetupAddressForLocationBasedSignInQuestionAnswerInput = {
  address: AddressInput;
  position?: InputMaybe<PositionInput>;
};

export type CategoryOnboardingV4SetupAddressForLocationBasedSignInQuestionMutation = {
  __typename?: 'CategoryOnboardingV4SetupAddressForLocationBasedSignInQuestionMutation';
  answer: Array<CategoryOnboardingV4Category>;
};


export type CategoryOnboardingV4SetupAddressForLocationBasedSignInQuestionMutationanswerArgs = {
  answer: CategoryOnboardingV4SetupAddressForLocationBasedSignInQuestionAnswerInput;
  siteSetId: Scalars['SiteSetId'];
};

export type CategoryOnboardingV4SetupAddressForLocationBasedSignInQuestionPayload = {
  __typename?: 'CategoryOnboardingV4SetupAddressForLocationBasedSignInQuestionPayload';
  addressFormat: AddressFormat;
};

export type CategoryOnboardingV4SetupGuide = {
  __typename?: 'CategoryOnboardingV4SetupGuide';
  categories: Array<CategoryOnboardingV4Category>;
  progress: Scalars['Int'];
};

export type CategoryOnboardingV4ShouldParentsAndStaffUseTheSignInKioskQuestion = {
  __typename?: 'CategoryOnboardingV4ShouldParentsAndStaffUseTheSignInKioskQuestion';
  answer: CategoryOnboardingV4DoYouWantToUseTheSignInKioskQuestionAnswer;
  description?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type CategoryOnboardingV4ShouldParentsBeAbleToSendMessagesToOtherParentsQuestion = {
  __typename?: 'CategoryOnboardingV4ShouldParentsBeAbleToSendMessagesToOtherParentsQuestion';
  answer: CategoryOnboardingV4ShouldParentsBeAbleToSendMessagesToOtherParentsQuestionAnswer;
  description?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type CategoryOnboardingV4ShouldParentsBeAbleToSendMessagesToOtherParentsQuestionAnswer = {
  __typename?: 'CategoryOnboardingV4ShouldParentsBeAbleToSendMessagesToOtherParentsQuestionAnswer';
  shouldParentsBeAbleToSendMessagesToOtherParents: Scalars['Boolean'];
};

export type CategoryOnboardingV4ShouldParentsBeAbleToSendMessagesToOtherParentsQuestionAnswerInput = {
  shouldParentsBeAbleToSendMessagesToOtherParents: Scalars['Boolean'];
};

export type CategoryOnboardingV4ShouldParentsBeAbleToSendMessagesToOtherParentsQuestionMutation = {
  __typename?: 'CategoryOnboardingV4ShouldParentsBeAbleToSendMessagesToOtherParentsQuestionMutation';
  answer: Array<CategoryOnboardingV4Category>;
};


export type CategoryOnboardingV4ShouldParentsBeAbleToSendMessagesToOtherParentsQuestionMutationanswerArgs = {
  answer: CategoryOnboardingV4ShouldParentsBeAbleToSendMessagesToOtherParentsQuestionAnswerInput;
  siteSetId: Scalars['SiteSetId'];
};

export type CategoryOnboardingV4SignInKioskSection = {
  __typename?: 'CategoryOnboardingV4SignInKioskSection';
  currentQuestion?: Maybe<CategoryOnboardingV4Question>;
  id: SetupGuideSectionId;
  isCompleted: Scalars['Boolean'];
  questions: Array<CategoryOnboardingV4Question>;
  state: CategoryOnboardingV4SectionState;
  title: Scalars['String'];
};

export type CategoryOnboardingV4SignInOptionsSection = {
  __typename?: 'CategoryOnboardingV4SignInOptionsSection';
  currentQuestion?: Maybe<CategoryOnboardingV4Question>;
  id: SetupGuideSectionId;
  isCompleted: Scalars['Boolean'];
  questions: Array<CategoryOnboardingV4Question>;
  state: CategoryOnboardingV4SectionState;
  title: Scalars['String'];
};

export type CategoryOnboardingV4StaffQuestion = {
  __typename?: 'CategoryOnboardingV4StaffQuestion';
  description?: Maybe<Scalars['String']>;
  payload: CategoryOnboardingV4StaffQuestionPayload;
  title: Scalars['String'];
};

export type CategoryOnboardingV4StaffQuestionPayload = {
  __typename?: 'CategoryOnboardingV4StaffQuestionPayload';
  hasStaff: Scalars['Boolean'];
};

export type CategoryOnboardingV4StaffSection = {
  __typename?: 'CategoryOnboardingV4StaffSection';
  currentQuestion?: Maybe<CategoryOnboardingV4Question>;
  id: SetupGuideSectionId;
  isCompleted: Scalars['Boolean'];
  questions: Array<CategoryOnboardingV4Question>;
  state: CategoryOnboardingV4SectionState;
  title: Scalars['String'];
};

export type CategoryOnboardingV4StatementBasedTrackingQuestion = {
  __typename?: 'CategoryOnboardingV4StatementBasedTrackingQuestion';
  answer?: Maybe<CategoryOnboardingV4StatementBasedTrackingQuestionAnswer>;
  description?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type CategoryOnboardingV4StatementBasedTrackingQuestionAnswer = {
  __typename?: 'CategoryOnboardingV4StatementBasedTrackingQuestionAnswer';
  followsStatementBasedTracking: Scalars['Boolean'];
};

export type CategoryOnboardingV4StatementBasedTrackingQuestionAnswerInput = {
  followsStatementBasedTracking: Scalars['Boolean'];
};

export type CategoryOnboardingV4StatementBasedTrackingQuestionMutation = {
  __typename?: 'CategoryOnboardingV4StatementBasedTrackingQuestionMutation';
  answer: Array<CategoryOnboardingV4Category>;
};


export type CategoryOnboardingV4StatementBasedTrackingQuestionMutationanswerArgs = {
  answer: CategoryOnboardingV4StatementBasedTrackingQuestionAnswerInput;
  siteSetId: Scalars['SiteSetId'];
};

export type CategoryOnboardingV4WhatDeviceForYourSignInKioskQuestion = {
  __typename?: 'CategoryOnboardingV4WhatDeviceForYourSignInKioskQuestion';
  answer?: Maybe<CategoryOnboardingV4WhatDeviceForYourSignInKioskQuestionAnswer>;
  description?: Maybe<Scalars['String']>;
  payload: CategoryOnboardingV4WhatDeviceForYourSignInKioskQuestionPayload;
  title: Scalars['String'];
};

export type CategoryOnboardingV4WhatDeviceForYourSignInKioskQuestionAnswer = {
  __typename?: 'CategoryOnboardingV4WhatDeviceForYourSignInKioskQuestionAnswer';
  device: CategoryOnboardingWhatDeviceForYourSignInKioskQuestionAnswerDeviceWithLabel;
};

export type CategoryOnboardingV4WhatDeviceForYourSignInKioskQuestionAnswerInput = {
  device: CategoryOnboardingWhatDeviceForYourSignInKioskQuestionAnswerDevice;
};

export type CategoryOnboardingV4WhatDeviceForYourSignInKioskQuestionMutation = {
  __typename?: 'CategoryOnboardingV4WhatDeviceForYourSignInKioskQuestionMutation';
  answer: Array<CategoryOnboardingV4Category>;
};


export type CategoryOnboardingV4WhatDeviceForYourSignInKioskQuestionMutationanswerArgs = {
  answer: CategoryOnboardingV4WhatDeviceForYourSignInKioskQuestionAnswerInput;
  siteSetId: Scalars['SiteSetId'];
};

export type CategoryOnboardingV4WhatDeviceForYourSignInKioskQuestionPayload = {
  __typename?: 'CategoryOnboardingV4WhatDeviceForYourSignInKioskQuestionPayload';
  devices: Array<CategoryOnboardingWhatDeviceForYourSignInKioskQuestionAnswerDeviceWithLabel>;
};

export type CategoryOnboardingV4WhenShouldYourStaffBeAutomaticallyLoggedOutQuestion = {
  __typename?: 'CategoryOnboardingV4WhenShouldYourStaffBeAutomaticallyLoggedOutQuestion';
  answer?: Maybe<CategoryOnboardingV4WhenShouldYourStaffBeAutomaticallyLoggedOutQuestionAnswer>;
  description?: Maybe<Scalars['String']>;
  payload: CategoryOnboardingV4WhenShouldYourStaffBeAutomaticallyLoggedOutQuestionPayload;
  title: Scalars['String'];
};

export type CategoryOnboardingV4WhenShouldYourStaffBeAutomaticallyLoggedOutQuestionAnswer = {
  __typename?: 'CategoryOnboardingV4WhenShouldYourStaffBeAutomaticallyLoggedOutQuestionAnswer';
  roles: Array<CategoryOnboardingV4WhenShouldYourStaffBeAutomaticallyLoggedOutQuestionRoleWithAutoLogoutSettings>;
};

export type CategoryOnboardingV4WhenShouldYourStaffBeAutomaticallyLoggedOutQuestionAnswerInput = {
  roles: Array<CategoryOnboardingV4WhenShouldYourStaffBeAutomaticallyLoggedOutQuestionRoleWithAutoLogoutSettingsInput>;
};

export type CategoryOnboardingV4WhenShouldYourStaffBeAutomaticallyLoggedOutQuestionMutation = {
  __typename?: 'CategoryOnboardingV4WhenShouldYourStaffBeAutomaticallyLoggedOutQuestionMutation';
  answer: Array<CategoryOnboardingV4Category>;
};


export type CategoryOnboardingV4WhenShouldYourStaffBeAutomaticallyLoggedOutQuestionMutationanswerArgs = {
  answer: CategoryOnboardingV4WhenShouldYourStaffBeAutomaticallyLoggedOutQuestionAnswerInput;
  siteSetId: Scalars['SiteSetId'];
};

export type CategoryOnboardingV4WhenShouldYourStaffBeAutomaticallyLoggedOutQuestionPayload = {
  __typename?: 'CategoryOnboardingV4WhenShouldYourStaffBeAutomaticallyLoggedOutQuestionPayload';
  autoLogoutOptions: Array<CategoryOnboardingV4WhenShouldYourStaffBeAutomaticallyLoggedOutQuestionPayloadAutoLogoutOptionCollection>;
  roles: Array<CategoryOnboardingV4WhenShouldYourStaffBeAutomaticallyLoggedOutQuestionRoleWithAutoLogoutSettings>;
};

export type CategoryOnboardingV4WhenShouldYourStaffBeAutomaticallyLoggedOutQuestionPayloadAutoLogoutOptionCollection = {
  __typename?: 'CategoryOnboardingV4WhenShouldYourStaffBeAutomaticallyLoggedOutQuestionPayloadAutoLogoutOptionCollection';
  items: Array<CategoryOnboardingV4WhenShouldYourStaffBeAutomaticallyLoggedOutQuestionPayloadAutoLogoutOptionItem>;
  roleId: Scalars['RoleId'];
};

export type CategoryOnboardingV4WhenShouldYourStaffBeAutomaticallyLoggedOutQuestionPayloadAutoLogoutOptionItem = {
  __typename?: 'CategoryOnboardingV4WhenShouldYourStaffBeAutomaticallyLoggedOutQuestionPayloadAutoLogoutOptionItem';
  autoLogoutAfterSeconds: Scalars['Int'];
  isRecommended: Scalars['Boolean'];
  label: Scalars['String'];
};

export type CategoryOnboardingV4WhenShouldYourStaffBeAutomaticallyLoggedOutQuestionRoleWithAutoLogoutSettings = {
  __typename?: 'CategoryOnboardingV4WhenShouldYourStaffBeAutomaticallyLoggedOutQuestionRoleWithAutoLogoutSettings';
  autoLogoutAfterSeconds: Scalars['Int'];
  id: Scalars['RoleId'];
  isManagerRole: Scalars['Boolean'];
  title: Scalars['String'];
};

export type CategoryOnboardingV4WhenShouldYourStaffBeAutomaticallyLoggedOutQuestionRoleWithAutoLogoutSettingsInput = {
  autoLogoutAfterSeconds: Scalars['Int'];
  id: Scalars['RoleId'];
  title: Scalars['String'];
};

export type CategoryOnboardingV4WhoShouldSeeSeenByReceiptsQuestion = {
  __typename?: 'CategoryOnboardingV4WhoShouldSeeSeenByReceiptsQuestion';
  answer?: Maybe<CategoryOnboardingV4WhoShouldSeeSeenByReceiptsQuestionAnswer>;
  description?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type CategoryOnboardingV4WhoShouldSeeSeenByReceiptsQuestionAnswer = {
  __typename?: 'CategoryOnboardingV4WhoShouldSeeSeenByReceiptsQuestionAnswer';
  canParentsSeeIfStaffReadTheirMessage: Scalars['Boolean'];
  canStaffSeeIfManagerReadTheirMessage: Scalars['Boolean'];
};

export type CategoryOnboardingV4WhoShouldSeeSeenByReceiptsQuestionAnswerInput = {
  canParentsSeeIfStaffReadTheirMessage: Scalars['Boolean'];
  canStaffSeeIfManagerReadTheirMessage: Scalars['Boolean'];
};

export type CategoryOnboardingV4WhoShouldSeeSeenByReceiptsQuestionMutation = {
  __typename?: 'CategoryOnboardingV4WhoShouldSeeSeenByReceiptsQuestionMutation';
  answer: Array<CategoryOnboardingV4Category>;
};


export type CategoryOnboardingV4WhoShouldSeeSeenByReceiptsQuestionMutationanswerArgs = {
  answer: CategoryOnboardingV4WhoShouldSeeSeenByReceiptsQuestionAnswerInput;
  siteSetId: Scalars['SiteSetId'];
};

export type CategoryOnboardingV4WhoShouldSignChildrenInAndOutQuestion = {
  __typename?: 'CategoryOnboardingV4WhoShouldSignChildrenInAndOutQuestion';
  answer: CategoryOnboardingV4WhoShouldSignChildrenInAndOutQuestionAnswer;
  description?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type CategoryOnboardingV4WhoShouldSignChildrenInAndOutQuestionAnswer = {
  __typename?: 'CategoryOnboardingV4WhoShouldSignChildrenInAndOutQuestionAnswer';
  parentsCanSignChildrenInAndOut: Scalars['Boolean'];
};

export type CategoryOnboardingV4WhoShouldSignChildrenInAndOutQuestionMutation = {
  __typename?: 'CategoryOnboardingV4WhoShouldSignChildrenInAndOutQuestionMutation';
  answer: Array<CategoryOnboardingV4Category>;
};


export type CategoryOnboardingV4WhoShouldSignChildrenInAndOutQuestionMutationanswerArgs = {
  doYouWantParentsToSignChildrenInAndOut: Scalars['Boolean'];
  siteSetId: Scalars['SiteSetId'];
};

export type CategoryOnboardingV4WritingAssistanceSection = {
  __typename?: 'CategoryOnboardingV4WritingAssistanceSection';
  currentQuestion?: Maybe<CategoryOnboardingV4Question>;
  id: SetupGuideSectionId;
  isCompleted: Scalars['Boolean'];
  questions: Array<CategoryOnboardingV4Question>;
  state: CategoryOnboardingV4SectionState;
  title: Scalars['String'];
};

export type CategoryOnboardingV4YourNurserySection = {
  __typename?: 'CategoryOnboardingV4YourNurserySection';
  currentQuestion?: Maybe<CategoryOnboardingV4Question>;
  id: SetupGuideSectionId;
  isCompleted: Scalars['Boolean'];
  questions: Array<CategoryOnboardingV4Question>;
  state: CategoryOnboardingV4SectionState;
  title: Scalars['String'];
};

export type CategoryOnboardingV4YourProfileSection = {
  __typename?: 'CategoryOnboardingV4YourProfileSection';
  currentQuestion?: Maybe<CategoryOnboardingV4Question>;
  id: SetupGuideSectionId;
  isCompleted: Scalars['Boolean'];
  questions: Array<CategoryOnboardingV4Question>;
  state: CategoryOnboardingV4SectionState;
  title: Scalars['String'];
};

export type CategoryOnboardingV4YourQRCodeIsReadyQuestion = {
  __typename?: 'CategoryOnboardingV4YourQRCodeIsReadyQuestion';
  description?: Maybe<Scalars['String']>;
  payload: CategoryOnboardingV4YourQRCodeIsReadyQuestionPayload;
  title: Scalars['String'];
};

export type CategoryOnboardingV4YourQRCodeIsReadyQuestionPayload = {
  __typename?: 'CategoryOnboardingV4YourQRCodeIsReadyQuestionPayload';
  qrSecret: CategoryOnboardingV4YourQRCodeIsReadyQuestionQRSecret;
  site: CategoryOnboardingV4YourQRCodeIsReadyQuestionSite;
};

export type CategoryOnboardingV4YourQRCodeIsReadyQuestionQRSecret = {
  __typename?: 'CategoryOnboardingV4YourQRCodeIsReadyQuestionQRSecret';
  secret: Scalars['String'];
  validFrom: Scalars['ZonedDateTime'];
};

export type CategoryOnboardingV4YourQRCodeIsReadyQuestionSite = {
  __typename?: 'CategoryOnboardingV4YourQRCodeIsReadyQuestionSite';
  profileImage?: Maybe<ProfileImage>;
  title: Scalars['String'];
};

export enum CategoryOnboardingWhatDeviceForYourSignInKioskQuestionAnswerDevice {
  AmazonFire = 'AmazonFire',
  Huawei = 'Huawei',
  Lenovo = 'Lenovo',
  Other = 'Other',
  Samsung = 'Samsung',
  iPad = 'iPad'
}

export type CategoryOnboardingWhatDeviceForYourSignInKioskQuestionAnswerDeviceWithLabel = {
  __typename?: 'CategoryOnboardingWhatDeviceForYourSignInKioskQuestionAnswerDeviceWithLabel';
  label: Scalars['String'];
  name: CategoryOnboardingWhatDeviceForYourSignInKioskQuestionAnswerDevice;
};

export type ChallengeAnsweredResult = AuthenticationFailed | AuthenticationSucceeded;

/** CheckIn time info of a staff member */
export type CheckIn = {
  __typename?: 'CheckIn';
  timeInfo: AttendanceTimeInfo;
};

/** Sign-in statements that must be confirmed by the user before sign-in, e.g. health-related checks */
export type CheckInStatementResult = {
  __typename?: 'CheckInStatementResult';
  statementId: Scalars['CheckInStatementId'];
  statementType: StatementType;
  title: Scalars['String'];
};

/** CheckOut times of a staff member */
export type CheckOut = {
  __typename?: 'CheckOut';
  doneAutomatically: Scalars['Boolean'];
  timeInfo: AttendanceTimeInfo;
};

export type CheckinOpeningHoursClosedResult = CheckinOpeningHoursResult & {
  __typename?: 'CheckinOpeningHoursClosedResult';
  day: Scalars['Int'];
};

export type CheckinOpeningHoursOpenResult = CheckinOpeningHoursResult & {
  __typename?: 'CheckinOpeningHoursOpenResult';
  day: Scalars['Int'];
  from: Scalars['LocalTime'];
  to: Scalars['LocalTime'];
};

export type CheckinOpeningHoursResult = {
  day: Scalars['Int'];
};

export type Child = {
  __typename?: 'Child';
  allergies: AllergiesResult;
  birthday?: Maybe<Scalars['LocalDate']>;
  birthplace?: Maybe<Scalars['String']>;
  /** Contacts for the child */
  contacts: Array<Contact>;
  endDate?: Maybe<Scalars['LocalDate']>;
  extraInfo?: Maybe<Scalars['String']>;
  gender?: Maybe<Gender>;
  group?: Maybe<Group>;
  groupId?: Maybe<Scalars['GroupId']>;
  groups: Array<GroupMove>;
  id: Scalars['ChildId'];
  institutionId: Scalars['InstitutionId'];
  isTestChild: Scalars['Boolean'];
  language: Scalars['String'];
  locale: Scalars['Locale'];
  name: Name;
  nationality?: Maybe<Scalars['String']>;
  /** Notes for the child */
  notes: Array<ChildNote>;
  /** The primary funding relation for this child */
  primaryFundingRelation?: Maybe<Relation>;
  profileImage?: Maybe<ProfileImage>;
  /**
   * The relations for this child
   * @deprecated Use `contacts` instead
   */
  relations: Array<Relation>;
  siblings: Array<SiblingLink>;
  startDate: Scalars['LocalDate'];
  states: Array<RuleStatePeriod>;
  status: ChildStatus;
  zoneId: Scalars['ZoneId'];
};


export type ChildnotesArgs = {
  childNoteIds?: InputMaybe<Array<Scalars['ChildNoteId']>>;
};


export type ChildstatesArgs = {
  from?: InputMaybe<Scalars['LocalDate']>;
  namespace?: InputMaybe<RuleNamespace>;
  to?: InputMaybe<Scalars['LocalDate']>;
};

export type ChildAbsenceCount = {
  __typename?: 'ChildAbsenceCount';
  count: Scalars['Int'];
  leaveType: LeaveType;
};

export type ChildAttendanceReport = AttendanceSummary & {
  __typename?: 'ChildAttendanceReport';
  child: Child;
  slots: Array<AttendanceSlot>;
  stats: AttendanceStats;
};


export type ChildAttendanceReportslotsArgs = {
  buckets?: InputMaybe<Array<ClosedLocalTimeRange>>;
};

export type ChildAttendanceStatus = {
  __typename?: 'ChildAttendanceStatus';
  child: Child;
  isExpected: Scalars['Boolean'];
  statuses: Array<AttendanceStatus>;
};


export type ChildAttendanceStatusisExpectedArgs = {
  filter?: InputMaybe<Array<AttendanceStatusFilter>>;
};


export type ChildAttendanceStatusstatusesArgs = {
  filter?: InputMaybe<Array<AttendanceStatusFilter>>;
};

/** Mutations specific to child based funding, like reports, exports, etc. */
export type ChildBasedFundingMutations = {
  __typename?: 'ChildBasedFundingMutations';
  /** Trigger Child Based Funding CSV export. Returns the status of export */
  triggerCsvExport: FinanceFileExport;
};


/** Mutations specific to child based funding, like reports, exports, etc. */
export type ChildBasedFundingMutationstriggerCsvExportArgs = {
  fundingState?: InputMaybe<FundingState>;
  fundingTypeId?: InputMaybe<Scalars['FundingTypeId']>;
  range?: InputMaybe<ClosedLocalDateRange>;
  siteSetId: Scalars['SiteSetId'];
};

/** Queries specific to child based funding, like reports, exports, etc. */
export type ChildBasedFundingQueries = {
  __typename?: 'ChildBasedFundingQueries';
  report: ChildBasedFundingReportPagination;
};


/** Queries specific to child based funding, like reports, exports, etc. */
export type ChildBasedFundingQueriesreportArgs = {
  funding?: InputMaybe<Scalars['FundingTypeId']>;
  fundingState?: InputMaybe<FundingState>;
  nextToken?: InputMaybe<Scalars['ChildBasedFundingReportCursor']>;
  range?: InputMaybe<ClosedLocalDateRange>;
  siteSetId: Scalars['SiteSetId'];
};

/** Lines from a single page of the child based funding report and aggregated statistics from the whole report/all of the pages. */
export type ChildBasedFundingReport = {
  __typename?: 'ChildBasedFundingReport';
  lines: Array<FundingReportRow>;
  numberOfChildren: Scalars['Int'];
};

/** Contains a page from the child based funding report results and a cursor to the next page. */
export type ChildBasedFundingReportPagination = {
  __typename?: 'ChildBasedFundingReportPagination';
  next?: Maybe<Scalars['ChildBasedFundingReportCursor']>;
  results: ChildBasedFundingReport;
};

export type ChildCheckinsQueryType = {
  __typename?: 'ChildCheckinsQueryType';
  /** Returns status of checkin for given child (true if checked in right now) */
  status: Scalars['Boolean'];
};


export type ChildCheckinsQueryTypestatusArgs = {
  childId: Scalars['ChildId'];
};

export type ChildContactAccessResponse = {
  __typename?: 'ChildContactAccessResponse';
  canAccess?: Maybe<Scalars['Boolean']>;
  canUpdate: Scalars['Boolean'];
};

export type ChildContactRoleInvitation = RoleInvitation & {
  __typename?: 'ChildContactRoleInvitation';
  /** @deprecated Use field childName instead. */
  childFirstName: Scalars['String'];
  childName: Name;
  childProfileImage?: Maybe<ProfileImage>;
  contactFirstName: Scalars['String'];
  privacyPolicyLink?: Maybe<Scalars['String']>;
  relationId: Scalars['RelationId'];
  roleId: Scalars['RoleId'];
  roleInvitationId: Scalars['RoleInvitationId'];
  roleTitle: Scalars['String'];
  siteTitle: Scalars['String'];
  verification: RoleInvitationVerification;
};

export type ChildContactsFields = {
  __typename?: 'ChildContactsFields';
  emergencyContact: FieldPermission;
};

/** Input for creating a child */
export type ChildCreationInput = {
  allergies?: InputMaybe<Scalars['String']>;
  birthDate?: InputMaybe<Scalars['LocalDate']>;
  birthplace?: InputMaybe<Scalars['String']>;
  dietaryRequirements?: InputMaybe<Scalars['String']>;
  doctorCity?: InputMaybe<Scalars['String']>;
  doctorCountry?: InputMaybe<Scalars['String']>;
  doctorName?: InputMaybe<Scalars['String']>;
  doctorPhone?: InputMaybe<Scalars['String']>;
  doctorState?: InputMaybe<Scalars['String']>;
  doctorStreet?: InputMaybe<Scalars['String']>;
  doctorZip?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['LocalDate']>;
  ethnicity?: InputMaybe<Scalars['String']>;
  extraInfo?: InputMaybe<Scalars['String']>;
  foreignId?: InputMaybe<Scalars['String']>;
  foreignIdReference?: InputMaybe<ForeignIdReferenceInput>;
  gender?: InputMaybe<Gender>;
  group: GroupImportInput;
  healthSpecialNotes?: InputMaybe<Scalars['String']>;
  institutionId: Scalars['InstitutionId'];
  isTestChild?: InputMaybe<Scalars['Boolean']>;
  language?: InputMaybe<Scalars['String']>;
  name: Scalars['NameInput'];
  nationality?: InputMaybe<Scalars['String']>;
  race?: InputMaybe<Scalars['String']>;
  religion?: InputMaybe<Scalars['String']>;
  socialSecurityNumber?: InputMaybe<Scalars['String']>;
  startDate: Scalars['LocalDate'];
};

/** Data to create a child */
export type ChildCreationInputResult = {
  __typename?: 'ChildCreationInputResult';
  allergies?: Maybe<Scalars['String']>;
  birthDate?: Maybe<Scalars['LocalDate']>;
  birthplace?: Maybe<Scalars['String']>;
  dietaryRequirements?: Maybe<Scalars['String']>;
  doctorCity?: Maybe<Scalars['String']>;
  doctorCountry?: Maybe<Scalars['String']>;
  doctorName?: Maybe<Scalars['String']>;
  doctorPhone?: Maybe<Scalars['String']>;
  doctorState?: Maybe<Scalars['String']>;
  doctorStreet?: Maybe<Scalars['String']>;
  doctorZip?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['LocalDate']>;
  ethnicity?: Maybe<Scalars['String']>;
  extraInfo?: Maybe<Scalars['String']>;
  /** @deprecated Use foreignIdReference */
  foreignId?: Maybe<Scalars['String']>;
  foreignIdReference?: Maybe<ForeignIdReference>;
  gender?: Maybe<Gender>;
  group: GroupImport;
  healthSpecialNotes?: Maybe<Scalars['String']>;
  institutionId: Scalars['InstitutionId'];
  isTestChild?: Maybe<Scalars['Boolean']>;
  language?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  nationality?: Maybe<Scalars['String']>;
  race?: Maybe<Scalars['String']>;
  religion?: Maybe<Scalars['String']>;
  socialSecurityNumber?: Maybe<Scalars['String']>;
  startDate: Scalars['LocalDate'];
};

/** Output for creating a child */
export type ChildCreationResult = {
  __typename?: 'ChildCreationResult';
  /** @deprecated Use the address field in the relation import result */
  address?: Maybe<Address>;
  birthDate?: Maybe<Scalars['LocalDate']>;
  birthplace?: Maybe<Scalars['String']>;
  /** A ChildId is generated if a child is created with preview set to false */
  childId?: Maybe<Scalars['ChildId']>;
  endDate?: Maybe<Scalars['LocalDate']>;
  errors: Array<ImportError>;
  foreignIdReference?: Maybe<ForeignIdReference>;
  gender?: Maybe<Gender>;
  group?: Maybe<Group>;
  groupInfo: GroupImport;
  institutionId: Scalars['InstitutionId'];
  language?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  nationality?: Maybe<Scalars['String']>;
  socialSecurityNumber?: Maybe<Scalars['String']>;
  startDate: Scalars['LocalDate'];
};

export type ChildDateOfBirthVerification = RoleInvitationVerification & {
  __typename?: 'ChildDateOfBirthVerification';
  childFirstName: Scalars['String'];
  verificationMethod: RoleInvitationVerificationMethod;
};

/** Objects related to child development */
export type ChildDevelopment = {
  __typename?: 'ChildDevelopment';
  activities: ActivityField;
  availableReportHeaders: AvailableReportHeaders;
  /** Possible behaviors */
  behaviors: Array<Behavior>;
  curriculums: Curriculums;
  frameworkSettings: FrameworkSettings;
  /** If no arguments are given, returns all frameworks without duplicates available to all nurseries the user has access to */
  frameworks: Array<Framework>;
  lessonPlans: LessonPlans;
  /** Retrieves observations based on filters. One or more of `observationIds`, `childIds`, `institutionIds`, or `authors` must be provided. Note: Permission checks may filter out some results, leading to fewer returned observations than requested. Use the `next` cursor to retrieve next pages if exact number of observations is required. */
  observations: ObservationResult;
  organizationCoverage: Array<CoverageReport>;
  periodPlans: PeriodPlan;
  progress: Array<ChildDevelopmentProgress>;
};


/** Objects related to child development */
export type ChildDevelopmentbehaviorsArgs = {
  childId: Scalars['ChildId'];
};


/** Objects related to child development */
export type ChildDevelopmentframeworksArgs = {
  ids?: InputMaybe<Array<Scalars['FrameworkId']>>;
  title?: InputMaybe<Scalars['String']>;
};


/** Objects related to child development */
export type ChildDevelopmentobservationsArgs = {
  after?: InputMaybe<Scalars['ObservationCursor']>;
  areaIds?: InputMaybe<Array<Scalars['AreaId']>>;
  asOfDate?: InputMaybe<Scalars['LocalDate']>;
  authors?: InputMaybe<Array<Scalars['LoginId']>>;
  childIds?: InputMaybe<Array<Scalars['ChildId']>>;
  during?: InputMaybe<ClosedLocalDateRange>;
  first: Scalars['Int'];
  groupIds?: InputMaybe<Array<Scalars['GroupId']>>;
  ignoreMissing?: InputMaybe<Scalars['Boolean']>;
  institutionIds?: InputMaybe<Array<Scalars['InstitutionId']>>;
  nextStep?: InputMaybe<Scalars['Boolean']>;
  nextStepStatuses?: InputMaybe<Array<ObservationRemarkStatus>>;
  observationIds?: InputMaybe<Array<Scalars['ObservationId']>>;
  observedAfter?: InputMaybe<Scalars['LocalDate']>;
  observedBefore?: InputMaybe<Scalars['LocalDate']>;
  ordering?: InputMaybe<ObservationOrdering>;
  preview?: InputMaybe<Scalars['Boolean']>;
  statuses?: InputMaybe<Array<ObservationStatusState>>;
  variants?: InputMaybe<Array<ObservationVariant>>;
};


/** Objects related to child development */
export type ChildDevelopmentorganizationCoverageArgs = {
  institutionSetId: Scalars['InstitutionSetId'];
  range: ClosedLocalDateRange;
  variants: Array<ObservationVariant>;
};


/** Objects related to child development */
export type ChildDevelopmentprogressArgs = {
  asOf?: InputMaybe<Scalars['LocalDate']>;
  assessmentSettingId?: InputMaybe<Scalars['AssessmentSettingsId']>;
  bornAfter?: InputMaybe<Scalars['LocalDate']>;
  bornBefore?: InputMaybe<Scalars['LocalDate']>;
  childIds?: InputMaybe<Array<Scalars['ChildId']>>;
  frameworkId?: InputMaybe<Scalars['FrameworkId']>;
  gender?: InputMaybe<Gender>;
  groupIds?: InputMaybe<Array<Scalars['GroupId']>>;
  institutionId?: InputMaybe<Scalars['InstitutionId']>;
  limit?: InputMaybe<Scalars['Int']>;
  observedAfter?: InputMaybe<Scalars['LocalDate']>;
  offset?: InputMaybe<Scalars['Int']>;
  primaryKeyWorkerIds?: InputMaybe<Array<Scalars['EmployeeId']>>;
  reportConfigId?: InputMaybe<Scalars['ReportConfigId']>;
  tagIds?: InputMaybe<Array<Scalars['TagId']>>;
  variants?: InputMaybe<Array<ObservationVariant>>;
};

/** Represents a link to a specific area. */
export type ChildDevelopmentAreaLink = {
  __typename?: 'ChildDevelopmentAreaLink';
  assessmentSettings?: Maybe<ChildDevelopmentAreaRefinementSettings>;
  createdAt: Scalars['LocalDate'];
  observationId: Scalars['ObservationId'];
  refinement: Refinement;
};

export type ChildDevelopmentAreaProgress = {
  __typename?: 'ChildDevelopmentAreaProgress';
  /**
   *
   *  Contains information about all the area level assessments that have been made
   *  for the given child
   *
   */
  allLinks: Array<ChildDevelopmentAreaLink>;
  area: Area;
  /** Shows the overall completion for the child in the given area */
  completion?: Maybe<Scalars['Float']>;
  /** Convenience field, simply takes the last element of ChildDevelopmentAreaProgress.allLinks. */
  earliestLink?: Maybe<ChildDevelopmentAreaLink>;
  /** Convenience field, simply takes the head of ChildDevelopmentAreaProgress.allLinks. */
  latestLink?: Maybe<ChildDevelopmentAreaLink>;
  /**
   *
   *  Contains all the statements that have been linked to in observations made for the
   *  child in the given area.
   *
   *  If a statement has been linked to multiple times it will occur once in the list,
   *  but the [[ChildDevelopmentProgressLinkedStatement]] contains a reference to all the
   *  links that have been made.
   *
   */
  linkedStatements: Array<ChildDevelopmentProgressLinkedStatement>;
  progressAssessment?: Maybe<ChildDevelopmentProgressAssessment>;
  /** @deprecated Please use latestLink instead */
  refinement?: Maybe<Refinement>;
  subAreaProgress: Array<ChildDevelopmentAreaProgress>;
};


export type ChildDevelopmentAreaProgresssubAreaProgressArgs = {
  filter?: InputMaybe<ChildDevelopmentFilter>;
};

export type ChildDevelopmentAreaRefinement = {
  __typename?: 'ChildDevelopmentAreaRefinement';
  area: Area;
  areaRefinementSettings?: Maybe<ChildDevelopmentAreaRefinementSettings>;
  note?: Maybe<Scalars['String']>;
  refinement?: Maybe<Refinement>;
};

export type ChildDevelopmentAreaRefinementInput = {
  areaId: Scalars['AreaId'];
  areaRefinementSettings?: InputMaybe<ChildDevelopmentAreaRefinementSettingsInput>;
  note?: InputMaybe<Scalars['String']>;
  refinement?: InputMaybe<Refinement>;
};

export type ChildDevelopmentAreaRefinementSettings = {
  __typename?: 'ChildDevelopmentAreaRefinementSettings';
  ageBandSetting?: Maybe<AgeBandSetting>;
  assessmentOptionSetting?: Maybe<AssessmentOptionSetting>;
};

export type ChildDevelopmentAreaRefinementSettingsInput = {
  ageBandSettingId?: InputMaybe<Scalars['AgeBandSettingId']>;
  assessmentOptionSettingId?: InputMaybe<Scalars['AssessmentOptionSettingId']>;
};

/** These filters are used to select which sub-areas to include for a given area */
export enum ChildDevelopmentFilter {
  /**
   *
   *  Out of the areas that contain refinements on the `area` level select the one with the
   *  earliest refinement.
   *
   */
  EarliestRefinement = 'EarliestRefinement',
  /**
   *
   *  Out of the areas that contains linked statements this filter selects the one with the
   *  highest 'lower' value.
   *
   */
  HighestAgeBand = 'HighestAgeBand',
  /**
   *
   *  Out of the areas that contain refinements on the `area` level select the one with the most
   *  recent refinement.
   *
   */
  LatestRefinement = 'LatestRefinement',
  /**
   *
   *  Out of the areas that contains some, but not all, linked statements this filter selects
   *  the one with the lowest `placement` value.
   *
   *  In the edge case where there are only areas with either 100% or 0% we select the highest
   *  area with 100% completion
   *
   *
   */
  LowestUncompletedAgeBand = 'LowestUncompletedAgeBand',
  /** Don't apply any filters - return all sub-areas. */
  NoFilter = 'NoFilter'
}

/** Objects related to mutating child development */
export type ChildDevelopmentMutation = {
  __typename?: 'ChildDevelopmentMutation';
  activities: ActivityMutation;
  curriculums: CurriculumsMutation;
  frameworkSettings: FrameworkSettingsMutation;
  lessonPlans: LessonPlansMutationType;
  observations: ObservationMutation;
  /** Mutations related to Period Plans */
  periodPlans: PeriodPlanMutations;
};

export type ChildDevelopmentObservationRemark = {
  __typename?: 'ChildDevelopmentObservationRemark';
  areas: Array<ChildDevelopmentAreaRefinement>;
  body: Scalars['String'];
  customFieldValues: Array<CustomFieldValue>;
  date?: Maybe<Scalars['LocalDate']>;
  id: Scalars['RemarkId'];
  richTextBody?: Maybe<Scalars['String']>;
  statements: Array<ChildDevelopmentStatementRefinement>;
  status?: Maybe<ObservationRemarkStatus>;
};

export type ChildDevelopmentProgress = {
  __typename?: 'ChildDevelopmentProgress';
  areaProgress: Array<ChildDevelopmentAreaProgress>;
  /** Gets the area reports matching the report config given. */
  areaReports: Array<AreaReport>;
  child: Child;
  observationCount: ObservationCountInfo;
  /**
   * Gets the progress of the child. Note this will only be filled if the report was fetched with a valid reportConfigId.
   * @deprecated Use areaReports instead.
   */
  progress: Array<Progress>;
};

/** The assessment of the child's progress */
export enum ChildDevelopmentProgressAssessment {
  Ahead = 'Ahead',
  Behind = 'Behind',
  NoObservations = 'NoObservations',
  NotApplicable = 'NotApplicable',
  OnTrack = 'OnTrack',
  SlightlyAhead = 'SlightlyAhead',
  SlightlyBehind = 'SlightlyBehind'
}

/**
 *
 * Contains information about all links that have been made to this a specific statement for
 * a given child.
 *
 */
export type ChildDevelopmentProgressLinkedStatement = {
  __typename?: 'ChildDevelopmentProgressLinkedStatement';
  /**
   *
   *  A list of all the links that have been made to this statement for the given child.
   *  The list is sorted in descending order based on when the observation that contains
   *  the link was created.
   *
   *
   */
  allLinks: Array<ChildDevelopmentProgressStatementLink>;
  /** The most recent link that was made to this statement for the child. */
  latestLink: ChildDevelopmentProgressStatementLink;
  statement: Statement;
};

export type ChildDevelopmentProgressStatementLink = {
  __typename?: 'ChildDevelopmentProgressStatementLink';
  /** The portion of the overall area completion that is attributed to this single statement. */
  completion: Scalars['Float'];
  /** @deprecated Use `date` instead */
  createdAt: Scalars['ZonedDateTime'];
  /** The date of observation */
  date: Scalars['LocalDate'];
  observationId: Scalars['ObservationId'];
  refinement?: Maybe<Refinement>;
};

export type ChildDevelopmentRemarkInput = {
  areas: Array<ChildDevelopmentAreaRefinementInput>;
  body?: InputMaybe<Scalars['String']>;
  customFieldValues?: InputMaybe<Array<CustomFieldValueInput>>;
  date?: InputMaybe<Scalars['LocalDate']>;
  richTextBody?: InputMaybe<Scalars['String']>;
  statements: Array<ChildDevelopmentStatementRefinementInput>;
};

export type ChildDevelopmentReportHeader = {
  __typename?: 'ChildDevelopmentReportHeader';
  areaConfigs: Array<AreaConfig>;
  assessmentSetting?: Maybe<AssessmentSettings>;
  curriculumId: Scalars['FrameworkId'];
  name: Scalars['String'];
  reportConfigId: Scalars['ReportConfigId'];
  type: ReportConfigType;
  variantFilters: Array<ObservationVariantFilter>;
};

export type ChildDevelopmentStatementRefinement = {
  __typename?: 'ChildDevelopmentStatementRefinement';
  refinement?: Maybe<Refinement>;
  statement: Statement;
};

export type ChildDevelopmentStatementRefinementInput = {
  refinement?: InputMaybe<Refinement>;
  statementId: Scalars['StatementId'];
};

/** For mutating child leaves */
export type ChildLeaveMutations = {
  __typename?: 'ChildLeaveMutations';
  /** Create or update children's leave */
  updateLeaves: Array<ChildLeaveUpdateResult>;
};


/** For mutating child leaves */
export type ChildLeaveMutationsupdateLeavesArgs = {
  data: Array<ChildLeaveUpdateType>;
};

/** The result of updating child leaves */
export type ChildLeaveUpdateResult = {
  __typename?: 'ChildLeaveUpdateResult';
  child: Child;
  leaveStatus: Scalars['String'];
  /** This will be undefined if feature MealBookings is not enabled. Otherwise, this will be the number of meal bookings that were updated */
  updatedMeals?: Maybe<Scalars['Int']>;
};

/** Input for updating a child leave */
export type ChildLeaveUpdateType = {
  /** The id of the child */
  childId: Scalars['ChildId'];
  /** The type of leave */
  leaveType: LeaveType;
  /** What should happen with meal bookings, if exists */
  mealBookingManagementOnLeave?: InputMaybe<MealBookingManagementOnLeaveInput>;
  /** The range of the leave */
  range: ClosedLocalDateRange;
  /** The reason for the leave */
  reason?: InputMaybe<Scalars['String']>;
};

export type ChildLimitedInfo = {
  __typename?: 'ChildLimitedInfo';
  id: Scalars['ChildId'];
  name: Name;
  profileImage?: Maybe<ProfileImage>;
  /** The relations for this child */
  relations: Array<RelationLimitedInfo>;
  siteId: Scalars['SiteId'];
  zoneId: Scalars['ZoneId'];
};

/** Media tag allowance for children */
export type ChildMediaTagAllowance = {
  __typename?: 'ChildMediaTagAllowance';
  allowance: ReplyStatus;
  child: Child;
};

/** Objects related to mutating children */
export type ChildMutation = {
  __typename?: 'ChildMutation';
  /** Acknowledges the child note for the current user. */
  acknowledge: ChildNoteSignature;
  /** Allows creation of internal OR external siblings, but not both. */
  addSibling: SiblingLink;
  /** Cancel a group move. */
  cancelGroupMove: Array<GroupMove>;
  /**
   * Create a list of import objects
   * @deprecated Use field `import` instead
   */
  create: Array<ImportObjectResult>;
  createChildNote: ChildNote;
  deleteChildNote: Scalars['ChildNoteId'];
  hardDelete: Array<Scalars['ChildId']>;
  /** For mutating child leaves */
  leaves: ChildLeaveMutations;
  /** Schedules a move to the specified group. Might move the child's current group. */
  moveGroup: Array<GroupMove>;
  removeSibling: Array<SiblingLink>;
  softDelete: Array<Scalars['ChildId']>;
  updateChildNote: ChildNote;
  updatePrimaryFundingRelation: Array<Child>;
};


/** Objects related to mutating children */
export type ChildMutationacknowledgeArgs = {
  childNoteId: Scalars['ChildNoteId'];
  signedAs: SignedAs;
};


/** Objects related to mutating children */
export type ChildMutationaddSiblingArgs = {
  childId: Scalars['ChildId'];
  externalSiblingInput?: InputMaybe<ExternalSiblingLinkInput>;
  siblingId?: InputMaybe<Scalars['ChildId']>;
};


/** Objects related to mutating children */
export type ChildMutationcancelGroupMoveArgs = {
  childId: Scalars['ChildId'];
  date: Scalars['LocalDate'];
  groupId: Scalars['GroupId'];
  time?: InputMaybe<Scalars['LocalTime']>;
};


/** Objects related to mutating children */
export type ChildMutationcreateArgs = {
  importObject: Array<ImportObjectInput>;
  preview: Scalars['Boolean'];
};


/** Objects related to mutating children */
export type ChildMutationcreateChildNoteArgs = {
  childId: Scalars['ChildId'];
  fileIds?: InputMaybe<Array<Scalars['FileId']>>;
  imageIds?: InputMaybe<Array<Scalars['ImageId']>>;
  noteType?: InputMaybe<ChildNoteType>;
  parentVisible: Scalars['Boolean'];
  publish?: InputMaybe<Scalars['Boolean']>;
  safeguardingConcern?: InputMaybe<Scalars['Boolean']>;
  sendNotification?: InputMaybe<Scalars['Boolean']>;
  sensitive: Scalars['Boolean'];
  text?: InputMaybe<Scalars['String']>;
};


/** Objects related to mutating children */
export type ChildMutationdeleteChildNoteArgs = {
  noteId: Scalars['ChildNoteId'];
};


/** Objects related to mutating children */
export type ChildMutationhardDeleteArgs = {
  childIds: Array<Scalars['ChildId']>;
};


/** Objects related to mutating children */
export type ChildMutationmoveGroupArgs = {
  childId?: InputMaybe<Scalars['ChildId']>;
  childIds?: InputMaybe<Array<Scalars['ChildId']>>;
  date?: InputMaybe<Scalars['LocalDate']>;
  groupId: Scalars['GroupId'];
};


/** Objects related to mutating children */
export type ChildMutationremoveSiblingArgs = {
  childId: Scalars['ChildId'];
  linkId: Scalars['SiblingLinkId'];
};


/** Objects related to mutating children */
export type ChildMutationsoftDeleteArgs = {
  childIds?: InputMaybe<Array<Scalars['ChildId']>>;
  institutionIds?: InputMaybe<Array<Scalars['InstitutionId']>>;
};


/** Objects related to mutating children */
export type ChildMutationupdateChildNoteArgs = {
  fileIds?: InputMaybe<Array<Scalars['FileId']>>;
  imageIds?: InputMaybe<Array<Scalars['ImageId']>>;
  noteId: Scalars['ChildNoteId'];
  parentVisible: Scalars['Boolean'];
  publish?: InputMaybe<Scalars['Boolean']>;
  safeguardingConcern?: InputMaybe<Scalars['Boolean']>;
  sendNotification?: InputMaybe<Scalars['Boolean']>;
  sensitive: Scalars['Boolean'];
  text?: InputMaybe<Scalars['String']>;
};


/** Objects related to mutating children */
export type ChildMutationupdatePrimaryFundingRelationArgs = {
  primaryFundingRelations: Array<PrimaryFundingRelation>;
};

export type ChildNote = {
  __typename?: 'ChildNote';
  behaviors: Array<Behavior>;
  child: Child;
  createdAt: Scalars['ZonedDateTime'];
  createdBy: Person;
  /** The files attached to the note, if any */
  files: Array<File>;
  /** The images attached to the note, if any */
  images: Array<Image>;
  modifiedAt: Scalars['ZonedDateTime'];
  modifiedBy: Person;
  noteId: Scalars['ChildNoteId'];
  noteType: ChildNoteType;
  parentAcknowledgements: Array<ChildNoteSignature>;
  parentVisible: Scalars['Boolean'];
  publishedAt?: Maybe<Scalars['ZonedDateTime']>;
  safeguardingConcern: Scalars['Boolean'];
  sensitive: Scalars['Boolean'];
  text?: Maybe<Scalars['String']>;
};

export type ChildNoteSignature = Acknowledgment & {
  __typename?: 'ChildNoteSignature';
  acknowledgedAt: Scalars['ZonedDateTime'];
  acknowledgedBy: Person;
  id: Scalars['SignatureId'];
  signedAs: SignedAs;
  targetId: Scalars['ChildNoteId'];
  valid: Scalars['Boolean'];
  withdrawnAt?: Maybe<Scalars['ZonedDateTime']>;
};

export enum ChildNoteType {
  Classic = 'Classic',
  EspiraAktivitetsplikt = 'EspiraAktivitetsplikt',
  EspiraAnnet = 'EspiraAnnet',
  EspiraOppfoelgingssamtale = 'EspiraOppfoelgingssamtale',
  EspiraOppstartsamtale = 'EspiraOppstartsamtale',
  EspiraOrdinaerForeldresamtale = 'EspiraOrdinaerForeldresamtale',
  EspiraSkolestartsamtale = 'EspiraSkolestartsamtale'
}

export type ChildNotesResult = {
  __typename?: 'ChildNotesResult';
  behaviors: Array<Behavior>;
  next?: Maybe<Scalars['ChildNoteCursor']>;
  result: Array<ChildNote>;
};

export type ChildPeriodMutations = {
  __typename?: 'ChildPeriodMutations';
  /** Create a new period for KiBiG child funding data */
  createChildPeriod: KibigChildPeriod;
  deleteChildPeriod: Scalars['Boolean'];
  /** Update a period for KiBiG child funding data */
  updateChildPeriod: KibigChildPeriod;
};


export type ChildPeriodMutationscreateChildPeriodArgs = {
  ageGroup: KibigAgeGroup;
  childId: Scalars['ChildId'];
  comment?: InputMaybe<Scalars['String']>;
  fundable: Scalars['Boolean'];
  hasDisability: Scalars['Boolean'];
  hasNoGermanSpeakingParents: Scalars['Boolean'];
  institutionId: Scalars['InstitutionId'];
  kibigChildId?: InputMaybe<Scalars['String']>;
  municipality: Scalars['KibigMunicipalityId'];
  precourse: Scalars['Boolean'];
  preschool: Scalars['Boolean'];
  validFrom: Scalars['LocalDate'];
};


export type ChildPeriodMutationsdeleteChildPeriodArgs = {
  childPeriodId: Scalars['KibigChildPeriodId'];
};


export type ChildPeriodMutationsupdateChildPeriodArgs = {
  ageGroup: KibigAgeGroup;
  childPeriodId: Scalars['KibigChildPeriodId'];
  comment?: InputMaybe<Scalars['String']>;
  fundable: Scalars['Boolean'];
  hasDisability: Scalars['Boolean'];
  hasNoGermanSpeakingParents: Scalars['Boolean'];
  kibigChildId?: InputMaybe<Scalars['String']>;
  municipality: Scalars['KibigMunicipalityId'];
  precourse: Scalars['Boolean'];
  preschool: Scalars['Boolean'];
  validFrom: Scalars['LocalDate'];
};

export enum ChildPlanFilter {
  AllPlans = 'AllPlans',
  CurrentAndFuturePlans = 'CurrentAndFuturePlans',
  CurrentPlans = 'CurrentPlans'
}

/** Queries related to child profiles */
export type ChildProfileQueries = {
  __typename?: 'ChildProfileQueries';
  /** Returns information about which settings are enabled for child profiles */
  settings: ChildProfileSettingsResultType;
};


/** Queries related to child profiles */
export type ChildProfileQueriessettingsArgs = {
  siteSetId: Scalars['SiteSetId'];
};

/** The result of querying child profile settings */
export type ChildProfileSettingsResultType = {
  __typename?: 'ChildProfileSettingsResultType';
  /** Whether or not the family tab is enabled */
  hasFamilyTab: Scalars['Boolean'];
};

/** Input for creating a child relation */
export type ChildRelationCreationInput = {
  address?: InputMaybe<AddressInput>;
  /** Whether or not the child lives with this relation */
  childLivesWith?: InputMaybe<Scalars['Boolean']>;
  email?: InputMaybe<Scalars['EmailAddress']>;
  /** Whether or not the child relation is an emergency contact for the child */
  isEmergencyContact?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['NameInput'];
  phone?: InputMaybe<Scalars['PhoneNumber']>;
  /** The relation to the child, e.g. Dad, Mom, Grandparent etc. */
  relation?: InputMaybe<Scalars['String']>;
  workPhone?: InputMaybe<Scalars['PhoneNumber']>;
};

/** Data to create a child relation */
export type ChildRelationCreationInputResult = {
  __typename?: 'ChildRelationCreationInputResult';
  address?: Maybe<Address>;
  childLivesWith?: Maybe<Scalars['Boolean']>;
  email?: Maybe<Scalars['EmailAddress']>;
  isEmergencyContact?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  phone?: Maybe<PhoneNumberType>;
  relation?: Maybe<Scalars['String']>;
  workPhone?: Maybe<PhoneNumberType>;
};

/** Output for creating a child relation */
export type ChildRelationCreationResult = {
  __typename?: 'ChildRelationCreationResult';
  address?: Maybe<Address>;
  childLivesWith?: Maybe<Scalars['Boolean']>;
  email?: Maybe<Scalars['EmailAddress']>;
  errors: Array<ImportError>;
  name: Scalars['String'];
  phone?: Maybe<PhoneNumberType>;
  relation?: Maybe<Scalars['String']>;
  relationId?: Maybe<Scalars['RelationId']>;
  workPhone?: Maybe<PhoneNumberType>;
};

/** Roles assigned on a child */
export type ChildRole = {
  __typename?: 'ChildRole';
  roleId: Scalars['RoleId'];
  title: Scalars['String'];
};

/** A role assignment */
export type ChildRoleAssignment = {
  __typename?: 'ChildRoleAssignment';
  child: Child;
  role: ChildRole;
  targetId: Scalars['UniqueId'];
};

export type ChildSignInResult = {
  __typename?: 'ChildSignInResult';
  checkedIn: Scalars['Boolean'];
  /** @deprecated Use 'childInfo' field instead. Permissions required for this field are too restrictive for some users, e.g. those with family role. */
  child: Child;
  childInfo: ChildLimitedInfo;
  openingHours: Array<CheckinOpeningHoursResult>;
  requirePickupInfo: Scalars['Boolean'];
  showPickupUntilExactClosingTime: Scalars['Boolean'];
  statements: Array<CheckInStatementResult>;
};

/** The status of a child */
export enum ChildStatus {
  ACTIVE = 'ACTIVE',
  ANONYMIZED = 'ANONYMIZED',
  DELETED = 'DELETED',
  INQUIRY = 'INQUIRY'
}

export enum ChildStatusFilter {
  ActiveChildren = 'ActiveChildren',
  AllChildren = 'AllChildren',
  WithdrawnChildren = 'WithdrawnChildren'
}

/** Status filter for naps and custom statuses */
export type ChildStatusInput = {
  /** Filter on children with active custom statuses */
  customStatus?: InputMaybe<Scalars['StatusConfigId']>;
  /** Filter on children that are asleep or awake */
  sleepStatus?: InputMaybe<SleepStatus>;
};

/** Nap or custom statuses */
export type ChildStatusUnion = CustomStatusType | NapType;

export type ChildVaccinationDoses = {
  childId: Scalars['ChildId'];
  doses: Array<ChildVaccinationSingleDose>;
};

export type ChildVaccinationSingleDose = {
  /** If the dose type is an exemption, you must provide a note */
  doseType: DoseType;
  files?: InputMaybe<Array<Scalars['FileId']>>;
  givenOn: Scalars['LocalDate'];
  images?: InputMaybe<Array<Scalars['ImageId']>>;
  /** A non-empty note is required when exempting from a vaccination. */
  note?: InputMaybe<Scalars['String']>;
  ruleId: Scalars['ImmunizationRuleId'];
};

export type ChildrenByAgeGroupType = {
  __typename?: 'ChildrenByAgeGroupType';
  lower?: Maybe<Scalars['Int']>;
  numberOfChildren: Scalars['Int'];
  staffRatio?: Maybe<Scalars['Float']>;
  upper?: Maybe<Scalars['Int']>;
};

/** Media tagged with children */
export type ChildrenMediaTagged = {
  __typename?: 'ChildrenMediaTagged';
  /** All children tagged in media */
  children: Array<Child>;
  mediaId: Scalars['MediaId'];
};

export type ClosedIntRange = {
  __typename?: 'ClosedIntRange';
  from: Scalars['Int'];
  to: Scalars['Int'];
};

export type ClosedIntRangeInput = {
  from: Scalars['Int'];
  to: Scalars['Int'];
};

export type ClosedLocalDateRange = {
  from: Scalars['LocalDate'];
  to: Scalars['LocalDate'];
};

export type ClosedLocalTimeRange = {
  from: Scalars['LocalTime'];
  to: Scalars['LocalTime'];
};

export type ClosedZonedDateTimeRangeInput = {
  from: Scalars['ZonedDateTime'];
  to: Scalars['ZonedDateTime'];
};

export enum ClosingDay {
  ClosingDay = 'ClosingDay',
  Holiday = 'Holiday',
  TrainingDay = 'TrainingDay'
}

export type ClosingDayDay = {
  __typename?: 'ClosingDayDay';
  day: Scalars['LocalDate'];
  id: Scalars['ClosingDayId'];
  reason: Scalars['String'];
  siteId: Scalars['SiteId'];
  type: ClosingDay;
};

export type ClosingDayGroup = {
  __typename?: 'ClosingDayGroup';
  closingDays: Array<ClosingDayDay>;
  range: ClosingDayGroupLocalDateClosedRange;
};

export type ClosingDayGroupLocalDateClosedRange = {
  __typename?: 'ClosingDayGroupLocalDateClosedRange';
  from: Scalars['LocalDate'];
  to: Scalars['LocalDate'];
};

export type ClosingDayInput = {
  day: Scalars['LocalDate'];
  id?: InputMaybe<Scalars['ClosingDayId']>;
  reason: Scalars['String'];
  siteId: Scalars['SiteId'];
  type: ClosingDay;
};

export type ClosingDayWithLabel = {
  __typename?: 'ClosingDayWithLabel';
  label: Scalars['String'];
  name: ClosingDay;
};

export enum Color {
  BLACK = 'BLACK',
  BLUE = 'BLUE',
  BROWN = 'BROWN',
  GRAY = 'GRAY',
  GREEN = 'GREEN',
  LIGHTBLUE = 'LIGHTBLUE',
  LIGHTGREEN = 'LIGHTGREEN',
  ORANGE = 'ORANGE',
  PINK = 'PINK',
  PURPLE = 'PURPLE',
  RED = 'RED',
  YELLOW = 'YELLOW'
}

export type Comment = {
  __typename?: 'Comment';
  behaviors: Array<Behavior>;
  body: Scalars['String'];
  canManage: Scalars['Boolean'];
  /** Whether or not the user can report this comment */
  canReport: Scalars['Boolean'];
  id: Scalars['CommentId'];
  images: Array<Image>;
  /** Likes for this comment */
  likes: Likes;
  sentAt: Scalars['ZonedDateTime'];
  sentBy: Person;
};

/** Information about comparision table in the Feature Store */
export type ComparisonTable = {
  __typename?: 'ComparisonTable';
  isEnabled: Scalars['Boolean'];
};

/** Contains the result of completing (approving or rejecting) a staff leave request */
export type CompleteLeaveRequest = {
  __typename?: 'CompleteLeaveRequest';
  completedRequest: StaffLeaveRequest;
  remainingRequests: Array<StaffLeaveRequestWithOverlaps>;
};

/** Contains the updated (or completed) staff leave request */
export type CompleteLeaveRequestResultTypeV2 = {
  __typename?: 'CompleteLeaveRequestResultTypeV2';
  completedRequest: StaffLeaveRequest;
  remainingRequests: Array<StaffLeaveRequestWithOverlaps>;
  updatedStaffHours: Array<StaffHoursAttendanceByStaffTypeV2>;
};

export type CompletedLeaveRequestsResult = {
  __typename?: 'CompletedLeaveRequestsResult';
  next?: Maybe<Scalars['CompletedLeaveRequestsCursor']>;
  results: Array<StaffLeaveRequest>;
};

export enum CompletedLeaveRequestsSortOrder {
  ByDateAsc = 'ByDateAsc',
  ByDateDesc = 'ByDateDesc',
  ByRoomAsc = 'ByRoomAsc',
  ByRoomDesc = 'ByRoomDesc',
  ByStaffAsc = 'ByStaffAsc',
  ByStaffDesc = 'ByStaffDesc',
  Default = 'Default'
}

export type ConfigResult = {
  __typename?: 'ConfigResult';
  canAccess: Scalars['Boolean'];
  canAccessEmptyState: Scalars['Boolean'];
  canCreatePackages: Scalars['Boolean'];
  hasChildren: Scalars['Boolean'];
  hasDiscountPresets: Scalars['Boolean'];
  hasGroupAutoMove: Scalars['Boolean'];
};

export type ConfigResultUs = {
  __typename?: 'ConfigResultUs';
  canAccess: Scalars['Boolean'];
  canAccessEmptyState: Scalars['Boolean'];
  hasChildren: Scalars['Boolean'];
};

/** Automatic invoicing configuration inheritance */
export type ConfigurationInheritance = {
  __typename?: 'ConfigurationInheritance';
  canBeConfigured: Scalars['Boolean'];
  inheritedFrom?: Maybe<ConfigurationLevel>;
  inheritedFromId?: Maybe<Scalars['String']>;
};

export enum ConfigurationLevel {
  ORGANIZATION = 'ORGANIZATION',
  SITE = 'SITE'
}

/** Connection information for exporting from Kita-Planer */
export type ConnectionResult = {
  __typename?: 'ConnectionResult';
  credentialsExist: Scalars['Boolean'];
  /** Information about when the active credentials expire, if there are any */
  expiration?: Maybe<Scalars['ZonedDateTime']>;
};

export enum ConstituentCountries {
  England = 'England',
  Scotland = 'Scotland',
  Wales = 'Wales'
}

/** Represents a child contact */
export type Contact = {
  __typename?: 'Contact';
  address?: Maybe<Address>;
  childId: Scalars['ChildId'];
  email?: Maybe<Scalars['EmailAddress']>;
  emergencyContact: Scalars['Boolean'];
  id: Scalars['ContactId'];
  name: Name;
  /** Other child roles in the same site. Role invitations won't show up here. */
  otherChildRolesInSite: Array<ChildRoleAssignment>;
  phoneNumbers: Array<PhoneNumberType>;
  profileImage?: Maybe<ProfileImage>;
  /**
   * Basic child's contact info records.
   *
   * Currently available are:
   * - `TITLE`
   * - `RELATION`
   * - `PLACE_OF_WORK`
   * - `OCCUPATION`
   * - `EXTRA_INFO`
   *
   */
  records: Array<Record>;
  roleInvitations: Array<RoleInvitationData>;
  /** Active roles for the child. Role invitations won't show up here. */
  roles: Array<ChildRoleAssignment>;
};


/** Represents a child contact */
export type ContactrecordsArgs = {
  keys: Array<ContactRecordKey>;
};

/**
 *
 * Input for creating a contact.
 *
 * If you add a roles to the contact which does not yet have a login, this
 * will create a login for them.
 *
 * Supported roles:
 * - Parent: `d27c12e8-e1bf-4cb6-b10e-def7a83e3350`
 * - Family: `2a8c1370-3ea7-40e8-9a60-8773bbe66c5e`
 *
 */
export type ContactInvitationInput = {
  childId: Scalars['ChildId'];
  email?: InputMaybe<Scalars['EmailAddress']>;
  emergencyContact?: InputMaybe<Scalars['Boolean']>;
  mobilePhone?: InputMaybe<Scalars['PhoneNumber']>;
  name: Scalars['NameInput'];
  records: Array<RecordInput>;
  /**
   * Supported roles:
   * - Parent: `d27c12e8-e1bf-4cb6-b10e-def7a83e3350`
   * - Family: `2a8c1370-3ea7-40e8-9a60-8773bbe66c5e`
   *
   */
  roleId?: InputMaybe<Scalars['RoleId']>;
};

export enum ContactRecordKey {
  EXTRA_INFO = 'EXTRA_INFO',
  OCCUPATION = 'OCCUPATION',
  PLACE_OF_WORK = 'PLACE_OF_WORK',
  RELATION = 'RELATION',
  TITLE = 'TITLE'
}

export type ContactResult = {
  __typename?: 'ContactResult';
  success: Scalars['Boolean'];
};

/** Contact role assignment or invitation information */
export type ContactRoleInvitation = {
  __typename?: 'ContactRoleInvitation';
  relationId: Scalars['RelationId'];
  roleInvitations: Array<RoleInvitationData>;
  /** Active roles for the child. Role invitations won't show up here. */
  roles: Array<ChildRoleAssignment>;
};

export enum ContactType {
  CustomerOnTrialReadyToUpgrade = 'CustomerOnTrialReadyToUpgrade',
  CustomerOnTrialWantsNewTrial = 'CustomerOnTrialWantsNewTrial',
  CustomerWantsToBookADemoCall = 'CustomerWantsToBookADemoCall',
  CustomerWantsToTrialNewPackage = 'CustomerWantsToTrialNewPackage',
  CustomerWantsToUpgradeFromAPaidPackage = 'CustomerWantsToUpgradeFromAPaidPackage',
  CustomerWantsToUpgradePackage = 'CustomerWantsToUpgradePackage',
  ExistingUserTrialSignupWithNewSite = 'ExistingUserTrialSignupWithNewSite',
  NewFamlyPayLead = 'NewFamlyPayLead',
  OrganizationCreatedANewSite = 'OrganizationCreatedANewSite',
  OrganizationWantsToRequestANewSite = 'OrganizationWantsToRequestANewSite',
  ReferredCustomerWantsToBookADemoCall = 'ReferredCustomerWantsToBookADemoCall',
  SalesInbound = 'SalesInbound',
  Upsell = 'Upsell'
}

/** Input for updating a contact */
export type ContactUpdate = {
  address?: InputMaybe<AddressInput>;
  email?: InputMaybe<Scalars['EmailAddress']>;
  emergencyContact?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ContactId'];
  name: Scalars['NameInput'];
  phoneNumbers: Array<PhoneInput>;
  records: Array<RecordInput>;
  roles: Array<RoleAssignmentInput>;
};

export type ContactUpdateEmail = {
  contactId: Scalars['ContactId'];
  email?: InputMaybe<Scalars['EmailAddress']>;
};

export type ContactUpdateEmergencyContact = {
  contactId: Scalars['ContactId'];
  emergencyContact?: InputMaybe<Scalars['Boolean']>;
};

export type ContactUpdateName = {
  contactId: Scalars['ContactId'];
  name: Scalars['NameInput'];
};

export type ContactUpdatePhone = {
  contactId: Scalars['ContactId'];
  phone: Array<PhoneInput>;
};

export type ContactUpdateRecord = {
  contactId: Scalars['ContactId'];
  record: Array<RecordInput>;
};

export type ContactUpdateRoleId = {
  contactId: Scalars['ContactId'];
  roleId?: InputMaybe<Scalars['RoleId']>;
};

/** For creating and updating child contacts or role invitations */
export type ContactsMutation = {
  __typename?: 'ContactsMutation';
  /** Copies over the provided contacts onto the provided child. Note: Does not do anything clever, e.g. calling this twice will result in duplicate contacts. */
  copyContacts: Array<Contact>;
  /** After creating child contacts, returns list of them */
  create: Array<Contact>;
  /**
   * Either assign a child contact a role or create a role invitation for them.
   *  Previously existing invitations will be removed in case of a new invitation.
   * @deprecated Role updates are handled in the childContacts->roleUpdate endpoint instead.
   */
  invite: ContactRoleInvitation;
  /**
   * Update one or more contacts.
   * You can use `contacts` to update a full contact, or one of the arguments, e.g. `names`, to update a single field
   *
   */
  update: Array<Contact>;
  /**
   * Update the role of the relationId. If none provided, any roles or role invitations will be removed.
   *  If provided, the role will be assigned directly or a role invitation will be created.
   *  When transitioning, roles will be assigned directly, even if login validation is enabled.
   */
  updateRole: ContactRoleInvitation;
};


/** For creating and updating child contacts or role invitations */
export type ContactsMutationcopyContactsArgs = {
  childId: Scalars['ChildId'];
  contactIds: Array<Scalars['ContactId']>;
};


/** For creating and updating child contacts or role invitations */
export type ContactsMutationcreateArgs = {
  childContacts: Array<ContactInvitationInput>;
};


/** For creating and updating child contacts or role invitations */
export type ContactsMutationinviteArgs = {
  childId: Scalars['ChildId'];
  relationId: Scalars['RelationId'];
  roleId: Scalars['RoleId'];
};


/** For creating and updating child contacts or role invitations */
export type ContactsMutationupdateArgs = {
  contacts?: InputMaybe<Array<ContactUpdate>>;
  emails?: InputMaybe<Array<ContactUpdateEmail>>;
  emergencyContacts?: InputMaybe<Array<ContactUpdateEmergencyContact>>;
  forceAccountsSync?: InputMaybe<Scalars['Boolean']>;
  names?: InputMaybe<Array<ContactUpdateName>>;
  phones?: InputMaybe<Array<ContactUpdatePhone>>;
  records?: InputMaybe<Array<ContactUpdateRecord>>;
  roles?: InputMaybe<Array<ContactUpdateRoleId>>;
};


/** For creating and updating child contacts or role invitations */
export type ContactsMutationupdateRoleArgs = {
  relationId: Scalars['RelationId'];
  role?: InputMaybe<RoleUpdateType>;
};

export type ContactsQuery = {
  __typename?: 'ContactsQuery';
  /** Information about child contact fields */
  fields: ChildContactsFields;
};


export type ContactsQueryfieldsArgs = {
  childId: Scalars['ChildId'];
  siteSetId: Scalars['SiteSetId'];
};

export type ContentElement = {
  __typename?: 'ContentElement';
  description: Scalars['String'];
  file?: Maybe<File>;
  image?: Maybe<Image>;
  link: Scalars['String'];
  pubDate: Scalars['ZonedDateTime'];
  title: Scalars['String'];
};

export type ContentWidget = Widget & {
  __typename?: 'ContentWidget';
  elements: Array<ContentElement>;
  id: Scalars['HomeWidgetId'];
  next?: Maybe<Scalars['HomeWidgetCursor']>;
  title: Scalars['String'];
  widgetId: Scalars['String'];
};

export type ContractedHours = {
  __typename?: 'ContractedHours';
  hours: Scalars['Int'];
  minutes: Scalars['Int'];
  validFrom: Scalars['LocalDate'];
  validTo?: Maybe<Scalars['LocalDate']>;
};

export type ContractedHoursChange = {
  __typename?: 'ContractedHoursChange';
  createdAt: Scalars['ZonedDateTime'];
  createdById: Scalars['LoginId'];
  createdByName: Scalars['String'];
  newBankHours?: Maybe<BankHours>;
  newContractedHours?: Maybe<ContractedHours>;
  newWorkAvailability?: Maybe<WorkAvailability>;
  previousBankHours?: Maybe<BankHours>;
  previousContractedHours?: Maybe<ContractedHours>;
  previousWorkAvailability?: Maybe<WorkAvailability>;
};

/** Contracted hours change log queries */
export type ContractedHoursChangeQueries = {
  __typename?: 'ContractedHoursChangeQueries';
  /**
   * Returns change log for employee contracted hours data
   * @deprecated Current Mobile App Version 160. Use 'byEmployeeV2' instead
   */
  byEmployee: Array<ContractedHoursChange>;
  /** Returns change log for employee contracted hours data */
  byEmployeeV2: Array<ContractedHoursChangeV2>;
};


/** Contracted hours change log queries */
export type ContractedHoursChangeQueriesbyEmployeeArgs = {
  employeeId: Scalars['EmployeeId'];
  range: ClosedLocalDateRange;
};


/** Contracted hours change log queries */
export type ContractedHoursChangeQueriesbyEmployeeV2Args = {
  employeeId: Scalars['EmployeeId'];
  range: ClosedLocalDateRange;
};

export type ContractedHoursChangeV2 = {
  __typename?: 'ContractedHoursChangeV2';
  createdAt: Scalars['ZonedDateTime'];
  createdById: Scalars['LoginId'];
  createdByName: Scalars['String'];
  newBankHours?: Maybe<BankHoursV2>;
  newContractedHours?: Maybe<ContractedHours>;
  newWorkAvailability?: Maybe<WorkAvailability>;
  previousBankHours?: Maybe<BankHoursV2>;
  previousContractedHours?: Maybe<ContractedHours>;
  previousWorkAvailability?: Maybe<WorkAvailability>;
};

export type ContractedHoursInput = {
  effectiveDate: Scalars['LocalDate'];
  hours?: InputMaybe<Scalars['Int']>;
  minutes?: InputMaybe<Scalars['Int']>;
};

export type ContractedHoursManagementFlagsType = {
  __typename?: 'ContractedHoursManagementFlagsType';
  canEdit: Scalars['Boolean'];
  canView: Scalars['Boolean'];
};

export type ContractedHoursManagementResultType = {
  __typename?: 'ContractedHoursManagementResultType';
  bankHours: ContractedHoursManagementFlagsType;
  changeLog: ContractedHoursManagementFlagsType;
  contractedHours: ContractedHoursManagementFlagsType;
  workAvailability: ContractedHoursManagementFlagsType;
};

/** Contracted hours mutations */
export type ContractedHoursMutations = {
  __typename?: 'ContractedHoursMutations';
  /** Deletes scheduled change for an employee (if any is present). */
  deleteScheduledChange: ContractedHoursResult;
  /**
   * Save current value of employee contracted hours. If employee has no contracted hours set,
   * set new value effective from today. If employee has contracted hours set, can be
   * used to set different value, also effective from today. Scheduled changes are left unchanged.
   * Can de used to delete current value by passing null as cantractedHoursSaveInput.
   */
  saveCurrent: ContractedHoursResult;
  /**
   * Schedule a change to employee contracted hours. If employee has no contracted hours set,
   * can be used to set new value, as long as it's not in the past. If employee has contracted hours set, can be
   * used to set different value but only if change date is after today. There must be no other change scheduled
   * (or scheduled change needs to be deleted before scheduling a new one)
   */
  scheduleChange: ContractedHoursResult;
};


/** Contracted hours mutations */
export type ContractedHoursMutationsdeleteScheduledChangeArgs = {
  employeeId: Scalars['EmployeeId'];
};


/** Contracted hours mutations */
export type ContractedHoursMutationssaveCurrentArgs = {
  contractedHoursSaveInput?: InputMaybe<ContractedHoursSaveInput>;
  employeeId: Scalars['EmployeeId'];
};


/** Contracted hours mutations */
export type ContractedHoursMutationsscheduleChangeArgs = {
  contractedHoursInput: ContractedHoursInput;
  employeeId: Scalars['EmployeeId'];
};

/** Contracted hours queries */
export type ContractedHoursQueries = {
  __typename?: 'ContractedHoursQueries';
  /**
   * Contains current value for contracted hours as well as scheduled change to contracted hours.
   * Any of these may or may not be defined.
   */
  byEmployee: ContractedHoursResult;
  /** Returns current value for contracted hours of all employees in a given site. */
  bySite: Array<ContractedHoursResult>;
  /** Returns summary calculation of contracted hours for all employees in a given site. */
  periodSummaryForSite: Array<PeriodContractedHours>;
};


/** Contracted hours queries */
export type ContractedHoursQueriesbyEmployeeArgs = {
  employeeId: Scalars['EmployeeId'];
};


/** Contracted hours queries */
export type ContractedHoursQueriesbySiteArgs = {
  siteId: Scalars['SiteId'];
};


/** Contracted hours queries */
export type ContractedHoursQueriesperiodSummaryForSiteArgs = {
  range: ClosedLocalDateRange;
  siteId: Scalars['SiteId'];
};

export type ContractedHoursResult = {
  __typename?: 'ContractedHoursResult';
  current?: Maybe<ContractedHours>;
  employeeId: Scalars['EmployeeId'];
  scheduled?: Maybe<ContractedHoursScheduledChange>;
};

export type ContractedHoursSaveInput = {
  hours: Scalars['Int'];
  minutes: Scalars['Int'];
};

export type ContractedHoursScheduledChange = {
  __typename?: 'ContractedHoursScheduledChange';
  date: Scalars['LocalDate'];
  hours: Scalars['Int'];
  minutes: Scalars['Int'];
};

export type ConversationOptionsType = {
  __typename?: 'ConversationOptionsType';
  canSetTitle: Scalars['Boolean'];
  conversationId: Scalars['ConversationId'];
};

/** Queries for conversation settings */
export type ConversationSettings = {
  __typename?: 'ConversationSettings';
  /** Can user manage conversation settings under its profile */
  canManageSettings: Scalars['Boolean'];
};

/** Queries for conversations */
export type ConversationsField = {
  __typename?: 'ConversationsField';
  /** For a list of conversations, return the options this user have on them. At the moment only canSetTitle option is decided */
  conversationOptions: Array<ConversationOptionsType>;
};


/** Queries for conversations */
export type ConversationsFieldconversationOptionsArgs = {
  conversationIds: Array<Scalars['ConversationId']>;
};

/** Objects related to mutating conversations */
export type ConversationsMutations = {
  __typename?: 'ConversationsMutations';
  /** Set the title of the given conversation */
  setTitle?: Maybe<Scalars['Title']>;
};


/** Objects related to mutating conversations */
export type ConversationsMutationssetTitleArgs = {
  conversationId: Scalars['ConversationId'];
  title?: InputMaybe<Scalars['Title']>;
};

export type CopyObservationsResult = {
  __typename?: 'CopyObservationsResult';
  copiedObservations: Array<Observation>;
  from: Scalars['ChildId'];
  to: Scalars['ChildId'];
};

/** The type of correction */
export enum CorrectionType {
  /** The ACH payment failed and the money was refunded */
  ACH_FAILED = 'ACH_FAILED',
  /** The BACS payment failed and the money was refunded */
  BACS_FAILED = 'BACS_FAILED',
  /** A payment was disputed and the money was refunded */
  DISPUTE_LOST = 'DISPUTE_LOST',
  /** The payment was partially refunded */
  PARTIALLY_REFUNDED = 'PARTIALLY_REFUNDED',
  /** The payment was refunded */
  REFUNDED = 'REFUNDED',
  /** The SEPA payment failed and the money was refunded */
  SEPA_FAILED = 'SEPA_FAILED'
}

export type CoverageReport = {
  __typename?: 'CoverageReport';
  institution: Site;
  numChildrenTotal: Scalars['Int'];
  numChildrenWithObs: Scalars['Int'];
};

export type CreateBillPayerAndSiteInfo = {
  city: Scalars['String'];
  companyName: Scalars['String'];
  email: Scalars['EmailAddress'];
  phoneNumber: Scalars['String'];
  role: Scalars['String'];
  siteName: Scalars['String'];
  siteSetId: Scalars['SiteSetId'];
  street: Scalars['String'];
  zip: Scalars['String'];
};

export type CreateBillPayerInfo = {
  email?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['String']>;
  siteSetId: Scalars['SiteSetId'];
};

export type CreateGoCardlessInfo = {
  redirectUrl: Scalars['String'];
  siteSetId: Scalars['SiteSetId'];
};

/** Contains a list of invoices and their associated invoice runs. Invoice runs are only created when batch invoicing. */
export type CreateInvoicesResult = {
  __typename?: 'CreateInvoicesResult';
  invoices: Array<InvoiceResult>;
  runs: Array<InvoiceRun>;
};

export type CreateNewBillPayerInput = {
  address: AddressInput;
  billingCycle: BillingCycle;
  email: Scalars['ValidEmailAddress'];
  name: Scalars['NameInput'];
  phoneNumber: Scalars['PhoneNumber'];
  role: Scalars['String'];
};

/** Objects related to creating a new site */
export type CreateNewSiteMutations = {
  __typename?: 'CreateNewSiteMutations';
  /** Creates a new site */
  v1: Scalars['SiteId'];
};


/** Objects related to creating a new site */
export type CreateNewSiteMutationsv1Args = {
  contactPerson: Scalars['String'];
  country: Scalars['String'];
  createLoginForContactPerson: Scalars['Boolean'];
  email: Scalars['String'];
  managerRoleId?: InputMaybe<Scalars['RoleId']>;
  phone: Scalars['String'];
  salesforceAccountId?: InputMaybe<Scalars['String']>;
  siteName: Scalars['String'];
  state?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};

export type CreateSiteInformationInfo = {
  city: Scalars['String'];
  name: Scalars['String'];
  phoneNumber: Scalars['String'];
  siteSetId: Scalars['SiteSetId'];
  street: Scalars['String'];
  zip: Scalars['String'];
};

/** Result of setting the Kita-Planer credentials */
export type CredentialsResult = {
  __typename?: 'CredentialsResult';
  errors: Array<ImportError>;
  success: Scalars['Boolean'];
};

export enum Crew {
  finance = 'finance',
  foundation = 'foundation',
  growth = 'growth',
  ptp = 'ptp',
  stat = 'stat'
}

/** Curriculum */
export type Curriculum = {
  __typename?: 'Curriculum';
  abbreviation?: Maybe<Scalars['String']>;
  /** Can user change this curriculum? */
  canEdit: Scalars['Boolean'];
  createdAt: Scalars['ZonedDateTime'];
  createdBy: Person;
  curriculumType: CurriculumType;
  data: CurriculumData;
  deletedAt?: Maybe<Scalars['ZonedDateTime']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['FrameworkId'];
  lastModifiedAt: Scalars['ZonedDateTime'];
  lastModifiedBy: Person;
  owner?: Maybe<Scalars['SiteSetId']>;
  status: CurriculumStatus;
  title: Scalars['String'];
};

/** CurriculumAgeRange */
export type CurriculumAgeRange = {
  __typename?: 'CurriculumAgeRange';
  from: Scalars['Int'];
  to: Scalars['Int'];
};

/** CurriculumAgeRangeInput */
export type CurriculumAgeRangeInput = {
  from: Scalars['Int'];
  id?: InputMaybe<Scalars['AreaId']>;
  to: Scalars['Int'];
};

/** Article belonging to a section a subsection or none */
export type CurriculumArticle = CurriculumCategory & {
  __typename?: 'CurriculumArticle';
  articleId: Scalars['AreaId'];
  articleParentId?: Maybe<Scalars['AreaId']>;
  description: Scalars['String'];
  /** Title of the category */
  title?: Maybe<Scalars['String']>;
};

/** Represents a category inside a curriculum. Modeled as areas before, now they can be Section, Subsection or Article */
export type CurriculumCategory = {
  /** Title of the category */
  title?: Maybe<Scalars['String']>;
};

/** CurriculumData */
export type CurriculumData = {
  __typename?: 'CurriculumData';
  folders: Array<CurriculumFolder>;
  pages: Array<CurriculumPage>;
};

/** CurriculumDataInput */
export type CurriculumDataInput = {
  folders: Array<CurriculumFolderInput>;
  pages: Array<CurriculumPageInput>;
};

/** CurriculumFolder */
export type CurriculumFolder = {
  __typename?: 'CurriculumFolder';
  folders: Array<CurriculumFolder>;
  id: Scalars['AreaId'];
  learningArea?: Maybe<CurriculumLearningArea>;
  name: Scalars['String'];
  pages: Array<CurriculumPage>;
  placement: Scalars['Int'];
};

/** CurriculumFolderInput */
export type CurriculumFolderInput = {
  folders: Array<CurriculumFolderInput>;
  id?: InputMaybe<Scalars['AreaId']>;
  learningArea?: InputMaybe<CurriculumLearningAreaInput>;
  name: Scalars['String'];
  pages: Array<CurriculumPageInput>;
  placement: Scalars['Int'];
};

/** CurriculumInput */
export type CurriculumInput = {
  abbreviation?: InputMaybe<Scalars['String']>;
  curriculumType: CurriculumType;
  data: CurriculumDataInput;
  description?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

/** CurriculumLearningArea */
export type CurriculumLearningArea = {
  __typename?: 'CurriculumLearningArea';
  abbreviation: Scalars['String'];
  color: Scalars['Int'];
  isLinkable: Scalars['Boolean'];
};

/** CurriculumLearningAreaInput */
export type CurriculumLearningAreaInput = {
  abbreviation: Scalars['String'];
  color: Scalars['Int'];
  isLinkable?: InputMaybe<Scalars['Boolean']>;
};

/** CurriculumPage */
export type CurriculumPage = {
  __typename?: 'CurriculumPage';
  ageRange?: Maybe<CurriculumAgeRange>;
  content: Scalars['String'];
  id: Scalars['AreaId'];
  placement: Scalars['Int'];
  title: Scalars['String'];
};

/** CurriculumPageInput */
export type CurriculumPageInput = {
  ageRange?: InputMaybe<CurriculumAgeRangeInput>;
  content: Scalars['String'];
  id?: InputMaybe<Scalars['AreaId']>;
  placement: Scalars['Int'];
  title: Scalars['String'];
};

/** Section of a curriculum */
export type CurriculumSection = CurriculumCategory & {
  __typename?: 'CurriculumSection';
  color?: Maybe<Scalars['Int']>;
  sectionId: Scalars['AreaId'];
  /** Title of the category */
  title?: Maybe<Scalars['String']>;
};

export enum CurriculumStatus {
  DELETED = 'DELETED',
  DELETEDDRAFT = 'DELETEDDRAFT',
  DRAFT = 'DRAFT',
  PUBLISHED = 'PUBLISHED'
}

/** Subsection belonging to a section or a subsection */
export type CurriculumSubSection = CurriculumCategory & {
  __typename?: 'CurriculumSubSection';
  subSectionId: Scalars['AreaId'];
  subsectionParentId: Scalars['AreaId'];
  /** Title of the category */
  title?: Maybe<Scalars['String']>;
};

/** Curriculum toggle, represents available curriculum for given institutionSetId */
export type CurriculumToggle = {
  __typename?: 'CurriculumToggle';
  curriculum: Framework;
  curriculumType: CurriculumType;
  enabled: Scalars['Boolean'];
  institutionSetId: Scalars['InstitutionSetId'];
  observationType?: Maybe<ObservationType>;
  order?: Maybe<Scalars['Int']>;
};

/** Allows to enable a curriculum for an institution */
export type CurriculumToggleUpdate = {
  /** If LEARNING_FRAMEWORK observationType must be empty, if REFERENCE_MATERIAL observationType must be provided. */
  curriculumType: CurriculumType;
  enabled: Scalars['Boolean'];
  frameworkId: Scalars['FrameworkId'];
  observationType?: InputMaybe<ObservationType>;
};

export enum CurriculumType {
  LEARNING_FRAMEWORK = 'LEARNING_FRAMEWORK',
  REFERENCE_MATERIAL = 'REFERENCE_MATERIAL'
}

/** Object holding all queries related to curriculums */
export type Curriculums = {
  __typename?: 'Curriculums';
  /** Can user create curriculums? */
  canCreate: Scalars['Boolean'];
  /** Can user navigate to the curriculum list? */
  canView: Scalars['Boolean'];
  /** Can site create unlimited curriculums? */
  hasUnlimitedCurriculums: Scalars['Boolean'];
  listCurriculums: Array<Curriculum>;
  /** Returns all reference material enabled for institutionSetIds */
  listReferenceMaterials: Array<InstitutionSetReferenceMaterial>;
  /** Returns all curriculums available to institutionSetIds */
  listToggles: Array<CurriculumToggle>;
};


/** Object holding all queries related to curriculums */
export type CurriculumscanCreateArgs = {
  siteSetId: Scalars['InstitutionSetId'];
};


/** Object holding all queries related to curriculums */
export type CurriculumscanViewArgs = {
  institutionSetId: Scalars['InstitutionSetId'];
};


/** Object holding all queries related to curriculums */
export type CurriculumshasUnlimitedCurriculumsArgs = {
  siteSetId: Scalars['InstitutionSetId'];
};


/** Object holding all queries related to curriculums */
export type CurriculumslistCurriculumsArgs = {
  frameworkIds?: InputMaybe<Array<Scalars['FrameworkId']>>;
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
  includePublic?: InputMaybe<Scalars['Boolean']>;
  institutionSetId: Scalars['InstitutionSetId'];
};


/** Object holding all queries related to curriculums */
export type CurriculumslistReferenceMaterialsArgs = {
  filter?: InputMaybe<AreaFilterInput>;
  institutionSetId: Scalars['InstitutionSetId'];
  observationType?: InputMaybe<ObservationType>;
  previewCurriculums?: InputMaybe<Array<Scalars['FrameworkId']>>;
};


/** Object holding all queries related to curriculums */
export type CurriculumslistTogglesArgs = {
  curriculumType: CurriculumType;
  institutionSetIds: Array<Scalars['InstitutionSetId']>;
  observationType?: InputMaybe<ObservationType>;
};

/** Objects related to mutating curriculums */
export type CurriculumsMutation = {
  __typename?: 'CurriculumsMutation';
  deleteCurriculum: Array<Curriculum>;
  publishCurriculum: Curriculum;
  recoverCurriculum: Curriculum;
  saveCurriculum: Curriculum;
  updateCurriculum: Curriculum;
  /** Enable or disable curriculums for given institutionSetId */
  updateToggles: Array<CurriculumToggle>;
};


/** Objects related to mutating curriculums */
export type CurriculumsMutationdeleteCurriculumArgs = {
  frameworkId: Scalars['FrameworkId'];
};


/** Objects related to mutating curriculums */
export type CurriculumsMutationpublishCurriculumArgs = {
  frameworkId: Scalars['FrameworkId'];
};


/** Objects related to mutating curriculums */
export type CurriculumsMutationrecoverCurriculumArgs = {
  frameworkIds?: InputMaybe<Array<Scalars['FrameworkId']>>;
};


/** Objects related to mutating curriculums */
export type CurriculumsMutationsaveCurriculumArgs = {
  curriculum: CurriculumInput;
  institutionSetId: Scalars['InstitutionSetId'];
};


/** Objects related to mutating curriculums */
export type CurriculumsMutationupdateCurriculumArgs = {
  curriculum: CurriculumInput;
  frameworkId: Scalars['FrameworkId'];
};


/** Objects related to mutating curriculums */
export type CurriculumsMutationupdateTogglesArgs = {
  institutionSetId: Scalars['InstitutionSetId'];
  toggles: Array<CurriculumToggleUpdate>;
};

/** Represents an assessment custom field. */
export type CustomField = {
  __typename?: 'CustomField';
  assessmentSettingsId: Scalars['AssessmentSettingsId'];
  customFieldId: Scalars['AssessmentSettingsCustomFieldId'];
  label: Scalars['String'];
  order: Scalars['Int'];
};

export type CustomFieldInput = {
  label: Scalars['String'];
  order: Scalars['Int'];
};

/** Represents the assessment custom field settings. */
export type CustomFieldSettings = {
  __typename?: 'CustomFieldSettings';
  customFields: Array<CustomField>;
  enabled: Scalars['Boolean'];
};

export type CustomFieldSettingsInput = {
  enabled: Scalars['Boolean'];
  fields: Array<CustomFieldInput>;
};

export type CustomFieldValue = {
  __typename?: 'CustomFieldValue';
  customFieldSetting: CustomField;
  value?: Maybe<Scalars['String']>;
};

export type CustomFieldValueInput = {
  customFieldId: Scalars['AssessmentSettingsCustomFieldId'];
  value?: InputMaybe<Scalars['String']>;
};

export type CustomFteFeatureSettingsFlags = {
  __typename?: 'CustomFteFeatureSettingsFlags';
  /** Returns if this feature can be enabled. */
  canOptIn: Scalars['Boolean'];
  /** Returns if this feature is currently enabled. */
  enabled: Scalars['Boolean'];
};

export type CustomFteManagementType = {
  __typename?: 'CustomFteManagementType';
  /** Returns true if current user can edit custom FTE value of a session. */
  canEdit: Scalars['Boolean'];
  /** Returns true if current user can view custom FTE value of a session. */
  canView: Scalars['Boolean'];
};

/** A purchase line */
export type CustomLine = InvoiceLine & {
  __typename?: 'CustomLine';
  customLineId: Scalars['CustomLineId'];
  range?: Maybe<TimeRangeClosed>;
  shareLineRelations: Array<SubLineRelation>;
  title?: Maybe<Scalars['String']>;
  total: Scalars['BadMoney'];
};

/** Information on the child of form field */
export type CustomRegistrationFormChildField = {
  __typename?: 'CustomRegistrationFormChildField';
  /** Optional user supplied text associated with the field (usage depends on field type). */
  description?: Maybe<Scalars['String']>;
  fieldType: CustomRegistrationFormFieldType;
  fileAttachment?: Maybe<FormFileAttachmentType>;
  id: Scalars['CustomRegistrationFormFieldId'];
  /** Is the field mandatory. Value context dependent on section, form type and form locale. Mandatory value fields cannot have required flag set to false */
  mandatory: Scalars['Boolean'];
  required: Scalars['Boolean'];
  userConfiguration?: Maybe<Scalars['String']>;
};

/** Input type for child of a form field */
export type CustomRegistrationFormChildInputField = {
  /** Optional user supplied text associated with the field (usage depends on field type). */
  description?: InputMaybe<Scalars['String']>;
  fieldType: CustomRegistrationFormFieldType;
  /** Optional fileId of a file attachment. Empty by default. */
  fileId?: InputMaybe<Scalars['FileId']>;
  /** Optional setting of whether field value is required or not (defaults to false) */
  required?: InputMaybe<Scalars['Boolean']>;
  /** Optional user defined information associated with a field (e.g. default value). Empty by default. */
  userConfiguration?: InputMaybe<Scalars['String']>;
};

/** Details of the field type used in custom registration form builder */
export type CustomRegistrationFormConfiguration = {
  __typename?: 'CustomRegistrationFormConfiguration';
  /**
   *
   * Description of all known field types. See into specific description object to see constraints on
   *  possible use of that field.
   *
   */
  fields: Array<CustomRegistrationFormFieldTypeDescription>;
  /**
   *
   * Fields that have to be included somewhere on the form for the form to pass validation.
   * Does not include fields that are children on other fields.
   *
   */
  mandatoryFields: Array<CustomRegistrationFormFieldType>;
  sections: Array<CustomRegistrationFormSectionTypeDescription>;
};

export type CustomRegistrationFormCreateEnrollmentType = {
  __typename?: 'CustomRegistrationFormCreateEnrollmentType';
  canCreate: Scalars['Boolean'];
  canView: Scalars['Boolean'];
};

export type CustomRegistrationFormCreateInterestType = {
  __typename?: 'CustomRegistrationFormCreateInterestType';
  canCreate: Scalars['Boolean'];
  canView: Scalars['Boolean'];
};

export type CustomRegistrationFormCreateRegistrationType = {
  __typename?: 'CustomRegistrationFormCreateRegistrationType';
  canCreate: Scalars['Boolean'];
  canView: Scalars['Boolean'];
};

/** Holds general information on a Custom Registration Form */
export type CustomRegistrationFormDescription = {
  __typename?: 'CustomRegistrationFormDescription';
  /** If true, form is automatically shared with new sites added to the organization */
  autoShare: Scalars['Boolean'];
  /** Id of the custom registration form */
  formId: Scalars['CustomRegistrationFormId'];
  /** Name of the custom registration form */
  formName: Scalars['String'];
  /** The type of the custom registration form (e.g. interest, registration, enrollment) */
  formType: CustomRegistrationFormType;
  /** True if this form is currently published */
  isPublished: Scalars['Boolean'];
  /** True if this form is shared with other sites */
  isShared: Scalars['Boolean'];
  /** Date and Time of the last edit */
  lastEditedAt: Scalars['ZonedDateTime'];
  /** Login Id of the last user that changed this form */
  lastEditedBy: Scalars['LoginId'];
  /** Name of the last user that changed this form */
  lastEditedByName?: Maybe<Scalars['String']>;
  /** Number of sites this form is shared with (including the site it was created for). */
  numberOfSitesSharedWith: Scalars['Int'];
  /** A list of all site (and site set) ids this form is shared with. */
  siteIds: Array<Scalars['SiteId']>;
};

/** Details of the registration form */
export type CustomRegistrationFormDetails = {
  __typename?: 'CustomRegistrationFormDetails';
  formName: Scalars['String'];
  formType: CustomRegistrationFormType;
  id: Scalars['CustomRegistrationFormId'];
  /** Locale used to validate form fields. This matters for both design and submission of forms. */
  locale?: Maybe<Scalars['Locale']>;
  sections: Array<CustomRegistrationFormSection>;
  versionId: Scalars['Int'];
};

/** Input type for details of the registration form */
export type CustomRegistrationFormDetailsInput = {
  id: Scalars['CustomRegistrationFormId'];
  referenceVersionId: Scalars['Int'];
  sections: Array<CustomRegistrationFormSectionInput>;
};

/** Information on the form field */
export type CustomRegistrationFormField = {
  __typename?: 'CustomRegistrationFormField';
  /** List of children fields. Non empty in case of field groups/complex components. */
  children: Array<CustomRegistrationFormChildField>;
  /** Optional user supplied text associated with the field (usage depends on field type). */
  description?: Maybe<Scalars['String']>;
  fieldType: CustomRegistrationFormFieldType;
  id: Scalars['CustomRegistrationFormFieldId'];
  /** Is the field mandatory. Value context dependent on section, form type and form locale. Mandatory value fields cannot have required flag set to false */
  mandatory: Scalars['Boolean'];
  required: Scalars['Boolean'];
  userConfiguration?: Maybe<Scalars['String']>;
};

export enum CustomRegistrationFormFieldCategory {
  ABOUT = 'ABOUT',
  CONTACT = 'CONTACT',
  HEALTH = 'HEALTH',
  SENSITIVE = 'SENSITIVE'
}

export enum CustomRegistrationFormFieldType {
  ADDRESS = 'ADDRESS',
  ALLERGY = 'ALLERGY',
  ATTACH_A_FILE = 'ATTACH_A_FILE',
  BIRTHPLACE = 'BIRTHPLACE',
  BOOKING_NOTE = 'BOOKING_NOTE',
  CHILDS_NAME = 'CHILDS_NAME',
  CITY = 'CITY',
  CONTACTS_NAME = 'CONTACTS_NAME',
  COUNTRY = 'COUNTRY',
  DATE_OF_BIRTH = 'DATE_OF_BIRTH',
  DESIRED_BOOKING_DATES = 'DESIRED_BOOKING_DATES',
  DESIRED_BOOKING_DATES_BOOK_FRIDAY = 'DESIRED_BOOKING_DATES_BOOK_FRIDAY',
  DESIRED_BOOKING_DATES_BOOK_MONDAY = 'DESIRED_BOOKING_DATES_BOOK_MONDAY',
  DESIRED_BOOKING_DATES_BOOK_SATURDAY = 'DESIRED_BOOKING_DATES_BOOK_SATURDAY',
  DESIRED_BOOKING_DATES_BOOK_SUNDAY = 'DESIRED_BOOKING_DATES_BOOK_SUNDAY',
  DESIRED_BOOKING_DATES_BOOK_THURSDAY = 'DESIRED_BOOKING_DATES_BOOK_THURSDAY',
  DESIRED_BOOKING_DATES_BOOK_TUESDAY = 'DESIRED_BOOKING_DATES_BOOK_TUESDAY',
  DESIRED_BOOKING_DATES_BOOK_WEDNESDAY = 'DESIRED_BOOKING_DATES_BOOK_WEDNESDAY',
  DESIRED_BOOKING_DATES_FRIDAY_END = 'DESIRED_BOOKING_DATES_FRIDAY_END',
  DESIRED_BOOKING_DATES_FRIDAY_START = 'DESIRED_BOOKING_DATES_FRIDAY_START',
  DESIRED_BOOKING_DATES_MONDAY_END = 'DESIRED_BOOKING_DATES_MONDAY_END',
  DESIRED_BOOKING_DATES_MONDAY_START = 'DESIRED_BOOKING_DATES_MONDAY_START',
  DESIRED_BOOKING_DATES_RANGE_END = 'DESIRED_BOOKING_DATES_RANGE_END',
  DESIRED_BOOKING_DATES_RANGE_START = 'DESIRED_BOOKING_DATES_RANGE_START',
  DESIRED_BOOKING_DATES_SATURDAY_END = 'DESIRED_BOOKING_DATES_SATURDAY_END',
  DESIRED_BOOKING_DATES_SATURDAY_START = 'DESIRED_BOOKING_DATES_SATURDAY_START',
  DESIRED_BOOKING_DATES_SUNDAY_END = 'DESIRED_BOOKING_DATES_SUNDAY_END',
  DESIRED_BOOKING_DATES_SUNDAY_START = 'DESIRED_BOOKING_DATES_SUNDAY_START',
  DESIRED_BOOKING_DATES_THURSDAY_END = 'DESIRED_BOOKING_DATES_THURSDAY_END',
  DESIRED_BOOKING_DATES_THURSDAY_START = 'DESIRED_BOOKING_DATES_THURSDAY_START',
  DESIRED_BOOKING_DATES_TUESDAY_END = 'DESIRED_BOOKING_DATES_TUESDAY_END',
  DESIRED_BOOKING_DATES_TUESDAY_START = 'DESIRED_BOOKING_DATES_TUESDAY_START',
  DESIRED_BOOKING_DATES_WEDNESDAY_END = 'DESIRED_BOOKING_DATES_WEDNESDAY_END',
  DESIRED_BOOKING_DATES_WEDNESDAY_START = 'DESIRED_BOOKING_DATES_WEDNESDAY_START',
  DESIRED_STARTING_DATE = 'DESIRED_STARTING_DATE',
  DIETARY_CONSIDERATIONS = 'DIETARY_CONSIDERATIONS',
  DOCTORS_ADDRESS = 'DOCTORS_ADDRESS',
  DOCTORS_NAME = 'DOCTORS_NAME',
  DOCTORS_NUMBER = 'DOCTORS_NUMBER',
  EMAIL = 'EMAIL',
  ETHNICITY = 'ETHNICITY',
  EXTRA_INFO = 'EXTRA_INFO',
  FILE_DETAILS = 'FILE_DETAILS',
  FIRST_NAME = 'FIRST_NAME',
  GENDER = 'GENDER',
  HOME_NUMBER = 'HOME_NUMBER',
  LANGUAGE = 'LANGUAGE',
  LAST_NAME = 'LAST_NAME',
  MIDDLE_NAME = 'MIDDLE_NAME',
  MOBILE_NUMBER = 'MOBILE_NUMBER',
  NATIONALITY = 'NATIONALITY',
  OCCUPATION = 'OCCUPATION',
  PARAGRAPH = 'PARAGRAPH',
  PLACE_OF_WORK = 'PLACE_OF_WORK',
  POSTAL_CODE = 'POSTAL_CODE',
  PRIVACY_POLICY_CONFIRMATION = 'PRIVACY_POLICY_CONFIRMATION',
  RELATION = 'RELATION',
  RELIGION = 'RELIGION',
  SECONDARY_CONTACTS_EMAIL = 'SECONDARY_CONTACTS_EMAIL',
  SECONDARY_CONTACTS_NAME = 'SECONDARY_CONTACTS_NAME',
  SIGNATURE = 'SIGNATURE',
  SIGNATURE_CONFIRMATION = 'SIGNATURE_CONFIRMATION',
  SIGNATURE_TEXT = 'SIGNATURE_TEXT',
  SPECIAL_NOTES = 'SPECIAL_NOTES',
  SPECIAL_NOTES_ABOUT = 'SPECIAL_NOTES_ABOUT',
  SPECIAL_NOTES_HEALTH = 'SPECIAL_NOTES_HEALTH',
  STATE = 'STATE',
  STREET_NAME = 'STREET_NAME',
  STREET_NUMBER = 'STREET_NUMBER',
  TERMS_AND_CONDITIONS = 'TERMS_AND_CONDITIONS',
  TERMS_AND_CONDITIONS_CONFIRMATION = 'TERMS_AND_CONDITIONS_CONFIRMATION',
  TERMS_AND_CONDITIONS_CONTENT = 'TERMS_AND_CONDITIONS_CONTENT',
  TITLE = 'TITLE',
  TOLERATES_PENICILIN = 'TOLERATES_PENICILIN',
  UETA_CONFIRMATION = 'UETA_CONFIRMATION',
  UPLOADER = 'UPLOADER',
  VACCINES = 'VACCINES',
  WORK_NUMBER = 'WORK_NUMBER',
  ZIP_CODE = 'ZIP_CODE'
}

/** Details of the field type used in custom registration form builder */
export type CustomRegistrationFormFieldTypeDescription = {
  __typename?: 'CustomRegistrationFormFieldTypeDescription';
  /**
   *
   * Fields that may but don't have be included as children of field of this type for the form to pass validation.
   * These fields usually cannot be embedded directly into a section and can only be used as children of other
   * fields.
   *
   */
  allowedChildren: Array<CustomRegistrationFormFieldType>;
  /**
   *
   * List of section types that may include field of this type (are drop target in the editor). This is empty
   * for fields that can only be children of other fields.
   *
   */
  allowedIn: Array<CustomRegistrationFormSectionType>;
  category?: Maybe<CustomRegistrationFormFieldCategory>;
  fieldType: CustomRegistrationFormFieldType;
  /**
   *
   * Fields that must be included as children of field of this type for the form to pass validation.
   * These fields usually cannot be embedded directly into a section and can only be used as children of other
   * fields.
   *
   */
  mandatoryChildren: Array<CustomRegistrationFormFieldType>;
  /**
   *
   * List of section types that must include field of this type for the form to pass validation. This is empty
   * for fields that can only be children of other fields.
   *
   */
  mandatoryIn: Array<CustomRegistrationFormSectionType>;
  /**
   *
   * Defines whether entering a value to this field will be required for successful form submission. This is
   * ignored for fields that have children. If field is set as required in the configuration, making it optional
   * through editing the form template is not allowed. If configuration considers field as optional, then it
   * can still be set as required in the template.
   *
   */
  required: Scalars['Boolean'];
};

/** Input type for form field */
export type CustomRegistrationFormInputField = {
  /** List of children fields. Non empty in case of field groups/complex components. */
  children: Array<CustomRegistrationFormChildInputField>;
  /** Optional user supplied text associated with the field (usage depends on field type). */
  description?: InputMaybe<Scalars['String']>;
  fieldType: CustomRegistrationFormFieldType;
  /** Optional setting of whether field value is required or not (defaults to false) */
  required?: InputMaybe<Scalars['Boolean']>;
  /** Optional user defined information associated with a field (e.g. default value). Empty by default. */
  userConfiguration?: InputMaybe<Scalars['String']>;
};

/** Query custom registration form management permissions for a type of form or for a specific formId. */
export type CustomRegistrationFormManagementQueries = {
  __typename?: 'CustomRegistrationFormManagementQueries';
  /** Retrieve management flags for an existing form. */
  byFormId: CustomRegistrationFormManagementType;
  /** Retrieve management flags for a site or an org, without specifying form id. */
  bySiteSetId: CustomRegistrationFormManagementType;
  enrollment: CustomRegistrationFormCreateEnrollmentType;
  interest: CustomRegistrationFormCreateInterestType;
  registration: CustomRegistrationFormCreateRegistrationType;
};


/** Query custom registration form management permissions for a type of form or for a specific formId. */
export type CustomRegistrationFormManagementQueriesbyFormIdArgs = {
  customRegistrationFormId: Scalars['CustomRegistrationFormId'];
  siteSetId: Scalars['SiteSetId'];
};


/** Query custom registration form management permissions for a type of form or for a specific formId. */
export type CustomRegistrationFormManagementQueriesbySiteSetIdArgs = {
  siteSetId: Scalars['SiteSetId'];
};


/** Query custom registration form management permissions for a type of form or for a specific formId. */
export type CustomRegistrationFormManagementQueriesenrollmentArgs = {
  siteSetId: Scalars['SiteSetId'];
};


/** Query custom registration form management permissions for a type of form or for a specific formId. */
export type CustomRegistrationFormManagementQueriesinterestArgs = {
  siteSetId: Scalars['SiteSetId'];
};


/** Query custom registration form management permissions for a type of form or for a specific formId. */
export type CustomRegistrationFormManagementQueriesregistrationArgs = {
  siteSetId: Scalars['SiteSetId'];
};

export type CustomRegistrationFormManagementType = {
  __typename?: 'CustomRegistrationFormManagementType';
  canDelete: Scalars['Boolean'];
  canDownloadResponses: Scalars['Boolean'];
  canDuplicate: Scalars['Boolean'];
  canEdit: Scalars['Boolean'];
  canEditName: Scalars['Boolean'];
  canEditSuccessMessage: Scalars['Boolean'];
  canManageSubmissionKeys: Scalars['Boolean'];
  canPublish: Scalars['Boolean'];
  canSendEmails: Scalars['Boolean'];
  canShare: Scalars['Boolean'];
  canToggleNotifications: Scalars['Boolean'];
  canUnpublish: Scalars['Boolean'];
  canView: Scalars['Boolean'];
  canViewResponses: Scalars['Boolean'];
};

/** Top level node for custom registration form mutations */
export type CustomRegistrationFormMutations = {
  __typename?: 'CustomRegistrationFormMutations';
  /** duplicate multiple existing forms at once */
  batchDuplicate: Array<FormDescriptionWithDetailsType>;
  /** For internal use. Called when new site is added to an organization, to check if any forms need to be shared automatically with the site */
  createAutoSharesForNewSite: Scalars['Int'];
  /** Create new form */
  createExtended: FormDescriptionWithDetailsType;
  /** Create submission key for given site, form, child and child relation */
  createSubmissionKeyForChildRelation: Scalars['SubmissionKeyId'];
  /** Generate upload URL to upload a file attachment to a given form field */
  createUploadUrl: FileUpload;
  /** delete an existing form, all its shares and all its versions */
  delete: CustomRegistrationFormDescription;
  /** duplicate an existing form or a specific version */
  duplicate: FormDescriptionWithDetailsType;
  /** Rename an existing form */
  editName: CustomRegistrationFormDescription;
  /** Change notification status of an existing form for a given site. */
  notificationsEnabled: FormNotificationsResult;
  /** Register uploaded form attachment for use in Famly */
  registerUpload: Scalars['FileId'];
  /** Resend verification email, extending expiration time */
  resendVerificationEmail: FormEmailStatusResultType;
  /** Revoke submission key given its id */
  revokeSubmissionKey: Scalars['SubmissionKeyId'];
  /** Save form template */
  save: FormSaveResult;
  /** Scan uploaded, not yet registered form attachment for potential viruses */
  scanUpload: FileScanResult;
  /** send an email to a relation of a child */
  sendEmail: EmailResult;
  /** When set to 'true', the form is automatically shared with new site when new site is added to the organization */
  setAutoShare: CustomRegistrationFormDescription;
  /** Toggle the published state of a form. This method only updates the form description if the new `published` is different from the current published state. */
  setPublished: CustomRegistrationFormDescription;
  /** Form Submission API - unauthenticated */
  submitFormExtended: FormSubmitResult;
  /** Change success message of a an existing form for a given site. If no success message is passed it will be set to the default success message. */
  successMessage: FormSuccessMessageResult;
  /** Update the list of sites the form is shared with. Overwrites any existing shares. In other words: The form will be shared with all sites that are passed in the `shareWith` list. The form will be unshared for all sites that are not part of the list, except for the `siteSetId` which cannot be removed from the shares.  */
  updateShares: CustomRegistrationFormDescription;
  /** Validate email using validation code sent */
  verifyEmail: FormEmailVerificationResultType;
};


/** Top level node for custom registration form mutations */
export type CustomRegistrationFormMutationsbatchDuplicateArgs = {
  forms: Array<FormDuplicateInput>;
  siteSetId: Scalars['SiteSetId'];
};


/** Top level node for custom registration form mutations */
export type CustomRegistrationFormMutationscreateAutoSharesForNewSiteArgs = {
  organizationId: Scalars['SiteSetId'];
  siteId: Scalars['SiteId'];
};


/** Top level node for custom registration form mutations */
export type CustomRegistrationFormMutationscreateExtendedArgs = {
  formType: CustomRegistrationFormType;
  name: Scalars['String'];
  siteSetId: Scalars['SiteSetId'];
};


/** Top level node for custom registration form mutations */
export type CustomRegistrationFormMutationscreateSubmissionKeyForChildRelationArgs = {
  childId: Scalars['ChildId'];
  formId: Scalars['CustomRegistrationFormId'];
  relationId: Scalars['RelationId'];
  siteSetId: Scalars['SiteSetId'];
};


/** Top level node for custom registration form mutations */
export type CustomRegistrationFormMutationscreateUploadUrlArgs = {
  fieldId: Scalars['CustomRegistrationFormFieldId'];
};


/** Top level node for custom registration form mutations */
export type CustomRegistrationFormMutationsdeleteArgs = {
  formId: Scalars['CustomRegistrationFormId'];
  siteSetId: Scalars['SiteSetId'];
};


/** Top level node for custom registration form mutations */
export type CustomRegistrationFormMutationsduplicateArgs = {
  duplicateFormName?: InputMaybe<Scalars['String']>;
  formId: Scalars['CustomRegistrationFormId'];
  formVersion?: InputMaybe<Scalars['Int']>;
  siteSetId: Scalars['SiteSetId'];
};


/** Top level node for custom registration form mutations */
export type CustomRegistrationFormMutationseditNameArgs = {
  formId: Scalars['CustomRegistrationFormId'];
  name: Scalars['String'];
  siteSetId: Scalars['SiteSetId'];
};


/** Top level node for custom registration form mutations */
export type CustomRegistrationFormMutationsnotificationsEnabledArgs = {
  enableNotifications: Scalars['Boolean'];
  formId: Scalars['CustomRegistrationFormId'];
  siteId: Scalars['SiteId'];
};


/** Top level node for custom registration form mutations */
export type CustomRegistrationFormMutationsregisterUploadArgs = {
  fileName: Scalars['String'];
  fileUpload: FileUploadInput;
};


/** Top level node for custom registration form mutations */
export type CustomRegistrationFormMutationsresendVerificationEmailArgs = {
  email: Scalars['String'];
  siteId: Scalars['SiteId'];
};


/** Top level node for custom registration form mutations */
export type CustomRegistrationFormMutationsrevokeSubmissionKeyArgs = {
  siteSetId: Scalars['SiteSetId'];
  submissionKeyId: Scalars['SubmissionKeyId'];
};


/** Top level node for custom registration form mutations */
export type CustomRegistrationFormMutationssaveArgs = {
  form: CustomRegistrationFormDetailsInput;
  siteSetId: Scalars['SiteSetId'];
};


/** Top level node for custom registration form mutations */
export type CustomRegistrationFormMutationsscanUploadArgs = {
  fileUpload: FileUploadInput;
};


/** Top level node for custom registration form mutations */
export type CustomRegistrationFormMutationssendEmailArgs = {
  formId: Scalars['CustomRegistrationFormId'];
  relationId: Scalars['RelationId'];
  siteSetId: Scalars['SiteSetId'];
};


/** Top level node for custom registration form mutations */
export type CustomRegistrationFormMutationssetAutoShareArgs = {
  autoShare: Scalars['Boolean'];
  formId: Scalars['CustomRegistrationFormId'];
  siteSetId: Scalars['SiteSetId'];
};


/** Top level node for custom registration form mutations */
export type CustomRegistrationFormMutationssetPublishedArgs = {
  formId: Scalars['CustomRegistrationFormId'];
  published: Scalars['Boolean'];
  siteSetId: Scalars['SiteSetId'];
};


/** Top level node for custom registration form mutations */
export type CustomRegistrationFormMutationssubmitFormExtendedArgs = {
  fields: Array<FieldValueInput>;
  formId: Scalars['CustomRegistrationFormId'];
  formVersionId?: InputMaybe<Scalars['Int']>;
  siteSetId: Scalars['SiteSetId'];
  submissionKey?: InputMaybe<Scalars['SubmissionKeyId']>;
};


/** Top level node for custom registration form mutations */
export type CustomRegistrationFormMutationssuccessMessageArgs = {
  formId: Scalars['CustomRegistrationFormId'];
  message?: InputMaybe<Scalars['String']>;
  siteId: Scalars['SiteId'];
};


/** Top level node for custom registration form mutations */
export type CustomRegistrationFormMutationsupdateSharesArgs = {
  autoShare?: InputMaybe<Scalars['Boolean']>;
  formId: Scalars['CustomRegistrationFormId'];
  sharedWith: Array<Scalars['SiteId']>;
  siteSetId: Scalars['SiteSetId'];
};


/** Top level node for custom registration form mutations */
export type CustomRegistrationFormMutationsverifyEmailArgs = {
  verificationCode: Scalars['String'];
};

/** Top level node for custom registration form queries */
export type CustomRegistrationFormQueries = {
  __typename?: 'CustomRegistrationFormQueries';
  /** Configuration data for form builder, specifying components of a form that's edited */
  configuration: CustomRegistrationFormConfiguration;
  /** Returns the form description of a form by it's formId. */
  description?: Maybe<CustomRegistrationFormDescription>;
  /** Returns details of a form given its id. Requires permission to view the form. */
  details: CustomRegistrationFormDetails;
  /** Return verification status of an email */
  emailVerificationStatus: FormEmailStatusResultType;
  /** Get a list of child contacts with email addresses */
  listChildContacts: Array<FormRecipient>;
  /** Returns a paginated list of all custom registration forms of a given site set. (The default page size is set to 25.) If the option onlyPublished is set to true the result will only contain forms that are currently published. If the option onlyShared is set to true, only forms shared with other sites will be listed. It is further possible to define a sort order for the results. (The default sorting is the date of last edit.) */
  listFormsBySiteSetId: FormResult;
  /** Returns a list of all sites in an organisation the current user is allowed to share a form with. */
  listSites: Array<Site>;
  /** Returns a paginated list of all form submissions of a given site. (The default page size is set to 25.) Results can be filtered by specific child ids, form types, form ids and submission date range. It is further possible to define a sort order for the results. (The default sorting is the date of submission.) */
  listSubmissions: FormSubmissionResult;
  /** The notification settings of this form for the given site. Notifications about incoming form responses are enabled by default. */
  notificationsEnabled: Scalars['Boolean'];
  /** The number of responses submitted to this form. If `siteSetId` is an organisation the number of responses is calculated across all sites of the organisation this form is shared with. */
  numberOfResponses: Scalars['Int'];
  /** Preview form template */
  preview: FormPreviewResult;
  /** Returns publish URL of the form given siteSetId and formId. Can be used for both organization and single site. */
  previewUrl: Scalars['String'];
  /** Returns details of a form given its id. Does not require permission to view the form. */
  publicDetails: CustomRegistrationFormDetails;
  /** Returns public details of site set (institution or organization in this case) */
  publicSiteSetDetails: PublicSiteSetDetails;
  /** Returns publicly available information on the submission key */
  publicSubmissionKeyDetails: CustomRegistrationFormSubmissionKeyPublicData;
  /** Returns publish URL of the form given siteId and formId. */
  publishUrl: Scalars['String'];
  /** Returns URL to download CSV file with form responses */
  responsesCsvUrl: Scalars['String'];
  /** Returns data submitted with the form */
  submissionData: FormSubmissionData;
  /** Returns information on the submission key */
  submissionKeyDetails: CustomRegistrationFormSubmissionKey;
  /** The message displayed to anyone who successfully submits this form */
  successMessage: Scalars['String'];
};


/** Top level node for custom registration form queries */
export type CustomRegistrationFormQueriesconfigurationArgs = {
  formLocale: Scalars['Locale'];
  formType: CustomRegistrationFormType;
  siteSetId?: InputMaybe<Scalars['SiteSetId']>;
};


/** Top level node for custom registration form queries */
export type CustomRegistrationFormQueriesdescriptionArgs = {
  formId: Scalars['CustomRegistrationFormId'];
  siteSetId: Scalars['SiteSetId'];
};


/** Top level node for custom registration form queries */
export type CustomRegistrationFormQueriesdetailsArgs = {
  formId: Scalars['CustomRegistrationFormId'];
  formVersionId?: InputMaybe<Scalars['Int']>;
  siteSetId: Scalars['SiteSetId'];
};


/** Top level node for custom registration form queries */
export type CustomRegistrationFormQueriesemailVerificationStatusArgs = {
  email: Scalars['String'];
};


/** Top level node for custom registration form queries */
export type CustomRegistrationFormQuerieslistChildContactsArgs = {
  childId: Scalars['ChildId'];
};


/** Top level node for custom registration form queries */
export type CustomRegistrationFormQuerieslistFormsBySiteSetIdArgs = {
  next?: InputMaybe<Scalars['FormCursor']>;
  onlyPublished?: Scalars['Boolean'];
  onlyShared?: Scalars['Boolean'];
  pageSize?: InputMaybe<Scalars['Int']>;
  siteSetId: Scalars['SiteSetId'];
  sortOrder?: InputMaybe<FormSortOrder>;
};


/** Top level node for custom registration form queries */
export type CustomRegistrationFormQuerieslistSitesArgs = {
  siteSetId: Scalars['SiteSetId'];
};


/** Top level node for custom registration form queries */
export type CustomRegistrationFormQuerieslistSubmissionsArgs = {
  childIds?: InputMaybe<Array<Scalars['ChildId']>>;
  formIds?: InputMaybe<Array<Scalars['CustomRegistrationFormId']>>;
  formTypes?: InputMaybe<Array<CustomRegistrationFormType>>;
  next?: InputMaybe<Scalars['FormSubmissionCursor']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  range?: InputMaybe<ClosedLocalDateRange>;
  siteIds: Array<Scalars['SiteId']>;
  sortOrder?: InputMaybe<FormSubmissionSortOrder>;
};


/** Top level node for custom registration form queries */
export type CustomRegistrationFormQueriesnotificationsEnabledArgs = {
  formId: Scalars['CustomRegistrationFormId'];
  siteId: Scalars['SiteId'];
};


/** Top level node for custom registration form queries */
export type CustomRegistrationFormQueriesnumberOfResponsesArgs = {
  formId: Scalars['CustomRegistrationFormId'];
  siteSetId: Scalars['SiteSetId'];
};


/** Top level node for custom registration form queries */
export type CustomRegistrationFormQueriespreviewArgs = {
  form: CustomRegistrationFormDetailsInput;
  siteSetId: Scalars['SiteSetId'];
};


/** Top level node for custom registration form queries */
export type CustomRegistrationFormQueriespreviewUrlArgs = {
  formId: Scalars['CustomRegistrationFormId'];
  siteSetId: Scalars['SiteSetId'];
};


/** Top level node for custom registration form queries */
export type CustomRegistrationFormQueriespublicDetailsArgs = {
  formId: Scalars['CustomRegistrationFormId'];
  siteSetId: Scalars['SiteSetId'];
};


/** Top level node for custom registration form queries */
export type CustomRegistrationFormQueriespublicSiteSetDetailsArgs = {
  siteSetId: Scalars['SiteSetId'];
};


/** Top level node for custom registration form queries */
export type CustomRegistrationFormQueriespublicSubmissionKeyDetailsArgs = {
  submissionKeyId: Scalars['SubmissionKeyId'];
};


/** Top level node for custom registration form queries */
export type CustomRegistrationFormQueriespublishUrlArgs = {
  formId: Scalars['CustomRegistrationFormId'];
  siteId: Scalars['SiteId'];
  submissionKey?: InputMaybe<Scalars['SubmissionKeyId']>;
};


/** Top level node for custom registration form queries */
export type CustomRegistrationFormQueriesresponsesCsvUrlArgs = {
  formId: Scalars['CustomRegistrationFormId'];
  range?: InputMaybe<ClosedLocalDateRange>;
  siteSetId: Scalars['SiteSetId'];
};


/** Top level node for custom registration form queries */
export type CustomRegistrationFormQueriessubmissionDataArgs = {
  submissionId: Scalars['SubmissionId'];
};


/** Top level node for custom registration form queries */
export type CustomRegistrationFormQueriessubmissionKeyDetailsArgs = {
  siteSetId: Scalars['SiteSetId'];
  submissionKeyId: Scalars['SubmissionKeyId'];
};


/** Top level node for custom registration form queries */
export type CustomRegistrationFormQueriessuccessMessageArgs = {
  formId: Scalars['CustomRegistrationFormId'];
  siteId: Scalars['SiteId'];
};

export enum CustomRegistrationFormSaveStatus {
  CONCURRENT_UPDATE = 'CONCURRENT_UPDATE',
  SUCCESS = 'SUCCESS'
}

/** Details of the registration form section */
export type CustomRegistrationFormSection = {
  __typename?: 'CustomRegistrationFormSection';
  description?: Maybe<Scalars['String']>;
  fields: Array<CustomRegistrationFormField>;
  id: Scalars['CustomRegistrationFormSectionId'];
  name: Scalars['String'];
  sectionType: CustomRegistrationFormSectionType;
};

/** Input type for details of the registration form section */
export type CustomRegistrationFormSectionInput = {
  description?: InputMaybe<Scalars['String']>;
  fields: Array<CustomRegistrationFormInputField>;
  name: Scalars['String'];
  sectionType: CustomRegistrationFormSectionType;
};

export enum CustomRegistrationFormSectionType {
  CHILD = 'CHILD',
  CONTACT = 'CONTACT',
  DOCTOR = 'DOCTOR',
  ENROLLMENT = 'ENROLLMENT',
  HIDDEN = 'HIDDEN',
  SECONDARY_CONTACT = 'SECONDARY_CONTACT'
}

/** Details of the section type used in custom registration form builder */
export type CustomRegistrationFormSectionTypeDescription = {
  __typename?: 'CustomRegistrationFormSectionTypeDescription';
  /**
   *
   * List of field types that may (but do not have to) be included in section of this type.
   *
   */
  allowedFields: Array<CustomRegistrationFormFieldType>;
  /**
   *
   * Defines default name used when creating a section of this type.
   *
   */
  defaultName: Scalars['String'];
  /**
   *
   * List of field types must be included in the section of this type for the form to be considered a valid one.
   *
   */
  mandatoryFields: Array<CustomRegistrationFormFieldType>;
  /**
   *
   * Defines whether a section of this type is allowed to repeat in the form.
   *
   */
  multipleOccurrences: Scalars['Boolean'];
  sectionType: CustomRegistrationFormSectionType;
};

/** Details of form submission key */
export type CustomRegistrationFormSubmissionKey = {
  __typename?: 'CustomRegistrationFormSubmissionKey';
  childId?: Maybe<Scalars['ChildId']>;
  email?: Maybe<Scalars['String']>;
  expiresAt: Scalars['ZonedDateTime'];
  formId: Scalars['CustomRegistrationFormId'];
  id: Scalars['SubmissionKeyId'];
  relationId?: Maybe<Scalars['RelationId']>;
  revoked: Scalars['Boolean'];
  siteId: Scalars['SiteId'];
};

/** Details of form submission key */
export type CustomRegistrationFormSubmissionKeyPublicData = {
  __typename?: 'CustomRegistrationFormSubmissionKeyPublicData';
  expired: Scalars['Boolean'];
  expiresAt: Scalars['ZonedDateTime'];
  id: Scalars['SubmissionKeyId'];
  revoked: Scalars['Boolean'];
};

export enum CustomRegistrationFormType {
  ENROLLMENT = 'ENROLLMENT',
  INTEREST = 'INTEREST',
  REGISTRATION = 'REGISTRATION'
}

export type CustomRegistrationFormsFeatureSettingsFlags = {
  __typename?: 'CustomRegistrationFormsFeatureSettingsFlags';
  /** Returns true if the custom registration forms feature is enabled for this site set. */
  isEnabled: Scalars['Boolean'];
};

/** Details about custom reports settings */
export type CustomReportsSetting = {
  __typename?: 'CustomReportsSetting';
  /** Whether or not custom reports are enabled */
  isEnabled: Scalars['Boolean'];
};

/** Custom status, e.g. playing outside */
export type CustomStatusType = {
  __typename?: 'CustomStatusType';
  icon: Scalars['String'];
  iconColor: Scalars['String'];
  statusConfigId?: Maybe<Scalars['StatusConfigId']>;
  title: Scalars['String'];
};

export type DailyMedicationFormUpdate = {
  __typename?: 'DailyMedicationFormUpdate';
  /** For which day is the form update? */
  day: Scalars['LocalDate'];
  id: Scalars['DailyMedicationFormUpdateId'];
  /** Last administration, if relevant. E.g. when given last at home by parents. */
  lastAdministeredAt?: Maybe<Scalars['LocalDateTime']>;
  medicationForm: MedicationForm;
  /** Optional notes for the form update of the day */
  notes?: Maybe<Scalars['String']>;
  /** When should the medication be administered on that day? */
  times: Array<Scalars['LocalTime']>;
};

/** Daily staff amount per intervals */
export type DailySummary = {
  __typename?: 'DailySummary';
  AM: StaffingDetail;
  PM: StaffingDetail;
};

/** The result of creating a new data export request */
export type DataExportsCreationResult = {
  __typename?: 'DataExportsCreationResult';
  exportRequestId: Scalars['ExportRequestId'];
};

/** The result of querying data export requests */
export type DataExportsListResult = {
  __typename?: 'DataExportsListResult';
  exports: Array<DateExportItem>;
};

/** Mutations related to data exports */
export type DataExportsMutations = {
  __typename?: 'DataExportsMutations';
  /** Create a new data export request for the given entity */
  create: DataExportsCreationResult;
};


/** Mutations related to data exports */
export type DataExportsMutationscreateArgs = {
  entityId: Scalars['UniqueId'];
  entityType: ExportEntityType;
  loginIds: Array<Scalars['LoginId']>;
};

/** Queries related to data exports */
export type DataExportsQueries = {
  __typename?: 'DataExportsQueries';
  /** Lists the export requests for a given entity */
  byEntity: DataExportsListResult;
  /** Lists the export requests for a set of data export request IDs */
  byIds: DataExportsListResult;
  /** Lists the export requests for which the querying user has been added as recipient */
  list: DataExportsListResult;
};


/** Queries related to data exports */
export type DataExportsQueriesbyEntityArgs = {
  entityId: Scalars['UniqueId'];
  entityType: ExportEntityType;
};


/** Queries related to data exports */
export type DataExportsQueriesbyIdsArgs = {
  exportRequestIds: Array<Scalars['ExportRequestId']>;
};

/** A single data export item */
export type DateExportItem = {
  __typename?: 'DateExportItem';
  createdAt: Scalars['ZonedDateTime'];
  createdBy: Person;
  downloadLink?: Maybe<Scalars['String']>;
  expiresAt?: Maybe<Scalars['ZonedDateTime']>;
  exportRequestId: Scalars['ExportRequestId'];
  label: Scalars['String'];
};

export type DateFieldValue = GenericFormFieldValue & {
  __typename?: 'DateFieldValue';
  dateValue: Scalars['LocalDate'];
  fieldTemplate: GenericFormFieldTemplate;
  fieldTemplateId: Scalars['GenericFormFieldTemplateId'];
  fieldType: GenericFormFieldType;
  fieldValueId: Scalars['GenericFormFieldValueId'];
  valueAsString: Scalars['String'];
};

export type DateRangeInput = {
  fromInclusive?: InputMaybe<Scalars['LocalDate']>;
  toInclusive?: InputMaybe<Scalars['LocalDate']>;
};

export type DateTimeFieldValue = GenericFormFieldValue & {
  __typename?: 'DateTimeFieldValue';
  dateTimeValue: Scalars['LocalDateTime'];
  fieldTemplate: GenericFormFieldTemplate;
  fieldTemplateId: Scalars['GenericFormFieldTemplateId'];
  fieldType: GenericFormFieldType;
  fieldValueId: Scalars['GenericFormFieldValueId'];
  valueAsString: Scalars['String'];
};

export type DatevConfiguration = {
  __typename?: 'DatevConfiguration';
  accountNumberLength: Scalars['Int'];
  clientNumber: Scalars['Int'];
  consultantNumber: Scalars['Int'];
  exportType: DatevExportType;
  postingAccount: Scalars['AccountId'];
};

/**
 *
 *
 * The DatevExport type specified in which granularity to export to datev. We support 3 different
 *  granularities:
 *
 *   - One line per invoice
 *   - One line per invoice line
 *   - One line per invoice line item
 *
 *
 */
export enum DatevExportType {
  /** One line per invoice */
  PER_INVOICE = 'PER_INVOICE',
  /** One line per invoice line */
  PER_INVOICE_LINE = 'PER_INVOICE_LINE',
  /** One line per invoice line item */
  PER_INVOICE_LINE_ITEM = 'PER_INVOICE_LINE_ITEM'
}

/** For configuring Datev */
export type DatevMutation = {
  __typename?: 'DatevMutation';
  /** Write Datev configuration for siteset. Will overwrite the exising configuration if one already exists. */
  writeConfiguration: DatevConfiguration;
};


/** For configuring Datev */
export type DatevMutationwriteConfigurationArgs = {
  accountNumberLength: Scalars['Int'];
  clientNumber: Scalars['Int'];
  consultantNumber?: Scalars['Int'];
  exportType: DatevExportType;
  postingAccount: Scalars['AccountId'];
  siteSetId: Scalars['SiteSetId'];
};

/** Top level object for Datev integration */
export type DatevQuery = {
  __typename?: 'DatevQuery';
  /** Get Datev configuration for siteset */
  configuration?: Maybe<DatevConfiguration>;
};


/** Top level object for Datev integration */
export type DatevQueryconfigurationArgs = {
  siteSetId: Scalars['SiteSetId'];
};

export type DayConfigInput = {
  /** Minutes of break, if any */
  breakTimeMinutes?: InputMaybe<Scalars['Int']>;
  /** Date to start this schedule */
  startDate: Scalars['LocalDate'];
  /** Time slots by group, shouldn't overlap */
  timeSlots: Array<TimeSlotConfigInput>;
};

export type DayMealPlanInput = {
  day: Scalars['DayOfWeek'];
  meals: Array<MealTypeItemsInput>;
  week: Scalars['Int'];
};

export enum DayOfTheWeek {
  FRIDAY = 'FRIDAY',
  MONDAY = 'MONDAY',
  SATURDAY = 'SATURDAY',
  SUNDAY = 'SUNDAY',
  THURSDAY = 'THURSDAY',
  TUESDAY = 'TUESDAY',
  WEDNESDAY = 'WEDNESDAY'
}

/** Management queries */
export type DaycareManagementQueries = {
  __typename?: 'DaycareManagementQueries';
  employees: EmployeesManagementType;
};


/** Management queries */
export type DaycareManagementQueriesemployeesArgs = {
  siteSetId: Scalars['SiteSetId'];
};

export type DaysStats = {
  __typename?: 'DaysStats';
  absentTotal: Scalars['Int'];
  plannedTotal: Scalars['Int'];
  presentPct: Scalars['Float'];
  presentTotal: Scalars['Int'];
};

export type DebtCollectionBannerResult = {
  __typename?: 'DebtCollectionBannerResult';
  daysUntilDisabled: Scalars['Int'];
};

export type DeleteMediaInput = {
  children: Array<Scalars['ChildId']>;
  mediaId: Scalars['MediaId'];
};

/** Result of delete operation */
export type DeletedPayment = {
  __typename?: 'DeletedPayment';
  id: Scalars['PaymentId'];
};

export enum DeletionEntity {
  BILL_PAYER = 'BILL_PAYER',
  CHILD = 'CHILD',
  EMPLOYEE = 'EMPLOYEE',
  INQUIRY = 'INQUIRY',
  LOGIN = 'LOGIN',
  MESSAGE = 'MESSAGE',
  ORGANIZATION_PERSON = 'ORGANIZATION_PERSON',
  POST_MEDIA = 'POST_MEDIA'
}

/** Result of deleting Kita-Planer credentials */
export type DeletionResult = {
  __typename?: 'DeletionResult';
  institutionId: Scalars['InstitutionId'];
};

export enum DeletionStrategy {
  ANONYMIZE = 'ANONYMIZE',
  REMOVE = 'REMOVE'
}

export type DemoNurseryCreationInput = {
  deviceHeight?: InputMaybe<Scalars['Long']>;
  deviceWidth?: InputMaybe<Scalars['Long']>;
  featureInterests?: InputMaybe<Array<FeatureInterest>>;
  institutionName?: InputMaybe<Scalars['String']>;
  ownInterest?: InputMaybe<Scalars['String']>;
  packageId: Scalars['PackageId'];
  signupInstitutionType?: InputMaybe<InstitutionType>;
  signupRole?: InputMaybe<SignupRole>;
  touchDevice?: InputMaybe<Scalars['Boolean']>;
  userAgent?: InputMaybe<Scalars['String']>;
};

export type DemoVideo = {
  __typename?: 'DemoVideo';
  url: Scalars['String'];
};

/** A department is a grouping of groups */
export type Department = {
  __typename?: 'Department';
  departmentId: Scalars['DepartmentId'];
  institutionId: Scalars['InstitutionId'];
  title: Scalars['Title'];
};

/** Mutations related to departments */
export type DepartmentMutations = {
  __typename?: 'DepartmentMutations';
  create: Department;
  delete: Scalars['Int'];
  update: Department;
};


/** Mutations related to departments */
export type DepartmentMutationscreateArgs = {
  institutionId: Scalars['InstitutionId'];
  title: Scalars['Title'];
};


/** Mutations related to departments */
export type DepartmentMutationsdeleteArgs = {
  departmentId: Scalars['DepartmentId'];
  institutionId: Scalars['InstitutionId'];
};


/** Mutations related to departments */
export type DepartmentMutationsupdateArgs = {
  departmentId: Scalars['DepartmentId'];
  institutionId: Scalars['InstitutionId'];
  title: Scalars['Title'];
};

/** Mutations of institution's description */
export type DescriptionMutations = {
  __typename?: 'DescriptionMutations';
  updateDescription: Scalars['InstitutionId'];
};


/** Mutations of institution's description */
export type DescriptionMutationsupdateDescriptionArgs = {
  description?: InputMaybe<Scalars['String']>;
  institutionId: Scalars['InstitutionId'];
};

export type Device = {
  __typename?: 'Device';
  pinUsers: Array<PinUser>;
};


export type DevicepinUsersArgs = {
  deviceId: Scalars['DeviceId'];
};

/** The instruction/mandate to allow creation of a Direct Debit (BACS) payments source */
export type DirectDebitInstruction = {
  __typename?: 'DirectDebitInstruction';
  accountHolder: Scalars['String'];
  accountNumber: Scalars['String'];
  addressCity: Scalars['String'];
  addressCountry: Scalars['String'];
  addressStreet: Scalars['String'];
  addressZip: Scalars['String'];
  confirmed: Scalars['Boolean'];
  createdAtUTC: Scalars['ZonedDateTime'];
  id: Scalars['DirectDebitInstructionId'];
  mandate_url?: Maybe<Scalars['String']>;
  owner?: Maybe<Login>;
  reference?: Maybe<Scalars['String']>;
  sortCode: Scalars['String'];
};

export type DismissCategoryLandingPageTypeV1 = {
  __typename?: 'DismissCategoryLandingPageTypeV1';
  categoryLandingPage: Category;
  loginId: Scalars['LoginId'];
};

export type DismissItem = {
  __typename?: 'DismissItem';
  item: Scalars['Boolean'];
};


export type DismissItemitemArgs = {
  type: DismissibleItemType;
};

/** Result of dismissing foreign IDs */
export type DismissedData = {
  __typename?: 'DismissedData';
  /** Dismissed foreign IDs */
  dismissedIds: Array<Scalars['String']>;
};

export enum DismissibleItemType {
  FAMLY_PAY_SETUP = 'FAMLY_PAY_SETUP',
  SUBSCRIPTION_UPSELL = 'SUBSCRIPTION_UPSELL'
}

/** A document in the Documents app. */
export type Document = {
  __typename?: 'Document';
  description: Scalars['String'];
  documentId: Scalars['DocumentId'];
  fileId: Scalars['FileId'];
  fileURL: Scalars['String'];
  folderId?: Maybe<Scalars['FolderId']>;
  institutionId: Scalars['InstitutionId'];
  title: Scalars['String'];
  updatedAt: Scalars['ZonedDateTime'];
};

export type DocumentInput = {
  description: Scalars['String'];
  documentId?: InputMaybe<Scalars['DocumentId']>;
  fileId: Scalars['FileId'];
  folderId?: InputMaybe<Scalars['FolderId']>;
  institutionId: Scalars['InstitutionId'];
  title: Scalars['String'];
};

export type DocumentMutations = {
  __typename?: 'DocumentMutations';
  remove: Array<Scalars['DocumentId']>;
  update: Array<Document>;
};


export type DocumentMutationsremoveArgs = {
  documentIds: Array<Scalars['DocumentId']>;
};


export type DocumentMutationsupdateArgs = {
  documents: Array<DocumentInput>;
};

/** Objects related to mutating documents */
export type DocumentsMutations = {
  __typename?: 'DocumentsMutations';
  documents: DocumentMutations;
  folders: FoldersMutation;
};

export enum Domain {
  BillPayer = 'BillPayer',
  Child = 'Child',
  ChildPresence = 'ChildPresence',
  Contact = 'Contact',
  Invoice = 'Invoice',
  Payment = 'Payment',
  Room = 'Room'
}

export enum DoseType {
  ALL_EXEMPTED = 'ALL_EXEMPTED',
  EXEMPTED = 'EXEMPTED',
  GIVEN = 'GIVEN'
}

export type DoubleBookingType = {
  __typename?: 'DoubleBookingType';
  shiftA: ShiftTypeV3;
  shiftB: ShiftTypeV3;
};

export type DraftShiftManagementType = {
  __typename?: 'DraftShiftManagementType';
  canBulkDelete: Scalars['Boolean'];
  canCreate: Scalars['Boolean'];
  canDelete: Scalars['Boolean'];
  canEdit: Scalars['Boolean'];
  canView: Scalars['Boolean'];
};

/** A fake account for test purposes */
export type DummyAccount = PaymentsAccount & {
  __typename?: 'DummyAccount';
  /** Which payment provider this account is created for */
  accountType: PaymentsAccountType;
  /** Behaviors for this account */
  behaviors: Array<Behavior>;
  /** The potential deadline for new account information required. */
  dueBy?: Maybe<Scalars['ZonedDateTime']>;
  enabledParentFeeSourceTypes: Array<PaymentsSourceType>;
  enabledPaymentSourceTypes: Array<PaymentsSourceType>;
  /** Details about fees for the account */
  fees: Array<FeeDetails>;
  flexPay: PaymentsAccountFlexPay;
  /**
   * The minimum amount which should be paid with flexible payment, or null if flexible payment isn't enabled.
   * @deprecated Use flexPay.minPaymentAmount instead.
   */
  flexPayMinAmount?: Maybe<Scalars['BadMoney']>;
  institutionSetId: Scalars['InstitutionSetId'];
  paymentsAccountId: Scalars['PaymentsAccountId'];
  /** Whether this account can receive payments */
  paymentsEnabled: Scalars['Boolean'];
  /** Whether this account can receive payouts (withdraw money) */
  payoutsEnabled: Scalars['Boolean'];
  /** The current status of the account */
  status: AccountStatus;
  /** A detailed message behind the current status */
  statusMessage: Scalars['String'];
};

/** The earliest date parent can book meals for a child. */
export type EarliestDateToBook = {
  __typename?: 'EarliestDateToBook';
  date: Scalars['LocalDate'];
};

export type EditableLibrary = {
  __typename?: 'EditableLibrary';
  isEditable: Scalars['Boolean'];
  library: InstitutionActivityLibrary;
};

export type EditableLibraryV2 = {
  __typename?: 'EditableLibraryV2';
  isEditable: Scalars['Boolean'];
  library: ActivityLibrary;
};

/** Information about the eligibility of a SiteSet for a Sidekick add-on. */
export type EligibleForAddOn = {
  __typename?: 'EligibleForAddOn';
  siteSetId: Scalars['SiteSetId'];
};

export type EmailResult = {
  __typename?: 'EmailResult';
  errorMessage?: Maybe<Scalars['String']>;
  formName?: Maybe<Scalars['String']>;
  recipientEmail?: Maybe<Scalars['String']>;
  recipientName?: Maybe<Scalars['String']>;
  status: CustomRegistrationFormSaveStatus;
};

export enum EmailVerificationResultCode {
  EXPIRED = 'EXPIRED',
  INVALID_CODE = 'INVALID_CODE',
  OK = 'OK'
}

export enum EmailVerificationStatus {
  EXPIRED = 'EXPIRED',
  NOT_VERIFIED = 'NOT_VERIFIED',
  PENDING_VERIFICATION = 'PENDING_VERIFICATION',
  VERIFIED = 'VERIFIED'
}

/** Someone who works in an institution */
export type Employee = {
  __typename?: 'Employee';
  /** The address of the employee */
  address?: Maybe<Address>;
  /** The date of birth for the employee */
  birthDate?: Maybe<Scalars['LocalDate']>;
  /** Custom ID for an employee, assigned by external system. */
  customEmployeeId?: Maybe<Scalars['String']>;
  /** The email of the employee */
  email?: Maybe<Scalars['EmailAddress']>;
  /** The date the employee starts working */
  firstDay: Scalars['LocalDate'];
  /** The group the employee belongs to */
  group: Group;
  /** The group the employee belongs to */
  groupId: Scalars['GroupId'];
  /** The Famly ID for the employee */
  id: Scalars['EmployeeId'];
  /** The last day the employee works at the site */
  lastDay?: Maybe<Scalars['LocalDate']>;
  /** The name of the employee */
  name: Name;
  /** The phone number of the employee */
  phoneNumber?: Maybe<PhoneNumberType>;
  /** The employees profile image */
  profileImage?: Maybe<ProfileImage>;
  /**
   * The role, if any, granted to this employee
   * @deprecated Please use `roleId` instead
   */
  role?: Maybe<EmployeeAssignee>;
  /** The role, if any, granted to this employee */
  roleId?: Maybe<Scalars['RoleId']>;
  /** The site this employee works at */
  siteId: Scalars['SiteId'];
  /** The title of the employee, e.g. 'Temp staff' */
  title?: Maybe<Scalars['String']>;
};

/** An employee at a given institution */
export type EmployeeAssignee = RoleAssignee & {
  __typename?: 'EmployeeAssignee';
  employeeId: Scalars['EmployeeId'];
  institutionSetId: Scalars['InstitutionSetId'];
  person: Person;
  /** The ID of the role that has been assigned */
  roleId: Scalars['RoleId'];
};

export type EmployeeAttendanceInput = {
  /** Attendance date-time range */
  dateTimeRange: NonEmptyLocalDateTimeRangeInput;
  /** Staff member id */
  employeeId: Scalars['EmployeeId'];
  /** Room id of attendance */
  groupId: Scalars['GroupId'];
};

export type EmployeeCheckInFeatureSettingsFlags = {
  __typename?: 'EmployeeCheckInFeatureSettingsFlags';
  /** Returns true if this feature can be enabled by a user. */
  canOptIn: Scalars['Boolean'];
  /** Returns true if this feature is currently enabled. */
  isEnabled: Scalars['Boolean'];
};

/** Checkin statement for an employee */
export type EmployeeCheckinStatement = {
  __typename?: 'EmployeeCheckinStatement';
  statementId: Scalars['String'];
  title: Scalars['String'];
  type: Scalars['String'];
};

export type EmployeeInput = {
  address?: InputMaybe<AddressInput>;
  birthDate?: InputMaybe<Scalars['LocalDate']>;
  customEmployeeId?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['EmailAddress']>;
  firstDay: Scalars['LocalDate'];
  groupId: Scalars['GroupId'];
  institutionId: Scalars['InstitutionId'];
  lastDay?: InputMaybe<Scalars['LocalDate']>;
  name: Scalars['String'];
  phoneNumber?: InputMaybe<Scalars['String']>;
  roleId?: InputMaybe<Scalars['RoleId']>;
  title?: InputMaybe<Scalars['String']>;
};

export type EmployeeLeaveRangeInput = {
  /** Staff member id */
  employeeId: Scalars['EmployeeId'];
  /** Optional end time of the leave. Must be provided for hourly leaves. */
  endTime?: InputMaybe<Scalars['LocalDateTime']>;
  /** Optional staff leave subtype id */
  leaveSubTypeId?: InputMaybe<Scalars['StaffLeaveSubTypeId']>;
  /** Type of leaves for staff */
  leaveType: StaffLeaveType;
  /** Optional management note */
  managementNote?: InputMaybe<Scalars['String']>;
  /** Optional note */
  note?: InputMaybe<Scalars['String']>;
  /** Date range when employee is not expected */
  range: ClosedLocalDateRange;
  /** Optional start time of the leave. Must be provided for hourly leaves. */
  startTime?: InputMaybe<Scalars['LocalDateTime']>;
  /** Optional total hours of leave. Distributed evenly across all days. */
  totalHours?: InputMaybe<Scalars['Float']>;
};

/** For managing employees */
export type EmployeeMutations = {
  __typename?: 'EmployeeMutations';
  /** Create one or more employees */
  create: Array<Employee>;
  /**
   * Delete one or more employees.
   *       |Permanently deletes the data related to the employees with the given `employeeIds`. This includes but is not limited to:
   *       |* Profile information
   *       |* Role assignments
   *       |* Qualification data
   *       |* Checkin data
   *       |* Leave data
   *       |* Staff rota data
   *       |
   *       |NOTE: This action is irreversible. Data *cannot* be retrieved afterwards.
   *       |
   */
  delete: Array<Scalars['EmployeeId']>;
  /**
   * Update one or more employees.
   * You can use `employees` to update a full employee, or one of the arguments, e.g. `roles`, to update a single field
   *
   */
  update: Array<Employee>;
};


/** For managing employees */
export type EmployeeMutationscreateArgs = {
  employees: Array<EmployeeInput>;
};


/** For managing employees */
export type EmployeeMutationsdeleteArgs = {
  employeeIds: Array<Scalars['EmployeeId']>;
};


/** For managing employees */
export type EmployeeMutationsupdateArgs = {
  addresses?: InputMaybe<Array<EmployeeUpdateAddress>>;
  birthDates?: InputMaybe<Array<EmployeeUpdateBirthDate>>;
  customEmployeeIds?: InputMaybe<Array<EmployeeUpdateCustomEmployeeId>>;
  emails?: InputMaybe<Array<EmployeeUpdateEmail>>;
  employees?: InputMaybe<Array<EmployeeUpdate>>;
  firstAndLastDays?: InputMaybe<Array<EmployeeUpdateRange>>;
  groups?: InputMaybe<Array<EmployeeUpdateGroupId>>;
  names?: InputMaybe<Array<EmployeeUpdateName>>;
  phones?: InputMaybe<Array<EmployeeUpdatePhone>>;
  roles?: InputMaybe<Array<EmployeeUpdateRoleId>>;
  titles?: InputMaybe<Array<EmployeeUpdateTitle>>;
};

export type EmployeePeriodMutations = {
  __typename?: 'EmployeePeriodMutations';
  /** Create a new period for KiBiG employee funding data */
  createEmployeePeriod: KibigEmployeePeriod;
  /** Delete a period for KiBiG employee funding data */
  deleteEmployeePeriod: Scalars['Boolean'];
  /** Update a period for KiBiG employee funding data */
  updateEmployeePeriod: KibigEmployeePeriod;
};


export type EmployeePeriodMutationscreateEmployeePeriodArgs = {
  comment?: InputMaybe<Scalars['String']>;
  employeeId: Scalars['EmployeeId'];
  hoursWeekly: Scalars['BigDecimal'];
  institutionId: Scalars['InstitutionId'];
  kibigEmployeeId?: InputMaybe<Scalars['String']>;
  planningEnd: KibigPlanEnd;
  planningStart: KibigPlanStart;
  qualificationId: Scalars['KibigQualificationId'];
  validFrom: Scalars['LocalDate'];
};


export type EmployeePeriodMutationsdeleteEmployeePeriodArgs = {
  employeePeriodId: Scalars['KibigEmployeePeriodId'];
};


export type EmployeePeriodMutationsupdateEmployeePeriodArgs = {
  comment?: InputMaybe<Scalars['String']>;
  employeePeriodId: Scalars['KibigEmployeePeriodId'];
  hoursWeekly: Scalars['BigDecimal'];
  kibigEmployeeId?: InputMaybe<Scalars['String']>;
  planningEnd: KibigPlanEnd;
  planningStart: KibigPlanStart;
  qualificationId: Scalars['KibigQualificationId'];
  validFrom: Scalars['LocalDate'];
};

/** Staff member records by day regardless the group */
export type EmployeeRecordsByDay = RecordsByDay & {
  __typename?: 'EmployeeRecordsByDay';
  attendance: Array<StaffMemberAttendanceRecord>;
  date: Scalars['LocalDate'];
  leaves: Array<StaffMemberLeaves>;
  minutesBreak?: Maybe<Scalars['Int']>;
  minutesOverview: StaffMemberSummarizedMinutes;
  schedule: Array<StaffMemberScheduleRecord>;
};

export type EmployeeUpdate = {
  address?: InputMaybe<AddressInput>;
  birthDate?: InputMaybe<Scalars['LocalDate']>;
  customEmployeeId?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['EmailAddress']>;
  employeeId: Scalars['EmployeeId'];
  firstDay: Scalars['LocalDate'];
  groupId: Scalars['GroupId'];
  lastDay?: InputMaybe<Scalars['LocalDate']>;
  name: Scalars['String'];
  phoneNumber?: InputMaybe<Scalars['String']>;
  roleId?: InputMaybe<Scalars['RoleId']>;
  title?: InputMaybe<Scalars['String']>;
};

export type EmployeeUpdateAddress = {
  address?: InputMaybe<AddressInput>;
  employeeId: Scalars['EmployeeId'];
};

export type EmployeeUpdateBirthDate = {
  birthDate?: InputMaybe<Scalars['LocalDate']>;
  employeeId: Scalars['EmployeeId'];
};

export type EmployeeUpdateCustomEmployeeId = {
  customEmployeeId?: InputMaybe<Scalars['String']>;
  employeeId: Scalars['EmployeeId'];
};

export type EmployeeUpdateEmail = {
  email?: InputMaybe<Scalars['EmailAddress']>;
  employeeId: Scalars['EmployeeId'];
};

export type EmployeeUpdateGroupId = {
  employeeId: Scalars['EmployeeId'];
  groupId: Scalars['GroupId'];
};

export type EmployeeUpdateName = {
  employeeId: Scalars['EmployeeId'];
  name: Scalars['NameInput'];
};

export type EmployeeUpdatePhone = {
  employeeId: Scalars['EmployeeId'];
  phone?: InputMaybe<Scalars['PhoneNumber']>;
};

export type EmployeeUpdateRange = {
  employeeId: Scalars['EmployeeId'];
  range: ClosedLocalDateRange;
};

export type EmployeeUpdateRoleId = {
  employeeId: Scalars['EmployeeId'];
  roleId?: InputMaybe<Scalars['RoleId']>;
};

export type EmployeeUpdateTitle = {
  employeeId: Scalars['EmployeeId'];
  title?: InputMaybe<Scalars['String']>;
};

/** A limited representation of an employee containing only the name and ID. */
export type EmployeeWitness = {
  __typename?: 'EmployeeWitness';
  /** The Famly ID for the employee */
  id: Scalars['EmployeeId'];
  /** The name of the employee */
  name: Name;
};

export type EmployeesManagementType = {
  __typename?: 'EmployeesManagementType';
  canView: Scalars['Boolean'];
};

/** Paged results for employees (Not currently paged) */
export type EmployeesResult = {
  __typename?: 'EmployeesResult';
  employees: Array<Employee>;
};

export type EmployeesWithAssignedShiftsType = {
  __typename?: 'EmployeesWithAssignedShiftsType';
  assignedShifts: Array<AssignedShiftsType>;
  /** @deprecated Refactored Data */
  days: Array<AssignedShiftsType>;
  employee?: Maybe<Employee>;
  /** @deprecated Refactored Data */
  employeeId: Scalars['EmployeeId'];
  /** @deprecated Refactored Data */
  name: Name;
  scheduledMinutes: Scalars['Int'];
  /** @deprecated Refactored Data */
  scheduledMinutesInDateRange: Scalars['Int'];
};

export type EmptyStateAssets = {
  __typename?: 'EmptyStateAssets';
  /** Determines whether the user can see 'Show me how this works' button in some empty states */
  howThisWorksVideo?: Maybe<Scalars['String']>;
  learnMore: LearnMore;
};

export type EmptyStateChildAttendanceResultType = {
  __typename?: 'EmptyStateChildAttendanceResultType';
  canCreateChildren: Scalars['Boolean'];
  showEmptyState: Scalars['Boolean'];
};

export type EmptyStateCustomRegistrationFormsResultType = {
  __typename?: 'EmptyStateCustomRegistrationFormsResultType';
  canCreateCustomRegistrationForms: Scalars['Boolean'];
  showEmptyState: Scalars['Boolean'];
};

export type EmptyStateFutureAvailabilityResultType = {
  __typename?: 'EmptyStateFutureAvailabilityResultType';
  canAddBookingPlans: Scalars['Boolean'];
  showEmptyState: Scalars['Boolean'];
};

export type EmptyStateInquiriesResultType = {
  __typename?: 'EmptyStateInquiriesResultType';
  canCreateCustomRegistrationForms: Scalars['Boolean'];
  hasCustomRegistrationForms: Scalars['Boolean'];
  showEmptyState: Scalars['Boolean'];
};

export type EmptyStateOccupancyReportResultType = {
  __typename?: 'EmptyStateOccupancyReportResultType';
  canAddBookingPlans: Scalars['Boolean'];
  showEmptyState: Scalars['Boolean'];
};

export enum EmptyStatePage {
  Accidents = 'Accidents',
  ActivityPlanner = 'ActivityPlanner',
  Calendar = 'Calendar',
  ChildAttendance = 'ChildAttendance',
  ChildDevelopmentOverview = 'ChildDevelopmentOverview',
  ChildrenOverview = 'ChildrenOverview',
  DebtCollection = 'DebtCollection',
  Documents = 'Documents',
  Enquiries = 'Enquiries',
  Family = 'Family',
  Forms = 'Forms',
  FutureAvailability = 'FutureAvailability',
  Headcounts = 'Headcounts',
  HolidayRSVP = 'HolidayRSVP',
  InAppPayments = 'InAppPayments',
  IncidentReports = 'IncidentReports',
  Invoicing = 'Invoicing',
  Journey = 'Journey',
  Lists = 'Lists',
  MealPlans = 'MealPlans',
  Medication = 'Medication',
  MedicationForms = 'MedicationForms',
  Messages = 'Messages',
  Notes = 'Notes',
  Notifications = 'Notifications',
  Occupancy = 'Occupancy',
  ParentalPermissions = 'ParentalPermissions',
  Payments = 'Payments',
  Plans = 'Plans',
  ProgressReport = 'ProgressReport',
  PublicFunding = 'PublicFunding',
  Purchases = 'Purchases',
  RoomPlanner = 'RoomPlanner',
  StaffLeave = 'StaffLeave',
  StaffingOverview = 'StaffingOverview',
  Tally = 'Tally',
  TwoYearChecks = 'TwoYearChecks',
  WhatsNext = 'WhatsNext'
}

export type EmptyStateRoomPlannerResultType = {
  __typename?: 'EmptyStateRoomPlannerResultType';
  showEmptyState: Scalars['Boolean'];
};


export type EmptyStateRoomPlannerResultTypeshowEmptyStateArgs = {
  siteSetId: Scalars['SiteSetId'];
};

export type EmptyStateStaffLeaveResultType = {
  __typename?: 'EmptyStateStaffLeaveResultType';
  canManageFeatures: Scalars['Boolean'];
  showEmptyState: Scalars['Boolean'];
};

export enum EntryType {
  CHILDNOTE_CHANGED = 'CHILDNOTE_CHANGED',
  CHILDNOTE_CREATED = 'CHILDNOTE_CREATED',
  CHILDNOTE_DELETED = 'CHILDNOTE_DELETED'
}

export type ExactAttendanceFeatureSettingsFlags = {
  __typename?: 'ExactAttendanceFeatureSettingsFlags';
  /** Returns true if this feature can be enabled by a user. */
  canOptIn: Scalars['Boolean'];
  /** Returns true if this feature is currently enabled. */
  isEnabled: Scalars['Boolean'];
};

export enum ExceptionReasons {
  OnLeave = 'OnLeave'
}

export type ExpectationInputType = {
  features: Array<Scalars['String']>;
  id: ExpectationType;
};

export enum ExpectationType {
  ALL_IN_EARLY_CHILDHOOD_PLATFORM = 'ALL_IN_EARLY_CHILDHOOD_PLATFORM',
  CHILD_DEVELOPMENT = 'CHILD_DEVELOPMENT',
  EASY_WAYS_TO_GROW_YOUR_OCCUPANCY = 'EASY_WAYS_TO_GROW_YOUR_OCCUPANCY',
  ENGAGE_AND_COMMUNICATE_WITH_FAMILIES = 'ENGAGE_AND_COMMUNICATE_WITH_FAMILIES',
  FINANCES = 'FINANCES',
  PARENT_COMMUNICATION = 'PARENT_COMMUNICATION',
  REGISTERS = 'REGISTERS',
  SAVE_HOURS_AND_SIMPLIFY_YOUR_ADMIN = 'SAVE_HOURS_AND_SIMPLIFY_YOUR_ADMIN',
  STAFFING = 'STAFFING',
  STAY_ON_TOP_OF_EACH_CHILDS_LEARNING = 'STAY_ON_TOP_OF_EACH_CHILDS_LEARNING'
}

export type ExpectedChildrenType = {
  __typename?: 'ExpectedChildrenType';
  childrenByAgeGroups: Array<ChildrenByAgeGroupType>;
  total: Scalars['Int'];
};

export type ExpectedReason = ExpectedReasonCheckin | ExpectedReasonSession;

export type ExpectedReasonCheckin = {
  __typename?: 'ExpectedReasonCheckin';
  range: TimeRangeClosedLocalTime;
};

export type ExpectedReasonSession = {
  __typename?: 'ExpectedReasonSession';
  attendanceScheduleId?: Maybe<Scalars['AttendanceScheduleId']>;
  range: TimeRangeClosedLocalTime;
  sessionType: ExpectedReasonSessionType;
};

export enum ExpectedReasonSessionType {
  Plan = 'Plan',
  Purchase = 'Purchase'
}

export type Experiments = {
  __typename?: 'Experiments';
  assistedChildImportServiceOffering: AssistedChildImportServiceOffering;
};

/** Child data from the export from Kita-Planer */
export type ExportDataChild = {
  __typename?: 'ExportDataChild';
  child: KitaPlanerChild;
  idData: KitaPlanerIdData;
  parent1: KitaPlanerParent;
  parent2?: Maybe<KitaPlanerParent>;
};

/** Children data that can not be imported directly into Famly */
export type ExportDataChildOutputWithError = {
  __typename?: 'ExportDataChildOutputWithError';
  importErrors: Array<ImportError>;
  inputData: ExportDataChild;
};

/** Result of the export from Kita-Planer */
export type ExportDataOutput = {
  __typename?: 'ExportDataOutput';
  dataWithErrors: Array<ExportDataChildOutputWithError>;
  importObjectInput: Array<ImportObjectInputResult>;
  successfulExport: Scalars['Boolean'];
};

export enum ExportEntityType {
  BILL_PAYER = 'BILL_PAYER',
  BILL_PAYER_INVOICES = 'BILL_PAYER_INVOICES',
  CHILD = 'CHILD',
  CHILD_TAGGED_IMAGES = 'CHILD_TAGGED_IMAGES',
  LOGIN = 'LOGIN',
  LOGIN_POST_MEDIA = 'LOGIN_POST_MEDIA',
  SITE = 'SITE',
  SITE_MEDIA = 'SITE_MEDIA',
  STAFF = 'STAFF'
}

export type ExportMutations = {
  __typename?: 'ExportMutations';
  /** Export bill payers */
  billPayers: BillPayerExportResult;
  /** Export invoices */
  invoices: InvoiceExportResult;
};


export type ExportMutationsbillPayersArgs = {
  billPayers: Array<BillPayerExportInputType>;
};


export type ExportMutationsinvoicesArgs = {
  invoices: Array<InvoiceExportInputType>;
};

/** List of invoice exports */
export type ExportResult = {
  __typename?: 'ExportResult';
  downloadUrl?: Maybe<Scalars['String']>;
  fileCreatedAt?: Maybe<Scalars['LocalDate']>;
  format: InvoiceExportFormat;
  generationId: Scalars['String'];
  includes: InvoiceExportIncludes;
  invoiceCreatedFrom?: Maybe<Scalars['LocalDate']>;
  invoiceCreatedTo?: Maybe<Scalars['LocalDate']>;
  invoicingDateFrom?: Maybe<Scalars['LocalDate']>;
  invoicingDateTo?: Maybe<Scalars['LocalDate']>;
  status: ExportStatus;
};

/** Status of invoice export */
export type ExportStatus = {
  __typename?: 'ExportStatus';
  progress?: Maybe<Scalars['Int']>;
  status: InvoiceExportStatusValue;
};

/** returns a response of an export to kinder connect */
export type ExportToKinderConnectResultType = {
  __typename?: 'ExportToKinderConnectResultType';
  attendanceList: Array<KinderAttendanceRecordType>;
  errors?: Maybe<Array<Scalars['String']>>;
  response: KinderConnectUploadResponse;
};

export type ExportedBillPayer = {
  __typename?: 'ExportedBillPayer';
  billPayerId: Scalars['BillPayerId'];
};

export type ExportedInvoice = {
  __typename?: 'ExportedInvoice';
  invoiceId: Scalars['InvoiceId'];
};

export type ExportsQueries = {
  __typename?: 'ExportsQueries';
  csv: Scalars['String'];
  issues: Array<FamlyError>;
  list: Array<ExportResult>;
};


export type ExportsQueriescsvArgs = {
  billPayerIds?: InputMaybe<Array<Scalars['BillPayerId']>>;
  createdFrom?: InputMaybe<Scalars['LocalDate']>;
  createdTo?: InputMaybe<Scalars['LocalDate']>;
  from: Scalars['LocalDate'];
  institutionIds: Array<Scalars['InstitutionId']>;
  to: Scalars['LocalDate'];
};


export type ExportsQueriesissuesArgs = {
  billPayerIds?: InputMaybe<Array<Scalars['BillPayerId']>>;
  createdFrom?: InputMaybe<Scalars['LocalDate']>;
  createdTo?: InputMaybe<Scalars['LocalDate']>;
  from: Scalars['LocalDate'];
  institutionIds: Array<Scalars['InstitutionId']>;
  to: Scalars['LocalDate'];
};


export type ExportsQuerieslistArgs = {
  institutionSetId: Scalars['InstitutionSetId'];
};

export type ExternalSiblingLink = SiblingLink & {
  __typename?: 'ExternalSiblingLink';
  /** Can be null if the sibling link is internal and the sibling doesn't have a birthday */
  birthDate?: Maybe<Scalars['LocalDate']>;
  /** Will be null if not set. */
  endDate?: Maybe<Scalars['LocalDate']>;
  id: Scalars['SiblingLinkId'];
  name: Name;
  /** The start date for the sibling (optional for external siblings) */
  startDate?: Maybe<Scalars['LocalDate']>;
};

export type ExternalSiblingLinkInput = {
  birthDate: Scalars['LocalDate'];
  endDate?: InputMaybe<Scalars['LocalDate']>;
  name: Scalars['NameInput'];
  startDate?: InputMaybe<Scalars['LocalDate']>;
};

export enum ExternalSystemName {
  /** Integration with custom systems */
  CUSTOM = 'CUSTOM',
  /** Integration with QuickBooks */
  QUICKBOOKS = 'QUICKBOOKS',
  /** Integration with an unknown system */
  UNKNOWN = 'UNKNOWN',
  /** Integration with Xero */
  XERO = 'XERO',
  /** Integration with XLedger */
  XLEDGER = 'XLEDGER'
}

/** Return object of the First Steps subscription confirmation flow */
export type FSConfirmSubscription = {
  __typename?: 'FSConfirmSubscription';
  createdSubscriptionPackageId?: Maybe<Scalars['PackageId']>;
};

/** Mutations for First Steps confirm subscription flow */
export type FSConfirmSubscriptionFlowMutations = {
  __typename?: 'FSConfirmSubscriptionFlowMutations';
  /** @deprecated FS confirm subscription flow was only available until December 9th 2022 */
  confirmSubscription: FSConfirmSubscription;
};


/** Mutations for First Steps confirm subscription flow */
export type FSConfirmSubscriptionFlowMutationsconfirmSubscriptionArgs = {
  billingCycle: BillingCycle;
  institutionSetId: Scalars['InstitutionSetId'];
  packageId: Scalars['PackageId'];
};

/** Object node for First Steps confirm subscription flow */
export type FSConfirmSubscriptionFlowObject = {
  __typename?: 'FSConfirmSubscriptionFlowObject';
  /**
   * Returns the siteSetId that the First Steps confirm subscription flow is applicable for (or null)
   * @deprecated FS confirm subscription flow was only available until December 9th 2022
   */
  availableSiteSetId?: Maybe<Scalars['InstitutionSetId']>;
  /**
   * Determines whether the user can see the First Steps confirm subscription flow
   * @deprecated FS confirm subscription flow was only available until December 9th 2022
   */
  canAccess: Scalars['Boolean'];
};

/** Top level node for FTE queries */
export type FTEQueries = {
  __typename?: 'FTEQueries';
  generic: GenericFTEQueries;
  session: SessionFTEQueries;
};

/** Queries for the Facebook integration */
export type FacebookIntegration = {
  __typename?: 'FacebookIntegration';
  /** List the Facebook pages that Famly has been given access to by this user */
  availablePages: FacebookPages;
  /** List the Facebook pages that are linked to InstitutionSetIds */
  linkedPages: FacebookLinkedPages;
};


/** Queries for the Facebook integration */
export type FacebookIntegrationlinkedPagesArgs = {
  institutionSetIds: Array<Scalars['InstitutionSetId']>;
};

/** Integrating with facebook */
export type FacebookIntegrationMutation = {
  __typename?: 'FacebookIntegrationMutation';
  /** Add pages to an InstitutionSetId */
  addPages: FacebookLinkedPages;
  /** Remove Facebook pages and all links to posts */
  removePages: FacebookRemovePages;
  /** Store a short-lived user access token for this loginId */
  saveToken: TokenResult;
};


/** Integrating with facebook */
export type FacebookIntegrationMutationaddPagesArgs = {
  institutionSetId: Scalars['InstitutionSetId'];
  pageIds: Array<Scalars['String']>;
};


/** Integrating with facebook */
export type FacebookIntegrationMutationremovePagesArgs = {
  tokenIds: Array<Scalars['FacebookAccessTokenId']>;
};


/** Integrating with facebook */
export type FacebookIntegrationMutationsaveTokenArgs = {
  code: Scalars['String'];
  redirectUri: Scalars['String'];
};

/** Result of listing Facebook pages that are connected to an InstitutionSetId */
export type FacebookLinkedPages = {
  __typename?: 'FacebookLinkedPages';
  linkedPages: Array<LinkedPages>;
};

/** Result of listing a facebook page */
export type FacebookPage = {
  __typename?: 'FacebookPage';
  imageUrl: Scalars['String'];
  name: Scalars['String'];
  pageId: Scalars['String'];
  url: Scalars['String'];
};

/** Result of listing facebook pages that are connected to a LoginId */
export type FacebookPages = {
  __typename?: 'FacebookPages';
  pages: Array<FacebookPage>;
};

/** Result of unlinking facebook pages */
export type FacebookRemovePages = {
  __typename?: 'FacebookRemovePages';
  /** TokenId of removed link */
  tokenIds: Array<Scalars['FacebookAccessTokenId']>;
};

/** A failed transaction with failure information */
export type FailedTransaction = {
  __typename?: 'FailedTransaction';
  errorMessage?: Maybe<Scalars['String']>;
  paymentId: Scalars['PaymentId'];
  paymentTransactionId: Scalars['PaymentsTransactionId'];
};

/** An error that occurred while running a request */
export type FamlyError = {
  __typename?: 'FamlyError';
  code: Scalars['Int'];
  message: Scalars['String'];
};

/** Place for promo endpoints related to Famly Pay */
export type FamlyPay = {
  __typename?: 'FamlyPay';
  newsFeed: NewsFeed;
};


/** Place for promo endpoints related to Famly Pay */
export type FamlyPaynewsFeedArgs = {
  siteSetId: Scalars['SiteSetId'];
};

/** Data provided to register a payment in Famly */
export type FamlyPaymentInput = {
  amount: Scalars['BadMoney'];
  /** A reference to the bill payer the payment is registered for. */
  billPayer: BillPayerReferenceInput;
  /** The child this payment relates to, if any. */
  childId?: InputMaybe<Scalars['ChildId']>;
  /** The external system this bill payer relates to. */
  externalBillPayerReferences?: InputMaybe<Array<PaymentExternalSystemInput>>;
  /** Deprecated: Please use `externalSystem` instead. */
  externalId?: InputMaybe<Scalars['String']>;
  /** The external system this payment relates to. */
  externalSystem?: InputMaybe<PaymentExternalSystemInput>;
  /** The id of an invoice corresponding to a given payment */
  invoiceId?: InputMaybe<Scalars['InvoiceId']>;
  /** A note to put on the payment (hidden from parents). */
  note: Scalars['String'];
  /** Should the user be notified about the payment being created? If yes the default behavior is to send them an e-mail about it. */
  notifyUser?: InputMaybe<Scalars['Boolean']>;
  /** The date the payment was made on. */
  paymentDate: Scalars['LocalDate'];
  /** The payment method used to make the payment. */
  paymentMethod: PaymentMethod;
  /** The payments feed ID from which this payment originated */
  paymentsFeedId?: InputMaybe<Scalars['PaymentsFeedId']>;
  /** The row number of the corresponding proto payment in the payments feed */
  paymentsFeedRowNumber?: InputMaybe<Scalars['Int']>;
};

export enum FeatureInterest {
  ACTIVITY_PLANNING = 'ACTIVITY_PLANNING',
  CHILD_OBSERVATIONS = 'CHILD_OBSERVATIONS',
  DAILY_LOGS = 'DAILY_LOGS',
  ENQUIRY_MANAGEMENT = 'ENQUIRY_MANAGEMENT',
  INVOICING = 'INVOICING',
  LEARNING_JOURNALS = 'LEARNING_JOURNALS',
  OTHER = 'OTHER',
  PARENT_COMMUNICATION = 'PARENT_COMMUNICATION',
  PARENT_PARTNERSHIPS = 'PARENT_PARTNERSHIPS',
  REGISTERS = 'REGISTERS'
}

export type FeatureInterestType = {
  __typename?: 'FeatureInterestType';
  description: Scalars['String'];
  id: FeatureInterest;
};

export enum FeaturePackage {
  Childminder = 'Childminder',
  Foundation = 'Foundation',
  Free = 'Free',
  Premium = 'Premium',
  Professional = 'Professional'
}

/** Top level node for changing feature settings */
export type FeatureSettingsMutations = {
  __typename?: 'FeatureSettingsMutations';
  shiftplanner: ShiftPlannerFeatureSettingsMutations;
};

/** Operations querying staffhours feature settings */
export type FeatureSettingsQueries = {
  __typename?: 'FeatureSettingsQueries';
  employeeCheckIn: EmployeeCheckInFeatureSettingsFlags;
  exactAttendance: ExactAttendanceFeatureSettingsFlags;
  holidayLeaveAllowance: HolidayLeaveAllowanceFeatureSettingsFlags;
  leave: LeaveFeatureSettingsFlags;
  leaveRangeSettings: LeaveRangeFeatureSettingsFlags;
  leaveRequest: LeaveRequestFeatureSettingsFlags;
  partDayLeave: PartDayLeaveFeatureSettingsFlags;
  shiftplanner: ShiftPlannerFeatureSettingsFlags;
  staffAttendancePage: StaffAttendancePageFeatureSettingsFlags;
  staffHours: StaffHoursFeatureSettingsFlags;
  staffHoursPage: StaffHoursPageFeatureSettingsFlags;
  staffLeaveAPI: StaffLeaveAPIFeatureSettingsFlags;
  staffRotas: StaffRotasFeatureSettingsFlags;
  subtype: SubTypeFeatureSettingsFlags;
  weekendSupport: WeekendSupportFeatureSettingsFlags;
};


/** Operations querying staffhours feature settings */
export type FeatureSettingsQueriesemployeeCheckInArgs = {
  siteSetId: Scalars['InstitutionSetId'];
};


/** Operations querying staffhours feature settings */
export type FeatureSettingsQueriesexactAttendanceArgs = {
  siteSetId: Scalars['InstitutionSetId'];
};


/** Operations querying staffhours feature settings */
export type FeatureSettingsQueriesholidayLeaveAllowanceArgs = {
  siteSetId: Scalars['InstitutionSetId'];
};


/** Operations querying staffhours feature settings */
export type FeatureSettingsQueriesleaveArgs = {
  siteSetId: Scalars['InstitutionSetId'];
};


/** Operations querying staffhours feature settings */
export type FeatureSettingsQueriesleaveRangeSettingsArgs = {
  siteSetId: Scalars['InstitutionSetId'];
};


/** Operations querying staffhours feature settings */
export type FeatureSettingsQueriesleaveRequestArgs = {
  siteSetId: Scalars['InstitutionSetId'];
};


/** Operations querying staffhours feature settings */
export type FeatureSettingsQueriespartDayLeaveArgs = {
  siteSetId: Scalars['InstitutionSetId'];
};


/** Operations querying staffhours feature settings */
export type FeatureSettingsQueriesshiftplannerArgs = {
  siteSetId: Scalars['InstitutionSetId'];
};


/** Operations querying staffhours feature settings */
export type FeatureSettingsQueriesstaffAttendancePageArgs = {
  siteSetId: Scalars['SiteSetId'];
};


/** Operations querying staffhours feature settings */
export type FeatureSettingsQueriesstaffHoursArgs = {
  siteSetId: Scalars['InstitutionSetId'];
};


/** Operations querying staffhours feature settings */
export type FeatureSettingsQueriesstaffHoursPageArgs = {
  siteSetId: Scalars['InstitutionSetId'];
};


/** Operations querying staffhours feature settings */
export type FeatureSettingsQueriesstaffLeaveAPIArgs = {
  siteSetId: Scalars['InstitutionSetId'];
};


/** Operations querying staffhours feature settings */
export type FeatureSettingsQueriesstaffRotasArgs = {
  siteSetId: Scalars['InstitutionSetId'];
};


/** Operations querying staffhours feature settings */
export type FeatureSettingsQueriessubtypeArgs = {
  siteSetId: Scalars['InstitutionSetId'];
};


/** Operations querying staffhours feature settings */
export type FeatureSettingsQueriesweekendSupportArgs = {
  siteSetId: Scalars['InstitutionSetId'];
};

/** Set the state of a feature. */
export type FeatureState = {
  enable: Scalars['Boolean'];
  feature: FeatureType;
};

/** All we need to show Famly Store - categories, packages, features and apps. */
export type FeatureStore = {
  __typename?: 'FeatureStore';
  addOns: Array<BrowseAddOn>;
  boosterPacks?: Maybe<Array<BoosterPackDetails>>;
  browse: Browse;
  comparisionTable: ComparisonTable;
  mobileApp: MobileApp;
  packages: Array<PackageDetails>;
  upgrade: Upgrade;
};

/** All the mutations we need for the feature store */
export type FeatureStoreMutations = {
  __typename?: 'FeatureStoreMutations';
  mobileApp: MobileAppMutations;
  trial: TrialMutations;
  upgrade: FeatureStoreUpgrade;
  upsell: Upsell;
};

export type FeatureStoreUpgrade = {
  __typename?: 'FeatureStoreUpgrade';
  /**
   * Register bill payer information
   * @deprecated Use createInternalBillPayerAndBillingInfo instead
   */
  createBillPayer: StoreBillPayer;
  /** Get a GoCardless URL that can be used to registering payment details */
  createGoCardlessUrl: GoCardlessRedirectFlow;
  /**
   * Register bill payer information
   * @deprecated Use createInternalBillPayerAndSiteInformation instead, this endpoint does not add address when creating the billpayer
   */
  createInternalBillPayerAndBillingInfo?: Maybe<StoreBillPayerWithId>;
  /** Creates internal bill payer and also registers site information */
  createInternalBillPayerAndSiteInfo?: Maybe<StoreBillPayerWithId>;
  /**
   * Register site information
   * @deprecated Use createInternalBillPayerAndSiteInformation instead, this endpoint's functionality has been merged into a new one that also creates an internal bill payer.
   */
  createSiteInformation: StoreSiteInformation;
  forAddon: ForAddon;
  /** Upgrade from a free package to one of the booster package. The return is the number of seconds that the client needs to wait, due to replica lag and cache update, before refetching behaviors and other stuff. */
  forBoosterPack: Scalars['Int'];
  /** Upgrade from a free package to a paid package. The return is the number of seconds that the client needs to wait, due to replica lag and cache update, before refetching behaviors and other stuff. */
  forPackage: Scalars['Int'];
};


export type FeatureStoreUpgradecreateBillPayerArgs = {
  createBillPayerInfo: CreateBillPayerInfo;
};


export type FeatureStoreUpgradecreateGoCardlessUrlArgs = {
  createGoCardlessUrlInfo: CreateGoCardlessInfo;
};


export type FeatureStoreUpgradecreateInternalBillPayerAndBillingInfoArgs = {
  createBillPayerInfo: CreateBillPayerInfo;
};


export type FeatureStoreUpgradecreateInternalBillPayerAndSiteInfoArgs = {
  CreateBillPayerAndSiteInfo: CreateBillPayerAndSiteInfo;
};


export type FeatureStoreUpgradecreateSiteInformationArgs = {
  createSiteInformationInfo: CreateSiteInformationInfo;
};


export type FeatureStoreUpgradeforBoosterPackArgs = {
  boosterPackUpgradeInfo: BoosterPackUpgradeInfo;
};


export type FeatureStoreUpgradeforPackageArgs = {
  upgradeInfo: UpgradeInfo;
};

export enum FeatureSupportState {
  /** Functionality is active/enabled and can be used. */
  ACTIVE = 'ACTIVE',
  /**
   *
   * Functionality is inactive but can be enabled via a Setting, Famly Store, or
   * other mechanisms. In most cases you will want to treat `INACTIVE`, `MISSING_PERMISSION`
   * and `UNAVAILABLE` the same.
   *
   */
  INACTIVE = 'INACTIVE',
  /**
   *
   * Functionality is active/enabled but the user does not have the required permission
   * to use it. In most cases you will want to treat `MISSING_PERMISSION`, `INACTIVE`,
   * and `UNAVAILABLE` the same.
   *
   */
  MISSING_PERMISSION = 'MISSING_PERMISSION',
  /**
   *
   * Functionality is not accessible in any way to the user. In most cases you will want to treat
   * `UNAVAILABLE`, `MISSING_PERMISSION`, and `INACTIVE` the same.
   *
   */
  UNAVAILABLE = 'UNAVAILABLE'
}

export enum FeatureType {
  ALLOW_OTHER_PARENTS_TO_PICKUP = 'ALLOW_OTHER_PARENTS_TO_PICKUP',
  AUTOMATIC_PAYMENT_METHOD_MODAL_REQUIRED = 'AUTOMATIC_PAYMENT_METHOD_MODAL_REQUIRED',
  BANK_HOURS = 'BANK_HOURS',
  DISABLE_NAVIGATION_V2 = 'DISABLE_NAVIGATION_V2',
  DISABLE_PARENT_OBSERVATIONS = 'DISABLE_PARENT_OBSERVATIONS',
  DISABLE_PARENT_TO_PARENT_CONVERSATION = 'DISABLE_PARENT_TO_PARENT_CONVERSATION',
  DISABLE_STAFF_ATTENDANCE_PAGE = 'DISABLE_STAFF_ATTENDANCE_PAGE',
  DISABLE_UNEXPECTED_NOTIFICATION = 'DISABLE_UNEXPECTED_NOTIFICATION',
  ENABLE_ADJUST_INVOICE_DATE = 'ENABLE_ADJUST_INVOICE_DATE',
  ENABLE_BUILDING_THE_AMBITION_FRAMEWORK = 'ENABLE_BUILDING_THE_AMBITION_FRAMEWORK',
  ENABLE_COEL_LEARNING_FRAMEWORK = 'ENABLE_COEL_LEARNING_FRAMEWORK',
  ENABLE_CUSTOM_FTE_OVERWRITE = 'ENABLE_CUSTOM_FTE_OVERWRITE',
  ENABLE_ECAT_FRAMEWORK = 'ENABLE_ECAT_FRAMEWORK',
  ENABLE_EYFP17_FRAMEWORK = 'ENABLE_EYFP17_FRAMEWORK',
  ENABLE_EYO_LEARNING_FRAMEWORK = 'ENABLE_EYO_LEARNING_FRAMEWORK',
  ENABLE_GIRFEC_LEARNING_FRAMEWORK = 'ENABLE_GIRFEC_LEARNING_FRAMEWORK',
  ENABLE_HEADCOUNTS = 'ENABLE_HEADCOUNTS',
  ENABLE_LEARNING_FRAMEWORK_RTA = 'ENABLE_LEARNING_FRAMEWORK_RTA',
  ENABLE_LEAVE_SUBTYPES = 'ENABLE_LEAVE_SUBTYPES',
  ENABLE_MEDIA_SHARE = 'ENABLE_MEDIA_SHARE',
  ENABLE_PARENT_PURCHASES_TIME_RESTRICTION = 'ENABLE_PARENT_PURCHASES_TIME_RESTRICTION',
  ENABLE_PART_DAY_LEAVE = 'ENABLE_PART_DAY_LEAVE',
  ENABLE_PAYMENT_IMPORTS = 'ENABLE_PAYMENT_IMPORTS',
  ENABLE_PREBIRTH_TO_THREE_LEARNING_FRAMEWORK = 'ENABLE_PREBIRTH_TO_THREE_LEARNING_FRAMEWORK',
  ENABLE_SCOTTISH_LEARNING_FRAMEWORK = 'ENABLE_SCOTTISH_LEARNING_FRAMEWORK',
  ENABLE_SCOTTISH_LEARNING_FRAMEWORK_V2 = 'ENABLE_SCOTTISH_LEARNING_FRAMEWORK_V2',
  ENABLE_SEND_FRAMEWORK = 'ENABLE_SEND_FRAMEWORK',
  ENABLE_SHIFT_PLANNER = 'ENABLE_SHIFT_PLANNER',
  ENABLE_WELSH_LEARNING_FRAMEWORK = 'ENABLE_WELSH_LEARNING_FRAMEWORK',
  LEAVE_SUBTYPES_REQUIRED = 'LEAVE_SUBTYPES_REQUIRED',
  LOGIN_VALIDATION = 'LOGIN_VALIDATION',
  ONLY_STAFF_CAN_ASSIGN_RELATION_ROLES = 'ONLY_STAFF_CAN_ASSIGN_RELATION_ROLES',
  PAYMENT_METHOD_MODAL_REQUIRED = 'PAYMENT_METHOD_MODAL_REQUIRED',
  PLAN_PARTS = 'PLAN_PARTS',
  QR_SIGNIN = 'QR_SIGNIN',
  SETTINGS_DISABLE_STAFF_REMINDER_IMMUNISATION = 'SETTINGS_DISABLE_STAFF_REMINDER_IMMUNISATION',
  SETTINGS_ENABLE_EMPLOYEE_LEAVE_REQUEST = 'SETTINGS_ENABLE_EMPLOYEE_LEAVE_REQUEST',
  SETTINGS_ENABLE_PARENT_REMINDER_IMMUNISATION = 'SETTINGS_ENABLE_PARENT_REMINDER_IMMUNISATION',
  SETTINGS_ENABLE_STAFF_TAGGING_MEDIA = 'SETTINGS_ENABLE_STAFF_TAGGING_MEDIA',
  SETTINGS_USE_EYFS_2021_CHILD_DEVELOPMENT = 'SETTINGS_USE_EYFS_2021_CHILD_DEVELOPMENT',
  SHOW_NAVIGATION_V2 = 'SHOW_NAVIGATION_V2',
  SIDEKICK = 'SIDEKICK',
  SIDEKICK_ADDON_TRIAL_BANNERS = 'SIDEKICK_ADDON_TRIAL_BANNERS',
  STAFF_ATTENDANCE_PAGE = 'STAFF_ATTENDANCE_PAGE',
  STAFF_EXACT_ATTENDANCE = 'STAFF_EXACT_ATTENDANCE',
  STAFF_HOURS_PAGE = 'STAFF_HOURS_PAGE',
  USE_PINCODE_CHECKIN = 'USE_PINCODE_CHECKIN',
  WEEKEND_SUPPORT = 'WEEKEND_SUPPORT'
}

/** Breakdown of fees for a specific payment method or group of payment methods */
export type FeeDetails = {
  __typename?: 'FeeDetails';
  /** @deprecated This field has been deprecated in favor of descriptions. */
  description: Scalars['Markdown'];
  /** Returns a list of single line descriptions for the specific fee */
  descriptions: Array<Scalars['String']>;
  icon: PaymentsSourceIcon;
  sourceTypes: Array<PaymentsSourceType>;
  title: Scalars['String'];
};

/** A single item in a user's feed */
export type FeedItem = {
  __typename?: 'FeedItem';
  id: Scalars['FeedItemId'];
};

export type FieldOption = {
  __typename?: 'FieldOption';
  order: Scalars['Int'];
  value: GenericFormFieldValue;
};

export type FieldPermission = {
  __typename?: 'FieldPermission';
  /** Returns true if current user can edit this field */
  canEdit: Scalars['Boolean'];
  /** Returns true if current user can view this field */
  canView: Scalars['Boolean'];
};

/** Input type for a field-value input  */
export type FieldValueInput = {
  fieldId: Scalars['CustomRegistrationFormFieldId'];
  value: Scalars['String'];
};

export type FieldValuesInput = {
  dateTimeValue?: InputMaybe<Scalars['LocalDateTime']>;
  dateValue?: InputMaybe<Scalars['LocalDate']>;
  fieldTemplateId: Scalars['GenericFormFieldTemplateId'];
  fieldType: GenericFormFieldType;
  fieldValueId?: InputMaybe<Scalars['GenericFormFieldValueId']>;
  numberValue?: InputMaybe<Scalars['BigDecimal']>;
  stringValue?: InputMaybe<Scalars['String']>;
  timeValue?: InputMaybe<Scalars['LocalTime']>;
};

/** A media of type file */
export type File = {
  __typename?: 'File';
  id: Scalars['FileId'];
  name: Scalars['String'];
  url: Scalars['String'];
};

export enum FileExportFormat {
  CHILD_BASED_FUNDING = 'CHILD_BASED_FUNDING',
  DATEV_BILL_PAYERS = 'DATEV_BILL_PAYERS',
  DATEV_INVOICES = 'DATEV_INVOICES',
  PDF_INVOICES = 'PDF_INVOICES',
  SAGE_200_BILL_PAYERS = 'SAGE_200_BILL_PAYERS',
  SAGE_200_INVOICE_ITEMS = 'SAGE_200_INVOICE_ITEMS',
  SAGE_200_PAYMENTS = 'SAGE_200_PAYMENTS'
}

export enum FileExportStatus {
  FAILED = 'FAILED',
  IN_PROGRESS = 'IN_PROGRESS',
  READY = 'READY',
  TRIGGERED = 'TRIGGERED'
}

export enum FileScanResult {
  INFECTED = 'INFECTED',
  OK = 'OK'
}

/** Data required to make an out-of-band file upload */
export type FileUpload = {
  __typename?: 'FileUpload';
  /** HMAC value required for submitting an uploaded file for use */
  hmac: Scalars['HMAC'];
  /** The target URL for a file upload PUT request */
  signedUploadUrl: Scalars['URI'];
};

/** Input for submitting an uploaded file for use */
export type FileUploadInput = {
  /** The HMAC required to prove the file upload is legitimate */
  hmac: Scalars['HMAC'];
  /** The previously received file upload URL */
  signedUploadUrl: Scalars['URI'];
};

/** Objects related to finance: funding, invoicing, etc. */
export type Finance = {
  __typename?: 'Finance';
  /** Account setup */
  accountSetup: AccountSetup;
  attendanceSchedules: AttendanceScheduleQueries;
  billingProfiles: BillingProfileQueries;
  billingSchemes: BillingSchemeQueries;
  bookingPatternBuilder: BookingPatternBuilder;
  bulkPatternFlow: BulkPatternFlow;
  childBasedFunding: ChildBasedFundingQueries;
  fileExports: FinanceFileExportQueries;
  financeOnboarding: FinanceOnboarding;
  funding: FundingField;
  integration: IntegrationQueries;
  invoiceSettings: InvoiceSettings;
  invoices: InvoiceQueries;
  overview: FinanceOverview;
  parentPurchaseSettings: ParentPurchaseSettingsQueries;
  paymentReminders: PaymentReminderQueries;
  /** For querying payments */
  payments: PaymentQueries;
  planFundingSettings: PlanFundingSettingsQueries;
  pricingGroups: PricingGroupQueries;
  publicFundingSettings: PublicFundingSettingsQueries;
  purchases: PurchaseQueries;
  revenueItems: RevenueItemQueries;
  run: RunQueries;
  sepaSettings: SepaSettingsQueries;
  subscriptionPage: SubscriptionPage;
  /** Information about functionality that is supported via features or integrations */
  supports: IntegrationSupport;
};


/** Objects related to finance: funding, invoicing, etc. */
export type FinanceaccountSetupArgs = {
  institutionId: Scalars['InstitutionId'];
};


/** Objects related to finance: funding, invoicing, etc. */
export type FinanceinvoiceSettingsArgs = {
  siteSetId: Scalars['SiteSetId'];
};


/** Objects related to finance: funding, invoicing, etc. */
export type FinanceoverviewArgs = {
  childStatus?: InputMaybe<ChildStatusFilter>;
  childrenInRooms?: InputMaybe<Array<Scalars['GroupId']>>;
  childrenStartedBeforeOrOn?: InputMaybe<Scalars['LocalDate']>;
  cursor?: InputMaybe<Scalars['FinanceOverviewCursor']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  planFilter?: ChildPlanFilter;
  siteId: Scalars['SiteId'];
};


/** Objects related to finance: funding, invoicing, etc. */
export type FinancesupportsArgs = {
  institutionSetId: Scalars['InstitutionSetId'];
};

/** Describes a downloadable file and its current status. You can request the latest status via the `byFileExportId` query and you can get the URL from the `progress` field if it is done. */
export type FinanceFileExport = {
  __typename?: 'FinanceFileExport';
  fileExportId: Scalars['FileExportId'];
  format: FileExportFormat;
  progress: FinanceFileExportProgress;
  siteSetId: Scalars['SiteSetId'];
};

/** Mutations for generating Datev file exports. */
export type FinanceFileExportDatevMutations = {
  __typename?: 'FinanceFileExportDatevMutations';
  /** Trigger Datev BillPayers export. Returns the status of export */
  billPayers: FinanceFileExport;
  /** Trigger Datev Invoice export. Returns the status of export */
  invoices: FinanceFileExport;
};


/** Mutations for generating Datev file exports. */
export type FinanceFileExportDatevMutationsbillPayersArgs = {
  from?: InputMaybe<Scalars['LocalDate']>;
  siteSetId: Scalars['SiteSetId'];
  to?: InputMaybe<Scalars['LocalDate']>;
};


/** Mutations for generating Datev file exports. */
export type FinanceFileExportDatevMutationsinvoicesArgs = {
  from?: InputMaybe<Scalars['LocalDate']>;
  siteSetId: Scalars['SiteSetId'];
  to?: InputMaybe<Scalars['LocalDate']>;
};

/** A failed file export. To figure out why the export failed, check out the information provided in `reasons`. */
export type FinanceFileExportFailed = {
  __typename?: 'FinanceFileExportFailed';
  reasons: Array<FinanceFileExportReasons>;
  status: FileExportStatus;
};

/** A file export that is still being generated. You will need to try the request again at a later time to see if the export has changed to either `FinanceFileExportReady` or `FinanceFileExportFailed`. */
export type FinanceFileExportInProgress = {
  __typename?: 'FinanceFileExportInProgress';
  status: FileExportStatus;
};

/** Mutations related to exporting files or reports. You can find mutations for generating the exports here. */
export type FinanceFileExportMutations = {
  __typename?: 'FinanceFileExportMutations';
  childBasedFunding: ChildBasedFundingMutations;
  datev: FinanceFileExportDatevMutations;
  pdf: FinanceFileExportPdfMutations;
  sage200: FinanceFileExportSage200Mutations;
};

/** Mutations for generating various PDF exports. */
export type FinanceFileExportPdfMutations = {
  __typename?: 'FinanceFileExportPdfMutations';
  /**
   *
   * Trigger export of invoice PDFs.
   *
   * The optional and range- and invoiceIds arguments are used to filter the list of invoices to export.
   * If none are set, all invoices for the given siteSetId will be exported. Most common scenario
   * is probably to export specific invoices, or invoices in a date-range.
   *
   * The permission check is done on the given siteSetId which is why this is non-optional.
   *
   *
   */
  invoices: FinanceFileExport;
};


/** Mutations for generating various PDF exports. */
export type FinanceFileExportPdfMutationsinvoicesArgs = {
  invoiceIds?: InputMaybe<Array<Scalars['InvoiceId']>>;
  range?: InputMaybe<NonEmptyLocalDateRangeInput>;
  siteSetId: Scalars['SiteSetId'];
};

/** The status of the file export, indicating either if it's still in progress, if it failed, or if it is done and ready to download. */
export type FinanceFileExportProgress = FinanceFileExportFailed | FinanceFileExportInProgress | FinanceFileExportReady | FinanceFileExportTriggered;

/** Queries related to exporting files or reports. */
export type FinanceFileExportQueries = {
  __typename?: 'FinanceFileExportQueries';
  /** Look up the current status from a given `fileExportId`, to check if it is still in progress, failed, or if it's done and the file is ready to download. */
  byFileExportId: FinanceFileExport;
};


/** Queries related to exporting files or reports. */
export type FinanceFileExportQueriesbyFileExportIdArgs = {
  fileExportId: Scalars['FileExportId'];
};

/** A ready file export, which will allow you to download the export via the provided `file` field. */
export type FinanceFileExportReady = {
  __typename?: 'FinanceFileExportReady';
  file: File;
  status: FileExportStatus;
};

/**
 *
 * Details the reasons why an export failed, and provides additional debugging information.
 *
 * This information should primarily:
 * 1. Make debugging a failed export much easier for developers.
 * 1. Potentially make debugging easier for users if we ever decide to expose these fields to them.
 *
 * We don't take the usual approach of linking `targetType` with an enum describing possible targets
 * or linking it to a database table.
 * The `targetType` field should always be in a human-understandable format.
 *
 * As an example, let's say we're exporting an invoice csv for site ABC.
 * While trying to fetch all the necessary data, we for some reason fail to fetch the full name of BillPayer `f57d8270-dc10-4762-8a48-feb5330d79c5`.
 *
 * In that scenario, the `FinanceFileExportReasons` could look something like this:
 *
 * ```
 * reasons: {
 *  targetId: "f57d8270-dc10-4762-8a48-feb5330d79c5"
 *  targetType: "BillPayer"
 *  errors: ["Failed to fetch billPayer name."]
 * }
 * ```
 *
 * As shown in the example, this structure could potentially lead to duplicated data between `targetId`/`targetType` and the error messages.
 *
 *
 */
export type FinanceFileExportReasons = {
  __typename?: 'FinanceFileExportReasons';
  errors: Array<Scalars['String']>;
  targetId: Scalars['String'];
  targetType: Scalars['String'];
};

/** Mutations for generating Sage200 file exports. */
export type FinanceFileExportSage200Mutations = {
  __typename?: 'FinanceFileExportSage200Mutations';
  /** Generate Sage200 BillPayer export. Returns the status of the file export, which can also be retrieved from `byFileExportId` */
  billPayers: FinanceFileExport;
  /** Generate sage 200 Invoice export. Returns the status of export */
  invoices: FinanceFileExport;
  /** Generate Sage200 Payment export. Returns the status of the file export, which can also be retrieved from `byFileExportId` */
  payments: FinanceFileExport;
};


/** Mutations for generating Sage200 file exports. */
export type FinanceFileExportSage200MutationsbillPayersArgs = {
  billPayerCreatedAfter?: InputMaybe<Scalars['LocalDate']>;
  billPayerCreatedBefore?: InputMaybe<Scalars['LocalDate']>;
  siteSetId: Scalars['SiteSetId'];
};


/** Mutations for generating Sage200 file exports. */
export type FinanceFileExportSage200MutationsinvoicesArgs = {
  from?: InputMaybe<Scalars['LocalDate']>;
  siteSetId: Scalars['SiteSetId'];
  to?: InputMaybe<Scalars['LocalDate']>;
};


/** Mutations for generating Sage200 file exports. */
export type FinanceFileExportSage200MutationspaymentsArgs = {
  paymentCreatedAfter?: InputMaybe<Scalars['LocalDate']>;
  paymentCreatedBefore?: InputMaybe<Scalars['LocalDate']>;
  paymentDateAfter?: InputMaybe<Scalars['LocalDate']>;
  paymentDateBefore?: InputMaybe<Scalars['LocalDate']>;
  siteSetId: Scalars['SiteSetId'];
};

/** A file export that has been triggered. You will need to try the request again at a later time to see if the export has changed to either `FinanceFileExportInProgress`,`FinanceFileExportReady` or `FinanceFileExportFailed`. */
export type FinanceFileExportTriggered = {
  __typename?: 'FinanceFileExportTriggered';
  status: FileExportStatus;
};

/** CRUD for finance: funding, invoicing, etc. */
export type FinanceMutation = {
  __typename?: 'FinanceMutation';
  /** Configure accounts for a site */
  account: AccountMutations;
  /** Set accounts and replaces (destructive) AccountSetup for a site */
  accountSetup: AccountSetup;
  attendanceSchedules: AttendanceScheduleMutations;
  billingProfiles: BillingProfileMutations;
  fileExports: FinanceFileExportMutations;
  financeOnboarding: FinanceOnboardingMutation;
  funding: FundingMutation;
  integration: IntegrationMutations;
  invoices: InvoiceMutations;
  parentPurchaseSettings: ParentPurchaseSettingsMutation;
  paymentReminders: PaymentReminderMutations;
  /** For managing payments */
  payments: PaymentMutations;
  pricingGroups: PricingGroupMutations;
  publicFundingSettings: PublicFundingSettingsMutations;
  purchases: PurchaseMutations;
  sepaSettings: SEPAMutation;
  subscriptionPage: SubscriptionPageMutation;
  surveys: SurveyMutations;
};


/** CRUD for finance: funding, invoicing, etc. */
export type FinanceMutationaccountSetupArgs = {
  accounts: Array<AccountInput>;
  institutionId: Scalars['InstitutionId'];
};

/** Top level object for finance onboarding queries */
export type FinanceOnboarding = {
  __typename?: 'FinanceOnboarding';
  /** @deprecated Use config node instead */
  canViewFinanceOnboarding: Scalars['Boolean'];
  config: ConfigResult;
  /** Configuration related to the US version of Finance onboarding for paid packages */
  configPaidUs: ConfigResult;
  /** Configuration related to US version of Finance onboarding */
  configUs: ConfigResultUs;
};


/** Top level object for finance onboarding queries */
export type FinanceOnboardingcanViewFinanceOnboardingArgs = {
  institutionId: Scalars['SiteId'];
};


/** Top level object for finance onboarding queries */
export type FinanceOnboardingconfigArgs = {
  institutionId: Scalars['SiteId'];
};


/** Top level object for finance onboarding queries */
export type FinanceOnboardingconfigPaidUsArgs = {
  siteId: Scalars['SiteId'];
};


/** Top level object for finance onboarding queries */
export type FinanceOnboardingconfigUsArgs = {
  siteId: Scalars['SiteId'];
};

/** Top level object for finance onboarding mutations */
export type FinanceOnboardingMutation = {
  __typename?: 'FinanceOnboardingMutation';
  /** Enables BillingSchemeActualsV2 if all billing profiles are of type ActualsV2 */
  enableBillingSchemeActualsV2: Scalars['Boolean'];
};


/** Top level object for finance onboarding mutations */
export type FinanceOnboardingMutationenableBillingSchemeActualsV2Args = {
  siteId: Scalars['SiteId'];
};

export type FinanceOverview = {
  __typename?: 'FinanceOverview';
  children: Array<FinanceOverviewChild>;
  cursor?: Maybe<Scalars['FinanceOverviewCursor']>;
  isEnabled: Scalars['Boolean'];
};

export type FinanceOverviewBillPayer = {
  __typename?: 'FinanceOverviewBillPayer';
  billPayer: BillPayer;
  hasAutomaticPaymentMethod: Scalars['Boolean'];
  latestInvoice?: Maybe<InvoiceWithoutLines>;
  paymentMethods: Array<PaymentsSource>;
  share: Scalars['BigDecimal'];
};

export type FinanceOverviewChild = {
  __typename?: 'FinanceOverviewChild';
  billPayers: Array<FinanceOverviewBillPayer>;
  child: Child;
  plans: Array<FinanceOverviewPlan>;
};

/** A plan appearing on the finance overview page */
export type FinanceOverviewPlan = {
  __typename?: 'FinanceOverviewPlan';
  child: Child;
  parts: Array<FinanceOverviewPlanPart>;
  planId: Scalars['PlanId'];
  /** If empty/null, automatic pricing groups/bands are used */
  pricingGroup?: Maybe<PricingGroup>;
  range: NonEmptyLocalDateRange;
};

/** A plan part with additional data added for the finance overview page */
export type FinanceOverviewPlanPart = {
  __typename?: 'FinanceOverviewPlanPart';
  annualization?: Maybe<Annualization>;
  attendanceSchedule?: Maybe<AttendanceSchedule>;
  billingProfile?: Maybe<BillingProfile>;
  billingScheme: BillingScheme;
  bookings: Array<PlanBooking>;
  /** Only plan parts with order = 0 can have funding */
  funding?: Maybe<PlanFunding>;
  order: Scalars['Int'];
  planPartId: Scalars['PlanPartId'];
  statistics: FinanceOverviewPlanPartStatistics;
  termTimeOnly: Scalars['Boolean'];
};

export type FinanceOverviewPlanPartStatistics = {
  __typename?: 'FinanceOverviewPlanPartStatistics';
  sessionMinutesPerWeek: Scalars['Int'];
};

export enum FinancePeriod {
  DAILY = 'DAILY',
  HOURLY = 'HOURLY',
  MONTHLY = 'MONTHLY',
  WEEKLY = 'WEEKLY',
  YEARLY = 'YEARLY'
}

export enum FinancePeriodFunding {
  MONTHLY = 'MONTHLY',
  WEEKLY = 'WEEKLY',
  YEARLY = 'YEARLY'
}

export enum FiscalYear {
  APR1MAR31 = 'APR1MAR31',
  AUG1JUL31 = 'AUG1JUL31',
  DEC1NOV30 = 'DEC1NOV30',
  FEB1JAN31 = 'FEB1JAN31',
  JAN1DEC31 = 'JAN1DEC31',
  JUL1JUN30 = 'JUL1JUN30',
  JUN1MAY31 = 'JUN1MAY31',
  LAST52WEEKS = 'LAST52WEEKS',
  MAR1FEB = 'MAR1FEB',
  MAY1APR30 = 'MAY1APR30',
  NOV1OCT31 = 'NOV1OCT31',
  OCT1SEPT30 = 'OCT1SEPT30',
  SEPT1AUG31 = 'SEPT1AUG31'
}

export type FlatRate = Funding & {
  __typename?: 'FlatRate';
  accountId?: Maybe<Scalars['AccountId']>;
  behaviors: Array<Behavior>;
  billPayer?: Maybe<BillPayer>;
  billPayerId?: Maybe<Scalars['BillPayerId']>;
  discontinued: Scalars['Boolean'];
  id: Scalars['FundingTypeId'];
  institutionId: Scalars['InstitutionId'];
  interval: FlatRateInterval;
  title: Scalars['String'];
};

/** The interval that the funding amount applies to */
export enum FlatRateInterval {
  MONTHLY = 'MONTHLY'
}

/** A Stripe flexible fee scheme */
export type FlexibleFeeScheme = {
  __typename?: 'FlexibleFeeScheme';
  createdAt: Scalars['ZonedDateTime'];
  description: Scalars['String'];
  flexibleFeeSchemeId: Scalars['StripeFlexibleFeeSchemeId'];
  schemeType: StripeFlexibleFeeSchemeType;
};

/** A Stripe flexible fee scheme link for a site */
export type FlexibleFeeSchemeLinkForBackoffice = {
  __typename?: 'FlexibleFeeSchemeLinkForBackoffice';
  createdBy: Scalars['LoginId'];
  /** This is the scheme description */
  description: Scalars['String'];
  endDate: Scalars['LocalDate'];
  flexibleFeeSchemeId: Scalars['StripeFlexibleFeeSchemeId'];
  id: Scalars['StripeFlexibleFeeSchemeLinkId'];
  note?: Maybe<Scalars['String']>;
  siteSetId: Scalars['SiteSetId'];
  startDate: Scalars['LocalDate'];
  /** This is e.g. Active, Expired, Deleted */
  status: Scalars['String'];
};

/** A folder in the Documents app. */
export type Folder = {
  __typename?: 'Folder';
  documents: Array<Document>;
  folderId?: Maybe<Scalars['FolderId']>;
  institutionId: Scalars['InstitutionId'];
  navPath: Array<PathElement>;
  path: Scalars['String'];
  subFolders: Array<Folder>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['ZonedDateTime']>;
};

export type FolderInput = {
  institutionId: Scalars['InstitutionId'];
  parentId?: InputMaybe<Scalars['FolderId']>;
  title: Scalars['String'];
};

export type FoldersMutation = {
  __typename?: 'FoldersMutation';
  create: Array<Folder>;
  remove: Array<Scalars['FolderId']>;
  rename: Folder;
};


export type FoldersMutationcreateArgs = {
  folders: Array<FolderInput>;
};


export type FoldersMutationremoveArgs = {
  folderIds: Array<Scalars['FolderId']>;
};


export type FoldersMutationrenameArgs = {
  folderId: Scalars['FolderId'];
  institutionId: Scalars['InstitutionId'];
  title: Scalars['String'];
};

export type FoodItem = {
  __typename?: 'FoodItem';
  deleted: Scalars['Boolean'];
  id: Scalars['FoodItemId'];
  lastUsed?: Maybe<Scalars['ZonedDateTime']>;
  title: Scalars['String'];
  unit?: Maybe<Scalars['String']>;
};

export type FoodItemInput = {
  title: Scalars['String'];
  unit?: InputMaybe<Scalars['String']>;
};

/** Mutations to upgrade addons */
export type ForAddon = {
  __typename?: 'ForAddon';
  /** Purchase the sidekick add-on and set it up for use by accepting the T&C, granting SidekickAccess permission to all roles in the site and enabling the writing assistant feature. The site must have bill payer infos already setup. */
  sidekick: SidekickAddonUpgradeResponse;
};


/** Mutations to upgrade addons */
export type ForAddonsidekickArgs = {
  sidekickAddonUpgradeInfo: SidekickAddonUpgradeInfo;
};

/** Foreign ID with foreign system information */
export type ForeignIdReference = {
  __typename?: 'ForeignIdReference';
  foreignId: Scalars['String'];
  /** @deprecated Please use `.system` instead, as the use of the enum here is too restrictive */
  foreignSystem: ForeignSystem;
  system: Scalars['String'];
};

/** Foreign ID with foreign system information */
export type ForeignIdReferenceInput = {
  /** Foreign ID */
  foreignId: Scalars['String'];
  /** Please use `system` instead */
  foreignSystem?: InputMaybe<ForeignSystem>;
  /** The name of the system where the foreign ID is used */
  system?: InputMaybe<Scalars['String']>;
};

/** Specify the system the foreign ID belongs to. Deprecated */
export enum ForeignSystem {
  KITA_PLANER = 'KITA_PLANER',
  UNKNOWN = 'UNKNOWN'
}

export type FormAcknowledgement = {
  __typename?: 'FormAcknowledgement';
  acknowledgedAt: Scalars['ZonedDateTime'];
  acknowledgedBy: Person;
  id: Scalars['SignatureId'];
  medicationFormId: Scalars['MedicationFormId'];
  type: SignedAs;
  valid: Scalars['Boolean'];
  withdrawnAt?: Maybe<Scalars['ZonedDateTime']>;
};

/** Holds general information on a Custom Registration Form */
export type FormDescriptionWithDetailsType = {
  __typename?: 'FormDescriptionWithDetailsType';
  /** description of the form */
  description: CustomRegistrationFormDescription;
  /** details of the duplicate form */
  details: CustomRegistrationFormDetails;
};

/** Holds general information on a Custom Registration Form with additional data */
export type FormDescriptionWithNumberOfResponsesType = {
  __typename?: 'FormDescriptionWithNumberOfResponsesType';
  /** Description of the form */
  description: CustomRegistrationFormDescription;
  /** Permission flags for the form */
  managementFlags: CustomRegistrationFormManagementType;
  /** The number of responses submitted to this form. If `siteSetId` is an organisation the number of responses is calculated across all sites of the organisation this form is shared with. */
  numberOfResponses: Scalars['Int'];
  /** Preview URL of a form */
  previewUrl: Scalars['String'];
  /** Publish URL of a form (public part of URL only). */
  publishUrl: Scalars['String'];
};

/** Input type for batch form duplicate operation */
export type FormDuplicateInput = {
  duplicateName?: InputMaybe<Scalars['String']>;
  formId: Scalars['CustomRegistrationFormId'];
  formVersion?: InputMaybe<Scalars['Int']>;
};

export type FormEmailStatusResultType = {
  __typename?: 'FormEmailStatusResultType';
  expiration?: Maybe<Scalars['ZonedDateTime']>;
  sentAt?: Maybe<Scalars['ZonedDateTime']>;
  statusCode: EmailVerificationStatus;
};

export type FormEmailVerificationResultType = {
  __typename?: 'FormEmailVerificationResultType';
  expiration?: Maybe<Scalars['ZonedDateTime']>;
  nurseryEmail?: Maybe<Scalars['String']>;
  resultCode: EmailVerificationResultCode;
};

/** File Attachment Details */
export type FormFileAttachmentType = {
  __typename?: 'FormFileAttachmentType';
  fileId: Scalars['FileId'];
  filename: Scalars['String'];
  objectUrl: Scalars['String'];
};

export type FormNotificationsResult = {
  __typename?: 'FormNotificationsResult';
  /** Id of the custom registration form */
  formId: Scalars['CustomRegistrationFormId'];
  /** True if staff members with form editing permissions are notified about new form responses */
  notificationsEnabled: Scalars['Boolean'];
  /** Id of the site that is affected by this setting */
  siteId: Scalars['SiteId'];
};

export type FormPreviewResult = {
  __typename?: 'FormPreviewResult';
  formDetails?: Maybe<CustomRegistrationFormDetails>;
};

export type FormRecipient = {
  __typename?: 'FormRecipient';
  email?: Maybe<Scalars['EmailAddress']>;
  emailStatus?: Maybe<EmailVerificationStatus>;
  name: Name;
  relationId: Scalars['RelationId'];
};

export type FormResult = {
  __typename?: 'FormResult';
  next?: Maybe<Scalars['FormCursor']>;
  results: Array<FormDescriptionWithNumberOfResponsesType>;
};

export type FormSaveResult = {
  __typename?: 'FormSaveResult';
  mostRecentVersion: Scalars['Int'];
  savedForm?: Maybe<CustomRegistrationFormDetails>;
  status: CustomRegistrationFormSaveStatus;
};

export enum FormSortOrder {
  ByDateAsc = 'ByDateAsc',
  ByDateDesc = 'ByDateDesc',
  ByNameAsc = 'ByNameAsc',
  ByNameDesc = 'ByNameDesc',
  Default = 'Default'
}

/** Holds general information on a Form Submission */
export type FormSubmission = {
  __typename?: 'FormSubmission';
  /** Id of the child this form response was submitted for */
  childId?: Maybe<Scalars['ChildId']>;
  /** Date and time of the submission */
  createdAt: Scalars['ZonedDateTime'];
  /** Id of the form */
  formId: Scalars['CustomRegistrationFormId'];
  /** Name of the custom registration form */
  formName: Scalars['String'];
  /** The type of the custom registration form (e.g. interest, registration, enrollment) */
  formType: CustomRegistrationFormType;
  /** Version number of the form */
  formVersionNumber: Scalars['Int'];
  /** Id of the site this form response was submitted to */
  siteId: Scalars['SiteId'];
  /** Id of the form submission */
  submissionId: Scalars['SubmissionId'];
};

export type FormSubmissionData = {
  __typename?: 'FormSubmissionData';
  data: Array<SubmittedFormFieldData>;
  submission: FormSubmission;
};

export type FormSubmissionResult = {
  __typename?: 'FormSubmissionResult';
  next?: Maybe<Scalars['FormSubmissionCursor']>;
  results: Array<FormSubmission>;
};

export enum FormSubmissionSortOrder {
  ByFormNameAsc = 'ByFormNameAsc',
  ByFormNameDesc = 'ByFormNameDesc',
  BySubmissionDateAsc = 'BySubmissionDateAsc',
  BySubmissionDateDesc = 'BySubmissionDateDesc',
  Default = 'Default'
}

export type FormSubmitResult = {
  __typename?: 'FormSubmitResult';
  /** Id of the submission */
  submissionId: Scalars['SubmissionId'];
  /** Time of the submission recorded by server */
  submittedAt: Scalars['ZonedDateTime'];
  /** Name of the person submitting the form */
  submittedBy?: Maybe<Scalars['String']>;
  /** Success message configured for the site */
  successMessage: Scalars['String'];
};

export type FormSuccessMessageResult = {
  __typename?: 'FormSuccessMessageResult';
  /** Id of the custom registration form */
  formId: Scalars['CustomRegistrationFormId'];
  /** Id of the site that is affected by this setting */
  siteId: Scalars['SiteId'];
  /** The message displayed to anyone who successfully submits this form for this site */
  successMessage: Scalars['String'];
};

export type Framework = {
  __typename?: 'Framework';
  abbr?: Maybe<Scalars['String']>;
  areas: Array<Area>;
  childDevelopmentVersion: Scalars['Int'];
  configs?: Maybe<Array<ReportConfig>>;
  deletedAt?: Maybe<Scalars['ZonedDateTime']>;
  deletedBy?: Maybe<Person>;
  hasAgeBands: Scalars['Boolean'];
  id: Scalars['FrameworkId'];
  owner?: Maybe<Scalars['SiteSetId']>;
  /** @deprecated curriculums -> listReferenceMaterial query should be used */
  referenceMaterial: Array<FrameworkRefMaterial>;
  subtitle?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};


export type FrameworkareasArgs = {
  filter?: InputMaybe<AreaFilterInput>;
};


export type FrameworkreferenceMaterialArgs = {
  filter?: InputMaybe<AreaFilterInput>;
};

export type FrameworkRefMaterial = {
  __typename?: 'FrameworkRefMaterial';
  /** Reference Material which has been linked to a Learning Framework */
  framework: Framework;
  /** 'area' describes an area of a Learning Framework linked to a 'reference' area of Reference Material */
  material: Array<AreaRefMaterial>;
  /** Describes whether reference materials are filtered based on child's age range. */
  supportsAgeFiltering: Scalars['Boolean'];
};

/** Object holding all queries related to framework settings. FrameworkSettings is a wrong name for this type, it should had been called AssessmentSettings. */
export type FrameworkSettings = {
  __typename?: 'FrameworkSettings';
  assessmentSettings: Array<AssessmentSettings>;
  /** Use this object instead of behaviors. It holds what options on assessment settings a user has */
  userOptions: AssessmentSettingsUserOptions;
};


/** Object holding all queries related to framework settings. FrameworkSettings is a wrong name for this type, it should had been called AssessmentSettings. */
export type FrameworkSettingsassessmentSettingsArgs = {
  filter?: InputMaybe<AssessmentSettingsFilterInput>;
  institutionSetId: Scalars['InstitutionSetId'];
};


/** Object holding all queries related to framework settings. FrameworkSettings is a wrong name for this type, it should had been called AssessmentSettings. */
export type FrameworkSettingsuserOptionsArgs = {
  siteSetId: Scalars['SiteSetId'];
};

/** Object holding all mutations related to framework settings */
export type FrameworkSettingsMutation = {
  __typename?: 'FrameworkSettingsMutation';
  activateAssessmentSettings: AssessmentSettings;
  createAssessmentSettings: AssessmentSettings;
  deactivateAssessmentSettings: AssessmentSettings;
  deleteAssessmentSettings: AssessmentSettings;
  updateAssessmentSettings: AssessmentSettings;
};


/** Object holding all mutations related to framework settings */
export type FrameworkSettingsMutationactivateAssessmentSettingsArgs = {
  assessmentSettingsId: Scalars['AssessmentSettingsId'];
  institutionSetId: Scalars['InstitutionSetId'];
};


/** Object holding all mutations related to framework settings */
export type FrameworkSettingsMutationcreateAssessmentSettingsArgs = {
  assessmentSettings: AssessmentSettingsInput;
};


/** Object holding all mutations related to framework settings */
export type FrameworkSettingsMutationdeactivateAssessmentSettingsArgs = {
  assessmentSettingsId: Scalars['AssessmentSettingsId'];
  institutionSetId: Scalars['InstitutionSetId'];
};


/** Object holding all mutations related to framework settings */
export type FrameworkSettingsMutationdeleteAssessmentSettingsArgs = {
  assessmentSettingsId: Scalars['AssessmentSettingsId'];
  institutionSetId: Scalars['InstitutionSetId'];
};


/** Object holding all mutations related to framework settings */
export type FrameworkSettingsMutationupdateAssessmentSettingsArgs = {
  assessmentSettings: AssessmentSettingsUpdate;
};

export enum FrameworkSettingsStatus {
  ACTIVE = 'ACTIVE',
  DELETED = 'DELETED',
  DRAFT = 'DRAFT',
  INACTIVE = 'INACTIVE'
}

export enum FreeSeats {
  FEW_VACANCIES = 'FEW_VACANCIES',
  MANY_VACANCIES = 'MANY_VACANCIES',
  NO_VACANCIES = 'NO_VACANCIES'
}

/** Holds information on FTE calculation for a child */
export type Fte = {
  __typename?: 'Fte';
  /** Algorithm used for FTE calculation */
  calculation: FteCalculation;
  /** ID of the child */
  childId: Scalars['ChildId'];
  /** FTE value */
  fte: Scalars['Float'];
  /** Period for which FTE was calculated */
  period: TimeRangeClosed;
  /** ID of the child's site */
  siteId: Scalars['SiteId'];
};

export enum FteCalculation {
  GENERIC = 'GENERIC'
}

/** Definition of a funding type */
export type Funding = {
  accountId?: Maybe<Scalars['AccountId']>;
  behaviors: Array<Behavior>;
  billPayer?: Maybe<BillPayer>;
  discontinued: Scalars['Boolean'];
  id: Scalars['FundingTypeId'];
  institutionId: Scalars['InstitutionId'];
  title: Scalars['String'];
};

/** Objects related to generic funding */
export type FundingField = {
  __typename?: 'FundingField';
  fundingLoop: FundingLoopQueries;
  periods: Array<FundingPeriod>;
  types: Array<Funding>;
};


/** Objects related to generic funding */
export type FundingFieldperiodsArgs = {
  childIds?: InputMaybe<Array<Scalars['ChildId']>>;
  fundingPeriodIds?: InputMaybe<Array<Scalars['FundingPeriodId']>>;
};


/** Objects related to generic funding */
export type FundingFieldtypesArgs = {
  fundingTypeIds?: InputMaybe<Array<Scalars['FundingTypeId']>>;
  institutionIds?: InputMaybe<Array<Scalars['InstitutionId']>>;
};

/** A single funding for a child from the child based funding report. */
export type FundingForChild = {
  __typename?: 'FundingForChild';
  endDate: Scalars['LocalDate'];
  invoiceDeduction: Scalars['BadMoney'];
  monthlyRate: Scalars['BadMoney'];
  netInvoiced: Scalars['BadMoney'];
  startDate: Scalars['LocalDate'];
  title: Scalars['String'];
  totalInvoiced: Scalars['BadMoney'];
};

export type FundingLoopQueries = {
  __typename?: 'FundingLoopQueries';
  /** The children that will appear in the Funding Loop export. */
  children: Array<Child>;
};


export type FundingLoopQuerieschildrenArgs = {
  from: Scalars['LocalDate'];
  headCountDate: Scalars['LocalDate'];
  institutionId: Scalars['InstitutionId'];
  to: Scalars['LocalDate'];
};

/** CRUD for generic funding */
export type FundingMutation = {
  __typename?: 'FundingMutation';
  /** Create a new flat rate funding type */
  createFlatRateType: FlatRate;
  /** Create a new funding period for a child */
  createFundingPeriod: FundingPeriod;
  /** Create a new per-item funding type */
  createPerItemType: PerItem;
  /** Create a new plan funding type */
  createPlanType: FundingPlan;
  /** Delete a funding period (with potential warnings) */
  deleteFundingPeriod: Scalars['FundingPeriodId'];
  /** Delete a funding type */
  deleteFundingType: Scalars['FundingTypeId'];
  /** Discontinue a funding type */
  discontinueFundingType: Funding;
  /** Update flat rate funding type */
  updateFlatRateType: FlatRate;
  /** Update a funding period with end date and/or amount */
  updateFundingPeriod: FundingPeriod;
  /** Update per-item funding type */
  updatePerItemType: PerItem;
  /** Update plan funding type */
  updatePlanType: FundingPlan;
};


/** CRUD for generic funding */
export type FundingMutationcreateFlatRateTypeArgs = {
  accountId?: InputMaybe<Scalars['AccountId']>;
  billPayerId?: InputMaybe<Scalars['BillPayerId']>;
  institutionId: Scalars['InstitutionId'];
  interval: FlatRateInterval;
  title: Scalars['String'];
};


/** CRUD for generic funding */
export type FundingMutationcreateFundingPeriodArgs = {
  amount: Scalars['BigDecimal'];
  childId: Scalars['ChildId'];
  fundingTypeId: Scalars['FundingTypeId'];
  periodEnd: Scalars['LocalDate'];
  periodStart: Scalars['LocalDate'];
};


/** CRUD for generic funding */
export type FundingMutationcreatePerItemTypeArgs = {
  accountId?: InputMaybe<Scalars['AccountId']>;
  allProducts: Scalars['Boolean'];
  billPayerId?: InputMaybe<Scalars['BillPayerId']>;
  fixedTotal: Scalars['Boolean'];
  institutionId: Scalars['InstitutionId'];
  productIds: Array<Scalars['ProductId']>;
  title: Scalars['String'];
};


/** CRUD for generic funding */
export type FundingMutationcreatePlanTypeArgs = {
  accountId?: InputMaybe<Scalars['AccountId']>;
  ageRange?: InputMaybe<ClosedIntRangeInput>;
  institutionId: Scalars['InstitutionId'];
  periods: Array<FundingPeriodPlanInput>;
  title: Scalars['String'];
};


/** CRUD for generic funding */
export type FundingMutationdeleteFundingPeriodArgs = {
  fundingPeriodId: Scalars['FundingPeriodId'];
};


/** CRUD for generic funding */
export type FundingMutationdeleteFundingTypeArgs = {
  fundingTypeId: Scalars['FundingTypeId'];
};


/** CRUD for generic funding */
export type FundingMutationdiscontinueFundingTypeArgs = {
  fundingTypeId: Scalars['FundingTypeId'];
};


/** CRUD for generic funding */
export type FundingMutationupdateFlatRateTypeArgs = {
  accountId?: InputMaybe<Scalars['AccountId']>;
  billPayerId?: InputMaybe<Scalars['BillPayerId']>;
  fundingTypeId: Scalars['FundingTypeId'];
  title: Scalars['String'];
};


/** CRUD for generic funding */
export type FundingMutationupdateFundingPeriodArgs = {
  amount?: InputMaybe<Scalars['BigDecimal']>;
  fundingPeriodId: Scalars['FundingPeriodId'];
  periodEnd?: InputMaybe<Scalars['LocalDate']>;
  periodStart?: InputMaybe<Scalars['LocalDate']>;
};


/** CRUD for generic funding */
export type FundingMutationupdatePerItemTypeArgs = {
  accountId?: InputMaybe<Scalars['AccountId']>;
  allProducts: Scalars['Boolean'];
  billPayerId?: InputMaybe<Scalars['BillPayerId']>;
  fixedTotal: Scalars['Boolean'];
  fundingTypeId: Scalars['FundingTypeId'];
  productIds: Array<Scalars['ProductId']>;
  title: Scalars['String'];
};


/** CRUD for generic funding */
export type FundingMutationupdatePlanTypeArgs = {
  accountId?: InputMaybe<Scalars['AccountId']>;
  ageRange?: InputMaybe<ClosedIntRangeInput>;
  fundingTypeId: Scalars['FundingTypeId'];
  periods: Array<FundingPeriodPlanInput>;
  title: Scalars['String'];
};

export type FundingPeriod = {
  __typename?: 'FundingPeriod';
  amount: Scalars['BigDecimal'];
  behaviors: Array<Behavior>;
  childId: Scalars['ChildId'];
  funding: Funding;
  id: Scalars['FundingPeriodId'];
  periodEnd: Scalars['LocalDate'];
  periodStart: Scalars['LocalDate'];
};

export type FundingPeriodPlan = {
  __typename?: 'FundingPeriodPlan';
  from: Scalars['LocalDate'];
  rates: Array<FundingPeriodRate>;
  to?: Maybe<Scalars['LocalDate']>;
};

export type FundingPeriodPlanInput = {
  from: Scalars['LocalDate'];
  rates: Array<FundingPeriodRateInput>;
  to?: InputMaybe<Scalars['LocalDate']>;
};

export type FundingPeriodRate = {
  __typename?: 'FundingPeriodRate';
  headcountDate?: Maybe<Scalars['LocalDate']>;
  rate: Scalars['BigDecimal'];
  title: Scalars['String'];
};

export type FundingPeriodRateInput = {
  headcountDate?: InputMaybe<Scalars['LocalDate']>;
  rate: Scalars['BigDecimal'];
  title: Scalars['String'];
};

export type FundingPlan = Funding & {
  __typename?: 'FundingPlan';
  accountId?: Maybe<Scalars['AccountId']>;
  ageRange?: Maybe<ClosedIntRange>;
  behaviors: Array<Behavior>;
  billPayer?: Maybe<BillPayer>;
  discontinued: Scalars['Boolean'];
  id: Scalars['FundingTypeId'];
  institutionId: Scalars['InstitutionId'];
  periods: Array<FundingPeriodPlan>;
  title: Scalars['String'];
};

/** A single row in the child based funding report, includes aggregated statistics from all of the child's funding's for the given period. */
export type FundingReportRow = {
  __typename?: 'FundingReportRow';
  child: Child;
  funding: Array<FundingForChild>;
  invoiceDeduction: Scalars['BadMoney'];
  monthlyRate: Scalars['BadMoney'];
  netInvoiced: Scalars['BadMoney'];
  totalInvoiced: Scalars['BadMoney'];
};

export enum FundingState {
  HAS_FUNDING = 'HAS_FUNDING',
  NO_FUNDING = 'NO_FUNDING'
}

export enum Gender {
  FEMALE = 'FEMALE',
  MALE = 'MALE'
}

/** Queries that compute FTE values using Generic algorithm */
export type GenericFTEQueries = {
  __typename?: 'GenericFTEQueries';
  byChildIds: Array<PlanPartFte>;
  byPlanIds: Array<PlanPartFte>;
  /** @deprecated This is superseded by byPlainIds/byChildIds queries. Metric computed here should not be used, it is not compatible with one from new queries. */
  bySiteWeekly: Array<Fte>;
};


/** Queries that compute FTE values using Generic algorithm */
export type GenericFTEQueriesbyChildIdsArgs = {
  childIds: Array<Scalars['ChildId']>;
};


/** Queries that compute FTE values using Generic algorithm */
export type GenericFTEQueriesbyPlanIdsArgs = {
  planIds: Array<Scalars['PlanId']>;
};


/** Queries that compute FTE values using Generic algorithm */
export type GenericFTEQueriesbySiteWeeklyArgs = {
  range: ClosedLocalDateRange;
  siteSetId: Scalars['SiteSetId'];
};

/** Represents an instantiated generic form template. */
export type GenericForm = {
  __typename?: 'GenericForm';
  fieldValues: Array<GenericFormFieldValue>;
  template: GenericFormTemplate;
};

export type GenericFormFieldTemplate = {
  __typename?: 'GenericFormFieldTemplate';
  id: Scalars['GenericFormFieldTemplateId'];
  options?: Maybe<Array<FieldOption>>;
  order: Scalars['Int'];
  required: Scalars['Boolean'];
  title: Scalars['String'];
  type: GenericFormFieldType;
};

export enum GenericFormFieldType {
  DATE = 'DATE',
  DATE_TIME = 'DATE_TIME',
  LONG_TEXT = 'LONG_TEXT',
  NUMBER = 'NUMBER',
  SHORT_TEXT = 'SHORT_TEXT',
  TIME = 'TIME'
}

export type GenericFormFieldValue = {
  fieldTemplate: GenericFormFieldTemplate;
  fieldTemplateId: Scalars['GenericFormFieldTemplateId'];
  fieldType: GenericFormFieldType;
  fieldValueId: Scalars['GenericFormFieldValueId'];
  valueAsString: Scalars['String'];
};

/** An object holding the information necessary to fill out a generic form */
export type GenericFormInput = {
  /** The filled out values */
  fieldValues: Array<FieldValuesInput>;
  /** The version id of the form that is being filled out */
  templateVersionId: Scalars['GenericFormTemplateVersionId'];
};

export type GenericFormInstance = {
  __typename?: 'GenericFormInstance';
  child?: Maybe<Child>;
  createdAt: Scalars['ZonedDateTime'];
  createdBy: Person;
  fieldValues: Array<GenericFormFieldValue>;
  instanceId: Scalars['GenericFormInstanceId'];
  lastModifiedAt: Scalars['ZonedDateTime'];
  lastModifiedBy: Person;
  status: GenericFormStatus;
  template: GenericFormTemplate;
};

export type GenericFormInstanceInput = {
  /** The id of the child that hte form pertains to */
  childId: Scalars['ChildId'];
  fieldValues: Array<FieldValuesInput>;
  status: GenericFormStatus;
  templateVersionId: Scalars['GenericFormTemplateVersionId'];
};

export enum GenericFormStatus {
  DRAFT = 'DRAFT',
  PUBLISHED = 'PUBLISHED'
}

export type GenericFormTemplate = {
  __typename?: 'GenericFormTemplate';
  createdBy: Person;
  fields: Array<GenericFormFieldTemplate>;
  id: Scalars['GenericFormTemplateId'];
  title: Scalars['String'];
  version: Scalars['Long'];
  versionId: Scalars['GenericFormTemplateVersionId'];
};

export enum GenericFormType {
  CHILD_FORM = 'CHILD_FORM',
  MEDICATION_FORM = 'MEDICATION_FORM',
  PERIOD_PLAN = 'PERIOD_PLAN'
}

/** Queries and objects related to generic forms */
export type GenericForms = {
  __typename?: 'GenericForms';
  /** This is an incomplete API and we reserve the right to change it at any time. */
  listGenericForms: Array<GenericFormTemplate>;
};


/** Queries and objects related to generic forms */
export type GenericFormslistGenericFormsArgs = {
  institutionSetId?: InputMaybe<Scalars['InstitutionSetId']>;
  types?: InputMaybe<Array<GenericFormType>>;
  versionIds?: InputMaybe<Array<Scalars['GenericFormTemplateVersionId']>>;
};

/** Mutations related to generic forms */
export type GenericFormsMutations = {
  __typename?: 'GenericFormsMutations';
  /** Creates a new generic form instance */
  create: GenericFormInstance;
  /** Updates an existing generic form instance */
  update: GenericFormInstance;
};


/** Mutations related to generic forms */
export type GenericFormsMutationscreateArgs = {
  form: GenericFormInstanceInput;
};


/** Mutations related to generic forms */
export type GenericFormsMutationsupdateArgs = {
  form: GenericFormInstanceInput;
  formId: Scalars['GenericFormInstanceId'];
};

export type GoCardlessRedirectFlow = {
  __typename?: 'GoCardlessRedirectFlow';
  id: Scalars['String'];
  token: Scalars['String'];
  url: Scalars['String'];
};

/** Represents a physical room in an institution */
export type Group = {
  __typename?: 'Group';
  /** A plain-text description of the group */
  description?: Maybe<Scalars['String']>;
  id: Scalars['GroupId'];
  institutionId: Scalars['InstitutionId'];
  ordering?: Maybe<Scalars['Int']>;
  profileImage?: Maybe<ProfileImage>;
  staffRatio?: Maybe<Scalars['Float']>;
  title: Scalars['String'];
};

export type GroupImport = {
  __typename?: 'GroupImport';
  groupId?: Maybe<Scalars['GroupId']>;
  name?: Maybe<Scalars['String']>;
};

/** Input for assigning a child to a group through either GroupId or name */
export type GroupImportInput = {
  groupId?: InputMaybe<Scalars['GroupId']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Media tag allowance for all children in group */
export type GroupMediaTagAllowance = {
  __typename?: 'GroupMediaTagAllowance';
  childrenAllowance: Array<ChildMediaTagAllowance>;
  group: Group;
};

export type GroupMove = {
  __typename?: 'GroupMove';
  childId: Scalars['ChildId'];
  date: Scalars['LocalDate'];
  group: Group;
  groupId: Scalars['GroupId'];
  /** @deprecated This field is not used anymore and will always be empty */
  time?: Maybe<Scalars['LocalTime']>;
};

/** For managing groups (rooms) */
export type GroupMutations = {
  __typename?: 'GroupMutations';
  /** Update the ordering of groups */
  order: Array<Group>;
};


/** For managing groups (rooms) */
export type GroupMutationsorderArgs = {
  groupIds: Array<Scalars['GroupId']>;
  siteId: Scalars['SiteId'];
};

/** Staff member records by day for a specific group */
export type GroupRecordsByDay = RecordsByDay & {
  __typename?: 'GroupRecordsByDay';
  attendance: Array<StaffMemberAttendanceRecord>;
  date: Scalars['LocalDate'];
  leaves: Array<StaffMemberLeaves>;
  /** @deprecated Field 'otherRoomsWithScheduleRecords' should be used */
  otherRoomsWithRecords: Array<Scalars['GroupId']>;
  otherRoomsWithScheduleRecords: Array<Group>;
  schedule: Array<StaffMemberScheduleRecord>;
};

/** Queries related to headcounts */
export type Headcount = {
  __typename?: 'Headcount';
  behaviors: HeadcountBehaviorsResult;
  /** Latest headcount today for given childIds in given institutionId */
  lastCountedToday: HeadcountLastCountedResult;
  list: HeadcountListResult;
};


/** Queries related to headcounts */
export type HeadcountbehaviorsArgs = {
  institutionId: Scalars['InstitutionId'];
};


/** Queries related to headcounts */
export type HeadcountlastCountedTodayArgs = {
  childIds: Array<Scalars['ChildId']>;
  institutionId: Scalars['InstitutionId'];
};


/** Queries related to headcounts */
export type HeadcountlistArgs = {
  after?: InputMaybe<Scalars['HeadcountCursor']>;
  filterByTimeOfDay?: InputMaybe<ClosedLocalTimeRange>;
  groupIds?: InputMaybe<Array<Scalars['GroupId']>>;
  institutionId: Scalars['InstitutionId'];
  limit?: InputMaybe<Scalars['Int']>;
  period?: InputMaybe<ClosedLocalDateRange>;
  tagIds?: InputMaybe<Array<Scalars['TagId']>>;
};

/** List of active behaviors for Headcounts */
export type HeadcountBehaviorsResult = {
  __typename?: 'HeadcountBehaviorsResult';
  result: Array<Behavior>;
};

/** The result of using the 'create' mutation for headcounts */
export type HeadcountCreationResult = {
  __typename?: 'HeadcountCreationResult';
  result: Array<HeadcountInterface>;
};

/** List of counted children by group */
export type HeadcountGroup = HeadcountInterface & {
  __typename?: 'HeadcountGroup';
  /** Counted children */
  children: Array<Child>;
  /** Timestamp of creation */
  createdAt: Scalars['ZonedDateTime'];
  /** The person who created the Headcount */
  createdBy: Person;
  group: Group;
  /** The ID of the Headcount entry */
  id: Scalars['HeadcountId'];
  /** Institution in which the headcount was executed */
  institution: Site;
  /** Information about the child status filter, if used */
  statusFilter?: Maybe<Array<ChildStatusUnion>>;
  /** Total count of children, might be larger than the size of children field in case of data deletion/anonymization */
  total: Scalars['Int'];
};

/** Data for creating a headcount for either a group or tag */
export type HeadcountInput = {
  /** ChildIds for all counted children */
  childIds: Array<Scalars['ChildId']>;
  /** GroupId, if the count was done for a group - tagId must be empty */
  groupId?: InputMaybe<Scalars['GroupId']>;
  /** InstitutionId in which the headcount was executed */
  institutionId: Scalars['InstitutionId'];
  /** Headcount filter on child status */
  statusFilter?: InputMaybe<ChildStatusInput>;
  /** TagId, if the count was done for a tag - groupId must be empty */
  tagId?: InputMaybe<Scalars['TagId']>;
};

/** List of counted children by tag or group */
export type HeadcountInterface = {
  /** Counted children */
  children: Array<Child>;
  /** Timestamp of creation */
  createdAt: Scalars['ZonedDateTime'];
  /** The person who created the Headcount */
  createdBy: Person;
  /** The ID of the Headcount entry */
  id: Scalars['HeadcountId'];
  /** Institution in which the headcount was executed */
  institution: Site;
  /** Information about the child status filter, if used */
  statusFilter?: Maybe<Array<ChildStatusUnion>>;
  /** Total count of children, might be larger than the size of children field in case of data deletion/anonymization */
  total: Scalars['Int'];
};

/** Information about the latest headcount today */
export type HeadcountLastCountedResult = {
  __typename?: 'HeadcountLastCountedResult';
  localDate: Scalars['LocalDate'];
  result: Array<HeadcountLastCountedResultList>;
};

/** Latest headcount today, if exists */
export type HeadcountLastCountedResultList = {
  __typename?: 'HeadcountLastCountedResultList';
  child: Child;
  countCreatedAt?: Maybe<Scalars['ZonedDateTime']>;
};

/** List of headcounts with pagination */
export type HeadcountListResult = {
  __typename?: 'HeadcountListResult';
  next?: Maybe<Scalars['HeadcountCursor']>;
  result: Array<HeadcountInterface>;
};

/** Mutations related to headcounts */
export type HeadcountMutations = {
  __typename?: 'HeadcountMutations';
  create: HeadcountCreationResult;
};


/** Mutations related to headcounts */
export type HeadcountMutationscreateArgs = {
  headcounts: Array<HeadcountInput>;
};

/** List of counted children by tag */
export type HeadcountTag = HeadcountInterface & {
  __typename?: 'HeadcountTag';
  /** Counted children */
  children: Array<Child>;
  /** Timestamp of creation */
  createdAt: Scalars['ZonedDateTime'];
  /** The person who created the Headcount */
  createdBy: Person;
  /** The ID of the Headcount entry */
  id: Scalars['HeadcountId'];
  /** Institution in which the headcount was executed */
  institution: Site;
  /** Information about the child status filter, if used */
  statusFilter?: Maybe<Array<ChildStatusUnion>>;
  tag: Tag;
  /** Total count of children, might be larger than the size of children field in case of data deletion/anonymization */
  total: Scalars['Int'];
};

/** A link to a help article */
export type HelpLink = {
  __typename?: 'HelpLink';
  /** An identifier that can be used to enable special behavior in the client */
  id: Scalars['String'];
  link?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

/** A historical Stripe flexible fee scheme link for a site */
export type HistoricalFlexibleFeeSchemeLink = {
  __typename?: 'HistoricalFlexibleFeeSchemeLink';
  createdBy: Scalars['LoginId'];
  deletedBy?: Maybe<Scalars['LoginId']>;
  /** This is the scheme description */
  description: Scalars['String'];
  endDate: Scalars['LocalDate'];
  flexibleFeeSchemeId: Scalars['StripeFlexibleFeeSchemeId'];
  /** This will contain, e.g. "Deleted at..." */
  historyNote?: Maybe<Scalars['String']>;
  id: Scalars['StripeFlexibleFeeSchemeLinkId'];
  note?: Maybe<Scalars['String']>;
  siteSetId: Scalars['SiteSetId'];
  startDate: Scalars['LocalDate'];
  /** This is e.g. Active, Expired, Deleted */
  status: Scalars['String'];
};

export type HolidayLeaveAllowanceFeatureSettingsFlags = {
  __typename?: 'HolidayLeaveAllowanceFeatureSettingsFlags';
  /** Returns if this feature is currently enabled. */
  enabled: Scalars['Boolean'];
};

/** The result of storing a user's customization for Famly Home */
export type HomeCustomization = {
  __typename?: 'HomeCustomization';
  /** The ordered list of all excluded widgets */
  excluded: WidgetInfoSetResult;
  /** The ordered list of all included widgets */
  included: WidgetInfoSetResult;
};

/** Top level node for Famly Home customization mutations */
export type HomeCustomizationMutations = {
  __typename?: 'HomeCustomizationMutations';
  /** Clears the customized widgets for this user */
  clear: HomeCustomization;
  /** Stores the customized widgets for this user. Any previous customization will be overwritten */
  store: HomeCustomization;
};


/** Top level node for Famly Home customization mutations */
export type HomeCustomizationMutationsclearArgs = {
  siteSetId: Scalars['SiteSetId'];
  widgetArea: WidgetArea;
};


/** Top level node for Famly Home customization mutations */
export type HomeCustomizationMutationsstoreArgs = {
  excludeIds: Array<Scalars['HomeWidgetId']>;
  includeIds: Array<Scalars['HomeWidgetId']>;
  siteSetId: Scalars['SiteSetId'];
  widgetArea: WidgetArea;
};

/** Details about Famly Home customization status */
export type HomeCustomizationStatus = {
  __typename?: 'HomeCustomizationStatus';
  /** Whether or not Famly Home customization is enabled */
  isEnabled: Scalars['Boolean'];
};

/** The object holding all possible mutations regarding Famly Home */
export type HomeMutations = {
  __typename?: 'HomeMutations';
  customization: HomeCustomizationMutations;
};

/** The object holding all possible queries regarding Famly Home */
export type HomeQueries = {
  __typename?: 'HomeQueries';
  /** Returns the list of all available widgets for this area. Takes into account permissions, and uses their customizations to order them */
  availableWidgetsByArea: WidgetInfoSetResult;
  /** Builds the provided set of widgets */
  byIds: WidgetSetResult;
  /** Details about Famly Home customization status */
  customization: HomeCustomizationStatus;
  /** Returns the list of all available widgets for this area. Takes into account permissions and any customizations */
  idsByArea: WidgetInfoSetResult;
  /** Returns the list of all widgets that are "new" for this site set. Takes in account permissions and customizations. If the user has not customized their widgets, an empty list will be returned */
  newWidgets: WidgetInfoSetResult;
  /** @deprecated Please use `idsByArea` instead and then build the widgets via `byIds` */
  primary: WidgetSetResult;
  /** @deprecated Please use `idsByArea` instead and then build the widgets via `byIds` */
  secondary: WidgetSetResult;
  widgetPage: HomeWidgetPageResult;
};


/** The object holding all possible queries regarding Famly Home */
export type HomeQueriesavailableWidgetsByAreaArgs = {
  siteSetId: Scalars['SiteSetId'];
  widgetArea: WidgetArea;
};


/** The object holding all possible queries regarding Famly Home */
export type HomeQueriesbyIdsArgs = {
  ids: Array<Scalars['HomeWidgetId']>;
  siteSetId: Scalars['SiteSetId'];
};


/** The object holding all possible queries regarding Famly Home */
export type HomeQueriescustomizationArgs = {
  siteSetId: Scalars['SiteSetId'];
};


/** The object holding all possible queries regarding Famly Home */
export type HomeQueriesidsByAreaArgs = {
  siteSetId: Scalars['SiteSetId'];
  widgetArea: WidgetArea;
};


/** The object holding all possible queries regarding Famly Home */
export type HomeQueriesnewWidgetsArgs = {
  siteSetId: Scalars['SiteSetId'];
};


/** The object holding all possible queries regarding Famly Home */
export type HomeQueriesprimaryArgs = {
  siteSetId?: InputMaybe<Scalars['SiteSetId']>;
};


/** The object holding all possible queries regarding Famly Home */
export type HomeQueriessecondaryArgs = {
  siteSetId?: InputMaybe<Scalars['SiteSetId']>;
};


/** The object holding all possible queries regarding Famly Home */
export type HomeQuerieswidgetPageArgs = {
  from?: InputMaybe<Scalars['HomeWidgetCursor']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  siteSetId: Scalars['SiteSetId'];
  widgetId: Scalars['HomeWidgetId'];
};

/** The next page of a widget */
export type HomeWidgetPageResult = {
  __typename?: 'HomeWidgetPageResult';
  page?: Maybe<Widget>;
};

/** An image of type media */
export type Image = {
  __typename?: 'Image';
  height: Scalars['Int'];
  id: Scalars['ImageId'];
  secret: ImageSecret;
  width: Scalars['Int'];
};

export enum ImageCrop {
  face = 'face'
}

export type ImageSecret = {
  __typename?: 'ImageSecret';
  crop?: Maybe<ImageCrop>;
  expires: Scalars['ZonedDateTime'];
  key: Scalars['HMAC'];
  path: Scalars['String'];
  prefix: Scalars['String'];
};

export type ImmunizationMutations = {
  __typename?: 'ImmunizationMutations';
  /**
   * Permanently deletes the registered vaccinations.
   * If the documentation provided for those vaccinations are not used for any other vaccinations then those are also deleted.
   */
  deleteVaccinations: Array<Scalars['VaccinationId']>;
  documentVaccinations: Array<VaccinationGiven>;
  exemptVaccinations: Array<VaccinationExempted>;
  registerVaccinations: Array<Vaccination>;
  setRegulation: ImmunizationRegulation;
};


export type ImmunizationMutationsdeleteVaccinationsArgs = {
  vaccinationIds: Array<Scalars['VaccinationId']>;
};


export type ImmunizationMutationsdocumentVaccinationsArgs = {
  documentation: VaccinationInput;
};


export type ImmunizationMutationsexemptVaccinationsArgs = {
  documentation: VaccinationInput;
  reason: Scalars['String'];
};


export type ImmunizationMutationsregisterVaccinationsArgs = {
  vaccinationDoses: Array<ChildVaccinationDoses>;
};


export type ImmunizationMutationssetRegulationArgs = {
  institutionSetId: Scalars['InstitutionSetId'];
  regulationId: Scalars['ImmunizationRegulationId'];
};

export type ImmunizationRecord = {
  __typename?: 'ImmunizationRecord';
  child: Child;
  dueOn: Scalars['LocalDate'];
  rule: VaccinationRule;
  status: ImmunizationRecordStatusType;
  vaccination?: Maybe<Vaccination>;
  vaccine: Vaccine;
};

export type ImmunizationRecordGroup = {
  __typename?: 'ImmunizationRecordGroup';
  child: Child;
  dueOn: Scalars['LocalDate'];
  records: Array<ImmunizationRecord>;
};

export enum ImmunizationRecordStatusType {
  ALL_EXEMPTED = 'ALL_EXEMPTED',
  DUE = 'DUE',
  EXEMPTED = 'EXEMPTED',
  GIVEN = 'GIVEN',
  OVER_DUE = 'OVER_DUE'
}

export type ImmunizationRecordsResult = {
  __typename?: 'ImmunizationRecordsResult';
  childrenWithoutBirthdays: Array<Child>;
  next?: Maybe<Scalars['ImmunizationRecordsCursor']>;
  result: Array<ImmunizationRecordGroup>;
};

export type ImmunizationRegulation = {
  __typename?: 'ImmunizationRegulation';
  id: Scalars['ImmunizationRegulationId'];
  title: Scalars['String'];
  vaccines: Array<Vaccine>;
};

export type Immunizations = {
  __typename?: 'Immunizations';
  /** Immunization baseline for a site, listing children by vaccination status excluding those that have graduated.It also excludes children that haven't born or haven't had their birthday set */
  baseline: Baseline;
  /**
   * Possible behaviors
   * @deprecated Use flags canViewAllRecords and canManageRecords instead
   */
  behaviors: Array<Behavior>;
  /** Can user edit the immunizations table for a child? */
  canEdit: Scalars['Boolean'];
  /** Can user manage children immunizations for site. It replaces CanEditImmunizationRecords behavior */
  canManageRecords: Scalars['Boolean'];
  /** Can user manage reminders for staff and parents */
  canManageReminders: Scalars['Boolean'];
  /** Can user see the immunizations table for a child? */
  canView: Scalars['Boolean'];
  /** Can user see the children immunizations for site. It replaces ImmunizationRecordsRead behavior */
  canViewAllRecords: Scalars['Boolean'];
  records: ImmunizationRecordsResult;
  regulations: Array<ImmunizationRegulation>;
  vaccines: Array<Vaccine>;
};


export type ImmunizationsbaselineArgs = {
  siteId: Scalars['SiteId'];
};


export type ImmunizationsbehaviorsArgs = {
  institutionId: Scalars['InstitutionId'];
};


export type ImmunizationscanEditArgs = {
  childId: Scalars['ChildId'];
  siteId: Scalars['InstitutionId'];
};


export type ImmunizationscanManageRecordsArgs = {
  siteId: Scalars['InstitutionId'];
};


export type ImmunizationscanManageRemindersArgs = {
  siteId: Scalars['InstitutionId'];
};


export type ImmunizationscanViewArgs = {
  childId: Scalars['ChildId'];
  siteId: Scalars['InstitutionId'];
};


export type ImmunizationscanViewAllRecordsArgs = {
  siteId: Scalars['InstitutionId'];
};


export type ImmunizationsrecordsArgs = {
  after?: InputMaybe<Scalars['ImmunizationRecordsCursor']>;
  bornAfter?: InputMaybe<Scalars['LocalDate']>;
  bornBefore?: InputMaybe<Scalars['LocalDate']>;
  childGender?: InputMaybe<Gender>;
  childIds?: InputMaybe<Array<Scalars['ChildId']>>;
  completed?: InputMaybe<Scalars['Boolean']>;
  dueBetween?: InputMaybe<ClosedLocalDateRange>;
  exempted?: InputMaybe<Scalars['Boolean']>;
  groupIds?: InputMaybe<Array<Scalars['GroupId']>>;
  institutionId: Scalars['InstitutionId'];
  keyworkerIds?: InputMaybe<Array<Scalars['EmployeeId']>>;
  limit?: InputMaybe<Scalars['Int']>;
  overDue?: InputMaybe<Scalars['Boolean']>;
  tagIds?: InputMaybe<Array<Scalars['TagId']>>;
  upcoming?: InputMaybe<Scalars['Boolean']>;
  vaccineIds?: InputMaybe<Array<Scalars['VaccineId']>>;
  withBaseline?: InputMaybe<Scalars['Boolean']>;
};


export type ImmunizationsregulationsArgs = {
  institutionSetId?: InputMaybe<Scalars['InstitutionSetId']>;
};


export type ImmunizationsvaccinesArgs = {
  institutionSetIds: Array<Scalars['InstitutionSetId']>;
};

export enum ImportCategory {
  BILLPAYER = 'BILLPAYER',
  EMAIL_ADDRESS = 'EMAIL_ADDRESS',
  FOREIGN_ID = 'FOREIGN_ID',
  GROUP = 'GROUP',
  KITA_PLANER_CREDENTIALS = 'KITA_PLANER_CREDENTIALS',
  KITA_PLANER_RESPONSE = 'KITA_PLANER_RESPONSE',
  LOCAL_DATE = 'LOCAL_DATE',
  NAME = 'NAME',
  SIBLING = 'SIBLING',
  UNKNOWN = 'UNKNOWN'
}

/** Holds information about which parts of the import system is supported for the current user for a single site */
export type ImportConfiguration = {
  __typename?: 'ImportConfiguration';
  canExportFromKitaPlaner: Scalars['Boolean'];
  canImportBillPayers: Scalars['Boolean'];
  canImportDietaryInformation: Scalars['Boolean'];
  canImportDoctorInformation: Scalars['Boolean'];
  canImportEthnicityField: Scalars['Boolean'];
  canImportForeignIds: Scalars['Boolean'];
  canImportHealthInformation: Scalars['Boolean'];
  canImportRaceField: Scalars['Boolean'];
  canImportReligionField: Scalars['Boolean'];
  canImportSensitiveBillPayerInformation: Scalars['Boolean'];
  canImportSiblings: Scalars['Boolean'];
  canImportSocialSecurityNumber: Scalars['Boolean'];
  canManageKitaPlaner: Scalars['Boolean'];
  siteId: Scalars['InstitutionId'];
};

/** Count details for the import data */
export type ImportCountResult = {
  __typename?: 'ImportCountResult';
  /** Count of newly created bill payers */
  newBillPayers: Scalars['Int'];
  /** Count of newly created children */
  newChildren: Scalars['Int'];
  /** Count of newly created groups */
  newGroups: Scalars['Int'];
  /** Count of newly created child relations */
  newRelations: Scalars['Int'];
  /** Count of newly created siblings */
  newSiblings: Scalars['Int'];
};

export type ImportError = {
  __typename?: 'ImportError';
  category: ImportCategory;
  errorCode: Scalars['Int'];
  message: Scalars['String'];
};

/** Import functionality */
export type ImportMutation = {
  __typename?: 'ImportMutation';
  /** Import data */
  import: ImportResult;
};


/** Import functionality */
export type ImportMutationimportArgs = {
  importData: Array<ImportObjectInput>;
  preview: Scalars['Boolean'];
};

export type ImportObjectInput = {
  billPayer?: InputMaybe<BillPayerInput>;
  child?: InputMaybe<ChildCreationInput>;
  importObjectId: Scalars['ImportObjectId'];
  relations?: InputMaybe<Array<ChildRelationCreationInput>>;
  siblingForeignIds?: InputMaybe<Array<Scalars['String']>>;
};

/** All data for an import element */
export type ImportObjectInputResult = {
  __typename?: 'ImportObjectInputResult';
  billPayer?: Maybe<BillPayerInputResult>;
  child?: Maybe<ChildCreationInputResult>;
  importObjectId: Scalars['ImportObjectId'];
  relations?: Maybe<Array<ChildRelationCreationInputResult>>;
  siblingForeignIds?: Maybe<Array<Scalars['String']>>;
};

/** Output for the import module */
export type ImportObjectResult = {
  __typename?: 'ImportObjectResult';
  billPayer?: Maybe<BillPayerCreationResult>;
  child?: Maybe<ChildCreationResult>;
  importObjectId: Scalars['ImportObjectId'];
  relations?: Maybe<Array<ChildRelationCreationResult>>;
  siblings?: Maybe<Array<SiblingLinkCreationResult>>;
};

/** Queries related to import functionality */
export type ImportQuery = {
  __typename?: 'ImportQuery';
  /** @deprecated Behaviors are deprecated. Please use the `configuration` field instead. */
  behaviors: Array<Behavior>;
  /** Get import configuration for a site */
  configuration: ImportConfiguration;
  /** Link to template import file */
  template: ImportTemplate;
};


/** Queries related to import functionality */
export type ImportQuerybehaviorsArgs = {
  institutionId: Scalars['InstitutionId'];
};


/** Queries related to import functionality */
export type ImportQueryconfigurationArgs = {
  siteId: Scalars['InstitutionId'];
};


/** Queries related to import functionality */
export type ImportQuerytemplateArgs = {
  institutionId: Scalars['InstitutionId'];
};

/** Output for the import module */
export type ImportResult = {
  __typename?: 'ImportResult';
  counts: ImportCountResult;
  importData: Array<ImportObjectResult>;
};

/** Links and information about templates for use with Famly import */
export type ImportTemplate = {
  __typename?: 'ImportTemplate';
  templateUrl: Scalars['String'];
};

/** Top level object for in-app purchasing mutations */
export type InAppPurchaseMutations = {
  __typename?: 'InAppPurchaseMutations';
  fsConfirmSubscriptionFlow: FSConfirmSubscriptionFlowMutations;
};

/** Top level object for in-app purchasing */
export type InAppPurchaseObject = {
  __typename?: 'InAppPurchaseObject';
  fsConfirmSubscriptionFlow: FSConfirmSubscriptionFlowObject;
  package: PackageObject;
};

export type InViewType = {
  id: Scalars['NavigationItemId'];
  order: Scalars['Int'];
};

export enum InboxType {
  ALL = 'ALL',
  OWN = 'OWN',
  STAR = 'STAR'
}

/** Top level node for inquiries mutations */
export type InquiriesMutations = {
  __typename?: 'InquiriesMutations';
  /** Confirm an inquiry (enroll a child). */
  confirmInquiry: Inquiry;
  /** Creates a new Inquiry. */
  createInquiry: Inquiry;
  /** Creates a new inquiry action. */
  createInquiryAction: InquiryAction;
  /** Deletes inquiries given their IDs. */
  deleteInquiries: Array<Inquiry>;
  /** Deletes an inquiry action. */
  deleteInquiryAction: InquiryAction;
  /** Moves an inquiry to another site. */
  moveInquiry: Inquiry;
  /** Updates an inquiry. */
  updateInquiry: Inquiry;
  /** Updates an existing inquiry action. */
  updateInquiryAction: InquiryAction;
};


/** Top level node for inquiries mutations */
export type InquiriesMutationsconfirmInquiryArgs = {
  groupId: Scalars['GroupId'];
  inquiryId: Scalars['InquiryId'];
  startDate: Scalars['LocalDate'];
};


/** Top level node for inquiries mutations */
export type InquiriesMutationscreateInquiryArgs = {
  inquiryInput: InquiryInput;
};


/** Top level node for inquiries mutations */
export type InquiriesMutationscreateInquiryActionArgs = {
  inquiryActionInput: InquiryActionInput;
  inquiryId: Scalars['InquiryId'];
};


/** Top level node for inquiries mutations */
export type InquiriesMutationsdeleteInquiriesArgs = {
  inquiryIds: Array<Scalars['InquiryId']>;
};


/** Top level node for inquiries mutations */
export type InquiriesMutationsdeleteInquiryActionArgs = {
  inquiryActionId: Scalars['InquiryActionId'];
};


/** Top level node for inquiries mutations */
export type InquiriesMutationsmoveInquiryArgs = {
  inquiryId: Scalars['InquiryId'];
  targetSiteId: Scalars['SiteId'];
};


/** Top level node for inquiries mutations */
export type InquiriesMutationsupdateInquiryArgs = {
  inquiryId: Scalars['InquiryId'];
  inquiryUpdateInput: InquiryUpdateInput;
};


/** Top level node for inquiries mutations */
export type InquiriesMutationsupdateInquiryActionArgs = {
  inquiryActionId: Scalars['InquiryActionId'];
  inquiryActionInput: InquiryActionInput;
};

/** limitations related to inquiries */
export type InquiriesObject = {
  __typename?: 'InquiriesObject';
  /** determines if a user has access to activity logging */
  hasActivityLogging: Scalars['Boolean'];
  /**
   * determines if a user has access to inquiry activity log
   * @deprecated use limitationSettings endpoint instead
   */
  isInquiryActivityLogLimited: Scalars['Boolean'];
  /**
   * determines if a user has access to inquiry booking method
   * @deprecated use limitationSettings endpoint instead
   */
  isInquiryBookingMethodLimited: Scalars['Boolean'];
  /**
   * determines if a user has access to inquiry reason
   * @deprecated use limitationSettings endpoint instead
   */
  isInquiryReasonLimited: Scalars['Boolean'];
  /**
   * determines if a user has access to inquiry source
   * @deprecated use limitationSettings endpoint instead
   */
  isInquirySourceLimited: Scalars['Boolean'];
  /**
   * determines if a user has access to website form
   * @deprecated use limitationSettings endpoint instead
   */
  isWebsiteFormLimited: Scalars['Boolean'];
};

/** Top level node for inquiries queries */
export type InquiriesQueries = {
  __typename?: 'InquiriesQueries';
  /** Returns a list of inquiries matching supplied criteria. Data that user does not have read rights to will not be returned. */
  listInquiries: InquiriesResult;
  /** Returns a list of all rooms in an organisation. */
  listRooms: Array<Group>;
  /** Returns a list of all sites in an organisation. */
  listSites: Array<Site>;
  /** Gets details of single inquiry given an ID. */
  showInquiry: Inquiry;
};


/** Top level node for inquiries queries */
export type InquiriesQuerieslistInquiriesArgs = {
  cursor?: InputMaybe<Scalars['InquiriesCursor']>;
  filters?: InputMaybe<InquiryFilter>;
  pageSize?: InputMaybe<Scalars['Int']>;
  siteSetIds: Array<Scalars['SiteSetId']>;
  sortOrder?: InputMaybe<InquirySortOrder>;
};


/** Top level node for inquiries queries */
export type InquiriesQuerieslistRoomsArgs = {
  siteSetId: Scalars['SiteSetId'];
};


/** Top level node for inquiries queries */
export type InquiriesQuerieslistSitesArgs = {
  siteSetId: Scalars['SiteSetId'];
};


/** Top level node for inquiries queries */
export type InquiriesQueriesshowInquiryArgs = {
  inquiryId: Scalars['InquiryId'];
};

export type InquiriesResult = {
  __typename?: 'InquiriesResult';
  next?: Maybe<Scalars['InquiriesCursor']>;
  results: Array<Inquiry>;
};

/** limitations related to inquiries */
export type InquiriesSettingObject = {
  __typename?: 'InquiriesSettingObject';
  /**
   * determines if a user has access to inquiry activity log
   * @deprecated Use inquiryActivityLogLimitationWithSiteId instead
   */
  inquiryActivityLogLimitation: LimitationType;
  /** Determines if a site has access to inquiry activity log */
  inquiryActivityLogLimitationWithSiteId: LimitationType;
  /**
   * determines if a user has access to inquiry booking method
   * @deprecated Use inquiryBookingMethodLimitationWithSiteId instead
   */
  inquiryBookingMethodLimitation: LimitationType;
  /** Determines if a site has access to inquiry booking method */
  inquiryBookingMethodLimitationWithSiteId: LimitationType;
  /**
   * determines if a user has access to the inquiry conversion stat
   * @deprecated Use inquiryConversionStatLimitationWithSiteId instead
   */
  inquiryConversionStatLimitation: LimitationType;
  /** Determines if a site has access to inquiry conversion stat */
  inquiryConversionStatLimitationWithSiteId: LimitationType;
  /**
   * determines if a user has access to inquiry reason
   * @deprecated Use inquiryReasonLimitationWithSiteId instead
   */
  inquiryReasonLimitation: LimitationType;
  /** Determines if a site has access to inquiry reason */
  inquiryReasonLimitationWithSiteId: LimitationType;
  /**
   * determines if a user has access to inquiry source
   * @deprecated Use inquirySourceLimitationWithSiteId instead
   */
  inquirySourceLimitation: LimitationType;
  /** Determines if a site has access to inquiry source */
  inquirySourceLimitationWithSiteId: LimitationType;
  /**
   * determines if a user has access to inquiry activity log
   * @deprecated Use inquiryActivityLogLimitationWithSiteId instead
   */
  isInquiryActivityLogLimited: LimitationType;
  /**
   * determines if a user has access to inquiry booking method
   * @deprecated Use inquiryBookingMethodLimitationWithSiteId instead
   */
  isInquiryBookingMethodLimited: LimitationType;
  /**
   * determines if a user has access to the inquiry conversion stat
   * @deprecated Use inquiryConversionStatLimitationWithSiteId instead
   */
  isInquiryConversionStatLimited: LimitationType;
  /**
   * determines if a user has access to inquiry reason
   * @deprecated Use inquiryReasonLimitationWithSiteId instead
   */
  isInquiryReasonLimited: LimitationType;
  /**
   * determines if a user has access to inquiry source
   * @deprecated Use inquirySourceLimitationWithSiteId instead
   */
  isInquirySourceLimited: LimitationType;
  /**
   * determines if a user has access to website form
   * @deprecated Use websiteFormLimitationWithSiteId instead
   */
  isWebsiteFormLimited: LimitationType;
  /**
   * determines if a user has access to website form
   * @deprecated Use websiteFormLimitationWithSiteId instead
   */
  websiteFormLimitation: LimitationType;
  /** Determines if a site has access to website form */
  websiteFormLimitationWithSiteId: LimitationType;
};


/** limitations related to inquiries */
export type InquiriesSettingObjectinquiryActivityLogLimitationWithSiteIdArgs = {
  siteId: Scalars['SiteId'];
};


/** limitations related to inquiries */
export type InquiriesSettingObjectinquiryBookingMethodLimitationWithSiteIdArgs = {
  siteId: Scalars['SiteId'];
};


/** limitations related to inquiries */
export type InquiriesSettingObjectinquiryConversionStatLimitationWithSiteIdArgs = {
  siteId: Scalars['SiteId'];
};


/** limitations related to inquiries */
export type InquiriesSettingObjectinquiryReasonLimitationWithSiteIdArgs = {
  siteId: Scalars['SiteId'];
};


/** limitations related to inquiries */
export type InquiriesSettingObjectinquirySourceLimitationWithSiteIdArgs = {
  siteId: Scalars['SiteId'];
};


/** limitations related to inquiries */
export type InquiriesSettingObjectwebsiteFormLimitationWithSiteIdArgs = {
  siteId: Scalars['SiteId'];
};

/** Represents a child inquiry */
export type Inquiry = {
  __typename?: 'Inquiry';
  /** All actions on this inquiry */
  actions: Array<InquiryAction>;
  /** BookingSource */
  bookingSource?: Maybe<InquiryBookingSource>;
  /** Child */
  child?: Maybe<Child>;
  /** Child ID */
  childId: Scalars['ChildId'];
  /** The date of the inquiry */
  createdAt: Scalars['ZonedDateTime'];
  /** FTE for a child (if available) */
  fte?: Maybe<Scalars['Float']>;
  /** Inquiry Id */
  id: Scalars['InquiryId'];
  /** LostCategory */
  lostCategory?: Maybe<InquiryLostCategory>;
  /** LostReason */
  lostReason: Scalars['String'];
  /** Note */
  note: Scalars['String'];
  /** Plan for a child, if set */
  plan?: Maybe<Plan>;
  /** Reason */
  reason?: Maybe<InquiryReason>;
  /** Site ID */
  siteId: Scalars['SiteId'];
  /** Source */
  source?: Maybe<InquirySource>;
  /** Status of inquiry */
  status: InquiryStatus;
};

/** Represents a child inquiry action */
export type InquiryAction = {
  __typename?: 'InquiryAction';
  /** Inquiry action type */
  actionType: InquiryActionType;
  /** Inquiry action Id */
  id: Scalars['InquiryActionId'];
  /** Inquiry Id */
  inquiryId: Scalars['InquiryId'];
  /** Last update time of this action */
  lastUpdatedAt: Scalars['ZonedDateTime'];
};

export type InquiryActionInput = {
  due?: InputMaybe<Scalars['LocalDate']>;
  note?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<InquiryActionType>;
};

export enum InquiryActionType {
  EMAIL = 'EMAIL',
  OTHER = 'OTHER',
  PHONE = 'PHONE',
  QUOTE_SENT = 'QUOTE_SENT',
  SHOWAROUND = 'SHOWAROUND',
  STATUS_UPDATE = 'STATUS_UPDATE',
  TASK = 'TASK'
}

export enum InquiryBookingSource {
  CHILDCARE_SITE = 'CHILDCARE_SITE',
  DAYNURSERIES_SITE = 'DAYNURSERIES_SITE',
  DIRECT = 'DIRECT',
  EMAIL = 'EMAIL',
  FACEBOOK = 'FACEBOOK',
  PHONE = 'PHONE',
  WEBSITE = 'WEBSITE'
}

export type InquiryFeatureSettingsFlags = {
  __typename?: 'InquiryFeatureSettingsFlags';
  /** Returns true if the 'Download CSV' Button must be hidden. */
  hideEnquiryCSVDownload: Scalars['Boolean'];
  /** Returns true if the 'New Enquiry' Button on registration page must be hidden. */
  hideNewEnquiryButton: Scalars['Boolean'];
};

export type InquiryFilter = {
  actions: Array<InquiryActionType>;
  createdFrom?: InputMaybe<Scalars['LocalDate']>;
  createdTo?: InputMaybe<Scalars['LocalDate']>;
  rooms: Array<Scalars['GroupId']>;
  search?: InputMaybe<Scalars['String']>;
  sources: Array<InquirySource>;
  startFrom?: InputMaybe<Scalars['LocalDate']>;
  startTo?: InputMaybe<Scalars['LocalDate']>;
  statuses: Array<InquiryStatus>;
};

export type InquiryInput = {
  birthday?: InputMaybe<Scalars['LocalDate']>;
  bookingSource?: InputMaybe<InquiryBookingSource>;
  contactEmail?: InputMaybe<Scalars['EmailAddress']>;
  contactName?: InputMaybe<Scalars['NameInput']>;
  contactPhone?: InputMaybe<Scalars['PhoneNumber']>;
  gender?: InputMaybe<Gender>;
  groupId?: InputMaybe<Scalars['GroupId']>;
  lostCategory?: InputMaybe<InquiryLostCategory>;
  lostReason?: InputMaybe<Scalars['String']>;
  name: Scalars['NameInput'];
  note?: InputMaybe<Scalars['String']>;
  reason?: InputMaybe<InquiryReason>;
  siteId: Scalars['SiteId'];
  source?: InputMaybe<InquirySource>;
  startDate: Scalars['LocalDate'];
  status?: InputMaybe<InquiryStatus>;
};

export enum InquiryLostCategory {
  AVAILABILITY = 'AVAILABILITY',
  BETTER_FOOD = 'BETTER_FOOD',
  BETTER_TEACHING_FRAMEWORK_ELSEWHERE = 'BETTER_TEACHING_FRAMEWORK_ELSEWHERE',
  CANCELLED_REGISTRATION = 'CANCELLED_REGISTRATION',
  MOVED = 'MOVED',
  OTHER = 'OTHER',
  PRICE = 'PRICE'
}

export enum InquiryReason {
  BACK_TO_WORK = 'BACK_TO_WORK',
  ELIGIBLE_FOR_FREE_ENTITLEMENT = 'ELIGIBLE_FOR_FREE_ENTITLEMENT',
  LOOKED_AFTER_CHILD = 'LOOKED_AFTER_CHILD',
  MOVED_BACK = 'MOVED_BACK',
  MOVED_FROM_ANOTHER_CHILDCARE_SETTING = 'MOVED_FROM_ANOTHER_CHILDCARE_SETTING',
  MOVED_FROM_ANOTHER_INTERNAL_SETTING = 'MOVED_FROM_ANOTHER_INTERNAL_SETTING',
  NEW_EMPLOYMENT = 'NEW_EMPLOYMENT',
  OTHER = 'OTHER',
  PARENT_ACCESSING_LEARNING = 'PARENT_ACCESSING_LEARNING',
  SIBLINGS_AT_THE_SETTING = 'SIBLINGS_AT_THE_SETTING',
  SOCIAL_INTERACTION = 'SOCIAL_INTERACTION'
}

export enum InquirySortOrder {
  ByChildNameAsc = 'ByChildNameAsc',
  ByChildNameDesc = 'ByChildNameDesc',
  ByContactNameAsc = 'ByContactNameAsc',
  ByContactNameDesc = 'ByContactNameDesc',
  ByCreatedAsc = 'ByCreatedAsc',
  ByCreatedDesc = 'ByCreatedDesc',
  ByFteAsc = 'ByFteAsc',
  ByFteDesc = 'ByFteDesc',
  ByLastActionAsc = 'ByLastActionAsc',
  ByLastActionDesc = 'ByLastActionDesc',
  ByNoteAsc = 'ByNoteAsc',
  ByNoteDesc = 'ByNoteDesc',
  ByPlanNameAsc = 'ByPlanNameAsc',
  ByPlanNameDesc = 'ByPlanNameDesc',
  ByRoomNameAsc = 'ByRoomNameAsc',
  ByRoomNameDesc = 'ByRoomNameDesc',
  BySiteNameAsc = 'BySiteNameAsc',
  BySiteNameDesc = 'BySiteNameDesc',
  ByStartAsc = 'ByStartAsc',
  ByStartDesc = 'ByStartDesc',
  ByStatusAsc = 'ByStatusAsc',
  ByStatusDesc = 'ByStatusDesc',
  Default = 'Default'
}

export enum InquirySource {
  BANNER = 'BANNER',
  CHILDCARE_SITE = 'CHILDCARE_SITE',
  CRM = 'CRM',
  CURRENT_CHILD_ATTENDING = 'CURRENT_CHILD_ATTENDING',
  DAYNURSERIES_SITE = 'DAYNURSERIES_SITE',
  DAY_NURSERIES = 'DAY_NURSERIES',
  FAMILY_INFORMATION_SERVICES = 'FAMILY_INFORMATION_SERVICES',
  FLOURISH_CRM = 'FLOURISH_CRM',
  FOREST_SCHOOL_ASSOCIATION = 'FOREST_SCHOOL_ASSOCIATION',
  LEAFLETS_BROCHURES = 'LEAFLETS_BROCHURES',
  LOCAL_AUTHORITY_SIGNPOSTING = 'LOCAL_AUTHORITY_SIGNPOSTING',
  LOCAL_PRESS = 'LOCAL_PRESS',
  OPEN_DAY_EVENT = 'OPEN_DAY_EVENT',
  OTHER = 'OTHER',
  OTHER_NURSERY = 'OTHER_NURSERY',
  PARENT_RECOMMENDATION = 'PARENT_RECOMMENDATION',
  PRINT_ADVERT = 'PRINT_ADVERT',
  SEARCH_ENGINE = 'SEARCH_ENGINE',
  SIBLING = 'SIBLING',
  SOCIAL_MEDIA = 'SOCIAL_MEDIA',
  STAFF_RECOMMENDATION = 'STAFF_RECOMMENDATION',
  WEBSITE = 'WEBSITE',
  WORD_OF_MOUTH = 'WORD_OF_MOUTH'
}

export enum InquiryStatus {
  CONFIRMED = 'CONFIRMED',
  CONTACTED = 'CONTACTED',
  LOST = 'LOST',
  NEW = 'NEW',
  VIEWED = 'VIEWED',
  WAITING_LIST = 'WAITING_LIST'
}

export type InquiryUpdateInput = {
  bookingSource?: InputMaybe<InquiryBookingSource>;
  groupId?: InputMaybe<Scalars['GroupId']>;
  lostCategory?: InputMaybe<InquiryLostCategory>;
  lostReason?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  reason?: InputMaybe<InquiryReason>;
  source?: InputMaybe<InquirySource>;
  status?: InputMaybe<InquiryStatus>;
};

/** The activity library for a specific institution */
export type InstitutionActivityLibrary = {
  __typename?: 'InstitutionActivityLibrary';
  institution: Site;
};

/** Holds info on Institution and payload that are associated with given Behavior */
export type InstitutionBehaviorNode = {
  __typename?: 'InstitutionBehaviorNode';
  id: Scalars['String'];
  institution: Site;
  payload: Array<BehaviorPayload>;
};

export type InstitutionDetails = {
  __typename?: 'InstitutionDetails';
  address?: Maybe<Address>;
  behaviors: Array<Behavior>;
  contactPerson?: Maybe<Name>;
  description?: Maybe<Scalars['String']>;
  ean?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  socialMedia?: Maybe<SocialMedia>;
  vat?: Maybe<Scalars['String']>;
};

export type InstitutionFundingYearMutations = {
  __typename?: 'InstitutionFundingYearMutations';
  /** Create a new KiBiG funding year for institution */
  createInstitutionFundingYear: KibigInstitutionFundingYear;
  /** Delete KiBiG funding year for institution */
  deleteInstitutionFundingYear: Scalars['Boolean'];
  /** Update existing KiBiG funding year for institution */
  updateInstitutionFundingYear: KibigInstitutionFundingYear;
};


export type InstitutionFundingYearMutationscreateInstitutionFundingYearArgs = {
  baseValue: Scalars['BigDecimal'];
  bonus: Scalars['BigDecimal'];
  expansionFactor: Scalars['BigDecimal'];
  institutionId: Scalars['InstitutionId'];
  year: Scalars['Int'];
};


export type InstitutionFundingYearMutationsdeleteInstitutionFundingYearArgs = {
  fundingId: Scalars['KibigFundingId'];
};


export type InstitutionFundingYearMutationsupdateInstitutionFundingYearArgs = {
  baseValue: Scalars['BigDecimal'];
  bonus: Scalars['BigDecimal'];
  expansionFactor: Scalars['BigDecimal'];
  fundingId: Scalars['KibigFundingId'];
};

/** Mutations managing institution features */
export type InstitutionManagedFeaturesMutations = {
  __typename?: 'InstitutionManagedFeaturesMutations';
  /** Relate a parental permission with a feature flag. Parental permission must have as target an institution or an org, any other target will be dismissed */
  linkFeatureWithParentalPermission: LinkedFeaturesWithParentalPermission;
  setFeatures: Array<ManagedFeature>;
};


/** Mutations managing institution features */
export type InstitutionManagedFeaturesMutationslinkFeatureWithParentalPermissionArgs = {
  input: ParentalPermissionFeatureInput;
};


/** Mutations managing institution features */
export type InstitutionManagedFeaturesMutationssetFeaturesArgs = {
  features: Array<FeatureState>;
  institutionId: Scalars['InstitutionId'];
};

/** Media tag allowance by institution */
export type InstitutionMediaTagAllowance = {
  __typename?: 'InstitutionMediaTagAllowance';
  childrenAllowance: Array<ChildMediaTagAllowance>;
  /** Children allowance by group. If child doesn't have a group assigned it won't be listed here */
  groupAllowance: Array<GroupMediaTagAllowance>;
  institution: Site;
};

export type InstitutionSet = {
  __typename?: 'InstitutionSet';
  institutionSetId: Scalars['InstitutionSetId'];
  profileImage?: Maybe<ProfileImage>;
  siteType: Scalars['String'];
  title: Scalars['String'];
};

/** Information about an institution set */
export type InstitutionSetInfo = {
  __typename?: 'InstitutionSetInfo';
  country: Scalars['Country'];
  institutionSetId: Scalars['InstitutionSetId'];
  isInstitution: Scalars['Boolean'];
  isOrganization: Scalars['Boolean'];
};

/** All reference material for an institution */
export type InstitutionSetReferenceMaterial = {
  __typename?: 'InstitutionSetReferenceMaterial';
  institution: Site;
  /** Reference material. Currently, this is only supporting reference material linked to Learning Frameworks */
  referenceMaterial: Array<FrameworkRefMaterial>;
};

export type InstitutionSetting = {
  status: InstitutionSettingStatus;
  subtitle: InstitutionSettingSubtitle;
  title: Scalars['String'];
};

export type InstitutionSettingAccounting = InstitutionSetting & {
  __typename?: 'InstitutionSettingAccounting';
  status: InstitutionSettingStatus;
  subtitle: InstitutionSettingSubtitle;
  title: Scalars['String'];
};

export type InstitutionSettingBillingProfiles = InstitutionSetting & {
  __typename?: 'InstitutionSettingBillingProfiles';
  status: InstitutionSettingStatus;
  subtitle: InstitutionSettingSubtitle;
  title: Scalars['String'];
};

export type InstitutionSettingChildren = InstitutionSetting & {
  __typename?: 'InstitutionSettingChildren';
  status: InstitutionSettingStatus;
  subtitle: InstitutionSettingSubtitle;
  title: Scalars['String'];
};

export type InstitutionSettingFunding = InstitutionSetting & {
  __typename?: 'InstitutionSettingFunding';
  status: InstitutionSettingStatus;
  subtitle: InstitutionSettingSubtitle;
  title: Scalars['String'];
};

export type InstitutionSettingGroup = {
  __typename?: 'InstitutionSettingGroup';
  groups: Array<InstitutionSetting>;
  title: Scalars['String'];
};

export type InstitutionSettingInvoiceLayout = InstitutionSetting & {
  __typename?: 'InstitutionSettingInvoiceLayout';
  status: InstitutionSettingStatus;
  subtitle: InstitutionSettingSubtitle;
  title: Scalars['String'];
};

export type InstitutionSettingMealSettings = InstitutionSetting & {
  __typename?: 'InstitutionSettingMealSettings';
  status: InstitutionSettingStatus;
  subtitle: InstitutionSettingSubtitle;
  title: Scalars['String'];
};

export type InstitutionSettingNurseryInfo = InstitutionSetting & {
  __typename?: 'InstitutionSettingNurseryInfo';
  status: InstitutionSettingStatus;
  subtitle: InstitutionSettingSubtitle;
  title: Scalars['String'];
};

export type InstitutionSettingParentBookings = InstitutionSetting & {
  __typename?: 'InstitutionSettingParentBookings';
  status: InstitutionSettingStatus;
  subtitle: InstitutionSettingSubtitle;
  title: Scalars['String'];
};

export type InstitutionSettingParentPayments = InstitutionSetting & {
  __typename?: 'InstitutionSettingParentPayments';
  status: InstitutionSettingStatus;
  subtitle: InstitutionSettingSubtitle;
  title: Scalars['String'];
};

export type InstitutionSettingPlans = InstitutionSetting & {
  __typename?: 'InstitutionSettingPlans';
  status: InstitutionSettingStatus;
  subtitle: InstitutionSettingSubtitle;
  title: Scalars['String'];
};

export type InstitutionSettingPricing = InstitutionSetting & {
  __typename?: 'InstitutionSettingPricing';
  status: InstitutionSettingStatus;
  subtitle: InstitutionSettingSubtitle;
  title: Scalars['String'];
};

export type InstitutionSettingRooms = InstitutionSetting & {
  __typename?: 'InstitutionSettingRooms';
  status: InstitutionSettingStatus;
  subtitle: InstitutionSettingSubtitle;
  title: Scalars['String'];
};

export type InstitutionSettingStaff = InstitutionSetting & {
  __typename?: 'InstitutionSettingStaff';
  status: InstitutionSettingStatus;
  subtitle: InstitutionSettingSubtitle;
  title: Scalars['String'];
};

export enum InstitutionSettingStatus {
  complete = 'complete',
  disabled = 'disabled',
  incomplete = 'incomplete',
  normal = 'normal'
}

export type InstitutionSettingSubtitle = {
  __typename?: 'InstitutionSettingSubtitle';
  label: Scalars['String'];
  status: InstitutionSettingStatus;
};

export type InstitutionSettings = {
  __typename?: 'InstitutionSettings';
  /** All setting elements */
  allSettings: Array<SettingsTree>;
  /** @deprecated Use field 'setup' instead */
  settingGroups: Array<InstitutionSettingGroup>;
  /** Elements used during the setup process */
  setup: Array<InstitutionSettingGroup>;
};

export enum InstitutionType {
  AFTERSCHOOL = 'AFTERSCHOOL',
  CHILDMINDER = 'CHILDMINDER',
  NON_PROFIT = 'NON_PROFIT',
  NURSERY = 'NURSERY',
  NURSERY_GROUP = 'NURSERY_GROUP',
  OOSC = 'OOSC',
  PRESCHOOL = 'PRESCHOOL',
  SINGLE_NURSERY = 'SINGLE_NURSERY',
  WRAPAROUND = 'WRAPAROUND'
}

/** Objects related to mutating institutions */
export type InstitutionsMutation = {
  __typename?: 'InstitutionsMutation';
  departments: DepartmentMutations;
  description: DescriptionMutations;
  managedFeatures: InstitutionManagedFeaturesMutations;
  rules: RulesMutations;
  saveSwissInstitutionData: Scalars['Boolean'];
  socialMedia: SocialMediaMutations;
  tags: TagMutations;
  updateAgeGroups: AgeGroupSet;
  updateConstituentCountry?: Maybe<ConstituentCountries>;
  updateRollingDeletion: Array<RollingDeletion>;
};


/** Objects related to mutating institutions */
export type InstitutionsMutationsaveSwissInstitutionDataArgs = {
  institutionId: Scalars['InstitutionId'];
  qrIbanAccount?: InputMaybe<Scalars['String']>;
};


/** Objects related to mutating institutions */
export type InstitutionsMutationupdateAgeGroupsArgs = {
  ageGroups: Array<AgeGroupInput>;
  institutionId: Scalars['InstitutionId'];
  validFrom: Scalars['LocalDate'];
};


/** Objects related to mutating institutions */
export type InstitutionsMutationupdateConstituentCountryArgs = {
  country?: InputMaybe<ConstituentCountries>;
  siteId: Scalars['SiteId'];
};


/** Objects related to mutating institutions */
export type InstitutionsMutationupdateRollingDeletionArgs = {
  institutionId: Scalars['InstitutionId'];
  rollingDeletion: Array<RollingDeletionInput>;
};

/** Result of creating one or more new integrations */
export type IntegrationCreate = {
  __typename?: 'IntegrationCreate';
  institutionSetIds: Array<Scalars['InstitutionSetId']>;
};

/** Input for creating/registering a new generic integration */
export type IntegrationCreateInput = {
  institutionSetIds: Array<Scalars['InstitutionSetId']>;
};

/** Info about external integrations */
export type IntegrationInfo = {
  __typename?: 'IntegrationInfo';
  behaviors: Array<Behavior>;
  integrationName?: Maybe<Scalars['String']>;
};

export enum IntegrationKind {
  /** Indicates if this is native or custom integration */
  custom = 'custom',
  /** Indicates if this is native or custom integration */
  native = 'native'
}

export type IntegrationMutations = {
  __typename?: 'IntegrationMutations';
  /** Create new integration setups for the given institution set IDs */
  create: IntegrationCreate;
  /** Terminates Famly's access to a Xero account */
  deleteXeroConnection: Scalars['Boolean'];
  export: ExportMutations;
  kitabuli: KitabuliMutations;
  task: IntegrationTaskMutations;
};


export type IntegrationMutationscreateArgs = {
  input: IntegrationCreateInput;
};


export type IntegrationMutationsdeleteXeroConnectionArgs = {
  institutionSetId: Scalars['InstitutionSetId'];
};

export type IntegrationQueries = {
  __typename?: 'IntegrationQueries';
  info: IntegrationInfo;
  kitabuli: KitabuliQueries;
  task: IntegrationTaskQueries;
  xero: XeroIntegrationQueries;
};


export type IntegrationQueriesinfoArgs = {
  institutionSetId: Scalars['InstitutionSetId'];
};

/** Details about supported features and integrations */
export type IntegrationSupport = {
  __typename?: 'IntegrationSupport';
  /** Indicates support for viewing and exporting the Child-based Funding report. */
  canExportChildBasedFundingReport: FeatureSupportState;
  /** Indicates support for exporting DATEV reports and data. */
  canExportDatev: FeatureSupportState;
  /** Indicates support for exporting invoice PDFs. */
  canExportInvoicePdfs: FeatureSupportState;
  /** Indicates support for exporting the detailed Organization-level Public Funding report. */
  canExportOrgPublicFunding: FeatureSupportState;
  /** Indicates support for exporting SEPA reports and data. */
  canExportSEPA: FeatureSupportState;
  /** Indicates support for exporting Sage200 reports and data. */
  canExportSage200: FeatureSupportState;
  /** Indicates support for exporting Xero reports and data. */
  canExportXero: FeatureSupportState;
  /** Indicates whether the user can manage Payment Methods on behalf of the Bill Payer. */
  canManageBillPayerPaymentMethods: FeatureSupportState;
  /** Indicates support for managing Plans for Attendance purposes. */
  canManagePlansForAttendance: FeatureSupportState;
  /** Indicates whether the user can manage the public funding settings. */
  canManagePublicFundingSettings: FeatureSupportState;
  /** Indicates support for using Automatic Invoicing. */
  canUseAutomaticInvoicing: FeatureSupportState;
  /** Information about the Kitabuli integration */
  kitabuli: SupportsKitabuli;
  /**
   * Information about the parent purchases feature
   * @deprecated Use the `purchases` field instead. These features apply to all purchases, not just parent purchases
   */
  parentPurchases: SupportsParentPurchases;
  /** Information about purchases */
  purchases: SupportsPurchases;
  /** Indicates support for adjusting invoice date to first of selected month. */
  shouldAdjustInvoiceDate: FeatureSupportState;
};

/** A task arising from an integration with an external system (e.g. an accounting system) */
export type IntegrationTask = {
  institution: Site;
  institutionSetId: Scalars['InstitutionSetId'];
  integrationTaskId: Scalars['IntegrationTaskId'];
  message?: Maybe<Scalars['String']>;
  prettifiedMessage?: Maybe<Scalars['String']>;
  status: IntegrationTaskStatus;
  taskType: IntegrationTaskType;
  updatedAt?: Maybe<Scalars['ZonedDateTime']>;
};

/** A task related to a specific bill payer */
export type IntegrationTaskBillPayer = IntegrationTask & {
  __typename?: 'IntegrationTaskBillPayer';
  billPayer: BillPayer;
  billPayerRetryAction?: Maybe<IntegrationTaskBillPayerAction>;
  institution: Site;
  institutionSetId: Scalars['InstitutionSetId'];
  integrationTaskId: Scalars['IntegrationTaskId'];
  message?: Maybe<Scalars['String']>;
  prettifiedMessage?: Maybe<Scalars['String']>;
  status: IntegrationTaskStatus;
  taskType: IntegrationTaskType;
  updatedAt?: Maybe<Scalars['ZonedDateTime']>;
};

export enum IntegrationTaskBillPayerAction {
  BillPayerCreate = 'BillPayerCreate',
  BillPayerUpdate = 'BillPayerUpdate'
}

export type IntegrationTaskDismissResult = {
  __typename?: 'IntegrationTaskDismissResult';
  integrationTaskIds: Array<Scalars['IntegrationTaskId']>;
};

/** A task related to a specific invoice */
export type IntegrationTaskInvoice = IntegrationTask & {
  __typename?: 'IntegrationTaskInvoice';
  institution: Site;
  institutionSetId: Scalars['InstitutionSetId'];
  integrationTaskId: Scalars['IntegrationTaskId'];
  invoice: Invoice;
  /** Invoice ID included here since it is optional on the Invoice type */
  invoiceId: Scalars['InvoiceId'];
  invoiceRetryAction?: Maybe<IntegrationTaskInvoiceAction>;
  message?: Maybe<Scalars['String']>;
  prettifiedMessage?: Maybe<Scalars['String']>;
  status: IntegrationTaskStatus;
  taskType: IntegrationTaskType;
  updatedAt?: Maybe<Scalars['ZonedDateTime']>;
};

export enum IntegrationTaskInvoiceAction {
  InvoiceSend = 'InvoiceSend'
}

export type IntegrationTaskMutations = {
  __typename?: 'IntegrationTaskMutations';
  dismiss: IntegrationTaskDismissResult;
};


export type IntegrationTaskMutationsdismissArgs = {
  integrationTaskIds: Array<Scalars['IntegrationTaskId']>;
};

/** A task related to a specific payment */
export type IntegrationTaskPayment = IntegrationTask & {
  __typename?: 'IntegrationTaskPayment';
  institution: Site;
  institutionSetId: Scalars['InstitutionSetId'];
  integrationTaskId: Scalars['IntegrationTaskId'];
  message?: Maybe<Scalars['String']>;
  payment: Payment;
  paymentRetryAction?: Maybe<PaymentTaskInvoiceAction>;
  prettifiedMessage?: Maybe<Scalars['String']>;
  status: IntegrationTaskStatus;
  taskType: IntegrationTaskType;
  updatedAt?: Maybe<Scalars['ZonedDateTime']>;
};

export type IntegrationTaskQueries = {
  __typename?: 'IntegrationTaskQueries';
  list: Array<IntegrationTask>;
};


export type IntegrationTaskQuerieslistArgs = {
  institutionSetId: Scalars['InstitutionSetId'];
  status: Array<IntegrationTaskStatus>;
};

export enum IntegrationTaskStatus {
  Failed = 'Failed',
  Pending = 'Pending',
  Successful = 'Successful'
}

export enum IntegrationTaskType {
  BillPayerCreate = 'BillPayerCreate',
  BillPayerUpdate = 'BillPayerUpdate',
  InvoiceSend = 'InvoiceSend',
  PaymentCreate = 'PaymentCreate',
  PaymentUpdate = 'PaymentUpdate'
}

export enum IntegrationType {
  kinderconnect = 'kinderconnect',
  quickbooks = 'quickbooks',
  slack = 'slack',
  xero = 'xero',
  zohocrm = 'zohocrm'
}

/** Fields for payment methods related to internal invoicing */
export type InternalPaymentMethodFields = {
  __typename?: 'InternalPaymentMethodFields';
  /** Retrieve client secret for existing pending setup intent for payment source */
  clientSecret?: Maybe<Scalars['String']>;
};


/** Fields for payment methods related to internal invoicing */
export type InternalPaymentMethodFieldsclientSecretArgs = {
  billPayerId: Scalars['BillPayerId'];
  paymentsSourceId: Scalars['PaymentsSourceId'];
};

/** Mutations for payment methods related to internal invoicing */
export type InternalPaymentMethodMutations = {
  __typename?: 'InternalPaymentMethodMutations';
  /** Cancel a payment that is in PENDING or REQUIRES_VALIDATION state */
  cancelPayment: CancelPaymentResult;
  /** Create a Direct Debit Instruction required for BACS Direct Debit */
  createDDI: DirectDebitInstruction;
  /** Create a setup intent for available payment methods and options */
  createPaymentIntent: StartPaymentMethod;
  /** Remove a payment source */
  deletePaymentSource: Scalars['PaymentsSourceId'];
  /** Resume a payment that is in REQUIRES_VALIDATION state */
  resumePayment: PaymentResponse;
  /** Save payment method for later use */
  savePaymentMethod: PaymentsSource;
  /** Verify payment method, mark as active and attach to Stripe customer */
  verifyPaymentMethod: PaymentsSource;
};


/** Mutations for payment methods related to internal invoicing */
export type InternalPaymentMethodMutationscancelPaymentArgs = {
  billPayerId: Scalars['BillPayerId'];
  paymentId: Scalars['PaymentId'];
};


/** Mutations for payment methods related to internal invoicing */
export type InternalPaymentMethodMutationscreateDDIArgs = {
  accountHolder: Scalars['String'];
  accountNumber: Scalars['String'];
  addressCity: Scalars['String'];
  addressStreet: Scalars['String'];
  addressZip: Scalars['String'];
  billPayerId: Scalars['BillPayerId'];
  sortCode: Scalars['String'];
};


/** Mutations for payment methods related to internal invoicing */
export type InternalPaymentMethodMutationscreatePaymentIntentArgs = {
  billPayerId: Scalars['BillPayerId'];
};


/** Mutations for payment methods related to internal invoicing */
export type InternalPaymentMethodMutationsdeletePaymentSourceArgs = {
  billPayerId: Scalars['BillPayerId'];
  paymentSourceId: Scalars['PaymentsSourceId'];
};


/** Mutations for payment methods related to internal invoicing */
export type InternalPaymentMethodMutationsresumePaymentArgs = {
  billPayerId: Scalars['BillPayerId'];
  paymentId: Scalars['PaymentId'];
};


/** Mutations for payment methods related to internal invoicing */
export type InternalPaymentMethodMutationssavePaymentMethodArgs = {
  billPayerId: Scalars['BillPayerId'];
  isVerified?: InputMaybe<Scalars['Boolean']>;
  paymentMethodId: Scalars['String'];
};


/** Mutations for payment methods related to internal invoicing */
export type InternalPaymentMethodMutationsverifyPaymentMethodArgs = {
  billPayerId: Scalars['BillPayerId'];
  paymentsSourceId: Scalars['PaymentsSourceId'];
};

export type InternalSiblingLink = SiblingLink & {
  __typename?: 'InternalSiblingLink';
  /** Can be null if the sibling link is internal and the sibling doesn't have a birthday */
  birthDate?: Maybe<Scalars['LocalDate']>;
  canAccessSibling: Scalars['Boolean'];
  /** Will be null if not set. */
  endDate?: Maybe<Scalars['LocalDate']>;
  id: Scalars['SiblingLinkId'];
  institution: Site;
  name: Name;
  sibling: Child;
  siblingId: Scalars['ChildId'];
  /** The start date for the sibling (optional for external siblings) */
  startDate?: Maybe<Scalars['LocalDate']>;
};

export type IntervalSummary = {
  __typename?: 'IntervalSummary';
  staffAttended: Scalars['Int'];
  staffRequired: Scalars['Float'];
  staffScheduled: Scalars['Int'];
};

export type InvalidRoleInvitation = RoleInvitation & {
  __typename?: 'InvalidRoleInvitation';
  error: Scalars['String'];
  privacyPolicyLink?: Maybe<Scalars['String']>;
  roleId: Scalars['RoleId'];
  roleInvitationId: Scalars['RoleInvitationId'];
  roleTitle: Scalars['String'];
  siteTitle: Scalars['String'];
  verification: RoleInvitationVerification;
};

/** An invoice with line data */
export type Invoice = {
  __typename?: 'Invoice';
  billPayer: BillPayer;
  dueDate: Scalars['LocalDate'];
  externalReferences: Array<InvoiceExternalSystemReference>;
  invoiceDate: Scalars['LocalDate'];
  /** A JSON blob of invoice details as generated by core in the generic table format. */
  invoiceDetailsCore: Scalars['String'];
  invoiceId?: Maybe<Scalars['InvoiceId']>;
  invoiceNumber: Scalars['String'];
  lines: Array<InvoiceLine>;
  pdf?: Maybe<InvoicePDF>;
  title: Scalars['String'];
  total: Scalars['BadMoney'];
};

export enum InvoiceExportFormat {
  Csv = 'Csv',
  Xero = 'Xero'
}

export enum InvoiceExportIncludes {
  Invoices = 'Invoices',
  Items = 'Items',
  Lines = 'Lines'
}

export type InvoiceExportInputType = {
  institutionId: Scalars['InstitutionId'];
  invoiceId: Scalars['InvoiceId'];
};

/** The result of a(n) invoice export */
export type InvoiceExportResult = {
  __typename?: 'InvoiceExportResult';
  details: Array<InvoiceExportStatus>;
  /** @deprecated Use details instead */
  failed: Array<ExportedInvoice>;
  /** @deprecated Use details instead */
  succeeded: Array<ExportedInvoice>;
};

/** The status of exporting a(n) invoice */
export type InvoiceExportStatus = {
  __typename?: 'InvoiceExportStatus';
  invoiceId: Scalars['InvoiceId'];
  status: SynchronizationStatus;
};

export enum InvoiceExportStatusValue {
  Completed = 'Completed',
  Expired = 'Expired',
  Pending = 'Pending'
}

/** Details of the reference in an external system for a specific invoice */
export type InvoiceExternalSystemReference = {
  __typename?: 'InvoiceExternalSystemReference';
  /** The external ID this invoice relates to. */
  id: Scalars['String'];
  /** The name of the custom integration. Only relevant if `system` is set to `CUSTOM`. */
  name?: Maybe<Scalars['String']>;
  /** The name of the external system this invoice relates to, or 'CUSTOM' if it is a custom integration. */
  system: ExternalSystemName;
};

/** Details of the reference in an external system for a specific invoice */
export type InvoiceExternalSystemReferenceInput = {
  /** The external ID this invoice relates to. */
  id: Scalars['String'];
  /** The name of the custom integration. Only relevant if `system` is set to `CUSTOM`. */
  name?: InputMaybe<Scalars['String']>;
  /** The name of the external system this invoice relates to, or 'CUSTOM' if it is a custom integration. */
  system?: InputMaybe<ExternalSystemName>;
};

/** A description of errors that took place when generating invoices */
export type InvoiceFailure = {
  __typename?: 'InvoiceFailure';
  billPayer: BillPayer;
  /** A list of errors that occurred while generating invoices, in arbitrary order */
  errors: Array<FamlyError>;
};

/** A line on an invoice */
export type InvoiceLine = {
  shareLineRelations: Array<SubLineRelation>;
  total: Scalars['BadMoney'];
};

export enum InvoiceMode {
  BatchPersist = 'BatchPersist',
  Persist = 'Persist',
  Preview = 'Preview'
}

export type InvoiceMutations = {
  __typename?: 'InvoiceMutations';
  automaticInvoicing: AutomaticInvoicingConfigMutation;
  create: CreateInvoicesResult;
  /** Update the external reference of an invoice */
  updateExternalReference: InvoiceExternalSystemReference;
};


export type InvoiceMutationscreateArgs = {
  dueDate: Scalars['LocalDate'];
  invoiceDate?: InputMaybe<Scalars['LocalDate']>;
  mode: InvoiceMode;
  notify: Scalars['Boolean'];
  range: ClosedLocalDateRange;
  requests: Array<InvoiceRequest>;
};


export type InvoiceMutationsupdateExternalReferenceArgs = {
  externalReference: InvoiceExternalSystemReferenceInput;
  invoiceId: Scalars['InvoiceId'];
};

/** An invoice rendered to PDF */
export type InvoicePDF = {
  invoiceId: Scalars['InvoiceId'];
};

/** An invoice PDF encoded as a base64 string */
export type InvoicePDFBase64 = InvoicePDF & {
  __typename?: 'InvoicePDFBase64';
  data: Scalars['String'];
  invoiceId: Scalars['InvoiceId'];
};

/** A file with a beautiful PDF */
export type InvoicePDFFile = InvoicePDF & {
  __typename?: 'InvoicePDFFile';
  file: File;
  invoiceId: Scalars['InvoiceId'];
};

export type InvoiceQueries = {
  __typename?: 'InvoiceQueries';
  automaticInvoicing: AutomaticInvoicingConfigQuery;
  byBillPayers: InvoicesResult;
  /** List invoices for each child where the child appears on at least one invoice line. */
  byChild: Array<InvoicesForChild>;
  byInvoiceNumber?: Maybe<Invoice>;
  exports: ExportsQueries;
};


export type InvoiceQueriesbyBillPayersArgs = {
  billPayers: Array<BillPayerReferenceInput>;
};


export type InvoiceQueriesbyChildArgs = {
  billPayerShareFilter: BillPayerShareFilter;
  childIds: Array<Scalars['ChildId']>;
};


export type InvoiceQueriesbyInvoiceNumberArgs = {
  institutionSetId: Scalars['InstitutionSetId'];
  invoiceNumber: Scalars['Int'];
};

export type InvoiceRequest = {
  billPayerId: Scalars['BillPayerId'];
  customLines?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
};

/** An invoice, or a description of errors if invoicing was not successful */
export type InvoiceResult = InvoiceFailure | InvoiceSuccess;

/** Represents an invoice run */
export type InvoiceRun = {
  __typename?: 'InvoiceRun';
  institutionId: Scalars['InstitutionId'];
  runId: Scalars['RunId'];
};

/** Invoice Settings */
export type InvoiceSettings = {
  __typename?: 'InvoiceSettings';
  costCenter?: Maybe<Scalars['String']>;
};

export enum InvoiceStatus {
  NoInvoices = 'NoInvoices',
  SomeInvoices = 'SomeInvoices'
}

/** An invoice */
export type InvoiceSuccess = {
  __typename?: 'InvoiceSuccess';
  invoice: Invoice;
};

/** An invoice without line data */
export type InvoiceWithoutLines = {
  __typename?: 'InvoiceWithoutLines';
  billPayer: BillPayer;
  dueDate: Scalars['LocalDate'];
  externalReferences: Array<InvoiceExternalSystemReference>;
  invoiceDate: Scalars['LocalDate'];
  invoiceId?: Maybe<Scalars['InvoiceId']>;
  invoiceNumber: Scalars['String'];
  title: Scalars['String'];
  total: Scalars['BadMoney'];
};

/** description */
export type InvoicesForChild = {
  __typename?: 'InvoicesForChild';
  child: Child;
  invoices: Array<InvoiceWithoutLines>;
};

/** Contains a list of invoices */
export type InvoicesResult = {
  __typename?: 'InvoicesResult';
  invoices: Array<Invoice>;
};

export enum InvoicingPeriod {
  /** @deprecated Use `NEXT` instead */
  ADVANCE = 'ADVANCE',
  /** @deprecated Use `PREVIOUS` instead */
  ARREAR = 'ARREAR',
  CURRENT = 'CURRENT',
  NEXT = 'NEXT',
  PREVIOUS = 'PREVIOUS'
}

export enum InvoicingScheme {
  HALFWAY = 'HALFWAY',
  IMPROVED = 'IMPROVED',
  STANDARD = 'STANDARD'
}

export type ItemsMutationType = {
  __typename?: 'ItemsMutationType';
  remove: Scalars['Boolean'];
};


export type ItemsMutationTyperemoveArgs = {
  removeNavigationItemInfo: RemoveNavigationItemInfoType;
};

/** Objects related to Kibig funding */
export type Kibig = {
  __typename?: 'Kibig';
  /** Retrieve the active period for an employee, if any */
  activeEmployeePeriod?: Maybe<KibigEmployeePeriod>;
  /** Retrieve a list of kibig child periods */
  childPeriods: Array<KibigChildPeriod>;
  /** Retrieve a list of kibig employee periods */
  employeePeriods: Array<KibigEmployeePeriod>;
  /** A report detailing key numbers and expected funding */
  fundingReports: KibigFundingReport;
  /** Retrieve a list of kibig institution funding years */
  institutionFundingYears: Array<KibigInstitutionFundingYear>;
  /** Retrieve KiBiG base data for institutions */
  institutions: Array<KibigInstitution>;
  /** Municipalities in Bayern for use with KiBiG */
  municipalities: Array<KibigMunicipality>;
  /** Qualifications for employees to determine their KiBiG funding coverage */
  qualifications: Array<KibigQualification>;
  /** A report detailing staff KiBiG funding coverage */
  staffReports: KibigStaffReport;
  /** A link to the XML file for the given year */
  xmlDownloads: KibigXmlDownload;
};


/** Objects related to Kibig funding */
export type KibigactiveEmployeePeriodArgs = {
  employeeId: Scalars['EmployeeId'];
};


/** Objects related to Kibig funding */
export type KibigchildPeriodsArgs = {
  childIds?: InputMaybe<Array<Scalars['ChildId']>>;
  childPeriodIds?: InputMaybe<Array<Scalars['KibigChildPeriodId']>>;
};


/** Objects related to Kibig funding */
export type KibigemployeePeriodsArgs = {
  employeeIds?: InputMaybe<Array<Scalars['EmployeeId']>>;
  employeePeriodIds?: InputMaybe<Array<Scalars['KibigEmployeePeriodId']>>;
};


/** Objects related to Kibig funding */
export type KibigfundingReportsArgs = {
  institutionId: Scalars['InstitutionId'];
  year: Scalars['Int'];
};


/** Objects related to Kibig funding */
export type KibiginstitutionFundingYearsArgs = {
  fundingIds?: InputMaybe<Array<Scalars['KibigFundingId']>>;
  institutionIds?: InputMaybe<Array<Scalars['InstitutionId']>>;
};


/** Objects related to Kibig funding */
export type KibiginstitutionsArgs = {
  institutionIds: Array<Scalars['InstitutionId']>;
};


/** Objects related to Kibig funding */
export type KibigmunicipalitiesArgs = {
  municipalityIds?: InputMaybe<Array<Scalars['KibigMunicipalityId']>>;
};


/** Objects related to Kibig funding */
export type KibigqualificationsArgs = {
  qualificationIds?: InputMaybe<Array<Scalars['KibigQualificationId']>>;
};


/** Objects related to Kibig funding */
export type KibigstaffReportsArgs = {
  institutionId: Scalars['InstitutionId'];
  year: Scalars['Int'];
};


/** Objects related to Kibig funding */
export type KibigxmlDownloadsArgs = {
  institutionId: Scalars['InstitutionId'];
  year: Scalars['Int'];
};

/** The age group the child belongs to for funding purposes */
export enum KibigAgeGroup {
  /** Children from age three who are not in school */
  REGULAR_CHILD = 'REGULAR_CHILD',
  /** Children enrolled for school */
  SCHOOL_CHILD = 'SCHOOL_CHILD',
  /** Children aged up to 3 years */
  UNDER_THREE = 'UNDER_THREE'
}

/** Details about a child, related kibig data and funding */
export type KibigChildFundingDetails = {
  child: Child;
  period?: Maybe<KibigChildPeriod>;
  totals: KibigFundingTotals;
};

export type KibigChildPeriod = {
  __typename?: 'KibigChildPeriod';
  ageGroup: KibigAgeGroup;
  childId: Scalars['ChildId'];
  comment?: Maybe<Scalars['String']>;
  createdAt: Scalars['ZonedDateTime'];
  createdBy: Scalars['LoginId'];
  deletedAt?: Maybe<Scalars['ZonedDateTime']>;
  deletedBy?: Maybe<Scalars['LoginId']>;
  fundable: Scalars['Boolean'];
  hasDisability: Scalars['Boolean'];
  hasNoGermanSpeakingParents: Scalars['Boolean'];
  id: Scalars['KibigChildPeriodId'];
  institutionId: Scalars['InstitutionId'];
  kibigChildId?: Maybe<Scalars['String']>;
  municipality: KibigMunicipality;
  precourse: Scalars['Boolean'];
  preschool: Scalars['Boolean'];
  validFrom: Scalars['LocalDate'];
};

/** Stats about children for a given month */
export type KibigChildStats = {
  __typename?: 'KibigChildStats';
  count: Scalars['Int'];
  countWithDisability: Scalars['Int'];
  pctOverThreeHours: Scalars['Int'];
  preschoolChildCount: Scalars['Int'];
  totalHours: Scalars['BigDecimal'];
  totalWeightedHours: Scalars['BigDecimal'];
};

export type KibigEmployeeDays = {
  __typename?: 'KibigEmployeeDays';
  absent: Scalars['Boolean'];
  days: TimeRangeClosed;
  leaveType?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
};

export type KibigEmployeeMonth = {
  __typename?: 'KibigEmployeeMonth';
  funded: Scalars['Boolean'];
  hint?: Maybe<Scalars['String']>;
  hoursWeekly: Scalars['BigDecimal'];
  isQualified: Scalars['Boolean'];
  month: Scalars['Int'];
  period?: Maybe<KibigEmployeePeriod>;
};

export type KibigEmployeePeriod = {
  __typename?: 'KibigEmployeePeriod';
  comment?: Maybe<Scalars['String']>;
  createdAt: Scalars['ZonedDateTime'];
  createdBy: Scalars['LoginId'];
  deletedAt?: Maybe<Scalars['ZonedDateTime']>;
  deletedBy?: Maybe<Scalars['LoginId']>;
  employeeId: Scalars['EmployeeId'];
  hoursWeekly: Scalars['BigDecimal'];
  id: Scalars['KibigEmployeePeriodId'];
  institutionId: Scalars['InstitutionId'];
  kibigEmployeeId?: Maybe<Scalars['String']>;
  planningEnd: KibigPlanEnd;
  planningStart: KibigPlanStart;
  qualification: KibigQualification;
  validFrom: Scalars['LocalDate'];
};

export type KibigEmployeeYear = {
  __typename?: 'KibigEmployeeYear';
  actuals: Array<KibigEmployeeDays>;
  employee: Employee;
  fundingMonths: Array<KibigEmployeeMonth>;
};

/** Indicates whether the associated value should be flagged */
export enum KibigFlag {
  ERROR = 'ERROR',
  OK = 'OK',
  WARNING = 'WARNING'
}

/** Details about children, staff and funding granted for a given month */
export type KibigFundingMonth = {
  __typename?: 'KibigFundingMonth';
  childDetails: Array<LongTermChildFundingDetails>;
  children: KibigChildStats;
  month: Scalars['Int'];
  staff: KibigStaffStats;
  totals: KibigFundingTotals;
};

/** A detailed report for funding throughout the given year */
export type KibigFundingReport = {
  __typename?: 'KibigFundingReport';
  institutionId: Scalars['InstitutionId'];
  /** @deprecated Does not include the reason why the child is missing from the report. Use missingChildrenDetailed instead. */
  missingChildren: Array<Child>;
  missingChildrenDetailed: Array<KibigMissingChild>;
  months: Array<KibigFundingMonth>;
  shortTerm?: Maybe<KibigShortTermFunding>;
  warnings: Array<KibigWarning>;
  year: Scalars['Int'];
};

/** The total funding granted for a given month */
export type KibigFundingTotals = {
  __typename?: 'KibigFundingTotals';
  basicFunding: Scalars['BigDecimal'];
  bonusFunding: Scalars['BigDecimal'];
  precourseFunding: Scalars['BigDecimal'];
  preschoolFunding: Scalars['BigDecimal'];
  totalFunding: Scalars['BigDecimal'];
  underThreeFunding: Scalars['BigDecimal'];
};

export type KibigInstitution = {
  __typename?: 'KibigInstitution';
  institutionId: Scalars['InstitutionId'];
  kibigInstitutionId: Scalars['String'];
};

export type KibigInstitutionFundingYear = {
  __typename?: 'KibigInstitutionFundingYear';
  baseValue: Scalars['BigDecimal'];
  bonus: Scalars['BigDecimal'];
  expansionFactor: Scalars['BigDecimal'];
  id: Scalars['KibigFundingId'];
  institutionId: Scalars['InstitutionId'];
  year: Scalars['Int'];
};

export type KibigInstitutionMutations = {
  __typename?: 'KibigInstitutionMutations';
  /** Set the KiBiG ID for an institution */
  setInstitutionKibigId: KibigInstitution;
};


export type KibigInstitutionMutationssetInstitutionKibigIdArgs = {
  institutionId: Scalars['InstitutionId'];
  kibigId: Scalars['String'];
};

/** A child that has no kibig data along with a hint to whether they could potentially receive funding */
export type KibigMissingChild = {
  __typename?: 'KibigMissingChild';
  child: Child;
  hint: KibigMissingChildHint;
};

/** The reason why a child has been marked as having missing KiBiG data. */
export enum KibigMissingChildHint {
  HasLongTermBookings = 'HasLongTermBookings',
  HasNoBookings = 'HasNoBookings',
  HasShortTermBookings = 'HasShortTermBookings'
}

export type KibigMunicipality = {
  __typename?: 'KibigMunicipality';
  id: Scalars['KibigMunicipalityId'];
  identifier: Scalars['Int'];
  name: Scalars['String'];
};

/** Objects related to mutating Kibig funding */
export type KibigMutation = {
  __typename?: 'KibigMutation';
  childPeriods: ChildPeriodMutations;
  employeePeriods: EmployeePeriodMutations;
  institutionFundingYears: InstitutionFundingYearMutations;
  institutions: KibigInstitutionMutations;
};

/** Determines the funding coverage of an employee when they quit */
export enum KibigPlanEnd {
  /** Employee coverage ends on the month of the end date (N) */
  END_MONTH = 'END_MONTH',
  /** Employee coverage ends based on the 42-day rule (~2 months) */
  FORTY_TWO_DAY_RULE = 'FORTY_TWO_DAY_RULE',
  /** Employee coverage ends the month after the end date (N+1) */
  ONE_MONTH_EXTRA = 'ONE_MONTH_EXTRA',
  /** Employee coverage ends the month prior to end date (N-1) */
  PREVIOUS_MONTH = 'PREVIOUS_MONTH'
}

/** Determines the funding coverage of an employee when they start */
export enum KibigPlanStart {
  /** Employee coverage is valid for month if they have over 50% working days (following a 42-day rule absence) */
  HALF_DAYS = 'HALF_DAYS',
  /** Employee coverage starts two months following their start date (N+2) */
  MONTH_AFTER_NEXT = 'MONTH_AFTER_NEXT',
  /** Employee coverage starts the month following their start date (N+1) */
  NEXT_MONTH = 'NEXT_MONTH',
  /** Employee coverage starts at the month of their start date (N) */
  START_MONTH = 'START_MONTH'
}

export type KibigQualification = {
  __typename?: 'KibigQualification';
  id: Scalars['KibigQualificationId'];
  name: Scalars['String'];
  qualificationLevel: KibigQualificationLevel;
};

/** The qualification level of a specific type of staff */
export enum KibigQualificationLevel {
  /** Experience and education in a specific core area */
  AREA_SPECIALIST = 'AREA_SPECIALIST',
  /** A person who contributes through experiences in the educational field */
  HELPER = 'HELPER',
  /** Staff outside above categories */
  OTHER = 'OTHER',
  /** Highly educated specialists (state-approved) */
  SPECIALIST = 'SPECIALIST',
  /** Supporting caretaker (min 2 years of education) */
  SUPPORT = 'SUPPORT'
}

/** Details about the short term funding for all children for the given year */
export type KibigShortTermFunding = {
  __typename?: 'KibigShortTermFunding';
  childCount: Scalars['Int'];
  childDetails: Array<ShortTermChildFundingDetails>;
  monthsOfFunding: Scalars['Int'];
  totals: KibigFundingTotals;
};

export type KibigStaffReport = {
  __typename?: 'KibigStaffReport';
  employees: Array<KibigEmployeeYear>;
  institution: Site;
  /** @deprecated Use `missingEmployees` */
  missingData: Array<Employee>;
  missingEmployees: Array<Employee>;
  year: Scalars['Int'];
};

/** Stats about staff for a given month */
export type KibigStaffStats = {
  __typename?: 'KibigStaffStats';
  count: Scalars['Int'];
  qualifiedRatio: Scalars['BigDecimal'];
  qualifiedRatioFlag: KibigFlag;
  ratio: Scalars['BigDecimal'];
  ratioFlag: KibigFlag;
  totalHours: Scalars['BigDecimal'];
  totalQualifiedHours: Scalars['BigDecimal'];
};

/** Warning about missing or invalid data */
export type KibigWarning = {
  __typename?: 'KibigWarning';
  code: Scalars['Int'];
  message: Scalars['String'];
};

export type KibigXmlDownload = {
  __typename?: 'KibigXmlDownload';
  institutionId: Scalars['InstitutionId'];
  url: Scalars['String'];
  year: Scalars['Int'];
};

/** returns the attencandeList as it will be sent out to kinder connect api */
export type KinderAttendanceRecordType = {
  __typename?: 'KinderAttendanceRecordType';
  attendanceDate: Scalars['String'];
  attendanceType: Scalars['String'];
  childID: Scalars['Int'];
  modifyCount: Scalars['Int'];
  note: Scalars['String'];
  timeIn?: Maybe<Scalars['LocalTime']>;
  timeOut?: Maybe<Scalars['LocalTime']>;
  userName?: Maybe<Scalars['String']>;
  userType?: Maybe<Scalars['String']>;
};

export type KinderConnectAttendanceData = {
  __typename?: 'KinderConnectAttendanceData';
  absent: Scalars['Int'];
  attended: Scalars['Int'];
  holiday: Scalars['Int'];
  other: Scalars['Int'];
  sick: Scalars['Int'];
  total: Scalars['Int'];
};

/** KinderConnectChild */
export type KinderConnectChild = {
  __typename?: 'KinderConnectChild';
  attendance?: Maybe<KinderConnectAttendanceData>;
  famlyChild?: Maybe<Child>;
  kinderConnect: KinderConnectIdData;
};

/** returns a list of children along with their attendance */
export type KinderConnectChildWithAttendanceType = {
  __typename?: 'KinderConnectChildWithAttendanceType';
  attendance?: Maybe<KinderConnectAttendanceData>;
  child: Child;
};

/** returns a list of kinder connect children and unlinked children from famly */
export type KinderConnectChildrenAggregateType = {
  __typename?: 'KinderConnectChildrenAggregateType';
  kcChildren: Array<KinderConnectChild>;
  unlinkedFamlyChildren: Array<Child>;
};

/** returns a list of kinder connect children and unlinked children from famly */
export type KinderConnectChildrenWithAttendanceInfoType = {
  __typename?: 'KinderConnectChildrenWithAttendanceInfoType';
  childrenWithAttendance: Array<KinderConnectChildWithAttendanceType>;
};

export type KinderConnectExportLogType = {
  __typename?: 'KinderConnectExportLogType';
  childrenCount: Scalars['Int'];
  createdAt: Scalars['ZonedDateTime'];
  /** Deprecated! Use createdByV2 */
  createdBy: Scalars['LoginId'];
  createdByV2?: Maybe<Person>;
  range: TimeRangeClosed;
  siteSetId: Scalars['SiteSetId'];
};

/** returns a list all the exports that this institution had in the last 12 months */
export type KinderConnectExportLogsType = {
  __typename?: 'KinderConnectExportLogsType';
  logs: Array<KinderConnectExportLogType>;
};

export type KinderConnectFeatureSettingsFlags = {
  __typename?: 'KinderConnectFeatureSettingsFlags';
  /** Returns true if KinderConnect is enabled for this siteSet. */
  enabled: Scalars['Boolean'];
};

/** Ids of child from kinder connect */
export type KinderConnectIdData = {
  __typename?: 'KinderConnectIdData';
  /** ChildId in KinderConnect */
  birthday?: Maybe<Scalars['LocalDate']>;
  /** ChildId in KinderConnect */
  childIdExtern: Scalars['String'];
  /** name of the child in kinder connect */
  name: Scalars['String'];
};

/** Mutations for the KinderConnect integration */
export type KinderConnectMutations = {
  __typename?: 'KinderConnectMutations';
  /** exports the attendance information to kinder connect for children of this period */
  export: ExportToKinderConnectResultType;
  /** link a kc child with a famly child */
  kinderConnectLink: KinderConnectToFamlyChildMapType;
  /** unlink a kc child with a famly child */
  kinderConnectUnlink: KinderConnectToFamlyChildMapType;
};


/** Mutations for the KinderConnect integration */
export type KinderConnectMutationsexportArgs = {
  range: ClosedLocalDateRange;
  siteSetId: Scalars['SiteSetId'];
};


/** Mutations for the KinderConnect integration */
export type KinderConnectMutationskinderConnectLinkArgs = {
  famlyChildId?: InputMaybe<Scalars['ChildId']>;
  kcChildId: Scalars['String'];
  siteSetId: Scalars['SiteSetId'];
};


/** Mutations for the KinderConnect integration */
export type KinderConnectMutationskinderConnectUnlinkArgs = {
  famlyChildId: Scalars['ChildId'];
  siteSetId: Scalars['SiteSetId'];
};

/** KinderConnect related queries */
export type KinderConnectQueries = {
  __typename?: 'KinderConnectQueries';
  children: KinderConnectChildrenAggregateType;
  exportLogs: KinderConnectExportLogsType;
  kinderConnectChildrenWithAttendanceInfo: KinderConnectChildrenWithAttendanceInfoType;
};


/** KinderConnect related queries */
export type KinderConnectQuerieschildrenArgs = {
  range: ClosedLocalDateRange;
  siteSetId: Scalars['SiteSetId'];
};


/** KinderConnect related queries */
export type KinderConnectQueriesexportLogsArgs = {
  siteSetId: Scalars['SiteSetId'];
};


/** KinderConnect related queries */
export type KinderConnectQuerieskinderConnectChildrenWithAttendanceInfoArgs = {
  range: ClosedLocalDateRange;
  siteSetId: Scalars['SiteSetId'];
};

/** returns a list of kinder connect children and unlinked children from famly */
export type KinderConnectToFamlyChildMapType = {
  __typename?: 'KinderConnectToFamlyChildMapType';
  famlyChild?: Maybe<Child>;
  kcChild: Scalars['String'];
};

export type KinderConnectUploadResponse = {
  __typename?: 'KinderConnectUploadResponse';
  requestStatusID: Scalars['Int'];
  requestStatusText: Scalars['String'];
};

/** Child data from Kita-Planer */
export type KitaPlanerChild = {
  __typename?: 'KitaPlanerChild';
  birthDate: Scalars['String'];
  firstName: Scalars['String'];
  gender: Scalars['String'];
  lastName: Scalars['String'];
};

/** Export child data from Kita-Planer */
export type KitaPlanerExport = {
  __typename?: 'KitaPlanerExport';
  /** Export child data from Kita-Planer */
  export: ExportDataOutput;
  /** Connection information for exporting from Kita-Planer */
  isConnected: ConnectionResult;
};


/** Export child data from Kita-Planer */
export type KitaPlanerExportexportArgs = {
  dateRange?: InputMaybe<DateRangeInput>;
  institutionId: Scalars['InstitutionId'];
};


/** Export child data from Kita-Planer */
export type KitaPlanerExportisConnectedArgs = {
  institutionId: Scalars['InstitutionId'];
};

/** Ids necessary to link children in Famly to Kita-Planer IDs */
export type KitaPlanerIdData = {
  __typename?: 'KitaPlanerIdData';
  /** ChildId in Kita-Planer */
  childIdExtern: Scalars['String'];
  /** The HMAC required to prove the correctness of the IDs */
  hmac: Scalars['HMAC'];
  /** InstitutionId in Kita-Planer */
  institutionIdExtern: Scalars['String'];
};

/** Managing the Kita-Planer account */
export type KitaPlanerMutation = {
  __typename?: 'KitaPlanerMutation';
  /** Delete all active credentials that are linked to Kita-Planer */
  deleteCredentials: DeletionResult;
  /** Dismiss foreign child IDs from the import from Kita-Planer */
  dismiss: DismissedData;
  /** Set the credentials to export from Kita-Planer */
  setCredentials: CredentialsResult;
};


/** Managing the Kita-Planer account */
export type KitaPlanerMutationdeleteCredentialsArgs = {
  institutionId: Scalars['InstitutionId'];
};


/** Managing the Kita-Planer account */
export type KitaPlanerMutationdismissArgs = {
  dismissedIds: Array<Scalars['String']>;
  institutionId: Scalars['InstitutionId'];
};


/** Managing the Kita-Planer account */
export type KitaPlanerMutationsetCredentialsArgs = {
  certificatePassword: Scalars['String'];
  fileId: Scalars['FileId'];
  institutionId: Scalars['InstitutionId'];
  kitaIdExtern: Scalars['String'];
  user: Scalars['String'];
  userPassword: Scalars['String'];
};

/** Parent data for a child from Kita-Planer */
export type KitaPlanerParent = {
  __typename?: 'KitaPlanerParent';
  address?: Maybe<Address>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phone1: Scalars['String'];
  phone2: Scalars['String'];
};

/** Data returned when creating a company in Kitabuli */
export type KitabuliCreateCompanyResponse = {
  __typename?: 'KitabuliCreateCompanyResponse';
  status: Status;
};

/** Mutations for the Kitabuli integration */
export type KitabuliMutations = {
  __typename?: 'KitabuliMutations';
  /** Create a company, sites and a user in Kitabuli */
  createCompany: KitabuliCreateCompanyResponse;
  /** Create webhook for forwarding events to kitabuli */
  createCompanyWebhook: WebhookEndpoint;
};


/** Mutations for the Kitabuli integration */
export type KitabuliMutationscreateCompanyArgs = {
  siteSetId: Scalars['SiteSetId'];
};


/** Mutations for the Kitabuli integration */
export type KitabuliMutationscreateCompanyWebhookArgs = {
  siteSetId: Scalars['SiteSetId'];
};

/** Queries for the Kitabuli integration */
export type KitabuliQueries = {
  __typename?: 'KitabuliQueries';
  /** Connection status between the site set and Kitabuli */
  currentStatus: KitabuliCreateCompanyResponse;
  /** Request a URL which will enable the user to access Kitabuli on redirect. */
  redirectURL: KitabuliRedirectURLResponse;
};


/** Queries for the Kitabuli integration */
export type KitabuliQueriescurrentStatusArgs = {
  siteSetId: Scalars['SiteSetId'];
};


/** Queries for the Kitabuli integration */
export type KitabuliQueriesredirectURLArgs = {
  childId?: InputMaybe<Scalars['ChildId']>;
  siteId: Scalars['SiteId'];
};

/** Data for redirecting a user to Kitabuli */
export type KitabuliRedirectURLResponse = {
  __typename?: 'KitabuliRedirectURLResponse';
  url?: Maybe<Scalars['String']>;
};

export type LandingPageAssets = {
  __typename?: 'LandingPageAssets';
  demoVideo: DemoVideo;
  promiseSection: PromiseSection;
  testimonial?: Maybe<LandingPageTestimonial>;
};

export type LandingPageTestimonial = {
  __typename?: 'LandingPageTestimonial';
  name: Scalars['String'];
  numberOfStars: Scalars['Int'];
  quote: Scalars['String'];
  role: Scalars['String'];
  video?: Maybe<TestimonialVideo>;
};

export type LearnMore = {
  __typename?: 'LearnMore';
  /** The id of the help article that should be shown when the user clicks 'Learn more' */
  helpArticle?: Maybe<Scalars['Int']>;
  /** The video that should be shown when the user clicks 'Learn more' */
  video?: Maybe<Scalars['Int']>;
};

export enum LearningFramework {
  CoEL = 'CoEL',
  EYFS = 'EYFS'
}

export enum LearningFrameworkForScotland {
  BtA = 'BtA',
  CfE = 'CfE',
  CfE_Outcomes = 'CfE_Outcomes',
  GIRFEC = 'GIRFEC',
  PTT = 'PTT',
  RtA = 'RtA',
  RtA_Old = 'RtA_Old',
  SEND = 'SEND'
}

export enum LearningFrameworkForWales {
  DevelopmentalPathways = 'DevelopmentalPathways'
}

export type LeaveFeatureSettingsFlags = {
  __typename?: 'LeaveFeatureSettingsFlags';
  /** Returns true if this feature can be enabled by a user. */
  canOptIn: Scalars['Boolean'];
  /** Returns true if this feature is currently enabled. */
  isEnabled: Scalars['Boolean'];
};

export type LeaveManagementFlagsBasicType = {
  __typename?: 'LeaveManagementFlagsBasicType';
  canEdit: Scalars['Boolean'];
  canView: Scalars['Boolean'];
};

export type LeaveManagementFlagsSiteSetType = {
  __typename?: 'LeaveManagementFlagsSiteSetType';
  canEdit: Scalars['Boolean'];
  canView: Scalars['Boolean'];
};

export type LeaveManagementNotesType = {
  __typename?: 'LeaveManagementNotesType';
  /** Returns true if current user can create a management note. */
  canCreate: Scalars['Boolean'];
  /** Returns true if current user can delete management notes. */
  canDelete: Scalars['Boolean'];
  /** Returns true if current user can edit management notes */
  canEdit: Scalars['Boolean'];
  /** Returns true if current user can view a management note. */
  canView: Scalars['Boolean'];
};

/** Query leave management for specific type of leave */
export type LeaveManagementQuery = {
  __typename?: 'LeaveManagementQuery';
  absence: LeaveManagementType;
  /**
   * Basic Leave management flags return if the calling user has permission to view and edit on site set level.
   * If an employeeId is passed, the query will resolve if the calling user is allowed to view that specific employee's data.
   */
  basic: LeaveManagementFlagsBasicType;
  childSick: LeaveManagementType;
  holiday: LeaveManagementType;
  sick: LeaveManagementType;
  /** Returns true if the calling user has site set level management rights to view and edit employee leave. */
  siteSet: LeaveManagementFlagsSiteSetType;
};


/** Query leave management for specific type of leave */
export type LeaveManagementQueryabsenceArgs = {
  employeeId: Scalars['EmployeeId'];
  siteSetId: Scalars['InstitutionSetId'];
};


/** Query leave management for specific type of leave */
export type LeaveManagementQuerybasicArgs = {
  employeeId?: InputMaybe<Scalars['EmployeeId']>;
  siteSetId: Scalars['SiteSetId'];
};


/** Query leave management for specific type of leave */
export type LeaveManagementQuerychildSickArgs = {
  employeeId: Scalars['EmployeeId'];
  siteSetId: Scalars['InstitutionSetId'];
};


/** Query leave management for specific type of leave */
export type LeaveManagementQueryholidayArgs = {
  employeeId: Scalars['EmployeeId'];
  siteSetId: Scalars['InstitutionSetId'];
};


/** Query leave management for specific type of leave */
export type LeaveManagementQuerysickArgs = {
  employeeId: Scalars['EmployeeId'];
  siteSetId: Scalars['InstitutionSetId'];
};


/** Query leave management for specific type of leave */
export type LeaveManagementQuerysiteSetArgs = {
  siteSetId: Scalars['InstitutionSetId'];
};

export type LeaveManagementType = {
  __typename?: 'LeaveManagementType';
  /** Returns true if current user can create leaves of this type. */
  canCreate: Scalars['Boolean'];
  /** Returns true if current user can delete leaves of this type. */
  canDelete: Scalars['Boolean'];
  /** Returns true if current user can edit leaves of this type. */
  canEdit: Scalars['Boolean'];
  /** Returns true if current user can append (or change) the sub type of leaves of this type. */
  canEditSubtype: Scalars['Boolean'];
  /** Returns true if current user can view leaves of this type. */
  canView: Scalars['Boolean'];
  /** Returns management notes flags. */
  managementNotes: LeaveManagementNotesType;
};

export type LeaveMinutesType = {
  __typename?: 'LeaveMinutesType';
  absent: Scalars['Int'];
  childSick: Scalars['Int'];
  holiday: Scalars['Int'];
  paid: Scalars['Int'];
  sick: Scalars['Int'];
};

export type LeaveRangeFeatureSettingsFlags = {
  __typename?: 'LeaveRangeFeatureSettingsFlags';
  /** Returns if this feature is currently enabled. */
  enabled: Scalars['Boolean'];
};

export type LeaveRequestFeatureSettingsFlags = {
  __typename?: 'LeaveRequestFeatureSettingsFlags';
  /** Returns true if it is allowed to customize leave types that require approval. */
  canCustomizeLeaveTypesThatRequireApproval: Scalars['Boolean'];
  /** Returns true if this feature can be enabled. */
  canOptIn: Scalars['Boolean'];
  /** Returns true if this feature is currently enabled. */
  enabled: Scalars['Boolean'];
};

/** Query leave request management for specific type of leave request */
export type LeaveRequestManagementQuery = {
  __typename?: 'LeaveRequestManagementQuery';
  absence: LeaveRequestManagementType;
  childSick: LeaveRequestManagementType;
  holiday: LeaveRequestManagementType;
  sick: LeaveRequestManagementType;
};


/** Query leave request management for specific type of leave request */
export type LeaveRequestManagementQueryabsenceArgs = {
  employeeId: Scalars['EmployeeId'];
  siteSetId: Scalars['InstitutionSetId'];
};


/** Query leave request management for specific type of leave request */
export type LeaveRequestManagementQuerychildSickArgs = {
  employeeId: Scalars['EmployeeId'];
  siteSetId: Scalars['InstitutionSetId'];
};


/** Query leave request management for specific type of leave request */
export type LeaveRequestManagementQueryholidayArgs = {
  employeeId: Scalars['EmployeeId'];
  siteSetId: Scalars['InstitutionSetId'];
};


/** Query leave request management for specific type of leave request */
export type LeaveRequestManagementQuerysickArgs = {
  employeeId: Scalars['EmployeeId'];
  siteSetId: Scalars['InstitutionSetId'];
};

export type LeaveRequestManagementType = {
  __typename?: 'LeaveRequestManagementType';
  /** Returns true if current user can approve leave requests of this type. */
  canApprove: Scalars['Boolean'];
  /** Returns true if current user can request leaves of this type. (Only users who cannot approve leaves can request leaves.) */
  canCreate: Scalars['Boolean'];
  /** Returns true if current user can reject (and thereby delete) leave requests of this type. */
  canDelete: Scalars['Boolean'];
  /** Returns true if current user can edit leave requests of this type. */
  canEdit: Scalars['Boolean'];
  /** Returns true if current user can append (or change) the subtype of leave requests of this type. */
  canEditSubtype: Scalars['Boolean'];
  /** Returns true if current user can view leave requests of this type. */
  canView: Scalars['Boolean'];
  /** Returns management notes flags. */
  managementNotes: LeaveManagementNotesType;
};

export type LeaveRequestType = {
  __typename?: 'LeaveRequestType';
  approvalStatus: StaffLeaveRequestApprovalStatus;
  dateRange: TimeRangeClosed;
  endTime?: Maybe<Scalars['LocalTime']>;
  leaveSubTypeId?: Maybe<Scalars['StaffLeaveSubTypeId']>;
  leaveType?: Maybe<StaffLeaveType>;
  leaves: Array<StaffMemberLeaves>;
  managementNote?: Maybe<ManagementNote>;
  note?: Maybe<Scalars['String']>;
  staffLeaveRequestId: Scalars['StaffLeaveRequestId'];
  startTime?: Maybe<Scalars['LocalTime']>;
  totalHours?: Maybe<Scalars['Float']>;
  totalMinutes?: Maybe<Scalars['Int']>;
};

export enum LeaveType {
  ABSENT = 'ABSENT',
  SICK = 'SICK',
  VACATION = 'VACATION'
}

/** Create, delete or update staff member leaves */
export type LeavesMutation = {
  __typename?: 'LeavesMutation';
  /** @deprecated Deprecated in App Version 163. Use createRangeV2 instead. */
  createRange: StaffMemberRecords;
  createRangeV2?: Maybe<StaffHoursAttendanceByStaffTypeV2>;
  deleteLeaves: StaffMemberRecords;
  staffLeaveRequest: StaffLeaveRequestMutation;
  subtypes: StaffLeaveSubTypeMutations;
};


/** Create, delete or update staff member leaves */
export type LeavesMutationcreateRangeArgs = {
  displayRange: ClosedLocalDateRange;
  leaveInput: EmployeeLeaveRangeInput;
};


/** Create, delete or update staff member leaves */
export type LeavesMutationcreateRangeV2Args = {
  displayRange: ClosedLocalDateRange;
  leaveInput: EmployeeLeaveRangeInput;
};


/** Create, delete or update staff member leaves */
export type LeavesMutationdeleteLeavesArgs = {
  displayRange: ClosedLocalDateRange;
  employeeLeaveIds: Array<Scalars['EmployeeLeaveId']>;
};

/** Query staff member leaves */
export type LeavesQuery = {
  __typename?: 'LeavesQuery';
  /** Returns the URL to fetch the Staff Leave CSV. */
  csvExportURL: Scalars['String'];
  subtypes: StaffLeaveSubTypesQueries;
};


/** Query staff member leaves */
export type LeavesQuerycsvExportURLArgs = {
  from?: InputMaybe<Scalars['LocalDate']>;
  siteId: Scalars['SiteId'];
  to?: InputMaybe<Scalars['LocalDate']>;
};

export type LessonPlan = {
  __typename?: 'LessonPlan';
  appliesToGroups: Array<Group>;
  appliesToTags: Array<Tag>;
  behaviors: Array<Behavior>;
  description?: Maybe<Scalars['String']>;
  endDate: Scalars['LocalDate'];
  id: Scalars['LessonPlanId'];
  published: Scalars['Boolean'];
  sections: Array<LessonPlanSection>;
  startDate: Scalars['LocalDate'];
};

export type LessonPlanActivity = LessonPlanItem & {
  __typename?: 'LessonPlanActivity';
  /** @deprecated Activities can be deleted, in which case this field will fail. Use 'maybeActivity' instead. */
  activity: Activity;
  date: Scalars['LocalDate'];
  id: Scalars['LessonPlanItemId'];
  maybeActivity?: Maybe<Activity>;
  order: Scalars['Int'];
};

export type LessonPlanCreationResult = {
  __typename?: 'LessonPlanCreationResult';
  lessonPlans: Array<LessonPlan>;
};

export type LessonPlanInput = {
  dateRange: ClosedLocalDateRange;
  description?: InputMaybe<Scalars['String']>;
  groupId: Scalars['GroupId'];
  sections: Array<LessonPlanSectionInput>;
};

export type LessonPlanItem = {
  date: Scalars['LocalDate'];
  id: Scalars['LessonPlanItemId'];
  order: Scalars['Int'];
};

export type LessonPlanItemInput = {
  activity?: InputMaybe<Scalars['ActivityId']>;
  date: Scalars['LocalDate'];
  note?: InputMaybe<Scalars['String']>;
  order: Scalars['Int'];
  /** The id of the section the item is in, takes precedence over 'sectionName'. */
  sectionId?: InputMaybe<Scalars['LessonPlanSectionId']>;
  /** The section the item is in by its name */
  sectionName?: InputMaybe<Scalars['String']>;
};

export type LessonPlanItemUpdate = {
  /** Either this or 'note' must be given. */
  activityId?: InputMaybe<Scalars['ActivityId']>;
  date: Scalars['LocalDate'];
  id: Scalars['LessonPlanItemId'];
  /** Either this or 'activityId' must be given. */
  note?: InputMaybe<Scalars['String']>;
  order: Scalars['Int'];
  /** The section the item is in by id, takes precedence over 'sectionName'. */
  sectionId?: InputMaybe<Scalars['LessonPlanSectionId']>;
  /** The section the item is in by its name */
  sectionName?: InputMaybe<Scalars['String']>;
};

export type LessonPlanNote = LessonPlanItem & {
  __typename?: 'LessonPlanNote';
  date: Scalars['LocalDate'];
  id: Scalars['LessonPlanItemId'];
  note: Scalars['String'];
  order: Scalars['Int'];
};

export type LessonPlanSection = {
  __typename?: 'LessonPlanSection';
  hiddenFromParents: Scalars['Boolean'];
  id: Scalars['LessonPlanSectionId'];
  items: Array<LessonPlanItem>;
  name: Scalars['String'];
  /** The 0-indexed order of the section in the plan */
  order: Scalars['Int'];
};

export type LessonPlanSectionInput = {
  hiddenFromParents: Scalars['Boolean'];
  items: Array<LessonPlanItemInput>;
  /** Must be non-empty */
  name: Scalars['String'];
  order: Scalars['Int'];
};

export type LessonPlanSectionUpdate = {
  hiddenFromParents: Scalars['Boolean'];
  id: Scalars['LessonPlanSectionId'];
  name: Scalars['String'];
  order: Scalars['Int'];
};

/** The different states that a LessonPlan can be in */
export enum LessonPlanState {
  DRAFT = 'DRAFT',
  PUBLISHED = 'PUBLISHED'
}

export type LessonPlanStateUpdate = {
  newState: LessonPlanState;
  notifyParents: Scalars['Boolean'];
};

export type LessonPlanUpdateDescription = {
  description?: InputMaybe<Scalars['String']>;
  lessonPlanId: Scalars['LessonPlanId'];
};

export type LessonPlanUpdateItemUpdates = {
  itemUpdates: Array<LessonPlanItemUpdate>;
  lessonPlanId: Scalars['LessonPlanId'];
};

export type LessonPlanUpdateNewItems = {
  lessonPlanId: Scalars['LessonPlanId'];
  newItems: Array<LessonPlanItemInput>;
};

export type LessonPlanUpdateNewSections = {
  lessonPlanId: Scalars['LessonPlanId'];
  newSections: Array<LessonPlanSectionInput>;
};

export type LessonPlanUpdateRemoveItems = {
  lessonPlanId: Scalars['LessonPlanId'];
  removeItems: Array<Scalars['LessonPlanItemId']>;
};

export type LessonPlanUpdateRemoveSections = {
  lessonPlanId: Scalars['LessonPlanId'];
  removeSections: Array<Scalars['LessonPlanSectionId']>;
};

export type LessonPlanUpdateResult = {
  __typename?: 'LessonPlanUpdateResult';
  lessonPlans: Array<LessonPlan>;
};

export type LessonPlanUpdateSectionUpdates = {
  lessonPlanId: Scalars['LessonPlanId'];
  sectionUpdates: Array<LessonPlanSectionUpdate>;
};

export type LessonPlanUpdateState = {
  lessonPlanId: Scalars['LessonPlanId'];
  state: LessonPlanState;
};

export type LessonPlanUpdateStateUpdate = {
  lessonPlanId: Scalars['LessonPlanId'];
  stateUpdate: LessonPlanStateUpdate;
};

/** Object holding all queries related to lesson plans */
export type LessonPlans = {
  __typename?: 'LessonPlans';
  behaviors: Array<Behavior>;
  /** Returns true if there are any lesson plans accessible to the current user for a specified site. */
  hasAny: Scalars['Boolean'];
  list: LessonPlansListResult;
};


/** Object holding all queries related to lesson plans */
export type LessonPlansbehaviorsArgs = {
  institutionId: Scalars['InstitutionId'];
};


/** Object holding all queries related to lesson plans */
export type LessonPlanshasAnyArgs = {
  siteId: Scalars['SiteId'];
};


/** Object holding all queries related to lesson plans */
export type LessonPlanslistArgs = {
  childIds?: InputMaybe<Array<Scalars['ChildId']>>;
  dateRange: ClosedLocalDateRange;
  groupIds?: InputMaybe<Array<Scalars['GroupId']>>;
};

export type LessonPlansDeleteResult = {
  __typename?: 'LessonPlansDeleteResult';
  /** The ids of the successfully deleted lesson plans */
  deletedIds: Array<Scalars['LessonPlanId']>;
};

/** The result of listing lesson plans */
export type LessonPlansListResult = {
  __typename?: 'LessonPlansListResult';
  lessonPlans: Array<LessonPlan>;
};

/** Object holding all mutations related to lesson plans */
export type LessonPlansMutationType = {
  __typename?: 'LessonPlansMutationType';
  create: LessonPlanCreationResult;
  delete: LessonPlansDeleteResult;
  update: LessonPlanUpdateResult;
};


/** Object holding all mutations related to lesson plans */
export type LessonPlansMutationTypecreateArgs = {
  lessonPlans: Array<LessonPlanInput>;
};


/** Object holding all mutations related to lesson plans */
export type LessonPlansMutationTypedeleteArgs = {
  lessonPlanIds: Array<Scalars['LessonPlanId']>;
};


/** Object holding all mutations related to lesson plans */
export type LessonPlansMutationTypeupdateArgs = {
  addItems?: InputMaybe<Array<LessonPlanUpdateNewItems>>;
  addSections?: InputMaybe<Array<LessonPlanUpdateNewSections>>;
  deleteItems?: InputMaybe<Array<LessonPlanUpdateRemoveItems>>;
  deleteSections?: InputMaybe<Array<LessonPlanUpdateRemoveSections>>;
  descriptions?: InputMaybe<Array<LessonPlanUpdateDescription>>;
  states?: InputMaybe<Array<LessonPlanUpdateState>>;
  statesWithNotifications?: InputMaybe<Array<LessonPlanUpdateStateUpdate>>;
  updateItems?: InputMaybe<Array<LessonPlanUpdateItemUpdates>>;
  updateSections?: InputMaybe<Array<LessonPlanUpdateSectionUpdates>>;
};

export type Level = QualificationAssignment & {
  __typename?: 'Level';
  certificateNumber?: Maybe<Scalars['String']>;
  employeeId: Scalars['EmployeeId'];
  expirationDate?: Maybe<Scalars['LocalDateTime']>;
  fileIds: Array<Scalars['FileId']>;
  /** The files attached to the qualification, if any */
  files: Array<File>;
  id: Scalars['StaffQualificationAssignmentId'];
  imageIds: Array<Scalars['ImageId']>;
  /** The images attached to the qualification, if any */
  images: Array<Image>;
  institutionId: Scalars['InstitutionId'];
  level: Scalars['Int'];
  note?: Maybe<Scalars['String']>;
  qualification: Qualification;
  qualificationDate: Scalars['LocalDateTime'];
  qualificationId: Scalars['StaffQualificationId'];
  title?: Maybe<Scalars['String']>;
};

export type LibraryMembershipInput = {
  canEdit: Scalars['Boolean'];
  institutionSetId: Scalars['InstitutionSetId'];
};

/** Represents a like by a user */
export type Like = {
  __typename?: 'Like';
  /** When this was liked */
  likedAt: Scalars['ZonedDateTime'];
  /** Who liked this */
  likedBy: Person;
};

/** A collection of likes */
export type Likes = {
  __typename?: 'Likes';
  /** How many likes has this thing gotten? */
  count: Scalars['Int'];
  /** Has the current user liked this? */
  likedByMe: Scalars['Boolean'];
  /** The actual likes */
  likes: Array<Like>;
};

/** The type of a limitation */
export enum LimitationType {
  /** There is no limitation */
  NONE = 'NONE',
  /** Limitation to be used without upsell */
  WITHOUT_UPSELL = 'WITHOUT_UPSELL',
  /** Limitation to be used with upsell */
  WITH_UPSELL = 'WITH_UPSELL'
}

/** Result of linking a facebook page */
export type LinkedFacebookPage = {
  __typename?: 'LinkedFacebookPage';
  imageUrl: Scalars['String'];
  name: Scalars['String'];
  pageId: Scalars['String'];
  tokenId: Scalars['FacebookAccessTokenId'];
  url: Scalars['String'];
};

/** Represents features that had been linked to a parental permission */
export type LinkedFeaturesWithParentalPermission = {
  __typename?: 'LinkedFeaturesWithParentalPermission';
  parentalPermissionFeatures: Array<ParentalPermissionFeature>;
};

/** Facebook pages that are connected to an InstitutionSetId */
export type LinkedPages = {
  __typename?: 'LinkedPages';
  institutionSetId: Scalars['InstitutionSetId'];
  pages: Array<LinkedFacebookPage>;
};

export type ListRoleInvitationsResult = {
  __typename?: 'ListRoleInvitationsResult';
  result: Array<RoleInvitation>;
};

export type ListRoleInvitationsResultByChild = {
  __typename?: 'ListRoleInvitationsResultByChild';
  result: Array<RoleInvitationsByChild>;
};

/** A list of permissions to render and paginated list of roles */
export type ListRolesResult = {
  __typename?: 'ListRolesResult';
  next?: Maybe<Scalars['RoleCursor']>;
  permissions: Array<PermissionTree>;
  roles: Array<Role>;
};

export type ListWidget = Widget & {
  __typename?: 'ListWidget';
  elements: Array<ListWidgetElement>;
  id: Scalars['HomeWidgetId'];
  next?: Maybe<Scalars['HomeWidgetCursor']>;
  title: Scalars['String'];
  widgetId: Scalars['String'];
};

export type ListWidgetElement = {
  __typename?: 'ListWidgetElement';
  body?: Maybe<Scalars['String']>;
  category?: Maybe<ListWidgetElementCategory>;
  date?: Maybe<Scalars['LocalDate']>;
  image?: Maybe<ProfileImage>;
  link?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['Float']>;
  time?: Maybe<Scalars['LocalTime']>;
};

export enum ListWidgetElementCategory {
  NEEDS_ATTENTION_ACCIDENTS_INCIDENTS = 'NEEDS_ATTENTION_ACCIDENTS_INCIDENTS',
  NEEDS_ATTENTION_ASSESSMENT_PENDING_REVIEW = 'NEEDS_ATTENTION_ASSESSMENT_PENDING_REVIEW',
  NEEDS_ATTENTION_LEAVE_REQUESTS = 'NEEDS_ATTENTION_LEAVE_REQUESTS',
  NEEDS_ATTENTION_MEDICATION_OVERDUE = 'NEEDS_ATTENTION_MEDICATION_OVERDUE',
  NEEDS_ATTENTION_PAYMENTS_ACCOUNT_NEEDS_VERIFICATION = 'NEEDS_ATTENTION_PAYMENTS_ACCOUNT_NEEDS_VERIFICATION',
  SHIFT_SCHEDULE_AVAILABILITY_CONFLICT = 'SHIFT_SCHEDULE_AVAILABILITY_CONFLICT',
  SHIFT_SCHEDULE_DOUBLE_BOOKING_CONFLICT = 'SHIFT_SCHEDULE_DOUBLE_BOOKING_CONFLICT',
  SHIFT_SCHEDULE_LEAVE_CONFLICT = 'SHIFT_SCHEDULE_LEAVE_CONFLICT',
  SHIFT_SCHEDULE_OPEN_SHIFTS = 'SHIFT_SCHEDULE_OPEN_SHIFTS'
}

export enum LogLevel {
  DEBUG = 'DEBUG',
  ERROR = 'ERROR',
  INFO = 'INFO',
  WARNING = 'WARNING'
}

/** A Famly user */
export type Login = {
  __typename?: 'Login';
  details: LoginDetails;
  email: Scalars['EmailAddress'];
  help: Array<HelpLink>;
  id: Scalars['LoginId'];
  locale: Scalars['Locale'];
  me: Login;
  name: Name;
};

/** A newly created login */
export type LoginCreated = {
  __typename?: 'LoginCreated';
  accessToken: Scalars['AccessToken'];
  deviceId: Scalars['DeviceId'];
  login: Login;
};

/** Additional data about a Famly user */
export type LoginDetails = {
  __typename?: 'LoginDetails';
  address?: Maybe<Address>;
  phone?: Maybe<PhoneNumberType>;
};

/** Objects related to mutating logins */
export type LoginMutation = {
  __typename?: 'LoginMutation';
  hardDelete: Array<Scalars['LoginId']>;
  removeParentAccess: Array<Scalars['InstitutionId']>;
  /** Reset when the provided users were last seen in the system */
  resetLastSeen: Array<Scalars['LoginId']>;
  /** Completely resets the login attempts for the provided users */
  resetLoginAttempts: Array<Scalars['LoginId']>;
  softDelete: Array<Scalars['LoginId']>;
};


/** Objects related to mutating logins */
export type LoginMutationhardDeleteArgs = {
  loginIds: Array<Scalars['LoginId']>;
};


/** Objects related to mutating logins */
export type LoginMutationremoveParentAccessArgs = {
  institutionIds: Array<Scalars['InstitutionId']>;
};


/** Objects related to mutating logins */
export type LoginMutationresetLastSeenArgs = {
  loginIds: Array<Scalars['LoginId']>;
};


/** Objects related to mutating logins */
export type LoginMutationresetLoginAttemptsArgs = {
  loginIds: Array<Scalars['LoginId']>;
};


/** Objects related to mutating logins */
export type LoginMutationsoftDeleteArgs = {
  loginIds: Array<Scalars['LoginId']>;
};

/** A login to the system */
export type Logins = {
  __typename?: 'Logins';
  emailLessLoginAvailable: Array<Scalars['LoginId']>;
  welcomeInformation: WelcomeInformation;
};


/** A login to the system */
export type LoginsemailLessLoginAvailableArgs = {
  loginIds: Array<Scalars['LoginId']>;
};


/** A login to the system */
export type LoginswelcomeInformationArgs = {
  email?: InputMaybe<Scalars['String']>;
  token: Scalars['Password'];
};

/** Details about the long-term funding for a specific month */
export type LongTermChildFundingDetails = KibigChildFundingDetails & {
  __typename?: 'LongTermChildFundingDetails';
  child: Child;
  dailyHours: Scalars['BigDecimal'];
  period?: Maybe<KibigChildPeriod>;
  totals: KibigFundingTotals;
};

export type LongTextFieldValue = GenericFormFieldValue & {
  __typename?: 'LongTextFieldValue';
  fieldTemplate: GenericFormFieldTemplate;
  fieldTemplateId: Scalars['GenericFormFieldTemplateId'];
  fieldType: GenericFormFieldType;
  fieldValueId: Scalars['GenericFormFieldValueId'];
  stringValue: Scalars['String'];
  valueAsString: Scalars['String'];
};

export type MagicLink = {
  __typename?: 'MagicLink';
  showMagicLinkButton: Scalars['Boolean'];
};

/** A managed feature is a feature that the user can enable/disable themselves */
export type ManagedFeature = {
  __typename?: 'ManagedFeature';
  /** True if the feature has been enabled and false otherwise */
  enabled: Scalars['Boolean'];
  /** The unique ID of the feature */
  featureId: Scalars['String'];
};

/** A managed feature is a feature that the user can enable/disable themselves */
export type ManagedFeatureData = {
  __typename?: 'ManagedFeatureData';
  /** True if the feature has been enabled and false otherwise */
  enabled: Scalars['Boolean'];
  /** The unique ID of the feature */
  featureId: Scalars['String'];
  institutionSetId: Scalars['InstitutionSetId'];
};

/** Contains mutations related to managed features */
export type ManagedFeaturesMutation = {
  __typename?: 'ManagedFeaturesMutation';
  setFeatures: Array<ManagedFeatureData>;
};


/** Contains mutations related to managed features */
export type ManagedFeaturesMutationsetFeaturesArgs = {
  features: Array<FeatureState>;
  institutionSetId: Scalars['InstitutionSetId'];
};

/** This contains information about the management note */
export type ManagementNote = {
  __typename?: 'ManagementNote';
  note: Scalars['String'];
  updatedAt: Scalars['ZonedDateTime'];
  updatedBy: Person;
};

/** Operations querying staffhours management */
export type ManagementQueries = {
  __typename?: 'ManagementQueries';
  /**
   * Attendance management `canView` and `canCreate` return true if the calling user has view
   * permissions for the site set, or if the calling user is a staff member and allowed to view it's own data.
   * @deprecated Deprecated in App Version 167. Use V2 instead.
   */
  attendance: AttendanceManagementResultType;
  /**
   * Attendance management flags return if the calling user has permissions for the site set.
   * If an employeeId is passed, the query will resolve if the calling user is allowed to access that specific employee's data.
   */
  attendanceV2: AttendanceManagementResultType;
  /**
   * Contracted hours, bank hours and work availability `canView` returns true if the calling user
   * has view permissions for the site set or if it is a staff member and allowed to view it's own
   * contract data. Viewing the change log is only possible if the user has view permission for the site set.
   *
   * @deprecated Deprecated in App Version 167. Use V2 instead.
   */
  contractedHours: ContractedHoursManagementResultType;
  /**
   * Contracted hours, bank hours and work availability management flags return if the calling user has permissions for the site set.
   * If an employeeId is passed, the query will resolve if the calling user is allowed to access that specific employee's data.
   */
  contractedHoursV2: ContractedHoursManagementResultType;
  leaveRequests: LeaveRequestManagementQuery;
  leaves: LeaveManagementQuery;
  schedules: ScheduleManagementType;
  shiftplanner: ShiftPlannerManagementType;
  staffAttendance: StaffAttendanceManagementQuery;
  subtypes: SubTypeManagementType;
  /**
   * Staff hours totals `canView` returns true
   * * If the calling user is a manager and is allowed to access all staff records, or
   * * if the calling user is a staff member and allowed to view it's own data.
   * @deprecated Deprecated in App Version 167. Use V2 instead.
   */
  totals: StaffHoursTotalsManagementType;
  /**
   * Staff hours totals flags return if the calling user has permissions for the site set.
   * If an employeeId is passed, the query will resolve if the calling user is allowed to
   * access that specific employee's data.
   */
  totalsV2: StaffHoursTotalsManagementType;
  workTags: WorkTagsManagementFlagsType;
};


/** Operations querying staffhours management */
export type ManagementQueriesattendanceArgs = {
  employeeId?: InputMaybe<Scalars['EmployeeId']>;
  siteSetId: Scalars['SiteSetId'];
};


/** Operations querying staffhours management */
export type ManagementQueriesattendanceV2Args = {
  employeeId?: InputMaybe<Scalars['EmployeeId']>;
  siteSetId: Scalars['SiteSetId'];
};


/** Operations querying staffhours management */
export type ManagementQueriescontractedHoursArgs = {
  employeeId?: InputMaybe<Scalars['EmployeeId']>;
  siteSetId: Scalars['SiteSetId'];
};


/** Operations querying staffhours management */
export type ManagementQueriescontractedHoursV2Args = {
  employeeId?: InputMaybe<Scalars['EmployeeId']>;
  siteSetId: Scalars['SiteSetId'];
};


/** Operations querying staffhours management */
export type ManagementQueriesschedulesArgs = {
  employeeId: Scalars['EmployeeId'];
  siteSetId: Scalars['SiteSetId'];
};


/** Operations querying staffhours management */
export type ManagementQueriesshiftplannerArgs = {
  siteSetId: Scalars['SiteSetId'];
};


/** Operations querying staffhours management */
export type ManagementQueriessubtypesArgs = {
  siteSetId: Scalars['InstitutionSetId'];
};


/** Operations querying staffhours management */
export type ManagementQueriestotalsArgs = {
  employeeId?: InputMaybe<Scalars['EmployeeId']>;
  siteSetId: Scalars['SiteSetId'];
};


/** Operations querying staffhours management */
export type ManagementQueriestotalsV2Args = {
  employeeId?: InputMaybe<Scalars['EmployeeId']>;
  siteSetId: Scalars['SiteSetId'];
};


/** Operations querying staffhours management */
export type ManagementQueriesworkTagsArgs = {
  siteSetId: Scalars['SiteSetId'];
};

export type ManagerTokenDetails = WatchMeGrowTokenDetails & {
  __typename?: 'ManagerTokenDetails';
  canAccessReports: Scalars['Boolean'];
  canSetup: Scalars['Boolean'];
  type: WatchMeGrowTokenType;
};

/** Definition of max funded minutes per day */
export type MaxFundedMinutesPerDay = {
  __typename?: 'MaxFundedMinutesPerDay';
  source: Source;
  value: Scalars['Int'];
};

/** Queries for operating on the current user */
export type Me = {
  __typename?: 'Me';
  /** Contains information about user's app version */
  appVersion: AppVersionInformation;
  apps: Array<AppType>;
  /** Describes which options are available for authentication */
  authenticationOptions: AuthenticationOptions;
  /** Contains settings for auto logout */
  autoLogout: AutoLogout;
  /** Gets all available contexts for the user */
  availableContexts: Array<UserContext>;
  /**
   * Lists available OpenID providers for the provided user.
   *
   * If a token is provided, this will determine the user. Otherwise, the currently authenticated user will be used.
   *
   */
  availableOpenIDProviders: Array<OpenIDProvider>;
  /** Gets all available signature types for the user */
  availableSignatureTypes: Array<SignedAs>;
  /** Contains information about the banners that should be shown to the user */
  banners: Banners;
  /** Object with conversations data where user is part */
  conversations: UserConversation;
  /** Gets the currently chosen context for the user */
  currentContext?: Maybe<UserContext>;
  /** Contains information about the features that are enabled directly on the user */
  features: UserFeatures;
  me: Login;
  myCalendar: MyCalendar;
  navigation: Navigation;
  navigationView: Array<NavigationViewType>;
  /** Contains settings for news feed */
  newsfeed: Newsfeed;
  /** User notifications */
  notifications: UserNotifications;
  referral: Referral;
  /** Contains settings for access restrictions */
  restrictions: Restrictions;
  /** Show the pin for this user */
  showPin?: Maybe<Scalars['String']>;
  /** Information about the user's terms and conditions */
  termsAndConditions: TermsAndConditions;
  /** Contains settings for updates */
  updates: Updates;
  /** What's New information from Famly */
  whatsNew: WhatsNew;
};


/** Queries for operating on the current user */
export type MeavailableOpenIDProvidersArgs = {
  token?: InputMaybe<Scalars['String']>;
};


/** Queries for operating on the current user */
export type MeavailableSignatureTypesArgs = {
  institutionSetIdArg: Scalars['InstitutionSetId'];
};


/** Queries for operating on the current user */
export type MeshowPinArgs = {
  token: Scalars['String'];
};

/** Mutations for logins */
export type MeMutation = {
  __typename?: 'MeMutation';
  /** Answers an AuthenticationChallenged result from a call to authenticateWithPassword */
  answerChallenge: ChallengeAnsweredResult;
  /** Authenticate using OpenID connect */
  authenticateWithOIDC: AuthenticateWithOIDCResult;
  authenticateWithOneTimeToken: Scalars['AccessToken'];
  authenticateWithPassword: AuthenticateWithPasswordResult;
  /** Like 'authenticateWithPassword', but allows you to circumvent the 'answerChallenge' flow by providing a user context choice and 2FA code immediately. */
  authenticateWithPasswordAndContext: AuthenticateWithPasswordAndContextResult;
  authenticateWithPin: AuthenticateWithPinResult;
  authenticateWithToken: Scalars['AccessToken'];
  /**
   * Connect a user to the provided OpenID user.
   *
   * If a token is provided, this will determine the user. Otherwise, the currently authenticated user will be used.
   *
   */
  connectOpenID: AuthenticateWithOIDCResult;
  /** Create a new login */
  create: LoginCreated;
  /**
   * Disconnect a user from the chosen provider.
   *
   * All connections between the user and the provider will be deleted.
   *
   */
  disconnectOpenID: Scalars['LoginId'];
  /** Mutations to manage the features that can be enabled directly on the user */
  features: UserFeatureMutations;
  /** Extends session */
  keepAlive: AutoLogout;
  navigation: NavigationMutation;
  /** Send a invite to the new freemium to the email in the input */
  newFreemiumSendInvite: Array<Scalars['EmailAddress']>;
  /** Request a one-time use token for logging in */
  requestOneTimeToken: Scalars['EmailAddress'];
  /**
   * Request a token via email to connect to OpenID
   *
   */
  requestOpenIdConnectToken: Scalars['String'];
  /** Request a token that can be used to authenticate with another endpoint */
  requestToken: Scalars['String'];
  /** Reset the password for the login associated with the reset password token */
  resetPassword: Login;
  /** Sets the current user context for the given device */
  setContext: Scalars['AccessToken'];
  /** Set feature interests of user */
  setFeatureInterests: Array<FeatureInterest>;
  /** Sets the initial password, and optionally a pin */
  setInitialPasswordAndPin: SetInitialPasswordAndPinResult;
  /**
   * Set institution type of nursery
   * @deprecated Use setSignupInfo instead
   */
  setInstitutionType: InstitutionType;
  /** Set the password for this user */
  setPassword: Login;
  /** Set the pin for the user specified by the token. If the user specified by the token is not the current user, an internal token must be set */
  setPin: Login;
  /** Set signup info at nursery creation */
  setSignupInfo: Scalars['LoginId'];
  /** Set the main view for a user */
  setView: NavigationViewType;
};


/** Mutations for logins */
export type MeMutationanswerChallengeArgs = {
  deviceId: Scalars['DeviceId'];
  expiresAt: Scalars['Long'];
  hmac: Scalars['String'];
  loginId: Scalars['LoginId'];
  twoFactorCode?: InputMaybe<Scalars['Int']>;
  userContextId: Scalars['String'];
};


/** Mutations for logins */
export type MeMutationauthenticateWithOIDCArgs = {
  code: Scalars['String'];
  deviceId?: InputMaybe<Scalars['DeviceId']>;
  email: Scalars['EmailAddress'];
  openIDProviderId: Scalars['OIDCProviderId'];
  redirect: Scalars['URI'];
};


/** Mutations for logins */
export type MeMutationauthenticateWithOneTimeTokenArgs = {
  loginId: Scalars['LoginId'];
  token: Scalars['String'];
};


/** Mutations for logins */
export type MeMutationauthenticateWithPasswordArgs = {
  deviceId?: InputMaybe<Scalars['DeviceId']>;
  email: Scalars['EmailAddress'];
  legacy?: InputMaybe<Scalars['Boolean']>;
  password: Scalars['Password'];
};


/** Mutations for logins */
export type MeMutationauthenticateWithPasswordAndContextArgs = {
  contextId: Scalars['String'];
  email: Scalars['EmailAddress'];
  password: Scalars['Password'];
  twoFactorCode?: InputMaybe<Scalars['Int']>;
};


/** Mutations for logins */
export type MeMutationauthenticateWithPinArgs = {
  deviceId: Scalars['DeviceId'];
  legacy?: InputMaybe<Scalars['Boolean']>;
  loginId: Scalars['LoginId'];
  pin: Scalars['String'];
};


/** Mutations for logins */
export type MeMutationauthenticateWithTokenArgs = {
  token: Scalars['String'];
};


/** Mutations for logins */
export type MeMutationconnectOpenIDArgs = {
  code: Scalars['String'];
  deviceId?: InputMaybe<Scalars['DeviceId']>;
  openIDProviderId: Scalars['OIDCProviderId'];
  redirect: Scalars['URI'];
  token?: InputMaybe<Scalars['String']>;
};


/** Mutations for logins */
export type MeMutationcreateArgs = {
  address?: InputMaybe<AddressInput>;
  createDemoNursery: DemoNurseryCreationInput;
  email: Scalars['ValidEmailAddress'];
  locale: Scalars['Locale'];
  name: Scalars['String'];
  password?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};


/** Mutations for logins */
export type MeMutationdisconnectOpenIDArgs = {
  loginId?: InputMaybe<Scalars['LoginId']>;
  openIDProviderId: Scalars['OIDCProviderId'];
};


/** Mutations for logins */
export type MeMutationnewFreemiumSendInviteArgs = {
  email: Array<Scalars['ValidEmailAddress']>;
};


/** Mutations for logins */
export type MeMutationrequestOneTimeTokenArgs = {
  email: Scalars['ValidEmailAddress'];
};


/** Mutations for logins */
export type MeMutationrequestOpenIdConnectTokenArgs = {
  email: Scalars['String'];
};


/** Mutations for logins */
export type MeMutationrequestTokenArgs = {
  code?: InputMaybe<Scalars['String']>;
  loginId?: InputMaybe<Scalars['LoginId']>;
  openIDProviderId?: InputMaybe<Scalars['OIDCProviderId']>;
  password?: InputMaybe<Scalars['Password']>;
  redirect?: InputMaybe<Scalars['URI']>;
  tokenType: TokenType;
};


/** Mutations for logins */
export type MeMutationresetPasswordArgs = {
  email?: InputMaybe<Scalars['String']>;
  newPassword: Scalars['Password'];
  token: Scalars['String'];
};


/** Mutations for logins */
export type MeMutationsetContextArgs = {
  deviceId: Scalars['DeviceId'];
  userContextId: Scalars['String'];
};


/** Mutations for logins */
export type MeMutationsetFeatureInterestsArgs = {
  featureInterests: Array<FeatureInterest>;
  institutionId: Scalars['InstitutionId'];
};


/** Mutations for logins */
export type MeMutationsetInitialPasswordAndPinArgs = {
  email?: InputMaybe<Scalars['String']>;
  password: Scalars['Password'];
  pin?: InputMaybe<Scalars['String']>;
  token: Scalars['String'];
};


/** Mutations for logins */
export type MeMutationsetInstitutionTypeArgs = {
  institutionId: Scalars['InstitutionId'];
  institutionType: InstitutionType;
};


/** Mutations for logins */
export type MeMutationsetPasswordArgs = {
  newPassword: Scalars['Password'];
  oldPassword: Scalars['Password'];
};


/** Mutations for logins */
export type MeMutationsetPinArgs = {
  pin: Scalars['String'];
  token: Scalars['String'];
};


/** Mutations for logins */
export type MeMutationsetSignupInfoArgs = {
  deviceHeight?: InputMaybe<Scalars['Long']>;
  deviceWidth?: InputMaybe<Scalars['Long']>;
  institutionId: Scalars['InstitutionId'];
  institutionType?: InputMaybe<InstitutionType>;
  signupRole?: InputMaybe<SignupRole>;
  touchDevice?: InputMaybe<Scalars['Boolean']>;
  userAgent?: InputMaybe<Scalars['String']>;
};


/** Mutations for logins */
export type MeMutationsetViewArgs = {
  inView: Array<InViewType>;
  viewId: Scalars['NavigationViewId'];
};

/** The deadline parents have to change meal bookings. */
export type MealBookingDeadline = {
  __typename?: 'MealBookingDeadline';
  /** An enum of the selected deadline day */
  day: MealBookingDeadlineDay;
  /** The time of the day parents have to change meal bookings if day isn't NoDeadline. */
  time?: Maybe<Scalars['LocalTime']>;
};

export enum MealBookingDeadlineDay {
  DAY_BEFORE = 'DAY_BEFORE',
  NO_DEADLINE = 'NO_DEADLINE',
  ONE_WEEK_BEFORE = 'ONE_WEEK_BEFORE',
  SAME_DAY = 'SAME_DAY',
  TWO_DAYS_BEFORE = 'TWO_DAYS_BEFORE'
}

export type MealBookingDeadlineInput = {
  day: MealBookingDeadlineDay;
  time?: InputMaybe<Scalars['LocalTime']>;
};

/** What should happen with meal bookings when a child is on leave */
export type MealBookingManagementOnLeaveInput = {
  /** Provide only if optOutSelection is OptOutSomeMeals. */
  optOutMealTypes?: InputMaybe<Array<Scalars['MealTypeId']>>;
  optOutSelection: MealBookingSelectionOnLeave;
};

export type MealBookingReportAllergiesTotalEntry = {
  __typename?: 'MealBookingReportAllergiesTotalEntry';
  allergy: Scalars['String'];
  total: Scalars['Int'];
};

export type MealBookingReportEntry = {
  __typename?: 'MealBookingReportEntry';
  allergies: Array<Scalars['String']>;
  child: Child;
  entries: Array<MealBookingReportPerDateEntry>;
  groupName: Scalars['String'];
  siteId: Scalars['SiteId'];
};

export type MealBookingReportMealTotalEntry = {
  __typename?: 'MealBookingReportMealTotalEntry';
  mealType: MealType;
  total: Scalars['Int'];
};

export type MealBookingReportPerDateEntry = {
  __typename?: 'MealBookingReportPerDateEntry';
  date: Scalars['LocalDate'];
  meal: MealType;
  selection: Scalars['Boolean'];
};

/** Represents the paginated result of meal booking report listing */
export type MealBookingReportResult = {
  __typename?: 'MealBookingReportResult';
  /** A list of meal booking report */
  listing: Array<MealBookingReportEntry>;
  /** If this token is not empty, use this as an argument to fetch the next set of report rows */
  next?: Maybe<Scalars['MealBookingReportCursor']>;
  /** The totals of all the filter-matched data, disregarding pagination */
  totals: MealBookingReportTotals;
};

export type MealBookingReportTotals = {
  __typename?: 'MealBookingReportTotals';
  allergies: Array<MealBookingReportAllergiesTotalEntry>;
  childrenCount: Scalars['Int'];
  meals: Array<MealBookingReportMealTotalEntry>;
};

export type MealBookingSelection = {
  __typename?: 'MealBookingSelection';
  child: Child;
  date: Scalars['LocalDate'];
  isLocked: Scalars['Boolean'];
  mealType: MealType;
  selection: Scalars['Boolean'];
};

export type MealBookingSelectionInput = {
  childId: Scalars['ChildId'];
  date: Scalars['LocalDate'];
  isLocked: Scalars['Boolean'];
  mealTypeId: Scalars['MealTypeId'];
  selection: Scalars['Boolean'];
};

export enum MealBookingSelectionOnLeave {
  OPT_OUT_ALL_MEALS = 'OPT_OUT_ALL_MEALS',
  OPT_OUT_NONE_MEALS = 'OPT_OUT_NONE_MEALS',
  OPT_OUT_SOME_MEALS = 'OPT_OUT_SOME_MEALS'
}

/** The meal booking settings for a specific site set. */
export type MealBookingSettings = {
  __typename?: 'MealBookingSettings';
  /** Whether the user has permissions to edit the settings. */
  canEdit: Scalars['Boolean'];
  /** The deadline parents have to change meal bookings. */
  deadline: MealBookingDeadline;
  /** Whether meal booking is enabled for usage. */
  isEnabled: Scalars['Boolean'];
  siteSetId: Scalars['SiteSetId'];
};

export type MealPlan = {
  __typename?: 'MealPlan';
  archivedAt?: Maybe<Scalars['ZonedDateTime']>;
  catchAll: Scalars['Boolean'];
  /** Children directly included in the meal plan */
  children: Array<Child>;
  createdAt: Scalars['ZonedDateTime'];
  endDate?: Maybe<Scalars['LocalDate']>;
  /** Groups included in the meal plan */
  groups: Array<Group>;
  id: Scalars['MealPlanId'];
  institutionSetId: Scalars['InstitutionSetId'];
  isV3: Scalars['Boolean'];
  /**
   * Get the latest meal plan day filled out (*with data)
   * @deprecated Replaced by `startDate` and `endDate`
   */
  latestDate?: Maybe<Scalars['LocalDate']>;
  name?: Maybe<Scalars['String']>;
  recurring: Scalars['Boolean'];
  startDate?: Maybe<Scalars['LocalDate']>;
  status: MealPlanStatus;
  tags: Array<Tag>;
};

export type MealPlanDay = {
  __typename?: 'MealPlanDay';
  day: Scalars['DayOfWeek'];
  /** @deprecated Replaced by `week` and `day`. */
  mealDate: Scalars['LocalDate'];
  /** @deprecated This is now part of `MealPlanSchedule`, which already includes the `MealPlan`. */
  mealPlan: MealPlan;
  meals: Array<MealTypeItems>;
  week: Scalars['Int'];
};

export type MealPlanDayInput = {
  mealDate: Scalars['LocalDate'];
  mealPlanId: Scalars['MealPlanId'];
  meals: Array<MealTypeItemsInput>;
};

export type MealPlanSchedule = {
  __typename?: 'MealPlanSchedule';
  currentWeek?: Maybe<Scalars['Int']>;
  days: Array<SegmentDay>;
  mealPlan: MealPlan;
};

export enum MealPlanStatus {
  ARCHIVED = 'ARCHIVED',
  DELETED = 'DELETED',
  DRAFT = 'DRAFT',
  PUBLISHED = 'PUBLISHED'
}

export type MealPlanUpdateDatesInput = {
  end?: InputMaybe<Scalars['LocalDate']>;
  start?: InputMaybe<Scalars['LocalDate']>;
};

/** Objects related to meal plans */
export type MealPlans = {
  __typename?: 'MealPlans';
  /** Whether or not site has recurring meal plans enabled */
  canUseRecurring: Scalars['Boolean'];
  /**
   * If true, the V2 meal plan API is disabled and V3 UI + API should be used.
   * @deprecated Meal plans V3 have been released and this field now always returns true.
   */
  isV3Enabled: Scalars['Boolean'];
  /** List of meal plans for a site by status. */
  list: Array<MealPlan>;
  /** Returns all data required to render the meal plan's edit view. If the meal plan hasn't been converted to V3, this will also trigger the conversion. */
  mealPlanSchedule: MealPlanSchedule;
};


/** Objects related to meal plans */
export type MealPlanscanUseRecurringArgs = {
  siteSetId: Scalars['InstitutionSetId'];
};


/** Objects related to meal plans */
export type MealPlansisV3EnabledArgs = {
  siteSetId: Scalars['InstitutionSetId'];
};


/** Objects related to meal plans */
export type MealPlanslistArgs = {
  siteSetId: Scalars['InstitutionSetId'];
  status?: InputMaybe<Array<MealPlanStatus>>;
};


/** Objects related to meal plans */
export type MealPlansmealPlanScheduleArgs = {
  mealPlanId: Scalars['MealPlanId'];
  nWeeks?: InputMaybe<Scalars['Int']>;
  startDate?: InputMaybe<Scalars['LocalDate']>;
};

/** Make changes to meal plans */
export type MealPlansMutations = {
  __typename?: 'MealPlansMutations';
  archive: Scalars['MealPlanId'];
  create: MealPlan;
  delete: Scalars['MealPlanId'];
  /** Creates a draft copy of an existing meal plan. */
  duplicate: Scalars['MealPlanId'];
  publish: MealPlan;
  update: MealPlan;
  updateMealPlanDays: MealPlanSchedule;
};


/** Make changes to meal plans */
export type MealPlansMutationsarchiveArgs = {
  mealPlanId: Scalars['MealPlanId'];
};


/** Make changes to meal plans */
export type MealPlansMutationscreateArgs = {
  catchAll: Scalars['Boolean'];
  childIds: Array<Scalars['ChildId']>;
  endDate?: InputMaybe<Scalars['LocalDate']>;
  groupIds: Array<Scalars['GroupId']>;
  mealPlanDays: Array<DayMealPlanInput>;
  name?: InputMaybe<Scalars['String']>;
  recurring: Scalars['Boolean'];
  siteSetId: Scalars['InstitutionSetId'];
  startDate?: InputMaybe<Scalars['LocalDate']>;
  tagIds: Array<Scalars['TagId']>;
};


/** Make changes to meal plans */
export type MealPlansMutationsdeleteArgs = {
  mealPlanId: Scalars['MealPlanId'];
};


/** Make changes to meal plans */
export type MealPlansMutationsduplicateArgs = {
  mealPlanId: Scalars['MealPlanId'];
};


/** Make changes to meal plans */
export type MealPlansMutationspublishArgs = {
  mealPlanId: Scalars['MealPlanId'];
};


/** Make changes to meal plans */
export type MealPlansMutationsupdateArgs = {
  catchAll?: InputMaybe<Scalars['Boolean']>;
  childIds?: InputMaybe<Array<Scalars['ChildId']>>;
  dates?: InputMaybe<MealPlanUpdateDatesInput>;
  groupIds?: InputMaybe<Array<Scalars['GroupId']>>;
  mealPlanDays?: InputMaybe<Array<DayMealPlanInput>>;
  mealPlanId: Scalars['MealPlanId'];
  name?: InputMaybe<Scalars['String']>;
  recurring?: InputMaybe<Scalars['Boolean']>;
  tagIds?: InputMaybe<Array<Scalars['TagId']>>;
};


/** Make changes to meal plans */
export type MealPlansMutationsupdateMealPlanDaysArgs = {
  mealPlanDays: Array<DayMealPlanInput>;
  mealPlanId: Scalars['MealPlanId'];
};

export type MealType = {
  __typename?: 'MealType';
  color: Scalars['Int'];
  id: Scalars['MealTypeId'];
  institutionId: Scalars['InstitutionId'];
  order: Scalars['Int'];
  title: Scalars['String'];
};

export type MealTypeItems = {
  __typename?: 'MealTypeItems';
  foodItems: Array<FoodItem>;
  mealType: MealType;
};

export type MealTypeItemsInput = {
  foodItemIds: Array<Scalars['FoodItemId']>;
  mealTypeId: Scalars['MealTypeId'];
};

/** Objects related to meals and food. Fields related to meal plans are deprecated, use `mealPlans` instead. */
export type Meals = {
  __typename?: 'Meals';
  behaviors: Array<Behavior>;
  /** Whether the meal booking reports can be viewed for the given site. */
  canViewMealBookingsReports: Array<PerSitePermissions>;
  foodItems: Array<FoodItem>;
  /** Whether the meal booking feature is enabled for the given site. */
  isMealBookingEnabled: Scalars['Boolean'];
  /** The meal booking settings for the given site. If nothing has been set yet but feature is enabled, it will return default settings */
  mealBookingSettings: MealBookingSettings;
  /** The meal booking settings for each of the given children. If feature is disabled for site's child, child won't be listed */
  mealBookingSettingsForChildren: Array<PerChildMealBookingSettings>;
  /** Returns the URL to fetch csv meal plans report. */
  mealBookingsCsvReport: Scalars['String'];
  /** Get the meal bookings for the given date range and children. */
  mealBookingsForChildren: Array<MealBookingSelection>;
  /** Get the meal bookings reports for the given filters. */
  mealBookingsReportsByFilters: MealBookingReportResult;
  /** @deprecated Replaced by `MealPlan.mealPlanSchedule`. */
  mealPlanDays: Array<MealPlanDay>;
  /** @deprecated Replaced by `MealPlans.list`. */
  mealPlans: Array<MealPlan>;
  mealTypes: Array<MealType>;
  mealsForChild?: Maybe<MealPlanDay>;
  mealsForChildren: Array<MealsForChildren>;
};


/** Objects related to meals and food. Fields related to meal plans are deprecated, use `mealPlans` instead. */
export type MealsbehaviorsArgs = {
  institutionSetId: Scalars['InstitutionSetId'];
};


/** Objects related to meals and food. Fields related to meal plans are deprecated, use `mealPlans` instead. */
export type MealscanViewMealBookingsReportsArgs = {
  siteSetIds: Array<Scalars['SiteSetId']>;
};


/** Objects related to meals and food. Fields related to meal plans are deprecated, use `mealPlans` instead. */
export type MealsfoodItemsArgs = {
  institutionId: Scalars['InstitutionId'];
  limit?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
};


/** Objects related to meals and food. Fields related to meal plans are deprecated, use `mealPlans` instead. */
export type MealsisMealBookingEnabledArgs = {
  siteSetId: Scalars['SiteSetId'];
};


/** Objects related to meals and food. Fields related to meal plans are deprecated, use `mealPlans` instead. */
export type MealsmealBookingSettingsArgs = {
  siteSetId: Scalars['SiteSetId'];
};


/** Objects related to meals and food. Fields related to meal plans are deprecated, use `mealPlans` instead. */
export type MealsmealBookingSettingsForChildrenArgs = {
  childIds: Array<Scalars['ChildId']>;
};


/** Objects related to meals and food. Fields related to meal plans are deprecated, use `mealPlans` instead. */
export type MealsmealBookingsCsvReportArgs = {
  allergies?: InputMaybe<Array<Scalars['String']>>;
  childIds?: InputMaybe<Array<Scalars['ChildId']>>;
  dates: ClosedLocalDateRange;
  roomIds?: InputMaybe<Array<Scalars['GroupId']>>;
  siteSetId: Scalars['InstitutionSetId'];
  tagIds?: InputMaybe<Array<Scalars['TagId']>>;
};


/** Objects related to meals and food. Fields related to meal plans are deprecated, use `mealPlans` instead. */
export type MealsmealBookingsForChildrenArgs = {
  childIds: Array<Scalars['ChildId']>;
  dates: ClosedLocalDateRange;
};


/** Objects related to meals and food. Fields related to meal plans are deprecated, use `mealPlans` instead. */
export type MealsmealBookingsReportsByFiltersArgs = {
  allergies?: InputMaybe<Array<Scalars['String']>>;
  childIds?: InputMaybe<Array<Scalars['ChildId']>>;
  dates: ClosedLocalDateRange;
  next?: InputMaybe<Scalars['MealBookingReportCursor']>;
  roomIds?: InputMaybe<Array<Scalars['GroupId']>>;
  siteSetId: Scalars['SiteSetId'];
  tagIds?: InputMaybe<Array<Scalars['TagId']>>;
  take?: InputMaybe<Scalars['Int']>;
};


/** Objects related to meals and food. Fields related to meal plans are deprecated, use `mealPlans` instead. */
export type MealsmealPlanDaysArgs = {
  dates: Array<Scalars['LocalDate']>;
  mealPlanId: Scalars['MealPlanId'];
};


/** Objects related to meals and food. Fields related to meal plans are deprecated, use `mealPlans` instead. */
export type MealsmealPlansArgs = {
  institutionSetId: Scalars['InstitutionSetId'];
};


/** Objects related to meals and food. Fields related to meal plans are deprecated, use `mealPlans` instead. */
export type MealsmealTypesArgs = {
  institutionIds: Scalars['InstitutionId'];
};


/** Objects related to meals and food. Fields related to meal plans are deprecated, use `mealPlans` instead. */
export type MealsmealsForChildArgs = {
  childId: Scalars['ChildId'];
  date: Scalars['LocalDate'];
};


/** Objects related to meals and food. Fields related to meal plans are deprecated, use `mealPlans` instead. */
export type MealsmealsForChildrenArgs = {
  childIds: Array<Scalars['ChildId']>;
  date: Scalars['LocalDate'];
};

export type MealsForChildren = {
  __typename?: 'MealsForChildren';
  children: Array<Scalars['ChildId']>;
  mealPlan: MealPlan;
  mealPlanDay?: Maybe<MealPlanDay>;
};

/** Change meals and food items. Mutations on meal plans are deprecated, use `mealPlans` instead. */
export type MealsMutations = {
  __typename?: 'MealsMutations';
  /** @deprecated Use MealPlans.update to clear all days from the meal plan. */
  clearMealPlanDays: Scalars['Boolean'];
  createFoodItem: FoodItem;
  createFoodItems: Array<FoodItem>;
  /** @deprecated Replaced by `mealPlans.create`. */
  createMealPlan: MealPlan;
  deleteFoodItem: Scalars['Boolean'];
  /** @deprecated Replaced by `mealPlans.delete`. */
  deleteMealPlan: Scalars['Boolean'];
  /** @deprecated Replaced by `mealPlans.delete`. */
  deleteMealPlans: Array<Scalars['MealPlanId']>;
  /** Set the deadline for parents to change meal bookings on the given site */
  setMealBookingSettings: MealBookingSettings;
  /** @deprecated Use either MealPlans.update or MealPlans.updateMealPlanDays. */
  setMealPlanDays: Array<MealPlanDay>;
  /** Update meal bookings. */
  updateMealBookings: Array<MealBookingSelection>;
  /** @deprecated Replaced by `mealPlans.update`. */
  updateMealPlan: MealPlan;
};


/** Change meals and food items. Mutations on meal plans are deprecated, use `mealPlans` instead. */
export type MealsMutationsclearMealPlanDaysArgs = {
  dates: Array<Scalars['LocalDate']>;
  mealPlanId: Scalars['MealPlanId'];
};


/** Change meals and food items. Mutations on meal plans are deprecated, use `mealPlans` instead. */
export type MealsMutationscreateFoodItemArgs = {
  institutionIds: Scalars['InstitutionId'];
  title: Scalars['String'];
  unit?: InputMaybe<Scalars['String']>;
};


/** Change meals and food items. Mutations on meal plans are deprecated, use `mealPlans` instead. */
export type MealsMutationscreateFoodItemsArgs = {
  foodItems: Array<FoodItemInput>;
  siteSetIds: Array<Scalars['SiteSetId']>;
};


/** Change meals and food items. Mutations on meal plans are deprecated, use `mealPlans` instead. */
export type MealsMutationscreateMealPlanArgs = {
  catchAll: Scalars['Boolean'];
  childIds: Array<Scalars['ChildId']>;
  groupIds: Array<Scalars['GroupId']>;
  institutionSetId: Scalars['InstitutionSetId'];
  name?: InputMaybe<Scalars['String']>;
  tagIds: Array<Scalars['TagId']>;
};


/** Change meals and food items. Mutations on meal plans are deprecated, use `mealPlans` instead. */
export type MealsMutationsdeleteFoodItemArgs = {
  checkUsageInMealPlans?: InputMaybe<Scalars['Boolean']>;
  institutionIds: Scalars['InstitutionId'];
  title: Scalars['String'];
};


/** Change meals and food items. Mutations on meal plans are deprecated, use `mealPlans` instead. */
export type MealsMutationsdeleteMealPlanArgs = {
  mealPlanId: Scalars['MealPlanId'];
};


/** Change meals and food items. Mutations on meal plans are deprecated, use `mealPlans` instead. */
export type MealsMutationsdeleteMealPlansArgs = {
  mealPlanIds: Array<Scalars['MealPlanId']>;
};


/** Change meals and food items. Mutations on meal plans are deprecated, use `mealPlans` instead. */
export type MealsMutationssetMealBookingSettingsArgs = {
  deadline: MealBookingDeadlineInput;
  enabled: Scalars['Boolean'];
  siteSetId: Scalars['SiteSetId'];
};


/** Change meals and food items. Mutations on meal plans are deprecated, use `mealPlans` instead. */
export type MealsMutationssetMealPlanDaysArgs = {
  mealPlanDays: Array<MealPlanDayInput>;
};


/** Change meals and food items. Mutations on meal plans are deprecated, use `mealPlans` instead. */
export type MealsMutationsupdateMealBookingsArgs = {
  data: Array<MealBookingSelectionInput>;
};


/** Change meals and food items. Mutations on meal plans are deprecated, use `mealPlans` instead. */
export type MealsMutationsupdateMealPlanArgs = {
  catchAll: Scalars['Boolean'];
  childIds: Array<Scalars['ChildId']>;
  groupIds: Array<Scalars['GroupId']>;
  mealPlanId: Scalars['MealPlanId'];
  name?: InputMaybe<Scalars['String']>;
  tagIds: Array<Scalars['TagId']>;
};

export type MediaShare = {
  __typename?: 'MediaShare';
  /**
   * Used when it's not possible to provide a siteId as input
   * @deprecated Use canShareMedia instead
   */
  canShareFeedItemMedia: Scalars['Boolean'];
  /** Checks if user is a parent in the site and media share feature is enabled. If variables are omitted, the feature check is performed across all sites where the user is a parent */
  canShareMedia: Scalars['Boolean'];
  /** Media Share settings */
  settings: MediaShareSettings;
};


export type MediaSharecanShareFeedItemMediaArgs = {
  feedItemId: Scalars['FeedItemId'];
};


export type MediaSharecanShareMediaArgs = {
  childrenIds?: InputMaybe<Array<Scalars['ChildId']>>;
};


export type MediaSharesettingsArgs = {
  siteId: Scalars['InstitutionId'];
};

export type MediaShareSettings = {
  __typename?: 'MediaShareSettings';
  /** Checks if user can manage features and if media share setting isn't disable for the site */
  canManageMediaShare: Scalars['Boolean'];
  /** Checks if user is a parent in the site and media share feature is enabled */
  canShareMedia: Scalars['Boolean'];
};

/** For querying media tags and taggable entities like children */
export type MediaTagAllowanceQueries = {
  __typename?: 'MediaTagAllowanceQueries';
  /** List all taggable entities by descending institutions from given institutionSetId */
  list: MediaTagAllowanceResult;
};


/** For querying media tags and taggable entities like children */
export type MediaTagAllowanceQuerieslistArgs = {
  institutionSetIds: Array<Scalars['InstitutionSetId']>;
};

/** Media tag allowance result by institution */
export type MediaTagAllowanceResult = {
  __typename?: 'MediaTagAllowanceResult';
  result: Array<InstitutionMediaTagAllowance>;
};

export type MediaTagInput = {
  appModule: AppModule;
  children: Array<Scalars['ChildId']>;
  imageId?: InputMaybe<Scalars['ImageId']>;
  videoId?: InputMaybe<Scalars['VideoId']>;
};

/** For creating/updating tags in entities like children */
export type MediaTagMutation = {
  __typename?: 'MediaTagMutation';
  /** Set the list of children tagged on a media. Children not present in the input will be untagged. */
  create: MediaTaggedResult;
  /** Delete tags from children in media */
  delete: MediaTaggedResult;
};


/** For creating/updating tags in entities like children */
export type MediaTagMutationcreateArgs = {
  input: Array<MediaTagInput>;
};


/** For creating/updating tags in entities like children */
export type MediaTagMutationdeleteArgs = {
  input: Array<DeleteMediaInput>;
};

/** For querying media already tagged from entities like children */
export type MediaTaggedQueries = {
  __typename?: 'MediaTaggedQueries';
  /** List all tagged entities on given ids */
  list: MediaTaggedResult;
};


/** For querying media already tagged from entities like children */
export type MediaTaggedQuerieslistArgs = {
  imageIds?: InputMaybe<Array<Scalars['ImageId']>>;
  videoIds?: InputMaybe<Array<Scalars['VideoId']>>;
};

/** Media tag allowance result by institution */
export type MediaTaggedResult = {
  __typename?: 'MediaTaggedResult';
  childrenMedia: Array<ChildrenMediaTagged>;
};

/** Mutations for tagging entities like children */
export type MediaTaggingMutation = {
  __typename?: 'MediaTaggingMutation';
  /** For creating/updating tags in entities like children */
  mediaTag: MediaTagMutation;
};

/** Queries for media (images, videos) of tagged entities like children */
export type MediaTaggingQueries = {
  __typename?: 'MediaTaggingQueries';
  /** For querying media already tagged from entities like children */
  mediaTagged: MediaTaggedQueries;
  /** For querying media tags and taggable entities like children */
  tagAllowance: MediaTagAllowanceQueries;
  /** Returns list of children that user can tag on a picture posted by the given site. */
  taggable: Array<ChildLimitedInfo>;
};


/** Queries for media (images, videos) of tagged entities like children */
export type MediaTaggingQueriestaggableArgs = {
  siteId: Scalars['SiteId'];
};

export type MedicationForm = {
  __typename?: 'MedicationForm';
  acknowledgements: Array<FormAcknowledgement>;
  active: Scalars['Boolean'];
  administerTo?: Maybe<Scalars['LocalDate']>;
  administeredMedication: AdministeredMedicationResult;
  behaviors: Array<Behavior>;
  canAdministerMedication: Scalars['Boolean'];
  child: Child;
  createdAt: Scalars['ZonedDateTime'];
  createdBy: Person;
  /** If true, parents should get notified daily. Defaults to true if `times` isn't empty. */
  dailyNotifications: Scalars['Boolean'];
  dailyUpdateForToday?: Maybe<DailyMedicationFormUpdate>;
  deactivatedAt?: Maybe<Scalars['ZonedDateTime']>;
  deactivatedBy?: Maybe<Person>;
  dosage: Scalars['BigDecimal'];
  dosageUnit: Scalars['String'];
  genericForm: GenericForm;
  id: Scalars['MedicationFormId'];
  lastChangedAt?: Maybe<Scalars['ZonedDateTime']>;
  lastChangedBy?: Maybe<Person>;
  medicationName: Scalars['String'];
  reasonForMedication: Scalars['String'];
  /** If an empty list is provided, the medication form applies for `only when needed` */
  time?: Maybe<Array<Scalars['LocalTime']>>;
  /** @deprecated Do not use this field. This is only here for backwards compatibility. Use field `time` instead */
  timeToBeGiven: Scalars['LocalTime'];
};


export type MedicationFormacknowledgementsArgs = {
  acknowledgementIds?: InputMaybe<Array<Scalars['SignatureId']>>;
  acknowledgementType?: InputMaybe<Array<SignedAs>>;
  onlyValid?: InputMaybe<Scalars['Boolean']>;
};


export type MedicationFormadministeredMedicationArgs = {
  after?: InputMaybe<Scalars['AdministeredMedicationCursor']>;
};

export type MedicationFormInput = {
  administerTo?: InputMaybe<Scalars['LocalDate']>;
  appliesToChild: Scalars['ChildId'];
  dailyNotifications?: InputMaybe<Scalars['Boolean']>;
  dosage: Scalars['BigDecimal'];
  dosageUnit: Scalars['String'];
  genericFormTemplateVersionId: Scalars['GenericFormTemplateVersionId'];
  genericFormValues: Array<FieldValuesInput>;
  medicationName: Scalars['String'];
  reasonForMedication: Scalars['String'];
  time?: InputMaybe<Array<Scalars['LocalTime']>>;
};

export type MedicationFormResult = {
  __typename?: 'MedicationFormResult';
  next?: Maybe<Scalars['MedicationFormCursor']>;
  results: Array<MedicationForm>;
};

/** Queries and objects related to medication forms */
export type MedicationForms = {
  __typename?: 'MedicationForms';
  /** Behaviors for Medication Forms */
  behaviors: Array<Behavior>;
  /** List name and IDs of current site employees. */
  employeeWitnesses: Array<EmployeeWitness>;
  hasDailyInputs?: Maybe<Scalars['Boolean']>;
  listMedicationForms: MedicationFormResult;
  termsAndConditions: TermsAndConditionsLinkResult;
};


/** Queries and objects related to medication forms */
export type MedicationFormsbehaviorsArgs = {
  childId?: InputMaybe<Scalars['ChildId']>;
  institutionSetId?: InputMaybe<Scalars['InstitutionSetId']>;
};


/** Queries and objects related to medication forms */
export type MedicationFormsemployeeWitnessesArgs = {
  siteId: Scalars['SiteId'];
};


/** Queries and objects related to medication forms */
export type MedicationFormshasDailyInputsArgs = {
  siteId: Scalars['SiteId'];
};


/** Queries and objects related to medication forms */
export type MedicationFormslistMedicationFormsArgs = {
  after?: InputMaybe<Scalars['MedicationFormCursor']>;
  authors?: InputMaybe<Array<Scalars['LoginId']>>;
  childIds?: InputMaybe<Array<Scalars['ChildId']>>;
  groupIds?: InputMaybe<Array<Scalars['GroupId']>>;
  ids?: InputMaybe<Array<Scalars['MedicationFormId']>>;
  institutionIds?: InputMaybe<Array<Scalars['InstitutionId']>>;
  missingAcknowledgements?: InputMaybe<Array<SignedAs>>;
  missingEmployeeAcknowledgement?: InputMaybe<Scalars['Boolean']>;
  missingParentAcknowledgement?: InputMaybe<Scalars['Boolean']>;
  onlyActive?: Scalars['Boolean'];
  onlyInactive?: Scalars['Boolean'];
  withinRange?: InputMaybe<DateRangeInput>;
};


/** Queries and objects related to medication forms */
export type MedicationFormstermsAndConditionsArgs = {
  siteSetId: Scalars['SiteSetId'];
};

export type MedicationFormsMutations = {
  __typename?: 'MedicationFormsMutations';
  /** Acknowledges the given medication form for the current user. */
  acknowledge: FormAcknowledgement;
  acknowledgeAdministeredMedication: AdministeredMedicationAcknowledgement;
  addDailyUpdate: DailyMedicationFormUpdate;
  administerMedication: AdministeredMedication;
  create: MedicationForm;
  deactivate: MedicationForm;
  /**
   * Note that it is *not* allowed to change the *appliesToChild* nor the *genericFormTemplateVersionId*.
   * As such these values on the *input* argument will be ignored.
   *
   */
  edit: MedicationForm;
  /** Set, update or delete the terms and conditions link for a siteSet */
  updateTermsAndConditionsLink: TermsAndConditionsLinkResult;
  /** Withdraws a previously given acknowledgement. */
  withdrawAcknowledgement: FormAcknowledgement;
};


export type MedicationFormsMutationsacknowledgeArgs = {
  medicationFormId: Scalars['MedicationFormId'];
  type: SignedAs;
};


export type MedicationFormsMutationsacknowledgeAdministeredMedicationArgs = {
  administeredMedicationId: Scalars['AdministeredMedicationId'];
  inCapacityOf: SignedAs;
};


export type MedicationFormsMutationsaddDailyUpdateArgs = {
  day?: InputMaybe<Scalars['LocalDate']>;
  lastAdministeredAt?: InputMaybe<Scalars['LocalDateTime']>;
  medicationFormId: Scalars['MedicationFormId'];
  notes?: InputMaybe<Scalars['String']>;
  times: Array<Scalars['LocalTime']>;
};


export type MedicationFormsMutationsadministerMedicationArgs = {
  administeredAt?: InputMaybe<Scalars['LocalDateTime']>;
  comment?: InputMaybe<Scalars['String']>;
  doseGiven: Scalars['BigDecimal'];
  doseUnit: Scalars['String'];
  medicationFormId: Scalars['MedicationFormId'];
  scheduledAt?: InputMaybe<Scalars['LocalTime']>;
  witnesses?: InputMaybe<Array<Scalars['EmployeeId']>>;
};


export type MedicationFormsMutationscreateArgs = {
  input: MedicationFormInput;
};


export type MedicationFormsMutationsdeactivateArgs = {
  id: Scalars['MedicationFormId'];
};


export type MedicationFormsMutationseditArgs = {
  id: Scalars['MedicationFormId'];
  input: MedicationFormInput;
};


export type MedicationFormsMutationsupdateTermsAndConditionsLinkArgs = {
  link?: InputMaybe<Scalars['String']>;
  siteSetId: Scalars['SiteSetId'];
};


export type MedicationFormsMutationswithdrawAcknowledgementArgs = {
  acknowledgementId: Scalars['SignatureId'];
};

export type MedicationTodayWidgetElement = {
  __typename?: 'MedicationTodayWidgetElement';
  form: MedicationForm;
  overDue: Scalars['Boolean'];
  scheduledAt: Scalars['LocalTime'];
};

export type MedicationTodayWidgetType = Widget & {
  __typename?: 'MedicationTodayWidgetType';
  elements: Array<MedicationTodayWidgetElement>;
  id: Scalars['HomeWidgetId'];
  /** @deprecated Does not hold enough information. Use 'elements' instead for full information */
  medicationForms: Array<MedicationForm>;
  next?: Maybe<Scalars['HomeWidgetCursor']>;
  title: Scalars['String'];
  widgetId: Scalars['String'];
};

/** Queries related to messages */
export type Messages = {
  __typename?: 'Messages';
  conversationSettings: ConversationSettings;
  possibleRecipients: PossibleRecipientsResult;
  staffToStaffConversations: StaffToStaffConversations;
};


/** Queries related to messages */
export type MessagespossibleRecipientsArgs = {
  after?: InputMaybe<Scalars['PossibleRecipientCursor']>;
  inboxType?: InputMaybe<InboxType>;
};

export type MilkReportFeatureSettingsFlags = {
  __typename?: 'MilkReportFeatureSettingsFlags';
  /** Returns true if exporting the milk report CSV is enabled for this siteSet. */
  enabled: Scalars['Boolean'];
};

export type MilkReportQueryType = {
  __typename?: 'MilkReportQueryType';
  /** Returns the URL to fetch csv milk report. SiteSetId and LocalDate 'from' and 'to' must be specified. If no values are set for 'exclude2hSessions' and 'excludeAbsences' they will default to false. */
  csvExportURL: Scalars['String'];
};


export type MilkReportQueryTypecsvExportURLArgs = {
  exclude2hSessions?: InputMaybe<Scalars['Boolean']>;
  excludeAbsences?: InputMaybe<Scalars['Boolean']>;
  from: Scalars['LocalDate'];
  siteSetId: Scalars['InstitutionSetId'];
  to: Scalars['LocalDate'];
};

/** For all things where we want to do something different when user is on the mobile app */
export type MobileApp = {
  __typename?: 'MobileApp';
  magicLink: MagicLink;
};

export type MobileAppMutations = {
  __typename?: 'MobileAppMutations';
  /**
   * Create a magic link for the url provided
   * @deprecated Use me/requestToken endpoint instead
   */
  createMobileMagicLink: Scalars['String'];
};


export type MobileAppMutationscreateMobileMagicLinkArgs = {
  redirectUrl: Scalars['String'];
};

/** Monthly automatic invoicing configuration */
export type MonthlyInvoicingConfig = {
  __typename?: 'MonthlyInvoicingConfig';
  exactDay?: Maybe<Scalars['Int']>;
  option: MonthlyInvoicingOptions;
};

/** Monthly automatic invoicing configuration */
export type MonthlyInvoicingConfigInput = {
  exactDay?: InputMaybe<Scalars['Int']>;
  option: MonthlyInvoicingOptions;
};

export enum MonthlyInvoicingOptions {
  EXACT_DAY_OF_MONTH = 'EXACT_DAY_OF_MONTH',
  FIRST_WEEK_DAY_OF_MONTH = 'FIRST_WEEK_DAY_OF_MONTH',
  LAST_WEEK_DAY_OF_MONTH = 'LAST_WEEK_DAY_OF_MONTH'
}

export type Mutation = {
  __typename?: 'Mutation';
  accidentReports: AccidentReportsMutations;
  addNewSite: AddNewSiteMutations;
  attendance: AttendanceMutations;
  billPayers: BillPayerMutations;
  categoryLandingPage: CategoryLandingPageMutation;
  categoryOnboarding: CategoryOnboardingMutation;
  /** For creating and updating child contacts or role invitations */
  childContacts: ContactsMutation;
  childDevelopment: ChildDevelopmentMutation;
  children: ChildMutation;
  contact: ContactResult;
  conversations: ConversationsMutations;
  createNewSite: CreateNewSiteMutations;
  dataExports: DataExportsMutations;
  datev: DatevMutation;
  dismiss: DismissItem;
  documents: DocumentsMutations;
  /** For managing employees */
  employees: EmployeeMutations;
  facebook: FacebookIntegrationMutation;
  featureStore: FeatureStoreMutations;
  finance: FinanceMutation;
  genericForms: GenericFormsMutations;
  /** For managing groups (rooms) */
  groups: GroupMutations;
  headcount: HeadcountMutations;
  home: HomeMutations;
  immunizations: ImmunizationMutations;
  import: ImportMutation;
  inAppPurchase: InAppPurchaseMutations;
  institutions: InstitutionsMutation;
  kibig: KibigMutation;
  kinderConnect: KinderConnectMutations;
  kitaPlaner: KitaPlanerMutation;
  logins: LoginMutation;
  managedFeatures: ManagedFeaturesMutation;
  me: MeMutation;
  mealPlans: MealPlansMutations;
  meals: MealsMutations;
  /** Mutations for tagging entities like children */
  mediaTagging: MediaTaggingMutation;
  medicationForms: MedicationFormsMutations;
  oidc: OIDCMutation;
  openingHours: OpeningHoursMutations;
  organizations: OrganizationMutation;
  outOfOfficeMutations: OutOfOfficeMutations;
  paragon: ParagonMutation;
  payments: PaymentsMutation;
  qrSignin: QRSigninMutation;
  reports: ReportMutations;
  /** Resyncs all contacts in the given site set ID */
  resyncContacts: Array<Scalars['ContactId']>;
  roles: RolesMutations;
  rss: RssIntegrationMutation;
  sales: SalesMutationType;
  security: SecurityMutation;
  selfsignup: SelfSignupV1Mutation;
  settings: SettingsMutations;
  sidekick: SidekickMutation;
  signup: SignupMutationType;
  sms: SMSMutations;
  staffQualifications: StaffQualificationMutations;
  staffhours: StaffHoursMutation;
  subscriptions: SubscriptionMutations;
  testChildAction: TestChildActionMutations;
  translation: TranslationMutations;
  upgradeFromFreePackage: UpgradeFromFreePackageMutations;
  upgradeFromPaidPackage: UpgradePackageMutations;
  usageHistory: UsageHistoryMutations;
  userGenerated: UserGeneratedMutations;
  village: VillageMutations;
  watchMeGrow: WatchMeGrowMutation;
  webhooks: WebhookMutations;
};


export type MutationcategoryLandingPageArgs = {
  categoryArg?: InputMaybe<Category>;
};


export type MutationcontactArgs = {
  contactType: ContactType;
  institutionSetId?: InputMaybe<Scalars['InstitutionSetId']>;
  note?: InputMaybe<Scalars['String']>;
  withFallbackSiteAssociation?: InputMaybe<Scalars['Boolean']>;
};


export type MutationresyncContactsArgs = {
  siteSetId: Scalars['SiteSetId'];
};

/** Top level object for my calendar */
export type MyCalendar = {
  __typename?: 'MyCalendar';
  /** Whether or not my calendar is enabled */
  isEnabled: Scalars['Boolean'];
};

/** A person's name */
export type Name = {
  __typename?: 'Name';
  firstName: Scalars['String'];
  fullName: Scalars['String'];
  lastName?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
};

/** Sleep status (nap) */
export type NapType = {
  __typename?: 'NapType';
  sleepStatus: SleepStatus;
};

export type Navigation = {
  __typename?: 'Navigation';
  items: Array<NavigationItem>;
  /** SiteSet information with additional information about the possible `enabledFor` elements within `lists` */
  siteSets: Array<InstitutionSet>;
};

/** None */
export type NavigationItem = {
  /** The sites that are available */
  enabledFor: Array<InstitutionSetInfo>;
  /** The ID of the navigation item */
  id: Scalars['String'];
};

export type NavigationItemAttendanceLandingPage = NavigationItem & {
  __typename?: 'NavigationItemAttendanceLandingPage';
  /** The sites that are available */
  enabledFor: Array<InstitutionSetInfo>;
  /** The ID of the navigation item */
  id: Scalars['String'];
  isDismissed: Scalars['Boolean'];
  isRemovable: Scalars['Boolean'];
};

export type NavigationItemAttendanceReports = NavigationItem & {
  __typename?: 'NavigationItemAttendanceReports';
  /** The sites that are available */
  enabledFor: Array<InstitutionSetInfo>;
  /** The ID of the navigation item */
  id: Scalars['String'];
};

export type NavigationItemBillPayers = NavigationItem & {
  __typename?: 'NavigationItemBillPayers';
  billPayers: Array<BillPayerDataType>;
  /** The sites that are available */
  enabledFor: Array<InstitutionSetInfo>;
  /** The ID of the navigation item */
  id: Scalars['String'];
  /** Needed to construct the account/balances route when there is more than one bill payer */
  loginId: Scalars['LoginId'];
};

export type NavigationItemChildBasedFundingReport = NavigationItem & {
  __typename?: 'NavigationItemChildBasedFundingReport';
  /** The sites that are available */
  enabledFor: Array<InstitutionSetInfo>;
  /** The ID of the navigation item */
  id: Scalars['String'];
};

export type NavigationItemChildren = NavigationItem & {
  __typename?: 'NavigationItemChildren';
  childIds: Array<Scalars['ChildId']>;
  /** The sites that are available */
  enabledFor: Array<InstitutionSetInfo>;
  /** The ID of the navigation item */
  id: Scalars['String'];
};

export type NavigationItemChildrenLandingPage = NavigationItem & {
  __typename?: 'NavigationItemChildrenLandingPage';
  /** The sites that are available */
  enabledFor: Array<InstitutionSetInfo>;
  /** The ID of the navigation item */
  id: Scalars['String'];
  isDismissed: Scalars['Boolean'];
  isRemovable: Scalars['Boolean'];
};

export type NavigationItemCustomForms = NavigationItem & {
  __typename?: 'NavigationItemCustomForms';
  /** The sites that are available */
  enabledFor: Array<InstitutionSetInfo>;
  /** The ID of the navigation item */
  id: Scalars['String'];
};

export type NavigationItemDataManagement = NavigationItem & {
  __typename?: 'NavigationItemDataManagement';
  /** The sites that are available */
  enabledFor: Array<InstitutionSetInfo>;
  /** The ID of the navigation item */
  id: Scalars['String'];
};

export type NavigationItemFeatureStore = NavigationItem & {
  __typename?: 'NavigationItemFeatureStore';
  /** The sites that are available */
  enabledFor: Array<InstitutionSetInfo>;
  /** The ID of the navigation item */
  id: Scalars['String'];
};

export type NavigationItemFinanceLandingPage = NavigationItem & {
  __typename?: 'NavigationItemFinanceLandingPage';
  /** The sites that are available */
  enabledFor: Array<InstitutionSetInfo>;
  /** The ID of the navigation item */
  id: Scalars['String'];
  isDismissed: Scalars['Boolean'];
  isRemovable: Scalars['Boolean'];
};

export type NavigationItemFinanceReports = NavigationItem & {
  __typename?: 'NavigationItemFinanceReports';
  /** The sites that are available */
  enabledFor: Array<InstitutionSetInfo>;
  /** The ID of the navigation item */
  id: Scalars['String'];
};

export type NavigationItemGetStarted = NavigationItem & {
  __typename?: 'NavigationItemGetStarted';
  /** The sites that are available */
  enabledFor: Array<InstitutionSetInfo>;
  /** The ID of the navigation item */
  id: Scalars['String'];
};

export type NavigationItemHome = NavigationItem & {
  __typename?: 'NavigationItemHome';
  /** The sites that are available */
  enabledFor: Array<InstitutionSetInfo>;
  /** The ID of the navigation item */
  id: Scalars['String'];
};

export type NavigationItemKinderConnect = NavigationItem & {
  __typename?: 'NavigationItemKinderConnect';
  /** The sites that are available */
  enabledFor: Array<InstitutionSetInfo>;
  /** The ID of the navigation item */
  id: Scalars['String'];
};

export type NavigationItemLearningLandingPage = NavigationItem & {
  __typename?: 'NavigationItemLearningLandingPage';
  /** The sites that are available */
  enabledFor: Array<InstitutionSetInfo>;
  /** The ID of the navigation item */
  id: Scalars['String'];
  isDismissed: Scalars['Boolean'];
  isRemovable: Scalars['Boolean'];
};

export type NavigationItemLearningReports = NavigationItem & {
  __typename?: 'NavigationItemLearningReports';
  /** The sites that are available */
  enabledFor: Array<InstitutionSetInfo>;
  /** The ID of the navigation item */
  id: Scalars['String'];
};

export type NavigationItemManageOrganizationSecurity = NavigationItem & {
  __typename?: 'NavigationItemManageOrganizationSecurity';
  /** The sites that are available */
  enabledFor: Array<InstitutionSetInfo>;
  /** The ID of the navigation item */
  id: Scalars['String'];
};

export type NavigationItemMealPlan = NavigationItem & {
  __typename?: 'NavigationItemMealPlan';
  /** The sites that are available */
  enabledFor: Array<InstitutionSetInfo>;
  /** The ID of the navigation item */
  id: Scalars['String'];
};

export type NavigationItemNewsFeed = NavigationItem & {
  __typename?: 'NavigationItemNewsFeed';
  /** The sites that are available */
  enabledFor: Array<InstitutionSetInfo>;
  /** The ID of the navigation item */
  id: Scalars['String'];
};

export type NavigationItemReports = NavigationItem & {
  __typename?: 'NavigationItemReports';
  /** The sites that are available */
  enabledFor: Array<InstitutionSetInfo>;
  /** The ID of the navigation item */
  id: Scalars['String'];
};

export type NavigationItemShiftPlanner = NavigationItem & {
  __typename?: 'NavigationItemShiftPlanner';
  /** The sites that are available */
  enabledFor: Array<InstitutionSetInfo>;
  /** The ID of the navigation item */
  id: Scalars['String'];
};

export type NavigationItemStaffAttendancePage = NavigationItem & {
  __typename?: 'NavigationItemStaffAttendancePage';
  /** The sites that are available */
  enabledFor: Array<InstitutionSetInfo>;
  /** The ID of the navigation item */
  id: Scalars['String'];
};

export type NavigationItemStaffHoursPage = NavigationItem & {
  __typename?: 'NavigationItemStaffHoursPage';
  /** The sites that are available */
  enabledFor: Array<InstitutionSetInfo>;
  /** The ID of the navigation item */
  id: Scalars['String'];
};

export type NavigationItemStaffLeavePage = NavigationItem & {
  __typename?: 'NavigationItemStaffLeavePage';
  /** The sites that are available */
  enabledFor: Array<InstitutionSetInfo>;
  /** The ID of the navigation item */
  id: Scalars['String'];
};

export type NavigationItemStaffRatioReport = NavigationItem & {
  __typename?: 'NavigationItemStaffRatioReport';
  /** The sites that are available */
  enabledFor: Array<InstitutionSetInfo>;
  /** The ID of the navigation item */
  id: Scalars['String'];
};

export type NavigationItemTemplates = NavigationItem & {
  __typename?: 'NavigationItemTemplates';
  /** The sites that are available */
  enabledFor: Array<InstitutionSetInfo>;
  /** The ID of the navigation item */
  id: Scalars['String'];
};

export type NavigationItemType = {
  __typename?: 'NavigationItemType';
  children: Array<NavigationItemType>;
  id: Scalars['NavigationItemId'];
  inView: Scalars['Boolean'];
  isCustomizable: Scalars['Boolean'];
  name: Scalars['String'];
  order: Scalars['Int'];
};

export type NavigationMutation = {
  __typename?: 'NavigationMutation';
  items: ItemsMutationType;
};

export type NavigationViewType = {
  __typename?: 'NavigationViewType';
  children: Array<NavigationItemType>;
  id: Scalars['NavigationViewId'];
  name: Scalars['String'];
};

export type NewsFeed = {
  __typename?: 'NewsFeed';
  from: Scalars['String'];
  noPaymentsReceivedMessage: Scalars['String'];
  recipients: Array<Scalars['String']>;
  reminderMessage: Scalars['String'];
};

export type Newsfeed = {
  __typename?: 'Newsfeed';
  /**
   * Controls gradual rollout of rich text in newsfeed.
   * @deprecated Rich-text is rolled out globally, the field is not needed anymore.
   */
  canUseRichText: Scalars['Boolean'];
};

export type NextTestChildAction = {
  __typename?: 'NextTestChildAction';
  actionId: TestChildActionId;
  childId: Scalars['ChildId'];
  siteId: Scalars['SiteId'];
};

export type NextTestChildActionV5 = {
  __typename?: 'NextTestChildActionV5';
  actionId: TestChildActionId;
  childId: Scalars['ChildId'];
  siteId: Scalars['SiteId'];
};

export type NoContextTarget = {
  __typename?: 'NoContextTarget';
  /** This field might contain any string and should not be used for anything. The type alone should decide the action. */
  name: Scalars['String'];
};

export type NoFiguresToShow = {
  __typename?: 'NoFiguresToShow';
  reason: ReasonToNotShowValues;
};

export type NoVerification = RoleInvitationVerification & {
  __typename?: 'NoVerification';
  verificationMethod: RoleInvitationVerificationMethod;
};

export type NonEmptyLocalDateRange = {
  __typename?: 'NonEmptyLocalDateRange';
  from: Scalars['LocalDate'];
  to?: Maybe<Scalars['LocalDate']>;
};

export type NonEmptyLocalDateRangeInput = {
  from: Scalars['LocalDate'];
  to?: InputMaybe<Scalars['LocalDate']>;
};

export type NonEmptyLocalDateTimeRangeInput = {
  from: Scalars['LocalDateTime'];
  to?: InputMaybe<Scalars['LocalDateTime']>;
};

export type NotSynced = SynchronizationStatus & {
  __typename?: 'NotSynced';
  /** The last time a synchronization was attempted */
  lastSyncTime?: Maybe<Scalars['ZonedDateTime']>;
};

export type NumberOfDraftShiftsType = {
  __typename?: 'NumberOfDraftShiftsType';
  allWeeks: Scalars['Int'];
  inDateRange: Scalars['Int'];
};

export type NumericFieldValue = GenericFormFieldValue & {
  __typename?: 'NumericFieldValue';
  fieldTemplate: GenericFormFieldTemplate;
  fieldTemplateId: Scalars['GenericFormFieldTemplateId'];
  fieldType: GenericFormFieldType;
  fieldValueId: Scalars['GenericFormFieldValueId'];
  numberValue: Scalars['BigDecimal'];
  valueAsString: Scalars['String'];
};

/** Manipulate OIDC providers */
export type OIDCMutation = {
  __typename?: 'OIDCMutation';
  /** Create a new provider */
  createProvider: OpenIDProvider;
};


/** Manipulate OIDC providers */
export type OIDCMutationcreateProviderArgs = {
  baseURI: Scalars['URI'];
  clientId: Scalars['String'];
  clientSecret: Scalars['String'];
  institutionSetId: Scalars['InstitutionSetId'];
  required: Scalars['Boolean'];
  title: Scalars['String'];
};

export type Observation = {
  __typename?: 'Observation';
  behaviors: Array<Behavior>;
  /** Whether or not the user can report this observation */
  canReport: Scalars['Boolean'];
  /** @deprecated Use the children field instead. */
  child?: Maybe<Child>;
  children: Array<PublicChild>;
  comments: ObservationComments;
  createdBy: Person;
  /**
   *
   *  The feed item that is associated with this observation for the currently logged in
   *  user.
   *
   */
  feedItem?: Maybe<FeedItem>;
  /** The files that are attached to the observation, if any */
  files: Array<File>;
  id: Scalars['String'];
  /** The images that are attached to the observation, if any */
  images: Array<Image>;
  /** Likes for this observation */
  likes: Likes;
  nextStep?: Maybe<ChildDevelopmentObservationRemark>;
  remark: ChildDevelopmentObservationRemark;
  reviewComments: ObservationReviewComments;
  settings?: Maybe<ObservationSettings>;
  /** The most recent status */
  status: ObservationStatus;
  /** A collection of all the statuses the observation has had */
  statuses: Array<ObservationStatus>;
  variant: ObservationVariant;
  version: ObservationVersion;
  /**
   * The video that is attached to the observation, if any
   * @deprecated Use the videos field instead.
   */
  video?: Maybe<Video>;
  /** The videos that are attached to the observation, if any */
  videos: Array<Video>;
};

export type ObservationComments = {
  __typename?: 'ObservationComments';
  count: Scalars['Int'];
  results: Array<Comment>;
};

export type ObservationCount = AreaReport & {
  __typename?: 'ObservationCount';
  area: Area;
  count: Scalars['Int'];
  observationIds: Array<Scalars['ObservationId']>;
  subTitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type ObservationCountInfo = {
  __typename?: 'ObservationCountInfo';
  total: Scalars['Int'];
  withLinkToTopLevelArea: Scalars['Int'];
  withoutLinks: Scalars['Int'];
};

export type ObservationDraftsWidgetType = Widget & {
  __typename?: 'ObservationDraftsWidgetType';
  id: Scalars['HomeWidgetId'];
  next?: Maybe<Scalars['HomeWidgetCursor']>;
  observations: Array<Observation>;
  title: Scalars['String'];
  version: ObservationVersion;
  widgetId: Scalars['String'];
};

export type ObservationMutation = {
  __typename?: 'ObservationMutation';
  copyObservations: CopyObservationsResult;
  createObservation: Observation;
  deleteObservations: Array<Scalars['ObservationId']>;
  /** Sets the status of *all* the provided next-steps to *newStatus*. If *newStatus* is omitted or *null*, then the remarks will have their status removed. Any provided ids which are not next-steps will be ignored. */
  setNextStepStatus: Array<ChildDevelopmentObservationRemark>;
  stealObservation: Array<Observation>;
};


export type ObservationMutationcopyObservationsArgs = {
  fromChildId: Scalars['ChildId'];
  toChildId: Scalars['ChildId'];
};


export type ObservationMutationcreateObservationArgs = {
  childId?: InputMaybe<Scalars['ChildId']>;
  childIds?: InputMaybe<Array<Scalars['ChildId']>>;
  fileIds?: InputMaybe<Array<Scalars['FileId']>>;
  imageIds?: InputMaybe<Array<Scalars['ImageId']>>;
  nextStep?: InputMaybe<ChildDevelopmentRemarkInput>;
  observationId?: InputMaybe<Scalars['ObservationId']>;
  remark: ChildDevelopmentRemarkInput;
  settings?: InputMaybe<ObservationSettingsInput>;
  status: ObservationStatusState;
  variant?: InputMaybe<ObservationVariant>;
  version?: InputMaybe<ObservationVersion>;
  videoId?: InputMaybe<Scalars['VideoId']>;
};


export type ObservationMutationdeleteObservationsArgs = {
  observationIds: Array<Scalars['ObservationId']>;
};


export type ObservationMutationsetNextStepStatusArgs = {
  newStatus?: InputMaybe<ObservationRemarkStatus>;
  nextStepIds: Array<Scalars['RemarkId']>;
};


export type ObservationMutationstealObservationArgs = {
  observationIds: Array<Scalars['ObservationId']>;
};

/** The sorting order used when listing observations */
export enum ObservationOrdering {
  DATE_ASCENDING = 'DATE_ASCENDING',
  DATE_DESCENDING = 'DATE_DESCENDING'
}

/** The state that an observation remark can be in. */
export enum ObservationRemarkStatus {
  COMPLETED = 'COMPLETED',
  NOT_COMPLETED = 'NOT_COMPLETED'
}

export type ObservationResult = {
  __typename?: 'ObservationResult';
  next?: Maybe<Scalars['ObservationCursor']>;
  results: Array<Observation>;
};

export type ObservationReviewComments = {
  __typename?: 'ObservationReviewComments';
  count: Scalars['Int'];
  results: Array<Comment>;
};

export type ObservationSettings = {
  __typename?: 'ObservationSettings';
  assessmentSetting?: Maybe<AssessmentSettings>;
};

export type ObservationSettingsInput = {
  assessmentSettingId?: InputMaybe<Scalars['AssessmentSettingsId']>;
};

export type ObservationStatus = {
  __typename?: 'ObservationStatus';
  createdAt: Scalars['ZonedDateTime'];
  createdBy: Person;
  state: ObservationStatusState;
};

/** The state a status can be in */
export enum ObservationStatusState {
  APPROVED = 'APPROVED',
  CHANGES_REQUESTED = 'CHANGES_REQUESTED',
  DRAFT = 'DRAFT',
  PENDING_REVIEW = 'PENDING_REVIEW',
  SENT = 'SENT'
}

export enum ObservationType {
  ASSESSMENT = 'ASSESSMENT',
  OBSERVATION = 'OBSERVATION'
}

/** The variant of the observation */
export enum ObservationVariant {
  ASSESSMENT = 'ASSESSMENT',
  PARENT_OBSERVATION = 'PARENT_OBSERVATION',
  REGULAR_OBSERVATION = 'REGULAR_OBSERVATION',
  TWO_YEAR_PROGRESS = 'TWO_YEAR_PROGRESS',
  /**
   *
   *  When an observation uses the UP_TO_SPEED_OBSERVATION variant it won't produce
   *  feed items.
   *
   */
  UP_TO_SPEED_OBSERVATION = 'UP_TO_SPEED_OBSERVATION'
}

export type ObservationVariantFilter = {
  __typename?: 'ObservationVariantFilter';
  default: Scalars['Boolean'];
  variant: ObservationVariant;
};

export enum ObservationVersion {
  EYFS_2021_REVISION = 'EYFS_2021_REVISION',
  REGULAR = 'REGULAR'
}

export type OccupancyStats = {
  __typename?: 'OccupancyStats';
  fraction: Scalars['Float'];
  percentage: Scalars['Float'];
};

/** Annual payment */
export type OfferBetaAnnualPaymentType = {
  __typename?: 'OfferBetaAnnualPaymentType';
  amount: Scalars['String'];
};

/** The customer receiving the offer */
export type OfferBetaCustomerType = {
  __typename?: 'OfferBetaCustomerType';
  name: Scalars['String'];
};

/** Monthly payment */
export type OfferBetaMonthlyPaymentType = {
  __typename?: 'OfferBetaMonthlyPaymentType';
  amount: Scalars['String'];
};

/** Mutations that can be performed on an offer */
export type OfferBetaMutationType = {
  __typename?: 'OfferBetaMutationType';
  accept: Scalars['String'];
};


/** Mutations that can be performed on an offer */
export type OfferBetaMutationTypeacceptArgs = {
  opportunityId: Scalars['String'];
};

/** The package specifications of the offer */
export type OfferBetaPackageType = {
  __typename?: 'OfferBetaPackageType';
  billingStartDate: Scalars['String'];
  numberOfSites?: Maybe<Scalars['Int']>;
  parentPayments: Scalars['Boolean'];
  paymentTerms: Scalars['String'];
  plan: Scalars['String'];
  price: Scalars['String'];
};

/** Union of the available payment types */
export type OfferBetaPaymentType = OfferBetaAnnualPaymentType | OfferBetaMonthlyPaymentType;

/** The package specifications of the offer */
export type OfferBetaPriceType = {
  __typename?: 'OfferBetaPriceType';
  annualPayment?: Maybe<Scalars['String']>;
  annualUpfrontDiscount?: Maybe<Scalars['String']>;
  monthlyDiscount?: Maybe<Scalars['String']>;
  monthlyPayment?: Maybe<Scalars['String']>;
  monthlySubtotal: Scalars['String'];
  monthlyTotal: Scalars['String'];
  payment: OfferBetaPaymentType;
  vat: Scalars['String'];
  vatPercentage: Scalars['String'];
};

/** An offer for a new customer */
export type OfferBetaType = {
  __typename?: 'OfferBetaType';
  customer: OfferBetaCustomerType;
  package: OfferBetaPackageType;
  price: OfferBetaPriceType;
};

/** Versioning node for offer mutations */
export type OfferMutationType = {
  __typename?: 'OfferMutationType';
  /** @deprecated New version available */
  beta: OfferBetaMutationType;
  /** @deprecated New version available */
  rc1: OfferRC1MutationType;
  v1: OfferV1MutationType;
};

/** Annual payment */
export type OfferRC1AnnualPaymentType = {
  __typename?: 'OfferRC1AnnualPaymentType';
  amount: Scalars['String'];
};

/** Information about the temporary discount (special offer) bundled with the offer */
export type OfferRC1DiscountType = {
  __typename?: 'OfferRC1DiscountType';
  months?: Maybe<Scalars['Int']>;
  percentage?: Maybe<Scalars['Int']>;
};

/** Monthly payment */
export type OfferRC1MonthlyPaymentType = {
  __typename?: 'OfferRC1MonthlyPaymentType';
  amount: Scalars['String'];
};

/** Mutations that can be performed on an offer */
export type OfferRC1MutationType = {
  __typename?: 'OfferRC1MutationType';
  accept: Scalars['String'];
};


/** Mutations that can be performed on an offer */
export type OfferRC1MutationTypeacceptArgs = {
  opportunityId: Scalars['String'];
};

/** Union of the available payment types */
export type OfferRC1PaymentType = OfferRC1AnnualPaymentType | OfferRC1MonthlyPaymentType;

/** The package specifications of the offer */
export type OfferRC1PriceType = {
  __typename?: 'OfferRC1PriceType';
  annualPayment?: Maybe<Scalars['String']>;
  annualUpfrontDiscount?: Maybe<Scalars['String']>;
  monthlyDiscount?: Maybe<Scalars['String']>;
  monthlyPayment?: Maybe<Scalars['String']>;
  monthlySubtotal: Scalars['String'];
  monthlyTotal: Scalars['String'];
  /** @deprecated Use `annualPayment` or `monthlyPayment` instead */
  payment: OfferRC1PaymentType;
  vat: Scalars['String'];
  vatPercentage: Scalars['String'];
};

/** An offer for a new customer */
export type OfferRC1Type = {
  __typename?: 'OfferRC1Type';
  customer: OfferBetaCustomerType;
  discount: OfferRC1DiscountType;
  package: OfferBetaPackageType;
  price: OfferRC1PriceType;
};

/** Versioning node for offer queries */
export type OfferType = {
  __typename?: 'OfferType';
  /** @deprecated New version available */
  beta: OfferBetaType;
  /** @deprecated New version available */
  rc1: OfferRC1Type;
  v1: OfferV1Type;
};

/** Annual payment */
export type OfferV1AnnualPaymentType = {
  __typename?: 'OfferV1AnnualPaymentType';
  amount: Scalars['String'];
};

/** The configuration of the offer */
export type OfferV1ConfigType = {
  __typename?: 'OfferV1ConfigType';
  timezones: Array<OfferV1TimezoneWithLabelType>;
  tosLink: Scalars['String'];
};

/** The customer receiving the offer */
export type OfferV1CustomerType = {
  __typename?: 'OfferV1CustomerType';
  name: Scalars['String'];
};

/** Information about the temporary discount (special offer) bundled with the offer */
export type OfferV1DiscountType = {
  __typename?: 'OfferV1DiscountType';
  months?: Maybe<Scalars['Int']>;
  percentage?: Maybe<Scalars['Int']>;
};

/** Monthly payment */
export type OfferV1MonthlyPaymentType = {
  __typename?: 'OfferV1MonthlyPaymentType';
  amount: Scalars['String'];
};

/** Mutations that can be performed on an offer */
export type OfferV1MutationType = {
  __typename?: 'OfferV1MutationType';
  accept: Scalars['String'];
};


/** Mutations that can be performed on an offer */
export type OfferV1MutationTypeacceptArgs = {
  opportunityId: Scalars['String'];
  timezone: Scalars['ZoneId'];
};

/** The package specifications of the offer */
export type OfferV1PackageType = {
  __typename?: 'OfferV1PackageType';
  billingStartDate: Scalars['String'];
  numberOfSites?: Maybe<Scalars['Int']>;
  parentPayments: Scalars['Boolean'];
  paymentTerms: Scalars['String'];
  plan: Scalars['String'];
  price: Scalars['String'];
};

/** Union of the available payment types */
export type OfferV1PaymentType = OfferV1AnnualPaymentType | OfferV1MonthlyPaymentType;

/** The package specifications of the offer */
export type OfferV1PriceType = {
  __typename?: 'OfferV1PriceType';
  annualPayment?: Maybe<Scalars['String']>;
  annualUpfrontDiscount?: Maybe<Scalars['String']>;
  monthlyDiscount?: Maybe<Scalars['String']>;
  monthlyPayment?: Maybe<Scalars['String']>;
  monthlySubtotal: Scalars['String'];
  monthlyTotal: Scalars['String'];
  /** @deprecated Use `annualPayment` or `monthlyPayment` instead */
  payment: OfferV1PaymentType;
  vat: Scalars['String'];
  vatPercentage: Scalars['String'];
};

/** The timezone of the offer that user can select */
export type OfferV1TimezoneWithLabelType = {
  __typename?: 'OfferV1TimezoneWithLabelType';
  label: Scalars['String'];
  value: Scalars['ZoneId'];
};

/** An offer for a new customer */
export type OfferV1Type = {
  __typename?: 'OfferV1Type';
  acceptedAt?: Maybe<Scalars['String']>;
  config: OfferV1ConfigType;
  customer: OfferV1CustomerType;
  discount: OfferV1DiscountType;
  package: OfferV1PackageType;
  price: OfferV1PriceType;
};

export type OldFreeMigrationNoticeBanner = {
  __typename?: 'OldFreeMigrationNoticeBanner';
  bannerCopy: Scalars['String'];
  ctaCopy: Scalars['String'];
  ctaLink: Scalars['String'];
};

/** Onboarding mutations for a site set */
export type OnboardingGQLBetaMutationType = {
  __typename?: 'OnboardingGQLBetaMutationType';
  complete: Scalars['Boolean'];
};


/** Onboarding mutations for a site set */
export type OnboardingGQLBetaMutationTypecompleteArgs = {
  siteSetId: Scalars['SiteSetId'];
};

/** Payments setup step payload */
export type OnboardingGQLBetaPaymentsSetupStepPayloadType = {
  __typename?: 'OnboardingGQLBetaPaymentsSetupStepPayloadType';
  billPayerId: Scalars['BillPayerId'];
};

/** Payments setup step */
export type OnboardingGQLBetaPaymentsSetupStepType = {
  __typename?: 'OnboardingGQLBetaPaymentsSetupStepType';
  isCompleted: Scalars['Boolean'];
  payload: OnboardingGQLBetaPaymentsSetupStepPayloadType;
};

/** Union of the possible onboarding steps */
export type OnboardingGQLBetaStepType = OnboardingGQLBetaPaymentsSetupStepType | OnboardingGQLBetaWelcomeCallStepType;

/** Onboarding information for a site set */
export type OnboardingGQLBetaType = {
  __typename?: 'OnboardingGQLBetaType';
  isCompleted: Scalars['Boolean'];
  siteSetId: Scalars['SiteSetId'];
  steps: Array<OnboardingGQLBetaStepType>;
};

/** Welcome call step payload */
export type OnboardingGQLBetaWelcomeCallStepPayloadType = {
  __typename?: 'OnboardingGQLBetaWelcomeCallStepPayloadType';
  prefillable: OnboardingGQLBetaWelcomeCallStepPrefillableType;
  schedulingUrl: Scalars['String'];
};

/** Welcome call step prefillable */
export type OnboardingGQLBetaWelcomeCallStepPrefillableType = {
  __typename?: 'OnboardingGQLBetaWelcomeCallStepPrefillableType';
  customQuestions: Array<Scalars['String']>;
  managerEmail: Scalars['EmailAddress'];
  managerName: Scalars['String'];
};

/** Welcome call step */
export type OnboardingGQLBetaWelcomeCallStepType = {
  __typename?: 'OnboardingGQLBetaWelcomeCallStepType';
  isCompleted: Scalars['Boolean'];
  payload: OnboardingGQLBetaWelcomeCallStepPayloadType;
};

/** Onboarding mutations for a site set */
export type OnboardingGQLV1MutationType = {
  __typename?: 'OnboardingGQLV1MutationType';
  complete: Scalars['Boolean'];
  disableCalendlyStep: Scalars['Boolean'];
  disablePaymentsSetupStep: Scalars['Boolean'];
  saveWelcomeCallUri: Scalars['Boolean'];
};


/** Onboarding mutations for a site set */
export type OnboardingGQLV1MutationTypecompleteArgs = {
  siteSetId: Scalars['SiteSetId'];
};


/** Onboarding mutations for a site set */
export type OnboardingGQLV1MutationTypedisableCalendlyStepArgs = {
  calendlyWelcomeCallEmail: Scalars['EmailAddress'];
  siteSetId: Scalars['SiteSetId'];
};


/** Onboarding mutations for a site set */
export type OnboardingGQLV1MutationTypedisablePaymentsSetupStepArgs = {
  siteSetId: Scalars['SiteSetId'];
};


/** Onboarding mutations for a site set */
export type OnboardingGQLV1MutationTypesaveWelcomeCallUriArgs = {
  siteSetId: Scalars['SiteSetId'];
  welcomeCallUri: Scalars['String'];
};

/** Open onboarding hub step */
export type OnboardingGQLV1OpenOnboardingHubStepType = {
  __typename?: 'OnboardingGQLV1OpenOnboardingHubStepType';
  isCompleted: Scalars['Boolean'];
  payload: OnboardingGQLVOpenOnboardingHubPayloadType;
};

/** Payments setup step payload */
export type OnboardingGQLV1PaymentsSetupStepPayloadType = {
  __typename?: 'OnboardingGQLV1PaymentsSetupStepPayloadType';
  billPayerId: Scalars['BillPayerId'];
};

/** Payments setup step */
export type OnboardingGQLV1PaymentsSetupStepType = {
  __typename?: 'OnboardingGQLV1PaymentsSetupStepType';
  isCompleted: Scalars['Boolean'];
  payload: OnboardingGQLV1PaymentsSetupStepPayloadType;
};

/** Union of the possible onboarding steps */
export type OnboardingGQLV1StepType = OnboardingGQLV1OpenOnboardingHubStepType | OnboardingGQLV1PaymentsSetupStepType | OnboardingGQLV1WelcomeCallStepType;

/** Onboarding information for a site set */
export type OnboardingGQLV1Type = {
  __typename?: 'OnboardingGQLV1Type';
  isCompleted: Scalars['Boolean'];
  siteSetId: Scalars['SiteSetId'];
  steps: Array<OnboardingGQLV1StepType>;
};

/** Welcome call step payload */
export type OnboardingGQLV1WelcomeCallStepPayloadType = {
  __typename?: 'OnboardingGQLV1WelcomeCallStepPayloadType';
  prefillable: OnboardingGQLV1WelcomeCallStepPrefillableType;
  schedulingUrl: Scalars['String'];
};

/** Welcome call step prefillable */
export type OnboardingGQLV1WelcomeCallStepPrefillableType = {
  __typename?: 'OnboardingGQLV1WelcomeCallStepPrefillableType';
  customQuestions: Array<Scalars['String']>;
  managerEmail: Scalars['EmailAddress'];
  managerName: Scalars['String'];
};

/** Welcome call step */
export type OnboardingGQLV1WelcomeCallStepType = {
  __typename?: 'OnboardingGQLV1WelcomeCallStepType';
  isCompleted: Scalars['Boolean'];
  payload: OnboardingGQLV1WelcomeCallStepPayloadType;
};

/** Open onboarding hub step payload */
export type OnboardingGQLVOpenOnboardingHubPayloadType = {
  __typename?: 'OnboardingGQLVOpenOnboardingHubPayloadType';
  onboardingHubUrl: Scalars['String'];
};

/** Versioning node for onboarding mutations */
export type OnboardingMutation = {
  __typename?: 'OnboardingMutation';
  /** @deprecated New version available */
  beta: OnboardingGQLBetaMutationType;
  v1: OnboardingGQLV1MutationType;
};

/** Versioning node for onboarding queries */
export type OnboardingType = {
  __typename?: 'OnboardingType';
  /** @deprecated New version available */
  beta?: Maybe<OnboardingGQLBetaType>;
  v1?: Maybe<OnboardingGQLV1Type>;
};

export type OneTimePasswordMutation = {
  __typename?: 'OneTimePasswordMutation';
  password: OneTimePasswordResultType;
};


export type OneTimePasswordMutationpasswordArgs = {
  loginId: Scalars['LoginId'];
};

export type OneTimePasswordResultType = {
  __typename?: 'OneTimePasswordResultType';
  password: Scalars['Password'];
};

export type OpenIDProvider = {
  __typename?: 'OpenIDProvider';
  id: Scalars['OIDCProviderId'];
  openIDProviderId: Scalars['OIDCProviderId'];
  params: Scalars['Json'];
  required: Scalars['Boolean'];
  title: Scalars['String'];
  url: Scalars['URI'];
};

export type OpenShiftsType = {
  __typename?: 'OpenShiftsType';
  /** @deprecated Refactored. Use byGroupsV3 instead. */
  date: Scalars['LocalDate'];
  /** @deprecated Refactored. Use byGroupsV3 instead. */
  shifts: Array<ShiftType>;
};

export type OpenShiftsTypeV3 = {
  __typename?: 'OpenShiftsTypeV3';
  date: Scalars['LocalDate'];
  shifts: Array<ShiftTypeV3>;
};

export type OpeningHours = {
  __typename?: 'OpeningHours';
  friday?: Maybe<TimeRangeClosedLocalTime>;
  monday?: Maybe<TimeRangeClosedLocalTime>;
  saturday?: Maybe<TimeRangeClosedLocalTime>;
  sunday?: Maybe<TimeRangeClosedLocalTime>;
  thursday?: Maybe<TimeRangeClosedLocalTime>;
  tuesday?: Maybe<TimeRangeClosedLocalTime>;
  wednesday?: Maybe<TimeRangeClosedLocalTime>;
};

export enum OpeningHoursDisplayMode {
  ByFullWeeks = 'ByFullWeeks',
  ByWeekDays = 'ByWeekDays'
}

/** Opening hours for a group */
export type OpeningHoursForGroup = {
  __typename?: 'OpeningHoursForGroup';
  groupId: Scalars['GroupId'];
  openOn: Array<CapacityHoursByDay>;
  validRange: NonEmptyLocalDateRange;
};

/** Opening hours data for a specific group */
export type OpeningHoursForGroupResult = {
  __typename?: 'OpeningHoursForGroupResult';
  groupId: Scalars['GroupId'];
  openingHours: Array<OpeningHoursForGroup>;
};

/** Opening hours for a group */
export type OpeningHoursGroup = {
  __typename?: 'OpeningHoursGroup';
  groupId: Scalars['GroupId'];
  openAt: Array<CapacityHours>;
  validRange: NonEmptyLocalDateRange;
};

/** Add or remove opening hours for a group. Due to the lack of interface/union types for input types in GraphQL, it is technically possible to perform both actions in the same object. However, this is disallowed by the backend. Please only perform one action (add or delete) for each input object. */
export type OpeningHoursGroupAction = {
  add?: InputMaybe<OpeningHoursGroupInput>;
  addByDay?: InputMaybe<OpeningHoursGroupByDayInput>;
  delete?: InputMaybe<OpeningHoursGroupDeleteAction>;
};

export type OpeningHoursGroupByDayInput = {
  groupId: Scalars['GroupId'];
  openAt: Array<CapacityHoursForDayInput>;
  validFrom: Scalars['LocalDate'];
};

/** Remove opening hours for the given group that are valid from the given date */
export type OpeningHoursGroupDeleteAction = {
  groupId: Scalars['GroupId'];
  validFrom: Scalars['LocalDate'];
};

export type OpeningHoursGroupInput = {
  groupId: Scalars['GroupId'];
  openAt: Array<CapacityHoursInput>;
  validFrom: Scalars['LocalDate'];
};

/** Mutations related to opening hours for groups */
export type OpeningHoursGroupMutations = {
  __typename?: 'OpeningHoursGroupMutations';
  /**
   * Create/update opening hours for groups
   * @deprecated Use modify instead.
   */
  change: Array<OpeningHoursGroupResult>;
  /** Create/update opening hours for groups */
  modify: Array<OpeningHoursForGroupResult>;
};


/** Mutations related to opening hours for groups */
export type OpeningHoursGroupMutationschangeArgs = {
  actions: Array<OpeningHoursGroupAction>;
  displayMode?: InputMaybe<OpeningHoursDisplayMode>;
  displayRange: ClosedLocalDateRange;
};


/** Mutations related to opening hours for groups */
export type OpeningHoursGroupMutationsmodifyArgs = {
  actions: Array<OpeningHoursGroupAction>;
  displayMode: OpeningHoursDisplayMode;
  displayRange: ClosedLocalDateRange;
};

/** Opening hours data for a specific group */
export type OpeningHoursGroupResult = {
  __typename?: 'OpeningHoursGroupResult';
  groupId: Scalars['GroupId'];
  openingHours: Array<OpeningHoursGroup>;
};

export type OpeningHoursInput = {
  friday?: InputMaybe<ClosedLocalTimeRange>;
  monday?: InputMaybe<ClosedLocalTimeRange>;
  saturday?: InputMaybe<ClosedLocalTimeRange>;
  sunday?: InputMaybe<ClosedLocalTimeRange>;
  thursday?: InputMaybe<ClosedLocalTimeRange>;
  tuesday?: InputMaybe<ClosedLocalTimeRange>;
  wednesday?: InputMaybe<ClosedLocalTimeRange>;
};

/** Mutations related to opening hours */
export type OpeningHoursMutations = {
  __typename?: 'OpeningHoursMutations';
  groups: OpeningHoursGroupMutations;
};

/** Queries for opening hours */
export type OpeningHoursQueries = {
  __typename?: 'OpeningHoursQueries';
  forGroups: Array<OpeningHoursForGroupResult>;
  /** @deprecated Use forGroups instead. */
  groups: Array<OpeningHoursGroupResult>;
};


/** Queries for opening hours */
export type OpeningHoursQueriesforGroupsArgs = {
  displayMode: OpeningHoursDisplayMode;
  displayRange: ClosedLocalDateRange;
  groupIds: Array<Scalars['GroupId']>;
};


/** Queries for opening hours */
export type OpeningHoursQueriesgroupsArgs = {
  displayMode?: InputMaybe<OpeningHoursDisplayMode>;
  displayRange: ClosedLocalDateRange;
  groupIds: Array<Scalars['GroupId']>;
};

export enum Operation {
  Created = 'Created',
  Deleted = 'Deleted',
  Updated = 'Updated'
}

export type OrgInquiriesFeatureSettingsFlags = {
  __typename?: 'OrgInquiriesFeatureSettingsFlags';
  /** Returns if this feature is currently enabled. */
  isEnabled: Scalars['Boolean'];
};

export type OrgInquiriesManagementType = {
  __typename?: 'OrgInquiriesManagementType';
  /** True if current user can create inquiries of the site. */
  canCreate: Scalars['Boolean'];
  /** True if current user can create inquiry actions in the site. */
  canCreateActions: Scalars['Boolean'];
  /** True if current user can delete inquiries of the site. */
  canDelete: Scalars['Boolean'];
  /** True if current user can delete inquiry actions in the site. */
  canDeleteActions: Scalars['Boolean'];
  /** True if current user can enroll a child to the site. */
  canEnrollChildren: Scalars['Boolean'];
  /**
   * True if current user can move an inquiry (along with child and its relations) out of the site.
   * To be able to move a child, user also needs 'canCreate' flag on target site.
   */
  canMoveInquiriesOut: Scalars['Boolean'];
  /** True if current user can update inquiries of the site. */
  canUpdate: Scalars['Boolean'];
  /** True if current user can update inquiry actions in the site. */
  canUpdateActions: Scalars['Boolean'];
  /** True if current user can view inquiries of the site. */
  canView: Scalars['Boolean'];
  /** True if current user can view inquiry actions in the site. */
  canViewActions: Scalars['Boolean'];
  /** SiteId for this set of management flags. */
  siteId: Scalars['SiteId'];
};

/** The activity library for a specific organization */
export type OrganizationActivityLibrary = {
  __typename?: 'OrganizationActivityLibrary';
  organization: InstitutionSet;
};

/** An organization person at a given organization */
export type OrganizationAssignee = RoleAssignee & {
  __typename?: 'OrganizationAssignee';
  institutionSetId: Scalars['InstitutionSetId'];
  organizationPersonId: Scalars['OrganizationPersonId'];
  person: Person;
  /** The ID of the role that has been assigned */
  roleId: Scalars['RoleId'];
};

/** Holds info on Organization and payload that are associated with given Behavior */
export type OrganizationBehaviorNode = {
  __typename?: 'OrganizationBehaviorNode';
  id: Scalars['OrganizationId'];
  organization: OrganizationDetails;
  payload: Array<BehaviorPayload>;
};

/** The result of calling the delete mutation for organizations */
export type OrganizationDeletionResult = {
  __typename?: 'OrganizationDeletionResult';
  deletedOrganizations: Array<Scalars['OrganizationId']>;
};

export type OrganizationDetails = {
  __typename?: 'OrganizationDetails';
  country: Scalars['Country'];
  id: Scalars['OrganizationId'];
  locale?: Maybe<Scalars['Locale']>;
  profileImage?: Maybe<ProfileImage>;
  timezone: Scalars['ZoneId'];
  title: Scalars['String'];
};

/** A managed feature is a feature that the user can enable/disable themselves */
export type OrganizationManagedFeature = {
  __typename?: 'OrganizationManagedFeature';
  /** True if the feature has been enabled and false otherwise */
  enabled: Scalars['Boolean'];
  /** The unique ID of the feature */
  featureId: Scalars['String'];
};

/** The result of calling the merge mutation for organizations */
export type OrganizationMergeResult = {
  __typename?: 'OrganizationMergeResult';
  numberOfAffectedRows: Scalars['Int'];
};

/** Contains mutations related to organizations */
export type OrganizationMutation = {
  __typename?: 'OrganizationMutation';
  delete: OrganizationDeletionResult;
  merge: OrganizationMergeResult;
};


/** Contains mutations related to organizations */
export type OrganizationMutationdeleteArgs = {
  ids: Array<Scalars['OrganizationId']>;
};


/** Contains mutations related to organizations */
export type OrganizationMutationmergeArgs = {
  mergedInto: Scalars['OrganizationId'];
  oldOrganization: Scalars['OrganizationId'];
};

/** Top level object for organization queries */
export type OrganizationObject = {
  __typename?: 'OrganizationObject';
  /** Determines if an organization has the necessary features and privileges to request the addition of a new site. */
  additionalSites: additionalSites;
  managedFeatures: Array<OrganizationManagedFeature>;
  organizationId: Scalars['OrganizationId'];
};


/** Top level object for organization queries */
export type OrganizationObjectadditionalSitesArgs = {
  siteSetId: Scalars['SiteSetId'];
};

export type OutOfOffice = {
  __typename?: 'OutOfOffice';
  /** Returns out of office statuses for given login ids */
  list: Array<OutOfOfficeStatus>;
  /** Returns out of office settings for logged in user */
  my: Array<OutOfOfficeSetting>;
};


export type OutOfOfficelistArgs = {
  active?: Scalars['Boolean'];
  institutionSetId: Scalars['InstitutionSetId'];
  loginIds: Array<Scalars['LoginId']>;
};

export type OutOfOfficeMutations = {
  __typename?: 'OutOfOfficeMutations';
  /** Sets out of office statuses */
  set: Array<OutOfOfficeSetting>;
};


export type OutOfOfficeMutationssetArgs = {
  settings: Array<OutOfOfficeSettingInput>;
};

export type OutOfOfficeSetting = {
  __typename?: 'OutOfOfficeSetting';
  institutionSetId: Scalars['InstitutionSetId'];
  status?: Maybe<OutOfOfficeStatus>;
};

export type OutOfOfficeSettingInput = {
  institutionSetId: Scalars['InstitutionSetId'];
  status?: InputMaybe<OutOfOfficeStatusInput>;
};

export type OutOfOfficeStatus = {
  __typename?: 'OutOfOfficeStatus';
  from: Scalars['ZonedDateTime'];
  institutionSetId: Scalars['InstitutionSetId'];
  loginId: Scalars['LoginId'];
  message?: Maybe<Scalars['String']>;
  person: Person;
  to: Scalars['ZonedDateTime'];
};

export type OutOfOfficeStatusInput = {
  from?: InputMaybe<Scalars['ZonedDateTime']>;
  message?: InputMaybe<Scalars['String']>;
  to: Scalars['ZonedDateTime'];
};

export type OutstandingBalanceWidget = Widget & {
  __typename?: 'OutstandingBalanceWidget';
  id: Scalars['HomeWidgetId'];
  next?: Maybe<Scalars['HomeWidgetCursor']>;
  outstanding: OutstandingBalanceWidgetOutstanding;
  overdue: OutstandingBalanceWidgetOverdue;
  title: Scalars['String'];
  widgetId: Scalars['String'];
};

export type OutstandingBalanceWidgetOutstanding = {
  __typename?: 'OutstandingBalanceWidgetOutstanding';
  now: Scalars['BadMoney'];
};

export type OutstandingBalanceWidgetOverdue = {
  __typename?: 'OutstandingBalanceWidgetOverdue';
  overdueBillPayersCount: Scalars['Int'];
  overdueChildren: Array<OutstandingBalanceWidgetOverdueChild>;
  overdueChildrenCount: Scalars['Int'];
};

export type OutstandingBalanceWidgetOverdueChild = {
  __typename?: 'OutstandingBalanceWidgetOverdueChild';
  child: Child;
};

export type OverStaffed = StaffingStatus & {
  __typename?: 'OverStaffed';
  msg: Scalars['String'];
};

export type Package = {
  __typename?: 'Package';
  id: FeaturePackage;
};

export type PackageDetails = {
  __typename?: 'PackageDetails';
  annuallyPrice: Scalars['String'];
  annuallyPriceBeforeDiscount?: Maybe<Scalars['String']>;
  annuallyPriceVAT: Scalars['String'];
  canBeTrialed: Scalars['Boolean'];
  canBeUpgradedTo: Scalars['Boolean'];
  description: Scalars['String'];
  featurePackage: FeaturePackage;
  features: Array<Scalars['String']>;
  includesFeaturesFrom?: Maybe<Scalars['String']>;
  isCurrentlyOnThisPackage: Scalars['Boolean'];
  limitationSpecifications: Array<Scalars['String']>;
  mainSellingPoints: Array<Scalars['String']>;
  monthlyPrice: Scalars['String'];
  monthlyPriceBeforeDiscount?: Maybe<Scalars['String']>;
  monthlyPriceVAT: Scalars['String'];
  title: Scalars['String'];
  upgradeCanBeRequested: UpgradeCanBeRequested;
};

export type PackageInformation = {
  __typename?: 'PackageInformation';
  billingPreferences: Array<Scalars['String']>;
  packages: Array<SubscriptionPackage>;
};

/** In-app purchase queries related to package */
export type PackageObject = {
  __typename?: 'PackageObject';
  /** Information about which upgrade scenario to display */
  upgradeScenario: UpgradeScenarioType;
};


/** In-app purchase queries related to package */
export type PackageObjectupgradeScenarioArgs = {
  institutionId: Scalars['InstitutionId'];
};

/** Input for passing a Paragon error to Famly to be logged */
export type ParagonError = {
  crew: Crew;
  details: Array<ParagonErrorDetails>;
  errorMessage: Scalars['String'];
};

/** Key value pair to provide more details about the error (e.g. site, bill payer, etc.) */
export type ParagonErrorDetails = {
  key: Scalars['String'];
  value?: InputMaybe<Scalars['String']>;
};

export type ParagonIntegration = {
  __typename?: 'ParagonIntegration';
  apiAccessToken?: Maybe<ApiAccessToken>;
  name: IntegrationType;
};

/** A list of all available Paragon apps and their status */
export type ParagonIntegrationSupport = {
  __typename?: 'ParagonIntegrationSupport';
  kind: IntegrationKind;
  name: Scalars['String'];
  support: FeatureSupportState;
};

/** For interacting with Paragon */
export type ParagonMutation = {
  __typename?: 'ParagonMutation';
  /** Report an error/warning that happened in a Paragon workflow. It is useful because if the workflow is triggered by an app event, the error response does not reach our system. See the https://docs-prod.useparagon.com/v/master/building-workflows/sending-api-responses. */
  reportError: Scalars['Boolean'];
  /** Update which integrations are enabled for this site */
  updateEnabledIntegrations: Array<Scalars['String']>;
};


/** For interacting with Paragon */
export type ParagonMutationreportErrorArgs = {
  error: ParagonError;
  logLevel?: LogLevel;
};


/** For interacting with Paragon */
export type ParagonMutationupdateEnabledIntegrationsArgs = {
  integrations: Array<Scalars['String']>;
  siteSetId: Scalars['SiteSetId'];
};

/** top level object for paragon integration engine */
export type ParagonQuery = {
  __typename?: 'ParagonQuery';
  /**
   * Is paragon integrations enabled
   * @deprecated Use supports.isParagonEnabled field instead.
   */
  enabled: Scalars['Boolean'];
  /** Fetch an access token valid for Paragon */
  getParagonToken: ParagonTokenResult;
  /** Information about Paragon functionality that is supported via features or integrations */
  supports: ParagonSupport;
};


/** top level object for paragon integration engine */
export type ParagonQueryenabledArgs = {
  siteSetId: Scalars['SiteSetId'];
};


/** top level object for paragon integration engine */
export type ParagonQuerygetParagonTokenArgs = {
  siteSetId: Scalars['SiteSetId'];
};


/** top level object for paragon integration engine */
export type ParagonQuerysupportsArgs = {
  siteSetId: Scalars['InstitutionSetId'];
};

/** Details about supported Paragon features and integrations */
export type ParagonSupport = {
  __typename?: 'ParagonSupport';
  /** List all available Paragon integrations and their status */
  integrations: Array<ParagonIntegrationSupport>;
  /** Indicates if Paragon integrations are enabled */
  isParagonEnabled: FeatureSupportState;
};

export type ParagonTokenResult = {
  __typename?: 'ParagonTokenResult';
  baseUrl: Scalars['String'];
  contextId: Scalars['ParagonContextId'];
  contextName: Scalars['String'];
  enabledIntegrations: Array<ParagonIntegration>;
  projectId: Scalars['String'];
  scriptSrc: Scalars['String'];
  token: Scalars['String'];
};

/** Settings for parent purchases */
export type ParentPurchaseSettings = {
  __typename?: 'ParentPurchaseSettings';
  behaviors: Array<Behavior>;
  enabled: Scalars['Boolean'];
  /** @deprecated This was used for parent self-signup, which is no longer supported */
  groupId?: Maybe<Scalars['GroupId']>;
  institutionId: Scalars['InstitutionId'];
  pricingGroupId?: Maybe<Scalars['PricingGroupId']>;
  productIds: Array<Scalars['ProductId']>;
  ruleGroupId?: Maybe<Scalars['RuleGroupId']>;
  sessionIds: Array<Scalars['SessionId']>;
};

/** Update parent purchase settings */
export type ParentPurchaseSettingsMutation = {
  __typename?: 'ParentPurchaseSettingsMutation';
  /** Set/update parent purchase settings */
  setParentPurchaseSettings: ParentPurchaseSettings;
};


/** Update parent purchase settings */
export type ParentPurchaseSettingsMutationsetParentPurchaseSettingsArgs = {
  defaultGroupId?: InputMaybe<Scalars['GroupId']>;
  defaultPricingGroupId: Scalars['PricingGroupId'];
  defaultRuleGroupId?: InputMaybe<Scalars['RuleGroupId']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  institutionId: Scalars['InstitutionId'];
  productIds: Array<Scalars['ProductId']>;
  sessionIds: Array<Scalars['SessionId']>;
};

/** Objects related to parent purchase settings */
export type ParentPurchaseSettingsQueries = {
  __typename?: 'ParentPurchaseSettingsQueries';
  /** Get parent purchase settings */
  getParentPurchaseSettings: ParentPurchaseSettings;
};


/** Objects related to parent purchase settings */
export type ParentPurchaseSettingsQueriesgetParentPurchaseSettingsArgs = {
  institutionId: Scalars['InstitutionId'];
};

export type ParentTokenDetails = WatchMeGrowTokenDetails & {
  __typename?: 'ParentTokenDetails';
  type: WatchMeGrowTokenType;
};

export type ParentalPermission = {
  __typename?: 'ParentalPermission';
  parentalPermissionId: Scalars['ParentalPermissionId'];
};

export type ParentalPermissionFeature = {
  __typename?: 'ParentalPermissionFeature';
  feature: FeatureType;
  institutionSetId: Scalars['InstitutionSetId'];
  parentalPermission: ParentalPermission;
};

export type ParentalPermissionFeatureInput = {
  feature: FeatureType;
  institutionSetId: Scalars['InstitutionSetId'];
  parentalPermissionId: Scalars['ParentalPermissionId'];
};

export type PartDayLeaveFeatureSettingsFlags = {
  __typename?: 'PartDayLeaveFeatureSettingsFlags';
  /** Returns if this feature can be enabled. */
  canOptIn: Scalars['Boolean'];
  /** Returns if this feature is currently enabled. */
  enabled: Scalars['Boolean'];
};

/** A single partner offer */
export type Partner = {
  __typename?: 'Partner';
  canClaim: Scalars['Boolean'];
  offerDetails: PartnerOfferDetails;
  offerUrl?: Maybe<Scalars['String']>;
  partnerId: PartnerType;
  partnerName: Scalars['String'];
  websiteUrl: Scalars['String'];
};

/** Information about the partner's offer */
export type PartnerOfferDetails = {
  __typename?: 'PartnerOfferDetails';
  description: Scalars['String'];
  descriptionShort: Scalars['String'];
  howToClaim?: Maybe<Scalars['String']>;
  offer: Scalars['String'];
  offerCode?: Maybe<Scalars['String']>;
  whoCanClaim: Scalars['String'];
};

export enum PartnerType {
  /** @deprecated Contract ran out. ID kept here for backwards compatibility */
  ADVENTURES_WITH_ALICE = 'ADVENTURES_WITH_ALICE',
  BOOGIE_MITES = 'BOOGIE_MITES',
  CHILDCARE_MARKETING = 'CHILDCARE_MARKETING',
  CREATIVE_STEPS = 'CREATIVE_STEPS',
  EARLY_EDUCATION = 'EARLY_EDUCATION',
  /** @deprecated Contract with EarlyYearsHub ran out. ID kept here for backwards compatibility */
  EARLY_YEARS_HUB = 'EARLY_YEARS_HUB',
  EARLY_YEARS_OUT_OF_THE_BOX = 'EARLY_YEARS_OUT_OF_THE_BOX',
  EARLY_YEARS_TV = 'EARLY_YEARS_TV',
  /** @deprecated Contract ran out. ID kept here for backwards compatibility */
  EVERON = 'EVERON',
  FLOURISH = 'FLOURISH',
  /** @deprecated Contract with HOPE ran out. ID kept here for backwards compatibility */
  HOPE_EDUCATION = 'HOPE_EDUCATION',
  HOPSCOTCH_CONSULTANCY = 'HOPSCOTCH_CONSULTANCY',
  LASER_LEARNING = 'LASER_LEARNING',
  /** @deprecated Contract ran out. ID kept here for backwards compatibility */
  MMS = 'MMS',
  ONE_DECISION = 'ONE_DECISION',
  POLYLINO = 'POLYLINO',
  SUE_ASQUITH = 'SUE_ASQUITH',
  TACTYC = 'TACTYC',
  THE_CHILDCARE_JOB_BOARD = 'THE_CHILDCARE_JOB_BOARD',
  THE_LEADERSHIP_WIZARD = 'THE_LEADERSHIP_WIZARD'
}

/** PasswordRules */
export type PasswordRules = {
  __typename?: 'PasswordRules';
  reauthenticateEveryNDays: Scalars['Int'];
};

export type PasswordRulesMutation = {
  __typename?: 'PasswordRulesMutation';
  setReauthenticateEveryNDays: Scalars['Int'];
};


export type PasswordRulesMutationsetReauthenticateEveryNDaysArgs = {
  days: Scalars['Int'];
  siteSetId: Scalars['SiteSetId'];
};

/** Part of a path to a folder. */
export type PathElement = {
  __typename?: 'PathElement';
  folderId: Scalars['FolderId'];
  title: Scalars['String'];
};

/** Details for a specific payment */
export type Payment = {
  __typename?: 'Payment';
  amount: Scalars['BadMoney'];
  billPayer: BillPayer;
  childId?: Maybe<Scalars['ChildId']>;
  id: Scalars['PaymentId'];
  invoices: Array<Invoice>;
  note: Scalars['String'];
  paymentDate: Scalars['LocalDate'];
  paymentMethod: PaymentMethod;
  paymentsFeedId?: Maybe<Scalars['PaymentsFeedId']>;
  paymentsFeedRowNumber?: Maybe<Scalars['Int']>;
};

/** Configuration preview for a single payment adoption promo */
export type PaymentAdoptionPromoPreview = {
  __typename?: 'PaymentAdoptionPromoPreview';
  displayText: Scalars['Markdown'];
  id: Scalars['PaymentPromoConfigurationId'];
  link?: Maybe<PaymentsPromoLink>;
  location: PaymentPromoLocation;
  promoType: PaymentPromoType;
};

/** Result of delete operation */
export type PaymentDeleteResult = {
  __typename?: 'PaymentDeleteResult';
  deleted: Array<DeletedPayment>;
};

/** Details about a payment */
export type PaymentDetails = {
  __typename?: 'PaymentDetails';
  amountInUnits: Scalars['Int'];
  currencyCode: Scalars['String'];
};

/** Details of the external system for a specific payment */
export type PaymentExternalSystem = {
  __typename?: 'PaymentExternalSystem';
  /** The type associated with the payment in the external system. */
  externalType?: Maybe<Scalars['String']>;
  /** The external ID this payment relates to. */
  id: Scalars['String'];
  /** The name of the custom integration. Only relevant if `system` is set to `CUSTOM`. */
  name?: Maybe<Scalars['String']>;
  /** The name of the external system this payment relates to, or 'CUSTOM' if it is a custom integration. */
  system: ExternalSystemName;
};

/** Input for details of the external system for a specific payment */
export type PaymentExternalSystemInput = {
  /** The external ID this payment relates to. */
  id: Scalars['String'];
  /** The name of the custom integration. Only relevant if `system` is set to `CUSTOM`. */
  name?: InputMaybe<Scalars['String']>;
  /** The name of the external system this payment relates to, or 'CUSTOM' if it is a custom integration. */
  system: ExternalSystemName;
};

/** Details of the reference in an external system for a specific payment */
export type PaymentExternalSystemReferenceInput = {
  /** The type associated with the payment in the external system. */
  externalType?: InputMaybe<Scalars['String']>;
  /** The external ID this payment relates to. */
  id: Scalars['String'];
  /** The name of the custom integration. Only relevant if `system` is set to `CUSTOM`. */
  name?: InputMaybe<Scalars['String']>;
  /** The name of the external system this payment relates to, or 'CUSTOM' if it is a custom integration. */
  system?: InputMaybe<ExternalSystemName>;
};

/** Details about the fees for a payment */
export type PaymentFee = {
  __typename?: 'PaymentFee';
  amount: Scalars['BadMoney'];
  balanceAfter: Scalars['BadMoney'];
  total: Scalars['BadMoney'];
  userFee: Scalars['BadMoney'];
};

export enum PaymentImportFileFormat {
  CSV = 'CSV',
  Excel = 'Excel'
}

export enum PaymentImportFlavour {
  Default = 'Default',
  Xero = 'Xero'
}

export type PaymentInput = {
  paymentMethod?: InputMaybe<PaymentMethodInput>;
  paymentsSourceId?: InputMaybe<Scalars['PaymentsSourceId']>;
};

/** The results of searching for a bill payer */
export type PaymentListResult = {
  __typename?: 'PaymentListResult';
  next?: Maybe<Scalars['PaymentCursor']>;
  payments: Array<Payment>;
};

export enum PaymentMethod {
  ACH = 'ACH',
  Adjustment = 'Adjustment',
  BankTransfer = 'BankTransfer',
  Cash = 'Cash',
  Cheque = 'Cheque',
  CreditCard = 'CreditCard',
  DebitCard = 'DebitCard',
  DirectDebit = 'DirectDebit',
  GovernmentGrant = 'GovernmentGrant',
  Other = 'Other',
  Payroll = 'Payroll',
  SEPA = 'SEPA',
  TaxFreeChildcare = 'TaxFreeChildcare',
  Voucher = 'Voucher',
  WriteOff = 'WriteOff'
}

export type PaymentMethodInput = {
  paymentMethodId: Scalars['String'];
  savePaymentMethod: Scalars['Boolean'];
};

export enum PaymentMethodRestriction {
  /** This means you need a Payment Method and it needs to be automatic (regular add card modal with forced autopay). */
  AUTOMATIC_PAYMENT_METHOD_REQUIRED = 'AUTOMATIC_PAYMENT_METHOD_REQUIRED',
  /** This means you already have a Payment Method, but now it's required that it's automatic (autopay setup modal). */
  AUTOMATIC_REQUIRED = 'AUTOMATIC_REQUIRED',
  /** All potential requirements are fulfilled (Payment Method, Survey, etc). */
  FULFILLED = 'FULFILLED',
  /** No requirements are being enforced or checked for. */
  NOT_REQUIRED = 'NOT_REQUIRED',
  /** This means you just need a Payment Method, so no requirement for it to be automatic (regular add card modal). */
  PAYMENT_METHOD_REQUIRED = 'PAYMENT_METHOD_REQUIRED',
  /** This means you are required to fill out the survey with a response, and have not yet done so. */
  SURVEY_REQUIRED = 'SURVEY_REQUIRED'
}

/** For managing payments */
export type PaymentMutations = {
  __typename?: 'PaymentMutations';
  /** Register new payments with the provided details. */
  create: Array<Payment>;
  /** Delete payments. */
  delete: PaymentDeleteResult;
  /** Update the external reference of a payment */
  updateExternalReference: PaymentExternalSystem;
};


/** For managing payments */
export type PaymentMutationscreateArgs = {
  payments: Array<FamlyPaymentInput>;
};


/** For managing payments */
export type PaymentMutationsdeleteArgs = {
  paymentIds: Array<Scalars['PaymentId']>;
};


/** For managing payments */
export type PaymentMutationsupdateExternalReferenceArgs = {
  externalReference: PaymentExternalSystemReferenceInput;
  paymentId: Scalars['PaymentId'];
};

export enum PaymentPromoLocation {
  Home = 'Home'
}

export enum PaymentPromoType {
  Banner = 'Banner',
  Widget = 'Widget'
}

/** For querying payments */
export type PaymentQueries = {
  __typename?: 'PaymentQueries';
  /** List all payments created from a payments feed */
  byPaymentsFeedId: PaymentListResult;
  search: Array<QueryResult>;
};


/** For querying payments */
export type PaymentQueriesbyPaymentsFeedIdArgs = {
  next?: InputMaybe<Scalars['PaymentCursor']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  paymentsFeedId: Scalars['PaymentsFeedId'];
};


/** For querying payments */
export type PaymentQueriessearchArgs = {
  amountEpsilon: Scalars['BadMoney'];
  daysEpsilon: Scalars['Int'];
  institutionId: Scalars['InstitutionId'];
  queries: Array<PaymentQueryInput>;
};

/**
 * A query contains the data needed to search for payments.
 *
 * BillPayerId and BillPayerName are both optional references to bill payers, and behave accordingly:
 * - If neither are provided, then it's considered an error, *at least 1* bill payer reference must always be provided
 * - If only one of BillPayerId or BillPayerName is defined, then search for payments with the the defined bill payer reference.
 * - If BillPayerId *and* BillPayerName are both defined, then search for payments that match at least 1 of these.
 *
 */
export type PaymentQueryInput = {
  amount: Scalars['BadMoney'];
  /** One of billPayerName or billPayerId is required. */
  billPayerId?: InputMaybe<Scalars['BillPayerId']>;
  /** One of billPayerName or billPayerId is required. */
  billPayerName?: InputMaybe<Scalars['String']>;
  /** The date the payment was made on. */
  paymentDate: Scalars['LocalDate'];
};

/** A payment reminder email queued for send-off (or already sent) to a bill payer */
export type PaymentReminderEmail = {
  __typename?: 'PaymentReminderEmail';
  billPayerId: Scalars['BillPayerId'];
  createdAt: Scalars['ZonedDateTime'];
  createdBy: Person;
  emailAddress: Scalars['EmailAddress'];
  htmlContent?: Maybe<Scalars['String']>;
  institutionId: Scalars['InstitutionId'];
  paymentReminderEmailId: Scalars['PaymentReminderEmailId'];
  plainTextContent?: Maybe<Scalars['String']>;
  subject: Scalars['String'];
};

/** Preview and send payment reminders */
export type PaymentReminderMutations = {
  __typename?: 'PaymentReminderMutations';
  defaultSubject: Scalars['String'];
  defaultTemplate: Scalars['String'];
  previewPaymentReminder: PaymentReminderPreview;
  send: PaymentReminderSendResult;
  /** @deprecated Use 'send' mutation instead, which returns a list of rendered email objects */
  sendPaymentReminder: Scalars['Boolean'];
};


/** Preview and send payment reminders */
export type PaymentReminderMutationsdefaultSubjectArgs = {
  institutionId: Scalars['InstitutionId'];
};


/** Preview and send payment reminders */
export type PaymentReminderMutationsdefaultTemplateArgs = {
  institutionId: Scalars['InstitutionId'];
};


/** Preview and send payment reminders */
export type PaymentReminderMutationspreviewPaymentReminderArgs = {
  billPayerId: Scalars['BillPayerId'];
  emailSubject?: InputMaybe<Scalars['String']>;
  emailTemplate?: InputMaybe<Scalars['String']>;
};


/** Preview and send payment reminders */
export type PaymentReminderMutationssendArgs = {
  billPayerIds: Array<Scalars['BillPayerId']>;
  emailSubject?: InputMaybe<Scalars['String']>;
  emailTemplate?: InputMaybe<Scalars['String']>;
};


/** Preview and send payment reminders */
export type PaymentReminderMutationssendPaymentReminderArgs = {
  billPayerIds: Array<Scalars['BillPayerId']>;
  emailSubject?: InputMaybe<Scalars['String']>;
  emailTemplate?: InputMaybe<Scalars['String']>;
};

/** A preview of the payment reminder e-mail with possible template variables */
export type PaymentReminderPreview = {
  __typename?: 'PaymentReminderPreview';
  preview: Scalars['String'];
  subject: Scalars['String'];
};

/** Fields related to payment reminders */
export type PaymentReminderQueries = {
  __typename?: 'PaymentReminderQueries';
  validateEmailsForBillPayers: Array<Scalars['BillPayerId']>;
  variables: Array<TemplateVariable>;
};


/** Fields related to payment reminders */
export type PaymentReminderQueriesvalidateEmailsForBillPayersArgs = {
  billPayerIds: Array<Scalars['BillPayerId']>;
};

export type PaymentReminderSendResult = {
  __typename?: 'PaymentReminderSendResult';
  emails: Array<PaymentReminderEmail>;
};

/** Returns data on an attempted payment - either the completed transaction or the intent for further action. */
export type PaymentResponse = {
  completed: Scalars['Boolean'];
};

/** A completed payment, with the details of the transaction */
export type PaymentResponseCompleted = PaymentResponse & {
  __typename?: 'PaymentResponseCompleted';
  completed: Scalars['Boolean'];
  transaction: PaymentTransaction;
};

/** A payment that has failed */
export type PaymentResponseFailed = PaymentResponse & {
  __typename?: 'PaymentResponseFailed';
  completed: Scalars['Boolean'];
  errorMessage: Scalars['String'];
};

/** A payment that requires further action to confirm */
export type PaymentResponseRequiresAction = PaymentResponse & {
  __typename?: 'PaymentResponseRequiresAction';
  completed: Scalars['Boolean'];
  intentClientSecret: Scalars['String'];
  transaction: PaymentTransaction;
};

export enum PaymentTaskInvoiceAction {
  PaymentCreate = 'PaymentCreate',
  PaymentUpdate = 'PaymentUpdate'
}

/** A transfer of money */
export type PaymentTransaction = {
  __typename?: 'PaymentTransaction';
  amount: Scalars['BigDecimal'];
  balancePaid: Scalars['BigDecimal'];
  billPayer: BillPayer;
  createdAt: Scalars['ZonedDateTime'];
  currency: Scalars['String'];
  fee: Scalars['BigDecimal'];
  id: Scalars['PaymentsTransactionId'];
  institutionFee: Scalars['BigDecimal'];
  paymentId: Scalars['PaymentId'];
  paymentsSourceId: Scalars['PaymentsSourceId'];
  status: TransactionStatus;
  statusMessage?: Maybe<Scalars['String']>;
  targetAccountId: Scalars['PaymentsAccountId'];
  userFee?: Maybe<Scalars['BigDecimal']>;
};

/** Objects related to payments */
export type Payments = {
  __typename?: 'Payments';
  /** Return a list of payments accounts for the given institution set */
  accounts: Array<PaymentsAccount>;
  /** Available payment methods */
  availablePaymentMethods: AvailablePaymentMethodsType;
  /** Behaviors for Payments Accounts */
  behaviors: Array<Behavior>;
  /** Check if nursery admin can disable in-app payments */
  canDisableFamlyPay: Scalars['Boolean'];
  /** Details about fees for a in-app payments account */
  fees: Array<FeeDetails>;
  feesByMonth: PaymentsFees;
  feesByYear: Array<PaymentsFees>;
  /** List valid account types for the given institution set */
  getAccountTypes: Array<PaymentsAccountType>;
  getActivity: PaymentsActivity;
  getBalance: PaymentsBalance;
  /** Return the payments source, if any, associated with a bill payer */
  getBillPayerSource?: Maybe<BillPayerSource>;
  /** Get list of missing fields required to verify account */
  getMissingFields: Array<Scalars['String']>;
  getPayout: PaymentsPayout;
  /** Get the public key required to interact with the payment provider */
  getPublicKeys: Array<PublicKey>;
  internalPaymentMethods: InternalPaymentMethodFields;
  listMonthlyPayoutVolume: Array<PaymentsPayoutVolume>;
  /** List payment sources and their status for the current user */
  listPaymentSources: Array<PaymentsSource>;
  /** List all payments made by the current user */
  listPayments: Array<PaymentTransaction>;
  listPayouts: Array<PaymentsPayout>;
  /** The date when bill payers will next be automatically charged */
  nextAutomaticPayment?: Maybe<Scalars['LocalDate']>;
  /** The upcoming dates when bill payers will be automatically charged */
  nextAutomaticPaymentDates?: Maybe<Array<Scalars['LocalDate']>>;
  /** Get details about payment payload */
  paymentDetails: PaymentDetails;
  paymentsFeed: PaymentsFeedQueries;
  personal: Personal;
  /** Get a list of upcoming dates for automatic payments */
  previewAutomaticPayments: AutomaticPaymentsPreview;
  promos: Promos;
  stripe: Stripe;
  stripeDirectDebit: StripeDirectDebit;
  /** Information about payment functionalities that are supported via features or integrations */
  supports: PaymentsIntegrationSupport;
  useAutomaticPaymentsByDefault: Scalars['Boolean'];
  userPaymentSourceTypes: Array<PaymentsSourceType>;
};


/** Objects related to payments */
export type PaymentsaccountsArgs = {
  institutionSetId: Scalars['InstitutionSetId'];
};


/** Objects related to payments */
export type PaymentsavailablePaymentMethodsArgs = {
  siteSetId: Scalars['InstitutionSetId'];
};


/** Objects related to payments */
export type PaymentsbehaviorsArgs = {
  institutionSetId: Scalars['InstitutionSetId'];
};


/** Objects related to payments */
export type PaymentscanDisableFamlyPayArgs = {
  paymentsAccountId: Scalars['PaymentsAccountId'];
};


/** Objects related to payments */
export type PaymentsfeesArgs = {
  institutionSetId: Scalars['InstitutionSetId'];
};


/** Objects related to payments */
export type PaymentsfeesByMonthArgs = {
  institutionSetId: Scalars['InstitutionSetId'];
  month: Scalars['Int'];
  year: Scalars['Int'];
};


/** Objects related to payments */
export type PaymentsfeesByYearArgs = {
  institutionSetId: Scalars['InstitutionSetId'];
  year: Scalars['Int'];
};


/** Objects related to payments */
export type PaymentsgetAccountTypesArgs = {
  forUser: Scalars['Boolean'];
  institutionSetId?: InputMaybe<Scalars['InstitutionSetId']>;
};


/** Objects related to payments */
export type PaymentsgetActivityArgs = {
  paymentsAccountId: Scalars['PaymentsAccountId'];
};


/** Objects related to payments */
export type PaymentsgetBalanceArgs = {
  paymentsAccountId: Scalars['PaymentsAccountId'];
};


/** Objects related to payments */
export type PaymentsgetBillPayerSourceArgs = {
  billPayerId: Scalars['BillPayerId'];
};


/** Objects related to payments */
export type PaymentsgetMissingFieldsArgs = {
  paymentsAccountId: Scalars['PaymentsAccountId'];
};


/** Objects related to payments */
export type PaymentsgetPayoutArgs = {
  paymentsPayoutId: Scalars['PaymentsPayoutId'];
};


/** Objects related to payments */
export type PaymentsgetPublicKeysArgs = {
  accountType: PaymentsAccountType;
  billPayerId?: InputMaybe<Scalars['BillPayerId']>;
  institutionSetId?: InputMaybe<Scalars['InstitutionSetId']>;
};


/** Objects related to payments */
export type PaymentslistMonthlyPayoutVolumeArgs = {
  from: Scalars['LocalDate'];
  paymentsAccountId: Scalars['PaymentsAccountId'];
  to: Scalars['LocalDate'];
};


/** Objects related to payments */
export type PaymentslistPaymentSourcesArgs = {
  billPayerId?: InputMaybe<Scalars['BillPayerId']>;
};


/** Objects related to payments */
export type PaymentslistPayoutsArgs = {
  paymentsAccountId: Scalars['PaymentsAccountId'];
};


/** Objects related to payments */
export type PaymentsnextAutomaticPaymentArgs = {
  paymentsAccountId: Scalars['PaymentsAccountId'];
};


/** Objects related to payments */
export type PaymentsnextAutomaticPaymentDatesArgs = {
  count: Scalars['Int'];
  paymentsAccountId: Scalars['PaymentsAccountId'];
};


/** Objects related to payments */
export type PaymentspaymentDetailsArgs = {
  payload: Scalars['String'];
};


/** Objects related to payments */
export type PaymentspreviewAutomaticPaymentsArgs = {
  automaticBillingDate: AutomaticBillingDateInput;
  paymentsAccountId: Scalars['PaymentsAccountId'];
  voucherHandlingConfiguration?: InputMaybe<VoucherHandlingConfiguration>;
};


/** Objects related to payments */
export type PaymentssupportsArgs = {
  institutionSetId: Scalars['InstitutionSetId'];
};


/** Objects related to payments */
export type PaymentsuseAutomaticPaymentsByDefaultArgs = {
  siteSetId: Scalars['InstitutionSetId'];
};


/** Objects related to payments */
export type PaymentsuserPaymentSourceTypesArgs = {
  billPayerId?: InputMaybe<Scalars['BillPayerId']>;
};

/** An account set up to receive payments */
export type PaymentsAccount = {
  /** Which payment provider this account is created for */
  accountType: PaymentsAccountType;
  /** Behaviors for this account */
  behaviors: Array<Behavior>;
  /** The potential deadline for new account information required. */
  dueBy?: Maybe<Scalars['ZonedDateTime']>;
  enabledParentFeeSourceTypes: Array<PaymentsSourceType>;
  enabledPaymentSourceTypes: Array<PaymentsSourceType>;
  /** Details about fees for the account */
  fees: Array<FeeDetails>;
  flexPay: PaymentsAccountFlexPay;
  /**
   * The minimum amount which should be paid with flexible payment, or null if flexible payment isn't enabled.
   * @deprecated Use flexPay.minPaymentAmount instead.
   */
  flexPayMinAmount?: Maybe<Scalars['BadMoney']>;
  institutionSetId: Scalars['InstitutionSetId'];
  paymentsAccountId: Scalars['PaymentsAccountId'];
  /** Whether this account can receive payments */
  paymentsEnabled: Scalars['Boolean'];
  /** Whether this account can receive payouts (withdraw money) */
  payoutsEnabled: Scalars['Boolean'];
  /** The current status of the account */
  status: AccountStatus;
  /** A detailed message behind the current status */
  statusMessage: Scalars['String'];
};

/** Object containing information about FlexPay, a feature allowing users to pay flexible amounts using FamlyPay. */
export type PaymentsAccountFlexPay = {
  __typename?: 'PaymentsAccountFlexPay';
  isEnabled: Scalars['Boolean'];
  maxBalanceAfterPayment?: Maybe<Scalars['BadMoney']>;
  minPaymentAmount?: Maybe<Scalars['BadMoney']>;
};

/** The type/platform the account is associated with */
export enum PaymentsAccountType {
  DUMMY = 'DUMMY',
  STRIPE = 'STRIPE'
}

/** Get overview of account activity from incoming payments until bank payouts */
export type PaymentsActivity = {
  __typename?: 'PaymentsActivity';
  completed: PaymentsActivitySegment;
  currency: Scalars['String'];
  inPayout: PaymentsActivitySegment;
  started: PaymentsActivitySegment;
  sumFeesTotal: Scalars['BadMoney'];
  sumTotal: Scalars['BadMoney'];
};

/** Get details about transactions and corrections for a specific segment of Famly Pay activity */
export type PaymentsActivitySegment = {
  __typename?: 'PaymentsActivitySegment';
  corrections: Array<PaymentsCorrection>;
  sum: Scalars['BadMoney'];
  sumAfterFees: Scalars['BadMoney'];
  sumCorrections: Scalars['BadMoney'];
  sumFees: Scalars['BadMoney'];
  transactions: Array<PaymentTransaction>;
};

/** The current outstanding balance of the institution account */
export type PaymentsBalance = {
  __typename?: 'PaymentsBalance';
  availableBalance: Scalars['BadMoney'];
  currency: Scalars['String'];
  /** The expected date for receiving the next payout */
  nextPayout?: Maybe<Scalars['LocalDate']>;
  paymentsAccountId: Scalars['PaymentsAccountId'];
  pendingBalance: Scalars['BadMoney'];
};

/** A correction to the account, usually in response to a dispute or other transaction */
export type PaymentsCorrection = {
  __typename?: 'PaymentsCorrection';
  accountId: Scalars['PaymentsAccountId'];
  amountFees: Scalars['BigDecimal'];
  amountTotal: Scalars['BigDecimal'];
  correctionReason: Scalars['String'];
  correctionType: CorrectionType;
  createdAt: Scalars['ZonedDateTime'];
  id: Scalars['PaymentsCorrectionId'];
  transaction?: Maybe<PaymentTransaction>;
};

/** Domain object of Payments Feed which is created by payment bulk importing */
export type PaymentsFeed = {
  __typename?: 'PaymentsFeed';
  createdAt: Scalars['ZonedDateTime'];
  createdBy: Scalars['LoginId'];
  errorDetails?: Maybe<Scalars['String']>;
  filename: Scalars['String'];
  /** indicates if there is something special about import source (e.g. xero import) */
  flavour: PaymentImportFlavour;
  /** @deprecated Use siteSetId field instead */
  institutionId: Scalars['InstitutionId'];
  isDismissed: Scalars['Boolean'];
  paymentsFeedId: Scalars['PaymentsFeedId'];
  /** This value is set to 0 if the status is Pending */
  protoPaymentsRemaining: Scalars['Int'];
  siteSetId: Scalars['InstitutionSetId'];
  status: PaymentsFeedStatus;
};

/** For managing payments feed */
export type PaymentsFeedMutations = {
  __typename?: 'PaymentsFeedMutations';
  /** Upload a CSV file containing payments feeds */
  importFromCsv: PaymentsFeed;
  /** Upload an Excel file containing payments feeds */
  importFromExcel: PaymentsFeed;
  /** Upload a CSV/Excel/Xero file containing payments feeds */
  importFromFile: PaymentsFeed;
  /** Update the dismissed status for payments feeds */
  updateDismissed: Array<PaymentsFeed>;
};


/** For managing payments feed */
export type PaymentsFeedMutationsimportFromCsvArgs = {
  data: Scalars['Base64String'];
  filename: Scalars['String'];
  institutionId: Scalars['InstitutionId'];
};


/** For managing payments feed */
export type PaymentsFeedMutationsimportFromExcelArgs = {
  data: Scalars['Base64String'];
  filename: Scalars['String'];
  institutionId: Scalars['InstitutionId'];
};


/** For managing payments feed */
export type PaymentsFeedMutationsimportFromFileArgs = {
  data: Scalars['Base64String'];
  fileFormat: PaymentImportFileFormat;
  filename: Scalars['String'];
  siteSetId: Scalars['InstitutionSetId'];
};


/** For managing payments feed */
export type PaymentsFeedMutationsupdateDismissedArgs = {
  dismissedFeeds: Array<Scalars['PaymentsFeedId']>;
  undismissedFeeds: Array<Scalars['PaymentsFeedId']>;
};

export type PaymentsFeedQueries = {
  __typename?: 'PaymentsFeedQueries';
  list: PaymentsFeedResult;
  protoPayment: ProtoPaymentQueries;
  templates: Templates;
};


export type PaymentsFeedQuerieslistArgs = {
  count?: InputMaybe<Scalars['Int']>;
  cursor?: InputMaybe<Scalars['PaymentsFeedCursor']>;
  includeDismissed?: InputMaybe<Scalars['Boolean']>;
  institutionIds?: InputMaybe<Array<Scalars['InstitutionId']>>;
  paymentsFeedIds?: InputMaybe<Array<Scalars['PaymentsFeedId']>>;
  siteSetIds?: Array<Scalars['InstitutionSetId']>;
  statuses?: InputMaybe<Array<PaymentsFeedStatus>>;
};

/** A paged list of payments feeds with a cursor */
export type PaymentsFeedResult = {
  __typename?: 'PaymentsFeedResult';
  cursor?: Maybe<Scalars['PaymentsFeedCursor']>;
  paymentsFeeds: Array<PaymentsFeed>;
};

export enum PaymentsFeedStatus {
  FAILED = 'FAILED',
  LOADED = 'LOADED',
  PENDING = 'PENDING'
}

export type PaymentsFees = {
  __typename?: 'PaymentsFees';
  institutionSetId: Scalars['InstitutionSetId'];
  invoices: Array<Invoice>;
  month: TimeRangeClosed;
  totals: PaymentsFeesTotals;
  totalsByType: Array<PaymentsFeesByType>;
};

export type PaymentsFeesByType = {
  __typename?: 'PaymentsFeesByType';
  paymentsSourceType: PaymentsSourceType;
  totals: PaymentsFeesTotals;
};

/** Total number of transactions, corrections, and associated fees */
export type PaymentsFeesTotals = {
  __typename?: 'PaymentsFeesTotals';
  correctionCount: Scalars['Int'];
  correctionTotal: Scalars['BadMoney'];
  feesTotal: Scalars['BadMoney'];
  transactionCount: Scalars['Int'];
  transactionTotal: Scalars['BadMoney'];
};

/** Details about supported payment features and integrations */
export type PaymentsIntegrationSupport = {
  __typename?: 'PaymentsIntegrationSupport';
  /** Indicates support for managing Famly Pay setup as well as it being active. */
  canManageFamlyPay: FeatureSupportState;
  /** Indicates support for ExactDayOfWeek automatic payments. */
  canUseExactDayOfWeek: FeatureSupportState;
  /** Indicates support for configuring automatic payments to be made on invoice due date. */
  canUseOnInvoiceDueDate: FeatureSupportState;
};

/** Mutations for creating payments accounts and charges */
export type PaymentsMutation = {
  __typename?: 'PaymentsMutation';
  /** Remove the payment source from a bill payer */
  clearBillPayer: Scalars['Boolean'];
  /**
   * Create new payments accounts
   * @deprecated Generic endpoint is no longer in use, please use payment provider-specific
   */
  createAccount: PaymentsAccount;
  /** Remove a payment source */
  deletePaymentSource: Scalars['Boolean'];
  /** Disable in-app payments for given account */
  disableFamlyPay: PaymentsAccount;
  internalPaymentMethods: InternalPaymentMethodMutations;
  /** Pay the outstanding balance for an account */
  payBalance: PaymentTransaction;
  paymentsFeed: PaymentsFeedMutations;
  /**
   * Create a payment source from a payment provider token
   * @deprecated Please use the Stripe-specific payment source endpoints
   */
  savePaymentSource: PaymentsSource;
  /** Set automatic payments */
  setAutomaticPayments: AutomaticPayments;
  /** Set the enabled payment sources types for the account */
  setEnabledPaymentSourceTypes: Array<PaymentsSourceType>;
  /**
   * Sets the minimum payment amount for the given account.
   * @deprecated Use setFlexPayConfig instead
   */
  setFlexPay?: Maybe<Scalars['BadMoney']>;
  /** Sets FlexPay configuration for the given account */
  setFlexPayConfig?: Maybe<PaymentsAccountFlexPay>;
  /** Set the payment source to use for a bill payer */
  setForBillPayer: Scalars['Boolean'];
  /** Set the payment source types for which parents will pay the fee */
  setParentFeeSourceTypes: Array<PaymentsSourceType>;
  /** Indicate that parents have been notified */
  setParentsNotified: Scalars['Boolean'];
  stripe: StripeMutation;
  stripeDirectDebit: StripeDirectDebitMutations;
  /**
   * Update payments account with additional information
   * @deprecated Generic endpoint is no longer in use, please use payment provider-specific
   */
  updateAccount: PaymentsAccount;
};


/** Mutations for creating payments accounts and charges */
export type PaymentsMutationclearBillPayerArgs = {
  billPayerId: Scalars['BillPayerId'];
};


/** Mutations for creating payments accounts and charges */
export type PaymentsMutationdeletePaymentSourceArgs = {
  paymentSourceId: Scalars['PaymentsSourceId'];
};


/** Mutations for creating payments accounts and charges */
export type PaymentsMutationdisableFamlyPayArgs = {
  paymentsAccountId: Scalars['PaymentsAccountId'];
};


/** Mutations for creating payments accounts and charges */
export type PaymentsMutationpayBalanceArgs = {
  flexPayAmount?: InputMaybe<Scalars['BadMoney']>;
  payload: Scalars['String'];
  paymentDuringCreation?: InputMaybe<Scalars['Boolean']>;
  paymentsSourceId: Scalars['PaymentsSourceId'];
};


/** Mutations for creating payments accounts and charges */
export type PaymentsMutationsavePaymentSourceArgs = {
  accountType: PaymentsAccountType;
  singleUse: Scalars['Boolean'];
  sourceToken: Scalars['String'];
};


/** Mutations for creating payments accounts and charges */
export type PaymentsMutationsetAutomaticPaymentsArgs = {
  automaticBillingDate?: InputMaybe<AutomaticBillingDateInput>;
  enabled: Scalars['Boolean'];
  paymentsAccountId: Scalars['PaymentsAccountId'];
  retryFailed?: InputMaybe<Scalars['Boolean']>;
  voucherHandlingConfiguration?: InputMaybe<VoucherHandlingConfiguration>;
};


/** Mutations for creating payments accounts and charges */
export type PaymentsMutationsetEnabledPaymentSourceTypesArgs = {
  enabledSourceTypes: Array<PaymentsSourceType>;
  paymentsAccountId: Scalars['PaymentsAccountId'];
};


/** Mutations for creating payments accounts and charges */
export type PaymentsMutationsetFlexPayArgs = {
  amount?: InputMaybe<Scalars['BadMoney']>;
  enable: Scalars['Boolean'];
  paymentsAccountId: Scalars['PaymentsAccountId'];
};


/** Mutations for creating payments accounts and charges */
export type PaymentsMutationsetFlexPayConfigArgs = {
  enable?: InputMaybe<Scalars['Boolean']>;
  maxBalanceAfterPayment?: InputMaybe<Scalars['BadMoney']>;
  minPaymentAmount?: InputMaybe<Scalars['BadMoney']>;
  paymentsAccountId: Scalars['PaymentsAccountId'];
};


/** Mutations for creating payments accounts and charges */
export type PaymentsMutationsetForBillPayerArgs = {
  billPayerId: Scalars['BillPayerId'];
  paymentsSourceId: Scalars['PaymentsSourceId'];
};


/** Mutations for creating payments accounts and charges */
export type PaymentsMutationsetParentFeeSourceTypesArgs = {
  parentFeeSourceTypes: Array<PaymentsSourceType>;
  paymentsAccountId: Scalars['PaymentsAccountId'];
};


/** Mutations for creating payments accounts and charges */
export type PaymentsMutationsetParentsNotifiedArgs = {
  paymentsAccountId: Scalars['PaymentsAccountId'];
};

/** A transfer of money from Famly to the institution */
export type PaymentsPayout = {
  __typename?: 'PaymentsPayout';
  account: PaymentsAccount;
  /** @deprecated Please use the new 'detailedCorrections' field */
  corrections: Array<PaymentsPayoutCorrection>;
  currency: Scalars['String'];
  detailedCorrections: Array<PaymentsCorrection>;
  detailedTransactions: Array<PaymentTransaction>;
  failureReason?: Maybe<Scalars['String']>;
  feeTotal: Scalars['BadMoney'];
  id: Scalars['PaymentsPayoutId'];
  payout: Scalars['BadMoney'];
  payoutDate: Scalars['LocalDate'];
  status: PayoutStatus;
  total: Scalars['BadMoney'];
  /** @deprecated Please use the new 'detailedTransactions' field */
  transactions: Array<PaymentsPayoutTransaction>;
};

/** Details about a single correction included in a payout */
export type PaymentsPayoutCorrection = {
  __typename?: 'PaymentsPayoutCorrection';
  amount: Scalars['BadMoney'];
  correctionReason: Scalars['String'];
  correctionType: CorrectionType;
  datetime: Scalars['ZonedDateTime'];
  fee: Scalars['BadMoney'];
  relatedTransaction?: Maybe<PaymentsPayoutTransaction>;
};

/** Details about a single transaction included in a payout */
export type PaymentsPayoutTransaction = {
  __typename?: 'PaymentsPayoutTransaction';
  amount: Scalars['BadMoney'];
  billPayer: BillPayer;
  datetime: Scalars['ZonedDateTime'];
  fee: Scalars['BadMoney'];
  paymentId: Scalars['PaymentId'];
};

/** The total payout volume for a given period */
export type PaymentsPayoutVolume = {
  __typename?: 'PaymentsPayoutVolume';
  currency: Scalars['String'];
  fees: Scalars['BigDecimal'];
  period: TimeRangeClosed;
  total: Scalars['BigDecimal'];
};

/** Optional promo link shown in banner or widget */
export type PaymentsPromoLink = {
  __typename?: 'PaymentsPromoLink';
  displayText: Scalars['String'];
  url: Scalars['String'];
};

/** A representation a credit card, direct debit or similar source usable for payments */
export type PaymentsSource = {
  __typename?: 'PaymentsSource';
  active: Scalars['Boolean'];
  behaviors: Array<Behavior>;
  expiryMonth?: Maybe<Scalars['String']>;
  expiryYear?: Maybe<Scalars['String']>;
  id: Scalars['PaymentsSourceId'];
  lastDigits?: Maybe<Scalars['String']>;
  owner?: Maybe<Login>;
  status: PaymentsSourceStatus;
  title: Scalars['String'];
  type: PaymentsSourceType;
};

export enum PaymentsSourceFilterInputType {
  /** ACH */
  ACH = 'ACH',
  /** ACSS */
  ACSS = 'ACSS',
  /** Bacs Direct Debit */
  BACS = 'BACS',
  /** Credit Card */
  CREDIT_CARD = 'CREDIT_CARD',
  /** Debit Card */
  DEBIT_CARD = 'DEBIT_CARD',
  NOT_SET_UP = 'NOT_SET_UP',
  /** SEPA */
  SEPA = 'SEPA'
}

export enum PaymentsSourceIcon {
  /** ACH Direct Debit payments */
  ACH = 'ACH',
  /** ACSS Direct Debit payments */
  ACSS = 'ACSS',
  /** BACS Direct Debit payments */
  BACS = 'BACS',
  /** Card payments */
  CARDS = 'CARDS',
  /** SEPA Direct Debit payments */
  SEPA = 'SEPA'
}

/** Determines whether a source can be used for payments */
export enum PaymentsSourceStatus {
  /** This payments source is temporarily disabled */
  DISABLED = 'DISABLED',
  /** This payment source failed to authorize */
  FAILED = 'FAILED',
  /** This payments source is invalid for use */
  INVALID = 'INVALID',
  /** This payments source is pending validation */
  PENDING = 'PENDING',
  /** This payments source can be used to make payments */
  READY = 'READY'
}

/** The type of entity this payments source represents */
export enum PaymentsSourceType {
  /** ACH */
  ACH = 'ACH',
  /** ACSS */
  ACSS = 'ACSS',
  /** Bacs Direct Debit */
  BACS = 'BACS',
  /** Credit Card */
  CREDIT_CARD = 'CREDIT_CARD',
  /** Debit Card */
  DEBIT_CARD = 'DEBIT_CARD',
  /** SEPA */
  SEPA = 'SEPA'
}

export type PaymentsWidgetPaymentsMade = {
  __typename?: 'PaymentsWidgetPaymentsMade';
  total: Scalars['Int'];
  viaFamlyPay: Scalars['Int'];
};

export type PaymentsWidgetPaymentsReceived = {
  __typename?: 'PaymentsWidgetPaymentsReceived';
  currentPeriod: Scalars['BadMoney'];
};

export type PaymentsWidgetType = Widget & {
  __typename?: 'PaymentsWidgetType';
  id: Scalars['HomeWidgetId'];
  next?: Maybe<Scalars['HomeWidgetCursor']>;
  paymentsMade: PaymentsWidgetPaymentsMade;
  paymentsReceived: PaymentsWidgetPaymentsReceived;
  title: Scalars['String'];
  widgetId: Scalars['String'];
};

/** The current status of the payout */
export enum PayoutStatus {
  /** Payout was canceled */
  CANCELED = 'CANCELED',
  /** Payout transferred to bank account */
  COMPLETED = 'COMPLETED',
  /** Payout failed to transfer to bank account */
  FAILED = 'FAILED',
  /** Payout is in transit to bank account */
  IN_TRANSIT = 'IN_TRANSIT',
  /** Payout is waiting to be transferred */
  PENDING = 'PENDING'
}

/** The meal booking settings for a specific child. */
export type PerChildMealBookingSettings = {
  __typename?: 'PerChildMealBookingSettings';
  canIgnoreDeadline: Scalars['Boolean'];
  /** Whether the user has permissions to manage the child's meal bookings. */
  canManageBookings: Scalars['Boolean'];
  child: Child;
  deadline: MealBookingDeadline;
  /** Use to flag when a booking is too early. If None, no restrictions apply. */
  earliestDateToBook?: Maybe<EarliestDateToBook>;
};

export type PerItem = Funding & {
  __typename?: 'PerItem';
  accountId?: Maybe<Scalars['AccountId']>;
  allProducts: Scalars['Boolean'];
  allSessions: Scalars['Boolean'];
  applyOnPlans: Scalars['Boolean'];
  applyOnPurchases: Scalars['Boolean'];
  behaviors: Array<Behavior>;
  billPayer?: Maybe<BillPayer>;
  billPayerId?: Maybe<Scalars['BillPayerId']>;
  discontinued: Scalars['Boolean'];
  fixedTotal: Scalars['Boolean'];
  id: Scalars['FundingTypeId'];
  institutionId: Scalars['InstitutionId'];
  products: Array<Scalars['ProductId']>;
  sessions: Array<Scalars['SessionId']>;
  title: Scalars['String'];
};

export type PerSite = {
  __typename?: 'PerSite';
  /** Returns the highest payment method restriction for each active site for the current user */
  paymentMethod: Array<SiteRestriction>;
};

export type PerSitePermissions = {
  __typename?: 'PerSitePermissions';
  canViewReports: Scalars['Boolean'];
  siteSetId: Scalars['SiteSetId'];
};

export type PeriodContractedHours = {
  __typename?: 'PeriodContractedHours';
  dailyContractedHoursAvg: Scalars['Float'];
  employeeId: Scalars['EmployeeId'];
  periodContractedHoursTotal: Scalars['Float'];
  range: TimeRangeClosed;
};

/** Queries related to period plans */
export type PeriodPlan = {
  __typename?: 'PeriodPlan';
  list: PeriodPlanListResult;
};


/** Queries related to period plans */
export type PeriodPlanlistArgs = {
  after?: InputMaybe<Scalars['PeriodPlanCursor']>;
  childId?: InputMaybe<Scalars['ChildId']>;
  evaluated?: InputMaybe<Scalars['Boolean']>;
  from?: InputMaybe<Scalars['LocalDate']>;
  groupIds?: InputMaybe<Array<Scalars['GroupId']>>;
  institutionId: Scalars['InstitutionId'];
  limit?: InputMaybe<Scalars['Int']>;
  periodPlanIds?: InputMaybe<Array<Scalars['PeriodPlanId']>>;
  statuses?: InputMaybe<Array<PeriodPlanStatus>>;
  tagIds?: InputMaybe<Array<Scalars['TagId']>>;
  to?: InputMaybe<Scalars['LocalDate']>;
};

/** The result of the 'create' mutation */
export type PeriodPlanCreationResult = {
  __typename?: 'PeriodPlanCreationResult';
  periodPlans: Array<PeriodPlanInterface>;
};

/** The result of the delete mutation */
export type PeriodPlanDeleteResult = {
  __typename?: 'PeriodPlanDeleteResult';
  deleted: Array<Scalars['PeriodPlanId']>;
};

/** Period plan for group */
export type PeriodPlanGroup = PeriodPlanInterface & {
  __typename?: 'PeriodPlanGroup';
  behaviors: Array<Behavior>;
  endDate: Scalars['LocalDate'];
  evaluated: Scalars['Boolean'];
  form: GenericForm;
  group: Group;
  id: Scalars['PeriodPlanId'];
  /** Institution in which the period plan was created */
  institution: Site;
  startDate: Scalars['LocalDate'];
  status: PeriodPlanStatus;
};

/** Input required to create or update a PeriodPlan */
export type PeriodPlanInput = {
  /** The input to the underlying generic form */
  genericFormInput: GenericFormInput;
  /** Mutually exclusive with tagId */
  groupId?: InputMaybe<Scalars['GroupId']>;
  /** The id of the institution the period plan is for */
  institutionId: Scalars['InstitutionId'];
  /** The date range the PeriodPlan covers */
  period: ClosedLocalDateRange;
  /** The status the period plan has */
  status: PeriodPlanStatus;
  /** Mutually exclusive with groupId */
  tagId?: InputMaybe<Scalars['TagId']>;
};

/** Period plan for group or tag */
export type PeriodPlanInterface = {
  behaviors: Array<Behavior>;
  endDate: Scalars['LocalDate'];
  evaluated: Scalars['Boolean'];
  form: GenericForm;
  id: Scalars['PeriodPlanId'];
  /** Institution in which the period plan was created */
  institution: Site;
  startDate: Scalars['LocalDate'];
  status: PeriodPlanStatus;
};

/** List of period plans with pagination */
export type PeriodPlanListResult = {
  __typename?: 'PeriodPlanListResult';
  next?: Maybe<Scalars['PeriodPlanCursor']>;
  result: Array<PeriodPlanInterface>;
};

/** Object holding mutations which can be carried out on Period Plans */
export type PeriodPlanMutations = {
  __typename?: 'PeriodPlanMutations';
  create: PeriodPlanCreationResult;
  delete: PeriodPlanDeleteResult;
  update: PeriodPlanUpdateResult;
};


/** Object holding mutations which can be carried out on Period Plans */
export type PeriodPlanMutationscreateArgs = {
  periodPlans: Array<PeriodPlanInput>;
};


/** Object holding mutations which can be carried out on Period Plans */
export type PeriodPlanMutationsdeleteArgs = {
  institutionId: Scalars['InstitutionId'];
  periodPlanIds: Array<Scalars['PeriodPlanId']>;
};


/** Object holding mutations which can be carried out on Period Plans */
export type PeriodPlanMutationsupdateArgs = {
  periodPlans: Array<PeriodPlanUpdate>;
};

export enum PeriodPlanStatus {
  DRAFT = 'DRAFT',
  PUBLISHED = 'PUBLISHED'
}

/** Period plan for tag */
export type PeriodPlanTag = PeriodPlanInterface & {
  __typename?: 'PeriodPlanTag';
  behaviors: Array<Behavior>;
  endDate: Scalars['LocalDate'];
  evaluated: Scalars['Boolean'];
  form: GenericForm;
  id: Scalars['PeriodPlanId'];
  /** Institution in which the period plan was created */
  institution: Site;
  startDate: Scalars['LocalDate'];
  status: PeriodPlanStatus;
  tag: Tag;
};

export type PeriodPlanUpdate = {
  id: Scalars['PeriodPlanId'];
  input: PeriodPlanInput;
};

/** The result of the 'update' mutation */
export type PeriodPlanUpdateResult = {
  __typename?: 'PeriodPlanUpdateResult';
  periodPlans: Array<PeriodPlanInterface>;
};

/** A single permission with no sub-permissions */
export type PermissionLeaf = PermissionTree & {
  __typename?: 'PermissionLeaf';
  /** A reference code for the permission */
  code?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  /** The name of this permission */
  title: Scalars['String'];
};

/** A group of permissions */
export type PermissionNode = PermissionTree & {
  __typename?: 'PermissionNode';
  /** A reference code for the permission */
  code?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  permissions: Array<PermissionTree>;
  /** The name of this permission */
  title: Scalars['String'];
};

/** A tree of permissions, grouped into sub-trees */
export type PermissionTree = {
  /** A reference code for the permission */
  code?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  /** The name of this permission */
  title: Scalars['String'];
};

export type Person = {
  __typename?: 'Person';
  name: Name;
  profileImage?: Maybe<ProfileImage>;
};

export type PersonContextTarget = {
  __typename?: 'PersonContextTarget';
  children: Array<Child>;
  person: Person;
};

/** Payments objects and endpoints related to the logged in user */
export type Personal = {
  __typename?: 'Personal';
  associatedBillPayers: Array<AssociatedBillPayer>;
  userPaymentSourceTypes: Array<PaymentsSourceType>;
};


/** Payments objects and endpoints related to the logged in user */
export type PersonaluserPaymentSourceTypesArgs = {
  billPayerId?: InputMaybe<Scalars['BillPayerId']>;
};

/** Input for a contact phone */
export type PhoneInput = {
  phoneType: PhoneType;
  value: Scalars['PhoneNumber'];
};

/** A phone number that may or may not be valid */
export type PhoneNumberType = {
  __typename?: 'PhoneNumberType';
  formatted?: Maybe<Scalars['String']>;
  phoneType?: Maybe<PhoneType>;
  value: Scalars['String'];
};

export enum PhoneType {
  HOME = 'HOME',
  MOBILE = 'MOBILE',
  WORK = 'WORK'
}

export type PinUser = {
  __typename?: 'PinUser';
  email: Scalars['EmailAddress'];
  id: Scalars['LoginId'];
  image?: Maybe<ProfileImage>;
  lastSeen: Scalars['ZonedDateTime'];
  name: Name;
};

/** A plan for a child */
export type Plan = {
  __typename?: 'Plan';
  child: Child;
  parts: Array<PlanPart>;
  planId: Scalars['PlanId'];
  /** If empty/null, automatic pricing groups/bands are used */
  pricingGroup?: Maybe<PricingGroup>;
  range: NonEmptyLocalDateRange;
};

/** A booking appearing on a plan */
export type PlanBooking = {
  planId: Scalars['PlanId'];
  planPartId: Scalars['PlanPartId'];
};

/** Funding on a plan */
export type PlanFunding = {
  /** The funding method that is in use */
  method: Scalars['String'];
  period: FinancePeriodFunding;
  /** The funded time may be given as either hours or minutes */
  time: PlanFundingTime;
};

/** Assisted funding */
export type PlanFundingAssisted = PlanFunding & {
  __typename?: 'PlanFundingAssisted';
  /** The funding method that is in use */
  method: Scalars['String'];
  period: FinancePeriodFunding;
  /** The funded time may be given as either hours or minutes */
  time: PlanFundingTime;
};

/** Manual funding */
export type PlanFundingManual = PlanFunding & {
  __typename?: 'PlanFundingManual';
  amount: Scalars['BadMoney'];
  /** The funding method that is in use */
  method: Scalars['String'];
  period: FinancePeriodFunding;
  /** The funded time may be given as either hours or minutes */
  time: PlanFundingTime;
};

/** Manual funding by rate */
export type PlanFundingManualByRate = PlanFunding & {
  __typename?: 'PlanFundingManualByRate';
  /** The funding method that is in use */
  method: Scalars['String'];
  period: FinancePeriodFunding;
  rate: Scalars['BadMoney'];
  /** The funded time may be given as either hours or minutes */
  time: PlanFundingTime;
};

export type PlanFundingSettingsQueries = {
  __typename?: 'PlanFundingSettingsQueries';
  maxFundedMinutesPerDay: MaxFundedMinutesPerDay;
};


export type PlanFundingSettingsQueriesmaxFundedMinutesPerDayArgs = {
  planId: Scalars['PlanId'];
  siteSetId: Scalars['InstitutionSetId'];
};

/** The funded time */
export type PlanFundingTime = PlanFundingTimeHours | PlanFundingTimeMinutes;

/** The funded time defined as hours */
export type PlanFundingTimeHours = {
  __typename?: 'PlanFundingTimeHours';
  hours: Scalars['Float'];
};

/** The funded time defined as minutes */
export type PlanFundingTimeMinutes = {
  __typename?: 'PlanFundingTimeMinutes';
  minutes: Scalars['Int'];
};

/** A plan line */
export type PlanLine = InvoiceLine & {
  __typename?: 'PlanLine';
  originalTotal?: Maybe<Scalars['BadMoney']>;
  /** @deprecated Use planIdOpt instead. Returns a 'nil UUID' if planIdOpt is null */
  planId: Scalars['PlanId'];
  planIdOpt?: Maybe<Scalars['PlanId']>;
  planLineId: Scalars['PlanLineId'];
  range: TimeRangeClosed;
  shareLineRelations: Array<SubLineRelation>;
  total: Scalars['BadMoney'];
};

/** A part of a plan */
export type PlanPart = {
  __typename?: 'PlanPart';
  annualization?: Maybe<Annualization>;
  attendanceSchedule?: Maybe<AttendanceSchedule>;
  billingProfile?: Maybe<BillingProfile>;
  billingScheme: BillingScheme;
  bookings: Array<PlanBooking>;
  /** Only plan parts with order = 0 can have funding */
  funding?: Maybe<PlanFunding>;
  order: Scalars['Int'];
  planPartId: Scalars['PlanPartId'];
  termTimeOnly: Scalars['Boolean'];
};

/** Holds information on FTE calculation for a child based on single plan part and opening hours only */
export type PlanPartFte = {
  __typename?: 'PlanPartFte';
  /** ID of the child */
  childId: Scalars['ChildId'];
  /** FTE value */
  fte: Scalars['Float'];
  /** ID of the plan part */
  planPartId: Scalars['PlanPartId'];
};

/** A product/extra charge booking appearing on a plan */
export type PlanProductBooking = PlanBooking & {
  __typename?: 'PlanProductBooking';
  /** The number of this item that has been booked */
  amount: Scalars['Int'];
  planId: Scalars['PlanId'];
  planPartId: Scalars['PlanPartId'];
  productAvailability: ProductAvailability;
  productBookingId: Scalars['Int'];
};

/** A session booking appearing on a plan */
export type PlanSessionBooking = PlanBooking & {
  __typename?: 'PlanSessionBooking';
  planId: Scalars['PlanId'];
  planPartId: Scalars['PlanPartId'];
  sessionAvailability: SessionAvailability;
  sessionBookingId: Scalars['SessionBookingId'];
  /** Should be preferred over the time range available on the sessionAvailability field, since it may be different for bookings with flexible hours */
  timeRange: TimeRangeClosedLocalTime;
};

export type Playground = {
  __typename?: 'Playground';
  error: Scalars['String'];
  triggerError: Scalars['Boolean'];
};


export type PlaygrounderrorArgs = {
  badClient?: InputMaybe<Scalars['Boolean']>;
  badRequest?: InputMaybe<Scalars['Boolean']>;
  debug?: InputMaybe<Scalars['String']>;
  display?: InputMaybe<Scalars['String']>;
  includeData?: InputMaybe<Scalars['Boolean']>;
  log?: InputMaybe<Scalars['Boolean']>;
  payload?: InputMaybe<Scalars['String']>;
  severity?: InputMaybe<Scalars['String']>;
  statusCode?: InputMaybe<Scalars['Int']>;
};

export type Position = {
  __typename?: 'Position';
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
};

export type PositionInput = {
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
};

/** Possible recipient information */
export type PossibleRecipientsInterface = {
  profileImage?: Maybe<ProfileImage>;
  subtitle?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

/** Information about the possible recipients */
export type PossibleRecipientsResult = {
  __typename?: 'PossibleRecipientsResult';
  /** Possible recipient information */
  elements: Array<PossibleRecipientsInterface>;
  /** Cursor to query the next elements, if not all elements are shown because of pagination */
  next?: Maybe<Scalars['PossibleRecipientCursor']>;
};

/** A leaf in the possible recipient tree structure */
export type PossibleRecipientsTreeLeaf = PossibleRecipientsInterface & {
  __typename?: 'PossibleRecipientsTreeLeaf';
  profileImage?: Maybe<ProfileImage>;
  recipients: Array<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

/** A node in the possible recipient tree structure */
export type PossibleRecipientsTreeNode = PossibleRecipientsInterface & {
  __typename?: 'PossibleRecipientsTreeNode';
  nextChild?: Maybe<Scalars['PossibleRecipientCursor']>;
  profileImage?: Maybe<ProfileImage>;
  subtitle?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type PossibleSignInsResult = {
  __typename?: 'PossibleSignInsResult';
  children: Array<ChildSignInResult>;
  staff: Array<PossibleStaffSignInsResult>;
};

export type PossibleStaffSignInsResult = {
  __typename?: 'PossibleStaffSignInsResult';
  /** Employee information, currently without contact details and role information */
  employee: Employee;
  /** The list of groups that the employee could sign into */
  groups: Array<Group>;
  /** If not null, the group that the employee is currently signed in */
  signedIn?: Maybe<Group>;
  site: Site;
  statements: Array<CheckInStatementResult>;
};

/** Details about the price per message */
export type PricePerMessage = {
  __typename?: 'PricePerMessage';
  /** The warning shown prior to sending a SMS message */
  warning: Scalars['String'];
};

/** The pricing of a revenue item */
export type Pricing = {
  __typename?: 'Pricing';
  adHocPrice?: Maybe<Scalars['BadMoney']>;
  period: FinancePeriod;
  price?: Maybe<Scalars['BadMoney']>;
  pricingGroupId: Scalars['PricingGroupId'];
  volume: Scalars['Int'];
};

export type PricingGroup = {
  __typename?: 'PricingGroup';
  deleted: Scalars['Boolean'];
  pricingGroupId: Scalars['PricingGroupId'];
  title: Scalars['Title'];
};

export type PricingGroupInput = {
  pricingGroupId?: InputMaybe<Scalars['PricingGroupId']>;
  title: Scalars['Title'];
};

export type PricingGroupMutations = {
  __typename?: 'PricingGroupMutations';
  setPricingGroups: Array<PricingGroup>;
};


export type PricingGroupMutationssetPricingGroupsArgs = {
  institutionSetId: Scalars['InstitutionSetId'];
  pricingGroups: Array<PricingGroupInput>;
};

export type PricingGroupQueries = {
  __typename?: 'PricingGroupQueries';
  behaviors: Array<Behavior>;
  list: Array<PricingGroup>;
};


export type PricingGroupQueriesbehaviorsArgs = {
  institutionSetId?: InputMaybe<Scalars['InstitutionSetId']>;
};


export type PricingGroupQuerieslistArgs = {
  includeDeleted?: Scalars['Boolean'];
  institutionSetIds?: InputMaybe<Array<Scalars['InstitutionSetId']>>;
  pricingGroupIds?: InputMaybe<Array<Scalars['PricingGroupId']>>;
};

/** The primary funding relation/contact for a child. */
export type PrimaryFundingRelation = {
  childId: Scalars['ChildId'];
  /** Sending null will remove the primary funding relation for this child. */
  relationId?: InputMaybe<Scalars['RelationId']>;
};

/** A user's private activity library */
export type PrivateActivityLibrary = {
  __typename?: 'PrivateActivityLibrary';
  id: Scalars['String'];
};

/** A product availability */
export type ProductAvailability = Availability & {
  __typename?: 'ProductAvailability';
  day: Scalars['DayOfWeek'];
  product: ProductVersion;
  productAvailabilityId: Scalars['ProductAvailabilityId'];
};

/** An ad hoc purchase booking of a product */
export type ProductPurchase = {
  __typename?: 'ProductPurchase';
  /** The number of times a product was booked */
  amount: Scalars['Int'];
  bookedPrice?: Maybe<Scalars['BadMoney']>;
  pricingGroupId: Scalars['PricingGroupId'];
  productAvailability: ProductAvailability;
  productAvailabilityId: Scalars['ProductAvailabilityId'];
  productPurchaseId: Scalars['ProductPurchaseId'];
  purchaseDate: Scalars['LocalDate'];
};

export type ProductPurchaseInput = {
  amount: Scalars['Int'];
  /** The (positive) price before multiplying by amount or applying any discounts */
  bookedPrice?: InputMaybe<Scalars['BadMoney']>;
  pricingGroupId: Scalars['PricingGroupId'];
  productAvailabilityId: Scalars['ProductAvailabilityId'];
  /** Note: The returned purchase might not use this ID */
  productPurchaseId?: InputMaybe<Scalars['ProductPurchaseId']>;
  purchaseDate: Scalars['LocalDate'];
};

/** A product version */
export type ProductVersion = RevenueItem & {
  __typename?: 'ProductVersion';
  active: Scalars['Boolean'];
  billOnChildAbsent: Scalars['Boolean'];
  billOnChildSick: Scalars['Boolean'];
  billOnClosingDays: Array<ClosingDay>;
  color: Scalars['Int'];
  discountable: Scalars['Boolean'];
  institutionSetId: Scalars['InstitutionSetId'];
  pricing: Array<Pricing>;
  productAvailabilities: Array<ProductAvailability>;
  productId: Scalars['ProductId'];
  productVersionId: Scalars['ProductVersionId'];
  title: Scalars['String'];
  validFrom: Scalars['LocalDate'];
  validTo?: Maybe<Scalars['LocalDate']>;
};

/** A profile image */
export type ProfileImage = {
  __typename?: 'ProfileImage';
  url: Scalars['String'];
};


/** A profile image */
export type ProfileImageurlArgs = {
  resolution?: InputMaybe<Scalars['Int']>;
};

/**
 * Describes the overall progress for an area as defined by its area configuration.
 * This type has no meaning if there is no report configuration for the area.
 */
export type Progress = AreaReport & {
  __typename?: 'Progress';
  area: Area;
  assessment?: Maybe<ChildDevelopmentProgressAssessment>;
  subTitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type PromiseCards = {
  __typename?: 'PromiseCards';
  description: Scalars['String'];
  illustrationSrc: Scalars['String'];
  title: Scalars['String'];
};

export type PromiseSection = {
  __typename?: 'PromiseSection';
  promiseCards: Array<PromiseCards>;
  title: Scalars['String'];
};

/** Promos-specific payments endpoints */
export type Promos = {
  __typename?: 'Promos';
  famlyPay: FamlyPay;
  paymentAdoptionPromos: Array<PaymentAdoptionPromoPreview>;
};


/** Promos-specific payments endpoints */
export type PromospaymentAdoptionPromosArgs = {
  location: PaymentPromoLocation;
  siteSetId: Scalars['SiteSetId'];
};

/** The available writing assistant prompts */
export enum PromptType {
  conversationalTone = 'conversationalTone',
  correctSpellingGrammar = 'correctSpellingGrammar',
  easyToRead = 'easyToRead',
  improveWriting = 'improveWriting',
  observantTone = 'observantTone',
  politeTone = 'politeTone',
  professionalTone = 'professionalTone',
  santaClausTone = 'santaClausTone',
  shortenText = 'shortenText'
}

/** Domain object of Payments Feed which is created by payment bulk importing */
export type ProtoPayment = {
  __typename?: 'ProtoPayment';
  amount: Scalars['Float'];
  billPayerName?: Maybe<Scalars['String']>;
  billPayerReference?: Maybe<Scalars['String']>;
  childName?: Maybe<Scalars['String']>;
  /** xero-flavored description */
  description?: Maybe<Scalars['String']>;
  invoiceNumber?: Maybe<Scalars['Int']>;
  /** this field is deprecated. It is part of a scheme for backwards-compatibility only returning always nothing. */
  originAccount?: Maybe<Scalars['String']>;
  /** Active payment that was created from this ProtoPayment. A ProtoPayment that hasn't been imported yet will not have a payment attached. */
  payment?: Maybe<Payment>;
  paymentDate: Scalars['LocalDate'];
  paymentMethod?: Maybe<Scalars['String']>;
  paymentsFeedId: Scalars['PaymentsFeedId'];
  processedAt?: Maybe<Scalars['ZonedDateTime']>;
  referenceText?: Maybe<Scalars['String']>;
  rowNumber: Scalars['Int'];
  voucherCompany?: Maybe<Scalars['String']>;
  /**
   * Was the billPayer notified (ex.: email) when the ProtoPayment was converted to a Payment?
   * This field is null if the ProtoPayment hasn't been converted to a Payment yet.
   * NOTE: ProtoPayments converted before 2022-04-20 will always have this field set to null.
   *
   */
  wasBillPayerNotified?: Maybe<Scalars['Boolean']>;
};

export type ProtoPaymentQueries = {
  __typename?: 'ProtoPaymentQueries';
  list: ProtoPaymentResult;
};


export type ProtoPaymentQuerieslistArgs = {
  count: Scalars['Int'];
  cursor?: InputMaybe<Scalars['ProtoPaymentCursor']>;
  paymentsFeedIds: Array<Scalars['PaymentsFeedId']>;
};

/** A paged list of payments feeds with a cursor */
export type ProtoPaymentResult = {
  __typename?: 'ProtoPaymentResult';
  cursor?: Maybe<Scalars['ProtoPaymentCursor']>;
  protoPayments: Array<ProtoPayment>;
};

/** The global public library */
export type PublicActivityLibrary = {
  __typename?: 'PublicActivityLibrary';
  id: Scalars['String'];
};

export type PublicChild = {
  __typename?: 'PublicChild';
  child: Child;
  id: Scalars['ChildId'];
  institutionId: Scalars['InstitutionId'];
  name: Scalars['String'];
  profileImage?: Maybe<ProfileImage>;
};

/** Public funding settings */
export type PublicFundingSettings = {
  __typename?: 'PublicFundingSettings';
  maxFundedMinutesPerDay: Scalars['Int'];
  settingsId: Scalars['PublicFundingSettingsId'];
};

export type PublicFundingSettingsMutations = {
  __typename?: 'PublicFundingSettingsMutations';
  delete: Scalars['PublicFundingSettingsId'];
  save: PublicFundingSettings;
};


export type PublicFundingSettingsMutationsdeleteArgs = {
  settingsId: Scalars['PublicFundingSettingsId'];
};


export type PublicFundingSettingsMutationssaveArgs = {
  maxFundedMinutesPerDay: Scalars['Int'];
  siteSetId: Scalars['InstitutionSetId'];
};

export type PublicFundingSettingsQueries = {
  __typename?: 'PublicFundingSettingsQueries';
  list?: Maybe<PublicFundingSettings>;
};


export type PublicFundingSettingsQuerieslistArgs = {
  siteSetId: Scalars['InstitutionSetId'];
};

export type PublicKey = {
  __typename?: 'PublicKey';
  name: Scalars['String'];
  value: Scalars['String'];
};

/** Details of site set or an institution */
export type PublicSiteSetDetails = {
  __typename?: 'PublicSiteSetDetails';
  locale: Scalars['String'];
  privacyPolicyUrl?: Maybe<Scalars['String']>;
  siteSetInformation: InstitutionSet;
};

export type PublishedShiftManagementType = {
  __typename?: 'PublishedShiftManagementType';
  canBulkDelete: Scalars['Boolean'];
  canCreate: Scalars['Boolean'];
  canDelete: Scalars['Boolean'];
  canEdit: Scalars['Boolean'];
  /** `canView` returns true whenever the calling user is an employee and allowed to view shifts assigned to them. */
  canView: Scalars['Boolean'];
};

/** An ad hoc purchase */
export type Purchase = {
  __typename?: 'Purchase';
  approvedAt?: Maybe<Scalars['ZonedDateTime']>;
  approvedBy?: Maybe<Person>;
  behaviors: Array<Behavior>;
  child: Child;
  createdAt: Scalars['ZonedDateTime'];
  discountAmount: Scalars['BadMoney'];
  id: Scalars['PurchaseId'];
  invoiceStatus: InvoiceStatus;
  invoices?: Maybe<Array<Invoice>>;
  invoicesWithoutLines?: Maybe<Array<InvoiceWithoutLines>>;
  note?: Maybe<Scalars['String']>;
  noteVisibleToParents?: Maybe<Scalars['Boolean']>;
  /** Can be used to order purchases. Defaults to earliest booking date. */
  ordering: Scalars['Long'];
  productBookings: Array<ProductPurchase>;
  rejectedAt?: Maybe<Scalars['ZonedDateTime']>;
  rejectedBy?: Maybe<Person>;
  rejectionMessage?: Maybe<Scalars['String']>;
  sessionBookings: Array<SessionPurchase>;
  type: Scalars['String'];
};


/** An ad hoc purchase */
export type PurchaseorderingArgs = {
  ordering?: InputMaybe<PurchaseOrdering>;
};

export enum PurchaseApprovalStatusType {
  Approved = 'Approved'
}

export type PurchaseAutomaticPricing = {
  __typename?: 'PurchaseAutomaticPricing';
  dates: NonEmptyLocalDateRange;
  pricingGroupId: Scalars['PricingGroupId'];
};

export type PurchaseAutomaticPricingForChild = {
  __typename?: 'PurchaseAutomaticPricingForChild';
  childId: Scalars['ChildId'];
  ruleGroups: Array<PurchaseAutomaticPricingForRuleGroup>;
};

export type PurchaseAutomaticPricingForRuleGroup = {
  __typename?: 'PurchaseAutomaticPricingForRuleGroup';
  childId: Scalars['ChildId'];
  pricing: Array<PurchaseAutomaticPricing>;
  ruleGroupId: Scalars['RuleGroupId'];
};

export type PurchaseAutomaticPricingResult = {
  __typename?: 'PurchaseAutomaticPricingResult';
  children: Array<PurchaseAutomaticPricingForChild>;
};

export type PurchaseInput = {
  approve?: InputMaybe<PurchaseApprovalStatusType>;
  childId: Scalars['ChildId'];
  discountAmount: Scalars['BadMoney'];
  note?: InputMaybe<Scalars['String']>;
  noteVisibleToParents?: InputMaybe<Scalars['Boolean']>;
  productBookings: Array<ProductPurchaseInput>;
  purchaseId?: InputMaybe<Scalars['PurchaseId']>;
  sessionBookings: Array<SessionPurchaseInput>;
};

/** A purchase line */
export type PurchaseLine = InvoiceLine & {
  __typename?: 'PurchaseLine';
  originalTotal?: Maybe<Scalars['BadMoney']>;
  /** @deprecated Use purchaseIdOpt instead. Returns a 'nil UUID' (all bits set to 0, so '00000000-0000-0000-0000-000000000000') if purchaseIdOpt is null. */
  purchaseId: Scalars['PurchaseId'];
  purchaseIdOpt?: Maybe<Scalars['PurchaseId']>;
  purchaseLineId: Scalars['PurchaseLineId'];
  range: TimeRangeClosed;
  shareLineRelations: Array<SubLineRelation>;
  total: Scalars['BadMoney'];
};

export type PurchaseMutations = {
  __typename?: 'PurchaseMutations';
  /** @deprecated Use the approve field in the update mutation */
  approve: Array<Purchase>;
  delete: Array<Scalars['PurchaseId']>;
  reject: Array<Scalars['PurchaseId']>;
  update: Array<Purchase>;
};


export type PurchaseMutationsapproveArgs = {
  purchaseIds: Array<Scalars['PurchaseId']>;
};


export type PurchaseMutationsdeleteArgs = {
  purchaseIds: Array<Scalars['PurchaseId']>;
};


export type PurchaseMutationsrejectArgs = {
  message: Scalars['String'];
  purchaseIds: Array<Scalars['PurchaseId']>;
};


export type PurchaseMutationsupdateArgs = {
  purchases: Array<PurchaseInput>;
};

export enum PurchaseOrdering {
  ByCreation = 'ByCreation',
  ByEarliestBooking = 'ByEarliestBooking'
}

export type PurchaseQueries = {
  __typename?: 'PurchaseQueries';
  /**
   * Pricing for ad-hoc purchases based on pricing group/band move rules (also known as pricing advance rules).
   * The result contains each applicable pricing group ID paired with the date range for which it applies for the given children.
   *
   */
  automaticPricing: PurchaseAutomaticPricingResult;
  behaviors: Array<Behavior>;
  filter: PurchaseResult;
  /** @deprecated Use the filter field instead. This field will only allow you to fetch the first 100 purchases. */
  list: Array<Purchase>;
};


export type PurchaseQueriesautomaticPricingArgs = {
  childIds: Array<Scalars['ChildId']>;
  siteId: Scalars['SiteId'];
};


export type PurchaseQueriesbehaviorsArgs = {
  childId?: InputMaybe<Scalars['ChildId']>;
  institutionSetId?: InputMaybe<Scalars['InstitutionSetId']>;
};


export type PurchaseQueriesfilterArgs = {
  after?: InputMaybe<Scalars['PurchaseCursor']>;
  approved?: InputMaybe<Scalars['Boolean']>;
  childIds?: InputMaybe<Array<Scalars['ChildId']>>;
  count?: InputMaybe<Scalars['Int']>;
  institutionSetIds?: InputMaybe<Array<Scalars['InstitutionSetId']>>;
  isParentPurchase?: InputMaybe<Scalars['Boolean']>;
  ordering?: InputMaybe<PurchaseOrdering>;
  purchaseIds?: InputMaybe<Array<Scalars['PurchaseId']>>;
  rejected?: InputMaybe<Scalars['Boolean']>;
};


export type PurchaseQuerieslistArgs = {
  after?: InputMaybe<Scalars['PurchaseCursor']>;
  approved?: InputMaybe<Scalars['Boolean']>;
  childIds?: InputMaybe<Array<Scalars['ChildId']>>;
  count?: InputMaybe<Scalars['Int']>;
  institutionSetIds?: InputMaybe<Array<Scalars['InstitutionSetId']>>;
  isParentPurchase?: InputMaybe<Scalars['Boolean']>;
  ordering?: InputMaybe<PurchaseOrdering>;
  purchaseIds?: InputMaybe<Array<Scalars['PurchaseId']>>;
  rejected?: InputMaybe<Scalars['Boolean']>;
};

/** A paged list of purchases with a cursor */
export type PurchaseResult = {
  __typename?: 'PurchaseResult';
  cursor?: Maybe<Scalars['PurchaseCursor']>;
  purchases: Array<Purchase>;
};

/** Queries and objects related to the QR signin of children and employees */
export type QRSignin = {
  __typename?: 'QRSignin';
  /** List the possible sign-ins for a user */
  possibleSignIns: PossibleSignInsResult;
  /**
   * List the QR code sign-in settings
   * @deprecated Please use siteSettings instead
   */
  settings: SettingsResultType;
  /** List the QR code sign-in settings */
  siteSettings: SiteSettingsResultType;
  /**
   * For validating that the hash would be accepted. Really only useful for local testing and might be removed later.
   * @deprecated Only use this for local testing.
   */
  validateHash: ValidateQRHashResult;
};


/** Queries and objects related to the QR signin of children and employees */
export type QRSigninpossibleSignInsArgs = {
  siteId?: InputMaybe<Scalars['SiteId']>;
};


/** Queries and objects related to the QR signin of children and employees */
export type QRSigninsettingsArgs = {
  siteId: Scalars['SiteId'];
};


/** Queries and objects related to the QR signin of children and employees */
export type QRSigninsiteSettingsArgs = {
  siteIds?: InputMaybe<Array<Scalars['SiteId']>>;
};


/** Queries and objects related to the QR signin of children and employees */
export type QRSigninvalidateHashArgs = {
  hash: Scalars['String'];
  plainText: Scalars['String'];
  secretId?: InputMaybe<Scalars['SigninSecretId']>;
  siteId: Scalars['SiteId'];
};

/** Mutations related to the QR signin of children and employees */
export type QRSigninMutation = {
  __typename?: 'QRSigninMutation';
  getSecret: QrSecret;
  signInChild: SignedInChildResult;
  signInEmployee: SignedInEmployeeResult;
  signOutChild: SignedOutChildResult;
  signOutEmployee: SignedOutEmployeeResult;
};


/** Mutations related to the QR signin of children and employees */
export type QRSigninMutationgetSecretArgs = {
  isStatic?: InputMaybe<Scalars['Boolean']>;
  preferExistingCode?: InputMaybe<Scalars['Boolean']>;
  siteId: Scalars['SiteId'];
};


/** Mutations related to the QR signin of children and employees */
export type QRSigninMutationsignInChildArgs = {
  childId: Scalars['ChildId'];
  hash: Scalars['String'];
  pickupRelationId?: InputMaybe<Scalars['RelationId']>;
  pickupTime?: InputMaybe<Scalars['LocalTime']>;
  plainText: Scalars['String'];
  signInStatements?: InputMaybe<Array<Scalars['CheckInStatementId']>>;
  siteId: Scalars['SiteId'];
};


/** Mutations related to the QR signin of children and employees */
export type QRSigninMutationsignInEmployeeArgs = {
  employeeId: Scalars['EmployeeId'];
  hash: Scalars['String'];
  plainText: Scalars['String'];
  signInStatements?: InputMaybe<Array<Scalars['CheckInStatementId']>>;
  singIntoGroup: Scalars['GroupId'];
  siteId: Scalars['SiteId'];
};


/** Mutations related to the QR signin of children and employees */
export type QRSigninMutationsignOutChildArgs = {
  childId: Scalars['ChildId'];
  hash: Scalars['String'];
  plainText: Scalars['String'];
  siteId: Scalars['SiteId'];
};


/** Mutations related to the QR signin of children and employees */
export type QRSigninMutationsignOutEmployeeArgs = {
  employeeId: Scalars['EmployeeId'];
  hash: Scalars['String'];
  plainText: Scalars['String'];
  siteId: Scalars['SiteId'];
};

export type QrSecret = {
  __typename?: 'QrSecret';
  secret: Scalars['String'];
  siteId: Scalars['SiteId'];
  /** Timezone set to UTC */
  validFrom: Scalars['ZonedDateTime'];
  /** Timezone set to UTC */
  validTo: Scalars['ZonedDateTime'];
};

export enum QrveyComponentType {
  CHART = 'CHART',
  DASHBOARD = 'DASHBOARD'
}

export type QrveyEmbedInformation = {
  __typename?: 'QrveyEmbedInformation';
  jwt: Scalars['String'];
  qrveyAppId: Scalars['String'];
  qrveyComponentType: QrveyComponentType;
  qrveyDomain: Scalars['String'];
  qrveyId: Scalars['String'];
  qrveySelfService: Scalars['Boolean'];
  qrveyUserId: Scalars['String'];
  qrveyWidgetDomain: Scalars['String'];
  reportId: Scalars['ReportId'];
};

export type QrveyReport = Report & {
  __typename?: 'QrveyReport';
  canDelete: Scalars['Boolean'];
  canSave: Scalars['Boolean'];
  categories: Array<ReportCategory>;
  createdBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']>;
  enabledFor: Array<InstitutionSet>;
  favorite: Scalars['Boolean'];
  id: Scalars['ReportId'];
  title: Scalars['String'];
};

export type Qualification = {
  __typename?: 'Qualification';
  hasCertificateNumber: Scalars['Boolean'];
  hasExpiration: Scalars['Boolean'];
  id: Scalars['StaffQualificationId'];
  institutionSetId?: Maybe<Scalars['InstitutionSetId']>;
  levels?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  unique: Scalars['Boolean'];
};

/** A staff qualification for a given employee */
export type QualificationAssignment = {
  certificateNumber?: Maybe<Scalars['String']>;
  employeeId: Scalars['EmployeeId'];
  expirationDate?: Maybe<Scalars['LocalDateTime']>;
  /** The files attached to the qualification, if any */
  files: Array<File>;
  id: Scalars['StaffQualificationAssignmentId'];
  /** The images attached to the qualification, if any */
  images: Array<Image>;
  institutionId: Scalars['InstitutionId'];
  note?: Maybe<Scalars['String']>;
  qualification: Qualification;
  qualificationDate: Scalars['LocalDateTime'];
  title?: Maybe<Scalars['String']>;
};

export type Query = {
  __typename?: 'Query';
  accidentReports: AccidentReports;
  /** Information about adding a new site the an organization */
  addNewSite: AddNewSiteQueryType;
  analytics: analytics;
  attendance: AttendanceQueries;
  audits: Array<AuditLogEntry>;
  behaviors: Array<BehaviorQuery>;
  billPayers: BillPayers;
  categoryLandingPage: CategoryLandingPageQuery;
  categoryOnboarding: CategoryOnboarding;
  childContacts: ContactsQuery;
  childDevelopment: ChildDevelopment;
  /**
   * Fetches child notes which the user has permission to see for the given children.
   * The result is paged and limited by the 'limit' argument.
   *
   */
  childNotes: ChildNotesResult;
  childProfile: ChildProfileQueries;
  children: Array<Child>;
  conversations: ConversationsField;
  dataExports: DataExportsQueries;
  datev: DatevQuery;
  device: Device;
  documents?: Maybe<Folder>;
  /** List current employees */
  employees: EmployeesResult;
  experiments: Experiments;
  facebook: FacebookIntegration;
  featureStore: FeatureStore;
  finance: Finance;
  genericForms: GenericForms;
  /** List groups by either GroupId or InstitutionId */
  groups: Array<Group>;
  headcount: Headcount;
  home: HomeQueries;
  immunizations: Immunizations;
  import: ImportQuery;
  inAppPurchase: InAppPurchaseObject;
  institutions: Array<Site>;
  kibig: Kibig;
  kinderConnect: KinderConnectQueries;
  kitaPlaner: KitaPlanerExport;
  limitationSettings: packageLimitationSettings;
  limitations: packageLimitations;
  logins: Logins;
  management: DaycareManagementQueries;
  me: Me;
  mealPlans: MealPlans;
  meals: Meals;
  mediaShare: MediaShare;
  /** Queries for media (images, videos) of tagged entities like children */
  mediaTagging: MediaTaggingQueries;
  medicationForms: MedicationForms;
  messages: Messages;
  openingHours: OpeningHoursQueries;
  /** Objects related to organization information */
  organizations: Array<OrganizationObject>;
  outOfOffice: OutOfOffice;
  paragon: ParagonQuery;
  payments: Payments;
  /** This is a place to put queries and mutations that are useful for experimenting/testing. You are free to break stuff. */
  playground: Playground;
  qrSignin: QRSignin;
  reports: ReportQueries;
  richText: RichTextQuery;
  roles: Roles;
  rss: RssIntegration;
  sales: SalesType;
  /** The root for all search related queries */
  search: Search;
  security: Security;
  settings: SettingsQueries;
  showMeHowThisWorks: ShowMeHowThisWorks;
  sidekick: Sidekick;
  signup: SignupType;
  signupInfo: SignupInfo;
  simplifiedUsInvoicing: SimplifiedUsInvoicing;
  sms: SMSQueries;
  staffQualifications: StaffQualifications;
  staffhours: StaffHoursQueries;
  store: StoreObject;
  subscriptions: Subscriptions;
  templatesPageAssets: TemplatesPageAssets;
  testChildAction: TestChildActions;
  translation: TranslationQueries;
  upgradeFromFreePackage: UpgradeFromFreePackage;
  upgradeFromPaidPackage: UpgradeFromPaidPackage;
  usageHistory: UsageHistoryQueries;
  userGenerated: UserGeneratedQueries;
  viewAsParent: ViewAsParent;
  village: VillageQueries;
  watchMeGrow: WatchMeGrowQuery;
  webhooks: WebhookQueries;
};


export type QueryauditsArgs = {
  cursor?: InputMaybe<Scalars['AuditCursor']>;
  entryTypes: Array<EntryType>;
  from: Scalars['LocalDateTime'];
  targetId: Scalars['String'];
  targetType: TargetType;
  to?: InputMaybe<Scalars['LocalDateTime']>;
};


export type QuerycategoryLandingPageArgs = {
  categoryArg?: InputMaybe<Category>;
};


export type QuerychildNotesArgs = {
  childIds: Array<Scalars['ChildId']>;
  cursor?: InputMaybe<Scalars['ChildNoteCursor']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  isAcknowledgedByParent?: InputMaybe<Scalars['Boolean']>;
  limit?: Scalars['Int'];
  noteIds?: InputMaybe<Array<Scalars['ChildNoteId']>>;
  noteTypes?: InputMaybe<Array<ChildNoteType>>;
  parentVisible?: InputMaybe<Scalars['Boolean']>;
  safeguardingConcern?: InputMaybe<Scalars['Boolean']>;
  sensitive?: InputMaybe<Scalars['Boolean']>;
};


export type QuerychildrenArgs = {
  childIds?: InputMaybe<Array<Scalars['ChildId']>>;
  gender?: InputMaybe<Gender>;
  institutionId?: InputMaybe<Scalars['InstitutionId']>;
  range?: InputMaybe<NonEmptyLocalDateRangeInput>;
  tagIds?: InputMaybe<Array<Scalars['TagId']>>;
};


export type QuerydocumentsArgs = {
  folderId?: InputMaybe<Scalars['FolderId']>;
  institutionId?: InputMaybe<Scalars['InstitutionId']>;
};


export type QueryemployeesArgs = {
  EmployeeIds?: InputMaybe<Array<Scalars['EmployeeId']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeIds?: InputMaybe<Array<Scalars['EmployeeId']>>;
  includeFuture?: InputMaybe<Scalars['Boolean']>;
  includePast?: InputMaybe<Scalars['Boolean']>;
  institutionIds?: InputMaybe<Array<Scalars['InstitutionId']>>;
  siteIds?: InputMaybe<Array<Scalars['SiteId']>>;
};


export type QueryfeatureStoreArgs = {
  siteSetId: Scalars['InstitutionSetId'];
};


export type QuerygroupsArgs = {
  groupIds?: InputMaybe<Array<Scalars['GroupId']>>;
  institutionIds?: InputMaybe<Array<Scalars['InstitutionId']>>;
};


export type QueryinstitutionsArgs = {
  institutionId?: InputMaybe<Scalars['InstitutionId']>;
  institutionIds?: InputMaybe<Array<Scalars['InstitutionId']>>;
};

/** A map of Payment queries => list of payments that matched them */
export type QueryResult = {
  __typename?: 'QueryResult';
  payments: Array<Payment>;
  query: query;
};

export type RatioInfo = {
  __typename?: 'RatioInfo';
  issues: Array<Scalars['String']>;
  status: RatioStatus;
};

export type RatioInfoDetailedPeriodsType = {
  __typename?: 'RatioInfoDetailedPeriodsType';
  date: Scalars['LocalDate'];
  expectedChildren: Scalars['Int'];
  from: Scalars['LocalTime'];
  groupId: Scalars['GroupId'];
  /** @deprecated Deprecated since App Version 153 */
  issues: Array<Scalars['String']>;
  requiredStaff: Scalars['Float'];
  scheduledStaff: Scalars['Int'];
  /** @deprecated Deprecated in App Version 167 */
  status: Scalars['String'];
  to: Scalars['LocalTime'];
};

export type RatioInfoDetailedPeriodsTypeV2 = {
  __typename?: 'RatioInfoDetailedPeriodsTypeV2';
  date: Scalars['LocalDate'];
  expectedChildren: ExpectedChildrenType;
  from: Scalars['LocalTime'];
  groupId: Scalars['GroupId'];
  requiredStaff: Scalars['Float'];
  scheduledStaff: Scalars['Int'];
  status: Scalars['String'];
  to: Scalars['LocalTime'];
};

/** Detailed ratio info includes additional ratio information for all periods of the day. */
export type RatioInfoDetailedType = {
  __typename?: 'RatioInfoDetailedType';
  date: Scalars['LocalDate'];
  expectedChildren: Scalars['Int'];
  from: Scalars['LocalTime'];
  groupId: Scalars['GroupId'];
  /** @deprecated Deprecated since App Version 153 */
  issues: Array<Scalars['String']>;
  periods: Array<RatioInfoDetailedPeriodsType>;
  /** The number of distinct employees that have shifts in the group on that day (not the number of shifts). */
  scheduledStaff: Scalars['Int'];
  /** @deprecated Deprecated in App Version 167 */
  status: Scalars['String'];
  to: Scalars['LocalTime'];
};

/** Detailed ratio info includes additional ratio information for all periods of the day. */
export type RatioInfoDetailedTypeV2 = {
  __typename?: 'RatioInfoDetailedTypeV2';
  date: Scalars['LocalDate'];
  expectedChildren: ExpectedChildrenType;
  from: Scalars['LocalTime'];
  groupId: Scalars['GroupId'];
  periods: Array<RatioInfoDetailedPeriodsTypeV2>;
  /** The number of distinct employees that have shifts in the group on that day (not the number of shifts). */
  scheduledStaff: Scalars['Int'];
  status: Scalars['String'];
  to: Scalars['LocalTime'];
};

/**
 * Ratio status can be:
 * 'OutOfRatio' if there are not enough shifts scheduled on the day
 * 'NoRatio' if no age groups or site opening hours are configured for the site
 * 'WithinRatio' if the number of scheduled staff matches the number of required staff based on age groups.
 */
export type RatioInfoType = {
  __typename?: 'RatioInfoType';
  date: Scalars['LocalDate'];
  expectedChildren: Scalars['Int'];
  groupId: Scalars['GroupId'];
  /** The number of distinct employees that have shifts in the group on that day (not the number of shifts). */
  scheduledStaff: Scalars['Int'];
  /** @deprecated Deprecated in App Version 167 */
  status: Scalars['String'];
};

export enum RatioStatus {
  NoRatios = 'NoRatios',
  OutOfRatios = 'OutOfRatios',
  WithinRatios = 'WithinRatios'
}

export enum ReasonToNotShowValues {
  ExistsUnderstaffedTimeRange = 'ExistsUnderstaffedTimeRange',
  NoStaffRatioConfigured = 'NoStaffRatioConfigured',
  StaffRotasNotConfigured = 'StaffRotasNotConfigured'
}

export type Record = {
  __typename?: 'Record';
  key: Scalars['String'];
  value: Scalars['String'];
};

/** Input for creating a record */
export type RecordInput = {
  key: Scalars['String'];
  value: Scalars['String'];
};

/** Staff member records by day */
export type RecordsByDay = {
  attendance: Array<StaffMemberAttendanceRecord>;
  date: Scalars['LocalDate'];
  leaves: Array<StaffMemberLeaves>;
  schedule: Array<StaffMemberScheduleRecord>;
};

export enum ReferenceMaterial {
  BT5_COEL = 'BT5_COEL',
  BT5_EYF = 'BT5_EYF',
  DM_COEL = 'DM_COEL',
  DM_EYFS = 'DM_EYFS',
  DM_EYFS_OC = 'DM_EYFS_OC',
  ELG_EYFS = 'ELG_EYFS'
}

export enum ReferenceMaterialForScotland {
  CfE = 'CfE',
  RtA = 'RtA'
}

export enum ReferenceMaterialForWales {
  DevelopmentalPathways = 'DevelopmentalPathways'
}

/** Tag for identifying a specific site */
export type ReferenceTag = {
  key?: Scalars['String'];
  value?: Scalars['String'];
};

/** Top level object for referral information */
export type Referral = {
  __typename?: 'Referral';
  /**
   * Information about whether the referral link is shown or not
   * @deprecated Referral Program is no longer available in Famly App. This endpoint is deprecated but kept around for backwards compatibility
   */
  canSeeReferralPage: Scalars['Boolean'];
  /**
   * This is used to see if users have access to see the Referral October Campaign (2022)
   * @deprecated Referral Program is no longer available in Famly App. This endpoint is deprecated but kept around for backwards compatibility
   */
  hasAccessToOctoberReferralCampaign: Scalars['Boolean'];
  /**
   * When our referred users first sign in as a trial user they would have access to a modal where they can request a demo call right after setting up their password, based on this endpoint
   * @deprecated Referral Program is no longer available in Famly App. This endpoint is deprecated but kept around for backwards compatibility
   */
  hasAccessToReferralFlowAfterPasswordCreated: Scalars['Boolean'];
  /**
   * Determines whether the user sees the DACH version of Terms and Conditions for the Referral page
   * @deprecated Referral Program is no longer available in Famly App. This endpoint is deprecated but kept around for backwards compatibility
   */
  hasDachReferralTerms: Scalars['Boolean'];
};


/** Top level object for referral information */
export type ReferralhasAccessToOctoberReferralCampaignArgs = {
  institutionSetId?: InputMaybe<Scalars['InstitutionSetId']>;
};

export enum Refinement {
  DEVELOPING = 'DEVELOPING',
  EMERGING = 'EMERGING',
  SECURE = 'SECURE'
}

/** Represents the assessment reflection settings. */
export type ReflectionSettings = {
  __typename?: 'ReflectionSettings';
  enabled: Scalars['Boolean'];
};

export type ReflectionSettingsInput = {
  enabled: Scalars['Boolean'];
};

/** A relation/contact for a child */
export type Relation = {
  __typename?: 'Relation';
  name: Name;
  profileImage?: Maybe<ProfileImage>;
  relationId: Scalars['RelationId'];
};

/** A relation/contact for a child */
export type RelationLimitedInfo = {
  __typename?: 'RelationLimitedInfo';
  name: Name;
  profileImage?: Maybe<ProfileImage>;
  relationId: Scalars['RelationId'];
};

export enum RelativeBillingDate {
  EXACT_DAY_OF_MONTH = 'EXACT_DAY_OF_MONTH',
  EXACT_DAY_OF_WEEK = 'EXACT_DAY_OF_WEEK',
  FIRST_WEEK_DAY_OF_MONTH = 'FIRST_WEEK_DAY_OF_MONTH',
  LAST_WEEK_DAY_OF_MONTH = 'LAST_WEEK_DAY_OF_MONTH',
  ON_INVOICE_DUE_DATE = 'ON_INVOICE_DUE_DATE',
  SECOND_LAST_WEEK_DAY_OF_MONTH = 'SECOND_LAST_WEEK_DAY_OF_MONTH'
}

export type RemoveNavigationItemInfoType = {
  navigationItem: Scalars['String'];
  siteId: Scalars['SiteId'];
};

/** How this recurrence repeats */
export enum RepetitionType {
  ONE_TIME = 'ONE_TIME',
  WEEKLY = 'WEEKLY'
}

export enum ReplyStatus {
  NOT_ANSWERED = 'NOT_ANSWERED',
  NOT_PERMITTED = 'NOT_PERMITTED',
  PERMITTED = 'PERMITTED'
}

export type Report = {
  categories: Array<ReportCategory>;
  createdBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']>;
  enabledFor: Array<InstitutionSet>;
  favorite: Scalars['Boolean'];
  id: Scalars['ReportId'];
  title: Scalars['String'];
};

export type ReportActivityResponse = {
  __typename?: 'ReportActivityResponse';
  activityId: Scalars['ActivityId'];
};

export type ReportCategory = {
  __typename?: 'ReportCategory';
  id: Scalars['ReportCategoryId'];
  title: Scalars['String'];
};

export type ReportCategoryResult = {
  __typename?: 'ReportCategoryResult';
  categories: Array<ReportCategory>;
};

export type ReportConfig = {
  __typename?: 'ReportConfig';
  areaConfigs: Array<AreaConfig>;
  frameworkId: Scalars['FrameworkId'];
  name: Scalars['String'];
  reportConfigId: Scalars['ReportConfigId'];
  type: ReportConfigType;
  variantFilters: Array<ObservationVariantFilter>;
};

export enum ReportConfigType {
  ADMIN = 'ADMIN',
  PROGRESS = 'PROGRESS'
}

export type ReportDataFragment = {
  __typename?: 'ReportDataFragment';
  description: Scalars['String'];
  title: Scalars['String'];
};

export type ReportDataset = {
  __typename?: 'ReportDataset';
  description: Scalars['String'];
  fragments: Array<ReportDataFragment>;
  id: Scalars['ReportDatasetId'];
  title: Scalars['String'];
};

export type ReportDatasetResult = {
  __typename?: 'ReportDatasetResult';
  datasets: Array<ReportDataset>;
};

export type ReportMutations = {
  __typename?: 'ReportMutations';
  createCustomReport: QrveyEmbedInformation;
  deleteCustomReport: Scalars['Boolean'];
  setFavoriteStatus: Report;
  updateCustomReport: Report;
};


export type ReportMutationscreateCustomReportArgs = {
  datasetId: Scalars['ReportDatasetId'];
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};


export type ReportMutationsdeleteCustomReportArgs = {
  reportId: Scalars['ReportId'];
};


export type ReportMutationssetFavoriteStatusArgs = {
  newFavoriteStatus: Scalars['Boolean'];
  reportId: Scalars['ReportId'];
};


export type ReportMutationsupdateCustomReportArgs = {
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  reportId: Scalars['ReportId'];
};

export type ReportQueries = {
  __typename?: 'ReportQueries';
  byId?: Maybe<Report>;
  categories: ReportCategoryResult;
  datasets: ReportDatasetResult;
  embedInformation: QrveyEmbedInformation;
  reports: ReportResult;
  /** Details about reports settings */
  settings: ReportsSettings;
  /** The suggested reports for the current user. Will return up to 10 reports, and pagination is not supported. */
  suggestedReports: Array<SuggestedReport>;
};


export type ReportQueriesbyIdArgs = {
  reportId: Scalars['ReportId'];
};


export type ReportQueriesembedInformationArgs = {
  reportId: Scalars['ReportId'];
};


export type ReportQueriesreportsArgs = {
  categoryIds?: InputMaybe<Array<Scalars['ReportCategoryId']>>;
  cursor?: InputMaybe<Scalars['ReportCursor']>;
  customReportsOnly?: InputMaybe<Scalars['Boolean']>;
  favoritesOnly?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
};

export type ReportResult = {
  __typename?: 'ReportResult';
  next?: Maybe<Scalars['ReportCursor']>;
  reports: Array<Report>;
};

export enum ReportableContent {
  FEED_COMMENT = 'FEED_COMMENT',
  MESSAGE = 'MESSAGE',
  OBSERVATION = 'OBSERVATION',
  POST = 'POST',
  USER = 'USER'
}

/** Details about reports settings */
export type ReportsSettings = {
  __typename?: 'ReportsSettings';
  /** Details about custom reports settings */
  customReports: CustomReportsSetting;
};

export type Restrictions = {
  __typename?: 'Restrictions';
  /** Controls access restrictions for users for payment method adding */
  paymentMethod: PaymentMethodRestriction;
  /** Returns a map of restrictions for each active site the user is associated with */
  perSite: PerSite;
};


export type RestrictionspaymentMethodArgs = {
  siteSetId?: InputMaybe<Scalars['SiteSetId']>;
};

/** A thing that can be bought, i.e. a session version or a product version */
export type RevenueItem = {
  billOnChildAbsent: Scalars['Boolean'];
  billOnChildSick: Scalars['Boolean'];
  billOnClosingDays: Array<ClosingDay>;
  color: Scalars['Int'];
  discountable: Scalars['Boolean'];
  institutionSetId: Scalars['InstitutionSetId'];
  pricing: Array<Pricing>;
  title: Scalars['String'];
  validFrom: Scalars['LocalDate'];
  validTo?: Maybe<Scalars['LocalDate']>;
};

export type RevenueItemQueries = {
  __typename?: 'RevenueItemQueries';
  behaviors: Array<Behavior>;
  /** A product version */
  productVersions: Array<ProductVersion>;
  /** A session version */
  sessionVersions: Array<SessionVersion>;
};


export type RevenueItemQueriesbehaviorsArgs = {
  institutionId: Scalars['InstitutionSetId'];
};


export type RevenueItemQueriesproductVersionsArgs = {
  childIds?: InputMaybe<Array<Scalars['ChildId']>>;
  institutionIds?: InputMaybe<Array<Scalars['InstitutionSetId']>>;
  productVersionIds?: InputMaybe<Array<Scalars['ProductVersionId']>>;
  validOnDate?: InputMaybe<Scalars['LocalDate']>;
};


export type RevenueItemQueriessessionVersionsArgs = {
  childIds?: InputMaybe<Array<Scalars['ChildId']>>;
  institutionIds?: InputMaybe<Array<Scalars['InstitutionSetId']>>;
  sessionVersionIds?: InputMaybe<Array<Scalars['SessionVersionId']>>;
  validOnDate?: InputMaybe<Scalars['LocalDate']>;
};

/** Generic query to manipulate rich text */
export type RichTextQuery = {
  __typename?: 'RichTextQuery';
  sanitize: Scalars['String'];
  toPlainText: Scalars['String'];
};


/** Generic query to manipulate rich text */
export type RichTextQuerysanitizeArgs = {
  richtext: Scalars['String'];
};


/** Generic query to manipulate rich text */
export type RichTextQuerytoPlainTextArgs = {
  richtext: Scalars['String'];
};

/** A role and their granted/locked permissions */
export type Role = {
  __typename?: 'Role';
  assignees: Array<RoleAssignee>;
  createdAt: Scalars['ZonedDateTime'];
  institutionSetIds: Array<Scalars['InstitutionSetId']>;
  institutionSets: Array<InstitutionSet>;
  locked: Scalars['Boolean'];
  lockedReason?: Maybe<RoleLockedReasons>;
  permissions: Array<RolePermission>;
  roleId: Scalars['RoleId'];
  settings: Array<RoleSettings>;
  source: RoleSource;
  target: RoleTarget;
  title: Scalars['String'];
};

/** A login assigned to a specific role */
export type RoleAssignee = {
  institutionSetId: Scalars['InstitutionSetId'];
  /** A generic representation of the assignee */
  person: Person;
  /** The ID of the role that has been assigned */
  roleId: Scalars['RoleId'];
};

/** Input for role assignment */
export type RoleAssignmentInput = {
  roleId: Scalars['RoleId'];
  targetId: Scalars['UniqueId'];
};

/** Save a role and assigned permissions */
export type RoleInput = {
  assignedPermissions: Array<Scalars['String']>;
  institutionSetIds: Array<Scalars['InstitutionSetId']>;
  roleId?: InputMaybe<Scalars['RoleId']>;
  source: RoleSource;
  target: RoleTarget;
  title: Scalars['String'];
};

/** Represents an invitation to take on a Role within the application */
export type RoleInvitation = {
  privacyPolicyLink?: Maybe<Scalars['String']>;
  roleId: Scalars['RoleId'];
  roleInvitationId: Scalars['RoleInvitationId'];
  roleTitle: Scalars['String'];
  siteTitle: Scalars['String'];
  verification: RoleInvitationVerification;
};

export type RoleInvitationAcceptanceResult = {
  __typename?: 'RoleInvitationAcceptanceResult';
  loginId: Scalars['LoginId'];
  pwAssignToken?: Maybe<Scalars['String']>;
};

/** Information about pending role invitations for a child contact */
export type RoleInvitationData = {
  __typename?: 'RoleInvitationData';
  roleId: Scalars['RoleId'];
  roleInvitationId: Scalars['RoleInvitationId'];
  roleTitle: Scalars['String'];
  verification: RoleInvitationVerification;
};

export type RoleInvitationRemovalResult = {
  __typename?: 'RoleInvitationRemovalResult';
  relationId: Scalars['RelationId'];
  roleInvitationId: Scalars['RoleInvitationId'];
};

/** Represents the verification steps necessary to accept a RoleInvitation */
export type RoleInvitationVerification = {
  verificationMethod: RoleInvitationVerificationMethod;
};

export enum RoleInvitationVerificationMethod {
  DATE_OF_BIRTH = 'DATE_OF_BIRTH',
  NO_VERIFICATION = 'NO_VERIFICATION'
}

export type RoleInvitationsByChild = {
  __typename?: 'RoleInvitationsByChild';
  childId: Scalars['ChildId'];
  invitations: Array<RoleInvitation>;
};

/** Object holding all mutations related to role invitations */
export type RoleInvitationsMutations = {
  __typename?: 'RoleInvitationsMutations';
  /** Accept a role invitation by providing its id and the corresponding token, as well as optional verification arguments as required by the invitation */
  accept: RoleInvitationAcceptanceResult;
  /** Remove the role invitation if it was valid at the time of the request */
  remove: RoleInvitationRemovalResult;
};


/** Object holding all mutations related to role invitations */
export type RoleInvitationsMutationsacceptArgs = {
  dateOfBirth?: InputMaybe<Scalars['LocalDate']>;
  roleInvitationId: Scalars['RoleInvitationId'];
  token: Scalars['String'];
};


/** Object holding all mutations related to role invitations */
export type RoleInvitationsMutationsremoveArgs = {
  roleInvitationId: Scalars['RoleInvitationId'];
};

/** Object holding all queries related to role invitations */
export type RoleInvitationsQueries = {
  __typename?: 'RoleInvitationsQueries';
  list: ListRoleInvitationsResult;
  listByChildIds: ListRoleInvitationsResultByChild;
};


/** Object holding all queries related to role invitations */
export type RoleInvitationsQuerieslistArgs = {
  roleInvitationIds: Array<Scalars['RoleInvitationId']>;
};


/** Object holding all queries related to role invitations */
export type RoleInvitationsQuerieslistByChildIdsArgs = {
  childIds: Array<Scalars['ChildId']>;
};

export enum RoleLockedReasons {
  BuiltIn = 'BuiltIn',
  CrossSite = 'CrossSite',
  MissingPermission = 'MissingPermission'
}

/** A potential permission for a given role */
export type RolePermission = {
  __typename?: 'RolePermission';
  granted: Scalars['Boolean'];
  id: Scalars['String'];
  /** Whether this permission can be changed */
  locked: Scalars['Boolean'];
  /** Whether one or more sub-permissions have been assigned */
  partial: Scalars['Boolean'];
};

/** A role's settings */
export type RoleSettings = {
  __typename?: 'RoleSettings';
  institutionSetId: Scalars['InstitutionSetId'];
  logoutSeconds: Scalars['Int'];
  roleId: Scalars['RoleId'];
};

/** Update role settings */
export type RoleSettingsInput = {
  institutionSetId: Scalars['InstitutionSetId'];
  logoutSeconds: Scalars['Int'];
  roleId: Scalars['RoleId'];
};

/** Object holding all mutations related to role settings */
export type RoleSettingsMutations = {
  __typename?: 'RoleSettingsMutations';
  update: Array<RoleSettings>;
};


/** Object holding all mutations related to role settings */
export type RoleSettingsMutationsupdateArgs = {
  roleSettings: Array<RoleSettingsInput>;
};

export enum RoleSource {
  EMPLOYEE = 'EMPLOYEE',
  LOGIN = 'LOGIN',
  ORGANIZATION_PERSON = 'ORGANIZATION_PERSON',
  RELATION = 'RELATION'
}

/** The object a role is granted for */
export enum RoleTarget {
  CHILD = 'CHILD',
  EMPLOYEE = 'EMPLOYEE',
  INSTITUTION = 'INSTITUTION',
  ORGANIZATION = 'ORGANIZATION'
}

export type RoleUpdateType = {
  /** If not set, use the existing contact email. If set, change the contacts' email and assign the role then. */
  newEmail?: InputMaybe<Scalars['EmailAddress']>;
  roleId: Scalars['RoleId'];
};

/** Objects related to viewing roles and permissions */
export type Roles = {
  __typename?: 'Roles';
  apiAccessTokens: ApiAccessTokenQueries;
  /** Lists the sites that the current user can manage roles for. If the user can't manage roles for multiple sites, null is returned. */
  availableSites?: Maybe<Array<InstitutionSet>>;
  invitations: RoleInvitationsQueries;
  list: ListRolesResult;
  permissions: Array<PermissionTree>;
};


/** Objects related to viewing roles and permissions */
export type RolesavailableSitesArgs = {
  institutionSetId: Scalars['InstitutionSetId'];
};


/** Objects related to viewing roles and permissions */
export type RoleslistArgs = {
  first: Scalars['Int'];
  institutionSetIds: Array<Scalars['InstitutionSetId']>;
  next?: InputMaybe<Scalars['RoleCursor']>;
  roleIds?: InputMaybe<Array<Scalars['RoleId']>>;
  source: RoleSource;
  target: RoleTarget;
};


/** Objects related to viewing roles and permissions */
export type RolespermissionsArgs = {
  siteSetId: Scalars['SiteSetId'];
};

/** Operations to change roles and permissions */
export type RolesMutations = {
  __typename?: 'RolesMutations';
  apiAccessTokens: ApiAccessTokenMutations;
  delete: Scalars['Boolean'];
  invitations: RoleInvitationsMutations;
  settings: RoleSettingsMutations;
  upsert: Array<Role>;
};


/** Operations to change roles and permissions */
export type RolesMutationsdeleteArgs = {
  institutionSetId: Scalars['InstitutionSetId'];
  roleIds: Array<Scalars['RoleId']>;
};


/** Operations to change roles and permissions */
export type RolesMutationsupsertArgs = {
  preview: Scalars['Boolean'];
  roles: Array<RoleInput>;
};

export type RollingDeletion = {
  __typename?: 'RollingDeletion';
  enabled: Scalars['Boolean'];
  entity: DeletionEntity;
  retentionDays: Scalars['Int'];
};

export type RollingDeletionInput = {
  enabled: Scalars['Boolean'];
  entity: DeletionEntity;
  retentionDays: Scalars['Int'];
};

export type RoomAbsence = {
  __typename?: 'RoomAbsence';
  childCounts: Array<ChildAbsenceCount>;
  room: Group;
  staffCounts: Array<StaffAbsenceCount>;
};

export type RoomAttendanceReport = AttendanceSummary & {
  __typename?: 'RoomAttendanceReport';
  ageGroups: Array<AgeGroupAttendanceReport>;
  children: Array<ChildAttendanceReport>;
  room: Group;
  slots: Array<AttendanceSlot>;
  stats: AttendanceStats;
};


export type RoomAttendanceReportslotsArgs = {
  buckets?: InputMaybe<Array<ClosedLocalTimeRange>>;
};

/** Models an option for filtering rooms in widgets. Essentially a label to be shown to the user as well as a set of room ids which should be passed on to subsequent queries if the user selects the filter. */
export type RoomFilterOption = {
  __typename?: 'RoomFilterOption';
  id: Scalars['UniqueId'];
  rooms: Array<Scalars['GroupId']>;
  title: Scalars['String'];
  type: RoomFilterOptionType;
};

export enum RoomFilterOptionType {
  DEPARTMENT = 'DEPARTMENT',
  FAVORITES = 'FAVORITES'
}

export type RoomOverview = {
  __typename?: 'RoomOverview';
  /** The children who are currently signed in */
  children: Array<Child>;
  childrenSignedInCount: Scalars['Int'];
  description?: Maybe<Scalars['String']>;
  expectedCount: Scalars['Int'];
  groupId: Scalars['GroupId'];
  isStarred: Scalars['Boolean'];
  /** @deprecated Use field RatioInfo instead */
  isWithinRatio?: Maybe<Scalars['Boolean']>;
  ratioInfo?: Maybe<RatioInfo>;
  room: Group;
  /** The staff who are currently signed in */
  staff?: Maybe<Array<Employee>>;
  staffSignedInCount?: Maybe<Scalars['Int']>;
  title: Scalars['String'];
};

/** Overview of total minutes in a room */
export type RoomOverviewTotalMinutes = {
  __typename?: 'RoomOverviewTotalMinutes';
  staffTotalAttendedMinutes: Scalars['Int'];
  staffTotalScheduledMinutes: Scalars['Int'];
};

export type RoomsWidget = Widget & {
  __typename?: 'RoomsWidget';
  /** The available room filters for the current user for this widget. */
  filterOptions: Array<RoomFilterOption>;
  id: Scalars['HomeWidgetId'];
  next?: Maybe<Scalars['HomeWidgetCursor']>;
  rooms: Array<RoomOverview>;
  siteCounts: Array<SiteCounts>;
  title: Scalars['String'];
  widgetId: Scalars['String'];
};


export type RoomsWidgetroomsArgs = {
  roomIds?: InputMaybe<Array<Scalars['GroupId']>>;
};


export type RoomsWidgetsiteCountsArgs = {
  roomIds?: InputMaybe<Array<Scalars['GroupId']>>;
};

/** Information about active RSS feeds per site */
export type RssInfo = {
  __typename?: 'RssInfo';
  institutionSet: InstitutionSet;
  url: Scalars['String'];
};

/** Queries for the RSS integration */
export type RssIntegration = {
  __typename?: 'RssIntegration';
  /** List the active RSS feed info for sites */
  active: Array<RssInfo>;
};


/** Queries for the RSS integration */
export type RssIntegrationactiveArgs = {
  institutionSetIds: Array<Scalars['InstitutionSetId']>;
};

/** Mutations for the RSS integration */
export type RssIntegrationMutation = {
  __typename?: 'RssIntegrationMutation';
  /** (De)activate RSS feeds for sites */
  activate: Array<RssInfo>;
};


/** Mutations for the RSS integration */
export type RssIntegrationMutationactivateArgs = {
  activate?: InputMaybe<Scalars['Boolean']>;
  institutionSetIds: Array<Scalars['InstitutionSetId']>;
};

export type RuleGroupInput = {
  ruleGroupId: Scalars['RuleGroupId'];
  ruleGroupName: Scalars['String'];
};

export enum RuleNamespace {
  pricing = 'pricing',
  rooms = 'rooms'
}

export type RuleSet = {
  __typename?: 'RuleSet';
  example: Array<RuleStatePeriod>;
  institution: Site;
  ruleGroupId: Scalars['RuleGroupId'];
  ruleGroupName?: Maybe<Scalars['String']>;
  /**
   * The order of rules is unimportant, as they are always sorted before being evaluated.
   *
   * Example of valid rules:
   *
   * ```json
   * [
   *   {
   *     "action" : {
   *       "groupId" : "76ca8bff-7e7a-4379-aecf-93ac1c3cf617",
   *       "type" : "MoveToGroup"
   *     },
   *     "type" : "Joins"
   *   },
   *   {
   *     "ageInMonths" : 48,
   *     "month" : "SEPTEMBER",
   *     "action" : {
   *       "ageGroupId" : "d924ece9-d60f-41ed-bc2a-36becb95b517",
   *       "type" : "MoveToAgeGroup"
   *     },
   *     "conditions" : [
   *       {
   *         "ageGroupId" : "1b908fc9-d136-441e-9cf1-e4ffbe2834cb",
   *         "type" : "InAgeGroup"
   *       }
   *     ],
   *     "type" : "MonthAfterAge"
   *   },
   *   {
   *     "ageInMonths" : 120,
   *     "when" : "FirstOfNextMonth",
   *     "action" : {
   *       "type" : "Leave"
   *     },
   *     "conditions" : [
   *     ],
   *     "type" : "Age"
   *   },
   *   {
   *     "conditions" : [
   *       {
   *         "ageGroupId" : "d924ece9-d60f-41ed-bc2a-36becb95b517",
   *         "type" : "InAgeGroup"
   *       }
   *     ],
   *     "action" : {
   *       "groupId" : "abc144e2-47ba-4fe8-bd22-e2d6e98fb553",
   *       "type" : "MoveToGroup"
   *     },
   *     "type" : "If"
   *   }
   * ]
   * ```
   *
   */
  rules: Array<Scalars['Json']>;
};


export type RuleSetexampleArgs = {
  childIds?: InputMaybe<Array<Scalars['ChildId']>>;
  state?: InputMaybe<RuleStateInput>;
};

export type RuleSetResult = {
  __typename?: 'RuleSetResult';
  ruleGroupId: Scalars['RuleGroupId'];
  ruleGroupName?: Maybe<Scalars['String']>;
  /**
   * The order of rules is unimportant, as they are always sorted before being evaluated.
   *
   * Example of valid rules:
   *
   * ```json
   * [
   *   {
   *     "action" : {
   *       "groupId" : "76ca8bff-7e7a-4379-aecf-93ac1c3cf617",
   *       "type" : "MoveToGroup"
   *     },
   *     "type" : "Joins"
   *   },
   *   {
   *     "ageInMonths" : 48,
   *     "month" : "SEPTEMBER",
   *     "action" : {
   *       "ageGroupId" : "d924ece9-d60f-41ed-bc2a-36becb95b517",
   *       "type" : "MoveToAgeGroup"
   *     },
   *     "conditions" : [
   *       {
   *         "ageGroupId" : "1b908fc9-d136-441e-9cf1-e4ffbe2834cb",
   *         "type" : "InAgeGroup"
   *       }
   *     ],
   *     "type" : "MonthAfterAge"
   *   },
   *   {
   *     "ageInMonths" : 120,
   *     "when" : "FirstOfNextMonth",
   *     "action" : {
   *       "type" : "Leave"
   *     },
   *     "conditions" : [
   *     ],
   *     "type" : "Age"
   *   },
   *   {
   *     "conditions" : [
   *       {
   *         "ageGroupId" : "d924ece9-d60f-41ed-bc2a-36becb95b517",
   *         "type" : "InAgeGroup"
   *       }
   *     ],
   *     "action" : {
   *       "groupId" : "abc144e2-47ba-4fe8-bd22-e2d6e98fb553",
   *       "type" : "MoveToGroup"
   *     },
   *     "type" : "If"
   *   }
   * ]
   * ```
   *
   */
  rules: Array<Scalars['Json']>;
};

export type RuleState = {
  __typename?: 'RuleState';
  /** @deprecated Use `pricingGroupId` instead */
  ageGroupId?: Maybe<Scalars['PricingGroupId']>;
  birthday: Scalars['LocalDate'];
  child: Child;
  childId: Scalars['ChildId'];
  endDate?: Maybe<Scalars['LocalDate']>;
  group?: Maybe<Group>;
  groupId?: Maybe<Scalars['GroupId']>;
  pricingGroupId?: Maybe<Scalars['PricingGroupId']>;
  startDate: Scalars['LocalDate'];
};

export type RuleStateInput = {
  /** Deprecated! Use `pricingGroupId` */
  ageGroupId?: InputMaybe<Scalars['PricingGroupId']>;
  birthday: Scalars['LocalDate'];
  childId: Scalars['ChildId'];
  endDate?: InputMaybe<Scalars['LocalDate']>;
  groupId?: InputMaybe<Scalars['GroupId']>;
  pricingGroupId?: InputMaybe<Scalars['PricingGroupId']>;
  startDate: Scalars['LocalDate'];
};

export type RuleStatePeriod = {
  __typename?: 'RuleStatePeriod';
  from: Scalars['LocalDate'];
  state: RuleState;
  to?: Maybe<Scalars['LocalDate']>;
};

export type RulesMutations = {
  __typename?: 'RulesMutations';
  deleteRuleGroup: Scalars['RuleGroupId'];
  /**
   * Create a new rule group. Giving it a name is mandatory.
   * The new rule group's ID will be returned along with the chosen name and the rules.
   *
   * This is similar to `setRules`, but it will always create a new rule group.
   *
   */
  newRuleGroup: RuleSetResult;
  setRules: Array<Scalars['Json']>;
};


export type RulesMutationsdeleteRuleGroupArgs = {
  ruleGroupId: Scalars['RuleGroupId'];
  siteId: Scalars['InstitutionId'];
};


export type RulesMutationsnewRuleGroupArgs = {
  namespace?: InputMaybe<Scalars['String']>;
  ruleGroupName: Scalars['String'];
  rules: Array<Scalars['Json']>;
  siteId: Scalars['InstitutionId'];
  version?: InputMaybe<Scalars['Int']>;
};


export type RulesMutationssetRulesArgs = {
  institutionId: Scalars['InstitutionId'];
  namespace?: InputMaybe<Scalars['String']>;
  ruleGroup?: InputMaybe<RuleGroupInput>;
  rules: Array<Scalars['Json']>;
  version?: InputMaybe<Scalars['Int']>;
};

/** Information on batch invoicing run */
export type Run = {
  __typename?: 'Run';
  from: Scalars['LocalDate'];
  institutionId: Scalars['InstitutionId'];
  runId: Scalars['RunId'];
  status: RunStatus;
  to: Scalars['LocalDate'];
};

/** Details of batch invoicing run */
export type RunDetails = {
  __typename?: 'RunDetails';
  progress: RunProgress;
  run: Run;
};

/** Information on batch invoicing run progress */
export type RunProgress = {
  __typename?: 'RunProgress';
  done: Scalars['Int'];
  invoicedSoFar: Scalars['BadMoney'];
  total: Scalars['Int'];
  totalInvoiceAmount: Scalars['BadMoney'];
};

export type RunQueries = {
  __typename?: 'RunQueries';
  details?: Maybe<RunDetails>;
  list: Array<Run>;
};


export type RunQueriesdetailsArgs = {
  runId: Scalars['RunId'];
};


export type RunQuerieslistArgs = {
  institutionId: Scalars['InstitutionId'];
  status?: InputMaybe<RunStatus>;
};

export enum RunStatus {
  FAILURE = 'FAILURE',
  RUNNING = 'RUNNING',
  SUCCESS = 'SUCCESS'
}

export enum SEPAFormat {
  DACH = 'DACH',
  SEPA = 'SEPA'
}

/** For managing SEPA settings */
export type SEPAMutation = {
  __typename?: 'SEPAMutation';
  set: SEPASettings;
};


/** For managing SEPA settings */
export type SEPAMutationsetArgs = {
  bic: Scalars['String'];
  iban: Scalars['String'];
  legalName: Scalars['String'];
  prefix: Scalars['String'];
  privateId: Scalars['String'];
  shortName: Scalars['String'];
  siteSetId: Scalars['SiteSetId'];
};

/** SEPA settings for specified site set. */
export type SEPASettings = {
  __typename?: 'SEPASettings';
  bic: Scalars['String'];
  format: SEPAFormat;
  iban: Scalars['String'];
  legalName: Scalars['String'];
  prefix: Scalars['String'];
  privateId: Scalars['String'];
  shortName: Scalars['String'];
};

/** Mutations related to SMS */
export type SMSMutations = {
  __typename?: 'SMSMutations';
  /** Sends a SMS message to the provided `loginId` */
  sendMessage: SmsSendMessageResult;
  /** Updates the SMS settings for the provided `siteSetId` */
  updateSettings: SmsSettings;
};


/** Mutations related to SMS */
export type SMSMutationssendMessageArgs = {
  body: Scalars['String'];
  createdBy: Scalars['LoginId'];
  itemId: Scalars['String'];
  itemType: SmsItemType;
  loginId: Scalars['LoginId'];
  siteSetId: Scalars['SiteSetId'];
  smsIdentifier: Scalars['SMSIdentifier'];
  url?: InputMaybe<Scalars['URI']>;
};


/** Mutations related to SMS */
export type SMSMutationsupdateSettingsArgs = {
  isEnabledForMessages?: InputMaybe<Scalars['Boolean']>;
  isEnabledForPosts?: InputMaybe<Scalars['Boolean']>;
  shortName?: InputMaybe<Scalars['String']>;
  siteSetId: Scalars['SiteSetId'];
};

/** Queries related to SMS */
export type SMSQueries = {
  __typename?: 'SMSQueries';
  /** Returns SMS billing information for the provided `siteId` */
  billingInformation?: Maybe<SmsSiteBillingInformation>;
  /** Returns SMS configuration information for the provided `siteId` for the current user */
  configuration?: Maybe<SmsSiteConfiguration>;
  /** Returns SMS settings information for the provided `siteSetIds` */
  settings: SmsSettingsResult;
  /** Returns SMS status information for the provided `smsIdentifier` */
  status: Array<SmsStatusResult>;
};


/** Queries related to SMS */
export type SMSQueriesbillingInformationArgs = {
  siteId: Scalars['SiteId'];
};


/** Queries related to SMS */
export type SMSQueriesconfigurationArgs = {
  siteId: Scalars['SiteId'];
};


/** Queries related to SMS */
export type SMSQueriessettingsArgs = {
  siteSetIds: Array<InputMaybe<Scalars['SiteSetId']>>;
};


/** Queries related to SMS */
export type SMSQueriesstatusArgs = {
  smsIdentifier: Scalars['SMSIdentifier'];
};

/** All mutations related to sales project */
export type SalesMutationType = {
  __typename?: 'SalesMutationType';
  offer: OfferMutationType;
  onboarding: OnboardingMutation;
};

/** All queries related to the sales project */
export type SalesType = {
  __typename?: 'SalesType';
  offer: OfferType;
  onboarding: OnboardingType;
};


/** All queries related to the sales project */
export type SalesTypeofferArgs = {
  opportunityId: Scalars['String'];
};

export type ScheduleConfigInput = {
  /** Range of dates covered by the schedule */
  dateRange: NonEmptyLocalDateRangeInput;
  /** Each elem represent a whole day that gather all time slots and a break time */
  dayConfigs: Array<DayConfigInput>;
  /** Repetition type of schedule */
  repeatType: RepetitionType;
};

export type ScheduleManagementType = {
  __typename?: 'ScheduleManagementType';
  /** Returns true if the current user is allowed to edit the staff rotas schedule. */
  canEdit: Scalars['Boolean'];
  /** Returns true if the current user can view the staff rotas schedule of the given employee. */
  canView: Scalars['Boolean'];
};

/** Create, delete or update staff member schedule */
export type ScheduleMutation = {
  __typename?: 'ScheduleMutation';
  createScheduleFromConfig: StaffMemberRecords;
};


/** Create, delete or update staff member schedule */
export type ScheduleMutationcreateScheduleFromConfigArgs = {
  displayRange: ClosedLocalDateRange;
  employeeId: Scalars['EmployeeId'];
  overrideOverlappingSchedules: Scalars['Boolean'];
  scheduleConfig: ScheduleConfigInput;
};

/** List staff schedules */
export type ScheduleQueries = {
  __typename?: 'ScheduleQueries';
  /** A list of abstract schedules, i.e. a model of the schedule which has not been calculated for concrete dates */
  list: Array<StaffSchedule>;
};


/** List staff schedules */
export type ScheduleQuerieslistArgs = {
  scheduleIds: Array<Scalars['StaffRotasScheduleId']>;
};

/** Scheduled staff member records for a range of dates */
export type ScheduleStaffMemberRecordsByDay = {
  __typename?: 'ScheduleStaffMemberRecordsByDay';
  date: Scalars['LocalDate'];
  scheduled: Array<StaffMemberScheduleRecord>;
};

export type SchedulesByStaffType = {
  __typename?: 'SchedulesByStaffType';
  employee?: Maybe<Employee>;
  schedule: Array<StaffScheduleType>;
  scheduledMinutes: Scalars['Int'];
};

/** Root type for all search related queries */
export type Search = {
  __typename?: 'Search';
  /** Lists all available search categories for the current user */
  availableCategories: Array<SearchCategory>;
};

/** Represents a single category in which the current user can perform searches */
export type SearchCategory = {
  __typename?: 'SearchCategory';
  description: Scalars['String'];
  /** A list of entity types which should be passed to core's search endpoint if this category is chosen */
  entityTypes: Array<Scalars['String']>;
  shortcut: Scalars['String'];
  title: Scalars['String'];
};

/** Security */
export type Security = {
  __typename?: 'Security';
  passwordRules: PasswordRules;
};


/** Security */
export type SecuritypasswordRulesArgs = {
  siteSetId: Scalars['SiteSetId'];
};

export type SecurityMutation = {
  __typename?: 'SecurityMutation';
  oneTimePassword: OneTimePasswordMutation;
  passwordRules: PasswordRulesMutation;
};

export type SegmentDay = {
  __typename?: 'SegmentDay';
  day: Scalars['DayOfWeek'];
  mealPlanId: Scalars['MealPlanId'];
  mealPlanSegmentId: Scalars['MealPlanSegmentId'];
  meals: Array<MealTypeItems>;
  week: Scalars['Int'];
};

/** Version 1 of the self signup. */
export type SelfSignupV1Mutation = {
  __typename?: 'SelfSignupV1Mutation';
  v1: SelfSignupV1MutationSignedUpType;
};


/** Version 1 of the self signup. */
export type SelfSignupV1Mutationv1Args = {
  attribution: Scalars['String'];
  contactEmail: Scalars['EmailAddress'];
  contactNameClean: Scalars['CleanNameScalar'];
  contactPhone: Scalars['PhoneNumber'];
  packageId: Scalars['PackageId'];
  siteName: Scalars['String'];
  timeZone: Scalars['String'];
};

export type SelfSignupV1MutationSignedUpType = {
  __typename?: 'SelfSignupV1MutationSignedUpType';
  accessToken?: Maybe<Scalars['AccessToken']>;
  country?: Maybe<Scalars['Country']>;
  deviceId?: Maybe<Scalars['DeviceId']>;
  employeeLoginId?: Maybe<Scalars['LoginId']>;
  existingUser: Scalars['Boolean'];
  siteId?: Maybe<Scalars['SiteId']>;
};

export type SepaSettingsQueries = {
  __typename?: 'SepaSettingsQueries';
  bySiteSetId?: Maybe<SEPASettings>;
};


export type SepaSettingsQueriesbySiteSetIdArgs = {
  siteSetId: Scalars['SiteSetId'];
};

/** A session availability */
export type SessionAvailability = Availability & {
  __typename?: 'SessionAvailability';
  day: Scalars['DayOfWeek'];
  session: SessionVersion;
  sessionAvailabilityId: Scalars['SessionAvailabilityId'];
  timeRange: TimeRangeClosedLocalTime;
};

/** Queries that compute FTE values for specific session(s) */
export type SessionFTEQueries = {
  __typename?: 'SessionFTEQueries';
  byId: SessionFte;
};


/** Queries that compute FTE values for specific session(s) */
export type SessionFTEQueriesbyIdArgs = {
  sessionId: Scalars['SessionId'];
};

/** Holds information on FTE calculation for a session (using only session and site opening hours) */
export type SessionFte = {
  __typename?: 'SessionFte';
  /** FTE value */
  fte: Scalars['Float'];
  /** ID of the session */
  sessionId: Scalars['SessionId'];
};

/** An ad hoc purchase booking of a session */
export type SessionPurchase = {
  __typename?: 'SessionPurchase';
  bookedPrice?: Maybe<Scalars['BadMoney']>;
  pricingGroupId: Scalars['PricingGroupId'];
  purchaseDate: Scalars['LocalDate'];
  sessionAvailability: SessionAvailability;
  sessionAvailabilityId: Scalars['SessionAvailabilityId'];
  sessionPurchaseId: Scalars['SessionPurchaseId'];
  /** The time at which the booked session starts and ends */
  sessionTime?: Maybe<TimeRangeClosedLocalTime>;
};

export type SessionPurchaseInput = {
  /** The (positive) price before multiplying by hours (for hourly) or applying any discounts */
  bookedPrice?: InputMaybe<Scalars['BadMoney']>;
  pricingGroupId: Scalars['PricingGroupId'];
  purchaseDate: Scalars['LocalDate'];
  range?: InputMaybe<ClosedLocalTimeRange>;
  sessionAvailabilityId: Scalars['SessionAvailabilityId'];
  /** Note: The returned purchase might not use this ID */
  sessionPurchaseId?: InputMaybe<Scalars['SessionPurchaseId']>;
};

export enum SessionType {
  PackageSession = 'PackageSession',
  StandaloneSession = 'StandaloneSession',
  VolumeSession = 'VolumeSession'
}

/** A session version */
export type SessionVersion = RevenueItem & {
  __typename?: 'SessionVersion';
  active: Scalars['Boolean'];
  billOnChildAbsent: Scalars['Boolean'];
  billOnChildSick: Scalars['Boolean'];
  billOnClosingDays: Array<ClosingDay>;
  color: Scalars['Int'];
  customFte?: Maybe<Scalars['Float']>;
  discountable: Scalars['Boolean'];
  flexibleHours: Scalars['Boolean'];
  fundable: Scalars['Boolean'];
  institutionSetId: Scalars['InstitutionSetId'];
  pricing: Array<Pricing>;
  sessionAvailabilities: Array<SessionAvailability>;
  sessionId: Scalars['SessionId'];
  sessionVersionId: Scalars['SessionVersionId'];
  title: Scalars['String'];
  type: SessionType;
  validFrom: Scalars['LocalDate'];
  validTo?: Maybe<Scalars['LocalDate']>;
  volumeDiscountGroupId?: Maybe<Scalars['VolumeDiscountGroupId']>;
};

export type SetInitialPasswordAndPinResult = {
  __typename?: 'SetInitialPasswordAndPinResult';
  accessToken: Scalars['AccessToken'];
};

/** Set the value of a setting. */
export type SettingInput = {
  key: SettingKeyType;
  value: Scalars['String'];
};

export enum SettingKeyType {
  /** Determine whether the room of the child is shown in the News Feed recipients list (default: `true`). */
  InstitutionNewsFeedParticipantRoomVisibility = 'InstitutionNewsFeedParticipantRoomVisibility',
  /**
   * Determine how much information of each participant is shown in the News Feed recipients list (default: `PARENT_FULL_CHILD_FIRSTNAME`).
   *
   * **Options:**
   *
   * - `PARENT_FULL_CHILD_FIRSTNAME`
   * - `PARENT_FIRSTNAME_CHILD_FIRSTNAME`
   * - `PARENT_FIRSTNAME_CHILD_NONE`
   */
  InstitutionNewsFeedParticipantVisibility = 'InstitutionNewsFeedParticipantVisibility',
  /** Turn this off to disable all seen-by receipt functionality (default: `true`). */
  InstitutionSeenByReceipt = 'InstitutionSeenByReceipt',
  /** Turn this off to block parents from seeing when a staff member or manager has seen their message (default: `true`). */
  InstitutionSeenByReceiptFromParentToStaff = 'InstitutionSeenByReceiptFromParentToStaff',
  /** Turn this off to block staff from seeing when a manager has read their message (default: `true`). */
  InstitutionSeenByReceiptFromStaffToManager = 'InstitutionSeenByReceiptFromStaffToManager'
}

export enum SettingType {
  BOOL = 'BOOL',
  FLOAT = 'FLOAT',
  JSON = 'JSON',
  STRING = 'STRING'
}

export type SettingValueBoolean = {
  __typename?: 'SettingValueBoolean';
  booleanValue: Scalars['Boolean'];
};

export type SettingValueFloat = {
  __typename?: 'SettingValueFloat';
  floatValue: Scalars['Float'];
};

export type SettingValueJson = {
  __typename?: 'SettingValueJson';
  jsonValue: Scalars['String'];
};

export type SettingValueString = {
  __typename?: 'SettingValueString';
  stringValue: Scalars['String'];
};

export type SettingValueUnion = SettingValueBoolean | SettingValueFloat | SettingValueJson | SettingValueString;

/** Details that define a setting */
export type Settings = {
  __typename?: 'Settings';
  /** A key identifying the setting. The combination of the key and scope is unique. */
  key: SettingKeyType;
  /** The possible options for the value. If this is null, then there are no constraints on the value besides its type. */
  options?: Maybe<Array<Scalars['String']>>;
  /** The scope of the setting. */
  scope: SettingsScope;
  /** The type of the value that the setting accepts. */
  type: SettingType;
  /** The value of a setting for the given target ID (target type is defined by the scope). */
  value?: Maybe<SettingValueUnion>;
};


/** Details that define a setting */
export type SettingsvalueArgs = {
  targetId: Scalars['UniqueId'];
};

export type SettingsLeaf = SettingsTree & {
  __typename?: 'SettingsLeaf';
  id: Scalars['String'];
  name: Scalars['String'];
};

/** Mutations managing settings */
export type SettingsMutations = {
  __typename?: 'SettingsMutations';
  setSettings: Array<SettingsScoped>;
};


/** Mutations managing settings */
export type SettingsMutationssetSettingsArgs = {
  scope: SettingsScope;
  settings: Array<SettingInput>;
  targetId: Scalars['UniqueId'];
};

export type SettingsNode = SettingsTree & {
  __typename?: 'SettingsNode';
  id: Scalars['String'];
  name: Scalars['String'];
  subsettings: Array<SettingsTree>;
};

/** Queries managing settings */
export type SettingsQueries = {
  __typename?: 'SettingsQueries';
  /**
   *
   *  List available settings for a given scope.
   *
   *  **NOTE:** Use the `keys` filter to limit results.
   *
   */
  settings: Array<Settings>;
};


/** Queries managing settings */
export type SettingsQueriessettingsArgs = {
  keys?: InputMaybe<Array<SettingKeyType>>;
  scope: SettingsScope;
};

export type SettingsResultType = {
  __typename?: 'SettingsResultType';
  /** True, if the 'QR_SIGNIN_SETTINGS' feature is enabled and the user has the permission to toggle the feature */
  canManage: Scalars['Boolean'];
  /** True, if the 'QR_SIGNIN' feature is enabled */
  isEnabled: Scalars['Boolean'];
  siteId: Scalars['SiteId'];
};

export enum SettingsScope {
  INSTITUTION = 'INSTITUTION',
  LOGIN = 'LOGIN',
  ORGANIZATION = 'ORGANIZATION'
}

/** Details that define a setting */
export type SettingsScoped = {
  __typename?: 'SettingsScoped';
  /** A key identifying the setting. The combination of the key and scope is unique. */
  key: SettingKeyType;
  /** The possible options for the value. If this is null, then there are no constraints on the value besides its type. */
  options?: Maybe<Array<Scalars['String']>>;
  /** The scope of the setting. */
  scope: SettingsScope;
  /** The type of the value that the setting accepts. */
  type: SettingType;
  /** The value of a setting. */
  value?: Maybe<SettingValueUnion>;
};

export type SettingsTree = {
  id: Scalars['String'];
  name: Scalars['String'];
};

export enum SetupGuideCategoryId {
  Attendance = 'Attendance',
  Basics = 'Basics',
  Communication = 'Communication',
  Finance = 'Finance',
  Learning = 'Learning'
}

export enum SetupGuideSectionId {
  AutomaticInvoicing = 'AutomaticInvoicing',
  ChildPlans = 'ChildPlans',
  Children = 'Children',
  CurriculumBuilder = 'CurriculumBuilder',
  InvoiceLayout = 'InvoiceLayout',
  InvoicingBasics = 'InvoicingBasics',
  LearningBasics = 'LearningBasics',
  Preferences = 'Preferences',
  Rooms = 'Rooms',
  SignInKiosk = 'SignInKiosk',
  SignInOptions = 'SignInOptions',
  Staff = 'Staff',
  WritingAssistance = 'WritingAssistance',
  YourNursery = 'YourNursery',
  YourProfile = 'YourProfile'
}

export type ShiftConflictsByGroupType = {
  __typename?: 'ShiftConflictsByGroupType';
  availabilityConflicts: Array<ShiftTypeV3>;
  date: Scalars['LocalDate'];
  doubleBookings: Array<DoubleBookingType>;
  groupId: Scalars['GroupId'];
  leaveConflicts: Array<ShiftTypeV3>;
  numberOfConflicts: Scalars['Int'];
  /** @deprecated Deprecated in App Version 172 */
  periods: Array<ShiftConflictsDetailedType>;
};

export type ShiftConflictsDetailedType = {
  __typename?: 'ShiftConflictsDetailedType';
  availabilityConflicts: Array<ShiftTypeV3>;
  date: Scalars['LocalDate'];
  doubleBookings: Array<DoubleBookingType>;
  from: Scalars['LocalTime'];
  groupId: Scalars['GroupId'];
  leaveConflicts: Array<ShiftTypeV3>;
  numberOfConflicts: Scalars['Int'];
  to: Scalars['LocalTime'];
};

export type ShiftConflictsResultType = {
  __typename?: 'ShiftConflictsResultType';
  doubleBookings: Array<ShiftTypeV3>;
  employee?: Maybe<Employee>;
  isOutsideWorkAvailability: Scalars['Boolean'];
  overlappingLeave: Array<LeaveRequestType>;
};

export type ShiftInput = {
  breakMinutes?: InputMaybe<Scalars['Int']>;
  date: Scalars['LocalDate'];
  employeeId?: InputMaybe<Scalars['EmployeeId']>;
  endTime: Scalars['ZonedDateTime'];
  groupId?: InputMaybe<Scalars['GroupId']>;
  startTime: Scalars['ZonedDateTime'];
};

export type ShiftInputV2 = {
  breakMinutes?: InputMaybe<Scalars['Int']>;
  date: Scalars['LocalDate'];
  employeeId?: InputMaybe<Scalars['EmployeeId']>;
  endTime: Scalars['ZonedDateTime'];
  groupId: Scalars['GroupId'];
  startTime: Scalars['ZonedDateTime'];
};

export type ShiftInputV3 = {
  breakMinutes?: InputMaybe<Scalars['Int']>;
  date: Scalars['LocalDate'];
  employeeId?: InputMaybe<Scalars['EmployeeId']>;
  endTime: Scalars['LocalTime'];
  groupId: Scalars['GroupId'];
  startTime: Scalars['LocalTime'];
  workTagId?: InputMaybe<Scalars['WorkTagId']>;
};

export type ShiftInputV4 = {
  breakMinutes?: InputMaybe<Scalars['Int']>;
  date: Scalars['LocalDate'];
  employeeId?: InputMaybe<Scalars['EmployeeId']>;
  endTime: Scalars['LocalTime'];
  groupId: Scalars['GroupId'];
  recurrence?: InputMaybe<ShiftRecurrenceInput>;
  startTime: Scalars['LocalTime'];
  workTagId?: InputMaybe<Scalars['WorkTagId']>;
};

export type ShiftLocationType = {
  __typename?: 'ShiftLocationType';
  groupId: Scalars['GroupId'];
  title: Scalars['String'];
};

export type ShiftManagementType = {
  __typename?: 'ShiftManagementType';
  draft: DraftShiftManagementType;
  /** @deprecated Deprecated in App Version 167. Use publishedV2 instead. */
  published: PublishedShiftManagementType;
  publishedV2: PublishedShiftManagementType;
};


export type ShiftManagementTypedraftArgs = {
  siteSetId: Scalars['SiteSetId'];
};


export type ShiftManagementTypepublishedArgs = {
  employeeId?: InputMaybe<Scalars['EmployeeId']>;
  siteSetId: Scalars['SiteSetId'];
};


export type ShiftManagementTypepublishedV2Args = {
  employeeId?: InputMaybe<Scalars['EmployeeId']>;
  siteSetId: Scalars['SiteSetId'];
};

/**
 * In order to update the ratio info (and the smiley) on the overview page,
 * the shift mutation result also returns the updated ratio information for
 * all days that are affected by the change made to the shift.
 */
export type ShiftMutationResultType = {
  __typename?: 'ShiftMutationResultType';
  affectedDays: Array<RatioInfoType>;
  shift: ShiftResultType;
};

/**
 * In order to update the ratio info (and the smiley) on the overview page,
 * the shift mutation result also returns the updated ratio information for
 * all days that are affected by the change made to the shift.
 */
export type ShiftMutationResultTypeV3 = {
  __typename?: 'ShiftMutationResultTypeV3';
  affectedDays: Array<RatioInfoType>;
  shift: ShiftResultTypeV3;
};

/**
 * In order to update the ratio info (and the smiley) on the overview page,
 * the shift mutation result also returns the updated ratio information for
 * all days that are affected by the change made to the shifts.
 */
export type ShiftMutationResultTypeV4 = {
  __typename?: 'ShiftMutationResultTypeV4';
  affectedDays: Array<RatioInfoType>;
  affectedEmployeeTotals: Array<StaffHoursTotalsByStaffTypeV2>;
  shifts: Array<ShiftResultTypeV3>;
};

/**
 * In order to update the ratio info (and the smiley) on the overview page,
 * the shift mutation result also returns the updated ratio information for
 * all days that are affected by the change made to the shifts.
 */
export type ShiftMutationResultTypeV5 = {
  __typename?: 'ShiftMutationResultTypeV5';
  affectedDays: Array<RatioInfoDetailedTypeV2>;
  affectedEmployeeTotals: Array<StaffHoursTotalsByStaffTypeV2>;
  shifts: Array<ShiftResultTypeV3>;
};

/**
 * In order to update the ratio info and other staff summary data on the overview page,
 * the shift mutation result also returns data for all days affected and summary for given date range.
 */
export type ShiftMutationResultTypeV6 = {
  __typename?: 'ShiftMutationResultTypeV6';
  affectedDays: Array<RatioInfoDetailedTypeV2>;
  attendanceByStaff: Array<StaffHoursAttendanceByStaffTypeV2>;
  shiftConflicts: Array<ShiftConflictsByGroupType>;
  shifts: Array<ShiftResultTypeV3>;
};

/** Top level node for shift mutations */
export type ShiftMutations = {
  __typename?: 'ShiftMutations';
  /**
   * Deprecated, don't use.
   * @deprecated Deprecated
   */
  create: ShiftMutationResultType;
  /**
   * Deprecated; use createV3 instead
   * @deprecated Deprecated; use createV3 instead
   */
  createV2: ShiftMutationResultType;
  /**
   * Create a new shift.
   * @deprecated Deprecated in app version 163
   */
  createV3: ShiftMutationResultTypeV3;
  /**
   * Create a new shift or recurrent shift.
   * @deprecated Deprecated in App Version 167. Use createV6 instead.
   */
  createV4: ShiftMutationResultTypeV4;
  /**
   * Create a new shift or recurrent shift.
   * @deprecated Deprecated in App Version 167. Use createV6 instead.
   */
  createV5: ShiftMutationResultTypeV5;
  /** Create a new shift or recurrent shift. */
  createV6: ShiftMutationResultTypeV6;
  /**
   * Delete a shift.
   * @deprecated Deprecated in App Version 167. Use deleteSingleShift instead.
   */
  delete: ShiftMutationResultType;
  /**
   * Delete a shift.
   * @deprecated Deprecated in App Version 167. Use deleteV4 instead.
   */
  deleteV2: ShiftMutationResultTypeV4;
  /**
   * Delete a shift.
   * @deprecated Deprecated in App Version 167. Use deleteV4 instead.
   */
  deleteV3: ShiftMutationResultTypeV5;
  /** Delete a shift. */
  deleteV4: ShiftMutationResultTypeV6;
  /**
   * Deprecated, don't use.
   * @deprecated Deprecated
   */
  update: ShiftMutationResultType;
  /**
   * Deprecated; use updateV3 instead
   * @deprecated Deprecated; use updateV3 instead
   */
  updateV2: ShiftMutationResultType;
  /**
   * Update a shift.
   * @deprecated Deprecated in app version 163
   */
  updateV3: ShiftMutationResultTypeV3;
  /**
   * Update a shift or recurrent shift.
   * @deprecated Deprecated in App Version 167. Use updateV6 instead.
   */
  updateV4: ShiftMutationResultTypeV4;
  /**
   * Update a shift or recurrent shift.
   * @deprecated Deprecated in App Version 167. Use updateV6 instead.
   */
  updateV5: ShiftMutationResultTypeV5;
  /** Update a shift or recurrent shift. */
  updateV6: ShiftMutationResultTypeV6;
};


/** Top level node for shift mutations */
export type ShiftMutationscreateArgs = {
  shiftInput: ShiftInput;
  siteSetId: Scalars['SiteSetId'];
};


/** Top level node for shift mutations */
export type ShiftMutationscreateV2Args = {
  shiftInput: ShiftInputV2;
  siteSetId: Scalars['SiteSetId'];
};


/** Top level node for shift mutations */
export type ShiftMutationscreateV3Args = {
  shiftInput: ShiftInputV3;
  siteSetId: Scalars['SiteSetId'];
};


/** Top level node for shift mutations */
export type ShiftMutationscreateV4Args = {
  ratioCalculationRange?: InputMaybe<ClosedLocalDateRange>;
  shiftInput: ShiftInputV4;
  siteSetId: Scalars['SiteSetId'];
};


/** Top level node for shift mutations */
export type ShiftMutationscreateV5Args = {
  ratioCalculationRange?: InputMaybe<ClosedLocalDateRange>;
  shiftInput: ShiftInputV4;
  siteSetId: Scalars['SiteSetId'];
};


/** Top level node for shift mutations */
export type ShiftMutationscreateV6Args = {
  shiftInput: ShiftInputV4;
  siteSetId: Scalars['SiteSetId'];
  staffDataCalculationRange: ClosedLocalDateRange;
};


/** Top level node for shift mutations */
export type ShiftMutationsdeleteArgs = {
  shiftId: Scalars['ShiftId'];
  siteSetId: Scalars['SiteSetId'];
};


/** Top level node for shift mutations */
export type ShiftMutationsdeleteV2Args = {
  deleteFuture?: InputMaybe<Scalars['Boolean']>;
  ratioCalculationRange?: InputMaybe<ClosedLocalDateRange>;
  shiftId: Scalars['ShiftId'];
  siteSetId: Scalars['SiteSetId'];
};


/** Top level node for shift mutations */
export type ShiftMutationsdeleteV3Args = {
  deleteFuture?: InputMaybe<Scalars['Boolean']>;
  ratioCalculationRange?: InputMaybe<ClosedLocalDateRange>;
  shiftId: Scalars['ShiftId'];
  siteSetId: Scalars['SiteSetId'];
};


/** Top level node for shift mutations */
export type ShiftMutationsdeleteV4Args = {
  deleteFuture?: InputMaybe<Scalars['Boolean']>;
  shiftId: Scalars['ShiftId'];
  siteSetId: Scalars['SiteSetId'];
  staffDataCalculationRange: ClosedLocalDateRange;
};


/** Top level node for shift mutations */
export type ShiftMutationsupdateArgs = {
  shiftUpdateInput: ShiftUpdateInput;
  siteSetId: Scalars['SiteSetId'];
};


/** Top level node for shift mutations */
export type ShiftMutationsupdateV2Args = {
  shiftUpdateInput: ShiftUpdateInputV2;
  siteSetId: Scalars['SiteSetId'];
};


/** Top level node for shift mutations */
export type ShiftMutationsupdateV3Args = {
  shiftUpdateInput: ShiftUpdateInputV3;
  siteSetId: Scalars['SiteSetId'];
};


/** Top level node for shift mutations */
export type ShiftMutationsupdateV4Args = {
  ratioCalculationRange?: InputMaybe<ClosedLocalDateRange>;
  shiftUpdateInput: ShiftUpdateInputV4;
  siteSetId: Scalars['SiteSetId'];
};


/** Top level node for shift mutations */
export type ShiftMutationsupdateV5Args = {
  ratioCalculationRange?: InputMaybe<ClosedLocalDateRange>;
  shiftUpdateInput: ShiftUpdateInputV4;
  siteSetId: Scalars['SiteSetId'];
};


/** Top level node for shift mutations */
export type ShiftMutationsupdateV6Args = {
  shiftUpdateInput: ShiftUpdateInputV4;
  siteSetId: Scalars['SiteSetId'];
  staffDataCalculationRange: ClosedLocalDateRange;
};

export type ShiftPlannerByGroupTypeV2 = {
  __typename?: 'ShiftPlannerByGroupTypeV2';
  /** @deprecated Refactored. Use byGroupsV3 instead. */
  groups: Array<ShiftsByGroupTypeV2>;
};

export type ShiftPlannerByGroupTypeV3 = {
  __typename?: 'ShiftPlannerByGroupTypeV3';
  groups: Array<ShiftsByGroupTypeV3>;
};

export type ShiftPlannerByGroupsFilterV2 = {
  groupIds: Array<Scalars['GroupId']>;
};

export type ShiftPlannerByGroupsResultV2 = {
  __typename?: 'ShiftPlannerByGroupsResultV2';
  /** @deprecated Refactored. Use byGroupsV3 instead. */
  next?: Maybe<Scalars['ShiftPlannerByGroupsCursor']>;
  /** @deprecated Refactored. Use byGroupsV3 instead. */
  result: ShiftPlannerByGroupTypeV2;
};

export type ShiftPlannerByGroupsResultV3 = {
  __typename?: 'ShiftPlannerByGroupsResultV3';
  next?: Maybe<Scalars['ShiftPlannerByGroupsCursor']>;
  result: ShiftPlannerByGroupTypeV3;
};

export type ShiftPlannerByStaffFilter = {
  employeeIds: Array<Scalars['EmployeeId']>;
};

export type ShiftPlannerByStaffResult = {
  __typename?: 'ShiftPlannerByStaffResult';
  /** @deprecated Refactored. Use byStaffV2 instead. */
  next?: Maybe<Scalars['ShiftPlannerByStaffCursor']>;
  /** @deprecated Refactored. Use byStaffV2 instead. */
  result: ShiftPlannerByStaffType;
};

export type ShiftPlannerByStaffResultV2 = {
  __typename?: 'ShiftPlannerByStaffResultV2';
  next?: Maybe<Scalars['ShiftPlannerByStaffCursor']>;
  result: ShiftPlannerByStaffTypeV2;
};

export type ShiftPlannerByStaffType = {
  __typename?: 'ShiftPlannerByStaffType';
  /** @deprecated Refactored. Use byStaffV2 instead. */
  employees: Array<EmployeesWithAssignedShiftsType>;
  /** @deprecated Refactored. Use byStaffV2 instead. */
  openShifts: Array<OpenShiftsType>;
};

/** Shifts are structured by their assignment: They are either assigned to an employee or open (= unassigned). */
export type ShiftPlannerByStaffTypeV2 = {
  __typename?: 'ShiftPlannerByStaffTypeV2';
  employees: Array<SchedulesByStaffType>;
  openShifts: Array<OpenShiftsTypeV3>;
};

export type ShiftPlannerCopyWeekResultType = {
  __typename?: 'ShiftPlannerCopyWeekResultType';
  affectedDays: Array<RatioInfoType>;
  shifts: Array<ShiftResultTypeV3>;
};

export type ShiftPlannerCopyWeekResultTypeV2 = {
  __typename?: 'ShiftPlannerCopyWeekResultTypeV2';
  affectedDays: Array<RatioInfoDetailedTypeV2>;
  shiftConflicts: Array<ShiftConflictsByGroupType>;
  shifts: Array<ShiftResultTypeV3>;
};

export type ShiftPlannerFeatureSettingsFlags = {
  __typename?: 'ShiftPlannerFeatureSettingsFlags';
  /** Returns true if the current user can enable/disable this feature. */
  canOptIn: Scalars['Boolean'];
  /** Returns true if this feature is currently enabled, false if the feature is not enabled. */
  isEnabled: Scalars['Boolean'];
  /** Only used for testing. */
  isTestingEnabled: Scalars['Boolean'];
};

/** Top level node for changing settings of the shift planner */
export type ShiftPlannerFeatureSettingsMutations = {
  __typename?: 'ShiftPlannerFeatureSettingsMutations';
  /** @deprecated Deprecated in App Version 160. */
  toggleFeature: Scalars['Boolean'];
};


/** Top level node for changing settings of the shift planner */
export type ShiftPlannerFeatureSettingsMutationstoggleFeatureArgs = {
  siteSetId: Scalars['SiteSetId'];
};

export type ShiftPlannerManagementType = {
  __typename?: 'ShiftPlannerManagementType';
  canCreate: Scalars['Boolean'];
  canDelete: Scalars['Boolean'];
  canEdit: Scalars['Boolean'];
  canView: Scalars['Boolean'];
  shift: ShiftManagementType;
};

/** Shift planner mutations */
export type ShiftPlannerMutations = {
  __typename?: 'ShiftPlannerMutations';
  /**
   * Performs bulk delete operation
   * @deprecated Deprecated in App Version 167.
   */
  bulkDeleteShifts: Scalars['Int'];
  /**
   * Performs bulk delete operation and returns updated ratio info.
   * @deprecated Deprecated in App Version 167.
   */
  bulkDeleteShiftsV2: ShiftMutationResultTypeV4;
  /**
   * Performs bulk delete operation and returns updated ratio info.
   * @deprecated Deprecated in App Version 167.
   */
  bulkDeleteShiftsV3: ShiftMutationResultTypeV5;
  /** Performs bulk delete operation and returns updated ratio info. */
  bulkDeleteShiftsV4: ShiftMutationResultTypeV6;
  /**
   * Copy one week of the schedule to another week.
   * If group ids are passed as parameter only the shifts of those groups will be copied.
   * If no group ids are passed shifts of all groups will be copied.
   *
   * If a ratio date range is passed the result will include ratio info for that date range
   * for all groups affected by the copy action.
   * @deprecated Deprecated in App Version 167.
   */
  copyWeek: ShiftPlannerCopyWeekResultType;
  /**
   * Copy one week of the schedule to another week.
   * If group ids are passed as parameter only the shifts of those groups will be copied.
   * If no group ids are passed shifts of all groups will be copied.
   *
   * If a ratio date range is passed the result will include ratio info for that date range
   * for all groups affected by the copy action.
   */
  copyWeekV2: ShiftPlannerCopyWeekResultTypeV2;
  /** Publish draft shifts within date range or, if no date range is specified, publish all draft shifts. */
  publish: ShiftPlannerPublishResultType;
  shift: ShiftMutations;
};


/** Shift planner mutations */
export type ShiftPlannerMutationsbulkDeleteShiftsArgs = {
  dateRange: ClosedLocalDateRange;
  filterEmployees?: InputMaybe<Array<Scalars['EmployeeId']>>;
  filterGroups?: InputMaybe<Array<Scalars['GroupId']>>;
  includeDraftShifts?: InputMaybe<Scalars['Boolean']>;
  siteSetId: Scalars['SiteSetId'];
};


/** Shift planner mutations */
export type ShiftPlannerMutationsbulkDeleteShiftsV2Args = {
  dateRange: ClosedLocalDateRange;
  filterEmployees?: InputMaybe<Array<Scalars['EmployeeId']>>;
  filterGroups?: InputMaybe<Array<Scalars['GroupId']>>;
  includeDraftShifts?: InputMaybe<Scalars['Boolean']>;
  includeRecurrentShifts?: InputMaybe<Scalars['Boolean']>;
  ratioCalculationRange?: InputMaybe<ClosedLocalDateRange>;
  siteSetId: Scalars['SiteSetId'];
};


/** Shift planner mutations */
export type ShiftPlannerMutationsbulkDeleteShiftsV3Args = {
  dateRange: ClosedLocalDateRange;
  filterEmployees?: InputMaybe<Array<Scalars['EmployeeId']>>;
  filterGroups?: InputMaybe<Array<Scalars['GroupId']>>;
  includeDraftShifts?: InputMaybe<Scalars['Boolean']>;
  includeRecurrentShifts?: InputMaybe<Scalars['Boolean']>;
  ratioCalculationRange?: InputMaybe<ClosedLocalDateRange>;
  siteSetId: Scalars['SiteSetId'];
};


/** Shift planner mutations */
export type ShiftPlannerMutationsbulkDeleteShiftsV4Args = {
  dateRange: ClosedLocalDateRange;
  filterEmployees?: InputMaybe<Array<Scalars['EmployeeId']>>;
  filterGroups?: InputMaybe<Array<Scalars['GroupId']>>;
  includeDraftShifts?: InputMaybe<Scalars['Boolean']>;
  includeRecurrentShifts?: InputMaybe<Scalars['Boolean']>;
  siteSetId: Scalars['SiteSetId'];
  staffDataCalculationRange: ClosedLocalDateRange;
};


/** Shift planner mutations */
export type ShiftPlannerMutationscopyWeekArgs = {
  fromRange: ClosedLocalDateRange;
  groupIds?: InputMaybe<Array<Scalars['GroupId']>>;
  ratioRange?: InputMaybe<ClosedLocalDateRange>;
  siteSetId: Scalars['SiteSetId'];
  toRange: ClosedLocalDateRange;
};


/** Shift planner mutations */
export type ShiftPlannerMutationscopyWeekV2Args = {
  fromRange: ClosedLocalDateRange;
  groupIds?: InputMaybe<Array<Scalars['GroupId']>>;
  ratioRange?: InputMaybe<ClosedLocalDateRange>;
  siteSetId: Scalars['SiteSetId'];
  toRange: ClosedLocalDateRange;
};


/** Shift planner mutations */
export type ShiftPlannerMutationspublishArgs = {
  dateRange?: InputMaybe<ClosedLocalDateRange>;
  siteSetId: Scalars['SiteSetId'];
};

export type ShiftPlannerPublishResultType = {
  __typename?: 'ShiftPlannerPublishResultType';
  publishedShifts: Array<ShiftType>;
};

/** Shift planner queries */
export type ShiftPlannerQueries = {
  __typename?: 'ShiftPlannerQueries';
  /**
   * Deprecated, use byGroupsV3 instead.
   * @deprecated Deprecated, use byGroupsV3 instead.
   */
  byGroupsV2: ShiftPlannerByGroupsResultV2;
  /**
   * Returns all shifts of the site in the given date range organized by groups.
   *
   * Filter: The result can be filtered passing a `ShiftPlannerByGroupsFilter` to only include specific groups.
   *
   * Pagination is currently not implemented.
   */
  byGroupsV3: ShiftPlannerByGroupsResultV3;
  /**
   * Deprecated, use byStaffV2 instead.
   * @deprecated Deprecated, use byStaffV2 instead.
   */
  byStaff: ShiftPlannerByStaffResult;
  /**
   * Returns all open shifts and all employees with assigned shifts in the given date range.
   * The result can further be filtered passing a `ShiftPlannerByStaffFilter` to only include
   * specific employees.
   * Pagination is currently not implemented.
   */
  byStaffV2: ShiftPlannerByStaffResultV2;
  /** Returns the number of shifts that would be deleted in bulk delete operation if given the same parameters. */
  countShiftsToDelete: Scalars['Int'];
  /** Returns the number of draft shifts in the provided date range and the overall number of all existing draft shifts of the given site without date limitation. */
  numberOfDraftShifts: NumberOfDraftShiftsType;
  /**
   * Detailed ratio info of the group.
   * @deprecated Deprecated, use ratioInfoDetailedV2 instead.
   */
  ratioInfo?: Maybe<Array<RatioInfoType>>;
  /**
   * Detailed ratio info of the group.
   * @deprecated Deprecated, use ratioInfoDetailedV2 instead.
   */
  ratioInfoDetailed: RatioInfoDetailedType;
  /**
   * Detailed ratio info of the group.
   * @deprecated Deprecated in App Version 167. User ratioInfoHourly instead.
   */
  ratioInfoDetailedV2?: Maybe<Array<RatioInfoDetailedType>>;
  /** Returns the hourly ratio info for the given groups in the given date range. */
  ratioInfoHourly?: Maybe<Array<RatioInfoDetailedTypeV2>>;
  /**
   * Ratio info for all groups in the given date range.
   * @deprecated Deprecated, use ratioInfoDetailedV2 instead.
   */
  ratioInfoV2?: Maybe<Array<RatioInfoType>>;
  shift: ShiftQueries;
  shiftConflicts: Array<ShiftConflictsByGroupType>;
};


/** Shift planner queries */
export type ShiftPlannerQueriesbyGroupsV2Args = {
  dateRange: ClosedLocalDateRange;
  filters?: InputMaybe<ShiftPlannerByGroupsFilterV2>;
  next?: InputMaybe<Scalars['ShiftPlannerByGroupsCursor']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  siteSetId: Scalars['SiteSetId'];
};


/** Shift planner queries */
export type ShiftPlannerQueriesbyGroupsV3Args = {
  dateRange: ClosedLocalDateRange;
  filters?: InputMaybe<ShiftPlannerByGroupsFilterV2>;
  next?: InputMaybe<Scalars['ShiftPlannerByGroupsCursor']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  siteSetId: Scalars['SiteSetId'];
};


/** Shift planner queries */
export type ShiftPlannerQueriesbyStaffArgs = {
  dateRange: ClosedLocalDateRange;
  filters?: InputMaybe<ShiftPlannerByStaffFilter>;
  next?: InputMaybe<Scalars['ShiftPlannerByStaffCursor']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  siteSetId: Scalars['SiteSetId'];
};


/** Shift planner queries */
export type ShiftPlannerQueriesbyStaffV2Args = {
  dateRange: ClosedLocalDateRange;
  filters?: InputMaybe<ShiftPlannerByStaffFilter>;
  next?: InputMaybe<Scalars['ShiftPlannerByStaffCursor']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  siteSetId: Scalars['SiteSetId'];
};


/** Shift planner queries */
export type ShiftPlannerQueriescountShiftsToDeleteArgs = {
  dateRange: ClosedLocalDateRange;
  filterEmployees?: InputMaybe<Array<Scalars['EmployeeId']>>;
  filterGroups?: InputMaybe<Array<Scalars['GroupId']>>;
  includeDraftShifts?: InputMaybe<Scalars['Boolean']>;
  includeRecurrentShifts?: InputMaybe<Scalars['Boolean']>;
  siteSetId: Scalars['SiteSetId'];
};


/** Shift planner queries */
export type ShiftPlannerQueriesnumberOfDraftShiftsArgs = {
  dateRange: ClosedLocalDateRange;
  siteSetId: Scalars['SiteSetId'];
};


/** Shift planner queries */
export type ShiftPlannerQueriesratioInfoArgs = {
  dateRange: ClosedLocalDateRange;
  groupId: Scalars['GroupId'];
  siteSetId: Scalars['SiteSetId'];
};


/** Shift planner queries */
export type ShiftPlannerQueriesratioInfoDetailedArgs = {
  date: Scalars['LocalDate'];
  groupId: Scalars['GroupId'];
  siteSetId: Scalars['SiteSetId'];
};


/** Shift planner queries */
export type ShiftPlannerQueriesratioInfoDetailedV2Args = {
  dateRange: ClosedLocalDateRange;
  groupIds: Array<Scalars['GroupId']>;
  siteSetId: Scalars['SiteSetId'];
};


/** Shift planner queries */
export type ShiftPlannerQueriesratioInfoHourlyArgs = {
  dateRange: ClosedLocalDateRange;
  groupIds?: InputMaybe<Array<Scalars['GroupId']>>;
  siteSetId: Scalars['SiteSetId'];
};


/** Shift planner queries */
export type ShiftPlannerQueriesratioInfoV2Args = {
  dateRange: ClosedLocalDateRange;
  groupIds: Array<Scalars['GroupId']>;
  siteSetId: Scalars['SiteSetId'];
};


/** Shift planner queries */
export type ShiftPlannerQueriesshiftConflictsArgs = {
  dateRange: ClosedLocalDateRange;
  groupIds?: InputMaybe<Array<Scalars['GroupId']>>;
  siteSetId: Scalars['SiteSetId'];
};

/** Top level node for shift queries */
export type ShiftQueries = {
  __typename?: 'ShiftQueries';
  /** Query double bookings, leave conflicts and availability conflicts upon shift creation. */
  conflictsOnCreate: Array<ShiftConflictsResultType>;
  /** Query double bookings, leave conflicts and availability conflicts upon shift update. */
  conflictsOnUpdate: Array<ShiftConflictsResultType>;
};


/** Top level node for shift queries */
export type ShiftQueriesconflictsOnCreateArgs = {
  shiftInput: ShiftInputV4;
  siteSetId: Scalars['SiteSetId'];
};


/** Top level node for shift queries */
export type ShiftQueriesconflictsOnUpdateArgs = {
  shiftInput: ShiftUpdateInputV4;
  siteSetId: Scalars['SiteSetId'];
};

export type ShiftRecurrenceInput = {
  fromDate: Scalars['LocalDate'];
  repeatFrequencyWeeks: Scalars['Int'];
  repeatFriday: Scalars['Boolean'];
  repeatMonday: Scalars['Boolean'];
  repeatSaturday: Scalars['Boolean'];
  repeatSunday: Scalars['Boolean'];
  repeatThursday: Scalars['Boolean'];
  repeatTuesday: Scalars['Boolean'];
  repeatWednesday: Scalars['Boolean'];
  untilDate: Scalars['LocalDate'];
};

export type ShiftRecurrenceType = {
  __typename?: 'ShiftRecurrenceType';
  fromDate: Scalars['LocalDate'];
  recurrenceId: Scalars['ShiftRecurrenceId'];
  repeatFrequencyWeeks: Scalars['Int'];
  repeatFriday: Scalars['Boolean'];
  repeatMonday: Scalars['Boolean'];
  repeatSaturday: Scalars['Boolean'];
  repeatSunday: Scalars['Boolean'];
  repeatThursday: Scalars['Boolean'];
  repeatTuesday: Scalars['Boolean'];
  repeatWednesday: Scalars['Boolean'];
  untilDate: Scalars['LocalDate'];
};

export type ShiftRecurrenceUpdateInput = {
  untilDate: Scalars['LocalDate'];
};

export type ShiftResultType = {
  __typename?: 'ShiftResultType';
  assignedTo?: Maybe<Scalars['EmployeeId']>;
  breakMinutes?: Maybe<Scalars['Int']>;
  date: Scalars['LocalDate'];
  /** This is LocalDateTime faked as UTC! */
  endTime: Scalars['ZonedDateTime'];
  location?: Maybe<ShiftLocationType>;
  shiftId: Scalars['ShiftId'];
  /** This is LocalDateTime faked as UTC! */
  startTime: Scalars['ZonedDateTime'];
  state: ShiftState;
};

export type ShiftResultTypeV3 = {
  __typename?: 'ShiftResultTypeV3';
  assignedTo?: Maybe<Scalars['EmployeeId']>;
  breakMinutes?: Maybe<Scalars['Int']>;
  date: Scalars['LocalDate'];
  endTime: Scalars['LocalTime'];
  location?: Maybe<ShiftLocationType>;
  recurrence?: Maybe<ShiftRecurrenceType>;
  shiftId: Scalars['ShiftId'];
  startTime: Scalars['LocalTime'];
  state: ShiftState;
  workTag?: Maybe<WorkTagResultResultType>;
};

export enum ShiftState {
  DRAFT = 'DRAFT',
  PUBLISHED = 'PUBLISHED'
}

/**
 * A shift can have two states: Draft or Published.
 * Shifts are either assigned to an employee or open (not assigned).
 * All shifts are located in a group/room
 */
export type ShiftType = {
  __typename?: 'ShiftType';
  assignedTo?: Maybe<Scalars['EmployeeId']>;
  breakMinutes?: Maybe<Scalars['Int']>;
  date: Scalars['LocalDate'];
  /** This is LocalDateTime faked as UTC! */
  endTime: Scalars['ZonedDateTime'];
  location?: Maybe<ShiftLocationType>;
  shiftId: Scalars['ShiftId'];
  /** This is LocalDateTime faked as UTC! */
  startTime: Scalars['ZonedDateTime'];
  state: ShiftState;
};

/**
 * A shift can have two states: Draft or Published.
 * Shifts are either assigned to an employee or open (not assigned).
 * All shifts are located in a group/room
 */
export type ShiftTypeV3 = {
  __typename?: 'ShiftTypeV3';
  assignedTo?: Maybe<Scalars['EmployeeId']>;
  breakMinutes?: Maybe<Scalars['Int']>;
  date: Scalars['LocalDate'];
  endTime: Scalars['LocalTime'];
  location?: Maybe<ShiftLocationType>;
  recurrence?: Maybe<ShiftRecurrenceType>;
  shiftId: Scalars['ShiftId'];
  startTime: Scalars['LocalTime'];
  state: ShiftState;
  workTag?: Maybe<WorkTagResultResultType>;
};

export type ShiftUpdateInput = {
  breakMinutes?: InputMaybe<Scalars['Int']>;
  date: Scalars['LocalDate'];
  employeeId?: InputMaybe<Scalars['EmployeeId']>;
  endTime: Scalars['ZonedDateTime'];
  groupId?: InputMaybe<Scalars['GroupId']>;
  shiftId: Scalars['ShiftId'];
  startTime: Scalars['ZonedDateTime'];
};

export type ShiftUpdateInputV2 = {
  breakMinutes?: InputMaybe<Scalars['Int']>;
  date: Scalars['LocalDate'];
  employeeId?: InputMaybe<Scalars['EmployeeId']>;
  endTime: Scalars['ZonedDateTime'];
  groupId: Scalars['GroupId'];
  shiftId: Scalars['ShiftId'];
  startTime: Scalars['ZonedDateTime'];
};

export type ShiftUpdateInputV3 = {
  breakMinutes?: InputMaybe<Scalars['Int']>;
  date: Scalars['LocalDate'];
  employeeId?: InputMaybe<Scalars['EmployeeId']>;
  endTime: Scalars['LocalTime'];
  groupId: Scalars['GroupId'];
  shiftId: Scalars['ShiftId'];
  startTime: Scalars['LocalTime'];
  workTagId?: InputMaybe<Scalars['WorkTagId']>;
};

export type ShiftUpdateInputV4 = {
  breakMinutes?: InputMaybe<Scalars['Int']>;
  date: Scalars['LocalDate'];
  employeeId?: InputMaybe<Scalars['EmployeeId']>;
  endTime: Scalars['LocalTime'];
  groupId: Scalars['GroupId'];
  recurrence?: InputMaybe<ShiftRecurrenceUpdateInput>;
  shiftId: Scalars['ShiftId'];
  startTime: Scalars['LocalTime'];
  workTagId?: InputMaybe<Scalars['WorkTagId']>;
};

export type ShiftsByGroupTypeV2 = {
  __typename?: 'ShiftsByGroupTypeV2';
  /** @deprecated Refactored. Use byGroupsV3 instead. */
  employees: Array<EmployeesWithAssignedShiftsType>;
  /** @deprecated Refactored. Use byGroupsV3 instead. */
  groupId: Scalars['GroupId'];
  /** @deprecated Refactored. Use byGroupsV3 instead. */
  openShifts: Array<OpenShiftsType>;
  /** @deprecated Refactored. Use byGroupsV3 instead. */
  title: Scalars['String'];
};

export type ShiftsByGroupTypeV3 = {
  __typename?: 'ShiftsByGroupTypeV3';
  employees: Array<SchedulesByStaffType>;
  groupId: Scalars['GroupId'];
  openShifts: Array<OpenShiftsTypeV3>;
  title: Scalars['String'];
};

/** Details about the short-term funding for the full year */
export type ShortTermChildFundingDetails = KibigChildFundingDetails & {
  __typename?: 'ShortTermChildFundingDetails';
  child: Child;
  monthsFunded: Scalars['Int'];
  period?: Maybe<KibigChildPeriod>;
  totalDays: Scalars['Int'];
  totals: KibigFundingTotals;
};

export type ShortTextFieldValue = GenericFormFieldValue & {
  __typename?: 'ShortTextFieldValue';
  fieldTemplate: GenericFormFieldTemplate;
  fieldTemplateId: Scalars['GenericFormFieldTemplateId'];
  fieldType: GenericFormFieldType;
  fieldValueId: Scalars['GenericFormFieldValueId'];
  stringValue: Scalars['String'];
  valueAsString: Scalars['String'];
};

/** Top level object for 'Show me how this works' */
export type ShowMeHowThisWorks = {
  __typename?: 'ShowMeHowThisWorks';
  /** Determines which assets should be shown in the empty state */
  emptyStateAssets?: Maybe<EmptyStateAssets>;
  /**
   * Determines whether the user can see 'Show me how this works' button in some empty states, which if clicked we show the user how a certain page or feature looks/works by a video/animation
   * @deprecated Use pageVideoSource object below in order to add new fields for show me how this works
   */
  isEnabled: Scalars['Boolean'];
  /**
   * Determines whether a page should have a 'show me how this works' and if so, which video to show.
   * @deprecated Use emptyStateAssets instead
   */
  pageVideoSource: pageVideoSource;
};


/** Top level object for 'Show me how this works' */
export type ShowMeHowThisWorksemptyStateAssetsArgs = {
  emptyStatePage: EmptyStatePage;
  siteSetId: Scalars['SiteSetId'];
};


/** Top level object for 'Show me how this works' */
export type ShowMeHowThisWorksisEnabledArgs = {
  siteSetId: Scalars['SiteSetId'];
};


/** Top level object for 'Show me how this works' */
export type ShowMeHowThisWorkspageVideoSourceArgs = {
  siteSetId: Scalars['SiteSetId'];
};

export type ShowOnlyRequiredStaff = {
  __typename?: 'ShowOnlyRequiredStaff';
  required: Scalars['Float'];
};

export type SiblingLink = {
  /** Can be null if the sibling link is internal and the sibling doesn't have a birthday */
  birthDate?: Maybe<Scalars['LocalDate']>;
  /** Will be null if not set. */
  endDate?: Maybe<Scalars['LocalDate']>;
  id: Scalars['SiblingLinkId'];
  name: Name;
  /** The start date for the sibling (optional for external siblings) */
  startDate?: Maybe<Scalars['LocalDate']>;
};

export type SiblingLinkCreationResult = {
  __typename?: 'SiblingLinkCreationResult';
  childId?: Maybe<Scalars['ChildId']>;
  errors: Array<ImportError>;
  foreignId: Scalars['String'];
};

/** Queries related to Sidekick add-on and writing assistant feature */
export type Sidekick = {
  __typename?: 'Sidekick';
  addOn: SidekickAddOn;
  /** The available writing assistant prompts */
  prompts: Array<PromptType>;
  settings: SidekickSettings;
  termsConditions: TermsConditions;
};

/** Queries related to Sidekick add-on settings */
export type SidekickAddOn = {
  __typename?: 'SidekickAddOn';
  /** If true, user can manage the Sidekick add-on settings for the given site. */
  canManage: Scalars['Boolean'];
  /** List sites that user is associated with and are eligible to activate add-on trial and purchase the subscription. */
  listEligible: Array<EligibleForAddOn>;
  trial: SidekickAddOnTrial;
};


/** Queries related to Sidekick add-on settings */
export type SidekickAddOncanManageArgs = {
  siteSetId: Scalars['SiteSetId'];
};

/** The state of a Sidekick add-on banners. */
export enum SidekickAddOnBannerState {
  /** Don't show any banners */
  ShowNothing = 'ShowNothing',
  /** Show purchase banners */
  ShowPurchaseAddOn = 'ShowPurchaseAddOn',
  /** Show start trial banners */
  ShowStartAddOnTrial = 'ShowStartAddOnTrial'
}

/** Fields related to Sidekick add-on trial */
export type SidekickAddOnTrial = {
  __typename?: 'SidekickAddOnTrial';
  /** Determines if banners for activating trial and purchasing subscription are allowed for the given site sets. If user does not have permission for given site, `ShowNothing` state is returned. */
  banner: Array<SiteSetBannerAllowedStatus>;
  /** Determines if the Sidekick add-on trial subscription has expired for the given site sets. */
  expiration: Array<SiteSetExpiredStatusType>;
};


/** Fields related to Sidekick add-on trial */
export type SidekickAddOnTrialbannerArgs = {
  siteSetIds: Array<Scalars['SiteSetId']>;
};


/** Fields related to Sidekick add-on trial */
export type SidekickAddOnTrialexpirationArgs = {
  siteSetIds: Array<Scalars['SiteSetId']>;
};

export type SidekickAddonUpgradeInfo = {
  siteSetId: Scalars['SiteSetId'];
};

export type SidekickAddonUpgradeResponse = {
  __typename?: 'SidekickAddonUpgradeResponse';
  /** Number of seconds the app should wait before refetching behaviors. */
  replicaLag: Scalars['Int'];
};

/** Mutations related to Sidekick add-on and writing assistant feature */
export type SidekickMutation = {
  __typename?: 'SidekickMutation';
  settings: SidekickSettingsMutation;
  /** Sets up the Sidekick add-on for the given site sets by accepting the terms and conditions, enabling the feature and granting access to all roles within the site set. */
  setup: Array<AddOnSetupResult>;
  /** Stores feedback about text that the writing assistant has rewritten. */
  storeFeedback: StoreFeedbackResponse;
  termsConditions: TermsConditionsMutation;
};


/** Mutations related to Sidekick add-on and writing assistant feature */
export type SidekickMutationsetupArgs = {
  siteSetIds: Array<Scalars['SiteSetId']>;
};


/** Mutations related to Sidekick add-on and writing assistant feature */
export type SidekickMutationstoreFeedbackArgs = {
  originalText: Scalars['String'];
  rewrittenText: Scalars['String'];
  selectedPrompt: Scalars['String'];
  userFeedback: Scalars['String'];
};

/** Queries related to the writing assistant settings */
export type SidekickSettings = {
  __typename?: 'SidekickSettings';
  /** If true, the writing assistant configuration should be available in settings. */
  canManage: Scalars['Boolean'];
  /** If true, the writing assistant is enabled for given user. */
  isEnabled?: Maybe<Scalars['Boolean']>;
};


/** Queries related to the writing assistant settings */
export type SidekickSettingscanManageArgs = {
  siteSetId: Scalars['SiteSetId'];
};


/** Queries related to the writing assistant settings */
export type SidekickSettingsisEnabledArgs = {
  siteSetId?: InputMaybe<Scalars['SiteSetId']>;
};

/** Mutations related to the writing assistant settings */
export type SidekickSettingsMutation = {
  __typename?: 'SidekickSettingsMutation';
  /** Toggles on/off the writing assistant for a site. When disabling the feature, it'll also invalidate the accepted T&C. */
  toggle?: Maybe<Scalars['Boolean']>;
};


/** Mutations related to the writing assistant settings */
export type SidekickSettingsMutationtoggleArgs = {
  siteSetId: Scalars['SiteSetId'];
};

export enum SidekickTermsAndConditionsVersion {
  V1 = 'V1',
  V2 = 'V2'
}

export type SidekickTermsResponse = {
  __typename?: 'SidekickTermsResponse';
  hasAccepted: Scalars['Boolean'];
  siteSetId: Scalars['SiteSetId'];
};

export enum SignedAs {
  EMPLOYEE = 'EMPLOYEE',
  PARENT = 'PARENT'
}

export type SignedInChildResult = {
  __typename?: 'SignedInChildResult';
  checkedStatements: Array<CheckInStatementResult>;
  /** @deprecated Do not use this field. Permissions required for this field are too restrictive for some users, e.g. those with family role. */
  child: Child;
  pickupRelation?: Maybe<Scalars['RelationId']>;
  pickupTime?: Maybe<Scalars['ZonedDateTime']>;
  signInId: Scalars['ChildCheckinId'];
  signInTime: Scalars['ZonedDateTime'];
};

export type SignedInEmployeeResult = {
  __typename?: 'SignedInEmployeeResult';
  checkedStatements: Array<CheckInStatementResult>;
  employeeId: Scalars['EmployeeId'];
  group: Group;
  signInId: Scalars['EmployeeCheckInId'];
  signInTime: Scalars['ZonedDateTime'];
};

export type SignedOutChildResult = {
  __typename?: 'SignedOutChildResult';
  childId: Scalars['ChildId'];
  pickupRelation?: Maybe<Scalars['RelationId']>;
  pickupTime?: Maybe<Scalars['ZonedDateTime']>;
  signinId: Scalars['ChildCheckinId'];
  signinTime: Scalars['ZonedDateTime'];
  signoutTime: Scalars['ZonedDateTime'];
};

export type SignedOutEmployeeResult = {
  __typename?: 'SignedOutEmployeeResult';
  employeeId: Scalars['EmployeeId'];
  group: Group;
  signInId: Scalars['EmployeeCheckInId'];
  signInTime: Scalars['ZonedDateTime'];
  signOutTime: Scalars['ZonedDateTime'];
};

/** List information that should be saved at signup time */
export type SignupInfo = {
  __typename?: 'SignupInfo';
  /** Feature interests */
  featureInterests: Array<FeatureInterestType>;
  /** Institution types */
  institutionType: Array<SignupInstitutionType>;
  /** Signup role at institution */
  signupRole: Array<SignupRoleType>;
};

export type SignupInstitutionType = {
  __typename?: 'SignupInstitutionType';
  description: Scalars['String'];
  id: InstitutionType;
};

/** All mutations related to when customers signs up. */
export type SignupMutationType = {
  __typename?: 'SignupMutationType';
  v1: SignupV1MutationType;
  v2: SignupV2MutationType;
  v3: SignupV3Mutation;
  v4: SignupV4Mutation;
  v5: SignupV5Mutation;
  v6: SignupV6Mutation;
  v7: SignupV7Mutation;
};

export enum SignupPrimarySite {
  NURSERY_GROUP = 'NURSERY_GROUP',
  SINGLE_NURSERY = 'SINGLE_NURSERY'
}

export enum SignupRole {
  ADMINISTRATOR = 'ADMINISTRATOR',
  CHILDMINDER = 'CHILDMINDER',
  DIRECTOROWNER = 'DIRECTOROWNER',
  MANAGER = 'MANAGER',
  OTHER = 'OTHER',
  PARENT = 'PARENT',
  PRACTITIONER = 'PRACTITIONER'
}

export type SignupRoleType = {
  __typename?: 'SignupRoleType';
  description: Scalars['String'];
  id: SignupRole;
};

export enum SignupSecondarySite {
  AFTERSCHOOL = 'AFTERSCHOOL',
  CHILDMINDER = 'CHILDMINDER',
  NON_PROFIT = 'NON_PROFIT',
  NURSERY = 'NURSERY',
  OOSC = 'OOSC',
  PRESCHOOL = 'PRESCHOOL',
  WRAPAROUND = 'WRAPAROUND'
}

/** All queries related to when customers signs up. */
export type SignupType = {
  __typename?: 'SignupType';
  v1: SignupV1Type;
  v2: SignupV2Type;
  v3: SignupV3;
  v4: SignupV4;
  v5: SignupV5;
  v6: SignupV6;
  v7: SignupV7;
};

/** Describes an expectation */
export type SignupV1ExpectationsType = {
  __typename?: 'SignupV1ExpectationsType';
  description: Scalars['String'];
  id: Scalars['String'];
  includedFeatures: Array<Scalars['String']>;
};

/** Describes a site type */
export type SignupV1InstitutionType = {
  __typename?: 'SignupV1InstitutionType';
  id: InstitutionType;
  name: Scalars['String'];
};

/** Version 1 of the signup flow. */
export type SignupV1MutationType = {
  __typename?: 'SignupV1MutationType';
  choosePassword: SignupV1QuestionsType;
  createTestChild: SignupV1QuestionsType;
  myExpectationsAre: SignupV1QuestionsType;
  myLicensedCapacityIs: SignupV1QuestionsType;
  myPreviouslyUsedChildCareSystemsAre: SignupV1QuestionsType;
  myRoleIs: SignupV1QuestionsType;
  mySiteTypesAre: SignupV1QuestionsType;
  theAmountOfSitesInMyGroupAre: SignupV1QuestionsType;
};


/** Version 1 of the signup flow. */
export type SignupV1MutationTypechoosePasswordArgs = {
  password: Scalars['String'];
  repeatedPassword?: InputMaybe<Scalars['String']>;
  token: Scalars['String'];
};


/** Version 1 of the signup flow. */
export type SignupV1MutationTypecreateTestChildArgs = {
  name: Scalars['String'];
};


/** Version 1 of the signup flow. */
export type SignupV1MutationTypemyExpectationsAreArgs = {
  expectations: Array<ExpectationInputType>;
};


/** Version 1 of the signup flow. */
export type SignupV1MutationTypemyLicensedCapacityIsArgs = {
  capacity: Scalars['String'];
};


/** Version 1 of the signup flow. */
export type SignupV1MutationTypemyPreviouslyUsedChildCareSystemsAreArgs = {
  childCareSystems: Array<Scalars['String']>;
};


/** Version 1 of the signup flow. */
export type SignupV1MutationTypemyRoleIsArgs = {
  role: Scalars['String'];
};


/** Version 1 of the signup flow. */
export type SignupV1MutationTypemySiteTypesAreArgs = {
  siteTypes: Array<InstitutionType>;
};


/** Version 1 of the signup flow. */
export type SignupV1MutationTypetheAmountOfSitesInMyGroupAreArgs = {
  amountOfSites: Scalars['String'];
};

/** When choosing your password */
export type SignupV1QuestionsChooseYourPasswordType = {
  __typename?: 'SignupV1QuestionsChooseYourPasswordType';
  name: Name;
  passwordPolicy: Scalars['String'];
  passwordRegex: Scalars['String'];
};

/** When choosing the amount of settings in your group */
export type SignupV1QuestionsHowManySitesInGroup = {
  __typename?: 'SignupV1QuestionsHowManySitesInGroup';
  ranges: Array<Scalars['String']>;
};

/** When choosing a test child */
export type SignupV1QuestionsTestChild = {
  __typename?: 'SignupV1QuestionsTestChild';
  avatar: Scalars['String'];
};

/** All the different questions that might be asked in the flow. */
export type SignupV1QuestionsType = SignupV1QuestionsChooseYourPasswordType | SignupV1QuestionsHowManySitesInGroup | SignupV1QuestionsTestChild | SignupV1QuestionsWhatAreYourExpectations | SignupV1QuestionsWhatIsYourLicensedCapacity | SignupV1QuestionsWhatPreviouslyUsedChildCareSystems | SignupV1QuestionsWhatTypeOfSite | SignupV1QuestionsWhatsYourRoleType;

/** When your expectations from using famly */
export type SignupV1QuestionsWhatAreYourExpectations = {
  __typename?: 'SignupV1QuestionsWhatAreYourExpectations';
  expectations: Array<SignupV1ExpectationsType>;
};

/** When choosing the licensed capacity of your site */
export type SignupV1QuestionsWhatIsYourLicensedCapacity = {
  __typename?: 'SignupV1QuestionsWhatIsYourLicensedCapacity';
  ranges: Array<Scalars['String']>;
};

/** When choosing previously used child care systems */
export type SignupV1QuestionsWhatPreviouslyUsedChildCareSystems = {
  __typename?: 'SignupV1QuestionsWhatPreviouslyUsedChildCareSystems';
  childCareSystems: Array<Scalars['String']>;
};

/** When choosing the type that best describes your site */
export type SignupV1QuestionsWhatTypeOfSite = {
  __typename?: 'SignupV1QuestionsWhatTypeOfSite';
  types: Array<SignupV1InstitutionType>;
};

/** When choosing the role you have in the site */
export type SignupV1QuestionsWhatsYourRoleType = {
  __typename?: 'SignupV1QuestionsWhatsYourRoleType';
  roles: Array<SignupRole>;
};

/** Version 1 of the signup flow. */
export type SignupV1Type = {
  __typename?: 'SignupV1Type';
  question: SignupV1QuestionsType;
};

/** Describes an expectation */
export type SignupV2ExpectationsType = {
  __typename?: 'SignupV2ExpectationsType';
  description: Scalars['String'];
  id: Scalars['String'];
  includedFeatures: Array<Scalars['String']>;
};

/** Describes a site type */
export type SignupV2InstitutionType = {
  __typename?: 'SignupV2InstitutionType';
  id: InstitutionType;
  name: Scalars['String'];
};

/** Version 2 of the signup flow. */
export type SignupV2MutationType = {
  __typename?: 'SignupV2MutationType';
  choosePassword: SignupV2QuestionsType;
  createTestChild?: Maybe<SignupV2QuestionsType>;
  myExpectationsAre?: Maybe<SignupV2QuestionsType>;
  myLicensedCapacityIs?: Maybe<SignupV2QuestionsType>;
  myPreviouslyUsedChildCareSystemsAre?: Maybe<SignupV2QuestionsType>;
  myRoleIs?: Maybe<SignupV2QuestionsType>;
  mySiteTypesAre?: Maybe<SignupV2QuestionsType>;
  theAmountOfSitesInMyGroupAre?: Maybe<SignupV2QuestionsType>;
};


/** Version 2 of the signup flow. */
export type SignupV2MutationTypechoosePasswordArgs = {
  password: Scalars['String'];
  token: Scalars['String'];
};


/** Version 2 of the signup flow. */
export type SignupV2MutationTypecreateTestChildArgs = {
  name: Scalars['String'];
};


/** Version 2 of the signup flow. */
export type SignupV2MutationTypemyExpectationsAreArgs = {
  expectations: Array<ExpectationInputType>;
};


/** Version 2 of the signup flow. */
export type SignupV2MutationTypemyLicensedCapacityIsArgs = {
  capacity: Scalars['String'];
};


/** Version 2 of the signup flow. */
export type SignupV2MutationTypemyPreviouslyUsedChildCareSystemsAreArgs = {
  childCareSystems: Array<Scalars['String']>;
};


/** Version 2 of the signup flow. */
export type SignupV2MutationTypemyRoleIsArgs = {
  role: SignupRole;
};


/** Version 2 of the signup flow. */
export type SignupV2MutationTypemySiteTypesAreArgs = {
  siteTypes: Array<InstitutionType>;
};


/** Version 2 of the signup flow. */
export type SignupV2MutationTypetheAmountOfSitesInMyGroupAreArgs = {
  amountOfSites: Scalars['String'];
};

/** When choosing your password */
export type SignupV2QuestionsChooseYourPasswordType = {
  __typename?: 'SignupV2QuestionsChooseYourPasswordType';
  name: Name;
  passwordPolicy: Scalars['String'];
  passwordRegex: Scalars['String'];
};

/** When choosing the amount of settings in your group */
export type SignupV2QuestionsHowManySitesInGroup = {
  __typename?: 'SignupV2QuestionsHowManySitesInGroup';
  ranges: Array<Scalars['String']>;
};

/** When choosing a test child */
export type SignupV2QuestionsTestChild = {
  __typename?: 'SignupV2QuestionsTestChild';
  avatar: Scalars['String'];
};

/** All the different questions that might be asked in the flow. */
export type SignupV2QuestionsType = SignupV2QuestionsChooseYourPasswordType | SignupV2QuestionsHowManySitesInGroup | SignupV2QuestionsTestChild | SignupV2QuestionsWhatAreYourExpectations | SignupV2QuestionsWhatIsYourLicensedCapacity | SignupV2QuestionsWhatPreviouslyUsedChildCareSystems | SignupV2QuestionsWhatTypeOfSite | SignupV2QuestionsWhatsYourRoleType;

/** When your expectations from using famly */
export type SignupV2QuestionsWhatAreYourExpectations = {
  __typename?: 'SignupV2QuestionsWhatAreYourExpectations';
  expectations: Array<SignupV2ExpectationsType>;
};

/** When choosing the licensed capacity of your site */
export type SignupV2QuestionsWhatIsYourLicensedCapacity = {
  __typename?: 'SignupV2QuestionsWhatIsYourLicensedCapacity';
  ranges: Array<Scalars['String']>;
};

/** When choosing previously used child care systems */
export type SignupV2QuestionsWhatPreviouslyUsedChildCareSystems = {
  __typename?: 'SignupV2QuestionsWhatPreviouslyUsedChildCareSystems';
  childCareSystems: Array<Scalars['String']>;
};

/** When choosing the type that best describes your site */
export type SignupV2QuestionsWhatTypeOfSite = {
  __typename?: 'SignupV2QuestionsWhatTypeOfSite';
  types: Array<SignupV2InstitutionType>;
};

/** When choosing the role you have in the site */
export type SignupV2QuestionsWhatsYourRoleType = {
  __typename?: 'SignupV2QuestionsWhatsYourRoleType';
  roles: Array<SignupRole>;
};

/** Version 2 of the signup flow. */
export type SignupV2Type = {
  __typename?: 'SignupV2Type';
  onFree: Scalars['Boolean'];
  onTrial: Scalars['Boolean'];
  onUsFree: Scalars['Boolean'];
  question?: Maybe<SignupV2QuestionsType>;
};

/** Version 3 of the signup flow. */
export type SignupV3 = {
  __typename?: 'SignupV3';
  onFree: Scalars['Boolean'];
  onTrial: Scalars['Boolean'];
  onUsFree: Scalars['Boolean'];
  question?: Maybe<SignupV3Questions>;
};

/** Describes an expectation */
export type SignupV3ExpectationsType = {
  __typename?: 'SignupV3ExpectationsType';
  description: Scalars['String'];
  id: Scalars['String'];
  includedFeatures: Array<Scalars['String']>;
};

/** Describes a site type */
export type SignupV3InstitutionType = {
  __typename?: 'SignupV3InstitutionType';
  id: InstitutionType;
  name: Scalars['String'];
};

/** Version 3 of the signup flow. */
export type SignupV3Mutation = {
  __typename?: 'SignupV3Mutation';
  choosePassword?: Maybe<SignupV3Questions>;
  createTestChild?: Maybe<SignupV3Questions>;
  myExpectationsAre?: Maybe<SignupV3Questions>;
  myLicensedCapacityIs?: Maybe<SignupV3Questions>;
  myPreviouslyUsedChildCareSystemsAre?: Maybe<SignupV3Questions>;
  myRoleIs?: Maybe<SignupV3Questions>;
  mySiteTypesAre?: Maybe<SignupV3Questions>;
  theAmountOfSitesInMyGroupAre?: Maybe<SignupV3Questions>;
};


/** Version 3 of the signup flow. */
export type SignupV3MutationchoosePasswordArgs = {
  password: Scalars['String'];
  token: Scalars['String'];
};


/** Version 3 of the signup flow. */
export type SignupV3MutationcreateTestChildArgs = {
  name: Scalars['String'];
};


/** Version 3 of the signup flow. */
export type SignupV3MutationmyExpectationsAreArgs = {
  expectations: Array<ExpectationInputType>;
};


/** Version 3 of the signup flow. */
export type SignupV3MutationmyLicensedCapacityIsArgs = {
  capacity: Scalars['String'];
};


/** Version 3 of the signup flow. */
export type SignupV3MutationmyPreviouslyUsedChildCareSystemsAreArgs = {
  childCareSystems: Array<Scalars['String']>;
};


/** Version 3 of the signup flow. */
export type SignupV3MutationmyRoleIsArgs = {
  role: SignupRole;
};


/** Version 3 of the signup flow. */
export type SignupV3MutationmySiteTypesAreArgs = {
  siteTypes: Array<InstitutionType>;
};


/** Version 3 of the signup flow. */
export type SignupV3MutationtheAmountOfSitesInMyGroupAreArgs = {
  amountOfSites: Scalars['String'];
};

/** All the different questions that might be asked in the flow. */
export type SignupV3Questions = SignupV3QuestionsChooseYourPassword | SignupV3QuestionsHowManySitesInGroup | SignupV3QuestionsTestChild | SignupV3QuestionsWhatAreYourExpectations | SignupV3QuestionsWhatIsYourLicensedCapacity | SignupV3QuestionsWhatPreviouslyUsedChildCareSystems | SignupV3QuestionsWhatTypeOfSite | SignupV3QuestionsWhatsYourRole;

/** When choosing your password */
export type SignupV3QuestionsChooseYourPassword = {
  __typename?: 'SignupV3QuestionsChooseYourPassword';
  name: Name;
  passwordPolicy: Scalars['String'];
  passwordRegex: Scalars['String'];
};

/** When choosing the amount of settings in your group */
export type SignupV3QuestionsHowManySitesInGroup = {
  __typename?: 'SignupV3QuestionsHowManySitesInGroup';
  ranges: Array<Scalars['String']>;
};

/** When choosing a test child */
export type SignupV3QuestionsTestChild = {
  __typename?: 'SignupV3QuestionsTestChild';
  avatar: Scalars['String'];
};

/** When your expectations from using famly */
export type SignupV3QuestionsWhatAreYourExpectations = {
  __typename?: 'SignupV3QuestionsWhatAreYourExpectations';
  expectations: Array<SignupV3ExpectationsType>;
};

/** When choosing the licensed capacity of your site */
export type SignupV3QuestionsWhatIsYourLicensedCapacity = {
  __typename?: 'SignupV3QuestionsWhatIsYourLicensedCapacity';
  ranges: Array<Scalars['String']>;
};

/** When choosing previously used child care systems */
export type SignupV3QuestionsWhatPreviouslyUsedChildCareSystems = {
  __typename?: 'SignupV3QuestionsWhatPreviouslyUsedChildCareSystems';
  childCareSystems: Array<Scalars['String']>;
};

/** When choosing the type that best describes your site */
export type SignupV3QuestionsWhatTypeOfSite = {
  __typename?: 'SignupV3QuestionsWhatTypeOfSite';
  types: Array<SignupV3InstitutionType>;
};

/** When choosing the role you have in the site */
export type SignupV3QuestionsWhatsYourRole = {
  __typename?: 'SignupV3QuestionsWhatsYourRole';
  roles: Array<SignupRole>;
};

/** Version 4 of the signup flow. */
export type SignupV4 = {
  __typename?: 'SignupV4';
  mixpanelVersions: Array<Scalars['String']>;
  onFree: Scalars['Boolean'];
  onTrial: Scalars['Boolean'];
  onUsFree: Scalars['Boolean'];
  question?: Maybe<SignupV4Questions>;
};

/** Describes an expectation */
export type SignupV4ExpectationsType = {
  __typename?: 'SignupV4ExpectationsType';
  description: Scalars['String'];
  id: Scalars['String'];
  includedFeatures: Array<Scalars['String']>;
};

/** Describes a site type */
export type SignupV4InstitutionType = {
  __typename?: 'SignupV4InstitutionType';
  id: InstitutionType;
  name: Scalars['String'];
};

/** Version 4 of the signup flow. */
export type SignupV4Mutation = {
  __typename?: 'SignupV4Mutation';
  choosePassword?: Maybe<SignupV4Questions>;
  createTestChild?: Maybe<SignupV4Questions>;
  myExpectationsAre?: Maybe<SignupV4Questions>;
  myLicensedCapacityIs?: Maybe<SignupV4Questions>;
  myPreviouslyUsedChildCareSystemsAre?: Maybe<SignupV4Questions>;
  myRoleIs?: Maybe<SignupV4Questions>;
  mySiteTypesAre?: Maybe<SignupV4Questions>;
  theAmountOfSitesInMyGroupAre?: Maybe<SignupV4Questions>;
};


/** Version 4 of the signup flow. */
export type SignupV4MutationchoosePasswordArgs = {
  password: Scalars['String'];
  referrer?: InputMaybe<Scalars['String']>;
  token: Scalars['String'];
};


/** Version 4 of the signup flow. */
export type SignupV4MutationcreateTestChildArgs = {
  name: Scalars['String'];
};


/** Version 4 of the signup flow. */
export type SignupV4MutationmyExpectationsAreArgs = {
  expectations: Array<ExpectationInputType>;
};


/** Version 4 of the signup flow. */
export type SignupV4MutationmyLicensedCapacityIsArgs = {
  capacity: Scalars['String'];
};


/** Version 4 of the signup flow. */
export type SignupV4MutationmyPreviouslyUsedChildCareSystemsAreArgs = {
  childCareSystems: Array<Scalars['String']>;
};


/** Version 4 of the signup flow. */
export type SignupV4MutationmyRoleIsArgs = {
  role: SignupRole;
};


/** Version 4 of the signup flow. */
export type SignupV4MutationmySiteTypesAreArgs = {
  siteTypes: Array<InstitutionType>;
};


/** Version 4 of the signup flow. */
export type SignupV4MutationtheAmountOfSitesInMyGroupAreArgs = {
  amountOfSites: Scalars['String'];
};

/** All the different questions that might be asked in the flow. */
export type SignupV4Questions = SignupV4QuestionsChooseYourPassword | SignupV4QuestionsHowManySitesInGroup | SignupV4QuestionsTestChild | SignupV4QuestionsWhatAreYourExpectations | SignupV4QuestionsWhatIsYourLicensedCapacity | SignupV4QuestionsWhatPreviouslyUsedChildCareSystems | SignupV4QuestionsWhatTypeOfSite | SignupV4QuestionsWhatsYourRole;

/** When choosing your password */
export type SignupV4QuestionsChooseYourPassword = {
  __typename?: 'SignupV4QuestionsChooseYourPassword';
  name: Name;
  passwordPolicy: Scalars['String'];
  passwordRegex: Scalars['String'];
};

/** When choosing the amount of settings in your group */
export type SignupV4QuestionsHowManySitesInGroup = {
  __typename?: 'SignupV4QuestionsHowManySitesInGroup';
  ranges: Array<Scalars['String']>;
};

/** When choosing a test child */
export type SignupV4QuestionsTestChild = {
  __typename?: 'SignupV4QuestionsTestChild';
  avatar: Scalars['String'];
};

/** When your expectations from using famly */
export type SignupV4QuestionsWhatAreYourExpectations = {
  __typename?: 'SignupV4QuestionsWhatAreYourExpectations';
  expectations: Array<SignupV4ExpectationsType>;
};

/** When choosing the licensed capacity of your site */
export type SignupV4QuestionsWhatIsYourLicensedCapacity = {
  __typename?: 'SignupV4QuestionsWhatIsYourLicensedCapacity';
  ranges: Array<Scalars['String']>;
};

/** When choosing previously used child care systems */
export type SignupV4QuestionsWhatPreviouslyUsedChildCareSystems = {
  __typename?: 'SignupV4QuestionsWhatPreviouslyUsedChildCareSystems';
  childCareSystems: Array<Scalars['String']>;
};

/** When choosing the type that best describes your site */
export type SignupV4QuestionsWhatTypeOfSite = {
  __typename?: 'SignupV4QuestionsWhatTypeOfSite';
  types: Array<SignupV4InstitutionType>;
};

/** When choosing the role you have in the site */
export type SignupV4QuestionsWhatsYourRole = {
  __typename?: 'SignupV4QuestionsWhatsYourRole';
  roles: Array<SignupV4RoleType>;
};

/** Describes a role */
export type SignupV4RoleType = {
  __typename?: 'SignupV4RoleType';
  id: SignupRole;
  name: Scalars['String'];
};

/** Version 5 of the signup flow. */
export type SignupV5 = {
  __typename?: 'SignupV5';
  mixpanelVersions: Array<Scalars['String']>;
  onFree: Scalars['Boolean'];
  onTrial: Scalars['Boolean'];
  onUsFree: Scalars['Boolean'];
  question?: Maybe<SignupV5Questions>;
};

/** Describes an expectation */
export type SignupV5ExpectationsType = {
  __typename?: 'SignupV5ExpectationsType';
  description: Scalars['String'];
  id: Scalars['String'];
  includedFeatures: Array<Scalars['String']>;
};

/** Describes a site type */
export type SignupV5InstitutionType = {
  __typename?: 'SignupV5InstitutionType';
  id: InstitutionType;
  name: Scalars['String'];
};

/** Version 5 of the signup flow. */
export type SignupV5Mutation = {
  __typename?: 'SignupV5Mutation';
  choosePassword?: Maybe<SignupV5Questions>;
  createTestChild?: Maybe<TestChildDetailsV5Type>;
  myExpectationsAre?: Maybe<SignupV5Questions>;
  myLicensedCapacityIs?: Maybe<SignupV5Questions>;
  myPreviouslyUsedChildCareSystemsAre?: Maybe<SignupV5Questions>;
  myRoleIs?: Maybe<SignupV5Questions>;
  mySiteTypesAre?: Maybe<SignupV5Questions>;
  theAmountOfSitesInMyGroupAre?: Maybe<SignupV5Questions>;
};


/** Version 5 of the signup flow. */
export type SignupV5MutationchoosePasswordArgs = {
  password: Scalars['String'];
  referrer?: InputMaybe<Scalars['String']>;
  token: Scalars['String'];
};


/** Version 5 of the signup flow. */
export type SignupV5MutationcreateTestChildArgs = {
  name: Scalars['String'];
};


/** Version 5 of the signup flow. */
export type SignupV5MutationmyExpectationsAreArgs = {
  expectations: Array<ExpectationInputType>;
};


/** Version 5 of the signup flow. */
export type SignupV5MutationmyLicensedCapacityIsArgs = {
  capacity: Scalars['String'];
};


/** Version 5 of the signup flow. */
export type SignupV5MutationmyPreviouslyUsedChildCareSystemsAreArgs = {
  childCareSystems: Array<Scalars['String']>;
};


/** Version 5 of the signup flow. */
export type SignupV5MutationmyRoleIsArgs = {
  role: SignupRole;
};


/** Version 5 of the signup flow. */
export type SignupV5MutationmySiteTypesAreArgs = {
  siteTypes: Array<InstitutionType>;
};


/** Version 5 of the signup flow. */
export type SignupV5MutationtheAmountOfSitesInMyGroupAreArgs = {
  amountOfSites: Scalars['String'];
};

/** All the different questions that might be asked in the flow. */
export type SignupV5Questions = SignupV5QuestionsChooseYourPassword | SignupV5QuestionsHowManySitesInGroup | SignupV5QuestionsTestChild | SignupV5QuestionsWhatAreYourExpectations | SignupV5QuestionsWhatIsYourLicensedCapacity | SignupV5QuestionsWhatPreviouslyUsedChildCareSystems | SignupV5QuestionsWhatTypeOfSite | SignupV5QuestionsWhatsYourRole;

/** When choosing your password */
export type SignupV5QuestionsChooseYourPassword = {
  __typename?: 'SignupV5QuestionsChooseYourPassword';
  name: Name;
  passwordPolicy: Scalars['String'];
  passwordRegex: Scalars['String'];
};

/** When choosing the amount of settings in your group */
export type SignupV5QuestionsHowManySitesInGroup = {
  __typename?: 'SignupV5QuestionsHowManySitesInGroup';
  ranges: Array<Scalars['String']>;
};

/** When choosing a test child */
export type SignupV5QuestionsTestChild = {
  __typename?: 'SignupV5QuestionsTestChild';
  avatar: Scalars['String'];
};

/** When your expectations from using famly */
export type SignupV5QuestionsWhatAreYourExpectations = {
  __typename?: 'SignupV5QuestionsWhatAreYourExpectations';
  expectations: Array<SignupV5ExpectationsType>;
};

/** When choosing the licensed capacity of your site */
export type SignupV5QuestionsWhatIsYourLicensedCapacity = {
  __typename?: 'SignupV5QuestionsWhatIsYourLicensedCapacity';
  ranges: Array<Scalars['String']>;
};

/** When choosing previously used child care systems */
export type SignupV5QuestionsWhatPreviouslyUsedChildCareSystems = {
  __typename?: 'SignupV5QuestionsWhatPreviouslyUsedChildCareSystems';
  childCareSystems: Array<Scalars['String']>;
};

/** When choosing the type that best describes your site */
export type SignupV5QuestionsWhatTypeOfSite = {
  __typename?: 'SignupV5QuestionsWhatTypeOfSite';
  types: Array<SignupV5InstitutionType>;
};

/** When choosing the role you have in the site */
export type SignupV5QuestionsWhatsYourRole = {
  __typename?: 'SignupV5QuestionsWhatsYourRole';
  roles: Array<SignupV5RoleType>;
};

/** Describes a role */
export type SignupV5RoleType = {
  __typename?: 'SignupV5RoleType';
  id: SignupRole;
  name: Scalars['String'];
};

/** Version 6 of the signup flow. */
export type SignupV6 = {
  __typename?: 'SignupV6';
  mixpanelVersions: Array<Scalars['String']>;
  onFree: Scalars['Boolean'];
  onTrial: Scalars['Boolean'];
  onUsFree: Scalars['Boolean'];
  question?: Maybe<SignupV6Questions>;
};

/** Describes an expectation */
export type SignupV6ExpectationsType = {
  __typename?: 'SignupV6ExpectationsType';
  description: Scalars['String'];
  id: Scalars['String'];
  includedFeatures: Array<Scalars['String']>;
};

/** Describes a site type */
export type SignupV6InstitutionType = {
  __typename?: 'SignupV6InstitutionType';
  id: InstitutionType;
  name: Scalars['String'];
};

/** Version 6 of the signup flow. */
export type SignupV6Mutation = {
  __typename?: 'SignupV6Mutation';
  choosePassword?: Maybe<SignupV6Questions>;
  createTestChild?: Maybe<TestChildDetailsV5Type>;
  myExpectationsAre?: Maybe<SignupV6Questions>;
  myLicensedCapacityIs?: Maybe<SignupV6Questions>;
  myPreviouslyUsedChildCareSystemsAre?: Maybe<SignupV6Questions>;
  myRoleIs?: Maybe<SignupV6Questions>;
  mySiteTypesAre?: Maybe<SignupV6Questions>;
  theAmountOfSitesInMyGroupAre?: Maybe<SignupV6Questions>;
};


/** Version 6 of the signup flow. */
export type SignupV6MutationchoosePasswordArgs = {
  password: Scalars['String'];
  referrer?: InputMaybe<Scalars['String']>;
  token: Scalars['String'];
};


/** Version 6 of the signup flow. */
export type SignupV6MutationcreateTestChildArgs = {
  name: Scalars['String'];
};


/** Version 6 of the signup flow. */
export type SignupV6MutationmyExpectationsAreArgs = {
  expectations: Array<ExpectationInputType>;
};


/** Version 6 of the signup flow. */
export type SignupV6MutationmyLicensedCapacityIsArgs = {
  capacity: Scalars['String'];
};


/** Version 6 of the signup flow. */
export type SignupV6MutationmyPreviouslyUsedChildCareSystemsAreArgs = {
  childCareSystems: Array<Scalars['String']>;
};


/** Version 6 of the signup flow. */
export type SignupV6MutationmyRoleIsArgs = {
  role: SignupRole;
};


/** Version 6 of the signup flow. */
export type SignupV6MutationmySiteTypesAreArgs = {
  primarySiteType: SignupPrimarySite;
  secondarySiteTypes?: InputMaybe<Array<SignupSecondarySite>>;
};


/** Version 6 of the signup flow. */
export type SignupV6MutationtheAmountOfSitesInMyGroupAreArgs = {
  amountOfSites: Scalars['String'];
};

/** Describes a site type */
export type SignupV6PrimarySiteType = {
  __typename?: 'SignupV6PrimarySiteType';
  id: SignupPrimarySite;
  name: Scalars['String'];
};

/** All the different questions that might be asked in the flow. */
export type SignupV6Questions = SignupV6QuestionsChooseYourPassword | SignupV6QuestionsHowManySitesInGroup | SignupV6QuestionsTestChild | SignupV6QuestionsWhatAreYourExpectations | SignupV6QuestionsWhatIsYourLicensedCapacity | SignupV6QuestionsWhatPreviouslyUsedChildCareSystems | SignupV6QuestionsWhatTypeOfSite | SignupV6QuestionsWhatsYourRole;

/** When choosing your password */
export type SignupV6QuestionsChooseYourPassword = {
  __typename?: 'SignupV6QuestionsChooseYourPassword';
  name: Name;
  passwordPolicy: Scalars['String'];
  passwordRegex: Scalars['String'];
};

/** When choosing the amount of settings in your group */
export type SignupV6QuestionsHowManySitesInGroup = {
  __typename?: 'SignupV6QuestionsHowManySitesInGroup';
  ranges: Array<Scalars['String']>;
};

/** When choosing a test child */
export type SignupV6QuestionsTestChild = {
  __typename?: 'SignupV6QuestionsTestChild';
  avatar: Scalars['String'];
};

/** When your expectations from using famly */
export type SignupV6QuestionsWhatAreYourExpectations = {
  __typename?: 'SignupV6QuestionsWhatAreYourExpectations';
  expectations: Array<SignupV6ExpectationsType>;
};

/** When choosing the licensed capacity of your site */
export type SignupV6QuestionsWhatIsYourLicensedCapacity = {
  __typename?: 'SignupV6QuestionsWhatIsYourLicensedCapacity';
  ranges: Array<Scalars['String']>;
};

/** When choosing previously used child care systems */
export type SignupV6QuestionsWhatPreviouslyUsedChildCareSystems = {
  __typename?: 'SignupV6QuestionsWhatPreviouslyUsedChildCareSystems';
  childCareSystems: Array<Scalars['String']>;
};

/** When choosing the type that best describes your site */
export type SignupV6QuestionsWhatTypeOfSite = {
  __typename?: 'SignupV6QuestionsWhatTypeOfSite';
  primarySiteTypes: Array<SignupV6PrimarySiteType>;
  secondarySiteTypes: Array<SignupV6SecondarySiteType>;
  /** @deprecated Use primarySiteTypes and secondarySiteTypes */
  types: Array<SignupV6InstitutionType>;
};

/** When choosing the role you have in the site */
export type SignupV6QuestionsWhatsYourRole = {
  __typename?: 'SignupV6QuestionsWhatsYourRole';
  roles: Array<SignupV6RoleType>;
};

/** Describes a role */
export type SignupV6RoleType = {
  __typename?: 'SignupV6RoleType';
  id: SignupRole;
  name: Scalars['String'];
};

/** Describes a site type */
export type SignupV6SecondarySiteType = {
  __typename?: 'SignupV6SecondarySiteType';
  id: SignupSecondarySite;
  name: Scalars['String'];
};

/** Version 7 of the signup flow. */
export type SignupV7 = {
  __typename?: 'SignupV7';
  mixpanelVersions: Array<Scalars['String']>;
  onFree: Scalars['Boolean'];
  onTrial: Scalars['Boolean'];
  onUsFree: Scalars['Boolean'];
  optionalTestChild: Scalars['Boolean'];
  question?: Maybe<SignupV7Questions>;
};

/** Describes an expectation */
export type SignupV7ExpectationsType = {
  __typename?: 'SignupV7ExpectationsType';
  description: Scalars['String'];
  id: Scalars['String'];
  includedFeatures: Array<Scalars['String']>;
};

/** Describes a site type */
export type SignupV7InstitutionType = {
  __typename?: 'SignupV7InstitutionType';
  id: InstitutionType;
  name: Scalars['String'];
};

/** Version 7 of the signup flow. */
export type SignupV7Mutation = {
  __typename?: 'SignupV7Mutation';
  choosePassword?: Maybe<SignupV7Questions>;
  createTestChild?: Maybe<TestChildDetailsV5Type>;
  dismiss?: Maybe<SignupV7Questions>;
  myExpectationIs?: Maybe<SignupV7Questions>;
  myLicensedCapacityIs?: Maybe<SignupV7Questions>;
  myPreviouslyUsedChildCareSystemsAre?: Maybe<SignupV7Questions>;
  myRoleIs?: Maybe<SignupV7Questions>;
  mySiteTypesAre?: Maybe<SignupV7Questions>;
  theAmountOfSitesInMyGroupAre?: Maybe<SignupV7Questions>;
};


/** Version 7 of the signup flow. */
export type SignupV7MutationchoosePasswordArgs = {
  password: Scalars['String'];
  referrer?: InputMaybe<Scalars['String']>;
  token: Scalars['String'];
};


/** Version 7 of the signup flow. */
export type SignupV7MutationcreateTestChildArgs = {
  name: Scalars['String'];
};


/** Version 7 of the signup flow. */
export type SignupV7MutationmyExpectationIsArgs = {
  expectation: ExpectationInputType;
};


/** Version 7 of the signup flow. */
export type SignupV7MutationmyLicensedCapacityIsArgs = {
  capacity: Scalars['String'];
};


/** Version 7 of the signup flow. */
export type SignupV7MutationmyPreviouslyUsedChildCareSystemsAreArgs = {
  childCareSystems: Array<Scalars['String']>;
};


/** Version 7 of the signup flow. */
export type SignupV7MutationmyRoleIsArgs = {
  role: SignupRole;
};


/** Version 7 of the signup flow. */
export type SignupV7MutationmySiteTypesAreArgs = {
  primarySiteType: SignupPrimarySite;
  secondarySiteTypes?: InputMaybe<Array<SignupSecondarySite>>;
};


/** Version 7 of the signup flow. */
export type SignupV7MutationtheAmountOfSitesInMyGroupAreArgs = {
  amountOfSites: Scalars['String'];
};

/** Describes a site type */
export type SignupV7PrimarySiteType = {
  __typename?: 'SignupV7PrimarySiteType';
  id: SignupPrimarySite;
  name: Scalars['String'];
};

/** All the different questions that might be asked in the flow. */
export type SignupV7Questions = SignupV7QuestionsChooseYourPassword | SignupV7QuestionsHowManySitesInGroup | SignupV7QuestionsTestChild | SignupV7QuestionsWhatAreYourExpectations | SignupV7QuestionsWhatIsYourLicensedCapacity | SignupV7QuestionsWhatPreviouslyUsedChildCareSystems | SignupV7QuestionsWhatTypeOfSite | SignupV7QuestionsWhatsYourRole;

/** When choosing your password */
export type SignupV7QuestionsChooseYourPassword = {
  __typename?: 'SignupV7QuestionsChooseYourPassword';
  name: Name;
  passwordPolicy: Scalars['String'];
  passwordRegex: Scalars['String'];
};

/** When choosing the amount of settings in your group */
export type SignupV7QuestionsHowManySitesInGroup = {
  __typename?: 'SignupV7QuestionsHowManySitesInGroup';
  ranges: Array<Scalars['String']>;
};

/** When choosing a test child */
export type SignupV7QuestionsTestChild = {
  __typename?: 'SignupV7QuestionsTestChild';
  avatar: Scalars['String'];
};

/** When your expectations from using famly */
export type SignupV7QuestionsWhatAreYourExpectations = {
  __typename?: 'SignupV7QuestionsWhatAreYourExpectations';
  expectations: Array<SignupV7ExpectationsType>;
};

/** When choosing the licensed capacity of your site */
export type SignupV7QuestionsWhatIsYourLicensedCapacity = {
  __typename?: 'SignupV7QuestionsWhatIsYourLicensedCapacity';
  ranges: Array<Scalars['String']>;
};

/** When choosing previously used child care systems */
export type SignupV7QuestionsWhatPreviouslyUsedChildCareSystems = {
  __typename?: 'SignupV7QuestionsWhatPreviouslyUsedChildCareSystems';
  childCareSystems: Array<Scalars['String']>;
};

/** When choosing the type that best describes your site */
export type SignupV7QuestionsWhatTypeOfSite = {
  __typename?: 'SignupV7QuestionsWhatTypeOfSite';
  primarySiteTypes: Array<SignupV7PrimarySiteType>;
  secondarySiteTypes: Array<SignupV7SecondarySiteType>;
  /** @deprecated Use primarySiteTypes and secondarySiteTypes */
  types: Array<SignupV7InstitutionType>;
};

/** When choosing the role you have in the site */
export type SignupV7QuestionsWhatsYourRole = {
  __typename?: 'SignupV7QuestionsWhatsYourRole';
  roles: Array<SignupV7RoleType>;
};

/** Describes a role */
export type SignupV7RoleType = {
  __typename?: 'SignupV7RoleType';
  id: SignupRole;
  name: Scalars['String'];
};

/** Describes a site type */
export type SignupV7SecondarySiteType = {
  __typename?: 'SignupV7SecondarySiteType';
  id: SignupSecondarySite;
  name: Scalars['String'];
};

/** Top level object for SimplifiedUsInvoicing queries */
export type SimplifiedUsInvoicing = {
  __typename?: 'SimplifiedUsInvoicing';
  /** Decides whether a child's site has access to Simplified US invoicing */
  isEnabledForChild: Scalars['Boolean'];
  /** Decides whether a site has access to Simplified US invoicing */
  isEnabledForSite: Scalars['Boolean'];
};


/** Top level object for SimplifiedUsInvoicing queries */
export type SimplifiedUsInvoicingisEnabledForChildArgs = {
  childId: Scalars['ChildId'];
};


/** Top level object for SimplifiedUsInvoicing queries */
export type SimplifiedUsInvoicingisEnabledForSiteArgs = {
  siteId: Scalars['SiteId'];
};

export type Site = {
  __typename?: 'Site';
  addressFormatting: AddressFormatting;
  ageGroups: AgeGroups;
  /** Behaviors that are granted to the current user */
  behaviors: Array<Behavior>;
  departments: Array<Department>;
  details: InstitutionDetails;
  /** @deprecated Use store.apps instead */
  famlyStoreApps: Array<StoreApp>;
  groups: Array<Group>;
  identificationNumber?: Maybe<Scalars['String']>;
  institutionId: Scalars['InstitutionId'];
  invoicingScheme: InvoicingScheme;
  locale: Scalars['Locale'];
  managedFeatures: Array<ManagedFeature>;
  managedFeaturesWitParentalPermissions: Array<ParentalPermissionFeature>;
  openingHours: OpeningHours;
  privacyPolicyUrl?: Maybe<Scalars['String']>;
  profileImage?: Maybe<ProfileImage>;
  rollingDeletion: Array<RollingDeletion>;
  ruleGroups: Array<RuleSet>;
  /**
   * @deprecated Use `ruleGroups` instead for the 'pricing' namespace. (The 'rooms' namespace can keep using this field.)
   * Using this field when more than one rule group exists will always return an error.
   */
  rules?: Maybe<RuleSet>;
  settings: InstitutionSettings;
  /**
   *
   *  List available settings for a given scope.
   *
   *  **NOTE:** Use the `keys` filter to limit results.
   *
   */
  settingsScoped: Array<SettingsScoped>;
  swissInstitutionData?: Maybe<SwissInstitutionData>;
  tags: Array<Tag>;
  timeZone: Scalars['ZoneId'];
  title: Scalars['String'];
};


export type SiteruleGroupsArgs = {
  namespace?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Array<Scalars['Json']>>;
  version?: InputMaybe<Scalars['Int']>;
};


export type SiterulesArgs = {
  namespace?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Array<Scalars['Json']>>;
  version?: InputMaybe<Scalars['Int']>;
};


export type SitesettingsScopedArgs = {
  keys?: InputMaybe<Array<SettingKeyType>>;
};

export type SiteBaseline = {
  __typename?: 'SiteBaseline';
  /** Children without vaccinations (given or exempt) */
  noVaccinations: Array<Child>;
  siteId: Scalars['SiteId'];
  /** Children with at least one vaccination recorded */
  withVaccinations: Array<Child>;
};

export type SiteBillPayer = {
  __typename?: 'SiteBillPayer';
  email?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  role: Scalars['String'];
};

export type SiteCounts = {
  __typename?: 'SiteCounts';
  childCount?: Maybe<Scalars['Int']>;
  /** If 'statusType' is 'Custom' this will hold the custom status */
  customStatus?: Maybe<CustomStatusType>;
  staffCount?: Maybe<Scalars['Int']>;
  statusType: StatusType;
};

export type SiteInformation = {
  __typename?: 'SiteInformation';
  city?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  phoneNumber: Scalars['String'];
  street?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type SiteOverviewElement = AbsencesWidget | RoomsWidget | TagsWidget;

export type SiteOverviewSummaryWidgetType = Widget & {
  __typename?: 'SiteOverviewSummaryWidgetType';
  id: Scalars['HomeWidgetId'];
  next?: Maybe<Scalars['HomeWidgetCursor']>;
  siteCounts: Array<SiteCounts>;
  title: Scalars['String'];
  widgetId: Scalars['String'];
};

export type SiteOverviewWidget = Widget & {
  __typename?: 'SiteOverviewWidget';
  elements: Array<SiteOverviewElement>;
  id: Scalars['HomeWidgetId'];
  next?: Maybe<Scalars['HomeWidgetCursor']>;
  title: Scalars['String'];
  widgetId: Scalars['String'];
};

export type SiteRestriction = {
  __typename?: 'SiteRestriction';
  restriction: PaymentMethodRestriction;
  siteId: Scalars['SiteId'];
};

/** Information about banner state for a Sidekick add-on */
export type SiteSetBannerAllowedStatus = {
  __typename?: 'SiteSetBannerAllowedStatus';
  /** @deprecated Use `state` field to determine if the banner is allowed. */
  isBannerAllowed: Scalars['Boolean'];
  siteSetId: Scalars['SiteSetId'];
  /** Indicates which Sidekick add-on banner should be shown. */
  state: SidekickAddOnBannerState;
};

/** Information about the expiration of the most recently created sidekick add-on trial for this site. */
export type SiteSetExpiredStatusType = {
  __typename?: 'SiteSetExpiredStatusType';
  /** The date and time when the trial subscription ends. */
  endsAt?: Maybe<Scalars['ZonedDateTime']>;
  hasConverted: Scalars['Boolean'];
  /** @deprecated Use `endsAt` field to determine if the trial subscription has expired or `trial.banner.state` to decide which banners to show. */
  isExpired: Scalars['Boolean'];
  siteSetId: Scalars['SiteSetId'];
};

export type SiteSettingsResultType = {
  __typename?: 'SiteSettingsResultType';
  siteSettings: Array<SettingsResultType>;
};

export enum SleepStatus {
  ASLEEP = 'ASLEEP',
  AWAKE = 'AWAKE'
}

export enum SmsItemType {
  MESSAGE = 'MESSAGE',
  POST = 'POST'
}

/** Details of the sent SMS message */
export type SmsSendMessageResult = {
  __typename?: 'SmsSendMessageResult';
  smsMessageId: Scalars['SmsMessageId'];
};

/** Details about SMS settings */
export type SmsSettings = {
  __typename?: 'SmsSettings';
  /** @deprecated Use the more specific canSendSmsForPosts and canSendSmsForMessages fields instead */
  canSendSms: Scalars['Boolean'];
  canSendSmsForMessages: Scalars['Boolean'];
  canSendSmsForPosts: Scalars['Boolean'];
  /** @deprecated Use canSendSms instead */
  isEnabled: Scalars['Boolean'];
  isEnabledForMessages: Scalars['Boolean'];
  isEnabledForPosts: Scalars['Boolean'];
  /** The phone number that SMS messages will be sent from */
  phoneNumber: Scalars['String'];
  pricePerMessage: PricePerMessage;
  shortName?: Maybe<Scalars['String']>;
  siteSetId: Scalars['SiteSetId'];
};

/** Details about SMS settings */
export type SmsSettingsResult = {
  __typename?: 'SmsSettingsResult';
  /**
   * Details about SMS settings for messages
   * @deprecated Use the more general 'settings' field instead
   */
  messages: Array<SmsSettings>;
  /**
   * Details about SMS settings for posts
   * @deprecated Use the more general 'settings' field instead
   */
  posts: Array<SmsSettings>;
  settings: Array<SmsSettings>;
};

/** Details about the billing information w.r.t. SMS for a given site */
export type SmsSiteBillingInformation = {
  __typename?: 'SmsSiteBillingInformation';
  costPreviousMonth?: Maybe<Scalars['String']>;
  costThisMonth?: Maybe<Scalars['String']>;
  messagesSentThisMonth: Scalars['Int'];
  siteId: Scalars['SiteId'];
};

/** Information about which SMS settings can be togged for a site */
export type SmsSiteConfiguration = {
  __typename?: 'SmsSiteConfiguration';
  canSetShortName: Scalars['Boolean'];
  canToggleForMessages: Scalars['Boolean'];
  canToggleForPost: Scalars['Boolean'];
  canViewBillingInformation: Scalars['Boolean'];
  siteId: Scalars['SiteId'];
};

export enum SmsStatus {
  DELIVERED = 'DELIVERED',
  FAILED = 'FAILED',
  INVALID_NUMBER = 'INVALID_NUMBER',
  IN_PROGRESS = 'IN_PROGRESS',
  NO_NUMBER = 'NO_NUMBER'
}

/** Details of a SMS status */
export type SmsStatusResult = {
  __typename?: 'SmsStatusResult';
  loginId: Scalars['LoginId'];
  smsStatus: SmsStatus;
};

export type SocialMedia = {
  __typename?: 'SocialMedia';
  facebook?: Maybe<Scalars['URI']>;
  instagram?: Maybe<Scalars['URI']>;
  twitter?: Maybe<Scalars['URI']>;
};

/** Mutations related to the social media */
export type SocialMediaMutations = {
  __typename?: 'SocialMediaMutations';
  updateFacebook?: Maybe<Scalars['URI']>;
  updateInstagram?: Maybe<Scalars['URI']>;
  updateTwitter?: Maybe<Scalars['URI']>;
};


/** Mutations related to the social media */
export type SocialMediaMutationsupdateFacebookArgs = {
  institutionId: Scalars['InstitutionId'];
  link?: InputMaybe<Scalars['URI']>;
};


/** Mutations related to the social media */
export type SocialMediaMutationsupdateInstagramArgs = {
  institutionId: Scalars['InstitutionId'];
  link?: InputMaybe<Scalars['URI']>;
};


/** Mutations related to the social media */
export type SocialMediaMutationsupdateTwitterArgs = {
  institutionId: Scalars['InstitutionId'];
  link?: InputMaybe<Scalars['URI']>;
};

export enum Source {
  EYEOG = 'EYEOG',
  Plan = 'Plan',
  SiteSet = 'SiteSet'
}

export type StaffAbsenceCount = {
  __typename?: 'StaffAbsenceCount';
  count: Scalars['Int'];
  leaveType: StaffLeaveType;
};

export type StaffAttendanceManagementEmployeeType = {
  __typename?: 'StaffAttendanceManagementEmployeeType';
  /** Returns true if the current user can edit the overall staff attendance (leaves, attended hours and scheduled hours) of the given employee. */
  canEdit: Scalars['Boolean'];
  /** Returns true if the current user can view the overall staff attendance (leaves, attended hours and scheduled hours) of the given employee. */
  canView: Scalars['Boolean'];
};

/** Query management of overall staff attendance (leaves, attended hours and scheduled hours). */
export type StaffAttendanceManagementQuery = {
  __typename?: 'StaffAttendanceManagementQuery';
  employee: StaffAttendanceManagementEmployeeType;
  siteSet: StaffAttendanceManagementType;
};


/** Query management of overall staff attendance (leaves, attended hours and scheduled hours). */
export type StaffAttendanceManagementQueryemployeeArgs = {
  employeeId: Scalars['EmployeeId'];
  siteSetId: Scalars['SiteSetId'];
};


/** Query management of overall staff attendance (leaves, attended hours and scheduled hours). */
export type StaffAttendanceManagementQuerysiteSetArgs = {
  siteSetId: Scalars['SiteSetId'];
};

export type StaffAttendanceManagementType = {
  __typename?: 'StaffAttendanceManagementType';
  /** Returns true if the current user can view the overall staff attendance (leaves, attended hours and scheduled hours) of the given site set. */
  canView: Scalars['Boolean'];
};

export type StaffAttendancePageFeatureSettingsFlags = {
  __typename?: 'StaffAttendancePageFeatureSettingsFlags';
  /** Returns true if the user is allowed to toggle this feature on/off. */
  canOptIn: Scalars['Boolean'];
  /** Returns true if the user is allowed to opt out of this feature. */
  canOptOut: Scalars['Boolean'];
  /** Returns true if the feature is enabled. */
  isEnabled: Scalars['Boolean'];
};

export type StaffHoursAttendanceByStaffOnDayType = {
  __typename?: 'StaffHoursAttendanceByStaffOnDayType';
  /** @deprecated Current Mobile App Version 163. Use 'attendanceV2' instead */
  attendance: Array<StaffMemberAttendanceRecord>;
  attendanceV2: Array<StaffMemberAttendanceRecordV2>;
  date: Scalars['LocalDate'];
  /** @deprecated Current Mobile App Version 160. Use 'leaveRequests.leaves' instead */
  leave: Array<StaffMemberLeaves>;
  leaveRequests: Array<LeaveRequestType>;
  /** @deprecated Current Mobile App Version 159. Use 'leaveRequests' instead */
  leaves: Array<LeaveRequestType>;
  shifts: Array<ShiftTypeV3>;
  totals: StaffHoursTotalsType;
};

export type StaffHoursAttendanceByStaffType = {
  __typename?: 'StaffHoursAttendanceByStaffType';
  bankHours?: Maybe<BankHours>;
  minutesOverview: StaffHoursTotalsType;
  recordsByDay: Array<StaffHoursAttendanceByStaffOnDayType>;
  staffMember: Employee;
};

export type StaffHoursAttendanceByStaffTypeV2 = {
  __typename?: 'StaffHoursAttendanceByStaffTypeV2';
  bankHours?: Maybe<BankHoursV2>;
  dateRange: TimeRangeClosed;
  minutesOverview: StaffHoursTotalsType;
  recordsByDay: Array<StaffHoursAttendanceByStaffOnDayType>;
  staffMember: Employee;
};

/** Staff hours attendance queries */
export type StaffHoursAttendanceQueriesType = {
  __typename?: 'StaffHoursAttendanceQueriesType';
  /**
   * Query the staff hours attendance in the date range for all employees of the site set.
   * The maximum date range is set to 7 days.
   *
   * Filters: The result can be filtered on employee ids and on employee base rooms. If group ids are passed,
   * the query will only return employees whose base room set to that group.
   *
   * Pagination will only be active if the parameter page size is passed.
   * If no page size is defined the query result will not be paginated.
   *
   * @deprecated Current Mobile App Version 160. Use 'byStaffV2' instead
   */
  byStaff: StaffHoursAttendanceResult;
  /**
   * Query the staff hours attendance in the date range for all employees of the site set.
   * The maximum date range is set to 7 days.
   *
   * Filters: The result can be filtered on employee ids and on employee base rooms. If group ids are passed,
   * the query will only return employees whose base room set to that group.
   *
   * Pagination will only be active if the parameter page size is passed.
   * If no page size is defined the query result will not be paginated.
   *
   */
  byStaffV2: StaffHoursAttendanceResultV2;
  dailyCsvExportURL: Scalars['String'];
  detailedCsvExportURL: Scalars['String'];
  historicalCsvExportURL: Scalars['String'];
};


/** Staff hours attendance queries */
export type StaffHoursAttendanceQueriesTypebyStaffArgs = {
  dateRange: ClosedLocalDateRange;
  employeeIds?: InputMaybe<Array<Scalars['EmployeeId']>>;
  groupIds?: InputMaybe<Array<Scalars['GroupId']>>;
  next?: InputMaybe<Scalars['StaffHoursByStaffCursor']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  siteSetId: Scalars['SiteSetId'];
};


/** Staff hours attendance queries */
export type StaffHoursAttendanceQueriesTypebyStaffV2Args = {
  dateRange: ClosedLocalDateRange;
  employeeIds?: InputMaybe<Array<Scalars['EmployeeId']>>;
  groupIds?: InputMaybe<Array<Scalars['GroupId']>>;
  next?: InputMaybe<Scalars['StaffHoursByStaffCursor']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  siteSetId: Scalars['SiteSetId'];
};


/** Staff hours attendance queries */
export type StaffHoursAttendanceQueriesTypedailyCsvExportURLArgs = {
  dateRange: ClosedLocalDateRange;
  siteSetId: Scalars['SiteSetId'];
};


/** Staff hours attendance queries */
export type StaffHoursAttendanceQueriesTypedetailedCsvExportURLArgs = {
  dateRange: ClosedLocalDateRange;
  recordTypes?: InputMaybe<Array<StaffHoursRecordTypes>>;
  siteSetId: Scalars['SiteSetId'];
};


/** Staff hours attendance queries */
export type StaffHoursAttendanceQueriesTypehistoricalCsvExportURLArgs = {
  dateRange: ClosedLocalDateRange;
  siteSetId: Scalars['SiteSetId'];
};

export type StaffHoursAttendanceResult = {
  __typename?: 'StaffHoursAttendanceResult';
  byStaff: Array<StaffHoursAttendanceByStaffType>;
  dateRange: TimeRangeClosed;
  next?: Maybe<Scalars['StaffHoursByStaffCursor']>;
};

export type StaffHoursAttendanceResultV2 = {
  __typename?: 'StaffHoursAttendanceResultV2';
  byStaff: Array<StaffHoursAttendanceByStaffTypeV2>;
  dateRange: TimeRangeClosed;
  next?: Maybe<Scalars['StaffHoursByStaffCursor']>;
};

/** Staff hours empty states queries */
export type StaffHoursEmptyStatesQueries = {
  __typename?: 'StaffHoursEmptyStatesQueries';
  staffLeave: EmptyStateStaffLeaveResultType;
};


/** Staff hours empty states queries */
export type StaffHoursEmptyStatesQueriesstaffLeaveArgs = {
  siteSetId: Scalars['SiteSetId'];
};

export type StaffHoursFeatureSettingsFlags = {
  __typename?: 'StaffHoursFeatureSettingsFlags';
  /** Returns if this feature is currently enabled. (Replaces behavior `ShowStaffHoursApp`) */
  enabled: Scalars['Boolean'];
};

export type StaffHoursInput = {
  /** Range of days to filter staff records */
  daysRange: ClosedLocalDateRange;
  /** Optional list of rooms ids. If provided will return only records for those specified ids. If not, it will list every room from institution */
  groupIds?: InputMaybe<Array<Scalars['GroupId']>>;
  institutionId: Scalars['InstitutionId'];
  /** Time to split day between AM and PM intervals */
  splitIntervalsTime: Scalars['LocalTime'];
};

/** Hours report of an institution */
export type StaffHoursInstitutionReport = {
  __typename?: 'StaffHoursInstitutionReport';
  dates: Array<Scalars['LocalDate']>;
  roomsReport: Array<StaffHoursRoomReport>;
};

/** Objects related to mutating staff hours */
export type StaffHoursMutation = {
  __typename?: 'StaffHoursMutation';
  attendance: AttendanceMutation;
  bankhours: BankHoursMutations;
  contractedhours: ContractedHoursMutations;
  featureSettings: FeatureSettingsMutations;
  leaves: LeavesMutation;
  schedule: ScheduleMutation;
  settings: StaffingSettingsMutations;
  shiftplanner: ShiftPlannerMutations;
  workTags: WorkTagMutations;
  workavailability: WorkAvailabilityMutations;
};

export type StaffHoursPageFeatureSettingsFlags = {
  __typename?: 'StaffHoursPageFeatureSettingsFlags';
  /** Returns true if the feature for the new staff hours page is enabled. */
  isEnabled: Scalars['Boolean'];
};

export type StaffHoursQueries = {
  __typename?: 'StaffHoursQueries';
  attendance: StaffHoursAttendanceQueriesType;
  bankhours: BankHoursQueries;
  /** If no employee ID is provided, the behaviors for the current user are returned */
  behaviors: Array<Behavior>;
  /** Staff hours of an staff member. Words 'staff member' is same as 'employee'. Word 'record' is  an abstraction to name leaves, attended hours and scheduled hours of an staff member.  */
  byEmployee: StaffMemberRecords;
  /** Staff hours of an institution. Word 'staff' is same as 'employees'. Words 'staff member' is same as 'employee'. Word 'record' is  an abstraction to name leaves, attended hours and scheduled hours of an staff member.  */
  byInstitution: StaffHoursInstitutionReport;
  contractedhours: ContractedHoursQueries;
  contractedhourschangelog: ContractedHoursChangeQueries;
  /** URL to fetch csv staffing data.Params 'institutionId','target',and 'expires' are included but a range to export should be providedwith 'from' and 'to' */
  csvExportURL: Scalars['String'];
  emptyStates: StaffHoursEmptyStatesQueries;
  featureSettings: FeatureSettingsQueries;
  leaves: LeavesQuery;
  management: ManagementQueries;
  schedule: ScheduleQueries;
  /** Number of employees having at least one valid schedule in current month, regardless the creation date */
  seats: Scalars['Int'];
  settings: StaffingSettings;
  shiftplanner: ShiftPlannerQueries;
  staffLeaveRequest: StaffLeaveRequestQuery;
  totals: StaffHoursTotalsQueriesType;
  workTags: WorkTagQueries;
  workavailability: WorkAvailabilityQueries;
};


export type StaffHoursQueriesbehaviorsArgs = {
  employeeId?: InputMaybe<Scalars['EmployeeId']>;
  institutionId: Scalars['InstitutionId'];
};


export type StaffHoursQueriesbyEmployeeArgs = {
  daysRange: ClosedLocalDateRange;
  employeeId: Scalars['EmployeeId'];
  institutionId: Scalars['InstitutionId'];
};


export type StaffHoursQueriesbyInstitutionArgs = {
  filter: StaffHoursInput;
};


export type StaffHoursQueriescsvExportURLArgs = {
  institutionId: Scalars['InstitutionId'];
};


export type StaffHoursQueriesseatsArgs = {
  institutionId: Scalars['InstitutionId'];
};


export type StaffHoursQueriessettingsArgs = {
  siteSetId: Scalars['InstitutionSetId'];
};

export enum StaffHoursRecordTypes {
  ATTENDANCE = 'ATTENDANCE',
  BREAK = 'BREAK',
  LEAVE = 'LEAVE',
  SCHEDULE = 'SCHEDULE'
}

/** Hours report of a room */
export type StaffHoursRoomReport = {
  __typename?: 'StaffHoursRoomReport';
  room: Group;
  roomOverviewTotal: RoomOverviewTotalMinutes;
  /** @deprecated Use staffingChart instead */
  staffOverviewByDay: Array<StaffOverviewByDay>;
  staffRecords: Array<StaffMemberRecords>;
  staffingChart: StaffingChart;
};

export type StaffHoursTotalsByStaffType = {
  __typename?: 'StaffHoursTotalsByStaffType';
  bankHours?: Maybe<BankHours>;
  employee: Employee;
  totals: StaffHoursTotalsType;
};

export type StaffHoursTotalsByStaffTypeV2 = {
  __typename?: 'StaffHoursTotalsByStaffTypeV2';
  bankHours?: Maybe<BankHoursV2>;
  employee: Employee;
  totals: StaffHoursTotalsType;
};

export type StaffHoursTotalsManagementFlagsType = {
  __typename?: 'StaffHoursTotalsManagementFlagsType';
  canView: Scalars['Boolean'];
};

export type StaffHoursTotalsManagementType = {
  __typename?: 'StaffHoursTotalsManagementType';
  canView: Scalars['Boolean'];
  csvExport: StaffHoursTotalsManagementFlagsType;
};

/** Staff hours totals queries */
export type StaffHoursTotalsQueriesType = {
  __typename?: 'StaffHoursTotalsQueriesType';
  /**
   * Query the staff hours totals in the date range for all employees of the site.
   * The maximum date range is 365 days.
   *
   * Filters: The result can be filtered on employee ids and on employee base rooms. If group ids are passed,
   * the query will only return employees whose base room set to that group.
   *
   * Pagination will only be active if the parameter page size is passed.
   * If no page size is defined the query result will not be paginated.
   *
   * @deprecated Current Mobile App Version 160. Use 'byStaffV2' instead
   */
  byStaff: StaffHoursTotalsResult;
  /**
   * Query the staff hours totals in the date range for all employees of the site.
   * The maximum date range is 365 days.
   *
   * Filters: The result can be filtered on employee ids and on employee base rooms. If group ids are passed,
   * the query will only return employees whose base room set to that group.
   *
   * Pagination will only be active if the parameter page size is passed.
   * If no page size is defined the query result will not be paginated.
   *
   */
  byStaffV2: StaffHoursTotalsResultV2;
  /** Returns the URL to fetch the staff hours totals CSV report. */
  csvExportURL: Scalars['String'];
};


/** Staff hours totals queries */
export type StaffHoursTotalsQueriesTypebyStaffArgs = {
  dateRange: ClosedLocalDateRange;
  employeeIds?: InputMaybe<Array<Scalars['EmployeeId']>>;
  groupIds?: InputMaybe<Array<Scalars['GroupId']>>;
  next?: InputMaybe<Scalars['StaffHoursByStaffCursor']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  siteSetId: Scalars['SiteSetId'];
};


/** Staff hours totals queries */
export type StaffHoursTotalsQueriesTypebyStaffV2Args = {
  dateRange: ClosedLocalDateRange;
  employeeIds?: InputMaybe<Array<Scalars['EmployeeId']>>;
  groupIds?: InputMaybe<Array<Scalars['GroupId']>>;
  next?: InputMaybe<Scalars['StaffHoursByStaffCursor']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  siteSetId: Scalars['SiteSetId'];
};


/** Staff hours totals queries */
export type StaffHoursTotalsQueriesTypecsvExportURLArgs = {
  dateRange: ClosedLocalDateRange;
  siteSetId: Scalars['SiteSetId'];
};

export type StaffHoursTotalsResult = {
  __typename?: 'StaffHoursTotalsResult';
  byStaff: Array<StaffHoursTotalsByStaffType>;
  dateRange: TimeRangeClosed;
  next?: Maybe<Scalars['StaffHoursByStaffCursor']>;
};

export type StaffHoursTotalsResultV2 = {
  __typename?: 'StaffHoursTotalsResultV2';
  byStaff: Array<StaffHoursTotalsByStaffTypeV2>;
  dateRange: TimeRangeClosed;
  next?: Maybe<Scalars['StaffHoursByStaffCursor']>;
};

export type StaffHoursTotalsType = {
  __typename?: 'StaffHoursTotalsType';
  /** Attended = The sum of check-in periods, excluding break time */
  attendedMinutes: Scalars['Int'];
  /**
   * Attended Total = Attended + Paid leave
   * @deprecated Deprecated in App Version 162. Use periodTotal instead.
   */
  attendedTotal: Scalars['Int'];
  /** Break = The sum of breaks of all published shifts assigned to the employee */
  breakMinutes: Scalars['Int'];
  /** Contract Difference = Attended Total - Contracted */
  contractedDifference: Scalars['Int'];
  contractedMinutes: Scalars['Int'];
  isSignOutMissing: Scalars['Boolean'];
  leaveMinutes: LeaveMinutesType;
  /** Period Total = Attended + Paid leave */
  periodTotal: Scalars['Int'];
  /** Schedule Difference = Attended - Scheduled */
  scheduleDifference: Scalars['Int'];
  /** Scheduled = The sum of all published shifts assigned to the employee, excluding break time */
  scheduledMinutes: Scalars['Int'];
};

export type StaffLeaveAPIFeatureSettingsFlags = {
  __typename?: 'StaffLeaveAPIFeatureSettingsFlags';
  /** Returns whether this feature is enabled or not. */
  enabled: Scalars['Boolean'];
};

/** Staff leave range by employee that overlaps with a leave requested range */
export type StaffLeaveOverlaps = {
  __typename?: 'StaffLeaveOverlaps';
  employee: Employee;
  leaveType: StaffLeaveType;
  range: TimeRangeClosed;
  workingDays: Scalars['Int'];
};

/** Employee leave request */
export type StaffLeaveRequest = {
  __typename?: 'StaffLeaveRequest';
  approvalStatus: StaffLeaveRequestApprovalStatus;
  createdAt: Scalars['ZonedDateTime'];
  createdBy: Person;
  employee: Employee;
  endTime?: Maybe<Scalars['LocalDateTime']>;
  leaveSubTypeId?: Maybe<Scalars['StaffLeaveSubTypeId']>;
  leaveType?: Maybe<StaffLeaveType>;
  managementNote?: Maybe<ManagementNote>;
  note?: Maybe<Scalars['String']>;
  requestedRange: TimeRangeClosed;
  staffLeaveRequestId: Scalars['StaffLeaveRequestId'];
  startTime?: Maybe<Scalars['LocalDateTime']>;
  totalHours?: Maybe<Scalars['Float']>;
  totalMinutes?: Maybe<Scalars['Int']>;
};

export enum StaffLeaveRequestApprovalStatus {
  Accepted = 'Accepted',
  Pending = 'Pending',
  Rejected = 'Rejected',
  Unconfirmed = 'Unconfirmed',
  Virtual = 'Virtual'
}

export type StaffLeaveRequestInput = {
  /** Staff member id */
  employeeId: Scalars['EmployeeId'];
  /** Optional end time of the leave. Required for hourly leaves. */
  endTime?: InputMaybe<Scalars['LocalDateTime']>;
  /** Requested leave primary type */
  leaveType?: InputMaybe<StaffLeaveType>;
  /** Text to be saved as a management note */
  managementNote?: InputMaybe<Scalars['String']>;
  /** Text to be saved as a leave note */
  note?: InputMaybe<Scalars['String']>;
  /** Range of days requested. 'From' is the first day off and 'to' the last one, so a one-day-off will have a range where from = to */
  range: ClosedLocalDateRange;
  /** Optional start time of the leave. Required for hourly leaves. */
  startTime?: InputMaybe<Scalars['LocalDateTime']>;
  /** Optional total hours of the leave. */
  totalHours?: InputMaybe<Scalars['Float']>;
};

/** Manage staff leave requests */
export type StaffLeaveRequestMutation = {
  __typename?: 'StaffLeaveRequestMutation';
  /**
   * Change leave request status and return all pending requests for institution
   * @deprecated Deprecated in App Version 163. Use completeLeaveRequestV2 instead.
   */
  completeLeaveRequest: CompleteLeaveRequest;
  /**
   * Change leave request status and return all pending requests for institution.
   * The result will include the updated staff hours for the employee whose leave request was updated
   * for all weeks this leave request intersects with.
   *
   */
  completeLeaveRequestV2: CompleteLeaveRequestResultTypeV2;
  /** Delete a leave request */
  delete: Scalars['StaffLeaveRequestId'];
  request: StaffLeaveRequestResult;
};


/** Manage staff leave requests */
export type StaffLeaveRequestMutationcompleteLeaveRequestArgs = {
  leaveRequestId: Scalars['StaffLeaveRequestId'];
  leaveSubTypeId?: InputMaybe<Scalars['StaffLeaveSubTypeId']>;
  managementNote?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  status: StaffLeaveRequestApprovalStatus;
};


/** Manage staff leave requests */
export type StaffLeaveRequestMutationcompleteLeaveRequestV2Args = {
  leaveRequestId: Scalars['StaffLeaveRequestId'];
  leaveSubTypeId?: InputMaybe<Scalars['StaffLeaveSubTypeId']>;
  managementNote?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  status: StaffLeaveRequestApprovalStatus;
};


/** Manage staff leave requests */
export type StaffLeaveRequestMutationdeleteArgs = {
  leaveRequestId: Scalars['StaffLeaveRequestId'];
};


/** Manage staff leave requests */
export type StaffLeaveRequestMutationrequestArgs = {
  leaveRequest: StaffLeaveRequestInput;
};

/** List submitted staff leave requests */
export type StaffLeaveRequestQuery = {
  __typename?: 'StaffLeaveRequestQuery';
  /** List all leave requests made of an employee */
  byEmployee: Array<StaffLeaveRequest>;
  /** List approved or rejected staff leave requests */
  completedLeaveRequests: CompletedLeaveRequestsResult;
  /** List staff leave requests for an institution that haven't been answered. These are all requests with status pending */
  pendingApprovalWithOverlaps: Array<StaffLeaveRequestWithOverlaps>;
};


/** List submitted staff leave requests */
export type StaffLeaveRequestQuerybyEmployeeArgs = {
  employeeId: Scalars['EmployeeId'];
  statuses: Array<StaffLeaveRequestApprovalStatus>;
};


/** List submitted staff leave requests */
export type StaffLeaveRequestQuerycompletedLeaveRequestsArgs = {
  fromDate?: InputMaybe<Scalars['LocalDate']>;
  includeVirtual?: InputMaybe<Scalars['Boolean']>;
  institutionSetIds: Array<Scalars['InstitutionSetId']>;
  next?: InputMaybe<Scalars['CompletedLeaveRequestsCursor']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<CompletedLeaveRequestsSortOrder>;
  toDate?: InputMaybe<Scalars['LocalDate']>;
};


/** List submitted staff leave requests */
export type StaffLeaveRequestQuerypendingApprovalWithOverlapsArgs = {
  includeUnconfirmed?: InputMaybe<Scalars['Boolean']>;
  institutionId: Scalars['InstitutionId'];
};

export enum StaffLeaveRequestResult {
  OverlapsWithAlreadyRequestedLeave = 'OverlapsWithAlreadyRequestedLeave',
  OverlapsWithExistingLeave = 'OverlapsWithExistingLeave',
  Success = 'Success'
}

/** Employee leave request including all other leaves that overlaps with requested range */
export type StaffLeaveRequestWithOverlaps = {
  __typename?: 'StaffLeaveRequestWithOverlaps';
  overlaps: Array<StaffLeaveOverlaps>;
  request: StaffLeaveRequest;
  workingDays: Scalars['Int'];
};

/** Staff leave sub type */
export type StaffLeaveSubType = {
  __typename?: 'StaffLeaveSubType';
  code?: Maybe<Scalars['String']>;
  id: Scalars['StaffLeaveSubTypeId'];
  leaveType: StaffLeaveType;
  name: Scalars['String'];
  paid?: Maybe<Scalars['Boolean']>;
};

/** Input for creating or modifying a staff leave sub type */
export type StaffLeaveSubTypeInput = {
  code?: InputMaybe<Scalars['String']>;
  leaveType: StaffLeaveType;
  name: Scalars['String'];
  paid?: InputMaybe<Scalars['Boolean']>;
};

/** Operations mutating staff leave sub types */
export type StaffLeaveSubTypeMutations = {
  __typename?: 'StaffLeaveSubTypeMutations';
  createV2: StaffLeaveSubType;
  delete: Array<Scalars['StaffLeaveSubTypeId']>;
  updateV2: StaffLeaveSubType;
};


/** Operations mutating staff leave sub types */
export type StaffLeaveSubTypeMutationscreateV2Args = {
  input: StaffLeaveSubTypeInput;
  institutionSetId: Scalars['InstitutionSetId'];
};


/** Operations mutating staff leave sub types */
export type StaffLeaveSubTypeMutationsdeleteArgs = {
  leaveSubTypeIds: Array<Scalars['StaffLeaveSubTypeId']>;
};


/** Operations mutating staff leave sub types */
export type StaffLeaveSubTypeMutationsupdateV2Args = {
  input: StaffLeaveSubTypeInput;
  institutionSetId: Scalars['InstitutionSetId'];
  leaveSubTypeId: Scalars['StaffLeaveSubTypeId'];
};

/** Staff leave sub types settings */
export type StaffLeaveSubTypeSettings = {
  __typename?: 'StaffLeaveSubTypeSettings';
  /** Can current user edit subtypes */
  canEdit: Scalars['Boolean'];
  /** Can organization opt in to subtypes */
  canOptIn: Scalars['Boolean'];
  /** Can current user view subtypes */
  canView: Scalars['Boolean'];
  /** Are subtypes currently enabled */
  enabled: Scalars['Boolean'];
};

/** Operations querying staff leave sub types */
export type StaffLeaveSubTypesQueries = {
  __typename?: 'StaffLeaveSubTypesQueries';
  listV2: Array<StaffLeaveSubType>;
  settings: StaffLeaveSubTypeSettings;
};


/** Operations querying staff leave sub types */
export type StaffLeaveSubTypesQuerieslistV2Args = {
  institutionSetId: Scalars['InstitutionSetId'];
};


/** Operations querying staff leave sub types */
export type StaffLeaveSubTypesQueriessettingsArgs = {
  institutionSetId: Scalars['InstitutionSetId'];
};

export enum StaffLeaveType {
  ABSENT = 'ABSENT',
  CHILD_SICK = 'CHILD_SICK',
  SICK = 'SICK',
  VACATION = 'VACATION'
}

/** Records for staff member attendance */
export type StaffMemberAttendanceRecord = {
  __typename?: 'StaffMemberAttendanceRecord';
  breakTimeMinutes?: Maybe<Scalars['Int']>;
  checkIn: CheckIn;
  checkInStatements?: Maybe<Array<EmployeeCheckinStatement>>;
  checkOut?: Maybe<CheckOut>;
  deleted: Scalars['Boolean'];
  employeeCheckInId: Scalars['EmployeeCheckInId'];
  group: Group;
  minutesDuration: Scalars['Int'];
};

/** Records for staff member attendance */
export type StaffMemberAttendanceRecordV2 = {
  __typename?: 'StaffMemberAttendanceRecordV2';
  breakTimeMinutes?: Maybe<Scalars['Int']>;
  checkIn: CheckIn;
  checkInStatements?: Maybe<Array<EmployeeCheckinStatement>>;
  checkOut?: Maybe<CheckOut>;
  deleted: Scalars['Boolean'];
  employeeCheckInId: Scalars['EmployeeCheckInId'];
  group: Group;
  minutesDuration: Scalars['Int'];
  workTag?: Maybe<WorkTagResultResultType>;
};

export type StaffMemberLeaveMinutes = {
  __typename?: 'StaffMemberLeaveMinutes';
  absent: Scalars['Int'];
  childSick: Scalars['Int'];
  holiday: Scalars['Int'];
  paid: Scalars['Int'];
  sick: Scalars['Int'];
};

/** Leave of a staff member */
export type StaffMemberLeaves = {
  __typename?: 'StaffMemberLeaves';
  date: Scalars['LocalDate'];
  deleted: Scalars['Boolean'];
  employeeLeaveId: Scalars['EmployeeLeaveId'];
  endTime?: Maybe<Scalars['LocalDateTime']>;
  hours?: Maybe<Scalars['Float']>;
  /** Leave subtype code */
  leaveSubTypeCode?: Maybe<Scalars['String']>;
  /** Leave subtype name */
  leaveSubTypeName?: Maybe<Scalars['String']>;
  leaveType: Scalars['String'];
  minutes?: Maybe<Scalars['Int']>;
  reason?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['LocalDateTime']>;
};

/** Staff member records in range requested */
export type StaffMemberRecords = {
  __typename?: 'StaffMemberRecords';
  minutesOverview: StaffMemberSummarizedMinutes;
  /** @deprecated Use recordsByDay instead */
  records: Array<StaffMemberRecordsByDay>;
  recordsByDay: Array<RecordsByDay>;
  staffMember: Employee;
};

/** Staff member records of a day */
export type StaffMemberRecordsByDay = {
  __typename?: 'StaffMemberRecordsByDay';
  attendance: Array<StaffMemberAttendanceRecord>;
  date: Scalars['LocalDate'];
  leaves: Array<StaffMemberLeaves>;
  otherRoomsWithRecords: StaffMemberRecordsOtherGroups;
  schedule: Array<StaffMemberScheduleRecord>;
};

/** Groups other than the requested group with schedules for the given employee */
export type StaffMemberRecordsOtherGroups = {
  __typename?: 'StaffMemberRecordsOtherGroups';
  roomsWithSchedule: Array<Group>;
};

/** Records for staff member schedule */
export type StaffMemberScheduleRecord = {
  __typename?: 'StaffMemberScheduleRecord';
  /** @deprecated Please use minutesBreak field in EmployeeRecordsByDay */
  breakTimeMinutes?: Maybe<Scalars['Int']>;
  checkIn: Scalars['LocalDateTime'];
  checkOut: Scalars['LocalDateTime'];
  exceptionReasons: Array<ExceptionReasons>;
  group: Group;
  minutesDuration: Scalars['Int'];
  repeats: RepetitionType;
  /** @deprecated We don't use this field anymore */
  staffRotasDailyScheduleId: Scalars['StaffRotasDailyScheduleId'];
  staffRotasScheduleId: Scalars['StaffRotasScheduleId'];
};

/** Amount of scheduled and attended minutes */
export type StaffMemberSummarizedMinutes = {
  __typename?: 'StaffMemberSummarizedMinutes';
  attendedMinutes: Scalars['Int'];
  leaveMinutes: StaffMemberLeaveMinutes;
  /** Schedule difference = Attended minutes - Shift schedule minutes. */
  scheduleDifference: Scalars['Int'];
  /**
   * @deprecated Only valid for Staff Rotas schedules (because there is maximal one break per day).
   * For accurate shift schedule and break minutes use 'shiftScheduleMinutes' and 'shiftBreakMinutes'.
   */
  scheduledMinutes: Scalars['Int'];
  /** The sum of breaks of all published shifts assigned to the employee. */
  shiftBreakMinutes: Scalars['Int'];
  /** The sum of all published shifts assigned to the employee (excluding break time). */
  shiftScheduleMinutes: Scalars['Int'];
};

/** Overview of staff records by day */
export type StaffOverviewByDay = {
  __typename?: 'StaffOverviewByDay';
  dailySummary: DailySummary;
  date: Scalars['LocalDate'];
};

/** Objects related to mutating staff qualifications */
export type StaffQualificationMutations = {
  __typename?: 'StaffQualificationMutations';
  createAssignment: QualificationAssignment;
  createQualification: Qualification;
  deleteAssignment: Scalars['Boolean'];
  deleteQualification: Scalars['Boolean'];
  updateAssignment: QualificationAssignment;
  updateQualification: Qualification;
};


/** Objects related to mutating staff qualifications */
export type StaffQualificationMutationscreateAssignmentArgs = {
  certificateNumber?: InputMaybe<Scalars['String']>;
  employeeId: Scalars['EmployeeId'];
  expirationDate?: InputMaybe<Scalars['LocalDateTime']>;
  fileIds?: InputMaybe<Array<Scalars['FileId']>>;
  imageIds?: InputMaybe<Array<Scalars['ImageId']>>;
  level?: InputMaybe<Scalars['Int']>;
  note?: InputMaybe<Scalars['String']>;
  qualificationDate: Scalars['LocalDateTime'];
  qualificationId: Scalars['StaffQualificationId'];
  title?: InputMaybe<Scalars['String']>;
};


/** Objects related to mutating staff qualifications */
export type StaffQualificationMutationscreateQualificationArgs = {
  hasCertificateNumber: Scalars['Boolean'];
  hasExpiration: Scalars['Boolean'];
  institutionSetId: Scalars['InstitutionSetId'];
  levels?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  unique: Scalars['Boolean'];
};


/** Objects related to mutating staff qualifications */
export type StaffQualificationMutationsdeleteAssignmentArgs = {
  assignmentId: Scalars['StaffQualificationAssignmentId'];
};


/** Objects related to mutating staff qualifications */
export type StaffQualificationMutationsdeleteQualificationArgs = {
  qualificationId: Scalars['StaffQualificationId'];
};


/** Objects related to mutating staff qualifications */
export type StaffQualificationMutationsupdateAssignmentArgs = {
  assignmentId: Scalars['StaffQualificationAssignmentId'];
  certificateNumber?: InputMaybe<Scalars['String']>;
  expirationDate?: InputMaybe<Scalars['LocalDateTime']>;
  fileIds?: InputMaybe<Array<Scalars['FileId']>>;
  imageIds?: InputMaybe<Array<Scalars['ImageId']>>;
  level?: InputMaybe<Scalars['Int']>;
  note?: InputMaybe<Scalars['String']>;
  qualificationDate: Scalars['LocalDateTime'];
  title?: InputMaybe<Scalars['String']>;
};


/** Objects related to mutating staff qualifications */
export type StaffQualificationMutationsupdateQualificationArgs = {
  hasCertificateNumber: Scalars['Boolean'];
  hasExpiration: Scalars['Boolean'];
  levels?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  qualificationId: Scalars['StaffQualificationId'];
  unique: Scalars['Boolean'];
};

/** Objects related to accessing staff qualifications */
export type StaffQualifications = {
  __typename?: 'StaffQualifications';
  assignments: Array<QualificationAssignment>;
  qualifications: Array<Qualification>;
};


/** Objects related to accessing staff qualifications */
export type StaffQualificationsassignmentsArgs = {
  assignmentIds?: InputMaybe<Array<Scalars['StaffQualificationAssignmentId']>>;
  employeeIds?: InputMaybe<Array<Scalars['EmployeeId']>>;
  institutionIds?: InputMaybe<Array<Scalars['InstitutionId']>>;
};


/** Objects related to accessing staff qualifications */
export type StaffQualificationsqualificationsArgs = {
  institutionSetId?: InputMaybe<Scalars['InstitutionSetId']>;
  qualificationIds?: InputMaybe<Array<Scalars['StaffQualificationId']>>;
};

export type StaffRotasFeatureSettingsFlags = {
  __typename?: 'StaffRotasFeatureSettingsFlags';
  /** Returns if this feature is currently enabled. (Replaces behavior `ShowStaffRotasApp`) */
  enabled: Scalars['Boolean'];
};

/** Metadata for a staff rotas subscription in Famly */
export type StaffRotasSubscriptionMetaData = {
  __typename?: 'StaffRotasSubscriptionMetaData';
  currentSeats: Scalars['Int'];
  seatsToCharge: Scalars['Int'];
};

/** A schedule for a specific member of staff */
export type StaffSchedule = {
  __typename?: 'StaffSchedule';
  employeeId: Scalars['EmployeeId'];
  range: NonEmptyLocalDateRange;
  schedule: Array<ScheduleStaffMemberRecordsByDay>;
  scheduleId: Scalars['StaffRotasScheduleId'];
};

export type StaffScheduleLeavesType = {
  __typename?: 'StaffScheduleLeavesType';
  approvalStatus: StaffLeaveRequestApprovalStatus;
  dateRange: TimeRangeClosed;
  endTime?: Maybe<Scalars['LocalTime']>;
  leaveSubTypeId?: Maybe<Scalars['StaffLeaveSubTypeId']>;
  leaveType?: Maybe<StaffLeaveType>;
  managementNote?: Maybe<ManagementNote>;
  note?: Maybe<Scalars['String']>;
  staffLeaveRequestId: Scalars['StaffLeaveRequestId'];
  startTime?: Maybe<Scalars['LocalTime']>;
  totalHours?: Maybe<Scalars['Float']>;
};

export type StaffScheduleType = {
  __typename?: 'StaffScheduleType';
  date: Scalars['LocalDate'];
  leaveRequests: Array<LeaveRequestType>;
  /** @deprecated Deprecated in App Version 164. Use leaveRequests.leaves instead. */
  leaves: Array<StaffScheduleLeavesType>;
  /** The sum of scheduled shifts (draft and published) minus break times. */
  scheduledMinutesOnDay: Scalars['Float'];
  shifts: Array<ShiftTypeV3>;
};

/** Queries for staff to staff conversations */
export type StaffToStaffConversations = {
  __typename?: 'StaffToStaffConversations';
  /**
   * If staff to staff messaging is enabled for the site
   * @deprecated Use behavior on staff instead
   */
  enabled: Scalars['Boolean'];
};


/** Queries for staff to staff conversations */
export type StaffToStaffConversationsenabledArgs = {
  siteId: Scalars['InstitutionId'];
};

/** Staffing figures for a given period of days represented as data points in the chart */
export type StaffingChart = {
  __typename?: 'StaffingChart';
  /** Chart creation datetime to be used as an indicator of when is _now_ for the backend */
  createdAt: Scalars['LocalDateTime'];
  dataPoints: Array<StaffingChartDataPoint>;
};

/** Staffing figures for a specific point in the time */
export type StaffingChartDataPoint = {
  __typename?: 'StaffingChartDataPoint';
  attended: Scalars['Int'];
  /** @deprecated Use field 'from' instead */
  dateTime: Scalars['LocalDateTime'];
  from: Scalars['LocalDateTime'];
  scheduled: Scalars['Int'];
  staffRequired: StaffingChartStaffRequiredType;
  to: Scalars['LocalDateTime'];
};

/** Staff required based on child checkins and child bookings */
export type StaffingChartStaffRequiredType = {
  __typename?: 'StaffingChartStaffRequiredType';
  byChildBookings: Scalars['Float'];
  byChildCheckIns: Scalars['Float'];
};

/** Attended/Scheduled/Required figures */
export type StaffingDetail = {
  __typename?: 'StaffingDetail';
  attended: StaffingFiguresPerDayInterval;
  scheduled: StaffingFiguresPerDayInterval;
  staffingChart: Array<StaffingInTimeRange>;
};

/** Figures in an interval of a day like AM/PM, when staff required is a maxim and all non maxim are covered */
export type StaffingFiguresOnMaxRequired = {
  __typename?: 'StaffingFiguresOnMaxRequired';
  numberOfStaff: Scalars['Int'];
  overStaffDisclaimer: Scalars['Boolean'];
  required: Scalars['Float'];
  staffStatus: StaffingStatus;
};

/** Comparison between staff required and actual attendance */
export type StaffingFiguresPerDayInterval = NoFiguresToShow | ShowOnlyRequiredStaff | StaffingFiguresOnMaxRequired;

export type StaffingInTimeRange = {
  __typename?: 'StaffingInTimeRange';
  intervalSummary?: Maybe<IntervalSummary>;
  time: TimeRangeClosedLocalTime;
};

export type StaffingOK = StaffingStatus & {
  __typename?: 'StaffingOK';
  msg: Scalars['String'];
};

/** Staffing related site settings values */
export type StaffingSettings = {
  __typename?: 'StaffingSettings';
  /** Require leave approval for absent */
  absentApprovalRequired?: Maybe<Scalars['Boolean']>;
  /** Leave range for absent */
  absentLeaveRangeV2?: Maybe<FiscalYear>;
  /** Require leave approval for child sick */
  childSickApprovalRequired?: Maybe<Scalars['Boolean']>;
  /** Leave range for child sick leave */
  childSickLeaveRangeV2?: Maybe<FiscalYear>;
  defaultWorkTagId?: Maybe<Scalars['WorkTagId']>;
  /** Number of hours employees work on a day */
  employeeWorkDay?: Maybe<Scalars['Float']>;
  /** Require leave approval for holiday */
  holidayApprovalRequired?: Maybe<Scalars['Boolean']>;
  /** Leave range for holidays */
  holidayLeaveRangeV2?: Maybe<FiscalYear>;
  /** Require leave approval for sick */
  sickApprovalRequired?: Maybe<Scalars['Boolean']>;
  /** Leave range for sick leave */
  sickLeaveRangeV2?: Maybe<FiscalYear>;
  siteSetId: Scalars['InstitutionSetId'];
};

/** Operations mutating staffing settings for a site */
export type StaffingSettingsMutations = {
  __typename?: 'StaffingSettingsMutations';
  /** Set the default work tag id, or unset it by passing null. */
  setDefaultWorkTag?: Maybe<Scalars['WorkTagId']>;
  /** Change approval required setting for absent leaves */
  updateAbsentApprovalRequired: Scalars['Boolean'];
  /** Change the default absent leave range */
  updateAbsentLeaveRangeV2: FiscalYear;
  /** Change approval required setting for childSick leaves */
  updateChildSickApprovalRequired: Scalars['Boolean'];
  /** Change the default child sick leave range */
  updateChildSickLeaveRangeV2: FiscalYear;
  /** Change number of hours employees work on a day */
  updateEmployeeWorkDay: Scalars['Float'];
  /** Change approval required setting for holiday leaves */
  updateHolidayApprovalRequired: Scalars['Boolean'];
  /** Change the default holiday leave range */
  updateHolidayLeaveRangeV2: FiscalYear;
  /** Change approval required setting for sick leaves */
  updateSickApprovalRequired: Scalars['Boolean'];
  /** Change the default sick leave range */
  updateSickLeaveRangeV2: FiscalYear;
};


/** Operations mutating staffing settings for a site */
export type StaffingSettingsMutationssetDefaultWorkTagArgs = {
  siteSetId: Scalars['SiteSetId'];
  workTagId?: InputMaybe<Scalars['WorkTagId']>;
};


/** Operations mutating staffing settings for a site */
export type StaffingSettingsMutationsupdateAbsentApprovalRequiredArgs = {
  approvalRequired?: InputMaybe<Scalars['Boolean']>;
  siteSetId: Scalars['InstitutionSetId'];
};


/** Operations mutating staffing settings for a site */
export type StaffingSettingsMutationsupdateAbsentLeaveRangeV2Args = {
  leaveRange?: InputMaybe<FiscalYear>;
  siteSetId: Scalars['InstitutionSetId'];
};


/** Operations mutating staffing settings for a site */
export type StaffingSettingsMutationsupdateChildSickApprovalRequiredArgs = {
  approvalRequired?: InputMaybe<Scalars['Boolean']>;
  siteSetId: Scalars['InstitutionSetId'];
};


/** Operations mutating staffing settings for a site */
export type StaffingSettingsMutationsupdateChildSickLeaveRangeV2Args = {
  leaveRange?: InputMaybe<FiscalYear>;
  siteSetId: Scalars['InstitutionSetId'];
};


/** Operations mutating staffing settings for a site */
export type StaffingSettingsMutationsupdateEmployeeWorkDayArgs = {
  employeeWorkDay?: InputMaybe<Scalars['Float']>;
  siteSetId: Scalars['InstitutionSetId'];
};


/** Operations mutating staffing settings for a site */
export type StaffingSettingsMutationsupdateHolidayApprovalRequiredArgs = {
  approvalRequired?: InputMaybe<Scalars['Boolean']>;
  siteSetId: Scalars['InstitutionSetId'];
};


/** Operations mutating staffing settings for a site */
export type StaffingSettingsMutationsupdateHolidayLeaveRangeV2Args = {
  leaveRange?: InputMaybe<FiscalYear>;
  siteSetId: Scalars['InstitutionSetId'];
};


/** Operations mutating staffing settings for a site */
export type StaffingSettingsMutationsupdateSickApprovalRequiredArgs = {
  approvalRequired?: InputMaybe<Scalars['Boolean']>;
  siteSetId: Scalars['InstitutionSetId'];
};


/** Operations mutating staffing settings for a site */
export type StaffingSettingsMutationsupdateSickLeaveRangeV2Args = {
  leaveRange?: InputMaybe<FiscalYear>;
  siteSetId: Scalars['InstitutionSetId'];
};

/** Status when the most staff is required */
export type StaffingStatus = {
  msg: Scalars['String'];
};

export type StaffingWidget = Widget & {
  __typename?: 'StaffingWidget';
  id: Scalars['HomeWidgetId'];
  next?: Maybe<Scalars['HomeWidgetCursor']>;
  rooms: Array<StaffHoursRoomReport>;
  title: Scalars['String'];
  widgetId: Scalars['String'];
};

/** Information required to setup a payment method for future use */
export type StartPaymentMethod = {
  __typename?: 'StartPaymentMethod';
  intentClientSecret: Scalars['String'];
  supportedTypes: Array<PaymentsSourceType>;
};

export type StartTrialInput = {
  institutionSetId: Scalars['InstitutionSetId'];
};

export type Statement = {
  __typename?: 'Statement';
  area: Area;
  areaId: Scalars['AreaId'];
  body: Scalars['String'];
  id: Scalars['StatementId'];
};

export enum StatementType {
  CHILD = 'CHILD',
  STAFF = 'STAFF'
}

export enum Status {
  CONNECTED = 'CONNECTED',
  NOT_CONNECTED = 'NOT_CONNECTED',
  PARTIALLY_CONNECTED = 'PARTIALLY_CONNECTED'
}

export enum StatusType {
  Absent = 'Absent',
  All = 'All',
  CheckedIn = 'CheckedIn',
  ChildSick = 'ChildSick',
  Custom = 'Custom',
  Expected = 'Expected',
  Sick = 'Sick',
  Vacation = 'Vacation'
}

/** Description of single application available in Famly Store */
export type StoreApp = {
  __typename?: 'StoreApp';
  appId: AppId;
};

export enum StoreAppId {
  ACCIDENT_REPORTING = 'ACCIDENT_REPORTING',
  ACTIVITY_LIBRARY = 'ACTIVITY_LIBRARY',
  ACTIVITY_PLANNER = 'ACTIVITY_PLANNER',
  ADVANCED_ENQUIRIES = 'ADVANCED_ENQUIRIES',
  ADVANCED_OBSERVATIONS = 'ADVANCED_OBSERVATIONS',
  AD_HOC_PURCHASES = 'AD_HOC_PURCHASES',
  ASSESSMENTS_AND_TWO_YEAR_CHECKS = 'ASSESSMENTS_AND_TWO_YEAR_CHECKS',
  ATTENDANCE_REPORT = 'ATTENDANCE_REPORT',
  AUTOMATED_PLAN_CHANGES = 'AUTOMATED_PLAN_CHANGES',
  BASIC_DAILY_LOGS = 'BASIC_DAILY_LOGS',
  CHILD_ABSENCE_REPORTING = 'CHILD_ABSENCE_REPORTING',
  CURRICULUM_BUILDER = 'CURRICULUM_BUILDER',
  CUSTOMISABLE_OVERVIEW = 'CUSTOMISABLE_OVERVIEW',
  CUSTOMISABLE_REGISTRATION_FORMS = 'CUSTOMISABLE_REGISTRATION_FORMS',
  CUSTOM_LISTS = 'CUSTOM_LISTS',
  CUSTOM_ROLES = 'CUSTOM_ROLES',
  CUSTOM_STATUSES = 'CUSTOM_STATUSES',
  DEBT_REPORT = 'DEBT_REPORT',
  DIRECT_DEBIT_EXPORT = 'DIRECT_DEBIT_EXPORT',
  DOCUMENT_STORAGE = 'DOCUMENT_STORAGE',
  ENQUIRIES = 'ENQUIRIES',
  FAMLY_INSIGHTS = 'FAMLY_INSIGHTS',
  FAMLY_PAY = 'FAMLY_PAY',
  FUNDING_LOOP = 'FUNDING_LOOP',
  GROUP_DASHBOARDS = 'GROUP_DASHBOARDS',
  GROUP_REPORTING = 'GROUP_REPORTING',
  HEAD_COUNTS = 'HEAD_COUNTS',
  HOLIDAY_RSVP = 'HOLIDAY_RSVP',
  INVOICING = 'INVOICING',
  LEAVE_APPROVAL = 'LEAVE_APPROVAL',
  LIVE_TRANSLATION = 'LIVE_TRANSLATION',
  MEAL_PLANS = 'MEAL_PLANS',
  MEDICATION_FORMS = 'MEDICATION_FORMS',
  MESSAGING = 'MESSAGING',
  OCCUPANCY_PLANNING = 'OCCUPANCY_PLANNING',
  PARENTAL_PERMISSIONS = 'PARENTAL_PERMISSIONS',
  PARENT_REQUESTED_CARE = 'PARENT_REQUESTED_CARE',
  PAYMENT_REMINDERS = 'PAYMENT_REMINDERS',
  PRECISE_LEAVE_TRACKING = 'PRECISE_LEAVE_TRACKING',
  REVENUE_REPORT = 'REVENUE_REPORT',
  ROOM_MOVE_RULES = 'ROOM_MOVE_RULES',
  ROOM_PLANNING = 'ROOM_PLANNING',
  SIGN_IN_OUT = 'SIGN_IN_OUT',
  STAFFING = 'STAFFING',
  STAFF_ROTAS = 'STAFF_ROTAS',
  TAGS = 'TAGS',
  XERO_CSV_INTEGRATION = 'XERO_CSV_INTEGRATION'
}

export enum StoreAppState {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  ON_TRIAL = 'ON_TRIAL'
}

export enum StoreAppType {
  CUSTOM_SUBSCRIPTION_APP = 'CUSTOM_SUBSCRIPTION_APP',
  PACKAGE_APP = 'PACKAGE_APP',
  TOGGLEABLE_APP = 'TOGGLEABLE_APP'
}

/** A single app/feature available in the famly store */
export type StoreAppV2 = {
  __typename?: 'StoreAppV2';
  appId: StoreAppId;
  package?: Maybe<SubscriptionPackage>;
  /** @deprecated Use appId instead */
  storeAppId: AppId;
  storeAppState: StoreAppState;
  storeAppType: StoreAppType;
};

export type StoreBillPayer = {
  __typename?: 'StoreBillPayer';
  email: Scalars['String'];
  isValid: Scalars['Boolean'];
  name: Scalars['String'];
  phoneNumber: Scalars['String'];
  role: Scalars['String'];
};

export type StoreBillPayerWithId = {
  __typename?: 'StoreBillPayerWithId';
  email: Scalars['String'];
  id: Scalars['BillPayerId'];
  name: Scalars['String'];
  phoneNumber: Scalars['String'];
  role: Scalars['String'];
};

export type StoreFeedbackResponse = {
  __typename?: 'StoreFeedbackResponse';
  createdAt: Scalars['ZonedDateTime'];
  loginId: Scalars['LoginId'];
  originalText: Scalars['String'];
  rewrittenText: Scalars['String'];
  selectedPrompt: Scalars['String'];
  userFeedback: Scalars['String'];
};

/** Top level object for Famly Store queries */
export type StoreObject = {
  __typename?: 'StoreObject';
  apps: Array<StoreApp>;
  appsV2: Array<StoreAppV2>;
  availablePackagesForTrial: Array<SubscriptionPackage>;
  canAccessPartnerStore: Scalars['Boolean'];
  partners: Array<Partner>;
};


/** Top level object for Famly Store queries */
export type StoreObjectappsArgs = {
  institutionId: Scalars['SiteId'];
};


/** Top level object for Famly Store queries */
export type StoreObjectappsV2Args = {
  institutionId: Scalars['SiteId'];
};


/** Top level object for Famly Store queries */
export type StoreObjectavailablePackagesForTrialArgs = {
  institutionId: Scalars['SiteId'];
};


/** Top level object for Famly Store queries */
export type StoreObjectcanAccessPartnerStoreArgs = {
  institutionId: Scalars['SiteId'];
};


/** Top level object for Famly Store queries */
export type StoreObjectpartnersArgs = {
  institutionId: Scalars['SiteId'];
};

export type StoreSiteInformation = {
  __typename?: 'StoreSiteInformation';
  address?: Maybe<Address>;
  isValid: Scalars['Boolean'];
  name: Scalars['String'];
  phoneNumber: Scalars['String'];
};

/** Stripe-specific payments endpoints */
export type Stripe = {
  __typename?: 'Stripe';
  accountPersons: Array<StripePerson>;
  /** Calculate the (user) fees for a potential payment */
  calculateFees: PaymentFee;
  /** Indicates whether the parent can manage their payment methods in the Settings page. */
  canParentManagePaymentMethods: Scalars['Boolean'];
  /** Retrieve client secret for existing pending setup intent for payment source */
  clientSecret?: Maybe<Scalars['String']>;
  /** Provides additional information for failed transactions. */
  failedTransactionsDetails: Array<FailedTransaction>;
  flexibleFeeScheme: StripeFlexibleFeeScheme;
  /**
   * Check if a user has an active mandate for a site for a given payment source
   * @deprecated Bacs does not require additional mandate collection.
   */
  hasActiveMandateForSite: Scalars['Boolean'];
  hasActiveParentFees: Scalars['Boolean'];
  paymentLink: StripePaymentLinkQueries;
  /**
   * Indicates whether the app should use the new flow for adding ACH direct debit payment methods.
   * @deprecated ACH Instant Verification Flow is now always on and there is no longer a need to check for it.
   */
  shouldUseAchInstantVerificationFlow: Scalars['Boolean'];
  /** Indicates whether the app should use the new flow for adding payment methods and making payments. */
  shouldUseNewPaymentFlow: Scalars['Boolean'];
  /** Indicates whether the app should use the Stripe PaymentElement flow or defer to the custom built Famly flow for adding payment methods. */
  shouldUseStripePaymentElementFlow: Scalars['Boolean'];
  /** Show pending ACH payment method, if any */
  showPendingAch?: Maybe<PaymentsSource>;
  stripeDirectDebit: StripeDirectDebit;
};


/** Stripe-specific payments endpoints */
export type StripeaccountPersonsArgs = {
  paymentsAccountId: Scalars['PaymentsAccountId'];
};


/** Stripe-specific payments endpoints */
export type StripecalculateFeesArgs = {
  flexPayAmount?: InputMaybe<Scalars['BadMoney']>;
  payload: Scalars['String'];
  paymentInput: PaymentInput;
};


/** Stripe-specific payments endpoints */
export type StripeclientSecretArgs = {
  paymentsSourceId: Scalars['PaymentsSourceId'];
};


/** Stripe-specific payments endpoints */
export type StripefailedTransactionsDetailsArgs = {
  billPayerId: Scalars['BillPayerId'];
  siteSetId: Scalars['InstitutionSetId'];
};


/** Stripe-specific payments endpoints */
export type StripehasActiveMandateForSiteArgs = {
  paymentsSourceId: Scalars['PaymentsSourceId'];
  siteSetId: Scalars['SiteSetId'];
};


/** Stripe-specific payments endpoints */
export type StripehasActiveParentFeesArgs = {
  siteSetIds: Array<Scalars['SiteSetId']>;
};

/** A payments account using Stripe as the underlying payments provider */
export type StripeAccount = PaymentsAccount & {
  __typename?: 'StripeAccount';
  /** Which payment provider this account is created for */
  accountType: PaymentsAccountType;
  bankAccount?: Maybe<StripeBankAccount>;
  /** Behaviors for this account */
  behaviors: Array<Behavior>;
  /** The potential deadline for new account information required. */
  dueBy?: Maybe<Scalars['ZonedDateTime']>;
  enabledParentFeeSourceTypes: Array<PaymentsSourceType>;
  enabledPaymentSourceTypes: Array<PaymentsSourceType>;
  /** Details about fees for the account */
  fees: Array<FeeDetails>;
  flexPay: PaymentsAccountFlexPay;
  /**
   * The minimum amount which should be paid with flexible payment, or null if flexible payment isn't enabled.
   * @deprecated Use flexPay.minPaymentAmount instead.
   */
  flexPayMinAmount?: Maybe<Scalars['BadMoney']>;
  institutionSetId: Scalars['InstitutionSetId'];
  paymentsAccountId: Scalars['PaymentsAccountId'];
  /** Whether this account can receive payments */
  paymentsEnabled: Scalars['Boolean'];
  /** Whether this account can receive payouts (withdraw money) */
  payoutsEnabled: Scalars['Boolean'];
  /** The current status of the account */
  status: AccountStatus;
  /** A detailed message behind the current status */
  statusMessage: Scalars['String'];
  stripeType: Scalars['String'];
};

/** Additional data to add to the account */
export type StripeAccountData = {
  businessProfile: StripeBusinessProfile;
};

/** Information about the primary Stripe bank account for an account */
export type StripeBankAccount = {
  __typename?: 'StripeBankAccount';
  last4: Scalars['String'];
  name: Scalars['String'];
  routingNumber: Scalars['String'];
};

/** Fields for describing the company / business to Stripe */
export type StripeBusinessProfile = {
  product_description?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

/** Objects related to Stripe Direct Debit (BACS) */
export type StripeDirectDebit = {
  __typename?: 'StripeDirectDebit';
  /** Get all authorized BACS Direct Debit payment sources for the current user */
  getBACSForUser: Array<BACSSource>;
  /** Get a Direct Debit Instruction */
  getDDI?: Maybe<DirectDebitInstruction>;
  /** Get all Direct Debit Instructions for the current user */
  getDDIForUser: Array<DirectDebitInstruction>;
};


/** Objects related to Stripe Direct Debit (BACS) */
export type StripeDirectDebitgetDDIArgs = {
  directDebitInstructionId: Scalars['DirectDebitInstructionId'];
};

/** Mutations for creating and accepting Direct Debit (BACS) in Stripe */
export type StripeDirectDebitMutations = {
  __typename?: 'StripeDirectDebitMutations';
  /** Confirm a Direct Debit Instruction and create a BACS payments source */
  confirmAndCreateBacs: BACSSource;
  /**
   * Confirm the DDI, allowing you to use it as a pre-requisite for a payments source
   * @deprecated Use confirmAndCreateBacs instead of separate confirm and create calls
   */
  confirmDDI: DirectDebitInstruction;
  /**
   * Create a BACS Direct Debit payments source
   * @deprecated Use confirmAndCreateBacs instead of separate confirm and create calls
   */
  createBacs: BACSSource;
  /** Create a Direct Debit Instruction required for BACS Direct Debit */
  createDDI: DirectDebitInstruction;
  /** Delete the DDI, preventing future use as payments source */
  deleteDdi: Scalars['Boolean'];
};


/** Mutations for creating and accepting Direct Debit (BACS) in Stripe */
export type StripeDirectDebitMutationsconfirmAndCreateBacsArgs = {
  directDebitInstructionId: Scalars['DirectDebitInstructionId'];
};


/** Mutations for creating and accepting Direct Debit (BACS) in Stripe */
export type StripeDirectDebitMutationsconfirmDDIArgs = {
  directDebitInstructionId: Scalars['DirectDebitInstructionId'];
};


/** Mutations for creating and accepting Direct Debit (BACS) in Stripe */
export type StripeDirectDebitMutationscreateBacsArgs = {
  directDebitInstructionId: Scalars['DirectDebitInstructionId'];
};


/** Mutations for creating and accepting Direct Debit (BACS) in Stripe */
export type StripeDirectDebitMutationscreateDDIArgs = {
  accountHolder: Scalars['String'];
  accountNumber: Scalars['String'];
  addressCity: Scalars['String'];
  addressStreet: Scalars['String'];
  addressZip: Scalars['String'];
  sortCode: Scalars['String'];
};


/** Mutations for creating and accepting Direct Debit (BACS) in Stripe */
export type StripeDirectDebitMutationsdeleteDdiArgs = {
  directDebitInstructionId: Scalars['DirectDebitInstructionId'];
};

/** Objects related to Stripe Flexible Fee Schemes */
export type StripeFlexibleFeeScheme = {
  __typename?: 'StripeFlexibleFeeScheme';
  /** Get all historical Stripe flexible fee scheme links for a given site set */
  getHistoricalLinksForSite: Array<HistoricalFlexibleFeeSchemeLink>;
  /** Get all current and future Stripe flexible fee scheme links for a given site set */
  getLinksForSite: Array<FlexibleFeeSchemeLinkForBackoffice>;
  /** List all possible Stripe flexible fee schemes */
  listAllSchemes: Array<FlexibleFeeScheme>;
};


/** Objects related to Stripe Flexible Fee Schemes */
export type StripeFlexibleFeeSchemegetHistoricalLinksForSiteArgs = {
  siteSetId: Scalars['SiteSetId'];
};


/** Objects related to Stripe Flexible Fee Schemes */
export type StripeFlexibleFeeSchemegetLinksForSiteArgs = {
  siteSetId: Scalars['SiteSetId'];
};

/** Mutations for creating and deleting Stripe flexible fee scheme links */
export type StripeFlexibleFeeSchemeMutations = {
  __typename?: 'StripeFlexibleFeeSchemeMutations';
  /** Create a Stripe flexible fee scheme link */
  createLink: FlexibleFeeSchemeLinkForBackoffice;
  /** Delete the specified Stripe flexible fee scheme link */
  deleteLink: HistoricalFlexibleFeeSchemeLink;
};


/** Mutations for creating and deleting Stripe flexible fee scheme links */
export type StripeFlexibleFeeSchemeMutationscreateLinkArgs = {
  endDate: Scalars['LocalDate'];
  flexibleFeeSchemeId: Scalars['StripeFlexibleFeeSchemeId'];
  note?: InputMaybe<Scalars['String']>;
  siteSetId: Scalars['SiteSetId'];
  startDate: Scalars['LocalDate'];
};


/** Mutations for creating and deleting Stripe flexible fee scheme links */
export type StripeFlexibleFeeSchemeMutationsdeleteLinkArgs = {
  flexibleFeeSchemeLinkId: Scalars['StripeFlexibleFeeSchemeLinkId'];
};

export enum StripeFlexibleFeeSchemeType {
  CUSTOM = 'CUSTOM',
  STANDARD = 'STANDARD'
}

/** Stripe-specific payments endpoints */
export type StripeMutation = {
  __typename?: 'StripeMutation';
  /** Cancel a payment that is either pending or awaiting validation */
  cancelPayment: CancelPaymentResult;
  /**
   * Collect mandates for all associated sites for a given user and payment method
   * @deprecated Bacs does not require additional mandate collection.
   */
  collectMandatesForAssociatedSites: Scalars['Boolean'];
  /**
   * Confirm an ACH payment method by specifying the micro-deposits made by Stripe
   * @deprecated Use SetupIntent and savePaymentMethod instead in order to handle both micro-deposits and instant verification
   */
  confirmAch: PaymentsSource;
  /** Attempt to confirm an already-started payment */
  confirmPayment: PaymentResponse;
  createAccount: PaymentsAccount;
  /**
   * Create an ACH payment method
   * @deprecated Use SetupIntent and savePaymentMethod instead.
   */
  createAch: PaymentsSource;
  /** Attempt to create a payment, with potential extra verification steps */
  createPayment: PaymentResponse;
  /** Create a setup intent for available payment methods and options */
  createPaymentSetupIntent: StartPaymentMethod;
  flexibleFeeScheme: StripeFlexibleFeeSchemeMutations;
  paymentLink: StripePaymentLinkMutations;
  /** Retrieve details to resume a payment requiring further validation */
  resumePayment: PaymentResponse;
  /** Save a payment method for later use */
  savePaymentMethod: PaymentsSource;
  /**
   * Get the client secret to start a setup intent
   * @deprecated Use createPaymentSetupIntent instead with institutionId
   */
  startPaymentMethod: StartPaymentMethod;
  stripeDirectDebit: StripeDirectDebitMutations;
  updateAccount: PaymentsAccount;
  /** Verify payment method, mark as active and attach to customer */
  verifyPaymentMethod: PaymentsSource;
};


/** Stripe-specific payments endpoints */
export type StripeMutationcancelPaymentArgs = {
  paymentId: Scalars['PaymentId'];
};


/** Stripe-specific payments endpoints */
export type StripeMutationcollectMandatesForAssociatedSitesArgs = {
  paymentsSourceId: Scalars['PaymentsSourceId'];
  siteSetIds?: InputMaybe<Array<Scalars['SiteSetId']>>;
};


/** Stripe-specific payments endpoints */
export type StripeMutationconfirmAchArgs = {
  amount1: Scalars['Int'];
  amount2: Scalars['Int'];
  paymentsSourceId: Scalars['PaymentsSourceId'];
};


/** Stripe-specific payments endpoints */
export type StripeMutationconfirmPaymentArgs = {
  paymentIntentId: Scalars['String'];
};


/** Stripe-specific payments endpoints */
export type StripeMutationcreateAccountArgs = {
  accountData?: InputMaybe<StripeAccountData>;
  accountToken: Scalars['String'];
  institutionSetId: Scalars['InstitutionSetId'];
};


/** Stripe-specific payments endpoints */
export type StripeMutationcreateAchArgs = {
  bankAccountToken: Scalars['String'];
};


/** Stripe-specific payments endpoints */
export type StripeMutationcreatePaymentArgs = {
  flexPayAmount?: InputMaybe<Scalars['BadMoney']>;
  payload: Scalars['String'];
  paymentInput: PaymentInput;
};


/** Stripe-specific payments endpoints */
export type StripeMutationresumePaymentArgs = {
  paymentId: Scalars['PaymentId'];
};


/** Stripe-specific payments endpoints */
export type StripeMutationsavePaymentMethodArgs = {
  institutionId?: InputMaybe<Scalars['InstitutionId']>;
  isVerified?: InputMaybe<Scalars['Boolean']>;
  paymentMethodId: Scalars['String'];
};


/** Stripe-specific payments endpoints */
export type StripeMutationupdateAccountArgs = {
  accountToken?: InputMaybe<Scalars['String']>;
  externalAccountToken?: InputMaybe<Scalars['String']>;
  paymentsAccountId: Scalars['PaymentsAccountId'];
  personTokens: Array<StripePersonInput>;
};


/** Stripe-specific payments endpoints */
export type StripeMutationverifyPaymentMethodArgs = {
  paymentsSourceId: Scalars['PaymentsSourceId'];
};

/** Mutations for handling Stripe Payment Links */
export type StripePaymentLinkMutations = {
  __typename?: 'StripePaymentLinkMutations';
  /** Create a product with a given price and description. */
  createProduct: Scalars['StripeProductId'];
};


/** Mutations for handling Stripe Payment Links */
export type StripePaymentLinkMutationscreateProductArgs = {
  description: Scalars['String'];
  paymentsAccountId: Scalars['PaymentsAccountId'];
  price: Scalars['BadMoney'];
  productType: StripeProductType;
};

/** Queries for Stripe Payment Links */
export type StripePaymentLinkQueries = {
  __typename?: 'StripePaymentLinkQueries';
  /** Fetches all Stripe products for a payments account Id */
  fetchProducts: Array<StripeProduct>;
};


/** Queries for Stripe Payment Links */
export type StripePaymentLinkQueriesfetchProductsArgs = {
  paymentsAccountId: Scalars['PaymentsAccountId'];
};

/** A person associated with a Stripe account (account opener/owner/director) */
export type StripePerson = {
  __typename?: 'StripePerson';
  address?: Maybe<StripePersonAddress>;
  /** Behaviors that determine special case handling for person data. */
  behaviors: Array<Behavior>;
  dob?: Maybe<StripePersonDob>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  lastName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  relationship?: Maybe<StripePersonRelationship>;
  verification?: Maybe<StripePersonVerification>;
  /** @deprecated Plase use the 'verification' field. */
  verificationError?: Maybe<Scalars['String']>;
  /** @deprecated Plase use the 'verification' field. */
  verificationStatus: VerificationStatus;
};

/** The address for a given person */
export type StripePersonAddress = {
  __typename?: 'StripePersonAddress';
  city?: Maybe<Scalars['String']>;
  line1?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
};

/** The date of birth for a given person */
export type StripePersonDob = {
  __typename?: 'StripePersonDob';
  day?: Maybe<Scalars['Long']>;
  month?: Maybe<Scalars['Long']>;
  year?: Maybe<Scalars['Long']>;
};

/** A person associated with an account */
export type StripePersonInput = {
  id?: InputMaybe<Scalars['String']>;
  token: Scalars['String'];
};

/** The relationship between the person and the account */
export type StripePersonRelationship = {
  __typename?: 'StripePersonRelationship';
  /** @deprecated Please use the 'representative' field instead. */
  accountOpener: Scalars['Boolean'];
  director: Scalars['Boolean'];
  owner: Scalars['Boolean'];
  percentOwnership: Scalars['BigDecimal'];
  representative: Scalars['Boolean'];
  title: Scalars['String'];
};

/** Details about the verification of a person for a Stripe account */
export type StripePersonVerification = {
  __typename?: 'StripePersonVerification';
  additionalDocumentError?: Maybe<Scalars['String']>;
  documentError?: Maybe<Scalars['String']>;
  status: VerificationStatus;
  verificationError?: Maybe<Scalars['String']>;
};

/** Object containing information about a Stripe Product */
export type StripeProduct = {
  __typename?: 'StripeProduct';
  description: Scalars['String'];
  price: Scalars['BadMoney'];
  productId: Scalars['StripeProductId'];
  productType: StripeProductType;
};

export enum StripeProductType {
  /** A product representing a Registration Fee */
  REGISTRATION_FEE = 'REGISTRATION_FEE'
}

/** A sub line of an invoice line */
export type SubLine = {
  __typename?: 'SubLine';
  fromRelations: Array<SubLineRelation>;
  subLineId: Scalars['SubLineId'];
  subtotal: Scalars['BadMoney'];
  title: Scalars['String'];
  toRelations: Array<SubLineRelation>;
  total: Scalars['BadMoney'];
};

/** A relation between two sub lines */
export type SubLineRelation = {
  __typename?: 'SubLineRelation';
  amount?: Maybe<Scalars['BadMoney']>;
  subLine: SubLine;
  type: Scalars['String'];
};

export type SubTypeFeatureSettingsFlags = {
  __typename?: 'SubTypeFeatureSettingsFlags';
  /** Returns if this feature can be enabled. */
  canOptIn: Scalars['Boolean'];
  /** Returns true if it is possible to enable subtype requirement in the settings. */
  canOptInToLeaveSubtypeRequired: Scalars['Boolean'];
  /** Returns if this feature is currently enabled. */
  enabled: Scalars['Boolean'];
  /** Returns if adding a subtype to a leave is required. */
  required: Scalars['Boolean'];
};

export type SubTypeManagementPaidStatusType = {
  __typename?: 'SubTypeManagementPaidStatusType';
  /** Returns true if current user can edit paid status of a subtype. */
  canEdit: Scalars['Boolean'];
  /** Returns true if current user can view paid status of a subtype. */
  canView: Scalars['Boolean'];
};

export type SubTypeManagementType = {
  __typename?: 'SubTypeManagementType';
  /** Returns true if current user can create new subtypes. */
  canCreate: Scalars['Boolean'];
  /** Returns true if current user can delete existing subtypes. */
  canDelete: Scalars['Boolean'];
  /** Returns true if current user can edit existing subtypes. */
  canEdit: Scalars['Boolean'];
  /** Returns true if current user can view subtypes. */
  canView: Scalars['Boolean'];
  /** Flags governing management of paid status on subtypes. */
  paidStatus: SubTypeManagementPaidStatusType;
};

export type SubmittedFormFieldData = {
  __typename?: 'SubmittedFormFieldData';
  /** Optional user supplied text associated with the field (usage depends on field type). */
  description?: Maybe<Scalars['String']>;
  fieldType: CustomRegistrationFormFieldType;
  id: Scalars['CustomRegistrationFormFieldId'];
  /** Value supplied in the form */
  value: Scalars['String'];
};

/** A subscription to a `package` for an institution set */
export type Subscription = {
  __typename?: 'Subscription';
  endDate?: Maybe<Scalars['ZonedDateTime']>;
  /** Upcoming subscription data to be used when some extra info is needed (fake data for now) */
  metadata?: Maybe<SubscriptionMetadata>;
  package?: Maybe<SubscriptionPackage>;
  pricing: SubscriptionPackagePricing;
  subscriptionId: Scalars['SubscriptionId'];
  subscriptionType: SubscriptionType;
  trial: Scalars['Boolean'];
  /** @deprecated Please use subscriptionType instead. */
  type?: Maybe<Scalars['String']>;
  /** @deprecated Please, use metadata field */
  units?: Maybe<Scalars['Int']>;
};

/** Data about subscriptions for an institution set */
export type SubscriptionData = {
  __typename?: 'SubscriptionData';
  currentSubscriptions: Array<Subscription>;
  institutionSetId: Scalars['InstitutionSetId'];
  /** Upcoming subscription changes if no further action is taken */
  projectedSubscriptions: Array<Subscription>;
  upgrades: Array<SubscriptionPackage>;
  /** @deprecated Trial subscriptions are handled through CS currently */
  upsell: Array<SubscriptionPackage>;
};

export type SubscriptionMetadata = StaffRotasSubscriptionMetaData;

/** Make changes related to subscriptions */
export type SubscriptionMutations = {
  __typename?: 'SubscriptionMutations';
  /** Confirm starting a paid staff rotas subscription using current seats in use */
  startStaffRotasPaidSubscription: Scalars['Boolean'];
  /** Confirm starting a trial staff rotas subscription */
  startStaffRotasTrialSubscription: Scalars['Boolean'];
  /** Starting a trial subscription of a package */
  startTrialSubscription: TrialSubscription;
  /** @deprecated Trial subscriptions are handled through CS currently */
  trialSubscription: Scalars['Boolean'];
};


/** Make changes related to subscriptions */
export type SubscriptionMutationsstartStaffRotasPaidSubscriptionArgs = {
  institutionId: Scalars['InstitutionId'];
};


/** Make changes related to subscriptions */
export type SubscriptionMutationsstartStaffRotasTrialSubscriptionArgs = {
  institutionId: Scalars['InstitutionId'];
};


/** Make changes related to subscriptions */
export type SubscriptionMutationsstartTrialSubscriptionArgs = {
  institutionSetId: Scalars['InstitutionSetId'];
  packageId: Scalars['PackageId'];
};


/** Make changes related to subscriptions */
export type SubscriptionMutationstrialSubscriptionArgs = {
  institutionSetId: Scalars['InstitutionSetId'];
  packageId: Scalars['PackageId'];
};

/** A package of features that can be subscribed to */
export type SubscriptionPackage = {
  __typename?: 'SubscriptionPackage';
  description?: Maybe<Scalars['String']>;
  packageId: Scalars['PackageId'];
  pricing: Array<SubscriptionPackagePricing>;
  shortDescription: Scalars['String'];
  title: Scalars['String'];
};

export type SubscriptionPackagePricing = {
  amount: Scalars['BadMoney'];
  billingCycle?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  monthsBilled: Scalars['Int'];
  total: Scalars['BadMoney'];
  vat: Scalars['BadMoney'];
};

/** Annually priced package */
export type SubscriptionPackagePricingAnnual = SubscriptionPackagePricing & {
  __typename?: 'SubscriptionPackagePricingAnnual';
  amount: Scalars['BadMoney'];
  billingCycle?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  monthsBilled: Scalars['Int'];
  total: Scalars['BadMoney'];
  vat: Scalars['BadMoney'];
};

/** Free package */
export type SubscriptionPackagePricingFree = SubscriptionPackagePricing & {
  __typename?: 'SubscriptionPackagePricingFree';
  amount: Scalars['BadMoney'];
  billingCycle?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  monthsBilled: Scalars['Int'];
  total: Scalars['BadMoney'];
  vat: Scalars['BadMoney'];
};

/** Monthly priced package */
export type SubscriptionPackagePricingMonthly = SubscriptionPackagePricing & {
  __typename?: 'SubscriptionPackagePricingMonthly';
  amount: Scalars['BadMoney'];
  billingCycle?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  monthsBilled: Scalars['Int'];
  total: Scalars['BadMoney'];
  vat: Scalars['BadMoney'];
};

/** Everything related to the subscription page */
export type SubscriptionPage = {
  __typename?: 'SubscriptionPage';
  v1: SubscriptionPageV1;
  v2: SubscriptionPageV2;
};

/** Custom representation of DateTime with usage limited to the domain of subscription page */
export type SubscriptionPageDateTime = {
  __typename?: 'SubscriptionPageDateTime';
  formatted: Scalars['String'];
  iso: Scalars['String'];
};

/** Custom representation of Money with usage limited to the domain of subscription page */
export type SubscriptionPageMoney = {
  __typename?: 'SubscriptionPageMoney';
  formatted: Scalars['String'];
  raw: Scalars['BigDecimal'];
};

/** Edit bill payer address and email */
export type SubscriptionPageMutation = {
  __typename?: 'SubscriptionPageMutation';
  v1: SubscriptionPageMutationV1;
};

/** First version of the subscription page mutations */
export type SubscriptionPageMutationV1 = {
  __typename?: 'SubscriptionPageMutationV1';
  editBillPayer: Scalars['Boolean'];
};


/** First version of the subscription page mutations */
export type SubscriptionPageMutationV1editBillPayerArgs = {
  editBillPayer: SubscriptionPageV1EditBillPayer;
};

/** First version of the subscription page */
export type SubscriptionPageV1 = {
  __typename?: 'SubscriptionPageV1';
  access: SubscriptionPageV1Access;
  billPayers: Array<SubscriptionPageV1BillPayer>;
};

/** Access requirement */
export type SubscriptionPageV1Access = {
  __typename?: 'SubscriptionPageV1Access';
  canAccess: Scalars['Boolean'];
};

/** Represents a bill payer */
export type SubscriptionPageV1BillPayer = {
  __typename?: 'SubscriptionPageV1BillPayer';
  address?: Maybe<Address>;
  balance: SubscriptionPageMoney;
  email?: Maybe<Scalars['EmailAddress']>;
  id: Scalars['BillPayerId'];
  internalFinanceSiteId: Scalars['SiteId'];
  invoicesAndPayments: Array<SubscriptionPageV1InvoiceOrPayment>;
  name: Scalars['String'];
  package: SubscriptionPageV1Package;
  paymentsSetup?: Maybe<SubscriptionPageV1PaymentsSetupType>;
};

export type SubscriptionPageV1EditBillPayer = {
  billPayerId: Scalars['BillPayerId'];
  newAddress: AddressInput;
  newEmail: Scalars['EmailAddress'];
};

/** Represents a case of payments setup where bill payer does have payment method attached to its account but does not have automatic payments enabled */
export type SubscriptionPageV1HasPaymentMethod = {
  __typename?: 'SubscriptionPageV1HasPaymentMethod';
  paymentMethod: Scalars['String'];
  paymentsSources: Array<PaymentsSource>;
};

/** Represents a case of payments setup where bill payer does have payment method attached to its account and has automatic payments enabled */
export type SubscriptionPageV1HasPaymentMethodAndAutomaticPaymentsEnabled = {
  __typename?: 'SubscriptionPageV1HasPaymentMethodAndAutomaticPaymentsEnabled';
  nextAutomaticPaymentsDate: SubscriptionPageDateTime;
  paymentMethod: Scalars['String'];
  paymentsSources: Array<PaymentsSource>;
};

/** Represents invoices available in the balance history */
export type SubscriptionPageV1Invoice = {
  __typename?: 'SubscriptionPageV1Invoice';
  amount: SubscriptionPageMoney;
  balance: SubscriptionPageMoney;
  date: SubscriptionPageDateTime;
  id: Scalars['InvoiceId'];
  number: Scalars['String'];
};

/** Represents an item of line - an invoice or a payment */
export type SubscriptionPageV1InvoiceOrPayment = SubscriptionPageV1Invoice | SubscriptionPageV1Payment;

/** Represents an aggregated information about a package (or packages) for a site or multiple */
export type SubscriptionPageV1Package = {
  __typename?: 'SubscriptionPageV1Package';
  name: Scalars['String'];
  sites: Array<SubscriptionPageV1Site>;
  upgrade: SubscriptionPageV1Upgrade;
};

/** Represents payments available in the balance history */
export type SubscriptionPageV1Payment = {
  __typename?: 'SubscriptionPageV1Payment';
  amount: SubscriptionPageMoney;
  balance: SubscriptionPageMoney;
  date: SubscriptionPageDateTime;
  id: Scalars['PaymentId'];
  paymentMethod: Scalars['String'];
  status: TransactionStatus;
};

/** Represents one of the cases of payments setup */
export type SubscriptionPageV1PaymentsSetupType = SubscriptionPageV1HasPaymentMethod | SubscriptionPageV1HasPaymentMethodAndAutomaticPaymentsEnabled;

/** Sites user has access to see and manage / pay for */
export type SubscriptionPageV1Site = {
  __typename?: 'SubscriptionPageV1Site';
  id: Scalars['SiteSetId'];
};

/** Object holding information about potential upgrade path for sites under management of the bill payer */
export type SubscriptionPageV1Upgrade = {
  __typename?: 'SubscriptionPageV1Upgrade';
  siteId?: Maybe<Scalars['SiteId']>;
};

/** First version of the subscription page */
export type SubscriptionPageV2 = {
  __typename?: 'SubscriptionPageV2';
  access: SubscriptionPageV1Access;
  billPayers: Array<SubscriptionPageV2BillPayer>;
};

/** Represents a bill payer */
export type SubscriptionPageV2BillPayer = {
  __typename?: 'SubscriptionPageV2BillPayer';
  address?: Maybe<Address>;
  balance: SubscriptionPageMoney;
  email?: Maybe<Scalars['EmailAddress']>;
  id: Scalars['BillPayerId'];
  internalFinanceSiteId: Scalars['SiteId'];
  invoicesAndPayments: Array<SubscriptionPageV2InvoiceOrPayment>;
  name: Scalars['String'];
  package: SubscriptionPageV1Package;
  paymentsSetup?: Maybe<SubscriptionPageV1PaymentsSetupType>;
};

/** Represents credit notes available in the balance history */
export type SubscriptionPageV2CreditNote = {
  __typename?: 'SubscriptionPageV2CreditNote';
  amount: SubscriptionPageMoney;
  balance: SubscriptionPageMoney;
  date: SubscriptionPageDateTime;
  id: Scalars['InvoiceId'];
  number: Scalars['String'];
};

/** Represents an item of line - an invoice, a credit note, or a payment */
export type SubscriptionPageV2InvoiceOrPayment = SubscriptionPageV1Invoice | SubscriptionPageV1Payment | SubscriptionPageV2CreditNote;

export enum SubscriptionType {
  FAMLY_SUBSCRIPTION = 'FAMLY_SUBSCRIPTION',
  STAFF_ROTAS = 'STAFF_ROTAS',
  UNKNOWN = 'UNKNOWN'
}

/** View subscription data */
export type Subscriptions = {
  __typename?: 'Subscriptions';
  forBillPayers: Array<SubscriptionData>;
  forInstitutionSets: Array<SubscriptionData>;
};


/** View subscription data */
export type SubscriptionsforBillPayersArgs = {
  billPayerIds: Array<Scalars['BillPayerId']>;
};


/** View subscription data */
export type SubscriptionsforInstitutionSetsArgs = {
  institutionSetIds: Array<Scalars['InstitutionSetId']>;
};

/**
 * The suggested billpayer for the provided, along with an optional invoice if one is matched, children and
 * whether or not they have registered emails.
 */
export type SuggestedBillPayer = {
  __typename?: 'SuggestedBillPayer';
  billPayer: BillPayer;
  /**
   * "True if a bill payer has an email set or if an email
   * is set on at least 1 of the invoice recipients for the bill payer.
   * "
   * @deprecated Use billPayer.canBeNotified instead
   */
  canBeNotified: Scalars['Boolean'];
  children: Array<Child>;
  invoice?: Maybe<Invoice>;
  /** @deprecated Use invoice.invoiceId instead */
  invoiceId?: Maybe<Scalars['InvoiceId']>;
};

export type SuggestedReport = {
  __typename?: 'SuggestedReport';
  reason: Scalars['String'];
  suggestion: Report;
};

export enum SupportStatus {
  DEPRECATED = 'DEPRECATED',
  SUPPORTED = 'SUPPORTED',
  UNSUPPORTED = 'UNSUPPORTED'
}

export type SupportsKitabuli = {
  __typename?: 'SupportsKitabuli';
  /** Indicates that the user can be redirected to Kitabuli. */
  canAccessKitabuli: FeatureSupportState;
  /** Indicates that the user can edit the setup for the Kitabuli integration. */
  canManageKitabuliIntegration: FeatureSupportState;
  /** Indicates that the Kitabuli integration is enabled. */
  integrationIsEnabled: FeatureSupportState;
};

export type SupportsParentPurchases = {
  __typename?: 'SupportsParentPurchases';
  /**
   * Indicates whether the user can manage parent purchases with rule sets.
   * @deprecated Use the `canManagePurchasesWithAutomaticPricing` field under `purchases` instead. This feature applies to all purchases, not just parent purchases
   */
  canManageParentPurchasesWithRuleSets: FeatureSupportState;
  /**
   * Indicates whether the new parent purchase design should be used.
   * @deprecated Use the `canUseNewPurchaseDesign` field under `purchases` instead. This feature applies to all purchases, not just parent purchases
   */
  canUseNewParentPurchaseDesign: FeatureSupportState;
  /**
   * Indicates whether the parent purchases with rule sets feature is enabled.
   * @deprecated Use the `automaticPricing` field under `purchases` instead. This feature applies to all purchases, not just parent purchases
   */
  parentPurchasesWithRuleSetsIsEnabled: FeatureSupportState;
};

export type SupportsPurchases = {
  __typename?: 'SupportsPurchases';
  /** Indicates whether automatic pricing for purchases is available. */
  automaticPricing: FeatureSupportState;
  /** Indicates whether the user can manage purchases with automatic pricing. */
  canManagePurchasesWithAutomaticPricing: FeatureSupportState;
  /** Indicates whether the new purchase design should be used. */
  canUseNewPurchaseDesign: FeatureSupportState;
};

/** Get details about a particular survey response */
export type Survey = {
  __typename?: 'Survey';
  createdBy: Scalars['LoginId'];
  responseText?: Maybe<Scalars['String']>;
  skipped: Scalars['Boolean'];
  surveyResponseId: Scalars['ParentSurveyResponseId'];
  surveyType: SurveyType;
};

/** Objects related to mutating surveys and survey responses */
export type SurveyMutations = {
  __typename?: 'SurveyMutations';
  saveResponse: Survey;
};


/** Objects related to mutating surveys and survey responses */
export type SurveyMutationssaveResponseArgs = {
  responseText?: InputMaybe<Scalars['String']>;
  skipped: Scalars['Boolean'];
  surveyType: SurveyType;
};

export enum SurveyType {
  FamlyPay = 'FamlyPay'
}

export type SwissInstitutionData = {
  __typename?: 'SwissInstitutionData';
  qrIbanAccount: Scalars['String'];
};

export type SyncError = SynchronizationStatus & {
  __typename?: 'SyncError';
  /** The last time a synchronization was attempted */
  lastSyncTime?: Maybe<Scalars['ZonedDateTime']>;
  /** The synchronization error */
  message: Scalars['String'];
};

export type Synced = SynchronizationStatus & {
  __typename?: 'Synced';
  /** The last time a synchronization was attempted */
  lastSyncTime?: Maybe<Scalars['ZonedDateTime']>;
};

/** Represents a synchronization status */
export type SynchronizationStatus = {
  /** The last time a synchronization was attempted */
  lastSyncTime?: Maybe<Scalars['ZonedDateTime']>;
};

export type Syncing = SynchronizationStatus & {
  __typename?: 'Syncing';
  /** The last time a synchronization was attempted */
  lastSyncTime?: Maybe<Scalars['ZonedDateTime']>;
  /** The time synchronization started */
  syncStarted: Scalars['ZonedDateTime'];
};

/** A tag is an arbitrary grouping of children or employees */
export type Tag = {
  __typename?: 'Tag';
  color: Color;
  id: Scalars['TagId'];
  institutionId: Scalars['InstitutionId'];
  profileImage?: Maybe<ProfileImage>;
  title: Scalars['Title'];
};

/** Mutations related to tags */
export type TagMutations = {
  __typename?: 'TagMutations';
  create: Tag;
  delete: Scalars['TagId'];
  update: Tag;
};


/** Mutations related to tags */
export type TagMutationscreateArgs = {
  color: Color;
  institutionId: Scalars['InstitutionId'];
  title: Scalars['Title'];
};


/** Mutations related to tags */
export type TagMutationsdeleteArgs = {
  institutionId: Scalars['InstitutionId'];
  tagId: Scalars['TagId'];
};


/** Mutations related to tags */
export type TagMutationsupdateArgs = {
  color: Color;
  institutionId: Scalars['InstitutionId'];
  tagId: Scalars['TagId'];
  title: Scalars['Title'];
};

export type TagOverview = {
  __typename?: 'TagOverview';
  /** The children with the tag who are currently signed in */
  children: Array<Child>;
  isStarred: Scalars['Boolean'];
  /** The staff with the tag who are currently signed in */
  staff?: Maybe<Array<Employee>>;
  tag: Tag;
};

export type TagsWidget = Widget & {
  __typename?: 'TagsWidget';
  /** Whether the user can add a new tag */
  canAdd: Scalars['Boolean'];
  id: Scalars['HomeWidgetId'];
  next?: Maybe<Scalars['HomeWidgetCursor']>;
  tags: Array<TagOverview>;
  title: Scalars['String'];
  widgetId: Scalars['String'];
};

/** Target language information */
export type TargetLanguageData = {
  __typename?: 'TargetLanguageData';
  loginId: Scalars['LoginId'];
  /** @deprecated Please use translationLanguage instead */
  targetLanguage?: Maybe<Scalars['String']>;
  translationLanguage?: Maybe<TranslationLanguage>;
};

export enum TargetType {
  CHILD = 'CHILD',
  INSTITUTION = 'INSTITUTION'
}

export type Template = {
  __typename?: 'Template';
  description: Scalars['String'];
  imageSrc: Scalars['String'];
  templateSrc: Scalars['String'];
  title: Scalars['String'];
};

/** A variable that is replaced in a template */
export type TemplateVariable = {
  __typename?: 'TemplateVariable';
  description?: Maybe<Scalars['String']>;
  identifier: Scalars['String'];
  type: TemplateVariableType;
};

/** The type of a template variable */
export enum TemplateVariableType {
  INTERNAL = 'INTERNAL',
  LABEL = 'LABEL',
  LINK = 'LINK'
}

/** Excel and CSV templates for payment import */
export type Templates = {
  __typename?: 'Templates';
  csv: File;
  excel: File;
};

/** Returns all the copy and assets needed for Templates page */
export type TemplatesPageAssets = {
  __typename?: 'TemplatesPageAssets';
  headline: Scalars['String'];
  subheadline: Scalars['String'];
  templates: Array<Template>;
};

/** Details about the Google Translation API T&Cs */
export type Terms = {
  __typename?: 'Terms';
  messaging: TermsInformation;
  newsfeed: TermsInformation;
};

export type TermsAndConditions = {
  __typename?: 'TermsAndConditions';
  /** Links to terms and conditions for the logged in user */
  links: Array<TermsAndConditionsLink>;
};

export type TermsAndConditionsLink = {
  __typename?: 'TermsAndConditionsLink';
  link: Scalars['String'];
};

export type TermsAndConditionsLinkResult = {
  __typename?: 'TermsAndConditionsLinkResult';
  link?: Maybe<Scalars['String']>;
  siteSetId: Scalars['SiteSetId'];
};

/** Queries related to Sidekick terms and conditions */
export type TermsConditions = {
  __typename?: 'TermsConditions';
  /** Returns whether site has accepted terms and conditions */
  hasAccepted: Scalars['Boolean'];
};


/** Queries related to Sidekick terms and conditions */
export type TermsConditionshasAcceptedArgs = {
  siteSetId?: InputMaybe<Scalars['SiteSetId']>;
  version: SidekickTermsAndConditionsVersion;
};

/** Mutations related to Sidekick terms and conditions */
export type TermsConditionsMutation = {
  __typename?: 'TermsConditionsMutation';
  /** Stores user's agreement to terms and conditions */
  accept: SidekickTermsResponse;
};


/** Mutations related to Sidekick terms and conditions */
export type TermsConditionsMutationacceptArgs = {
  siteSetId: Scalars['SiteSetId'];
  version: SidekickTermsAndConditionsVersion;
};

/** Details about the specific area of Google Translation API T&Cs */
export type TermsInformation = {
  __typename?: 'TermsInformation';
  /** When the terms were accepted. Note that this is accepted per site, not by area */
  acceptedAt?: Maybe<Scalars['ZonedDateTime']>;
  /** Whether translation is enabled for this area */
  enabledForTranslation: Scalars['Boolean'];
  /** Whether the terms should be shown for this area */
  showTerms: Scalars['Boolean'];
  /** The link to the terms for this area */
  url: Scalars['String'];
};

export enum TestChildActionId {
  APPROVE_AND_SEND_OBSERVATION = 'APPROVE_AND_SEND_OBSERVATION',
  CHILD_SIGN_IN = 'CHILD_SIGN_IN',
  FINISH_ASSESSMENT = 'FINISH_ASSESSMENT',
  FINISH_NEWS_FEED_POST = 'FINISH_NEWS_FEED_POST',
  NO_ACCESS = 'NO_ACCESS',
  STATUS = 'STATUS',
  UPDATE_ACCIDENT_REPORT = 'UPDATE_ACCIDENT_REPORT'
}

/** Version 4 of the test child flow mutations */
export type TestChildActionMutation = {
  __typename?: 'TestChildActionMutation';
  /** Marking a test child action as completed for a site set id getting the next available action */
  markActionCompleted?: Maybe<NextTestChildAction>;
};


/** Version 4 of the test child flow mutations */
export type TestChildActionMutationmarkActionCompletedArgs = {
  markActionCompletedArg: ActionCompletedInput;
};

/** All the mutations related to test child actions */
export type TestChildActionMutations = {
  __typename?: 'TestChildActionMutations';
  /**
   * Marking a test child action as completed for a site set id
   * @deprecated Use markActionCompleted from v4 instead
   */
  markActionCompleted: Scalars['Boolean'];
  /** @deprecated Use v5 instead */
  v4: TestChildActionMutation;
  v5: TestChildActionMutation;
};


/** All the mutations related to test child actions */
export type TestChildActionMutationsmarkActionCompletedArgs = {
  markActionCompletedArg: ActionCompletedInput;
};

/** All queries related to test child actions. */
export type TestChildActions = {
  __typename?: 'TestChildActions';
  /** @deprecated Use v5 instead */
  v1: TestChildActionsV1;
  /** @deprecated Use v5 instead */
  v2: TestChildActionsV2;
  /** @deprecated Use v5 instead */
  v3: TestChildActionsV3;
  /** @deprecated Use v5 instead */
  v4: TestChildActionsV4;
  v5: TestChildActionsV5;
};

/** Top level object for test child actions v1 */
export type TestChildActionsV1 = {
  __typename?: 'TestChildActionsV1';
  /** Information about next available Test Child action */
  nextTestChildAction?: Maybe<TestChildActionId>;
};

/** Top level object for test child actions v2 */
export type TestChildActionsV2 = {
  __typename?: 'TestChildActionsV2';
  /**
   * Information about next available Test Child action
   * @deprecated Use v3 of this endpoint instead
   */
  nextTestChildAction?: Maybe<NextTestChildAction>;
};


/** Top level object for test child actions v2 */
export type TestChildActionsV2nextTestChildActionArgs = {
  siteSetId: Scalars['InstitutionSetId'];
};

/** Top level object for Test Child actions v3 */
export type TestChildActionsV3 = {
  __typename?: 'TestChildActionsV3';
  /** Information about next available Test Child action */
  nextTestChildAction?: Maybe<NextTestChildAction>;
  /** Details about the Test Child that are needed for the Test Child actions */
  testChildDetails?: Maybe<TestChildDetailsType>;
};


/** Top level object for Test Child actions v3 */
export type TestChildActionsV3nextTestChildActionArgs = {
  siteId: Scalars['InstitutionId'];
};


/** Top level object for Test Child actions v3 */
export type TestChildActionsV3testChildDetailsArgs = {
  siteId: Scalars['InstitutionId'];
};

/** Top level object for Test Child actions v4 */
export type TestChildActionsV4 = {
  __typename?: 'TestChildActionsV4';
  /** Information about next available Test Child action */
  nextTestChildAction?: Maybe<NextTestChildAction>;
  /** Details about the Test Child that are needed for the Test Child actions */
  testChildDetails?: Maybe<TestChildDetailsType>;
};


/** Top level object for Test Child actions v4 */
export type TestChildActionsV4nextTestChildActionArgs = {
  siteId: Scalars['InstitutionId'];
};


/** Top level object for Test Child actions v4 */
export type TestChildActionsV4testChildDetailsArgs = {
  siteId: Scalars['InstitutionId'];
};

/** Top level object for Test Child actions v5 */
export type TestChildActionsV5 = {
  __typename?: 'TestChildActionsV5';
  /** Information about next available Test Child action */
  nextTestChildAction?: Maybe<NextTestChildActionV5>;
  /** Details about the Test Child that are needed for the Test Child actions */
  testChildDetails?: Maybe<TestChildDetailsV5Type>;
};


/** Top level object for Test Child actions v5 */
export type TestChildActionsV5nextTestChildActionArgs = {
  siteId: Scalars['InstitutionId'];
};


/** Top level object for Test Child actions v5 */
export type TestChildActionsV5testChildDetailsArgs = {
  siteId: Scalars['InstitutionId'];
};

/** Details about the Test Child that are needed for the Test Child actions */
export type TestChildDetailsType = {
  __typename?: 'TestChildDetailsType';
  /** Automatically created accident report for the Test Child */
  accidentReportId?: Maybe<Scalars['AccidentReportId']>;
  /** The name given to the Test Child */
  childName?: Maybe<Scalars['String']>;
  /** Automatically created draft assessment for the Test Child */
  draftAssessmentId?: Maybe<Scalars['ObservationId']>;
  /** Automatically created draft news feed post where the Test Child is the recipient */
  draftNewsFeedPostId?: Maybe<Scalars['PostId']>;
  /** Automatically created observation for the Test Child */
  observationId?: Maybe<Scalars['ObservationId']>;
  /** The room the Test Child belong to */
  roomId?: Maybe<Scalars['GroupId']>;
};

/** Details about the Test Child that are needed for the Test Child actions */
export type TestChildDetailsV5Type = {
  __typename?: 'TestChildDetailsV5Type';
  /** Automatically created accident report for the Test Child */
  accidentReportId?: Maybe<Scalars['AccidentReportId']>;
  /** The id of the Test Child */
  childId: Scalars['ChildId'];
  /** The name given to the Test Child */
  childName: Scalars['String'];
  /** Automatically created draft assessment for the Test Child */
  draftAssessmentId?: Maybe<Scalars['ObservationId']>;
  /** Automatically created draft news feed post where the Test Child is the recipient */
  draftNewsFeedPostId?: Maybe<Scalars['PostId']>;
  /** Automatically created observation for the Test Child */
  observationId?: Maybe<Scalars['ObservationId']>;
  /** The room the Test Child belong to */
  roomId?: Maybe<Scalars['GroupId']>;
  /** The id of the site the Test Child belongs to */
  siteId: Scalars['SiteId'];
};

export type Testimonial = {
  __typename?: 'Testimonial';
  author?: Maybe<Scalars['String']>;
  authorJobTitle?: Maybe<Scalars['String']>;
  authorsWorkPlace?: Maybe<Scalars['String']>;
  description: Scalars['String'];
};

export type TestimonialVideo = {
  __typename?: 'TestimonialVideo';
  title: Scalars['String'];
  url: Scalars['String'];
};

export type TimeFieldValue = GenericFormFieldValue & {
  __typename?: 'TimeFieldValue';
  fieldTemplate: GenericFormFieldTemplate;
  fieldTemplateId: Scalars['GenericFormFieldTemplateId'];
  fieldType: GenericFormFieldType;
  fieldValueId: Scalars['GenericFormFieldValueId'];
  timeValue: Scalars['LocalTime'];
  valueAsString: Scalars['String'];
};

export type TimeRangeClosed = {
  __typename?: 'TimeRangeClosed';
  from: Scalars['LocalDate'];
  to: Scalars['LocalDate'];
};

export type TimeRangeClosedLocalTime = {
  __typename?: 'TimeRangeClosedLocalTime';
  from: Scalars['LocalTime'];
  to: Scalars['LocalTime'];
};

export type TimeSlotConfigInput = {
  /** Room id where schedule will happen */
  groupId: Scalars['GroupId'];
  /** Scheduled time range of hours */
  timeRange: ClosedLocalTimeRange;
};

/** Result of setting the facebook access token */
export type TokenResult = {
  __typename?: 'TokenResult';
  availablePages: FacebookPages;
  isSaved: Scalars['Boolean'];
};

export enum TokenType {
  access_token = 'access_token',
  pin = 'pin'
}

/** The current status of a transaction */
export enum TransactionStatus {
  /** Transaction completed successfully */
  COMPLETED = 'COMPLETED',
  /** The transaction was disputed */
  DISPUTED = 'DISPUTED',
  /** The transaction completed unsuccessfully */
  FAILED = 'FAILED',
  /** Transaction is waiting to be sent to the payment provider */
  PENDING = 'PENDING',
  /** Transaction has been sent and is being processed */
  PROCESSING = 'PROCESSING',
  /** The transaction was refunded */
  REFUNDED = 'REFUNDED',
  /** Payment requires further validation to complete */
  REQUIRES_VALIDATION = 'REQUIRES_VALIDATION'
}

/** A video that's finished transcoding */
export type TranscodedVideo = {
  __typename?: 'TranscodedVideo';
  duration: Scalars['Int'];
  height: Scalars['Int'];
  id: Scalars['VideoId'];
  thumbnailUrl: Scalars['String'];
  videoUrl: Scalars['String'];
  width: Scalars['Int'];
};

/** A video that's currently being transcoded */
export type TranscodingVideo = {
  __typename?: 'TranscodingVideo';
  id: Scalars['VideoId'];
};

/** Translation data */
export type Translation = {
  __typename?: 'Translation';
  id: Scalars['String'];
  text: Scalars['String'];
  translation: Scalars['String'];
};

export enum TranslationArea {
  MESSAGING = 'MESSAGING',
  NEWSFEED = 'NEWSFEED'
}

/** Result of the translation request */
export type TranslationData = {
  __typename?: 'TranslationData';
  translations: Array<Translation>;
};

export type TranslationInput = {
  /** Should be a unique identifier to match the translated text back to the input */
  id: Scalars['String'];
  text: Scalars['String'];
};

export type TranslationLanguage = {
  __typename?: 'TranslationLanguage';
  /**
   * The filename of the icon to be shown, including the extension
   * @deprecated We no longer want to show flags for languages
   */
  flagIcon: Scalars['String'];
  /** Text for when we need to display a button with the generic "Hide translation" text */
  hideTranslationText: Scalars['String'];
  /** Whether the language is written from right-to-left */
  isRTL: Scalars['Boolean'];
  /** The language, defined as a Locale of either an ISO 639-1 code (e.g. "bg" or an BCP 47 code (e.g. "zh-CN") */
  language: Scalars['Locale'];
  /** The display name of the language, in the current user's locale if available. Otherwise nothing is returned */
  localizedName?: Maybe<Scalars['String']>;
  /** The display name of the language, manually localised in the language itself. For example, "Dansk" for Danish */
  name: Scalars['String'];
  /** Text for when we need to display a button with the generic "Translate" text */
  translateGenericText: Scalars['String'];
  /** Text for when we need to display a button in the feed */
  translatePostText: Scalars['String'];
  /** Text for when we need to display a button linking to the translation settings */
  translationSettingsText: Scalars['String'];
};

/** Mutations for translation settings */
export type TranslationMutations = {
  __typename?: 'TranslationMutations';
  /** Accepts the translation terms & conditions for the given site set */
  acceptTerms: Terms;
  /** Sets the given translation feature for this area and site set. Requires that the translation terms & conditions are accepted for the given site set */
  setFeature: Terms;
  /** Set the target language for this user, if a translation service is available for this user. */
  targetLanguage: TargetLanguageData;
};


/** Mutations for translation settings */
export type TranslationMutationsacceptTermsArgs = {
  siteSetId: Scalars['SiteSetId'];
};


/** Mutations for translation settings */
export type TranslationMutationssetFeatureArgs = {
  enable: Scalars['Boolean'];
  siteSetId: Scalars['SiteSetId'];
  translationArea: TranslationArea;
};


/** Mutations for translation settings */
export type TranslationMutationstargetLanguageArgs = {
  targetLanguage?: InputMaybe<Scalars['String']>;
};

/** Queries for translation settings and translations */
export type TranslationQueries = {
  __typename?: 'TranslationQueries';
  /** Lists the translation settings */
  listSettings: TranslationSettingsData;
  /** Lists the supported translation languages */
  listSupportedLanguages: Array<TranslationLanguage>;
  /** Details about the Google Translation API T&Cs */
  terms: Terms;
  /** Translate the text into the language defined for the user, if possible */
  translate: TranslationData;
};


/** Queries for translation settings and translations */
export type TranslationQueriestermsArgs = {
  siteSetId: Scalars['SiteSetId'];
};


/** Queries for translation settings and translations */
export type TranslationQueriestranslateArgs = {
  targetLanguage?: InputMaybe<Scalars['String']>;
  toTranslate: Array<TranslationInput>;
  translationArea?: InputMaybe<TranslationArea>;
};

/** Translation settings */
export type TranslationSettingsData = {
  __typename?: 'TranslationSettingsData';
  /** @deprecated Please use one of the more-specific fields instead, e.g. enabledForNewsfeed or enabledForMessaging */
  enabledFor: Array<Scalars['SiteSetId']>;
  enabledForMessaging: Array<Scalars['SiteSetId']>;
  enabledForNewsfeed: Array<Scalars['SiteSetId']>;
  loginId: Scalars['LoginId'];
  /** @deprecated Please use translationLanguage instead */
  targetLanguage?: Maybe<Scalars['String']>;
  translationLanguage?: Maybe<TranslationLanguage>;
};

export type TrialInput = {
  featurePackage: FeaturePackage;
  institutionSetId: Scalars['InstitutionSetId'];
};

/** Start trial subscription */
export type TrialMutations = {
  __typename?: 'TrialMutations';
  /** Starting a trial subscription of an add-on. */
  forAddOn: AddOnTrialResponse;
  /** Starting a trial subscription of a package and returns the number of seconds the app should wait before refetching behaviors */
  forFeaturePackage: Scalars['Int'];
  /**
   * Starting a trial subscription of a package and returns the number of seconds the app should wait before refetching behaviors
   * @deprecated Use forFeaturePackage instead
   */
  forPackage: Scalars['Int'];
};


/** Start trial subscription */
export type TrialMutationsforAddOnArgs = {
  startTrial: AddOnTrialInput;
};


/** Start trial subscription */
export type TrialMutationsforFeaturePackageArgs = {
  startTrial: TrialInput;
};


/** Start trial subscription */
export type TrialMutationsforPackageArgs = {
  startTrial: StartTrialInput;
};

/** Information about the started trial subscription */
export type TrialSubscription = {
  __typename?: 'TrialSubscription';
  subscription?: Maybe<Subscription>;
};

export type UnderStaffed = StaffingStatus & {
  __typename?: 'UnderStaffed';
  msg: Scalars['String'];
};

export type UnvalidatedSiteInformation = {
  __typename?: 'UnvalidatedSiteInformation';
  city?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  phoneNumber: Scalars['String'];
  street?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type UpdateAttendanceInput = {
  /** Attendance date-time range */
  dateTimeRange: NonEmptyLocalDateTimeRangeInput;
  /** Attendance id */
  employeeCheckInId: Scalars['EmployeeCheckInId'];
  /** Room id of attendance */
  groupId: Scalars['GroupId'];
};

export type Updates = {
  __typename?: 'Updates';
  /** Controls gradual rollout of the new updates resolver. */
  version: UpdatesVersion;
};

export enum UpdatesVersion {
  UpdatesV1 = 'UpdatesV1',
  UpdatesV2 = 'UpdatesV2'
}

/** Browse bill payer and site information needed to upgrade */
export type Upgrade = {
  __typename?: 'Upgrade';
  billPayer: StoreBillPayer;
  siteInformation: StoreSiteInformation;
};

export type UpgradeCanBeRequested = {
  __typename?: 'UpgradeCanBeRequested';
  viaIntercom: Scalars['Boolean'];
  viaSlack: Scalars['Boolean'];
};

/** Top level object for Famly Store, when upgrading from a free package */
export type UpgradeFromFreePackage = {
  __typename?: 'UpgradeFromFreePackage';
  billPayer?: Maybe<SiteBillPayer>;
  /** @deprecated This field is deprecated and should not be used */
  isPackageUpgradeFeatureEnabled: Scalars['Boolean'];
  packageInformation: PackageInformation;
  siteInformation?: Maybe<UnvalidatedSiteInformation>;
};


/** Top level object for Famly Store, when upgrading from a free package */
export type UpgradeFromFreePackagebillPayerArgs = {
  institutionId: Scalars['InstitutionId'];
};


/** Top level object for Famly Store, when upgrading from a free package */
export type UpgradeFromFreePackageisPackageUpgradeFeatureEnabledArgs = {
  institutionId: Scalars['InstitutionId'];
};


/** Top level object for Famly Store, when upgrading from a free package */
export type UpgradeFromFreePackagesiteInformationArgs = {
  institutionId: Scalars['InstitutionId'];
};

/** Update from a free package to a paid package */
export type UpgradeFromFreePackageMutations = {
  __typename?: 'UpgradeFromFreePackageMutations';
  /** Confirm purchase of a package */
  confirmPurchase: Scalars['Boolean'];
  /** Register bill payer information */
  createBillPayer: SiteBillPayer;
  /** Get a GoCardless URL that can be used to registering payment details */
  createGoCardlessUrl: GoCardlessRedirectFlow;
  /** Register site information */
  createSiteInformation: SiteInformation;
};


/** Update from a free package to a paid package */
export type UpgradeFromFreePackageMutationsconfirmPurchaseArgs = {
  billingCycle: BillingCycle;
  goCardlessId?: InputMaybe<Scalars['String']>;
  goCardlessToken?: InputMaybe<Scalars['String']>;
  institutionId: Scalars['InstitutionId'];
  packageId: Scalars['PackageId'];
  paymentPreference: PaymentMethod;
};


/** Update from a free package to a paid package */
export type UpgradeFromFreePackageMutationscreateBillPayerArgs = {
  email: Scalars['String'];
  institutionId: Scalars['InstitutionId'];
  name: Scalars['String'];
  phoneNumber: Scalars['String'];
  role: Scalars['String'];
};


/** Update from a free package to a paid package */
export type UpgradeFromFreePackageMutationscreateGoCardlessUrlArgs = {
  institutionId: Scalars['InstitutionId'];
  redirectUrl: Scalars['String'];
};


/** Update from a free package to a paid package */
export type UpgradeFromFreePackageMutationscreateSiteInformationArgs = {
  city: Scalars['String'];
  institutionId: Scalars['InstitutionId'];
  name: Scalars['String'];
  phoneNumber: Scalars['String'];
  street: Scalars['String'];
  zip: Scalars['String'];
};

/** Get information about upgrading from a paid package */
export type UpgradeFromPaidPackage = {
  __typename?: 'UpgradeFromPaidPackage';
  /**
   * Boolean to indicate whether the package upgrade feature is enabled for upsell
   * @deprecated This field is deprecated and should not be used
   */
  isPackageUpgradeFeatureEnabledForUpsell: Scalars['Boolean'];
};


/** Get information about upgrading from a paid package */
export type UpgradeFromPaidPackageisPackageUpgradeFeatureEnabledForUpsellArgs = {
  institutionId: Scalars['InstitutionId'];
};

export type UpgradeInfo = {
  billingCycle: BillingCycle;
  featurePackage: FeaturePackage;
  paymentPreference: PaymentMethod;
  siteSetId: Scalars['SiteSetId'];
};

/** Update package to a higher tier one */
export type UpgradePackageMutations = {
  __typename?: 'UpgradePackageMutations';
  /** Confirm upgrade of a package */
  confirmPackageUpgrade: Scalars['Boolean'];
};


/** Update package to a higher tier one */
export type UpgradePackageMutationsconfirmPackageUpgradeArgs = {
  billingCycle: BillingCycle;
  institutionId: Scalars['InstitutionId'];
  packageId: Scalars['PackageId'];
};

/** The upgrade flow to show to users */
export enum UpgradeScenarioType {
  /** Default upgrade scenario */
  DEFAULT = 'DEFAULT',
  /** Upgrade scenario for First Steps customers */
  FS_CONFIRM_SUBSCRIPTION = 'FS_CONFIRM_SUBSCRIPTION',
  /**
   * Upgrade scenario for referred users
   * @deprecated Referral Program is no longer available in Famly App. This enum is deprecated but kept around for backwards compatibility
   */
  REFERRAL = 'REFERRAL',
  /** Upgrade scenario from free package */
  UPGRADE_FROM_FREE_PACKAGE = 'UPGRADE_FROM_FREE_PACKAGE',
  /** Upgrade scenario from paid package */
  UPGRADE_FROM_PAID_PACKAGE = 'UPGRADE_FROM_PAID_PACKAGE'
}

export type Upsell = {
  __typename?: 'Upsell';
  /** Upsell to a higher tier booster pack. The return is the number of seconds that the client needs to wait, due to replica lag and cache update, before refetching behaviors and other stuff. */
  forBoosterPack: Scalars['Int'];
  /** Upgrade from a paid package to a higher tier. The return is the number of seconds that the client needs to wait, due to replica lag and cache update, before refetching behaviors and other stuff. */
  forPackage: Scalars['Int'];
};


export type UpsellforBoosterPackArgs = {
  boosterPackUpsellInfo: BoosterPackUpsellInfo;
};


export type UpsellforPackageArgs = {
  upsellInfo: UpsellInfo;
};

export type UpsellInfo = {
  billingCycle: BillingCycle;
  featurePackage: FeaturePackage;
  siteSetId: Scalars['SiteSetId'];
};

export type UpsellWidget = Widget & {
  __typename?: 'UpsellWidget';
  elements: Array<UpsellWidgetElement>;
  id: Scalars['HomeWidgetId'];
  next?: Maybe<Scalars['HomeWidgetCursor']>;
  openInStore: Scalars['Boolean'];
  title: Scalars['String'];
  widgetId: Scalars['String'];
};

export type UpsellWidgetElement = {
  __typename?: 'UpsellWidgetElement';
  storeAppId: StoreAppId;
};

export enum UsageHistoryGroupedSortOrder {
  MostRecentlyUsed = 'MostRecentlyUsed',
  MostUsed = 'MostUsed'
}

/** The recorded usage history item */
export type UsageHistoryItem = {
  __typename?: 'UsageHistoryItem';
  category: Scalars['String'];
  item: Scalars['String'];
  usageCount: Scalars['Int'];
  usageDate: Scalars['LocalDate'];
};

/** Mutations related to usage history */
export type UsageHistoryMutations = {
  __typename?: 'UsageHistoryMutations';
  /** Register a usage of an item in a category for today. If there is already a record present, the `usageCount` will be incremented */
  registerUsage: UsageHistoryItem;
};


/** Mutations related to usage history */
export type UsageHistoryMutationsregisterUsageArgs = {
  category: Scalars['String'];
  item: Scalars['String'];
};

/** Queries related to usage history */
export type UsageHistoryQueries = {
  __typename?: 'UsageHistoryQueries';
  /** Returns usage history for the current user */
  usage: Array<UsageHistoryResultType>;
};


/** Queries related to usage history */
export type UsageHistoryQueriesusageArgs = {
  category?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<UsageHistoryGroupedSortOrder>;
};

/** The result of querying usage history */
export type UsageHistoryResultType = {
  __typename?: 'UsageHistoryResultType';
  category: Scalars['String'];
  item: Scalars['String'];
  range: TimeRangeClosed;
  usageCount: Scalars['Int'];
};

/** Result from usage limitation validation */
export type UsageLimitationResultType = {
  __typename?: 'UsageLimitationResultType';
  current: Scalars['Int'];
  limit: Scalars['Int'];
  limitReached: Scalars['Boolean'];
};

export type UserBlock = {
  __typename?: 'UserBlock';
  blockedAt: Scalars['ZonedDateTime'];
  blockedUser: Person;
  loginId: Scalars['LoginId'];
};

export type UserContext = {
  __typename?: 'UserContext';
  id: Scalars['String'];
  target: UserContextTarget;
};

export type UserContextChoice = {
  __typename?: 'UserContextChoice';
  context: UserContext;
  hmac: Scalars['String'];
  requiresTwoFactor: Scalars['Boolean'];
};

/** Represents conversations status this user has in a single user context */
export type UserContextConversationsCount = {
  __typename?: 'UserContextConversationsCount';
  inbox: UserInbox;
  userContext: UserContext;
};

/**
 * Returns user context target, due to the backward compatibility the Person type will never be returned,
 * please use the PersonContextTarget type instead.
 * Likewise [[NoContextTarget]] will never be returned.
 */
export type UserContextTarget = InstitutionSet | NoContextTarget | Person | PersonContextTarget;

/** Represents user inbox: unseen and total amount of conversations */
export type UserConversation = {
  __typename?: 'UserConversation';
  /** The inbox for the user's *current* user profile */
  inbox: UserInbox;
  /** The unseen conversation counts for *all* the user's available contexts, including the current */
  userContextCounts: Array<UserContextConversationsCount>;
};

export type UserFeature = {
  __typename?: 'UserFeature';
  enabled: Scalars['Boolean'];
  feature: UserFeatureType;
};

export type UserFeatureMutations = {
  __typename?: 'UserFeatureMutations';
  /** Disable user managed features */
  disable: UserFeatureResult;
  /** Enable user managed features */
  enable: UserFeatureResult;
};


export type UserFeatureMutationsdisableArgs = {
  features: Array<UserFeatureType>;
  loginId?: InputMaybe<Scalars['LoginId']>;
};


export type UserFeatureMutationsenableArgs = {
  features: Array<UserFeatureType>;
  loginId?: InputMaybe<Scalars['LoginId']>;
};

export type UserFeatureResult = {
  __typename?: 'UserFeatureResult';
  features: Array<UserFeature>;
};

export enum UserFeatureType {
  SETTINGS_USE_EYFS_2021_CHILD_DEVELOPMENT = 'SETTINGS_USE_EYFS_2021_CHILD_DEVELOPMENT'
}

export type UserFeatures = {
  __typename?: 'UserFeatures';
  /** List information about the features that can be directly enabled for the user */
  list: UserFeatureResult;
};


export type UserFeatureslistArgs = {
  loginId?: InputMaybe<Scalars['LoginId']>;
};

export type UserGeneratedContentListReportsResult = {
  __typename?: 'UserGeneratedContentListReportsResult';
  next?: Maybe<Scalars['UserGeneratedContentListReportsCursor']>;
  reports: Array<UserGeneratedContentReport>;
};

export type UserGeneratedContentReport = {
  __typename?: 'UserGeneratedContentReport';
  contentCreator: Person;
  contentId: Scalars['UniqueId'];
  contentType: ReportableContent;
  link?: Maybe<Scalars['String']>;
  reason: Scalars['String'];
  reportId: Scalars['UserGeneratedContentReportId'];
  reportedAt: Scalars['ZonedDateTime'];
  reporter: Person;
};

export type UserGeneratedContentReportResult = {
  __typename?: 'UserGeneratedContentReportResult';
  report: UserGeneratedContentReport;
  success: Scalars['Boolean'];
};

export type UserGeneratedMutations = {
  __typename?: 'UserGeneratedMutations';
  blockUser: UserBlock;
  reportContent: UserGeneratedContentReportResult;
  unblockUser: Scalars['Boolean'];
};


export type UserGeneratedMutationsblockUserArgs = {
  loginId: Scalars['LoginId'];
};


export type UserGeneratedMutationsreportContentArgs = {
  comment: Scalars['String'];
  contentId: Scalars['UniqueId'];
  contentType: ReportableContent;
};


export type UserGeneratedMutationsunblockUserArgs = {
  loginId: Scalars['LoginId'];
};

export type UserGeneratedQueries = {
  __typename?: 'UserGeneratedQueries';
  listBlockedUsers: Array<UserBlock>;
  reports: UserGeneratedReportQueries;
};

export type UserGeneratedReportQueries = {
  __typename?: 'UserGeneratedReportQueries';
  list: UserGeneratedContentListReportsResult;
};


export type UserGeneratedReportQuerieslistArgs = {
  next?: InputMaybe<Scalars['UserGeneratedContentListReportsCursor']>;
  siteSetId: Scalars['SiteSetId'];
};

/** Number of unseen and total conversations for any type of inbox */
export type UserInbox = {
  __typename?: 'UserInbox';
  total: UserInboxCount;
  unseen: UserInboxCount;
};

/** Represents type of inbox a user can have */
export type UserInboxCount = {
  __typename?: 'UserInboxCount';
  all: Scalars['Int'];
  own: Scalars['Int'];
  star: Scalars['Int'];
};

/** Represents how many unseen notifications this user has */
export type UserNotifications = {
  __typename?: 'UserNotifications';
  /** The number of unseen notifications in the user's current context */
  unseen: Scalars['Int'];
  /** The unseen notification counts for *all* the users's available contexts, including the current */
  userContextCounts: Array<UserNotificationsContextCount>;
};

/** Represents how many unseen notifications this user has in a single user context */
export type UserNotificationsContextCount = {
  __typename?: 'UserNotificationsContextCount';
  unseen: Scalars['Int'];
  userContext: UserContext;
};

export type Vaccination = {
  child: Child;
  files: Array<File>;
  givenOn: Scalars['LocalDate'];
  id: Scalars['VaccinationId'];
  images: Array<Image>;
  note: Scalars['String'];
  ruleId: Scalars['ImmunizationRuleId'];
};

export type VaccinationExempted = Vaccination & {
  __typename?: 'VaccinationExempted';
  child: Child;
  files: Array<File>;
  givenOn: Scalars['LocalDate'];
  id: Scalars['VaccinationId'];
  images: Array<Image>;
  note: Scalars['String'];
  reason: Scalars['String'];
  ruleId: Scalars['ImmunizationRuleId'];
};

export type VaccinationGiven = Vaccination & {
  __typename?: 'VaccinationGiven';
  child: Child;
  files: Array<File>;
  givenOn: Scalars['LocalDate'];
  id: Scalars['VaccinationId'];
  images: Array<Image>;
  note: Scalars['String'];
  ruleId: Scalars['ImmunizationRuleId'];
};

export type VaccinationInput = {
  childId: Scalars['ChildId'];
  files: Array<Scalars['FileId']>;
  givenOn: Scalars['LocalDate'];
  images: Array<Scalars['ImageId']>;
  note: Scalars['String'];
  rules: Array<Scalars['ImmunizationRuleId']>;
};

export type VaccinationRule = {
  __typename?: 'VaccinationRule';
  description: Scalars['String'];
  id: Scalars['ImmunizationRuleId'];
  /** A recommended amount of months between every vaccination of a child for this rule */
  interval?: Maybe<Scalars['Int']>;
  isOptional: Scalars['Boolean'];
  isSeasonal: Scalars['Boolean'];
  maxChildAgeMonths: Scalars['Long'];
  minChildAgeMonths?: Maybe<Scalars['Long']>;
};

export type Vaccine = {
  __typename?: 'Vaccine';
  abbr?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['VaccineId'];
  rules: Array<VaccinationRule>;
  title: Scalars['String'];
  vaccineType?: Maybe<VaccineType>;
};

export enum VaccineType {
  ESSENTIAL_VACCINE = 'ESSENTIAL_VACCINE',
  PERIODIC_VACCINE = 'PERIODIC_VACCINE',
  PHYSICAL_EXAM = 'PHYSICAL_EXAM'
}

export type ValidateQRHashResult = {
  __typename?: 'ValidateQRHashResult';
  valid: Scalars['Boolean'];
};

export enum ValidationOption {
  DOBValidation = 'DOBValidation',
  NoValidation = 'NoValidation'
}

/** Describes whether an entity is verified, pending verification or not verified */
export enum VerificationStatus {
  PENDING = 'PENDING',
  UNVERIFIED = 'UNVERIFIED',
  VERIFIED = 'VERIFIED'
}

export type Video = TranscodedVideo | TranscodingVideo;

/** Top level object for 'View as Parent' */
export type ViewAsParent = {
  __typename?: 'ViewAsParent';
  /**
   * Determines whether the user can see 'View as parent' button, which will show the user how some feature will look for parents in cases where the user finds a feature they do not have access to
   * @deprecated Use the prototypeSrc field below instead
   */
  isEnabled: Scalars['Boolean'];
  /** Determines whether the frontend should show the 'Parent view' button and if so, which prototype to show based on subscription package. */
  prototypeSrc?: Maybe<Scalars['String']>;
};

export enum VillageAction {
  CAN_INVITE_OTHERS = 'CAN_INVITE_OTHERS',
  CAN_JOIN = 'CAN_JOIN'
}

export type VillageConnection = {
  __typename?: 'VillageConnection';
  url: Scalars['String'];
};

/** Root type for mutations related to Village */
export type VillageMutations = {
  __typename?: 'VillageMutations';
  invite: VillageSignupResult;
  join: VillageSignupResult;
};


/** Root type for mutations related to Village */
export type VillageMutationsinviteArgs = {
  emails: Array<Scalars['String']>;
};

/** Root type for queries related to Village */
export type VillageQueries = {
  __typename?: 'VillageQueries';
  connection?: Maybe<VillageConnection>;
};

export type VillageSignupResult = {
  __typename?: 'VillageSignupResult';
  emailsSignedUp: Array<Scalars['String']>;
};

export type VillageWidget = Widget & {
  __typename?: 'VillageWidget';
  action: VillageAction;
  id: Scalars['HomeWidgetId'];
  next?: Maybe<Scalars['HomeWidgetCursor']>;
  title: Scalars['String'];
  url?: Maybe<Scalars['String']>;
  widgetId: Scalars['String'];
};

/** Set voucher handling configuration (for automatic payments) */
export enum VoucherHandlingConfiguration {
  /** Include all past and future confirmed payments. */
  INCLUDE_ALL_CONFIRMED = 'INCLUDE_ALL_CONFIRMED',
  /** Do not include future payments or unconfirmed vouchers. */
  NO_FUTURES = 'NO_FUTURES',
  /** Include (unconfirmed) vouchers up to and including the month of the billing date. */
  WITH_BILLING_MONTH = 'WITH_BILLING_MONTH',
  /** Include (unconfirmed) vouchers up to and including the month after the billing date. */
  WITH_BILLING_MONTH_PLUS = 'WITH_BILLING_MONTH_PLUS'
}

export type WatchMeGrowData = {
  __typename?: 'WatchMeGrowData';
  appLink?: Maybe<Scalars['URI']>;
  centerId?: Maybe<Scalars['String']>;
  status?: Maybe<WmgPresenceStatus>;
  token?: Maybe<Scalars['String']>;
  tokenDetails?: Maybe<WatchMeGrowTokenDetails>;
};

/** For configuring WatchMeGrow */
export type WatchMeGrowMutation = {
  __typename?: 'WatchMeGrowMutation';
  /** Delete WMG configuration, by deleting the presence engine. */
  delete: Scalars['SiteSetId'];
  /** Initialize WMG configuration, by creating the presence engine and initializing all entities. */
  initialize: Scalars['SiteSetId'];
  /** Set the center ID associated to a site. To be used in backoffice. */
  setCenterId: Scalars['String'];
  /** Set if a child contact can access WatchMeGrow. */
  setChildContactAccess: Scalars['Boolean'];
  /** Define if child contacts can have access to WatchMeGrow. */
  setChildContactsAccess: Scalars['Boolean'];
};


/** For configuring WatchMeGrow */
export type WatchMeGrowMutationdeleteArgs = {
  siteSetId: Scalars['SiteSetId'];
};


/** For configuring WatchMeGrow */
export type WatchMeGrowMutationinitializeArgs = {
  siteSetId: Scalars['SiteSetId'];
};


/** For configuring WatchMeGrow */
export type WatchMeGrowMutationsetCenterIdArgs = {
  centerId: Scalars['String'];
  siteSetId: Scalars['SiteSetId'];
};


/** For configuring WatchMeGrow */
export type WatchMeGrowMutationsetChildContactAccessArgs = {
  enable: Scalars['Boolean'];
  relationId: Scalars['RelationId'];
};


/** For configuring WatchMeGrow */
export type WatchMeGrowMutationsetChildContactsAccessArgs = {
  enable: Scalars['Boolean'];
  siteSetId: Scalars['SiteSetId'];
};

/** Top level object for WatchMeGrow integration engine */
export type WatchMeGrowQuery = {
  __typename?: 'WatchMeGrowQuery';
  /** Whether a child contact can have access to WatchMeGrow. */
  canChildContactAccess: ChildContactAccessResponse;
  /** Whether child contacts have access to WatchMeGrow. */
  canContactsAccess: Scalars['Boolean'];
  /** The center ID mapped to the site, to be used in backoffice. */
  centerId?: Maybe<Scalars['String']>;
  /** Get integration details for WatchMeGrow. It will return `null` if the integration is not configured or the user doesn't have the required permissions. */
  integration?: Maybe<WatchMeGrowResult>;
  /** Whether WatchMeGrow is enabled for the site. */
  isEnabled: Scalars['Boolean'];
};


/** Top level object for WatchMeGrow integration engine */
export type WatchMeGrowQuerycanChildContactAccessArgs = {
  relationId: Scalars['RelationId'];
};


/** Top level object for WatchMeGrow integration engine */
export type WatchMeGrowQuerycanContactsAccessArgs = {
  siteSetId: Scalars['SiteSetId'];
};


/** Top level object for WatchMeGrow integration engine */
export type WatchMeGrowQuerycenterIdArgs = {
  siteSetId: Scalars['SiteSetId'];
};


/** Top level object for WatchMeGrow integration engine */
export type WatchMeGrowQueryintegrationArgs = {
  siteSetId?: InputMaybe<Scalars['SiteSetId']>;
};


/** Top level object for WatchMeGrow integration engine */
export type WatchMeGrowQueryisEnabledArgs = {
  siteSetId: Scalars['SiteSetId'];
};

export type WatchMeGrowResult = {
  __typename?: 'WatchMeGrowResult';
  data?: Maybe<WatchMeGrowData>;
};

export type WatchMeGrowTokenDetails = {
  type: WatchMeGrowTokenType;
};

export enum WatchMeGrowTokenType {
  MANAGER = 'MANAGER',
  PARENT = 'PARENT'
}

export type WebhookEndpoint = {
  __typename?: 'WebhookEndpoint';
  createdAt: Scalars['ZonedDateTime'];
  createdBy: Scalars['LoginId'];
  description?: Maybe<Scalars['String']>;
  enabled: Scalars['Boolean'];
  endpointId: Scalars['WebhookEndpointId'];
  name: Scalars['String'];
  secret: Scalars['String'];
  sensitive: Scalars['Boolean'];
  siteSetId: Scalars['SiteSetId'];
  subscribeToAll: Scalars['Boolean'];
  subscribedTo: Array<WebhookEventType>;
  url: Scalars['URI'];
};

export type WebhookEndpointData = {
  description?: InputMaybe<Scalars['String']>;
  enabled: Scalars['Boolean'];
  name: Scalars['String'];
  secret: Scalars['String'];
  /** If 'true' the secret will not be exposed to the consumer of this api. */
  sensitive?: InputMaybe<Scalars['Boolean']>;
  /** If 'true' then the endpoint will subscribe to all current and future event types, regardless of the values provided by 'subscribedTo'. */
  subscribeToAll?: InputMaybe<Scalars['Boolean']>;
  subscribedTo: Array<Scalars['String']>;
  url: Scalars['URI'];
};

export type WebhookEndpointListResult = {
  __typename?: 'WebhookEndpointListResult';
  endpoints: Array<WebhookEndpoint>;
  next?: Maybe<Scalars['WebhookEndpointCursor']>;
};

export type WebhookEndpointMutations = {
  __typename?: 'WebhookEndpointMutations';
  create: WebhookEndpoint;
  delete: Scalars['WebhookEndpointId'];
  update: WebhookEndpoint;
};


export type WebhookEndpointMutationscreateArgs = {
  endpointData: WebhookEndpointData;
  siteSetId: Scalars['SiteSetId'];
};


export type WebhookEndpointMutationsdeleteArgs = {
  endpointId: Scalars['WebhookEndpointId'];
  siteSetId: Scalars['SiteSetId'];
};


export type WebhookEndpointMutationsupdateArgs = {
  endpointData: WebhookEndpointData;
  endpointId: Scalars['WebhookEndpointId'];
  siteSetId: Scalars['SiteSetId'];
};

export type WebhookEndpointQueries = {
  __typename?: 'WebhookEndpointQueries';
  get?: Maybe<WebhookEndpoint>;
  list: WebhookEndpointListResult;
  possibleEventTypes: Array<WebhookEventType>;
};


export type WebhookEndpointQueriesgetArgs = {
  endpointId: Scalars['WebhookEndpointId'];
  siteSetId: Scalars['SiteSetId'];
};


export type WebhookEndpointQuerieslistArgs = {
  after?: InputMaybe<Scalars['WebhookEndpointCursor']>;
  limit?: InputMaybe<Scalars['Int']>;
  siteSetId: Scalars['SiteSetId'];
};


export type WebhookEndpointQueriespossibleEventTypesArgs = {
  siteSetId: Scalars['SiteSetId'];
};

/** Represents a webhook event, which is a notification sent by a webhook when certain events occur. */
export type WebhookEvent = {
  __typename?: 'WebhookEvent';
  /** The Json payload of the domain event that triggered the webhook event. */
  domainEventPayload: Scalars['Json'];
  /** The timestamp of the next scheduled retry for this event, if any. */
  nextRetry?: Maybe<Scalars['ZonedDateTime']>;
  /** siteSetId */
  siteSetId: Scalars['SiteSetId'];
  /** The status of the webhook event. */
  status: WebhookEventStatus;
  /** The timestamp when the webhook event occurred. */
  timestamp: Scalars['ZonedDateTime'];
  /** The number of times the webhook has attempted to send this event. */
  totalNumberOfAttempts: Scalars['Int'];
  /** The id of the endpoint the event is part of */
  webhookEndpointId: Scalars['WebhookEndpointId'];
  /** The ID of the webhook event. */
  webhookEventId: Scalars['WebhookEventId'];
  /** The type of the webhook event. */
  webhookEventType: WebhookEventType;
};

/** The result of querying for webhook events */
export type WebhookEventListResult = {
  __typename?: 'WebhookEventListResult';
  events: Array<WebhookEvent>;
  next?: Maybe<Scalars['WebhookEventCursor']>;
};

/** Represents all possible mutations on webhook events */
export type WebhookEventMutations = {
  __typename?: 'WebhookEventMutations';
  /** Attempt to deliver the provided events again, regardless of their status and whether or not they are currently queued for automatic retries */
  redeliver: Array<WebhookEvent>;
};


/** Represents all possible mutations on webhook events */
export type WebhookEventMutationsredeliverArgs = {
  endpointId: Scalars['WebhookEndpointId'];
  eventIds: Array<Scalars['WebhookEventId']>;
  siteSetId: Scalars['SiteSetId'];
};

/** Represents all possible queries on webhook events */
export type WebhookEventQueries = {
  __typename?: 'WebhookEventQueries';
  /** Gets a page of webhook events for a specific endpoint */
  byEndpointId: WebhookEventListResult;
};


/** Represents all possible queries on webhook events */
export type WebhookEventQueriesbyEndpointIdArgs = {
  after?: InputMaybe<Scalars['WebhookEventCursor']>;
  endpointId: Scalars['WebhookEndpointId'];
  limit?: InputMaybe<Scalars['Int']>;
  siteSetId: Scalars['SiteSetId'];
  status?: InputMaybe<WebhookEventStatus>;
  timeRange?: InputMaybe<ClosedZonedDateTimeRangeInput>;
};

export enum WebhookEventStatus {
  Failed = 'Failed',
  Pending = 'Pending',
  Succeeded = 'Succeeded'
}

export type WebhookEventType = {
  __typename?: 'WebhookEventType';
  description: Scalars['String'];
  domain: Domain;
  id: Scalars['String'];
  operation: Operation;
};

export type WebhookMutations = {
  __typename?: 'WebhookMutations';
  endpoints: WebhookEndpointMutations;
  events: WebhookEventMutations;
};

export type WebhookQueries = {
  __typename?: 'WebhookQueries';
  endpoints: WebhookEndpointQueries;
  events: WebhookEventQueries;
  requests: WebhookRequestQueries;
  /** The webhook status of the given site set. Takes into account user permissions and features */
  status: WebhookStatus;
};


export type WebhookQueriesstatusArgs = {
  siteSetId: Scalars['SiteSetId'];
};

/** A single webhook request associated with a webhook event. */
export type WebhookRequest = {
  __typename?: 'WebhookRequest';
  /** The attempt number for this particular request. */
  attemptNumber: Scalars['Int'];
  /** The id of the webhook endpoint that caused the request to be sent */
  endpointId: Scalars['WebhookEndpointId'];
  /** The id of the event which spawned this request */
  eventId: Scalars['WebhookEventId'];
  /** The type of the webhook event that the request belongs to */
  eventType: WebhookEventType;
  /** The headers of the request sent by the webhook. */
  requestHeaders: Scalars['String'];
  /**
   * The id of the request
   * @deprecated Please use webhookRequestId instead
   */
  requestId: Scalars['WebhookRequestId'];
  /** The payload of the request sent by the webhook. */
  requestPayload: Scalars['String'];
  /** The body of the response received from the endpoint, if any. */
  responseBody?: Maybe<Scalars['String']>;
  /** The headers of the response received from the endpoint, if any. */
  responseHeaders?: Maybe<Scalars['String']>;
  /** The HTTP status code of the response received from the endpoint, if any. */
  responseStatusCode?: Maybe<Scalars['Int']>;
  /** The id of the site set the request belongs to */
  siteSetId: Scalars['SiteSetId'];
  /** The status of the webhook request */
  status: WebhookRequestStatus;
  /** The amount of time taken to process the request in milliseconds, if available. */
  timeTaken?: Maybe<Scalars['Long']>;
  /** The timestamp when the webhook request was sent. */
  timestamp: Scalars['String'];
  /** The id of the request */
  webhookRequestId: Scalars['WebhookRequestId'];
};

/** The result of querying for webhook requests */
export type WebhookRequestListResult = {
  __typename?: 'WebhookRequestListResult';
  next?: Maybe<Scalars['WebhookRequestCursor']>;
  requests: Array<WebhookRequest>;
};

export type WebhookRequestQueries = {
  __typename?: 'WebhookRequestQueries';
  /** Gets all requests for a specific webhook endpoint */
  byEndpointId: WebhookRequestListResult;
  /** Gets all requests for a specific webhook event */
  byEventId: WebhookRequestListResult;
};


export type WebhookRequestQueriesbyEndpointIdArgs = {
  after?: InputMaybe<Scalars['WebhookRequestCursor']>;
  endpointId: Scalars['WebhookEndpointId'];
  limit?: InputMaybe<Scalars['Int']>;
  siteSetId: Scalars['SiteSetId'];
  status?: InputMaybe<WebhookRequestStatus>;
  timeRange?: InputMaybe<ClosedZonedDateTimeRangeInput>;
};


export type WebhookRequestQueriesbyEventIdArgs = {
  after?: InputMaybe<Scalars['WebhookRequestCursor']>;
  endpointId: Scalars['WebhookEndpointId'];
  eventId: Scalars['WebhookEventId'];
  limit?: InputMaybe<Scalars['Int']>;
  siteSetId: Scalars['SiteSetId'];
};

export enum WebhookRequestStatus {
  Failed = 'Failed',
  Succeeded = 'Succeeded'
}

export type WebhookStatus = {
  __typename?: 'WebhookStatus';
  isEnabled: Scalars['Boolean'];
};

export type WeekendSupportFeatureSettingsFlags = {
  __typename?: 'WeekendSupportFeatureSettingsFlags';
  /** Returns if this feature is currently enabled. */
  enabled: Scalars['Boolean'];
};

/** Weekly automatic invoicing configuration */
export type WeeklyInvoicingConfig = {
  __typename?: 'WeeklyInvoicingConfig';
  exactDay: Scalars['DayOfWeek'];
};

/** Weekly automatic invoicing configuration */
export type WeeklyInvoicingConfigInput = {
  exactDay: Scalars['DayOfWeek'];
};

export type WelcomeInformation = {
  __typename?: 'WelcomeInformation';
  canSetPin: Scalars['Boolean'];
  header: WelcomeInformationHeader;
  isTokenUsed: Scalars['Boolean'];
  privacyPolicy?: Maybe<Scalars['String']>;
};

export type WelcomeInformationHeader = {
  __typename?: 'WelcomeInformationHeader';
  name: Scalars['String'];
  profileImage?: Maybe<ProfileImage>;
  subtitle?: Maybe<Scalars['String']>;
};

/** What's New information */
export type WhatsNew = {
  __typename?: 'WhatsNew';
  enabled: Scalars['Boolean'];
};

export enum WhatsThisMediaType {
  IMAGE = 'IMAGE',
  VIDEO = 'VIDEO'
}

/** A Famly Home widget */
export type Widget = {
  id: Scalars['HomeWidgetId'];
  next?: Maybe<Scalars['HomeWidgetCursor']>;
  title: Scalars['String'];
  widgetId: Scalars['String'];
};

export enum WidgetArea {
  COMBINED = 'COMBINED',
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY'
}

/** Information about a Famly Home widget including its ID, WidgetID and translated title */
export type WidgetId = {
  __typename?: 'WidgetId';
  id: Scalars['HomeWidgetId'];
  title: Scalars['String'];
  widgetId: Scalars['String'];
};

/** A set of widget information including their IDs */
export type WidgetInfoSetResult = {
  __typename?: 'WidgetInfoSetResult';
  ids: Array<WidgetId>;
};

/** The result of querying widget sets */
export type WidgetSetResult = {
  __typename?: 'WidgetSetResult';
  widgets: Array<Widget>;
};

export enum WmgPresenceStatus {
  BUSY = 'BUSY',
  ERROR = 'ERROR',
  NONEXISTENT = 'NONEXISTENT',
  READY = 'READY'
}

export type WorkAvailability = {
  __typename?: 'WorkAvailability';
  friday?: Maybe<TimeRangeClosedLocalTime>;
  monday?: Maybe<TimeRangeClosedLocalTime>;
  saturday?: Maybe<TimeRangeClosedLocalTime>;
  sunday?: Maybe<TimeRangeClosedLocalTime>;
  thursday?: Maybe<TimeRangeClosedLocalTime>;
  tuesday?: Maybe<TimeRangeClosedLocalTime>;
  validFrom: Scalars['LocalDate'];
  validTo?: Maybe<Scalars['LocalDate']>;
  wednesday?: Maybe<TimeRangeClosedLocalTime>;
};

export type WorkAvailabilityInput = {
  friday?: InputMaybe<ClosedLocalTimeRange>;
  monday?: InputMaybe<ClosedLocalTimeRange>;
  saturday?: InputMaybe<ClosedLocalTimeRange>;
  sunday?: InputMaybe<ClosedLocalTimeRange>;
  thursday?: InputMaybe<ClosedLocalTimeRange>;
  tuesday?: InputMaybe<ClosedLocalTimeRange>;
  wednesday?: InputMaybe<ClosedLocalTimeRange>;
};

/** Work Availability mutations */
export type WorkAvailabilityMutations = {
  __typename?: 'WorkAvailabilityMutations';
  /** Save employee work availability. Replaces current value if present, always effective from today. */
  save: WorkAvailabilityResult;
};


/** Work Availability mutations */
export type WorkAvailabilityMutationssaveArgs = {
  employeeId: Scalars['EmployeeId'];
  workAvailabilityInput: WorkAvailabilityInput;
};

/** Work Availability queries */
export type WorkAvailabilityQueries = {
  __typename?: 'WorkAvailabilityQueries';
  /** Returns current value for employee work availability, if defined. */
  byEmployee: WorkAvailabilityResult;
  /** Returns current value for employees work availability. */
  byEmployees: Array<WorkAvailabilityResult>;
  /** Returns current value for work availability of all employees in a given site. */
  bySite: Array<WorkAvailabilityResult>;
  /** Returns default work availability for the site, which corresponds to current opening hours. */
  default: WorkAvailability;
};


/** Work Availability queries */
export type WorkAvailabilityQueriesbyEmployeeArgs = {
  employeeId: Scalars['EmployeeId'];
};


/** Work Availability queries */
export type WorkAvailabilityQueriesbyEmployeesArgs = {
  employeeIds: Array<Scalars['EmployeeId']>;
};


/** Work Availability queries */
export type WorkAvailabilityQueriesbySiteArgs = {
  siteId: Scalars['SiteId'];
};


/** Work Availability queries */
export type WorkAvailabilityQueriesdefaultArgs = {
  siteId: Scalars['SiteId'];
};

export type WorkAvailabilityResult = {
  __typename?: 'WorkAvailabilityResult';
  current?: Maybe<WorkAvailability>;
  employeeId: Scalars['EmployeeId'];
};

export enum WorkTagColor {
  BLUE = 'BLUE',
  GRAY = 'GRAY',
  GREEN = 'GREEN',
  ORANGE = 'ORANGE',
  RED = 'RED',
  YELLOW = 'YELLOW'
}

export type WorkTagCreateInput = {
  code?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<WorkTagColor>;
  name: Scalars['String'];
};

/** Work tag mutations */
export type WorkTagMutations = {
  __typename?: 'WorkTagMutations';
  create: WorkTagResultResultType;
  delete: WorkTagResultResultType;
  update: WorkTagResultResultType;
};


/** Work tag mutations */
export type WorkTagMutationscreateArgs = {
  siteSetId: Scalars['SiteSetId'];
  workTagInput: WorkTagCreateInput;
};


/** Work tag mutations */
export type WorkTagMutationsdeleteArgs = {
  siteSetId: Scalars['SiteSetId'];
  workTagId: Scalars['WorkTagId'];
};


/** Work tag mutations */
export type WorkTagMutationsupdateArgs = {
  siteSetId: Scalars['SiteSetId'];
  workTagInput: WorkTagUpdateInput;
};

/** Work tag queries */
export type WorkTagQueries = {
  __typename?: 'WorkTagQueries';
  bySiteSetId: Array<WorkTagResultResultType>;
};


/** Work tag queries */
export type WorkTagQueriesbySiteSetIdArgs = {
  siteSetId: Scalars['SiteSetId'];
};

export type WorkTagResultResultType = {
  __typename?: 'WorkTagResultResultType';
  code?: Maybe<Scalars['String']>;
  color?: Maybe<WorkTagColor>;
  name: Scalars['String'];
  siteId: Scalars['SiteId'];
  tagId: Scalars['WorkTagId'];
};

export type WorkTagUpdateInput = {
  code?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<WorkTagColor>;
  name: Scalars['String'];
  tagId: Scalars['WorkTagId'];
};

export type WorkTagsManagementFlagsType = {
  __typename?: 'WorkTagsManagementFlagsType';
  canCreate: Scalars['Boolean'];
  canDelete: Scalars['Boolean'];
  canEdit: Scalars['Boolean'];
  canView: Scalars['Boolean'];
};

/** Info about Xero connection */
export type XeroConnectionInfo = {
  __typename?: 'XeroConnectionInfo';
  name: Scalars['String'];
};

export type XeroIntegrationQueries = {
  __typename?: 'XeroIntegrationQueries';
  loginUrl: Scalars['String'];
};


export type XeroIntegrationQueriesloginUrlArgs = {
  institutionSetId: Scalars['InstitutionSetId'];
};

/** limitations related to account settings */
export type accountSettingsSettingObject = {
  __typename?: 'accountSettingsSettingObject';
  /** determines if the amount of children a site can add has reached its limit */
  children: UsageLimitationResultType;
  /** determines if the maximum number of employees has been reached */
  employees: UsageLimitationResultType;
  /**
   * determines if a user has access to notification settings
   * @deprecated Use notificationSettingsLimitation instead
   */
  isNotificationSettingsLimited: LimitationType;
  /** determines if a user has access to notification settings */
  notificationSettingsLimitation: LimitationType;
  /**
   * determines if a user has access to statuses in room settings
   * @deprecated Use roomSettingsStatusesWithSiteSetId instead
   */
  roomSettingsStatuses: LimitationType;
  /** determines if a user has access to statuses in room settings based on the siteSetId */
  roomSettingsStatusesWithSiteSetId: LimitationType;
};


/** limitations related to account settings */
export type accountSettingsSettingObjectroomSettingsStatusesWithSiteSetIdArgs = {
  siteId: Scalars['SiteId'];
};

/** Top level object for Additional Sites */
export type additionalSites = {
  __typename?: 'additionalSites';
  /** Determines whether an organization can request a new site to be added. */
  canRequestNewSite: Scalars['Boolean'];
};

/** Analytics configurations */
export type analytics = {
  __typename?: 'analytics';
  hotjar?: Maybe<hotjar>;
};

/** limitations related to a bill payer */
export type billPayerSettingObject = {
  __typename?: 'billPayerSettingObject';
  /**
   * determines if the user can have multiple bill payers split bills
   * @deprecated Use billPayerSplitLimitationWithSiteId instead
   */
  billPayerSplitLimitation: LimitationType;
  /** Determines if the site can have multiple bill payers split bills */
  billPayerSplitLimitationWithSiteId: LimitationType;
  /**
   * determines if the user can create bill payer credits
   * @deprecated Use creditLimitationWithSiteId instead
   */
  creditLimitation: LimitationType;
  /** Determines if the site has access to create bill payer credits */
  creditLimitationWithSiteId: LimitationType;
  /**
   * determines if the user can create bill payer surcharge
   * @deprecated Use surchargeLimitationWithSiteId instead
   */
  surchargeLimitation: LimitationType;
  /** Determines if the site has access to create bill payer surcharge */
  surchargeLimitationWithSiteId: LimitationType;
};


/** limitations related to a bill payer */
export type billPayerSettingObjectbillPayerSplitLimitationWithSiteIdArgs = {
  siteId: Scalars['SiteId'];
};


/** limitations related to a bill payer */
export type billPayerSettingObjectcreditLimitationWithSiteIdArgs = {
  siteId: Scalars['SiteId'];
};


/** limitations related to a bill payer */
export type billPayerSettingObjectsurchargeLimitationWithSiteIdArgs = {
  siteId: Scalars['SiteId'];
};

/** limitations related to a child profile */
export type childProfileSettingObject = {
  __typename?: 'childProfileSettingObject';
  /**
   * determines if the activity tab should be shown or not
   * @deprecated Use new activityTab node which takes a childId
   */
  activityTabLimitation: LimitationType;
  /** determines if the activity tab should be shown or not */
  activityTabLimitationWithChild: LimitationType;
  /**
   * determines if the user can create assessments for a child profile
   * @deprecated Use new assessment node which takes a childId
   */
  assessmentLimitation: LimitationType;
  /** determines if the activity tab should be shown or not */
  assessmentLimitationWithChild: LimitationType;
  /**
   * determines if purchases should be shown or not
   * @deprecated Use new purchases node which takes a childId
   */
  purchasesLimitation: LimitationType;
  /** determines if the activity tab should be shown or not */
  purchasesLimitationWithChild: LimitationType;
  /**
   * determines if the user can create two year check for a child profile
   * @deprecated Use new twoYearCheckLimitation node which takes a childId
   */
  twoYearCheckLimitation: LimitationType;
  /** determines if the activity tab should be shown or not */
  twoYearCheckLimitationWithChild: LimitationType;
};


/** limitations related to a child profile */
export type childProfileSettingObjectactivityTabLimitationWithChildArgs = {
  childId: Scalars['ChildId'];
};


/** limitations related to a child profile */
export type childProfileSettingObjectassessmentLimitationWithChildArgs = {
  childId: Scalars['ChildId'];
};


/** limitations related to a child profile */
export type childProfileSettingObjectpurchasesLimitationWithChildArgs = {
  childId: Scalars['ChildId'];
};


/** limitations related to a child profile */
export type childProfileSettingObjecttwoYearCheckLimitationWithChildArgs = {
  childId: Scalars['ChildId'];
};

/** limitations related to Home Overview */
export type homeOverviewSettingObject = {
  __typename?: 'homeOverviewSettingObject';
  /**
   * determines if a user can see the group action side menu when choosing a child or staff from the child/staff overview
   * @deprecated Use groupActionSideMenuLimitationWithSiteId instead
   */
  groupActionSideMenuLimitation: LimitationType;
  /** determines if a site can access the group action side menu when choosing a child or staff from the child/staff overview */
  groupActionSideMenuLimitationWithSiteId: LimitationType;
  /**
   * determines if a user has access to tags
   * @deprecated Use tagsLimitation instead
   */
  isTagsLimited: LimitationType;
  /**
   * determines if a user has access to tags
   * @deprecated Use tagsLimitationWithSiteId instead
   */
  tagsLimitation: LimitationType;
  /** Determines whether a site has access to tags */
  tagsLimitationWithSiteId: LimitationType;
};


/** limitations related to Home Overview */
export type homeOverviewSettingObjectgroupActionSideMenuLimitationWithSiteIdArgs = {
  siteId: Scalars['SiteId'];
};


/** limitations related to Home Overview */
export type homeOverviewSettingObjecttagsLimitationWithSiteIdArgs = {
  siteId: Scalars['SiteId'];
};

/** Hotjar configuration. NULL if Hotjar should not be enabled for the user */
export type hotjar = {
  __typename?: 'hotjar';
  /** Number of days since the site set was created */
  siteSetAgeInDays: Scalars['Int'];
};

/** limitations related to invoicing */
export type invoicingObject = {
  __typename?: 'invoicingObject';
  /** determines if a user has access to batch invoicing */
  hasBatchInvoicing: Scalars['Boolean'];
};

/** limitations related to invoicing */
export type invoicingSettingObject = {
  __typename?: 'invoicingSettingObject';
  /**
   * determines if a user has access to batch invoicing
   * @deprecated Use batchInvoicingLimitationWithSiteId instead
   */
  batchInvoicingLimitation: LimitationType;
  /** Determines if a site has access to batch invoicing */
  batchInvoicingLimitationWithSiteId: LimitationType;
  /**
   * determines if a user has access to batch invoicing
   * @deprecated Use batchInvoicingLimitationWithSiteId instead
   */
  isBatchInvoicingEnabled: LimitationType;
};


/** limitations related to invoicing */
export type invoicingSettingObjectbatchInvoicingLimitationWithSiteIdArgs = {
  siteId: Scalars['SiteId'];
};

/** limitations related to learning */
export type learningSettingObject = {
  __typename?: 'learningSettingObject';
  /**
   * determines if the activity plans are limited
   * @deprecated Use activityPlansWithSiteId instead
   */
  activityPlans: LimitationType;
  /** Determines if the activity plans are limited */
  activityPlansWithSiteId: LimitationType;
};


/** limitations related to learning */
export type learningSettingObjectactivityPlansWithSiteIdArgs = {
  siteId: Scalars['SiteId'];
};

/** limitations related to newsfeed */
export type newsFeedObject = {
  __typename?: 'newsFeedObject';
  /**
   * determines if a user has access to famly live
   * @deprecated use limitationSettings endpoint instead
   */
  isFamlyLiveLimited: Scalars['Boolean'];
  /**
   * determines if user can upload videos
   * @deprecated use limitationSettings endpoint instead
   */
  isVideoUploadLimited: Scalars['Boolean'];
};

/** limitations related to newsfeed */
export type newsFeedSettingObject = {
  __typename?: 'newsFeedSettingObject';
  /** determines if a user has access to famly live */
  famlyLiveLimitation: LimitationType;
  /**
   * determines if a user has access to famly live
   * @deprecated Use famlyLiveLimitation instead
   */
  isFamlyLiveLimited: LimitationType;
  /**
   * determines if user can upload videos
   * @deprecated Use videoUploadLimited instead
   */
  isVideoUploadLimited: LimitationType;
  /** determines if a newsfeed post has reached its limit of photos added */
  postImages: UsageLimitationResultType;
  /** determines if user can upload videos */
  videoUploadLimited: LimitationType;
};


/** limitations related to newsfeed */
export type newsFeedSettingObjectpostImagesArgs = {
  posts: Array<Scalars['String']>;
};

/** limitations related to pricing and rules */
export type observationsObject = {
  __typename?: 'observationsObject';
  /** determines if a user can create group observations */
  canCreateGroupObservation: Scalars['Boolean'];
  /** determines if a user has access to review process */
  hasReviewProcess: Scalars['Boolean'];
};

/** limitations related to pricing and rules */
export type observationsSettingObject = {
  __typename?: 'observationsSettingObject';
  /**
   * determines if a user can create group observations
   * @deprecated Use createGroupObservationLimitation instead
   */
  canCreateGroupObservation: LimitationType;
  /** determines if a user can create group observations */
  createGroupObservationLimitation: LimitationType;
  /**
   * determines if a user has access to review process
   * @deprecated Use reviewProcessLimitation instead
   */
  hasReviewProcess: LimitationType;
  /**
   * determines if a user has access to review process
   * @deprecated Deprecated due to not being used anymore
   */
  reviewProcessLimitation: LimitationType;
  /** determines if a user has access to see 'Whats next' button when creating a new observation */
  whatsNextLimitation: LimitationType;
};

/** package limitations */
export type packageLimitationObject = {
  __typename?: 'packageLimitationObject';
  /**
   * limitations related to inquiries
   * @deprecated use limitationSettings endpoint instead
   */
  inquiries: InquiriesObject;
  /**
   * limitations related to invoicing
   * @deprecated use limitationSettings endpoint instead
   */
  invoicing: invoicingObject;
  /**
   * limitations related to newsfeed
   * @deprecated use limitationSettings endpoint instead
   */
  newsfeed: newsFeedObject;
  /**
   * limitations related to observations
   * @deprecated use limitationSettings endpoint instead
   */
  observations: observationsObject;
  /**
   * limitations related to pricing and rules
   * @deprecated use limitationSettings endpoint instead
   */
  pricingAndRules: pricingAndRulesObject;
};

/** package limitation settings */
export type packageLimitationSettingObject = {
  __typename?: 'packageLimitationSettingObject';
  /** limitations related to account settings */
  accountSettings: accountSettingsSettingObject;
  /** limitations related to bill payer */
  billPayer: billPayerSettingObject;
  /** limitations related to a child profile */
  childProfile: childProfileSettingObject;
  /** limitations related to home overview */
  homeOverview: homeOverviewSettingObject;
  /** limitations related to inquiries */
  inquiries: InquiriesSettingObject;
  /** limitations related to invoicing */
  invoicing: invoicingSettingObject;
  /** limitations related to learning */
  learning: learningSettingObject;
  /** limitations related to newsfeed */
  newsfeed: newsFeedSettingObject;
  /** limitations related to observations */
  observations: observationsSettingObject;
  /** limitations related to pricing and rules */
  pricingAndRules: pricingAndRulesSettingObject;
};

/** top level object for limitations */
export type packageLimitationSettings = {
  __typename?: 'packageLimitationSettings';
  packageLimitationSettings: packageLimitationSettingObject;
};

/** top level object for limitations */
export type packageLimitations = {
  __typename?: 'packageLimitations';
  packageLimitations: packageLimitationObject;
};

/** Returns videos for the supported 'show me how this work' pages */
export type pageVideoSource = {
  __typename?: 'pageVideoSource';
  /**
   * Determines which video source should be sent to a user on the child development page.
   * @deprecated Use emptyStateAssets instead
   */
  childDevelopment?: Maybe<Scalars['String']>;
  /**
   * Determines which video source should be sent to a user on the child overview page.
   * @deprecated Use emptyStateAssets instead
   */
  childOverview?: Maybe<Scalars['String']>;
  /**
   * Determines which video source should be sent to a user on the invoicing page.
   * @deprecated Use emptyStateAssets instead
   */
  invoicing?: Maybe<Scalars['String']>;
  /**
   * Determines which video source should be sent to a user on the parental permission page.
   * @deprecated Use emptyStateAssets instead
   */
  parentalPermission?: Maybe<Scalars['String']>;
  /**
   * Determines which video source should be sent to a user on the plans page.
   * @deprecated Use emptyStateAssets instead
   */
  plans?: Maybe<Scalars['String']>;
  /**
   * Determines which video source should be sent to a user on the purchases page.
   * @deprecated Use emptyStateAssets instead
   */
  purchases?: Maybe<Scalars['String']>;
  /**
   * Determines which video source should be sent to a user on the room planner page.
   * @deprecated Use emptyStateAssets instead
   */
  roomPlanner?: Maybe<Scalars['String']>;
  /**
   * Determines which video source should be sent to a user on the safeguarding page.
   * @deprecated Use emptyStateAssets instead
   */
  safeguarding?: Maybe<Scalars['String']>;
  /**
   * Determines which video source should be sent to a user on the staff leave page.
   * @deprecated Use emptyStateAssets instead
   */
  staffLeave?: Maybe<Scalars['String']>;
};

/** limitations related to pricing and rules */
export type pricingAndRulesObject = {
  __typename?: 'pricingAndRulesObject';
  /** determines if a user can create pricing move rules */
  canCreatePricingMoveRules: Scalars['Boolean'];
  /** determines if a user can create pricing packages */
  canCreatePricingPackages: Scalars['Boolean'];
};

/** limitations related to pricing and rules */
export type pricingAndRulesSettingObject = {
  __typename?: 'pricingAndRulesSettingObject';
  /**
   * determines if a user can create pricing move rules
   * @deprecated Use pricingMoveRulesLimitationWithSiteId instead
   */
  canCreatePricingMoveRules: LimitationType;
  /**
   * determines if a user can create pricing packages
   * @deprecated Use pricingPackagesLimitationWithSiteId instead
   */
  canCreatePricingPackages: LimitationType;
  /**
   * determines if a user can create pricing move rules
   * @deprecated Use pricingMoveRulesLimitationWithSiteId instead
   */
  pricingMoveRulesLimitation: LimitationType;
  /**
   * determines if a site has access to create pricing move rules
   * @deprecated Deprecated due to not being used anymore
   */
  pricingMoveRulesLimitationWithSiteId: LimitationType;
  /**
   * determines if a user can create pricing packages
   * @deprecated Use pricingPackagesLimitationWithSiteId instead
   */
  pricingPackagesLimitation: LimitationType;
  /**
   * determines if a site has access to create pricing packages
   * @deprecated Deprecated due to not being used anymore
   */
  pricingPackagesLimitationWithSiteId: LimitationType;
};


/** limitations related to pricing and rules */
export type pricingAndRulesSettingObjectpricingMoveRulesLimitationWithSiteIdArgs = {
  siteId: Scalars['SiteId'];
};


/** limitations related to pricing and rules */
export type pricingAndRulesSettingObjectpricingPackagesLimitationWithSiteIdArgs = {
  siteId: Scalars['SiteId'];
};

/** Query used for searching through payments */
export type query = {
  __typename?: 'query';
  amount: Scalars['BadMoney'];
  billPayerId?: Maybe<Scalars['BillPayerId']>;
  billPayerName?: Maybe<Scalars['String']>;
  /**
   * The payment date
   * @deprecated Use paymentDate instead
   */
  date: Scalars['LocalDate'];
  paymentDate: Scalars['LocalDate'];
};
